function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

/*!
 * jQuery JavaScript Library v1.11.3
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-04-28T16:19Z
 */
(function (global, factory) {
  if ((typeof module === "undefined" ? "undefined" : _typeof2(module)) === "object" && _typeof2(module.exports) === "object") {
    // For CommonJS and CommonJS-like environments where a proper window is present,
    // execute the factory and get jQuery
    // For environments that do not inherently posses a window with a document
    // (such as Node.js), expose a jQuery-making factory as module.exports
    // This accentuates the need for the creation of a real window
    // e.g. var jQuery = require("jquery")(window);
    // See ticket #14549 for more info
    module.exports = global.document ? factory(global, true) : function (w) {
      if (!w.document) {
        throw new Error("jQuery requires a window with a document");
      }

      return factory(w);
    };
  } else {
    factory(global);
  } // Pass this if window is not defined yet

})(typeof window !== "undefined" ? window : this, function (window, noGlobal) {
  // Can't do this because several apps including ASP.NET trace
  // the stack via arguments.caller.callee and Firefox dies if
  // you try to trace through "use strict" call chains. (#13335)
  // Support: Firefox 18+
  //
  var deletedIds = [];
  var _slice = deletedIds.slice;
  var concat = deletedIds.concat;
  var push = deletedIds.push;
  var indexOf = deletedIds.indexOf;
  var class2type = {};
  var toString = class2type.toString;
  var hasOwn = class2type.hasOwnProperty;
  var support = {};

  var version = "1.11.3",
      // Define a local copy of jQuery
  jQuery = function jQuery(selector, context) {
    // The jQuery object is actually just the init constructor 'enhanced'
    // Need init if jQuery is called (just allow error to be thrown if not included)
    return new jQuery.fn.init(selector, context);
  },
      // Support: Android<4.1, IE<9
  // Make sure we trim BOM and NBSP
  rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      // Matches dashed string for camelizing
  rmsPrefix = /^-ms-/,
      rdashAlpha = /-([\da-z])/gi,
      // Used by jQuery.camelCase as callback to replace()
  fcamelCase = function fcamelCase(all, letter) {
    return letter.toUpperCase();
  };

  jQuery.fn = jQuery.prototype = {
    // The current version of jQuery being used
    jquery: version,
    constructor: jQuery,
    // Start with an empty selector
    selector: "",
    // The default length of a jQuery object is 0
    length: 0,
    toArray: function toArray() {
      return _slice.call(this);
    },
    // Get the Nth element in the matched element set OR
    // Get the whole matched element set as a clean array
    get: function get(num) {
      return num != null ? // Return just the one element from the set
      num < 0 ? this[num + this.length] : this[num] : // Return all the elements in a clean array
      _slice.call(this);
    },
    // Take an array of elements and push it onto the stack
    // (returning the new matched element set)
    pushStack: function pushStack(elems) {
      // Build a new jQuery matched element set
      var ret = jQuery.merge(this.constructor(), elems); // Add the old object onto the stack (as a reference)

      ret.prevObject = this;
      ret.context = this.context; // Return the newly-formed element set

      return ret;
    },
    // Execute a callback for every element in the matched set.
    // (You can seed the arguments with an array of args, but this is
    // only used internally.)
    each: function each(callback, args) {
      return jQuery.each(this, callback, args);
    },
    map: function map(callback) {
      return this.pushStack(jQuery.map(this, function (elem, i) {
        return callback.call(elem, i, elem);
      }));
    },
    slice: function slice() {
      return this.pushStack(_slice.apply(this, arguments));
    },
    first: function first() {
      return this.eq(0);
    },
    last: function last() {
      return this.eq(-1);
    },
    eq: function eq(i) {
      var len = this.length,
          j = +i + (i < 0 ? len : 0);
      return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
    },
    end: function end() {
      return this.prevObject || this.constructor(null);
    },
    // For internal use only.
    // Behaves like an Array's method, not like a jQuery method.
    push: push,
    sort: deletedIds.sort,
    splice: deletedIds.splice
  };

  jQuery.extend = jQuery.fn.extend = function () {
    var src,
        copyIsArray,
        copy,
        name,
        options,
        clone,
        target = arguments[0] || {},
        i = 1,
        length = arguments.length,
        deep = false; // Handle a deep copy situation

    if (typeof target === "boolean") {
      deep = target; // skip the boolean and the target

      target = arguments[i] || {};
      i++;
    } // Handle case when target is a string or something (possible in deep copy)


    if (_typeof2(target) !== "object" && !jQuery.isFunction(target)) {
      target = {};
    } // extend jQuery itself if only one argument is passed


    if (i === length) {
      target = this;
      i--;
    }

    for (; i < length; i++) {
      // Only deal with non-null/undefined values
      if ((options = arguments[i]) != null) {
        // Extend the base object
        for (name in options) {
          src = target[name];
          copy = options[name]; // Prevent never-ending loop

          if (target === copy) {
            continue;
          } // Recurse if we're merging plain objects or arrays


          if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && jQuery.isArray(src) ? src : [];
            } else {
              clone = src && jQuery.isPlainObject(src) ? src : {};
            } // Never move original objects, clone them


            target[name] = jQuery.extend(deep, clone, copy); // Don't bring in undefined values
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    } // Return the modified object


    return target;
  };

  jQuery.extend({
    // Unique for each copy of jQuery on the page
    expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
    // Assume jQuery is ready without the ready module
    isReady: true,
    error: function error(msg) {
      throw new Error(msg);
    },
    noop: function noop() {},
    // See test/unit/core.js for details concerning isFunction.
    // Since version 1.3, DOM methods and functions like alert
    // aren't supported. They return false on IE (#2968).
    isFunction: function isFunction(obj) {
      return jQuery.type(obj) === "function";
    },
    isArray: Array.isArray || function (obj) {
      return jQuery.type(obj) === "array";
    },
    isWindow: function isWindow(obj) {
      /* jshint eqeqeq: false */
      return obj != null && obj == obj.window;
    },
    isNumeric: function isNumeric(obj) {
      // parseFloat NaNs numeric-cast false positives (null|true|false|"")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      // adding 1 corrects loss of precision from parseFloat (#15100)
      return !jQuery.isArray(obj) && obj - parseFloat(obj) + 1 >= 0;
    },
    isEmptyObject: function isEmptyObject(obj) {
      var name;

      for (name in obj) {
        return false;
      }

      return true;
    },
    isPlainObject: function isPlainObject(obj) {
      var key; // Must be an Object.
      // Because of IE, we also have to check the presence of the constructor property.
      // Make sure that DOM nodes and window objects don't pass through, as well

      if (!obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow(obj)) {
        return false;
      }

      try {
        // Not own constructor property must be Object
        if (obj.constructor && !hasOwn.call(obj, "constructor") && !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
          return false;
        }
      } catch (e) {
        // IE8,9 Will throw exceptions on certain host objects #9897
        return false;
      } // Support: IE<9
      // Handle iteration over inherited properties before own properties.


      if (support.ownLast) {
        for (key in obj) {
          return hasOwn.call(obj, key);
        }
      } // Own properties are enumerated firstly, so to speed up,
      // if last one is own, then all properties are own.


      for (key in obj) {}

      return key === undefined || hasOwn.call(obj, key);
    },
    type: function type(obj) {
      if (obj == null) {
        return obj + "";
      }

      return _typeof2(obj) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : _typeof2(obj);
    },
    // Evaluates a script in a global context
    // Workarounds based on findings by Jim Driscoll
    // http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
    globalEval: function globalEval(data) {
      if (data && jQuery.trim(data)) {
        // We use execScript on Internet Explorer
        // We use an anonymous function so that context is window
        // rather than jQuery in Firefox
        (window.execScript || function (data) {
          window["eval"].call(window, data);
        })(data);
      }
    },
    // Convert dashed to camelCase; used by the css and data modules
    // Microsoft forgot to hump their vendor prefix (#9572)
    camelCase: function camelCase(string) {
      return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    },
    nodeName: function nodeName(elem, name) {
      return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    },
    // args is for internal usage only
    each: function each(obj, callback, args) {
      var value,
          i = 0,
          length = obj.length,
          isArray = isArraylike(obj);

      if (args) {
        if (isArray) {
          for (; i < length; i++) {
            value = callback.apply(obj[i], args);

            if (value === false) {
              break;
            }
          }
        } else {
          for (i in obj) {
            value = callback.apply(obj[i], args);

            if (value === false) {
              break;
            }
          }
        } // A special, fast, case for the most common use of each

      } else {
        if (isArray) {
          for (; i < length; i++) {
            value = callback.call(obj[i], i, obj[i]);

            if (value === false) {
              break;
            }
          }
        } else {
          for (i in obj) {
            value = callback.call(obj[i], i, obj[i]);

            if (value === false) {
              break;
            }
          }
        }
      }

      return obj;
    },
    // Support: Android<4.1, IE<9
    trim: function trim(text) {
      return text == null ? "" : (text + "").replace(rtrim, "");
    },
    // results is for internal usage only
    makeArray: function makeArray(arr, results) {
      var ret = results || [];

      if (arr != null) {
        if (isArraylike(Object(arr))) {
          jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
        } else {
          push.call(ret, arr);
        }
      }

      return ret;
    },
    inArray: function inArray(elem, arr, i) {
      var len;

      if (arr) {
        if (indexOf) {
          return indexOf.call(arr, elem, i);
        }

        len = arr.length;
        i = i ? i < 0 ? Math.max(0, len + i) : i : 0;

        for (; i < len; i++) {
          // Skip accessing in sparse arrays
          if (i in arr && arr[i] === elem) {
            return i;
          }
        }
      }

      return -1;
    },
    merge: function merge(first, second) {
      var len = +second.length,
          j = 0,
          i = first.length;

      while (j < len) {
        first[i++] = second[j++];
      } // Support: IE<9
      // Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)


      if (len !== len) {
        while (second[j] !== undefined) {
          first[i++] = second[j++];
        }
      }

      first.length = i;
      return first;
    },
    grep: function grep(elems, callback, invert) {
      var callbackInverse,
          matches = [],
          i = 0,
          length = elems.length,
          callbackExpect = !invert; // Go through the array, only saving the items
      // that pass the validator function

      for (; i < length; i++) {
        callbackInverse = !callback(elems[i], i);

        if (callbackInverse !== callbackExpect) {
          matches.push(elems[i]);
        }
      }

      return matches;
    },
    // arg is for internal usage only
    map: function map(elems, callback, arg) {
      var value,
          i = 0,
          length = elems.length,
          isArray = isArraylike(elems),
          ret = []; // Go through the array, translating each of the items to their new values

      if (isArray) {
        for (; i < length; i++) {
          value = callback(elems[i], i, arg);

          if (value != null) {
            ret.push(value);
          }
        } // Go through every key on the object,

      } else {
        for (i in elems) {
          value = callback(elems[i], i, arg);

          if (value != null) {
            ret.push(value);
          }
        }
      } // Flatten any nested arrays


      return concat.apply([], ret);
    },
    // A global GUID counter for objects
    guid: 1,
    // Bind a function to a context, optionally partially applying any
    // arguments.
    proxy: function proxy(fn, context) {
      var args, proxy, tmp;

      if (typeof context === "string") {
        tmp = fn[context];
        context = fn;
        fn = tmp;
      } // Quick check to determine if target is callable, in the spec
      // this throws a TypeError, but we will just return undefined.


      if (!jQuery.isFunction(fn)) {
        return undefined;
      } // Simulated bind


      args = _slice.call(arguments, 2);

      proxy = function proxy() {
        return fn.apply(context || this, args.concat(_slice.call(arguments)));
      }; // Set the guid of unique handler to the same of original handler, so it can be removed


      proxy.guid = fn.guid = fn.guid || jQuery.guid++;
      return proxy;
    },
    now: function now() {
      return +new Date();
    },
    // jQuery.support is not used in Core but other projects attach their
    // properties to it so it needs to exist.
    support: support
  }); // Populate the class2type map

  jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (i, name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });

  function isArraylike(obj) {
    // Support: iOS 8.2 (not reproducible in simulator)
    // `in` check used to prevent JIT error (gh-2145)
    // hasOwn isn't used here due to false negatives
    // regarding Nodelist length in IE
    var length = "length" in obj && obj.length,
        type = jQuery.type(obj);

    if (type === "function" || jQuery.isWindow(obj)) {
      return false;
    }

    if (obj.nodeType === 1 && length) {
      return true;
    }

    return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
  }

  var Sizzle =
  /*!
   * Sizzle CSS Selector Engine v2.2.0-pre
   * http://sizzlejs.com/
   *
   * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
   * Released under the MIT license
   * http://jquery.org/license
   *
   * Date: 2014-12-16
   */
  function (window) {
    var i,
        support,
        Expr,
        getText,
        isXML,
        tokenize,
        compile,
        select,
        outermostContext,
        sortInput,
        hasDuplicate,
        // Local document vars
    setDocument,
        document,
        docElem,
        documentIsHTML,
        rbuggyQSA,
        rbuggyMatches,
        matches,
        contains,
        // Instance-specific data
    expando = "sizzle" + 1 * new Date(),
        preferredDoc = window.document,
        dirruns = 0,
        done = 0,
        classCache = createCache(),
        tokenCache = createCache(),
        compilerCache = createCache(),
        sortOrder = function sortOrder(a, b) {
      if (a === b) {
        hasDuplicate = true;
      }

      return 0;
    },
        // General-purpose constants
    MAX_NEGATIVE = 1 << 31,
        // Instance methods
    hasOwn = {}.hasOwnProperty,
        arr = [],
        pop = arr.pop,
        push_native = arr.push,
        push = arr.push,
        slice = arr.slice,
        // Use a stripped-down indexOf as it's faster than native
    // http://jsperf.com/thor-indexof-vs-for/5
    indexOf = function indexOf(list, elem) {
      var i = 0,
          len = list.length;

      for (; i < len; i++) {
        if (list[i] === elem) {
          return i;
        }
      }

      return -1;
    },
        booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        // Regular expressions
    // Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
    whitespace = "[\\x20\\t\\r\\n\\f]",
        // http://www.w3.org/TR/css3-syntax/#characters
    characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        // Loosely modeled on CSS identifier characters
    // An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
    // Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
    identifier = characterEncoding.replace("w", "w#"),
        // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
    attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace + // Operator (capture 2)
    "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
        pseudos = ":(" + characterEncoding + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
    // 1. quoted (capture 3; capture 4 or capture 5)
    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
    ".*" + ")\\)|)",
        // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
    rwhitespace = new RegExp(whitespace + "+", "g"),
        rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
        rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
        rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
        rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),
        rpseudo = new RegExp(pseudos),
        ridentifier = new RegExp("^" + identifier + "$"),
        matchExpr = {
      "ID": new RegExp("^#(" + characterEncoding + ")"),
      "CLASS": new RegExp("^\\.(" + characterEncoding + ")"),
      "TAG": new RegExp("^(" + characterEncoding.replace("w", "w*") + ")"),
      "ATTR": new RegExp("^" + attributes),
      "PSEUDO": new RegExp("^" + pseudos),
      "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
      "bool": new RegExp("^(?:" + booleans + ")$", "i"),
      // For use in libraries implementing .is()
      // We use this for POS matching in `select`
      "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
    },
        rinputs = /^(?:input|select|textarea|button)$/i,
        rheader = /^h\d$/i,
        rnative = /^[^{]+\{\s*\[native \w/,
        // Easily-parseable/retrievable ID or TAG or CLASS selectors
    rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        rsibling = /[+~]/,
        rescape = /'|\\/g,
        // CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
    runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
        funescape = function funescape(_, escaped, escapedWhitespace) {
      var high = "0x" + escaped - 0x10000; // NaN means non-codepoint
      // Support: Firefox<24
      // Workaround erroneous numeric interpretation of +"0x"

      return high !== high || escapedWhitespace ? escaped : high < 0 ? // BMP codepoint
      String.fromCharCode(high + 0x10000) : // Supplemental Plane codepoint (surrogate pair)
      String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
    },
        // Used for iframes
    // See setDocument()
    // Removing the function wrapper causes a "Permission Denied"
    // error in IE
    unloadHandler = function unloadHandler() {
      setDocument();
    }; // Optimize for push.apply( _, NodeList )


    try {
      push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes); // Support: Android<4.0
      // Detect silently failing push.apply

      arr[preferredDoc.childNodes.length].nodeType;
    } catch (e) {
      push = {
        apply: arr.length ? // Leverage slice if possible
        function (target, els) {
          push_native.apply(target, slice.call(els));
        } : // Support: IE<9
        // Otherwise append directly
        function (target, els) {
          var j = target.length,
              i = 0; // Can't trust NodeList.length

          while (target[j++] = els[i++]) {}

          target.length = j - 1;
        }
      };
    }

    function Sizzle(selector, context, results, seed) {
      var match, elem, m, nodeType, // QSA vars
      i, groups, old, nid, newContext, newSelector;

      if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
        setDocument(context);
      }

      context = context || document;
      results = results || [];
      nodeType = context.nodeType;

      if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
        return results;
      }

      if (!seed && documentIsHTML) {
        // Try to shortcut find operations when possible (e.g., not under DocumentFragment)
        if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
          // Speed-up: Sizzle("#ID")
          if (m = match[1]) {
            if (nodeType === 9) {
              elem = context.getElementById(m); // Check parentNode to catch when Blackberry 4.6 returns
              // nodes that are no longer in the document (jQuery #6963)

              if (elem && elem.parentNode) {
                // Handle the case where IE, Opera, and Webkit return items
                // by name instead of ID
                if (elem.id === m) {
                  results.push(elem);
                  return results;
                }
              } else {
                return results;
              }
            } else {
              // Context is not a document
              if (context.ownerDocument && (elem = context.ownerDocument.getElementById(m)) && contains(context, elem) && elem.id === m) {
                results.push(elem);
                return results;
              }
            } // Speed-up: Sizzle("TAG")

          } else if (match[2]) {
            push.apply(results, context.getElementsByTagName(selector));
            return results; // Speed-up: Sizzle(".CLASS")
          } else if ((m = match[3]) && support.getElementsByClassName) {
            push.apply(results, context.getElementsByClassName(m));
            return results;
          }
        } // QSA path


        if (support.qsa && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
          nid = old = expando;
          newContext = context;
          newSelector = nodeType !== 1 && selector; // qSA works strangely on Element-rooted queries
          // We can work around this by specifying an extra ID on the root
          // and working up from there (Thanks to Andrew Dupont for the technique)
          // IE 8 doesn't work on object elements

          if (nodeType === 1 && context.nodeName.toLowerCase() !== "object") {
            groups = tokenize(selector);

            if (old = context.getAttribute("id")) {
              nid = old.replace(rescape, "\\$&");
            } else {
              context.setAttribute("id", nid);
            }

            nid = "[id='" + nid + "'] ";
            i = groups.length;

            while (i--) {
              groups[i] = nid + toSelector(groups[i]);
            }

            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
            newSelector = groups.join(",");
          }

          if (newSelector) {
            try {
              push.apply(results, newContext.querySelectorAll(newSelector));
              return results;
            } catch (qsaError) {} finally {
              if (!old) {
                context.removeAttribute("id");
              }
            }
          }
        }
      } // All others


      return select(selector.replace(rtrim, "$1"), context, results, seed);
    }
    /**
     * Create key-value caches of limited size
     * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
     *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
     *	deleting the oldest entry
     */


    function createCache() {
      var keys = [];

      function cache(key, value) {
        // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
        if (keys.push(key + " ") > Expr.cacheLength) {
          // Only keep the most recent entries
          delete cache[keys.shift()];
        }

        return cache[key + " "] = value;
      }

      return cache;
    }
    /**
     * Mark a function for special use by Sizzle
     * @param {Function} fn The function to mark
     */


    function markFunction(fn) {
      fn[expando] = true;
      return fn;
    }
    /**
     * Support testing using an element
     * @param {Function} fn Passed the created div and expects a boolean result
     */


    function assert(fn) {
      var div = document.createElement("div");

      try {
        return !!fn(div);
      } catch (e) {
        return false;
      } finally {
        // Remove from its parent by default
        if (div.parentNode) {
          div.parentNode.removeChild(div);
        } // release memory in IE


        div = null;
      }
    }
    /**
     * Adds the same handler for all of the specified attrs
     * @param {String} attrs Pipe-separated list of attributes
     * @param {Function} handler The method that will be applied
     */


    function addHandle(attrs, handler) {
      var arr = attrs.split("|"),
          i = attrs.length;

      while (i--) {
        Expr.attrHandle[arr[i]] = handler;
      }
    }
    /**
     * Checks document order of two siblings
     * @param {Element} a
     * @param {Element} b
     * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
     */


    function siblingCheck(a, b) {
      var cur = b && a,
          diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE); // Use IE sourceIndex if available on both nodes

      if (diff) {
        return diff;
      } // Check if b follows a


      if (cur) {
        while (cur = cur.nextSibling) {
          if (cur === b) {
            return -1;
          }
        }
      }

      return a ? 1 : -1;
    }
    /**
     * Returns a function to use in pseudos for input types
     * @param {String} type
     */


    function createInputPseudo(type) {
      return function (elem) {
        var name = elem.nodeName.toLowerCase();
        return name === "input" && elem.type === type;
      };
    }
    /**
     * Returns a function to use in pseudos for buttons
     * @param {String} type
     */


    function createButtonPseudo(type) {
      return function (elem) {
        var name = elem.nodeName.toLowerCase();
        return (name === "input" || name === "button") && elem.type === type;
      };
    }
    /**
     * Returns a function to use in pseudos for positionals
     * @param {Function} fn
     */


    function createPositionalPseudo(fn) {
      return markFunction(function (argument) {
        argument = +argument;
        return markFunction(function (seed, matches) {
          var j,
              matchIndexes = fn([], seed.length, argument),
              i = matchIndexes.length; // Match elements found at the specified indexes

          while (i--) {
            if (seed[j = matchIndexes[i]]) {
              seed[j] = !(matches[j] = seed[j]);
            }
          }
        });
      });
    }
    /**
     * Checks a node for validity as a Sizzle context
     * @param {Element|Object=} context
     * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
     */


    function testContext(context) {
      return context && typeof context.getElementsByTagName !== "undefined" && context;
    } // Expose support vars for convenience


    support = Sizzle.support = {};
    /**
     * Detects XML nodes
     * @param {Element|Object} elem An element or a document
     * @returns {Boolean} True iff elem is a non-HTML XML node
     */

    isXML = Sizzle.isXML = function (elem) {
      // documentElement is verified for cases where it doesn't yet exist
      // (such as loading iframes in IE - #4833)
      var documentElement = elem && (elem.ownerDocument || elem).documentElement;
      return documentElement ? documentElement.nodeName !== "HTML" : false;
    };
    /**
     * Sets document-related variables once based on the current document
     * @param {Element|Object} [doc] An element or document object to use to set the document
     * @returns {Object} Returns the current document
     */


    setDocument = Sizzle.setDocument = function (node) {
      var hasCompare,
          parent,
          doc = node ? node.ownerDocument || node : preferredDoc; // If no document and documentElement is available, return

      if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
        return document;
      } // Set our document


      document = doc;
      docElem = doc.documentElement;
      parent = doc.defaultView; // Support: IE>8
      // If iframe document is assigned to "document" variable and if iframe has been reloaded,
      // IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
      // IE6-8 do not support the defaultView property so parent will be undefined

      if (parent && parent !== parent.top) {
        // IE11 does not have attachEvent, so all must suffer
        if (parent.addEventListener) {
          parent.addEventListener("unload", unloadHandler, false);
        } else if (parent.attachEvent) {
          parent.attachEvent("onunload", unloadHandler);
        }
      }
      /* Support tests
      ---------------------------------------------------------------------- */


      documentIsHTML = !isXML(doc);
      /* Attributes
      ---------------------------------------------------------------------- */
      // Support: IE<8
      // Verify that getAttribute really returns attributes and not properties
      // (excepting IE8 booleans)

      support.attributes = assert(function (div) {
        div.className = "i";
        return !div.getAttribute("className");
      });
      /* getElement(s)By*
      ---------------------------------------------------------------------- */
      // Check if getElementsByTagName("*") returns only elements

      support.getElementsByTagName = assert(function (div) {
        div.appendChild(doc.createComment(""));
        return !div.getElementsByTagName("*").length;
      }); // Support: IE<9

      support.getElementsByClassName = rnative.test(doc.getElementsByClassName); // Support: IE<10
      // Check if getElementById returns elements by name
      // The broken getElementById methods don't pick up programatically-set names,
      // so use a roundabout getElementsByName test

      support.getById = assert(function (div) {
        docElem.appendChild(div).id = expando;
        return !doc.getElementsByName || !doc.getElementsByName(expando).length;
      }); // ID find and filter

      if (support.getById) {
        Expr.find["ID"] = function (id, context) {
          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
            var m = context.getElementById(id); // Check parentNode to catch when Blackberry 4.6 returns
            // nodes that are no longer in the document #6963

            return m && m.parentNode ? [m] : [];
          }
        };

        Expr.filter["ID"] = function (id) {
          var attrId = id.replace(runescape, funescape);
          return function (elem) {
            return elem.getAttribute("id") === attrId;
          };
        };
      } else {
        // Support: IE6/7
        // getElementById is not reliable as a find shortcut
        delete Expr.find["ID"];

        Expr.filter["ID"] = function (id) {
          var attrId = id.replace(runescape, funescape);
          return function (elem) {
            var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
            return node && node.value === attrId;
          };
        };
      } // Tag


      Expr.find["TAG"] = support.getElementsByTagName ? function (tag, context) {
        if (typeof context.getElementsByTagName !== "undefined") {
          return context.getElementsByTagName(tag); // DocumentFragment nodes don't have gEBTN
        } else if (support.qsa) {
          return context.querySelectorAll(tag);
        }
      } : function (tag, context) {
        var elem,
            tmp = [],
            i = 0,
            // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
        results = context.getElementsByTagName(tag); // Filter out possible comments

        if (tag === "*") {
          while (elem = results[i++]) {
            if (elem.nodeType === 1) {
              tmp.push(elem);
            }
          }

          return tmp;
        }

        return results;
      }; // Class

      Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
        if (documentIsHTML) {
          return context.getElementsByClassName(className);
        }
      };
      /* QSA/matchesSelector
      ---------------------------------------------------------------------- */
      // QSA and matchesSelector support
      // matchesSelector(:active) reports false when true (IE9/Opera 11.5)


      rbuggyMatches = []; // qSa(:focus) reports false when true (Chrome 21)
      // We allow this because of a bug in IE8/9 that throws an error
      // whenever `document.activeElement` is accessed on an iframe
      // So, we allow :focus to pass through QSA all the time to avoid the IE error
      // See http://bugs.jquery.com/ticket/13378

      rbuggyQSA = [];

      if (support.qsa = rnative.test(doc.querySelectorAll)) {
        // Build QSA regex
        // Regex strategy adopted from Diego Perini
        assert(function (div) {
          // Select is set to empty string on purpose
          // This is to test IE's treatment of not explicitly
          // setting a boolean content attribute,
          // since its presence should be enough
          // http://bugs.jquery.com/ticket/12359
          docElem.appendChild(div).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\f]' msallowcapture=''>" + "<option selected=''></option></select>"; // Support: IE8, Opera 11-12.16
          // Nothing should be selected when empty strings follow ^= or $= or *=
          // The test attribute must be unknown in Opera but "safe" for WinRT
          // http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section

          if (div.querySelectorAll("[msallowcapture^='']").length) {
            rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
          } // Support: IE8
          // Boolean attributes and "value" are not treated correctly


          if (!div.querySelectorAll("[selected]").length) {
            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
          } // Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+


          if (!div.querySelectorAll("[id~=" + expando + "-]").length) {
            rbuggyQSA.push("~=");
          } // Webkit/Opera - :checked should return selected option elements
          // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
          // IE8 throws error here and will not see later tests


          if (!div.querySelectorAll(":checked").length) {
            rbuggyQSA.push(":checked");
          } // Support: Safari 8+, iOS 8+
          // https://bugs.webkit.org/show_bug.cgi?id=136851
          // In-page `selector#id sibing-combinator selector` fails


          if (!div.querySelectorAll("a#" + expando + "+*").length) {
            rbuggyQSA.push(".#.+[+~]");
          }
        });
        assert(function (div) {
          // Support: Windows 8 Native Apps
          // The type and name attributes are restricted during .innerHTML assignment
          var input = doc.createElement("input");
          input.setAttribute("type", "hidden");
          div.appendChild(input).setAttribute("name", "D"); // Support: IE8
          // Enforce case-sensitivity of name attribute

          if (div.querySelectorAll("[name=d]").length) {
            rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
          } // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
          // IE8 throws error here and will not see later tests


          if (!div.querySelectorAll(":enabled").length) {
            rbuggyQSA.push(":enabled", ":disabled");
          } // Opera 10-11 does not throw on post-comma invalid pseudos


          div.querySelectorAll("*,:x");
          rbuggyQSA.push(",.*:");
        });
      }

      if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) {
        assert(function (div) {
          // Check to see if it's possible to do matchesSelector
          // on a disconnected node (IE 9)
          support.disconnectedMatch = matches.call(div, "div"); // This should fail with an exception
          // Gecko does not error, returns false instead

          matches.call(div, "[s!='']:x");
          rbuggyMatches.push("!=", pseudos);
        });
      }

      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
      /* Contains
      ---------------------------------------------------------------------- */

      hasCompare = rnative.test(docElem.compareDocumentPosition); // Element contains another
      // Purposefully does not implement inclusive descendent
      // As in, an element does not contain itself

      contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
        var adown = a.nodeType === 9 ? a.documentElement : a,
            bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
      } : function (a, b) {
        if (b) {
          while (b = b.parentNode) {
            if (b === a) {
              return true;
            }
          }
        }

        return false;
      };
      /* Sorting
      ---------------------------------------------------------------------- */
      // Document order sorting

      sortOrder = hasCompare ? function (a, b) {
        // Flag for duplicate removal
        if (a === b) {
          hasDuplicate = true;
          return 0;
        } // Sort on method existence if only one input has compareDocumentPosition


        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;

        if (compare) {
          return compare;
        } // Calculate position if both inputs belong to the same document


        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
        1; // Disconnected nodes

        if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
          // Choose the first element that is related to our preferred document
          if (a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
            return -1;
          }

          if (b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
            return 1;
          } // Maintain original order


          return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
        }

        return compare & 4 ? -1 : 1;
      } : function (a, b) {
        // Exit early if the nodes are identical
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }

        var cur,
            i = 0,
            aup = a.parentNode,
            bup = b.parentNode,
            ap = [a],
            bp = [b]; // Parentless nodes are either documents or disconnected

        if (!aup || !bup) {
          return a === doc ? -1 : b === doc ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0; // If the nodes are siblings, we can do a quick check
        } else if (aup === bup) {
          return siblingCheck(a, b);
        } // Otherwise we need full lists of their ancestors for comparison


        cur = a;

        while (cur = cur.parentNode) {
          ap.unshift(cur);
        }

        cur = b;

        while (cur = cur.parentNode) {
          bp.unshift(cur);
        } // Walk down the tree looking for a discrepancy


        while (ap[i] === bp[i]) {
          i++;
        }

        return i ? // Do a sibling check if the nodes have a common ancestor
        siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
        ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
      };
      return doc;
    };

    Sizzle.matches = function (expr, elements) {
      return Sizzle(expr, null, null, elements);
    };

    Sizzle.matchesSelector = function (elem, expr) {
      // Set document vars if needed
      if ((elem.ownerDocument || elem) !== document) {
        setDocument(elem);
      } // Make sure that attribute selectors are quoted


      expr = expr.replace(rattributeQuotes, "='$1']");

      if (support.matchesSelector && documentIsHTML && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
        try {
          var ret = matches.call(elem, expr); // IE 9's matchesSelector returns false on disconnected nodes

          if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
          // fragment in IE 9
          elem.document && elem.document.nodeType !== 11) {
            return ret;
          }
        } catch (e) {}
      }

      return Sizzle(expr, document, null, [elem]).length > 0;
    };

    Sizzle.contains = function (context, elem) {
      // Set document vars if needed
      if ((context.ownerDocument || context) !== document) {
        setDocument(context);
      }

      return contains(context, elem);
    };

    Sizzle.attr = function (elem, name) {
      // Set document vars if needed
      if ((elem.ownerDocument || elem) !== document) {
        setDocument(elem);
      }

      var fn = Expr.attrHandle[name.toLowerCase()],
          // Don't get fooled by Object.prototype properties (jQuery #13807)
      val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
      return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
    };

    Sizzle.error = function (msg) {
      throw new Error("Syntax error, unrecognized expression: " + msg);
    };
    /**
     * Document sorting and removing duplicates
     * @param {ArrayLike} results
     */


    Sizzle.uniqueSort = function (results) {
      var elem,
          duplicates = [],
          j = 0,
          i = 0; // Unless we *know* we can detect duplicates, assume their presence

      hasDuplicate = !support.detectDuplicates;
      sortInput = !support.sortStable && results.slice(0);
      results.sort(sortOrder);

      if (hasDuplicate) {
        while (elem = results[i++]) {
          if (elem === results[i]) {
            j = duplicates.push(i);
          }
        }

        while (j--) {
          results.splice(duplicates[j], 1);
        }
      } // Clear input after sorting to release objects
      // See https://github.com/jquery/sizzle/pull/225


      sortInput = null;
      return results;
    };
    /**
     * Utility function for retrieving the text value of an array of DOM nodes
     * @param {Array|Element} elem
     */


    getText = Sizzle.getText = function (elem) {
      var node,
          ret = "",
          i = 0,
          nodeType = elem.nodeType;

      if (!nodeType) {
        // If no nodeType, this is expected to be an array
        while (node = elem[i++]) {
          // Do not traverse comment nodes
          ret += getText(node);
        }
      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
        // Use textContent for elements
        // innerText usage removed for consistency of new lines (jQuery #11153)
        if (typeof elem.textContent === "string") {
          return elem.textContent;
        } else {
          // Traverse its children
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            ret += getText(elem);
          }
        }
      } else if (nodeType === 3 || nodeType === 4) {
        return elem.nodeValue;
      } // Do not include comment or processing instruction nodes


      return ret;
    };

    Expr = Sizzle.selectors = {
      // Can be adjusted by the user
      cacheLength: 50,
      createPseudo: markFunction,
      match: matchExpr,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: true
        },
        " ": {
          dir: "parentNode"
        },
        "+": {
          dir: "previousSibling",
          first: true
        },
        "~": {
          dir: "previousSibling"
        }
      },
      preFilter: {
        "ATTR": function ATTR(match) {
          match[1] = match[1].replace(runescape, funescape); // Move the given value to match[3] whether quoted or unquoted

          match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);

          if (match[2] === "~=") {
            match[3] = " " + match[3] + " ";
          }

          return match.slice(0, 4);
        },
        "CHILD": function CHILD(match) {
          /* matches from matchExpr["CHILD"]
          	1 type (only|nth|...)
          	2 what (child|of-type)
          	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
          	4 xn-component of xn+y argument ([+-]?\d*n|)
          	5 sign of xn-component
          	6 x of xn-component
          	7 sign of y-component
          	8 y of y-component
          */
          match[1] = match[1].toLowerCase();

          if (match[1].slice(0, 3) === "nth") {
            // nth-* requires argument
            if (!match[3]) {
              Sizzle.error(match[0]);
            } // numeric x and y parameters for Expr.filter.CHILD
            // remember that false/true cast respectively to 0/1


            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
            match[5] = +(match[7] + match[8] || match[3] === "odd"); // other types prohibit arguments
          } else if (match[3]) {
            Sizzle.error(match[0]);
          }

          return match;
        },
        "PSEUDO": function PSEUDO(match) {
          var excess,
              unquoted = !match[6] && match[2];

          if (matchExpr["CHILD"].test(match[0])) {
            return null;
          } // Accept quoted arguments as-is


          if (match[3]) {
            match[2] = match[4] || match[5] || ""; // Strip excess characters from unquoted arguments
          } else if (unquoted && rpseudo.test(unquoted) && ( // Get excess from tokenize (recursively)
          excess = tokenize(unquoted, true)) && ( // advance to the next closing parenthesis
          excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
            // excess is a negative index
            match[0] = match[0].slice(0, excess);
            match[2] = unquoted.slice(0, excess);
          } // Return only captures needed by the pseudo filter method (type and argument)


          return match.slice(0, 3);
        }
      },
      filter: {
        "TAG": function TAG(nodeNameSelector) {
          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
          return nodeNameSelector === "*" ? function () {
            return true;
          } : function (elem) {
            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
          };
        },
        "CLASS": function CLASS(className) {
          var pattern = classCache[className + " "];
          return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
            return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
          });
        },
        "ATTR": function ATTR(name, operator, check) {
          return function (elem) {
            var result = Sizzle.attr(elem, name);

            if (result == null) {
              return operator === "!=";
            }

            if (!operator) {
              return true;
            }

            result += "";
            return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
          };
        },
        "CHILD": function CHILD(type, what, argument, first, last) {
          var simple = type.slice(0, 3) !== "nth",
              forward = type.slice(-4) !== "last",
              ofType = what === "of-type";
          return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
          function (elem) {
            return !!elem.parentNode;
          } : function (elem, context, xml) {
            var cache,
                outerCache,
                node,
                diff,
                nodeIndex,
                start,
                dir = simple !== forward ? "nextSibling" : "previousSibling",
                parent = elem.parentNode,
                name = ofType && elem.nodeName.toLowerCase(),
                useCache = !xml && !ofType;

            if (parent) {
              // :(first|last|only)-(child|of-type)
              if (simple) {
                while (dir) {
                  node = elem;

                  while (node = node[dir]) {
                    if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                      return false;
                    }
                  } // Reverse direction for :only-* (if we haven't yet done so)


                  start = dir = type === "only" && !start && "nextSibling";
                }

                return true;
              }

              start = [forward ? parent.firstChild : parent.lastChild]; // non-xml :nth-child(...) stores cache data on `parent`

              if (forward && useCache) {
                // Seek `elem` from a previously-cached index
                outerCache = parent[expando] || (parent[expando] = {});
                cache = outerCache[type] || [];
                nodeIndex = cache[0] === dirruns && cache[1];
                diff = cache[0] === dirruns && cache[2];
                node = nodeIndex && parent.childNodes[nodeIndex];

                while (node = ++nodeIndex && node && node[dir] || ( // Fallback to seeking `elem` from the start
                diff = nodeIndex = 0) || start.pop()) {
                  // When found, cache indexes on `parent` and break
                  if (node.nodeType === 1 && ++diff && node === elem) {
                    outerCache[type] = [dirruns, nodeIndex, diff];
                    break;
                  }
                } // Use previously-cached element index if available

              } else if (useCache && (cache = (elem[expando] || (elem[expando] = {}))[type]) && cache[0] === dirruns) {
                diff = cache[1]; // xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
              } else {
                // Use the same loop as above to seek `elem` from the start
                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
                  if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                    // Cache the index of each encountered element
                    if (useCache) {
                      (node[expando] || (node[expando] = {}))[type] = [dirruns, diff];
                    }

                    if (node === elem) {
                      break;
                    }
                  }
                }
              } // Incorporate the offset, then check against cycle size


              diff -= last;
              return diff === first || diff % first === 0 && diff / first >= 0;
            }
          };
        },
        "PSEUDO": function PSEUDO(pseudo, argument) {
          // pseudo-class names are case-insensitive
          // http://www.w3.org/TR/selectors/#pseudo-classes
          // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
          // Remember that setFilters inherits from pseudos
          var args,
              fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo); // The user may use createPseudo to indicate that
          // arguments are needed to create the filter function
          // just as Sizzle does

          if (fn[expando]) {
            return fn(argument);
          } // But maintain support for old signatures


          if (fn.length > 1) {
            args = [pseudo, pseudo, "", argument];
            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
              var idx,
                  matched = fn(seed, argument),
                  i = matched.length;

              while (i--) {
                idx = indexOf(seed, matched[i]);
                seed[idx] = !(matches[idx] = matched[i]);
              }
            }) : function (elem) {
              return fn(elem, 0, args);
            };
          }

          return fn;
        }
      },
      pseudos: {
        // Potentially complex pseudos
        "not": markFunction(function (selector) {
          // Trim the selector passed to compile
          // to avoid treating leading and trailing
          // spaces as combinators
          var input = [],
              results = [],
              matcher = compile(selector.replace(rtrim, "$1"));
          return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
            var elem,
                unmatched = matcher(seed, null, xml, []),
                i = seed.length; // Match elements unmatched by `matcher`

            while (i--) {
              if (elem = unmatched[i]) {
                seed[i] = !(matches[i] = elem);
              }
            }
          }) : function (elem, context, xml) {
            input[0] = elem;
            matcher(input, null, xml, results); // Don't keep the element (issue #299)

            input[0] = null;
            return !results.pop();
          };
        }),
        "has": markFunction(function (selector) {
          return function (elem) {
            return Sizzle(selector, elem).length > 0;
          };
        }),
        "contains": markFunction(function (text) {
          text = text.replace(runescape, funescape);
          return function (elem) {
            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
          };
        }),
        // "Whether an element is represented by a :lang() selector
        // is based solely on the element's language value
        // being equal to the identifier C,
        // or beginning with the identifier C immediately followed by "-".
        // The matching of C against the element's language value is performed case-insensitively.
        // The identifier C does not have to be a valid language name."
        // http://www.w3.org/TR/selectors/#lang-pseudo
        "lang": markFunction(function (lang) {
          // lang value must be a valid identifier
          if (!ridentifier.test(lang || "")) {
            Sizzle.error("unsupported lang: " + lang);
          }

          lang = lang.replace(runescape, funescape).toLowerCase();
          return function (elem) {
            var elemLang;

            do {
              if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                elemLang = elemLang.toLowerCase();
                return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
              }
            } while ((elem = elem.parentNode) && elem.nodeType === 1);

            return false;
          };
        }),
        // Miscellaneous
        "target": function target(elem) {
          var hash = window.location && window.location.hash;
          return hash && hash.slice(1) === elem.id;
        },
        "root": function root(elem) {
          return elem === docElem;
        },
        "focus": function focus(elem) {
          return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
        },
        // Boolean properties
        "enabled": function enabled(elem) {
          return elem.disabled === false;
        },
        "disabled": function disabled(elem) {
          return elem.disabled === true;
        },
        "checked": function checked(elem) {
          // In CSS3, :checked should return both checked and selected elements
          // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
          var nodeName = elem.nodeName.toLowerCase();
          return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
        },
        "selected": function selected(elem) {
          // Accessing this property makes selected-by-default
          // options in Safari work properly
          if (elem.parentNode) {
            elem.parentNode.selectedIndex;
          }

          return elem.selected === true;
        },
        // Contents
        "empty": function empty(elem) {
          // http://www.w3.org/TR/selectors/#empty-pseudo
          // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
          //   but not by others (comment: 8; processing instruction: 7; etc.)
          // nodeType < 6 works because attributes (2) do not appear as children
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            if (elem.nodeType < 6) {
              return false;
            }
          }

          return true;
        },
        "parent": function parent(elem) {
          return !Expr.pseudos["empty"](elem);
        },
        // Element/input types
        "header": function header(elem) {
          return rheader.test(elem.nodeName);
        },
        "input": function input(elem) {
          return rinputs.test(elem.nodeName);
        },
        "button": function button(elem) {
          var name = elem.nodeName.toLowerCase();
          return name === "input" && elem.type === "button" || name === "button";
        },
        "text": function text(elem) {
          var attr;
          return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && ( // Support: IE<8
          // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
          (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
        },
        // Position-in-collection
        "first": createPositionalPseudo(function () {
          return [0];
        }),
        "last": createPositionalPseudo(function (matchIndexes, length) {
          return [length - 1];
        }),
        "eq": createPositionalPseudo(function (matchIndexes, length, argument) {
          return [argument < 0 ? argument + length : argument];
        }),
        "even": createPositionalPseudo(function (matchIndexes, length) {
          var i = 0;

          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }

          return matchIndexes;
        }),
        "odd": createPositionalPseudo(function (matchIndexes, length) {
          var i = 1;

          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }

          return matchIndexes;
        }),
        "lt": createPositionalPseudo(function (matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;

          for (; --i >= 0;) {
            matchIndexes.push(i);
          }

          return matchIndexes;
        }),
        "gt": createPositionalPseudo(function (matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;

          for (; ++i < length;) {
            matchIndexes.push(i);
          }

          return matchIndexes;
        })
      }
    };
    Expr.pseudos["nth"] = Expr.pseudos["eq"]; // Add button/input type pseudos

    for (i in {
      radio: true,
      checkbox: true,
      file: true,
      password: true,
      image: true
    }) {
      Expr.pseudos[i] = createInputPseudo(i);
    }

    for (i in {
      submit: true,
      reset: true
    }) {
      Expr.pseudos[i] = createButtonPseudo(i);
    } // Easy API for creating new setFilters


    function setFilters() {}

    setFilters.prototype = Expr.filters = Expr.pseudos;
    Expr.setFilters = new setFilters();

    tokenize = Sizzle.tokenize = function (selector, parseOnly) {
      var matched,
          match,
          tokens,
          type,
          soFar,
          groups,
          preFilters,
          cached = tokenCache[selector + " "];

      if (cached) {
        return parseOnly ? 0 : cached.slice(0);
      }

      soFar = selector;
      groups = [];
      preFilters = Expr.preFilter;

      while (soFar) {
        // Comma and first run
        if (!matched || (match = rcomma.exec(soFar))) {
          if (match) {
            // Don't consume trailing commas as valid
            soFar = soFar.slice(match[0].length) || soFar;
          }

          groups.push(tokens = []);
        }

        matched = false; // Combinators

        if (match = rcombinators.exec(soFar)) {
          matched = match.shift();
          tokens.push({
            value: matched,
            // Cast descendant combinators to space
            type: match[0].replace(rtrim, " ")
          });
          soFar = soFar.slice(matched.length);
        } // Filters


        for (type in Expr.filter) {
          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
            matched = match.shift();
            tokens.push({
              value: matched,
              type: type,
              matches: match
            });
            soFar = soFar.slice(matched.length);
          }
        }

        if (!matched) {
          break;
        }
      } // Return the length of the invalid excess
      // if we're just parsing
      // Otherwise, throw an error or return tokens


      return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
      tokenCache(selector, groups).slice(0);
    };

    function toSelector(tokens) {
      var i = 0,
          len = tokens.length,
          selector = "";

      for (; i < len; i++) {
        selector += tokens[i].value;
      }

      return selector;
    }

    function addCombinator(matcher, combinator, base) {
      var dir = combinator.dir,
          checkNonElements = base && dir === "parentNode",
          doneName = done++;
      return combinator.first ? // Check against closest ancestor/preceding element
      function (elem, context, xml) {
        while (elem = elem[dir]) {
          if (elem.nodeType === 1 || checkNonElements) {
            return matcher(elem, context, xml);
          }
        }
      } : // Check against all ancestor/preceding elements
      function (elem, context, xml) {
        var oldCache,
            outerCache,
            newCache = [dirruns, doneName]; // We can't set arbitrary data on XML nodes, so they don't benefit from dir caching

        if (xml) {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              if (matcher(elem, context, xml)) {
                return true;
              }
            }
          }
        } else {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              outerCache = elem[expando] || (elem[expando] = {});

              if ((oldCache = outerCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                // Assign to newCache so results back-propagate to previous elements
                return newCache[2] = oldCache[2];
              } else {
                // Reuse newcache so results back-propagate to previous elements
                outerCache[dir] = newCache; // A match means we're done; a fail means we have to keep checking

                if (newCache[2] = matcher(elem, context, xml)) {
                  return true;
                }
              }
            }
          }
        }
      };
    }

    function elementMatcher(matchers) {
      return matchers.length > 1 ? function (elem, context, xml) {
        var i = matchers.length;

        while (i--) {
          if (!matchers[i](elem, context, xml)) {
            return false;
          }
        }

        return true;
      } : matchers[0];
    }

    function multipleContexts(selector, contexts, results) {
      var i = 0,
          len = contexts.length;

      for (; i < len; i++) {
        Sizzle(selector, contexts[i], results);
      }

      return results;
    }

    function condense(unmatched, map, filter, context, xml) {
      var elem,
          newUnmatched = [],
          i = 0,
          len = unmatched.length,
          mapped = map != null;

      for (; i < len; i++) {
        if (elem = unmatched[i]) {
          if (!filter || filter(elem, context, xml)) {
            newUnmatched.push(elem);

            if (mapped) {
              map.push(i);
            }
          }
        }
      }

      return newUnmatched;
    }

    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
      if (postFilter && !postFilter[expando]) {
        postFilter = setMatcher(postFilter);
      }

      if (postFinder && !postFinder[expando]) {
        postFinder = setMatcher(postFinder, postSelector);
      }

      return markFunction(function (seed, results, context, xml) {
        var temp,
            i,
            elem,
            preMap = [],
            postMap = [],
            preexisting = results.length,
            // Get initial elements from seed or context
        elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
            // Prefilter to get matcher input, preserving a map for seed-results synchronization
        matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
            matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
        postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
        [] : // ...otherwise use results directly
        results : matcherIn; // Find primary matches

        if (matcher) {
          matcher(matcherIn, matcherOut, context, xml);
        } // Apply postFilter


        if (postFilter) {
          temp = condense(matcherOut, postMap);
          postFilter(temp, [], context, xml); // Un-match failing elements by moving them back to matcherIn

          i = temp.length;

          while (i--) {
            if (elem = temp[i]) {
              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
          }
        }

        if (seed) {
          if (postFinder || preFilter) {
            if (postFinder) {
              // Get the final matcherOut by condensing this intermediate into postFinder contexts
              temp = [];
              i = matcherOut.length;

              while (i--) {
                if (elem = matcherOut[i]) {
                  // Restore matcherIn since elem is not yet a final match
                  temp.push(matcherIn[i] = elem);
                }
              }

              postFinder(null, matcherOut = [], temp, xml);
            } // Move matched elements from seed to results to keep them synchronized


            i = matcherOut.length;

            while (i--) {
              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
                seed[temp] = !(results[temp] = elem);
              }
            }
          } // Add elements to results, through postFinder if defined

        } else {
          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);

          if (postFinder) {
            postFinder(null, results, matcherOut, xml);
          } else {
            push.apply(results, matcherOut);
          }
        }
      });
    }

    function matcherFromTokens(tokens) {
      var checkContext,
          matcher,
          j,
          len = tokens.length,
          leadingRelative = Expr.relative[tokens[0].type],
          implicitRelative = leadingRelative || Expr.relative[" "],
          i = leadingRelative ? 1 : 0,
          // The foundational matcher ensures that elements are reachable from top-level context(s)
      matchContext = addCombinator(function (elem) {
        return elem === checkContext;
      }, implicitRelative, true),
          matchAnyContext = addCombinator(function (elem) {
        return indexOf(checkContext, elem) > -1;
      }, implicitRelative, true),
          matchers = [function (elem, context, xml) {
        var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml)); // Avoid hanging onto element (issue #299)

        checkContext = null;
        return ret;
      }];

      for (; i < len; i++) {
        if (matcher = Expr.relative[tokens[i].type]) {
          matchers = [addCombinator(elementMatcher(matchers), matcher)];
        } else {
          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches); // Return special upon seeing a positional matcher

          if (matcher[expando]) {
            // Find the next relative operator (if any) for proper handling
            j = ++i;

            for (; j < len; j++) {
              if (Expr.relative[tokens[j].type]) {
                break;
              }
            }

            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector( // If the preceding token was a descendant combinator, insert an implicit any-element `*`
            tokens.slice(0, i - 1).concat({
              value: tokens[i - 2].type === " " ? "*" : ""
            })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
          }

          matchers.push(matcher);
        }
      }

      return elementMatcher(matchers);
    }

    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
      var bySet = setMatchers.length > 0,
          byElement = elementMatchers.length > 0,
          superMatcher = function superMatcher(seed, context, xml, results, outermost) {
        var elem,
            j,
            matcher,
            matchedCount = 0,
            i = "0",
            unmatched = seed && [],
            setMatched = [],
            contextBackup = outermostContext,
            // We must always have either seed elements or outermost context
        elems = seed || byElement && Expr.find["TAG"]("*", outermost),
            // Use integer dirruns iff this is the outermost matcher
        dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
            len = elems.length;

        if (outermost) {
          outermostContext = context !== document && context;
        } // Add elements passing elementMatchers directly to results
        // Keep `i` a string if there are no elements so `matchedCount` will be "00" below
        // Support: IE<9, Safari
        // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id


        for (; i !== len && (elem = elems[i]) != null; i++) {
          if (byElement && elem) {
            j = 0;

            while (matcher = elementMatchers[j++]) {
              if (matcher(elem, context, xml)) {
                results.push(elem);
                break;
              }
            }

            if (outermost) {
              dirruns = dirrunsUnique;
            }
          } // Track unmatched elements for set filters


          if (bySet) {
            // They will have gone through all possible matchers
            if (elem = !matcher && elem) {
              matchedCount--;
            } // Lengthen the array for every element, matched or not


            if (seed) {
              unmatched.push(elem);
            }
          }
        } // Apply set filters to unmatched elements


        matchedCount += i;

        if (bySet && i !== matchedCount) {
          j = 0;

          while (matcher = setMatchers[j++]) {
            matcher(unmatched, setMatched, context, xml);
          }

          if (seed) {
            // Reintegrate element matches to eliminate the need for sorting
            if (matchedCount > 0) {
              while (i--) {
                if (!(unmatched[i] || setMatched[i])) {
                  setMatched[i] = pop.call(results);
                }
              }
            } // Discard index placeholder values to get only actual matches


            setMatched = condense(setMatched);
          } // Add matches to results


          push.apply(results, setMatched); // Seedless set matches succeeding multiple successful matchers stipulate sorting

          if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
            Sizzle.uniqueSort(results);
          }
        } // Override manipulation of globals by nested matchers


        if (outermost) {
          dirruns = dirrunsUnique;
          outermostContext = contextBackup;
        }

        return unmatched;
      };

      return bySet ? markFunction(superMatcher) : superMatcher;
    }

    compile = Sizzle.compile = function (selector, match
    /* Internal Use Only */
    ) {
      var i,
          setMatchers = [],
          elementMatchers = [],
          cached = compilerCache[selector + " "];

      if (!cached) {
        // Generate a function of recursive functions that can be used to check each element
        if (!match) {
          match = tokenize(selector);
        }

        i = match.length;

        while (i--) {
          cached = matcherFromTokens(match[i]);

          if (cached[expando]) {
            setMatchers.push(cached);
          } else {
            elementMatchers.push(cached);
          }
        } // Cache the compiled function


        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers)); // Save selector and tokenization

        cached.selector = selector;
      }

      return cached;
    };
    /**
     * A low-level selection function that works with Sizzle's compiled
     *  selector functions
     * @param {String|Function} selector A selector or a pre-compiled
     *  selector function built with Sizzle.compile
     * @param {Element} context
     * @param {Array} [results]
     * @param {Array} [seed] A set of elements to match against
     */


    select = Sizzle.select = function (selector, context, results, seed) {
      var i,
          tokens,
          token,
          type,
          find,
          compiled = typeof selector === "function" && selector,
          match = !seed && tokenize(selector = compiled.selector || selector);
      results = results || []; // Try to minimize operations if there is no seed and only one group

      if (match.length === 1) {
        // Take a shortcut and set the context if the root selector is an ID
        tokens = match[0] = match[0].slice(0);

        if (tokens.length > 2 && (token = tokens[0]).type === "ID" && support.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
          context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];

          if (!context) {
            return results; // Precompiled matchers will still verify ancestry, so step up a level
          } else if (compiled) {
            context = context.parentNode;
          }

          selector = selector.slice(tokens.shift().value.length);
        } // Fetch a seed set for right-to-left matching


        i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;

        while (i--) {
          token = tokens[i]; // Abort if we hit a combinator

          if (Expr.relative[type = token.type]) {
            break;
          }

          if (find = Expr.find[type]) {
            // Search, expanding context for leading sibling combinators
            if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
              // If seed is empty or no tokens remain, we can return early
              tokens.splice(i, 1);
              selector = seed.length && toSelector(tokens);

              if (!selector) {
                push.apply(results, seed);
                return results;
              }

              break;
            }
          }
        }
      } // Compile and execute a filtering function if one is not provided
      // Provide `match` to avoid retokenization if we modified the selector above


      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, rsibling.test(selector) && testContext(context.parentNode) || context);
      return results;
    }; // One-time assignments
    // Sort stability


    support.sortStable = expando.split("").sort(sortOrder).join("") === expando; // Support: Chrome 14-35+
    // Always assume duplicates if they aren't passed to the comparison function

    support.detectDuplicates = !!hasDuplicate; // Initialize against the default document

    setDocument(); // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
    // Detached nodes confoundingly follow *each other*

    support.sortDetached = assert(function (div1) {
      // Should return 1, but returns 4 (following)
      return div1.compareDocumentPosition(document.createElement("div")) & 1;
    }); // Support: IE<8
    // Prevent attribute/property "interpolation"
    // http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx

    if (!assert(function (div) {
      div.innerHTML = "<a href='#'></a>";
      return div.firstChild.getAttribute("href") === "#";
    })) {
      addHandle("type|href|height|width", function (elem, name, isXML) {
        if (!isXML) {
          return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        }
      });
    } // Support: IE<9
    // Use defaultValue in place of getAttribute("value")


    if (!support.attributes || !assert(function (div) {
      div.innerHTML = "<input/>";
      div.firstChild.setAttribute("value", "");
      return div.firstChild.getAttribute("value") === "";
    })) {
      addHandle("value", function (elem, name, isXML) {
        if (!isXML && elem.nodeName.toLowerCase() === "input") {
          return elem.defaultValue;
        }
      });
    } // Support: IE<9
    // Use getAttributeNode to fetch booleans when getAttribute lies


    if (!assert(function (div) {
      return div.getAttribute("disabled") == null;
    })) {
      addHandle(booleans, function (elem, name, isXML) {
        var val;

        if (!isXML) {
          return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        }
      });
    }

    return Sizzle;
  }(window);

  jQuery.find = Sizzle;
  jQuery.expr = Sizzle.selectors;
  jQuery.expr[":"] = jQuery.expr.pseudos;
  jQuery.unique = Sizzle.uniqueSort;
  jQuery.text = Sizzle.getText;
  jQuery.isXMLDoc = Sizzle.isXML;
  jQuery.contains = Sizzle.contains;
  var rneedsContext = jQuery.expr.match.needsContext;
  var rsingleTag = /^<(\w+)\s*\/?>(?:<\/\1>|)$/;
  var risSimple = /^.[^:#\[\.,]*$/; // Implement the identical functionality for filter and not

  function winnow(elements, qualifier, not) {
    if (jQuery.isFunction(qualifier)) {
      return jQuery.grep(elements, function (elem, i) {
        /* jshint -W018 */
        return !!qualifier.call(elem, i, elem) !== not;
      });
    }

    if (qualifier.nodeType) {
      return jQuery.grep(elements, function (elem) {
        return elem === qualifier !== not;
      });
    }

    if (typeof qualifier === "string") {
      if (risSimple.test(qualifier)) {
        return jQuery.filter(qualifier, elements, not);
      }

      qualifier = jQuery.filter(qualifier, elements);
    }

    return jQuery.grep(elements, function (elem) {
      return jQuery.inArray(elem, qualifier) >= 0 !== not;
    });
  }

  jQuery.filter = function (expr, elems, not) {
    var elem = elems[0];

    if (not) {
      expr = ":not(" + expr + ")";
    }

    return elems.length === 1 && elem.nodeType === 1 ? jQuery.find.matchesSelector(elem, expr) ? [elem] : [] : jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
      return elem.nodeType === 1;
    }));
  };

  jQuery.fn.extend({
    find: function find(selector) {
      var i,
          ret = [],
          self = this,
          len = self.length;

      if (typeof selector !== "string") {
        return this.pushStack(jQuery(selector).filter(function () {
          for (i = 0; i < len; i++) {
            if (jQuery.contains(self[i], this)) {
              return true;
            }
          }
        }));
      }

      for (i = 0; i < len; i++) {
        jQuery.find(selector, self[i], ret);
      } // Needed because $( selector, context ) becomes $( context ).find( selector )


      ret = this.pushStack(len > 1 ? jQuery.unique(ret) : ret);
      ret.selector = this.selector ? this.selector + " " + selector : selector;
      return ret;
    },
    filter: function filter(selector) {
      return this.pushStack(winnow(this, selector || [], false));
    },
    not: function not(selector) {
      return this.pushStack(winnow(this, selector || [], true));
    },
    is: function is(selector) {
      return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
      // so $("p:first").is("p:last") won't return true for a doc with two "p".
      typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
    }
  }); // Initialize a jQuery object
  // A central reference to the root jQuery(document)

  var rootjQuery,
      // Use the correct document accordingly with window argument (sandbox)
  document = window.document,
      // A simple way to check for HTML strings
  // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
  // Strict HTML recognition (#11290: must start with <)
  rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      init = jQuery.fn.init = function (selector, context) {
    var match, elem; // HANDLE: $(""), $(null), $(undefined), $(false)

    if (!selector) {
      return this;
    } // Handle HTML strings


    if (typeof selector === "string") {
      if (selector.charAt(0) === "<" && selector.charAt(selector.length - 1) === ">" && selector.length >= 3) {
        // Assume that strings that start and end with <> are HTML and skip the regex check
        match = [null, selector, null];
      } else {
        match = rquickExpr.exec(selector);
      } // Match html or make sure no context is specified for #id


      if (match && (match[1] || !context)) {
        // HANDLE: $(html) -> $(array)
        if (match[1]) {
          context = context instanceof jQuery ? context[0] : context; // scripts is true for back-compat
          // Intentionally let the error be thrown if parseHTML is not present

          jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true)); // HANDLE: $(html, props)

          if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
            for (match in context) {
              // Properties of context are called as methods if possible
              if (jQuery.isFunction(this[match])) {
                this[match](context[match]); // ...and otherwise set as attributes
              } else {
                this.attr(match, context[match]);
              }
            }
          }

          return this; // HANDLE: $(#id)
        } else {
          elem = document.getElementById(match[2]); // Check parentNode to catch when Blackberry 4.6 returns
          // nodes that are no longer in the document #6963

          if (elem && elem.parentNode) {
            // Handle the case where IE and Opera return items
            // by name instead of ID
            if (elem.id !== match[2]) {
              return rootjQuery.find(selector);
            } // Otherwise, we inject the element directly into the jQuery object


            this.length = 1;
            this[0] = elem;
          }

          this.context = document;
          this.selector = selector;
          return this;
        } // HANDLE: $(expr, $(...))

      } else if (!context || context.jquery) {
        return (context || rootjQuery).find(selector); // HANDLE: $(expr, context)
        // (which is just equivalent to: $(context).find(expr)
      } else {
        return this.constructor(context).find(selector);
      } // HANDLE: $(DOMElement)

    } else if (selector.nodeType) {
      this.context = this[0] = selector;
      this.length = 1;
      return this; // HANDLE: $(function)
      // Shortcut for document ready
    } else if (jQuery.isFunction(selector)) {
      return typeof rootjQuery.ready !== "undefined" ? rootjQuery.ready(selector) : // Execute immediately if ready is not present
      selector(jQuery);
    }

    if (selector.selector !== undefined) {
      this.selector = selector.selector;
      this.context = selector.context;
    }

    return jQuery.makeArray(selector, this);
  }; // Give the init function the jQuery prototype for later instantiation


  init.prototype = jQuery.fn; // Initialize central reference

  rootjQuery = jQuery(document);
  var rparentsprev = /^(?:parents|prev(?:Until|All))/,
      // methods guaranteed to produce a unique set when starting from a unique set
  guaranteedUnique = {
    children: true,
    contents: true,
    next: true,
    prev: true
  };
  jQuery.extend({
    dir: function dir(elem, _dir, until) {
      var matched = [],
          cur = elem[_dir];

      while (cur && cur.nodeType !== 9 && (until === undefined || cur.nodeType !== 1 || !jQuery(cur).is(until))) {
        if (cur.nodeType === 1) {
          matched.push(cur);
        }

        cur = cur[_dir];
      }

      return matched;
    },
    sibling: function sibling(n, elem) {
      var r = [];

      for (; n; n = n.nextSibling) {
        if (n.nodeType === 1 && n !== elem) {
          r.push(n);
        }
      }

      return r;
    }
  });
  jQuery.fn.extend({
    has: function has(target) {
      var i,
          targets = jQuery(target, this),
          len = targets.length;
      return this.filter(function () {
        for (i = 0; i < len; i++) {
          if (jQuery.contains(this, targets[i])) {
            return true;
          }
        }
      });
    },
    closest: function closest(selectors, context) {
      var cur,
          i = 0,
          l = this.length,
          matched = [],
          pos = rneedsContext.test(selectors) || typeof selectors !== "string" ? jQuery(selectors, context || this.context) : 0;

      for (; i < l; i++) {
        for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
          // Always skip document fragments
          if (cur.nodeType < 11 && (pos ? pos.index(cur) > -1 : // Don't pass non-elements to Sizzle
          cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
            matched.push(cur);
            break;
          }
        }
      }

      return this.pushStack(matched.length > 1 ? jQuery.unique(matched) : matched);
    },
    // Determine the position of an element within
    // the matched set of elements
    index: function index(elem) {
      // No argument, return index in parent
      if (!elem) {
        return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      } // index in selector


      if (typeof elem === "string") {
        return jQuery.inArray(this[0], jQuery(elem));
      } // Locate the position of the desired element


      return jQuery.inArray( // If it receives a jQuery object, the first element is used
      elem.jquery ? elem[0] : elem, this);
    },
    add: function add(selector, context) {
      return this.pushStack(jQuery.unique(jQuery.merge(this.get(), jQuery(selector, context))));
    },
    addBack: function addBack(selector) {
      return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
    }
  });

  function sibling(cur, dir) {
    do {
      cur = cur[dir];
    } while (cur && cur.nodeType !== 1);

    return cur;
  }

  jQuery.each({
    parent: function parent(elem) {
      var parent = elem.parentNode;
      return parent && parent.nodeType !== 11 ? parent : null;
    },
    parents: function parents(elem) {
      return jQuery.dir(elem, "parentNode");
    },
    parentsUntil: function parentsUntil(elem, i, until) {
      return jQuery.dir(elem, "parentNode", until);
    },
    next: function next(elem) {
      return sibling(elem, "nextSibling");
    },
    prev: function prev(elem) {
      return sibling(elem, "previousSibling");
    },
    nextAll: function nextAll(elem) {
      return jQuery.dir(elem, "nextSibling");
    },
    prevAll: function prevAll(elem) {
      return jQuery.dir(elem, "previousSibling");
    },
    nextUntil: function nextUntil(elem, i, until) {
      return jQuery.dir(elem, "nextSibling", until);
    },
    prevUntil: function prevUntil(elem, i, until) {
      return jQuery.dir(elem, "previousSibling", until);
    },
    siblings: function siblings(elem) {
      return jQuery.sibling((elem.parentNode || {}).firstChild, elem);
    },
    children: function children(elem) {
      return jQuery.sibling(elem.firstChild);
    },
    contents: function contents(elem) {
      return jQuery.nodeName(elem, "iframe") ? elem.contentDocument || elem.contentWindow.document : jQuery.merge([], elem.childNodes);
    }
  }, function (name, fn) {
    jQuery.fn[name] = function (until, selector) {
      var ret = jQuery.map(this, fn, until);

      if (name.slice(-5) !== "Until") {
        selector = until;
      }

      if (selector && typeof selector === "string") {
        ret = jQuery.filter(selector, ret);
      }

      if (this.length > 1) {
        // Remove duplicates
        if (!guaranteedUnique[name]) {
          ret = jQuery.unique(ret);
        } // Reverse order for parents* and prev-derivatives


        if (rparentsprev.test(name)) {
          ret = ret.reverse();
        }
      }

      return this.pushStack(ret);
    };
  });
  var rnotwhite = /\S+/g; // String to Object options format cache

  var optionsCache = {}; // Convert String-formatted options into Object-formatted ones and store in cache

  function createOptions(options) {
    var object = optionsCache[options] = {};
    jQuery.each(options.match(rnotwhite) || [], function (_, flag) {
      object[flag] = true;
    });
    return object;
  }
  /*
   * Create a callback list using the following parameters:
   *
   *	options: an optional list of space-separated options that will change how
   *			the callback list behaves or a more traditional option object
   *
   * By default a callback list will act like an event callback list and can be
   * "fired" multiple times.
   *
   * Possible options:
   *
   *	once:			will ensure the callback list can only be fired once (like a Deferred)
   *
   *	memory:			will keep track of previous values and will call any callback added
   *					after the list has been fired right away with the latest "memorized"
   *					values (like a Deferred)
   *
   *	unique:			will ensure a callback can only be added once (no duplicate in the list)
   *
   *	stopOnFalse:	interrupt callings when a callback returns false
   *
   */


  jQuery.Callbacks = function (options) {
    // Convert options from String-formatted to Object-formatted if needed
    // (we check in cache first)
    options = typeof options === "string" ? optionsCache[options] || createOptions(options) : jQuery.extend({}, options);

    var // Flag to know if list is currently firing
    firing,
        // Last fire value (for non-forgettable lists)
    memory,
        // Flag to know if list was already fired
    _fired,
        // End of the loop when firing
    firingLength,
        // Index of currently firing callback (modified by remove if needed)
    firingIndex,
        // First callback to fire (used internally by add and fireWith)
    firingStart,
        // Actual callback list
    list = [],
        // Stack of fire calls for repeatable lists
    stack = !options.once && [],
        // Fire callbacks
    fire = function fire(data) {
      memory = options.memory && data;
      _fired = true;
      firingIndex = firingStart || 0;
      firingStart = 0;
      firingLength = list.length;
      firing = true;

      for (; list && firingIndex < firingLength; firingIndex++) {
        if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
          memory = false; // To prevent further calls using add

          break;
        }
      }

      firing = false;

      if (list) {
        if (stack) {
          if (stack.length) {
            fire(stack.shift());
          }
        } else if (memory) {
          list = [];
        } else {
          self.disable();
        }
      }
    },
        // Actual Callbacks object
    self = {
      // Add a callback or a collection of callbacks to the list
      add: function add() {
        if (list) {
          // First, we save the current length
          var start = list.length;

          (function add(args) {
            jQuery.each(args, function (_, arg) {
              var type = jQuery.type(arg);

              if (type === "function") {
                if (!options.unique || !self.has(arg)) {
                  list.push(arg);
                }
              } else if (arg && arg.length && type !== "string") {
                // Inspect recursively
                add(arg);
              }
            });
          })(arguments); // Do we need to add the callbacks to the
          // current firing batch?


          if (firing) {
            firingLength = list.length; // With memory, if we're not firing then
            // we should call right away
          } else if (memory) {
            firingStart = start;
            fire(memory);
          }
        }

        return this;
      },
      // Remove a callback from the list
      remove: function remove() {
        if (list) {
          jQuery.each(arguments, function (_, arg) {
            var index;

            while ((index = jQuery.inArray(arg, list, index)) > -1) {
              list.splice(index, 1); // Handle firing indexes

              if (firing) {
                if (index <= firingLength) {
                  firingLength--;
                }

                if (index <= firingIndex) {
                  firingIndex--;
                }
              }
            }
          });
        }

        return this;
      },
      // Check if a given callback is in the list.
      // If no argument is given, return whether or not list has callbacks attached.
      has: function has(fn) {
        return fn ? jQuery.inArray(fn, list) > -1 : !!(list && list.length);
      },
      // Remove all callbacks from the list
      empty: function empty() {
        list = [];
        firingLength = 0;
        return this;
      },
      // Have the list do nothing anymore
      disable: function disable() {
        list = stack = memory = undefined;
        return this;
      },
      // Is it disabled?
      disabled: function disabled() {
        return !list;
      },
      // Lock the list in its current state
      lock: function lock() {
        stack = undefined;

        if (!memory) {
          self.disable();
        }

        return this;
      },
      // Is it locked?
      locked: function locked() {
        return !stack;
      },
      // Call all callbacks with the given context and arguments
      fireWith: function fireWith(context, args) {
        if (list && (!_fired || stack)) {
          args = args || [];
          args = [context, args.slice ? args.slice() : args];

          if (firing) {
            stack.push(args);
          } else {
            fire(args);
          }
        }

        return this;
      },
      // Call all the callbacks with the given arguments
      fire: function fire() {
        self.fireWith(this, arguments);
        return this;
      },
      // To know if the callbacks have already been called at least once
      fired: function fired() {
        return !!_fired;
      }
    };

    return self;
  };

  jQuery.extend({
    Deferred: function Deferred(func) {
      var tuples = [// action, add listener, listener list, final state
      ["resolve", "done", jQuery.Callbacks("once memory"), "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), "rejected"], ["notify", "progress", jQuery.Callbacks("memory")]],
          _state = "pending",
          _promise = {
        state: function state() {
          return _state;
        },
        always: function always() {
          deferred.done(arguments).fail(arguments);
          return this;
        },
        then: function then()
        /* fnDone, fnFail, fnProgress */
        {
          var fns = arguments;
          return jQuery.Deferred(function (newDefer) {
            jQuery.each(tuples, function (i, tuple) {
              var fn = jQuery.isFunction(fns[i]) && fns[i]; // deferred[ done | fail | progress ] for forwarding actions to newDefer

              deferred[tuple[1]](function () {
                var returned = fn && fn.apply(this, arguments);

                if (returned && jQuery.isFunction(returned.promise)) {
                  returned.promise().done(newDefer.resolve).fail(newDefer.reject).progress(newDefer.notify);
                } else {
                  newDefer[tuple[0] + "With"](this === _promise ? newDefer.promise() : this, fn ? [returned] : arguments);
                }
              });
            });
            fns = null;
          }).promise();
        },
        // Get a promise for this deferred
        // If obj is provided, the promise aspect is added to the object
        promise: function promise(obj) {
          return obj != null ? jQuery.extend(obj, _promise) : _promise;
        }
      },
          deferred = {}; // Keep pipe for back-compat

      _promise.pipe = _promise.then; // Add list-specific methods

      jQuery.each(tuples, function (i, tuple) {
        var list = tuple[2],
            stateString = tuple[3]; // promise[ done | fail | progress ] = list.add

        _promise[tuple[1]] = list.add; // Handle state

        if (stateString) {
          list.add(function () {
            // state = [ resolved | rejected ]
            _state = stateString; // [ reject_list | resolve_list ].disable; progress_list.lock
          }, tuples[i ^ 1][2].disable, tuples[2][2].lock);
        } // deferred[ resolve | reject | notify ]


        deferred[tuple[0]] = function () {
          deferred[tuple[0] + "With"](this === deferred ? _promise : this, arguments);
          return this;
        };

        deferred[tuple[0] + "With"] = list.fireWith;
      }); // Make the deferred a promise

      _promise.promise(deferred); // Call given func if any


      if (func) {
        func.call(deferred, deferred);
      } // All done!


      return deferred;
    },
    // Deferred helper
    when: function when(subordinate
    /* , ..., subordinateN */
    ) {
      var i = 0,
          resolveValues = _slice.call(arguments),
          length = resolveValues.length,
          // the count of uncompleted subordinates
      remaining = length !== 1 || subordinate && jQuery.isFunction(subordinate.promise) ? length : 0,
          // the master Deferred. If resolveValues consist of only a single Deferred, just use that.
      deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
          // Update function for both resolve and progress values
      updateFunc = function updateFunc(i, contexts, values) {
        return function (value) {
          contexts[i] = this;
          values[i] = arguments.length > 1 ? _slice.call(arguments) : value;

          if (values === progressValues) {
            deferred.notifyWith(contexts, values);
          } else if (! --remaining) {
            deferred.resolveWith(contexts, values);
          }
        };
      },
          progressValues,
          progressContexts,
          resolveContexts; // add listeners to Deferred subordinates; treat others as resolved


      if (length > 1) {
        progressValues = new Array(length);
        progressContexts = new Array(length);
        resolveContexts = new Array(length);

        for (; i < length; i++) {
          if (resolveValues[i] && jQuery.isFunction(resolveValues[i].promise)) {
            resolveValues[i].promise().done(updateFunc(i, resolveContexts, resolveValues)).fail(deferred.reject).progress(updateFunc(i, progressContexts, progressValues));
          } else {
            --remaining;
          }
        }
      } // if we're not waiting on anything, resolve the master


      if (!remaining) {
        deferred.resolveWith(resolveContexts, resolveValues);
      }

      return deferred.promise();
    }
  }); // The deferred used on DOM ready

  var readyList;

  jQuery.fn.ready = function (fn) {
    // Add the callback
    jQuery.ready.promise().done(fn);
    return this;
  };

  jQuery.extend({
    // Is the DOM ready to be used? Set to true once it occurs.
    isReady: false,
    // A counter to track how many items to wait for before
    // the ready event fires. See #6781
    readyWait: 1,
    // Hold (or release) the ready event
    holdReady: function holdReady(hold) {
      if (hold) {
        jQuery.readyWait++;
      } else {
        jQuery.ready(true);
      }
    },
    // Handle when the DOM is ready
    ready: function ready(wait) {
      // Abort if there are pending holds or we're already ready
      if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
        return;
      } // Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).


      if (!document.body) {
        return setTimeout(jQuery.ready);
      } // Remember that the DOM is ready


      jQuery.isReady = true; // If a normal DOM Ready event fired, decrement, and wait if need be

      if (wait !== true && --jQuery.readyWait > 0) {
        return;
      } // If there are functions bound, to execute


      readyList.resolveWith(document, [jQuery]); // Trigger any bound ready events

      if (jQuery.fn.triggerHandler) {
        jQuery(document).triggerHandler("ready");
        jQuery(document).off("ready");
      }
    }
  });
  /**
   * Clean-up method for dom ready events
   */

  function detach() {
    if (document.addEventListener) {
      document.removeEventListener("DOMContentLoaded", completed, false);
      window.removeEventListener("load", completed, false);
    } else {
      document.detachEvent("onreadystatechange", completed);
      window.detachEvent("onload", completed);
    }
  }
  /**
   * The ready event handler and self cleanup method
   */


  function completed() {
    // readyState === "complete" is good enough for us to call the dom ready in oldIE
    if (document.addEventListener || event.type === "load" || document.readyState === "complete") {
      detach();
      jQuery.ready();
    }
  }

  jQuery.ready.promise = function (obj) {
    if (!readyList) {
      readyList = jQuery.Deferred(); // Catch cases where $(document).ready() is called after the browser event has already occurred.
      // we once tried to use readyState "interactive" here, but it caused issues like the one
      // discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15

      if (document.readyState === "complete") {
        // Handle it asynchronously to allow scripts the opportunity to delay ready
        setTimeout(jQuery.ready); // Standards-based browsers support DOMContentLoaded
      } else if (document.addEventListener) {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed, false); // A fallback to window.onload, that will always work

        window.addEventListener("load", completed, false); // If IE event model is used
      } else {
        // Ensure firing before onload, maybe late but safe also for iframes
        document.attachEvent("onreadystatechange", completed); // A fallback to window.onload, that will always work

        window.attachEvent("onload", completed); // If IE and not a frame
        // continually check to see if the document is ready

        var top = false;

        try {
          top = window.frameElement == null && document.documentElement;
        } catch (e) {}

        if (top && top.doScroll) {
          (function doScrollCheck() {
            if (!jQuery.isReady) {
              try {
                // Use the trick by Diego Perini
                // http://javascript.nwbox.com/IEContentLoaded/
                top.doScroll("left");
              } catch (e) {
                return setTimeout(doScrollCheck, 50);
              } // detach all dom ready events


              detach(); // and execute any waiting functions

              jQuery.ready();
            }
          })();
        }
      }
    }

    return readyList.promise(obj);
  };

  var strundefined = typeof undefined === "undefined" ? "undefined" : _typeof2(undefined); // Support: IE<9
  // Iteration over object's inherited properties before its own

  var i;

  for (i in jQuery(support)) {
    break;
  }

  support.ownLast = i !== "0"; // Note: most support tests are defined in their respective modules.
  // false until the test is run

  support.inlineBlockNeedsLayout = false; // Execute ASAP in case we need to set body.style.zoom

  jQuery(function () {
    // Minified: var a,b,c,d
    var val, div, body, container;
    body = document.getElementsByTagName("body")[0];

    if (!body || !body.style) {
      // Return for frameset docs that don't have a body
      return;
    } // Setup


    div = document.createElement("div");
    container = document.createElement("div");
    container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
    body.appendChild(container).appendChild(div);

    if (_typeof2(div.style.zoom) !== strundefined) {
      // Support: IE<8
      // Check if natively block-level elements act like inline-block
      // elements when setting their display to 'inline' and giving
      // them layout
      div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";
      support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;

      if (val) {
        // Prevent IE 6 from affecting layout for positioned elements #11048
        // Prevent IE from shrinking the body in IE 7 mode #12869
        // Support: IE<8
        body.style.zoom = 1;
      }
    }

    body.removeChild(container);
  });

  (function () {
    var div = document.createElement("div"); // Execute the test only if not already executed in another module.

    if (support.deleteExpando == null) {
      // Support: IE<9
      support.deleteExpando = true;

      try {
        delete div.test;
      } catch (e) {
        support.deleteExpando = false;
      }
    } // Null elements to avoid leaks in IE.


    div = null;
  })();
  /**
   * Determines whether an object can have data
   */


  jQuery.acceptData = function (elem) {
    var noData = jQuery.noData[(elem.nodeName + " ").toLowerCase()],
        nodeType = +elem.nodeType || 1; // Do not set data on non-element DOM nodes because it will not be cleared (#8335).

    return nodeType !== 1 && nodeType !== 9 ? false : // Nodes accept data unless otherwise specified; rejection can be conditional
    !noData || noData !== true && elem.getAttribute("classid") === noData;
  };

  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      rmultiDash = /([A-Z])/g;

  function dataAttr(elem, key, data) {
    // If nothing was found internally, try to fetch any
    // data from the HTML5 data-* attribute
    if (data === undefined && elem.nodeType === 1) {
      var name = "data-" + key.replace(rmultiDash, "-$1").toLowerCase();
      data = elem.getAttribute(name);

      if (typeof data === "string") {
        try {
          data = data === "true" ? true : data === "false" ? false : data === "null" ? null : // Only convert to a number if it doesn't change the string
          +data + "" === data ? +data : rbrace.test(data) ? jQuery.parseJSON(data) : data;
        } catch (e) {} // Make sure we set the data so it isn't changed later


        jQuery.data(elem, key, data);
      } else {
        data = undefined;
      }
    }

    return data;
  } // checks a cache object for emptiness


  function isEmptyDataObject(obj) {
    var name;

    for (name in obj) {
      // if the public data object is empty, the private is still empty
      if (name === "data" && jQuery.isEmptyObject(obj[name])) {
        continue;
      }

      if (name !== "toJSON") {
        return false;
      }
    }

    return true;
  }

  function internalData(elem, name, data, pvt
  /* Internal Use Only */
  ) {
    if (!jQuery.acceptData(elem)) {
      return;
    }

    var ret,
        thisCache,
        internalKey = jQuery.expando,
        // We have to handle DOM nodes and JS objects differently because IE6-7
    // can't GC object references properly across the DOM-JS boundary
    isNode = elem.nodeType,
        // Only DOM nodes need the global jQuery cache; JS object data is
    // attached directly to the object so GC can occur automatically
    cache = isNode ? jQuery.cache : elem,
        // Only defining an ID for JS objects if its cache already exists allows
    // the code to shortcut on the same path as a DOM node with no cache
    id = isNode ? elem[internalKey] : elem[internalKey] && internalKey; // Avoid doing any more work than we need to when trying to get data on an
    // object that has no data at all

    if ((!id || !cache[id] || !pvt && !cache[id].data) && data === undefined && typeof name === "string") {
      return;
    }

    if (!id) {
      // Only DOM nodes need a new unique ID for each element since their data
      // ends up in the global cache
      if (isNode) {
        id = elem[internalKey] = deletedIds.pop() || jQuery.guid++;
      } else {
        id = internalKey;
      }
    }

    if (!cache[id]) {
      // Avoid exposing jQuery metadata on plain JS objects when the object
      // is serialized using JSON.stringify
      cache[id] = isNode ? {} : {
        toJSON: jQuery.noop
      };
    } // An object can be passed to jQuery.data instead of a key/value pair; this gets
    // shallow copied over onto the existing cache


    if (_typeof2(name) === "object" || typeof name === "function") {
      if (pvt) {
        cache[id] = jQuery.extend(cache[id], name);
      } else {
        cache[id].data = jQuery.extend(cache[id].data, name);
      }
    }

    thisCache = cache[id]; // jQuery data() is stored in a separate object inside the object's internal data
    // cache in order to avoid key collisions between internal data and user-defined
    // data.

    if (!pvt) {
      if (!thisCache.data) {
        thisCache.data = {};
      }

      thisCache = thisCache.data;
    }

    if (data !== undefined) {
      thisCache[jQuery.camelCase(name)] = data;
    } // Check for both converted-to-camel and non-converted data property names
    // If a data property was specified


    if (typeof name === "string") {
      // First Try to find as-is property data
      ret = thisCache[name]; // Test for null|undefined property data

      if (ret == null) {
        // Try to find the camelCased property
        ret = thisCache[jQuery.camelCase(name)];
      }
    } else {
      ret = thisCache;
    }

    return ret;
  }

  function internalRemoveData(elem, name, pvt) {
    if (!jQuery.acceptData(elem)) {
      return;
    }

    var thisCache,
        i,
        isNode = elem.nodeType,
        // See jQuery.data for more information
    cache = isNode ? jQuery.cache : elem,
        id = isNode ? elem[jQuery.expando] : jQuery.expando; // If there is already no cache entry for this object, there is no
    // purpose in continuing

    if (!cache[id]) {
      return;
    }

    if (name) {
      thisCache = pvt ? cache[id] : cache[id].data;

      if (thisCache) {
        // Support array or space separated string names for data keys
        if (!jQuery.isArray(name)) {
          // try the string as a key before any manipulation
          if (name in thisCache) {
            name = [name];
          } else {
            // split the camel cased version by spaces unless a key with the spaces exists
            name = jQuery.camelCase(name);

            if (name in thisCache) {
              name = [name];
            } else {
              name = name.split(" ");
            }
          }
        } else {
          // If "name" is an array of keys...
          // When data is initially created, via ("key", "val") signature,
          // keys will be converted to camelCase.
          // Since there is no way to tell _how_ a key was added, remove
          // both plain key and camelCase key. #12786
          // This will only penalize the array argument path.
          name = name.concat(jQuery.map(name, jQuery.camelCase));
        }

        i = name.length;

        while (i--) {
          delete thisCache[name[i]];
        } // If there is no data left in the cache, we want to continue
        // and let the cache object itself get destroyed


        if (pvt ? !isEmptyDataObject(thisCache) : !jQuery.isEmptyObject(thisCache)) {
          return;
        }
      }
    } // See jQuery.data for more information


    if (!pvt) {
      delete cache[id].data; // Don't destroy the parent cache unless the internal data object
      // had been the only thing left in it

      if (!isEmptyDataObject(cache[id])) {
        return;
      }
    } // Destroy the cache


    if (isNode) {
      jQuery.cleanData([elem], true); // Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)

      /* jshint eqeqeq: false */
    } else if (support.deleteExpando || cache != cache.window) {
      /* jshint eqeqeq: true */
      delete cache[id]; // When all else fails, null
    } else {
      cache[id] = null;
    }
  }

  jQuery.extend({
    cache: {},
    // The following elements (space-suffixed to avoid Object.prototype collisions)
    // throw uncatchable exceptions if you attempt to set expando properties
    noData: {
      "applet ": true,
      "embed ": true,
      // ...but Flash objects (which have this classid) *can* handle expandos
      "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
    },
    hasData: function hasData(elem) {
      elem = elem.nodeType ? jQuery.cache[elem[jQuery.expando]] : elem[jQuery.expando];
      return !!elem && !isEmptyDataObject(elem);
    },
    data: function data(elem, name, _data) {
      return internalData(elem, name, _data);
    },
    removeData: function removeData(elem, name) {
      return internalRemoveData(elem, name);
    },
    // For internal use only.
    _data: function _data(elem, name, data) {
      return internalData(elem, name, data, true);
    },
    _removeData: function _removeData(elem, name) {
      return internalRemoveData(elem, name, true);
    }
  });
  jQuery.fn.extend({
    data: function data(key, value) {
      var i,
          name,
          data,
          elem = this[0],
          attrs = elem && elem.attributes; // Special expections of .data basically thwart jQuery.access,
      // so implement the relevant behavior ourselves
      // Gets all values

      if (key === undefined) {
        if (this.length) {
          data = jQuery.data(elem);

          if (elem.nodeType === 1 && !jQuery._data(elem, "parsedAttrs")) {
            i = attrs.length;

            while (i--) {
              // Support: IE11+
              // The attrs elements can be null (#14894)
              if (attrs[i]) {
                name = attrs[i].name;

                if (name.indexOf("data-") === 0) {
                  name = jQuery.camelCase(name.slice(5));
                  dataAttr(elem, name, data[name]);
                }
              }
            }

            jQuery._data(elem, "parsedAttrs", true);
          }
        }

        return data;
      } // Sets multiple values


      if (_typeof2(key) === "object") {
        return this.each(function () {
          jQuery.data(this, key);
        });
      }

      return arguments.length > 1 ? // Sets one value
      this.each(function () {
        jQuery.data(this, key, value);
      }) : // Gets one value
      // Try to fetch any internally stored data first
      elem ? dataAttr(elem, key, jQuery.data(elem, key)) : undefined;
    },
    removeData: function removeData(key) {
      return this.each(function () {
        jQuery.removeData(this, key);
      });
    }
  });
  jQuery.extend({
    queue: function queue(elem, type, data) {
      var queue;

      if (elem) {
        type = (type || "fx") + "queue";
        queue = jQuery._data(elem, type); // Speed up dequeue by getting out quickly if this is just a lookup

        if (data) {
          if (!queue || jQuery.isArray(data)) {
            queue = jQuery._data(elem, type, jQuery.makeArray(data));
          } else {
            queue.push(data);
          }
        }

        return queue || [];
      }
    },
    dequeue: function dequeue(elem, type) {
      type = type || "fx";

      var queue = jQuery.queue(elem, type),
          startLength = queue.length,
          fn = queue.shift(),
          hooks = jQuery._queueHooks(elem, type),
          next = function next() {
        jQuery.dequeue(elem, type);
      }; // If the fx queue is dequeued, always remove the progress sentinel


      if (fn === "inprogress") {
        fn = queue.shift();
        startLength--;
      }

      if (fn) {
        // Add a progress sentinel to prevent the fx queue from being
        // automatically dequeued
        if (type === "fx") {
          queue.unshift("inprogress");
        } // clear up the last queue stop function


        delete hooks.stop;
        fn.call(elem, next, hooks);
      }

      if (!startLength && hooks) {
        hooks.empty.fire();
      }
    },
    // not intended for public consumption - generates a queueHooks object, or returns the current one
    _queueHooks: function _queueHooks(elem, type) {
      var key = type + "queueHooks";
      return jQuery._data(elem, key) || jQuery._data(elem, key, {
        empty: jQuery.Callbacks("once memory").add(function () {
          jQuery._removeData(elem, type + "queue");

          jQuery._removeData(elem, key);
        })
      });
    }
  });
  jQuery.fn.extend({
    queue: function queue(type, data) {
      var setter = 2;

      if (typeof type !== "string") {
        data = type;
        type = "fx";
        setter--;
      }

      if (arguments.length < setter) {
        return jQuery.queue(this[0], type);
      }

      return data === undefined ? this : this.each(function () {
        var queue = jQuery.queue(this, type, data); // ensure a hooks for this queue

        jQuery._queueHooks(this, type);

        if (type === "fx" && queue[0] !== "inprogress") {
          jQuery.dequeue(this, type);
        }
      });
    },
    dequeue: function dequeue(type) {
      return this.each(function () {
        jQuery.dequeue(this, type);
      });
    },
    clearQueue: function clearQueue(type) {
      return this.queue(type || "fx", []);
    },
    // Get a promise resolved when queues of a certain type
    // are emptied (fx is the type by default)
    promise: function promise(type, obj) {
      var tmp,
          count = 1,
          defer = jQuery.Deferred(),
          elements = this,
          i = this.length,
          resolve = function resolve() {
        if (! --count) {
          defer.resolveWith(elements, [elements]);
        }
      };

      if (typeof type !== "string") {
        obj = type;
        type = undefined;
      }

      type = type || "fx";

      while (i--) {
        tmp = jQuery._data(elements[i], type + "queueHooks");

        if (tmp && tmp.empty) {
          count++;
          tmp.empty.add(resolve);
        }
      }

      resolve();
      return defer.promise(obj);
    }
  });
  var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
  var cssExpand = ["Top", "Right", "Bottom", "Left"];

  var isHidden = function isHidden(elem, el) {
    // isHidden might be called from jQuery#filter function;
    // in that case, element will be second argument
    elem = el || elem;
    return jQuery.css(elem, "display") === "none" || !jQuery.contains(elem.ownerDocument, elem);
  }; // Multifunctional method to get and set values of a collection
  // The value/s can optionally be executed if it's a function


  var access = jQuery.access = function (elems, fn, key, value, chainable, emptyGet, raw) {
    var i = 0,
        length = elems.length,
        bulk = key == null; // Sets many values

    if (jQuery.type(key) === "object") {
      chainable = true;

      for (i in key) {
        jQuery.access(elems, fn, i, key[i], true, emptyGet, raw);
      } // Sets one value

    } else if (value !== undefined) {
      chainable = true;

      if (!jQuery.isFunction(value)) {
        raw = true;
      }

      if (bulk) {
        // Bulk operations run against the entire set
        if (raw) {
          fn.call(elems, value);
          fn = null; // ...except when executing function values
        } else {
          bulk = fn;

          fn = function fn(elem, key, value) {
            return bulk.call(jQuery(elem), value);
          };
        }
      }

      if (fn) {
        for (; i < length; i++) {
          fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
      }
    }

    return chainable ? elems : // Gets
    bulk ? fn.call(elems) : length ? fn(elems[0], key) : emptyGet;
  };

  var rcheckableType = /^(?:checkbox|radio)$/i;

  (function () {
    // Minified: var a,b,c
    var input = document.createElement("input"),
        div = document.createElement("div"),
        fragment = document.createDocumentFragment(); // Setup

    div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"; // IE strips leading whitespace when .innerHTML is used

    support.leadingWhitespace = div.firstChild.nodeType === 3; // Make sure that tbody elements aren't automatically inserted
    // IE will insert them into empty tables

    support.tbody = !div.getElementsByTagName("tbody").length; // Make sure that link elements get serialized correctly by innerHTML
    // This requires a wrapper element in IE

    support.htmlSerialize = !!div.getElementsByTagName("link").length; // Makes sure cloning an html5 element does not cause problems
    // Where outerHTML is undefined, this still works

    support.html5Clone = document.createElement("nav").cloneNode(true).outerHTML !== "<:nav></:nav>"; // Check if a disconnected checkbox will retain its checked
    // value of true after appended to the DOM (IE6/7)

    input.type = "checkbox";
    input.checked = true;
    fragment.appendChild(input);
    support.appendChecked = input.checked; // Make sure textarea (and checkbox) defaultValue is properly cloned
    // Support: IE6-IE11+

    div.innerHTML = "<textarea>x</textarea>";
    support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue; // #11217 - WebKit loses check when the name is after the checked attribute

    fragment.appendChild(div);
    div.innerHTML = "<input type='radio' checked='checked' name='t'/>"; // Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
    // old WebKit doesn't clone checked state correctly in fragments

    support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked; // Support: IE<9
    // Opera does not clone events (and typeof div.attachEvent === undefined).
    // IE9-10 clones events bound via attachEvent, but they don't trigger with .click()

    support.noCloneEvent = true;

    if (div.attachEvent) {
      div.attachEvent("onclick", function () {
        support.noCloneEvent = false;
      });
      div.cloneNode(true).click();
    } // Execute the test only if not already executed in another module.


    if (support.deleteExpando == null) {
      // Support: IE<9
      support.deleteExpando = true;

      try {
        delete div.test;
      } catch (e) {
        support.deleteExpando = false;
      }
    }
  })();

  (function () {
    var i,
        eventName,
        div = document.createElement("div"); // Support: IE<9 (lack submit/change bubble), Firefox 23+ (lack focusin event)

    for (i in {
      submit: true,
      change: true,
      focusin: true
    }) {
      eventName = "on" + i;

      if (!(support[i + "Bubbles"] = eventName in window)) {
        // Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
        div.setAttribute(eventName, "t");
        support[i + "Bubbles"] = div.attributes[eventName].expando === false;
      }
    } // Null elements to avoid leaks in IE.


    div = null;
  })();

  var rformElems = /^(?:input|select|textarea)$/i,
      rkeyEvent = /^key/,
      rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
      rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
      rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

  function returnTrue() {
    return true;
  }

  function returnFalse() {
    return false;
  }

  function safeActiveElement() {
    try {
      return document.activeElement;
    } catch (err) {}
  }
  /*
   * Helper functions for managing events -- not part of the public interface.
   * Props to Dean Edwards' addEvent library for many of the ideas.
   */


  jQuery.event = {
    global: {},
    add: function add(elem, types, handler, data, selector) {
      var tmp,
          events,
          t,
          handleObjIn,
          special,
          eventHandle,
          handleObj,
          handlers,
          type,
          namespaces,
          origType,
          elemData = jQuery._data(elem); // Don't attach events to noData or text/comment nodes (but allow plain objects)


      if (!elemData) {
        return;
      } // Caller can pass in an object of custom data in lieu of the handler


      if (handler.handler) {
        handleObjIn = handler;
        handler = handleObjIn.handler;
        selector = handleObjIn.selector;
      } // Make sure that the handler has a unique ID, used to find/remove it later


      if (!handler.guid) {
        handler.guid = jQuery.guid++;
      } // Init the element's event structure and main handler, if this is the first


      if (!(events = elemData.events)) {
        events = elemData.events = {};
      }

      if (!(eventHandle = elemData.handle)) {
        eventHandle = elemData.handle = function (e) {
          // Discard the second event of a jQuery.event.trigger() and
          // when an event is called after a page has unloaded
          return _typeof2(jQuery) !== strundefined && (!e || jQuery.event.triggered !== e.type) ? jQuery.event.dispatch.apply(eventHandle.elem, arguments) : undefined;
        }; // Add elem as a property of the handle fn to prevent a memory leak with IE non-native events


        eventHandle.elem = elem;
      } // Handle multiple events separated by a space


      types = (types || "").match(rnotwhite) || [""];
      t = types.length;

      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort(); // There *must* be a type, no attaching namespace-only handlers

        if (!type) {
          continue;
        } // If event changes its type, use the special event handlers for the changed type


        special = jQuery.event.special[type] || {}; // If selector defined, determine special event api type, otherwise given type

        type = (selector ? special.delegateType : special.bindType) || type; // Update special based on newly reset type

        special = jQuery.event.special[type] || {}; // handleObj is passed to all event handlers

        handleObj = jQuery.extend({
          type: type,
          origType: origType,
          data: data,
          handler: handler,
          guid: handler.guid,
          selector: selector,
          needsContext: selector && jQuery.expr.match.needsContext.test(selector),
          namespace: namespaces.join(".")
        }, handleObjIn); // Init the event handler queue if we're the first

        if (!(handlers = events[type])) {
          handlers = events[type] = [];
          handlers.delegateCount = 0; // Only use addEventListener/attachEvent if the special events handler returns false

          if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
            // Bind the global event handler to the element
            if (elem.addEventListener) {
              elem.addEventListener(type, eventHandle, false);
            } else if (elem.attachEvent) {
              elem.attachEvent("on" + type, eventHandle);
            }
          }
        }

        if (special.add) {
          special.add.call(elem, handleObj);

          if (!handleObj.handler.guid) {
            handleObj.handler.guid = handler.guid;
          }
        } // Add to the element's handler list, delegates in front


        if (selector) {
          handlers.splice(handlers.delegateCount++, 0, handleObj);
        } else {
          handlers.push(handleObj);
        } // Keep track of which events have ever been used, for event optimization


        jQuery.event.global[type] = true;
      } // Nullify elem to prevent memory leaks in IE


      elem = null;
    },
    // Detach an event or set of events from an element
    remove: function remove(elem, types, handler, selector, mappedTypes) {
      var j,
          handleObj,
          tmp,
          origCount,
          t,
          events,
          special,
          handlers,
          type,
          namespaces,
          origType,
          elemData = jQuery.hasData(elem) && jQuery._data(elem);

      if (!elemData || !(events = elemData.events)) {
        return;
      } // Once for each type.namespace in types; type may be omitted


      types = (types || "").match(rnotwhite) || [""];
      t = types.length;

      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort(); // Unbind all events (on this namespace, if provided) for the element

        if (!type) {
          for (type in events) {
            jQuery.event.remove(elem, type + types[t], handler, selector, true);
          }

          continue;
        }

        special = jQuery.event.special[type] || {};
        type = (selector ? special.delegateType : special.bindType) || type;
        handlers = events[type] || [];
        tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"); // Remove matching events

        origCount = j = handlers.length;

        while (j--) {
          handleObj = handlers[j];

          if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
            handlers.splice(j, 1);

            if (handleObj.selector) {
              handlers.delegateCount--;
            }

            if (special.remove) {
              special.remove.call(elem, handleObj);
            }
          }
        } // Remove generic event handler if we removed something and no more handlers exist
        // (avoids potential for endless recursion during removal of special event handlers)


        if (origCount && !handlers.length) {
          if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
            jQuery.removeEvent(elem, type, elemData.handle);
          }

          delete events[type];
        }
      } // Remove the expando if it's no longer used


      if (jQuery.isEmptyObject(events)) {
        delete elemData.handle; // removeData also checks for emptiness and clears the expando if empty
        // so use it instead of delete

        jQuery._removeData(elem, "events");
      }
    },
    trigger: function trigger(event, data, elem, onlyHandlers) {
      var handle,
          ontype,
          cur,
          bubbleType,
          special,
          tmp,
          i,
          eventPath = [elem || document],
          type = hasOwn.call(event, "type") ? event.type : event,
          namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
      cur = tmp = elem = elem || document; // Don't do events on text and comment nodes

      if (elem.nodeType === 3 || elem.nodeType === 8) {
        return;
      } // focus/blur morphs to focusin/out; ensure we're not firing them right now


      if (rfocusMorph.test(type + jQuery.event.triggered)) {
        return;
      }

      if (type.indexOf(".") >= 0) {
        // Namespaced trigger; create a regexp to match event type in handle()
        namespaces = type.split(".");
        type = namespaces.shift();
        namespaces.sort();
      }

      ontype = type.indexOf(":") < 0 && "on" + type; // Caller can pass in a jQuery.Event object, Object, or just an event type string

      event = event[jQuery.expando] ? event : new jQuery.Event(type, _typeof2(event) === "object" && event); // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)

      event.isTrigger = onlyHandlers ? 2 : 3;
      event.namespace = namespaces.join(".");
      event.namespace_re = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null; // Clean up the event in case it is being reused

      event.result = undefined;

      if (!event.target) {
        event.target = elem;
      } // Clone any incoming data and prepend the event, creating the handler arg list


      data = data == null ? [event] : jQuery.makeArray(data, [event]); // Allow special events to draw outside the lines

      special = jQuery.event.special[type] || {};

      if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
        return;
      } // Determine event propagation path in advance, per W3C events spec (#9951)
      // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)


      if (!onlyHandlers && !special.noBubble && !jQuery.isWindow(elem)) {
        bubbleType = special.delegateType || type;

        if (!rfocusMorph.test(bubbleType + type)) {
          cur = cur.parentNode;
        }

        for (; cur; cur = cur.parentNode) {
          eventPath.push(cur);
          tmp = cur;
        } // Only add window if we got to document (e.g., not plain obj or detached DOM)


        if (tmp === (elem.ownerDocument || document)) {
          eventPath.push(tmp.defaultView || tmp.parentWindow || window);
        }
      } // Fire handlers on the event path


      i = 0;

      while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
        event.type = i > 1 ? bubbleType : special.bindType || type; // jQuery handler

        handle = (jQuery._data(cur, "events") || {})[event.type] && jQuery._data(cur, "handle");

        if (handle) {
          handle.apply(cur, data);
        } // Native handler


        handle = ontype && cur[ontype];

        if (handle && handle.apply && jQuery.acceptData(cur)) {
          event.result = handle.apply(cur, data);

          if (event.result === false) {
            event.preventDefault();
          }
        }
      }

      event.type = type; // If nobody prevented the default action, do it now

      if (!onlyHandlers && !event.isDefaultPrevented()) {
        if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && jQuery.acceptData(elem)) {
          // Call a native DOM method on the target with the same name name as the event.
          // Can't use an .isFunction() check here because IE6/7 fails that test.
          // Don't do default actions on window, that's where global variables be (#6170)
          if (ontype && elem[type] && !jQuery.isWindow(elem)) {
            // Don't re-trigger an onFOO event when we call its FOO() method
            tmp = elem[ontype];

            if (tmp) {
              elem[ontype] = null;
            } // Prevent re-triggering of the same event, since we already bubbled it above


            jQuery.event.triggered = type;

            try {
              elem[type]();
            } catch (e) {// IE<9 dies on focus/blur to hidden element (#1486,#12518)
              // only reproducible on winXP IE8 native, not IE9 in IE8 mode
            }

            jQuery.event.triggered = undefined;

            if (tmp) {
              elem[ontype] = tmp;
            }
          }
        }
      }

      return event.result;
    },
    dispatch: function dispatch(event) {
      // Make a writable jQuery.Event from the native event object
      event = jQuery.event.fix(event);

      var i,
          ret,
          handleObj,
          matched,
          j,
          handlerQueue = [],
          args = _slice.call(arguments),
          handlers = (jQuery._data(this, "events") || {})[event.type] || [],
          special = jQuery.event.special[event.type] || {}; // Use the fix-ed jQuery.Event rather than the (read-only) native event


      args[0] = event;
      event.delegateTarget = this; // Call the preDispatch hook for the mapped type, and let it bail if desired

      if (special.preDispatch && special.preDispatch.call(this, event) === false) {
        return;
      } // Determine handlers


      handlerQueue = jQuery.event.handlers.call(this, event, handlers); // Run delegates first; they may want to stop propagation beneath us

      i = 0;

      while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
        event.currentTarget = matched.elem;
        j = 0;

        while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
          // Triggered event must either 1) have no namespace, or
          // 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
          if (!event.namespace_re || event.namespace_re.test(handleObj.namespace)) {
            event.handleObj = handleObj;
            event.data = handleObj.data;
            ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);

            if (ret !== undefined) {
              if ((event.result = ret) === false) {
                event.preventDefault();
                event.stopPropagation();
              }
            }
          }
        }
      } // Call the postDispatch hook for the mapped type


      if (special.postDispatch) {
        special.postDispatch.call(this, event);
      }

      return event.result;
    },
    handlers: function handlers(event, _handlers) {
      var sel,
          handleObj,
          matches,
          i,
          handlerQueue = [],
          delegateCount = _handlers.delegateCount,
          cur = event.target; // Find delegate handlers
      // Black-hole SVG <use> instance trees (#13180)
      // Avoid non-left-click bubbling in Firefox (#3861)

      if (delegateCount && cur.nodeType && (!event.button || event.type !== "click")) {
        /* jshint eqeqeq: false */
        for (; cur != this; cur = cur.parentNode || this) {
          /* jshint eqeqeq: true */
          // Don't check non-elements (#13208)
          // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
          if (cur.nodeType === 1 && (cur.disabled !== true || event.type !== "click")) {
            matches = [];

            for (i = 0; i < delegateCount; i++) {
              handleObj = _handlers[i]; // Don't conflict with Object.prototype properties (#13203)

              sel = handleObj.selector + " ";

              if (matches[sel] === undefined) {
                matches[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) >= 0 : jQuery.find(sel, this, null, [cur]).length;
              }

              if (matches[sel]) {
                matches.push(handleObj);
              }
            }

            if (matches.length) {
              handlerQueue.push({
                elem: cur,
                handlers: matches
              });
            }
          }
        }
      } // Add the remaining (directly-bound) handlers


      if (delegateCount < _handlers.length) {
        handlerQueue.push({
          elem: this,
          handlers: _handlers.slice(delegateCount)
        });
      }

      return handlerQueue;
    },
    fix: function fix(event) {
      if (event[jQuery.expando]) {
        return event;
      } // Create a writable copy of the event object and normalize some properties


      var i,
          prop,
          copy,
          type = event.type,
          originalEvent = event,
          fixHook = this.fixHooks[type];

      if (!fixHook) {
        this.fixHooks[type] = fixHook = rmouseEvent.test(type) ? this.mouseHooks : rkeyEvent.test(type) ? this.keyHooks : {};
      }

      copy = fixHook.props ? this.props.concat(fixHook.props) : this.props;
      event = new jQuery.Event(originalEvent);
      i = copy.length;

      while (i--) {
        prop = copy[i];
        event[prop] = originalEvent[prop];
      } // Support: IE<9
      // Fix target property (#1925)


      if (!event.target) {
        event.target = originalEvent.srcElement || document;
      } // Support: Chrome 23+, Safari?
      // Target should not be a text node (#504, #13143)


      if (event.target.nodeType === 3) {
        event.target = event.target.parentNode;
      } // Support: IE<9
      // For mouse/key events, metaKey==false if it's undefined (#3368, #11328)


      event.metaKey = !!event.metaKey;
      return fixHook.filter ? fixHook.filter(event, originalEvent) : event;
    },
    // Includes some event props shared by KeyEvent and MouseEvent
    props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
    fixHooks: {},
    keyHooks: {
      props: "char charCode key keyCode".split(" "),
      filter: function filter(event, original) {
        // Add which for key events
        if (event.which == null) {
          event.which = original.charCode != null ? original.charCode : original.keyCode;
        }

        return event;
      }
    },
    mouseHooks: {
      props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
      filter: function filter(event, original) {
        var body,
            eventDoc,
            doc,
            button = original.button,
            fromElement = original.fromElement; // Calculate pageX/Y if missing and clientX/Y available

        if (event.pageX == null && original.clientX != null) {
          eventDoc = event.target.ownerDocument || document;
          doc = eventDoc.documentElement;
          body = eventDoc.body;
          event.pageX = original.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
          event.pageY = original.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
        } // Add relatedTarget, if necessary


        if (!event.relatedTarget && fromElement) {
          event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
        } // Add which for click: 1 === left; 2 === middle; 3 === right
        // Note: button is not normalized, so don't use it


        if (!event.which && button !== undefined) {
          event.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
        }

        return event;
      }
    },
    special: {
      load: {
        // Prevent triggered image.load events from bubbling to window.load
        noBubble: true
      },
      focus: {
        // Fire native event if possible so blur/focus sequence is correct
        trigger: function trigger() {
          if (this !== safeActiveElement() && this.focus) {
            try {
              this.focus();
              return false;
            } catch (e) {// Support: IE<9
              // If we error on focus to hidden element (#1486, #12518),
              // let .trigger() run the handlers
            }
          }
        },
        delegateType: "focusin"
      },
      blur: {
        trigger: function trigger() {
          if (this === safeActiveElement() && this.blur) {
            this.blur();
            return false;
          }
        },
        delegateType: "focusout"
      },
      click: {
        // For checkbox, fire native event so checked state will be right
        trigger: function trigger() {
          if (jQuery.nodeName(this, "input") && this.type === "checkbox" && this.click) {
            this.click();
            return false;
          }
        },
        // For cross-browser consistency, don't fire native .click() on links
        _default: function _default(event) {
          return jQuery.nodeName(event.target, "a");
        }
      },
      beforeunload: {
        postDispatch: function postDispatch(event) {
          // Support: Firefox 20+
          // Firefox doesn't alert if the returnValue field is not set.
          if (event.result !== undefined && event.originalEvent) {
            event.originalEvent.returnValue = event.result;
          }
        }
      }
    },
    simulate: function simulate(type, elem, event, bubble) {
      // Piggyback on a donor event to simulate a different one.
      // Fake originalEvent to avoid donor's stopPropagation, but if the
      // simulated event prevents default then we do the same on the donor.
      var e = jQuery.extend(new jQuery.Event(), event, {
        type: type,
        isSimulated: true,
        originalEvent: {}
      });

      if (bubble) {
        jQuery.event.trigger(e, null, elem);
      } else {
        jQuery.event.dispatch.call(elem, e);
      }

      if (e.isDefaultPrevented()) {
        event.preventDefault();
      }
    }
  };
  jQuery.removeEvent = document.removeEventListener ? function (elem, type, handle) {
    if (elem.removeEventListener) {
      elem.removeEventListener(type, handle, false);
    }
  } : function (elem, type, handle) {
    var name = "on" + type;

    if (elem.detachEvent) {
      // #8545, #7054, preventing memory leaks for custom events in IE6-8
      // detachEvent needed property on element, by name of that event, to properly expose it to GC
      if (_typeof2(elem[name]) === strundefined) {
        elem[name] = null;
      }

      elem.detachEvent(name, handle);
    }
  };

  jQuery.Event = function (src, props) {
    // Allow instantiation without the 'new' keyword
    if (!(this instanceof jQuery.Event)) {
      return new jQuery.Event(src, props);
    } // Event object


    if (src && src.type) {
      this.originalEvent = src;
      this.type = src.type; // Events bubbling up the document may have been marked as prevented
      // by a handler lower down the tree; reflect the correct value.

      this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: IE < 9, Android < 4.0
      src.returnValue === false ? returnTrue : returnFalse; // Event type
    } else {
      this.type = src;
    } // Put explicitly provided properties onto the event object


    if (props) {
      jQuery.extend(this, props);
    } // Create a timestamp if incoming event doesn't have one


    this.timeStamp = src && src.timeStamp || jQuery.now(); // Mark it as fixed

    this[jQuery.expando] = true;
  }; // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
  // http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html


  jQuery.Event.prototype = {
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    preventDefault: function preventDefault() {
      var e = this.originalEvent;
      this.isDefaultPrevented = returnTrue;

      if (!e) {
        return;
      } // If preventDefault exists, run it on the original event


      if (e.preventDefault) {
        e.preventDefault(); // Support: IE
        // Otherwise set the returnValue property of the original event to false
      } else {
        e.returnValue = false;
      }
    },
    stopPropagation: function stopPropagation() {
      var e = this.originalEvent;
      this.isPropagationStopped = returnTrue;

      if (!e) {
        return;
      } // If stopPropagation exists, run it on the original event


      if (e.stopPropagation) {
        e.stopPropagation();
      } // Support: IE
      // Set the cancelBubble property of the original event to true


      e.cancelBubble = true;
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      var e = this.originalEvent;
      this.isImmediatePropagationStopped = returnTrue;

      if (e && e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }

      this.stopPropagation();
    }
  }; // Create mouseenter/leave events using mouseover/out and event-time checks

  jQuery.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function (orig, fix) {
    jQuery.event.special[orig] = {
      delegateType: fix,
      bindType: fix,
      handle: function handle(event) {
        var ret,
            target = this,
            related = event.relatedTarget,
            handleObj = event.handleObj; // For mousenter/leave call the handler if related is outside the target.
        // NB: No relatedTarget if the mouse left/entered the browser window

        if (!related || related !== target && !jQuery.contains(target, related)) {
          event.type = handleObj.origType;
          ret = handleObj.handler.apply(this, arguments);
          event.type = fix;
        }

        return ret;
      }
    };
  }); // IE submit delegation

  if (!support.submitBubbles) {
    jQuery.event.special.submit = {
      setup: function setup() {
        // Only need this for delegated form submit events
        if (jQuery.nodeName(this, "form")) {
          return false;
        } // Lazy-add a submit handler when a descendant form may potentially be submitted


        jQuery.event.add(this, "click._submit keypress._submit", function (e) {
          // Node name check avoids a VML-related crash in IE (#9807)
          var elem = e.target,
              form = jQuery.nodeName(elem, "input") || jQuery.nodeName(elem, "button") ? elem.form : undefined;

          if (form && !jQuery._data(form, "submitBubbles")) {
            jQuery.event.add(form, "submit._submit", function (event) {
              event._submit_bubble = true;
            });

            jQuery._data(form, "submitBubbles", true);
          }
        }); // return undefined since we don't need an event listener
      },
      postDispatch: function postDispatch(event) {
        // If form was submitted by the user, bubble the event up the tree
        if (event._submit_bubble) {
          delete event._submit_bubble;

          if (this.parentNode && !event.isTrigger) {
            jQuery.event.simulate("submit", this.parentNode, event, true);
          }
        }
      },
      teardown: function teardown() {
        // Only need this for delegated form submit events
        if (jQuery.nodeName(this, "form")) {
          return false;
        } // Remove delegated handlers; cleanData eventually reaps submit handlers attached above


        jQuery.event.remove(this, "._submit");
      }
    };
  } // IE change delegation and checkbox/radio fix


  if (!support.changeBubbles) {
    jQuery.event.special.change = {
      setup: function setup() {
        if (rformElems.test(this.nodeName)) {
          // IE doesn't fire change on a check/radio until blur; trigger it on click
          // after a propertychange. Eat the blur-change in special.change.handle.
          // This still fires onchange a second time for check/radio after blur.
          if (this.type === "checkbox" || this.type === "radio") {
            jQuery.event.add(this, "propertychange._change", function (event) {
              if (event.originalEvent.propertyName === "checked") {
                this._just_changed = true;
              }
            });
            jQuery.event.add(this, "click._change", function (event) {
              if (this._just_changed && !event.isTrigger) {
                this._just_changed = false;
              } // Allow triggered, simulated change events (#11500)


              jQuery.event.simulate("change", this, event, true);
            });
          }

          return false;
        } // Delegated event; lazy-add a change handler on descendant inputs


        jQuery.event.add(this, "beforeactivate._change", function (e) {
          var elem = e.target;

          if (rformElems.test(elem.nodeName) && !jQuery._data(elem, "changeBubbles")) {
            jQuery.event.add(elem, "change._change", function (event) {
              if (this.parentNode && !event.isSimulated && !event.isTrigger) {
                jQuery.event.simulate("change", this.parentNode, event, true);
              }
            });

            jQuery._data(elem, "changeBubbles", true);
          }
        });
      },
      handle: function handle(event) {
        var elem = event.target; // Swallow native change events from checkbox/radio, we already triggered them above

        if (this !== elem || event.isSimulated || event.isTrigger || elem.type !== "radio" && elem.type !== "checkbox") {
          return event.handleObj.handler.apply(this, arguments);
        }
      },
      teardown: function teardown() {
        jQuery.event.remove(this, "._change");
        return !rformElems.test(this.nodeName);
      }
    };
  } // Create "bubbling" focus and blur events


  if (!support.focusinBubbles) {
    jQuery.each({
      focus: "focusin",
      blur: "focusout"
    }, function (orig, fix) {
      // Attach a single capturing handler on the document while someone wants focusin/focusout
      var handler = function handler(event) {
        jQuery.event.simulate(fix, event.target, jQuery.event.fix(event), true);
      };

      jQuery.event.special[fix] = {
        setup: function setup() {
          var doc = this.ownerDocument || this,
              attaches = jQuery._data(doc, fix);

          if (!attaches) {
            doc.addEventListener(orig, handler, true);
          }

          jQuery._data(doc, fix, (attaches || 0) + 1);
        },
        teardown: function teardown() {
          var doc = this.ownerDocument || this,
              attaches = jQuery._data(doc, fix) - 1;

          if (!attaches) {
            doc.removeEventListener(orig, handler, true);

            jQuery._removeData(doc, fix);
          } else {
            jQuery._data(doc, fix, attaches);
          }
        }
      };
    });
  }

  jQuery.fn.extend({
    on: function on(types, selector, data, fn,
    /*INTERNAL*/
    one) {
      var type, origFn; // Types can be a map of types/handlers

      if (_typeof2(types) === "object") {
        // ( types-Object, selector, data )
        if (typeof selector !== "string") {
          // ( types-Object, data )
          data = data || selector;
          selector = undefined;
        }

        for (type in types) {
          this.on(type, selector, data, types[type], one);
        }

        return this;
      }

      if (data == null && fn == null) {
        // ( types, fn )
        fn = selector;
        data = selector = undefined;
      } else if (fn == null) {
        if (typeof selector === "string") {
          // ( types, selector, fn )
          fn = data;
          data = undefined;
        } else {
          // ( types, data, fn )
          fn = data;
          data = selector;
          selector = undefined;
        }
      }

      if (fn === false) {
        fn = returnFalse;
      } else if (!fn) {
        return this;
      }

      if (one === 1) {
        origFn = fn;

        fn = function fn(event) {
          // Can use an empty set, since event contains the info
          jQuery().off(event);
          return origFn.apply(this, arguments);
        }; // Use same guid so caller can remove using origFn


        fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
      }

      return this.each(function () {
        jQuery.event.add(this, types, fn, data, selector);
      });
    },
    one: function one(types, selector, data, fn) {
      return this.on(types, selector, data, fn, 1);
    },
    off: function off(types, selector, fn) {
      var handleObj, type;

      if (types && types.preventDefault && types.handleObj) {
        // ( event )  dispatched jQuery.Event
        handleObj = types.handleObj;
        jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
        return this;
      }

      if (_typeof2(types) === "object") {
        // ( types-object [, selector] )
        for (type in types) {
          this.off(type, selector, types[type]);
        }

        return this;
      }

      if (selector === false || typeof selector === "function") {
        // ( types [, fn] )
        fn = selector;
        selector = undefined;
      }

      if (fn === false) {
        fn = returnFalse;
      }

      return this.each(function () {
        jQuery.event.remove(this, types, fn, selector);
      });
    },
    trigger: function trigger(type, data) {
      return this.each(function () {
        jQuery.event.trigger(type, data, this);
      });
    },
    triggerHandler: function triggerHandler(type, data) {
      var elem = this[0];

      if (elem) {
        return jQuery.event.trigger(type, data, elem, true);
      }
    }
  });

  function createSafeFragment(document) {
    var list = nodeNames.split("|"),
        safeFrag = document.createDocumentFragment();

    if (safeFrag.createElement) {
      while (list.length) {
        safeFrag.createElement(list.pop());
      }
    }

    return safeFrag;
  }

  var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|" + "header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
      rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
      rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),
      rleadingWhitespace = /^\s+/,
      rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
      rtagName = /<([\w:]+)/,
      rtbody = /<tbody/i,
      rhtml = /<|&#?\w+;/,
      rnoInnerhtml = /<(?:script|style|link)/i,
      // checked="checked" or checked
  rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
      rscriptType = /^$|\/(?:java|ecma)script/i,
      rscriptTypeMasked = /^true\/(.*)/,
      rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
      // We have to close these tags to support XHTML (#13200)
  wrapMap = {
    option: [1, "<select multiple='multiple'>", "</select>"],
    legend: [1, "<fieldset>", "</fieldset>"],
    area: [1, "<map>", "</map>"],
    param: [1, "<object>", "</object>"],
    thead: [1, "<table>", "</table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    // IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
    // unless wrapped in a div with non-breaking characters in front of it.
    _default: support.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
  },
      safeFragment = createSafeFragment(document),
      fragmentDiv = safeFragment.appendChild(document.createElement("div"));
  wrapMap.optgroup = wrapMap.option;
  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td;

  function getAll(context, tag) {
    var elems,
        elem,
        i = 0,
        found = _typeof2(context.getElementsByTagName) !== strundefined ? context.getElementsByTagName(tag || "*") : _typeof2(context.querySelectorAll) !== strundefined ? context.querySelectorAll(tag || "*") : undefined;

    if (!found) {
      for (found = [], elems = context.childNodes || context; (elem = elems[i]) != null; i++) {
        if (!tag || jQuery.nodeName(elem, tag)) {
          found.push(elem);
        } else {
          jQuery.merge(found, getAll(elem, tag));
        }
      }
    }

    return tag === undefined || tag && jQuery.nodeName(context, tag) ? jQuery.merge([context], found) : found;
  } // Used in buildFragment, fixes the defaultChecked property


  function fixDefaultChecked(elem) {
    if (rcheckableType.test(elem.type)) {
      elem.defaultChecked = elem.checked;
    }
  } // Support: IE<8
  // Manipulating tables requires a tbody


  function manipulationTarget(elem, content) {
    return jQuery.nodeName(elem, "table") && jQuery.nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr") ? elem.getElementsByTagName("tbody")[0] || elem.appendChild(elem.ownerDocument.createElement("tbody")) : elem;
  } // Replace/restore the type attribute of script elements for safe DOM manipulation


  function disableScript(elem) {
    elem.type = (jQuery.find.attr(elem, "type") !== null) + "/" + elem.type;
    return elem;
  }

  function restoreScript(elem) {
    var match = rscriptTypeMasked.exec(elem.type);

    if (match) {
      elem.type = match[1];
    } else {
      elem.removeAttribute("type");
    }

    return elem;
  } // Mark scripts as having already been evaluated


  function setGlobalEval(elems, refElements) {
    var elem,
        i = 0;

    for (; (elem = elems[i]) != null; i++) {
      jQuery._data(elem, "globalEval", !refElements || jQuery._data(refElements[i], "globalEval"));
    }
  }

  function cloneCopyEvent(src, dest) {
    if (dest.nodeType !== 1 || !jQuery.hasData(src)) {
      return;
    }

    var type,
        i,
        l,
        oldData = jQuery._data(src),
        curData = jQuery._data(dest, oldData),
        events = oldData.events;

    if (events) {
      delete curData.handle;
      curData.events = {};

      for (type in events) {
        for (i = 0, l = events[type].length; i < l; i++) {
          jQuery.event.add(dest, type, events[type][i]);
        }
      }
    } // make the cloned public data object a copy from the original


    if (curData.data) {
      curData.data = jQuery.extend({}, curData.data);
    }
  }

  function fixCloneNodeIssues(src, dest) {
    var nodeName, e, data; // We do not need to do anything for non-Elements

    if (dest.nodeType !== 1) {
      return;
    }

    nodeName = dest.nodeName.toLowerCase(); // IE6-8 copies events bound via attachEvent when using cloneNode.

    if (!support.noCloneEvent && dest[jQuery.expando]) {
      data = jQuery._data(dest);

      for (e in data.events) {
        jQuery.removeEvent(dest, e, data.handle);
      } // Event data gets referenced instead of copied if the expando gets copied too


      dest.removeAttribute(jQuery.expando);
    } // IE blanks contents when cloning scripts, and tries to evaluate newly-set text


    if (nodeName === "script" && dest.text !== src.text) {
      disableScript(dest).text = src.text;
      restoreScript(dest); // IE6-10 improperly clones children of object elements using classid.
      // IE10 throws NoModificationAllowedError if parent is null, #12132.
    } else if (nodeName === "object") {
      if (dest.parentNode) {
        dest.outerHTML = src.outerHTML;
      } // This path appears unavoidable for IE9. When cloning an object
      // element in IE9, the outerHTML strategy above is not sufficient.
      // If the src has innerHTML and the destination does not,
      // copy the src.innerHTML into the dest.innerHTML. #10324


      if (support.html5Clone && src.innerHTML && !jQuery.trim(dest.innerHTML)) {
        dest.innerHTML = src.innerHTML;
      }
    } else if (nodeName === "input" && rcheckableType.test(src.type)) {
      // IE6-8 fails to persist the checked state of a cloned checkbox
      // or radio button. Worse, IE6-7 fail to give the cloned element
      // a checked appearance if the defaultChecked value isn't also set
      dest.defaultChecked = dest.checked = src.checked; // IE6-7 get confused and end up setting the value of a cloned
      // checkbox/radio button to an empty string instead of "on"

      if (dest.value !== src.value) {
        dest.value = src.value;
      } // IE6-8 fails to return the selected option to the default selected
      // state when cloning options

    } else if (nodeName === "option") {
      dest.defaultSelected = dest.selected = src.defaultSelected; // IE6-8 fails to set the defaultValue to the correct value when
      // cloning other types of input fields
    } else if (nodeName === "input" || nodeName === "textarea") {
      dest.defaultValue = src.defaultValue;
    }
  }

  jQuery.extend({
    clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
      var destElements,
          node,
          clone,
          i,
          srcElements,
          inPage = jQuery.contains(elem.ownerDocument, elem);

      if (support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test("<" + elem.nodeName + ">")) {
        clone = elem.cloneNode(true); // IE<=8 does not properly clone detached, unknown element nodes
      } else {
        fragmentDiv.innerHTML = elem.outerHTML;
        fragmentDiv.removeChild(clone = fragmentDiv.firstChild);
      }

      if ((!support.noCloneEvent || !support.noCloneChecked) && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
        // We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
        destElements = getAll(clone);
        srcElements = getAll(elem); // Fix all IE cloning issues

        for (i = 0; (node = srcElements[i]) != null; ++i) {
          // Ensure that the destination node is not null; Fixes #9587
          if (destElements[i]) {
            fixCloneNodeIssues(node, destElements[i]);
          }
        }
      } // Copy the events from the original to the clone


      if (dataAndEvents) {
        if (deepDataAndEvents) {
          srcElements = srcElements || getAll(elem);
          destElements = destElements || getAll(clone);

          for (i = 0; (node = srcElements[i]) != null; i++) {
            cloneCopyEvent(node, destElements[i]);
          }
        } else {
          cloneCopyEvent(elem, clone);
        }
      } // Preserve script evaluation history


      destElements = getAll(clone, "script");

      if (destElements.length > 0) {
        setGlobalEval(destElements, !inPage && getAll(elem, "script"));
      }

      destElements = srcElements = node = null; // Return the cloned set

      return clone;
    },
    buildFragment: function buildFragment(elems, context, scripts, selection) {
      var j,
          elem,
          contains,
          tmp,
          tag,
          tbody,
          wrap,
          l = elems.length,
          // Ensure a safe fragment
      safe = createSafeFragment(context),
          nodes = [],
          i = 0;

      for (; i < l; i++) {
        elem = elems[i];

        if (elem || elem === 0) {
          // Add nodes directly
          if (jQuery.type(elem) === "object") {
            jQuery.merge(nodes, elem.nodeType ? [elem] : elem); // Convert non-html into a text node
          } else if (!rhtml.test(elem)) {
            nodes.push(context.createTextNode(elem)); // Convert html into DOM nodes
          } else {
            tmp = tmp || safe.appendChild(context.createElement("div")); // Deserialize a standard representation

            tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
            wrap = wrapMap[tag] || wrapMap._default;
            tmp.innerHTML = wrap[1] + elem.replace(rxhtmlTag, "<$1></$2>") + wrap[2]; // Descend through wrappers to the right content

            j = wrap[0];

            while (j--) {
              tmp = tmp.lastChild;
            } // Manually add leading whitespace removed by IE


            if (!support.leadingWhitespace && rleadingWhitespace.test(elem)) {
              nodes.push(context.createTextNode(rleadingWhitespace.exec(elem)[0]));
            } // Remove IE's autoinserted <tbody> from table fragments


            if (!support.tbody) {
              // String was a <table>, *may* have spurious <tbody>
              elem = tag === "table" && !rtbody.test(elem) ? tmp.firstChild : // String was a bare <thead> or <tfoot>
              wrap[1] === "<table>" && !rtbody.test(elem) ? tmp : 0;
              j = elem && elem.childNodes.length;

              while (j--) {
                if (jQuery.nodeName(tbody = elem.childNodes[j], "tbody") && !tbody.childNodes.length) {
                  elem.removeChild(tbody);
                }
              }
            }

            jQuery.merge(nodes, tmp.childNodes); // Fix #12392 for WebKit and IE > 9

            tmp.textContent = ""; // Fix #12392 for oldIE

            while (tmp.firstChild) {
              tmp.removeChild(tmp.firstChild);
            } // Remember the top-level container for proper cleanup


            tmp = safe.lastChild;
          }
        }
      } // Fix #11356: Clear elements from fragment


      if (tmp) {
        safe.removeChild(tmp);
      } // Reset defaultChecked for any radios and checkboxes
      // about to be appended to the DOM in IE 6/7 (#8060)


      if (!support.appendChecked) {
        jQuery.grep(getAll(nodes, "input"), fixDefaultChecked);
      }

      i = 0;

      while (elem = nodes[i++]) {
        // #4087 - If origin and destination elements are the same, and this is
        // that element, do not do anything
        if (selection && jQuery.inArray(elem, selection) !== -1) {
          continue;
        }

        contains = jQuery.contains(elem.ownerDocument, elem); // Append to fragment

        tmp = getAll(safe.appendChild(elem), "script"); // Preserve script evaluation history

        if (contains) {
          setGlobalEval(tmp);
        } // Capture executables


        if (scripts) {
          j = 0;

          while (elem = tmp[j++]) {
            if (rscriptType.test(elem.type || "")) {
              scripts.push(elem);
            }
          }
        }
      }

      tmp = null;
      return safe;
    },
    cleanData: function cleanData(elems,
    /* internal */
    acceptData) {
      var elem,
          type,
          id,
          data,
          i = 0,
          internalKey = jQuery.expando,
          cache = jQuery.cache,
          deleteExpando = support.deleteExpando,
          special = jQuery.event.special;

      for (; (elem = elems[i]) != null; i++) {
        if (acceptData || jQuery.acceptData(elem)) {
          id = elem[internalKey];
          data = id && cache[id];

          if (data) {
            if (data.events) {
              for (type in data.events) {
                if (special[type]) {
                  jQuery.event.remove(elem, type); // This is a shortcut to avoid jQuery.event.remove's overhead
                } else {
                  jQuery.removeEvent(elem, type, data.handle);
                }
              }
            } // Remove cache only if it was not already removed by jQuery.event.remove


            if (cache[id]) {
              delete cache[id]; // IE does not allow us to delete expando properties from nodes,
              // nor does it have a removeAttribute function on Document nodes;
              // we must handle all of these cases

              if (deleteExpando) {
                delete elem[internalKey];
              } else if (_typeof2(elem.removeAttribute) !== strundefined) {
                elem.removeAttribute(internalKey);
              } else {
                elem[internalKey] = null;
              }

              deletedIds.push(id);
            }
          }
        }
      }
    }
  });
  jQuery.fn.extend({
    text: function text(value) {
      return access(this, function (value) {
        return value === undefined ? jQuery.text(this) : this.empty().append((this[0] && this[0].ownerDocument || document).createTextNode(value));
      }, null, value, arguments.length);
    },
    append: function append() {
      return this.domManip(arguments, function (elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.appendChild(elem);
        }
      });
    },
    prepend: function prepend() {
      return this.domManip(arguments, function (elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.insertBefore(elem, target.firstChild);
        }
      });
    },
    before: function before() {
      return this.domManip(arguments, function (elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this);
        }
      });
    },
    after: function after() {
      return this.domManip(arguments, function (elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this.nextSibling);
        }
      });
    },
    remove: function remove(selector, keepData
    /* Internal Use Only */
    ) {
      var elem,
          elems = selector ? jQuery.filter(selector, this) : this,
          i = 0;

      for (; (elem = elems[i]) != null; i++) {
        if (!keepData && elem.nodeType === 1) {
          jQuery.cleanData(getAll(elem));
        }

        if (elem.parentNode) {
          if (keepData && jQuery.contains(elem.ownerDocument, elem)) {
            setGlobalEval(getAll(elem, "script"));
          }

          elem.parentNode.removeChild(elem);
        }
      }

      return this;
    },
    empty: function empty() {
      var elem,
          i = 0;

      for (; (elem = this[i]) != null; i++) {
        // Remove element nodes and prevent memory leaks
        if (elem.nodeType === 1) {
          jQuery.cleanData(getAll(elem, false));
        } // Remove any remaining nodes


        while (elem.firstChild) {
          elem.removeChild(elem.firstChild);
        } // If this is a select, ensure that it displays empty (#12336)
        // Support: IE<9


        if (elem.options && jQuery.nodeName(elem, "select")) {
          elem.options.length = 0;
        }
      }

      return this;
    },
    clone: function clone(dataAndEvents, deepDataAndEvents) {
      dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
      deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
      return this.map(function () {
        return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
      });
    },
    html: function html(value) {
      return access(this, function (value) {
        var elem = this[0] || {},
            i = 0,
            l = this.length;

        if (value === undefined) {
          return elem.nodeType === 1 ? elem.innerHTML.replace(rinlinejQuery, "") : undefined;
        } // See if we can take a shortcut and just use innerHTML


        if (typeof value === "string" && !rnoInnerhtml.test(value) && (support.htmlSerialize || !rnoshimcache.test(value)) && (support.leadingWhitespace || !rleadingWhitespace.test(value)) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
          value = value.replace(rxhtmlTag, "<$1></$2>");

          try {
            for (; i < l; i++) {
              // Remove element nodes and prevent memory leaks
              elem = this[i] || {};

              if (elem.nodeType === 1) {
                jQuery.cleanData(getAll(elem, false));
                elem.innerHTML = value;
              }
            }

            elem = 0; // If using innerHTML throws an exception, use the fallback method
          } catch (e) {}
        }

        if (elem) {
          this.empty().append(value);
        }
      }, null, value, arguments.length);
    },
    replaceWith: function replaceWith() {
      var arg = arguments[0]; // Make the changes, replacing each context element with the new content

      this.domManip(arguments, function (elem) {
        arg = this.parentNode;
        jQuery.cleanData(getAll(this));

        if (arg) {
          arg.replaceChild(elem, this);
        }
      }); // Force removal if there was no new content (e.g., from empty arguments)

      return arg && (arg.length || arg.nodeType) ? this : this.remove();
    },
    detach: function detach(selector) {
      return this.remove(selector, true);
    },
    domManip: function domManip(args, callback) {
      // Flatten any nested arrays
      args = concat.apply([], args);
      var first,
          node,
          hasScripts,
          scripts,
          doc,
          fragment,
          i = 0,
          l = this.length,
          set = this,
          iNoClone = l - 1,
          value = args[0],
          isFunction = jQuery.isFunction(value); // We can't cloneNode fragments that contain checked, in WebKit

      if (isFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
        return this.each(function (index) {
          var self = set.eq(index);

          if (isFunction) {
            args[0] = value.call(this, index, self.html());
          }

          self.domManip(args, callback);
        });
      }

      if (l) {
        fragment = jQuery.buildFragment(args, this[0].ownerDocument, false, this);
        first = fragment.firstChild;

        if (fragment.childNodes.length === 1) {
          fragment = first;
        }

        if (first) {
          scripts = jQuery.map(getAll(fragment, "script"), disableScript);
          hasScripts = scripts.length; // Use the original fragment for the last item instead of the first because it can end up
          // being emptied incorrectly in certain situations (#8070).

          for (; i < l; i++) {
            node = fragment;

            if (i !== iNoClone) {
              node = jQuery.clone(node, true, true); // Keep references to cloned scripts for later restoration

              if (hasScripts) {
                jQuery.merge(scripts, getAll(node, "script"));
              }
            }

            callback.call(this[i], node, i);
          }

          if (hasScripts) {
            doc = scripts[scripts.length - 1].ownerDocument; // Reenable scripts

            jQuery.map(scripts, restoreScript); // Evaluate executable scripts on first document insertion

            for (i = 0; i < hasScripts; i++) {
              node = scripts[i];

              if (rscriptType.test(node.type || "") && !jQuery._data(node, "globalEval") && jQuery.contains(doc, node)) {
                if (node.src) {
                  // Optional AJAX dependency, but won't run scripts if not present
                  if (jQuery._evalUrl) {
                    jQuery._evalUrl(node.src);
                  }
                } else {
                  jQuery.globalEval((node.text || node.textContent || node.innerHTML || "").replace(rcleanScript, ""));
                }
              }
            }
          } // Fix #11809: Avoid leaking memory


          fragment = first = null;
        }
      }

      return this;
    }
  });
  jQuery.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function (name, original) {
    jQuery.fn[name] = function (selector) {
      var elems,
          i = 0,
          ret = [],
          insert = jQuery(selector),
          last = insert.length - 1;

      for (; i <= last; i++) {
        elems = i === last ? this : this.clone(true);
        jQuery(insert[i])[original](elems); // Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()

        push.apply(ret, elems.get());
      }

      return this.pushStack(ret);
    };
  });
  var iframe,
      elemdisplay = {};
  /**
   * Retrieve the actual display of a element
   * @param {String} name nodeName of the element
   * @param {Object} doc Document object
   */
  // Called only from within defaultDisplay

  function actualDisplay(name, doc) {
    var style,
        elem = jQuery(doc.createElement(name)).appendTo(doc.body),
        // getDefaultComputedStyle might be reliably used only on attached element
    display = window.getDefaultComputedStyle && (style = window.getDefaultComputedStyle(elem[0])) ? // Use of this method is a temporary fix (more like optmization) until something better comes along,
    // since it was removed from specification and supported only in FF
    style.display : jQuery.css(elem[0], "display"); // We don't have any data stored on the element,
    // so use "detach" method as fast way to get rid of the element

    elem.detach();
    return display;
  }
  /**
   * Try to determine the default display value of an element
   * @param {String} nodeName
   */


  function defaultDisplay(nodeName) {
    var doc = document,
        display = elemdisplay[nodeName];

    if (!display) {
      display = actualDisplay(nodeName, doc); // If the simple way fails, read from inside an iframe

      if (display === "none" || !display) {
        // Use the already-created iframe if possible
        iframe = (iframe || jQuery("<iframe frameborder='0' width='0' height='0'/>")).appendTo(doc.documentElement); // Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse

        doc = (iframe[0].contentWindow || iframe[0].contentDocument).document; // Support: IE

        doc.write();
        doc.close();
        display = actualDisplay(nodeName, doc);
        iframe.detach();
      } // Store the correct default display


      elemdisplay[nodeName] = display;
    }

    return display;
  }

  (function () {
    var shrinkWrapBlocksVal;

    support.shrinkWrapBlocks = function () {
      if (shrinkWrapBlocksVal != null) {
        return shrinkWrapBlocksVal;
      } // Will be changed later if needed.


      shrinkWrapBlocksVal = false; // Minified: var b,c,d

      var div, body, container;
      body = document.getElementsByTagName("body")[0];

      if (!body || !body.style) {
        // Test fired too early or in an unsupported environment, exit.
        return;
      } // Setup


      div = document.createElement("div");
      container = document.createElement("div");
      container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
      body.appendChild(container).appendChild(div); // Support: IE6
      // Check if elements with layout shrink-wrap their children

      if (_typeof2(div.style.zoom) !== strundefined) {
        // Reset CSS: box-sizing; display; margin; border
        div.style.cssText = // Support: Firefox<29, Android 2.3
        // Vendor-prefix box-sizing
        "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" + "box-sizing:content-box;display:block;margin:0;border:0;" + "padding:1px;width:1px;zoom:1";
        div.appendChild(document.createElement("div")).style.width = "5px";
        shrinkWrapBlocksVal = div.offsetWidth !== 3;
      }

      body.removeChild(container);
      return shrinkWrapBlocksVal;
    };
  })();

  var rmargin = /^margin/;
  var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
  var getStyles,
      curCSS,
      rposition = /^(top|right|bottom|left)$/;

  if (window.getComputedStyle) {
    getStyles = function getStyles(elem) {
      // Support: IE<=11+, Firefox<=30+ (#15098, #14150)
      // IE throws on elements created in popups
      // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
      if (elem.ownerDocument.defaultView.opener) {
        return elem.ownerDocument.defaultView.getComputedStyle(elem, null);
      }

      return window.getComputedStyle(elem, null);
    };

    curCSS = function curCSS(elem, name, computed) {
      var width,
          minWidth,
          maxWidth,
          ret,
          style = elem.style;
      computed = computed || getStyles(elem); // getPropertyValue is only needed for .css('filter') in IE9, see #12537

      ret = computed ? computed.getPropertyValue(name) || computed[name] : undefined;

      if (computed) {
        if (ret === "" && !jQuery.contains(elem.ownerDocument, elem)) {
          ret = jQuery.style(elem, name);
        } // A tribute to the "awesome hack by Dean Edwards"
        // Chrome < 17 and Safari 5.0 uses "computed value" instead of "used value" for margin-right
        // Safari 5.1.7 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
        // this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values


        if (rnumnonpx.test(ret) && rmargin.test(name)) {
          // Remember the original values
          width = style.width;
          minWidth = style.minWidth;
          maxWidth = style.maxWidth; // Put in the new values to get a computed value out

          style.minWidth = style.maxWidth = style.width = ret;
          ret = computed.width; // Revert the changed values

          style.width = width;
          style.minWidth = minWidth;
          style.maxWidth = maxWidth;
        }
      } // Support: IE
      // IE returns zIndex value as an integer.


      return ret === undefined ? ret : ret + "";
    };
  } else if (document.documentElement.currentStyle) {
    getStyles = function getStyles(elem) {
      return elem.currentStyle;
    };

    curCSS = function curCSS(elem, name, computed) {
      var left,
          rs,
          rsLeft,
          ret,
          style = elem.style;
      computed = computed || getStyles(elem);
      ret = computed ? computed[name] : undefined; // Avoid setting ret to empty string here
      // so we don't default to auto

      if (ret == null && style && style[name]) {
        ret = style[name];
      } // From the awesome hack by Dean Edwards
      // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
      // If we're not dealing with a regular pixel number
      // but a number that has a weird ending, we need to convert it to pixels
      // but not position css attributes, as those are proportional to the parent element instead
      // and we can't measure the parent instead because it might trigger a "stacking dolls" problem


      if (rnumnonpx.test(ret) && !rposition.test(name)) {
        // Remember the original values
        left = style.left;
        rs = elem.runtimeStyle;
        rsLeft = rs && rs.left; // Put in the new values to get a computed value out

        if (rsLeft) {
          rs.left = elem.currentStyle.left;
        }

        style.left = name === "fontSize" ? "1em" : ret;
        ret = style.pixelLeft + "px"; // Revert the changed values

        style.left = left;

        if (rsLeft) {
          rs.left = rsLeft;
        }
      } // Support: IE
      // IE returns zIndex value as an integer.


      return ret === undefined ? ret : ret + "" || "auto";
    };
  }

  function addGetHookIf(conditionFn, hookFn) {
    // Define the hook, we'll check on the first run if it's really needed.
    return {
      get: function get() {
        var condition = conditionFn();

        if (condition == null) {
          // The test was not ready at this point; screw the hook this time
          // but check again when needed next time.
          return;
        }

        if (condition) {
          // Hook not needed (or it's not possible to use it due to missing dependency),
          // remove it.
          // Since there are no other hooks for marginRight, remove the whole object.
          delete this.get;
          return;
        } // Hook needed; redefine it so that the support test is not executed again.


        return (this.get = hookFn).apply(this, arguments);
      }
    };
  }

  (function () {
    // Minified: var b,c,d,e,f,g, h,i
    var div, style, a, pixelPositionVal, boxSizingReliableVal, reliableHiddenOffsetsVal, reliableMarginRightVal; // Setup

    div = document.createElement("div");
    div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
    a = div.getElementsByTagName("a")[0];
    style = a && a.style; // Finish early in limited (non-browser) environments

    if (!style) {
      return;
    }

    style.cssText = "float:left;opacity:.5"; // Support: IE<9
    // Make sure that element opacity exists (as opposed to filter)

    support.opacity = style.opacity === "0.5"; // Verify style float existence
    // (IE uses styleFloat instead of cssFloat)

    support.cssFloat = !!style.cssFloat;
    div.style.backgroundClip = "content-box";
    div.cloneNode(true).style.backgroundClip = "";
    support.clearCloneStyle = div.style.backgroundClip === "content-box"; // Support: Firefox<29, Android 2.3
    // Vendor-prefix box-sizing

    support.boxSizing = style.boxSizing === "" || style.MozBoxSizing === "" || style.WebkitBoxSizing === "";
    jQuery.extend(support, {
      reliableHiddenOffsets: function reliableHiddenOffsets() {
        if (reliableHiddenOffsetsVal == null) {
          computeStyleTests();
        }

        return reliableHiddenOffsetsVal;
      },
      boxSizingReliable: function boxSizingReliable() {
        if (boxSizingReliableVal == null) {
          computeStyleTests();
        }

        return boxSizingReliableVal;
      },
      pixelPosition: function pixelPosition() {
        if (pixelPositionVal == null) {
          computeStyleTests();
        }

        return pixelPositionVal;
      },
      // Support: Android 2.3
      reliableMarginRight: function reliableMarginRight() {
        if (reliableMarginRightVal == null) {
          computeStyleTests();
        }

        return reliableMarginRightVal;
      }
    });

    function computeStyleTests() {
      // Minified: var b,c,d,j
      var div, body, container, contents;
      body = document.getElementsByTagName("body")[0];

      if (!body || !body.style) {
        // Test fired too early or in an unsupported environment, exit.
        return;
      } // Setup


      div = document.createElement("div");
      container = document.createElement("div");
      container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
      body.appendChild(container).appendChild(div);
      div.style.cssText = // Support: Firefox<29, Android 2.3
      // Vendor-prefix box-sizing
      "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" + "box-sizing:border-box;display:block;margin-top:1%;top:1%;" + "border:1px;padding:1px;width:4px;position:absolute"; // Support: IE<9
      // Assume reasonable values in the absence of getComputedStyle

      pixelPositionVal = boxSizingReliableVal = false;
      reliableMarginRightVal = true; // Check for getComputedStyle so that this code is not run in IE<9.

      if (window.getComputedStyle) {
        pixelPositionVal = (window.getComputedStyle(div, null) || {}).top !== "1%";
        boxSizingReliableVal = (window.getComputedStyle(div, null) || {
          width: "4px"
        }).width === "4px"; // Support: Android 2.3
        // Div with explicit width and no margin-right incorrectly
        // gets computed margin-right based on width of container (#3333)
        // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right

        contents = div.appendChild(document.createElement("div")); // Reset CSS: box-sizing; display; margin; border; padding

        contents.style.cssText = div.style.cssText = // Support: Firefox<29, Android 2.3
        // Vendor-prefix box-sizing
        "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" + "box-sizing:content-box;display:block;margin:0;border:0;padding:0";
        contents.style.marginRight = contents.style.width = "0";
        div.style.width = "1px";
        reliableMarginRightVal = !parseFloat((window.getComputedStyle(contents, null) || {}).marginRight);
        div.removeChild(contents);
      } // Support: IE8
      // Check if table cells still have offsetWidth/Height when they are set
      // to display:none and there are still other visible table cells in a
      // table row; if so, offsetWidth/Height are not reliable for use when
      // determining if an element has been hidden directly using
      // display:none (it is still safe to use offsets if a parent element is
      // hidden; don safety goggles and see bug #4512 for more information).


      div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
      contents = div.getElementsByTagName("td");
      contents[0].style.cssText = "margin:0;border:0;padding:0;display:none";
      reliableHiddenOffsetsVal = contents[0].offsetHeight === 0;

      if (reliableHiddenOffsetsVal) {
        contents[0].style.display = "";
        contents[1].style.display = "none";
        reliableHiddenOffsetsVal = contents[0].offsetHeight === 0;
      }

      body.removeChild(container);
    }
  })(); // A method for quickly swapping in/out CSS properties to get correct calculations.


  jQuery.swap = function (elem, options, callback, args) {
    var ret,
        name,
        old = {}; // Remember the old values, and insert the new ones

    for (name in options) {
      old[name] = elem.style[name];
      elem.style[name] = options[name];
    }

    ret = callback.apply(elem, args || []); // Revert the old values

    for (name in options) {
      elem.style[name] = old[name];
    }

    return ret;
  };

  var ralpha = /alpha\([^)]*\)/i,
      ropacity = /opacity\s*=\s*([^)]*)/,
      // swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
  // see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
  rdisplayswap = /^(none|table(?!-c[ea]).+)/,
      rnumsplit = new RegExp("^(" + pnum + ")(.*)$", "i"),
      rrelNum = new RegExp("^([+-])=(" + pnum + ")", "i"),
      cssShow = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
  },
      cssNormalTransform = {
    letterSpacing: "0",
    fontWeight: "400"
  },
      cssPrefixes = ["Webkit", "O", "Moz", "ms"]; // return a css property mapped to a potentially vendor prefixed property

  function vendorPropName(style, name) {
    // shortcut for names that are not vendor prefixed
    if (name in style) {
      return name;
    } // check for vendor prefixed names


    var capName = name.charAt(0).toUpperCase() + name.slice(1),
        origName = name,
        i = cssPrefixes.length;

    while (i--) {
      name = cssPrefixes[i] + capName;

      if (name in style) {
        return name;
      }
    }

    return origName;
  }

  function showHide(elements, show) {
    var display,
        elem,
        hidden,
        values = [],
        index = 0,
        length = elements.length;

    for (; index < length; index++) {
      elem = elements[index];

      if (!elem.style) {
        continue;
      }

      values[index] = jQuery._data(elem, "olddisplay");
      display = elem.style.display;

      if (show) {
        // Reset the inline display of this element to learn if it is
        // being hidden by cascaded rules or not
        if (!values[index] && display === "none") {
          elem.style.display = "";
        } // Set elements which have been overridden with display: none
        // in a stylesheet to whatever the default browser style is
        // for such an element


        if (elem.style.display === "" && isHidden(elem)) {
          values[index] = jQuery._data(elem, "olddisplay", defaultDisplay(elem.nodeName));
        }
      } else {
        hidden = isHidden(elem);

        if (display && display !== "none" || !hidden) {
          jQuery._data(elem, "olddisplay", hidden ? display : jQuery.css(elem, "display"));
        }
      }
    } // Set the display of most of the elements in a second loop
    // to avoid the constant reflow


    for (index = 0; index < length; index++) {
      elem = elements[index];

      if (!elem.style) {
        continue;
      }

      if (!show || elem.style.display === "none" || elem.style.display === "") {
        elem.style.display = show ? values[index] || "" : "none";
      }
    }

    return elements;
  }

  function setPositiveNumber(elem, value, subtract) {
    var matches = rnumsplit.exec(value);
    return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
    Math.max(0, matches[1] - (subtract || 0)) + (matches[2] || "px") : value;
  }

  function augmentWidthOrHeight(elem, name, extra, isBorderBox, styles) {
    var i = extra === (isBorderBox ? "border" : "content") ? // If we already have the right measurement, avoid augmentation
    4 : // Otherwise initialize for horizontal or vertical properties
    name === "width" ? 1 : 0,
        val = 0;

    for (; i < 4; i += 2) {
      // both box models exclude margin, so add it if we want it
      if (extra === "margin") {
        val += jQuery.css(elem, extra + cssExpand[i], true, styles);
      }

      if (isBorderBox) {
        // border-box includes padding, so remove it if we want content
        if (extra === "content") {
          val -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
        } // at this point, extra isn't border nor margin, so remove border


        if (extra !== "margin") {
          val -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }
      } else {
        // at this point, extra isn't content, so add padding
        val += jQuery.css(elem, "padding" + cssExpand[i], true, styles); // at this point, extra isn't content nor padding, so add border

        if (extra !== "padding") {
          val += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }
      }
    }

    return val;
  }

  function getWidthOrHeight(elem, name, extra) {
    // Start with offset property, which is equivalent to the border-box value
    var valueIsBorderBox = true,
        val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
        styles = getStyles(elem),
        isBorderBox = support.boxSizing && jQuery.css(elem, "boxSizing", false, styles) === "border-box"; // some non-html elements return undefined for offsetWidth, so check for null/undefined
    // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
    // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668

    if (val <= 0 || val == null) {
      // Fall back to computed then uncomputed css if necessary
      val = curCSS(elem, name, styles);

      if (val < 0 || val == null) {
        val = elem.style[name];
      } // Computed unit is not pixels. Stop here and return.


      if (rnumnonpx.test(val)) {
        return val;
      } // we need the check for style in case a browser which returns unreliable values
      // for getComputedStyle silently falls back to the reliable elem.style


      valueIsBorderBox = isBorderBox && (support.boxSizingReliable() || val === elem.style[name]); // Normalize "", auto, and prepare for extra

      val = parseFloat(val) || 0;
    } // use the active box-sizing model to add/subtract irrelevant styles


    return val + augmentWidthOrHeight(elem, name, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles) + "px";
  }

  jQuery.extend({
    // Add in style property hooks for overriding the default
    // behavior of getting and setting a style property
    cssHooks: {
      opacity: {
        get: function get(elem, computed) {
          if (computed) {
            // We should always get a number back from opacity
            var ret = curCSS(elem, "opacity");
            return ret === "" ? "1" : ret;
          }
        }
      }
    },
    // Don't automatically add "px" to these possibly-unitless properties
    cssNumber: {
      "columnCount": true,
      "fillOpacity": true,
      "flexGrow": true,
      "flexShrink": true,
      "fontWeight": true,
      "lineHeight": true,
      "opacity": true,
      "order": true,
      "orphans": true,
      "widows": true,
      "zIndex": true,
      "zoom": true
    },
    // Add in properties whose names you wish to fix before
    // setting or getting the value
    cssProps: {
      // normalize float css property
      "float": support.cssFloat ? "cssFloat" : "styleFloat"
    },
    // Get and set the style property on a DOM Node
    style: function style(elem, name, value, extra) {
      // Don't set styles on text and comment nodes
      if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
        return;
      } // Make sure that we're working with the right name


      var ret,
          type,
          hooks,
          origName = jQuery.camelCase(name),
          style = elem.style;
      name = jQuery.cssProps[origName] || (jQuery.cssProps[origName] = vendorPropName(style, origName)); // gets hook for the prefixed version
      // followed by the unprefixed version

      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName]; // Check if we're setting a value

      if (value !== undefined) {
        type = _typeof2(value); // convert relative number strings (+= or -=) to relative numbers. #7345

        if (type === "string" && (ret = rrelNum.exec(value))) {
          value = (ret[1] + 1) * ret[2] + parseFloat(jQuery.css(elem, name)); // Fixes bug #9237

          type = "number";
        } // Make sure that null and NaN values aren't set. See: #7116


        if (value == null || value !== value) {
          return;
        } // If a number was passed in, add 'px' to the (except for certain CSS properties)


        if (type === "number" && !jQuery.cssNumber[origName]) {
          value += "px";
        } // Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
        // but it would mean to define eight (for every problematic property) identical functions


        if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
          style[name] = "inherit";
        } // If a hook was provided, use that value, otherwise just set the specified value


        if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
          // Support: IE
          // Swallow errors from 'invalid' CSS values (#5509)
          try {
            style[name] = value;
          } catch (e) {}
        }
      } else {
        // If a hook was provided get the non-computed value from there
        if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
          return ret;
        } // Otherwise just get the value from the style object


        return style[name];
      }
    },
    css: function css(elem, name, extra, styles) {
      var num,
          val,
          hooks,
          origName = jQuery.camelCase(name); // Make sure that we're working with the right name

      name = jQuery.cssProps[origName] || (jQuery.cssProps[origName] = vendorPropName(elem.style, origName)); // gets hook for the prefixed version
      // followed by the unprefixed version

      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName]; // If a hook was provided get the computed value from there

      if (hooks && "get" in hooks) {
        val = hooks.get(elem, true, extra);
      } // Otherwise, if a way to get the computed value exists, use that


      if (val === undefined) {
        val = curCSS(elem, name, styles);
      } //convert "normal" to computed value


      if (val === "normal" && name in cssNormalTransform) {
        val = cssNormalTransform[name];
      } // Return, converting to number if forced or a qualifier was provided and val looks numeric


      if (extra === "" || extra) {
        num = parseFloat(val);
        return extra === true || jQuery.isNumeric(num) ? num || 0 : val;
      }

      return val;
    }
  });
  jQuery.each(["height", "width"], function (i, name) {
    jQuery.cssHooks[name] = {
      get: function get(elem, computed, extra) {
        if (computed) {
          // certain elements can have dimension info if we invisibly show them
          // however, it must have a current display style that would benefit from this
          return rdisplayswap.test(jQuery.css(elem, "display")) && elem.offsetWidth === 0 ? jQuery.swap(elem, cssShow, function () {
            return getWidthOrHeight(elem, name, extra);
          }) : getWidthOrHeight(elem, name, extra);
        }
      },
      set: function set(elem, value, extra) {
        var styles = extra && getStyles(elem);
        return setPositiveNumber(elem, value, extra ? augmentWidthOrHeight(elem, name, extra, support.boxSizing && jQuery.css(elem, "boxSizing", false, styles) === "border-box", styles) : 0);
      }
    };
  });

  if (!support.opacity) {
    jQuery.cssHooks.opacity = {
      get: function get(elem, computed) {
        // IE uses filters for opacity
        return ropacity.test((computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "") ? 0.01 * parseFloat(RegExp.$1) + "" : computed ? "1" : "";
      },
      set: function set(elem, value) {
        var style = elem.style,
            currentStyle = elem.currentStyle,
            opacity = jQuery.isNumeric(value) ? "alpha(opacity=" + value * 100 + ")" : "",
            filter = currentStyle && currentStyle.filter || style.filter || ""; // IE has trouble with opacity if it does not have layout
        // Force it by setting the zoom level

        style.zoom = 1; // if setting opacity to 1, and no other filters exist - attempt to remove filter attribute #6652
        // if value === "", then remove inline opacity #12685

        if ((value >= 1 || value === "") && jQuery.trim(filter.replace(ralpha, "")) === "" && style.removeAttribute) {
          // Setting style.filter to null, "" & " " still leave "filter:" in the cssText
          // if "filter:" is present at all, clearType is disabled, we want to avoid this
          // style.removeAttribute is IE Only, but so apparently is this code path...
          style.removeAttribute("filter"); // if there is no filter style applied in a css rule or unset inline opacity, we are done

          if (value === "" || currentStyle && !currentStyle.filter) {
            return;
          }
        } // otherwise, set new filter values


        style.filter = ralpha.test(filter) ? filter.replace(ralpha, opacity) : filter + " " + opacity;
      }
    };
  }

  jQuery.cssHooks.marginRight = addGetHookIf(support.reliableMarginRight, function (elem, computed) {
    if (computed) {
      // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
      // Work around by temporarily setting element display to inline-block
      return jQuery.swap(elem, {
        "display": "inline-block"
      }, curCSS, [elem, "marginRight"]);
    }
  }); // These hooks are used by animate to expand properties

  jQuery.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function (prefix, suffix) {
    jQuery.cssHooks[prefix + suffix] = {
      expand: function expand(value) {
        var i = 0,
            expanded = {},
            // assumes a single number if not a string
        parts = typeof value === "string" ? value.split(" ") : [value];

        for (; i < 4; i++) {
          expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
        }

        return expanded;
      }
    };

    if (!rmargin.test(prefix)) {
      jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    }
  });
  jQuery.fn.extend({
    css: function css(name, value) {
      return access(this, function (elem, name, value) {
        var styles,
            len,
            map = {},
            i = 0;

        if (jQuery.isArray(name)) {
          styles = getStyles(elem);
          len = name.length;

          for (; i < len; i++) {
            map[name[i]] = jQuery.css(elem, name[i], false, styles);
          }

          return map;
        }

        return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
      }, name, value, arguments.length > 1);
    },
    show: function show() {
      return showHide(this, true);
    },
    hide: function hide() {
      return showHide(this);
    },
    toggle: function toggle(state) {
      if (typeof state === "boolean") {
        return state ? this.show() : this.hide();
      }

      return this.each(function () {
        if (isHidden(this)) {
          jQuery(this).show();
        } else {
          jQuery(this).hide();
        }
      });
    }
  });

  function Tween(elem, options, prop, end, easing) {
    return new Tween.prototype.init(elem, options, prop, end, easing);
  }

  jQuery.Tween = Tween;
  Tween.prototype = {
    constructor: Tween,
    init: function init(elem, options, prop, end, easing, unit) {
      this.elem = elem;
      this.prop = prop;
      this.easing = easing || "swing";
      this.options = options;
      this.start = this.now = this.cur();
      this.end = end;
      this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
    },
    cur: function cur() {
      var hooks = Tween.propHooks[this.prop];
      return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
    },
    run: function run(percent) {
      var eased,
          hooks = Tween.propHooks[this.prop];

      if (this.options.duration) {
        this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
      } else {
        this.pos = eased = percent;
      }

      this.now = (this.end - this.start) * eased + this.start;

      if (this.options.step) {
        this.options.step.call(this.elem, this.now, this);
      }

      if (hooks && hooks.set) {
        hooks.set(this);
      } else {
        Tween.propHooks._default.set(this);
      }

      return this;
    }
  };
  Tween.prototype.init.prototype = Tween.prototype;
  Tween.propHooks = {
    _default: {
      get: function get(tween) {
        var result;

        if (tween.elem[tween.prop] != null && (!tween.elem.style || tween.elem.style[tween.prop] == null)) {
          return tween.elem[tween.prop];
        } // passing an empty string as a 3rd parameter to .css will automatically
        // attempt a parseFloat and fallback to a string if the parse fails
        // so, simple values such as "10px" are parsed to Float.
        // complex values such as "rotate(1rad)" are returned as is.


        result = jQuery.css(tween.elem, tween.prop, ""); // Empty strings, null, undefined and "auto" are converted to 0.

        return !result || result === "auto" ? 0 : result;
      },
      set: function set(tween) {
        // use step hook for back compat - use cssHook if its there - use .style if its
        // available and use plain properties where available
        if (jQuery.fx.step[tween.prop]) {
          jQuery.fx.step[tween.prop](tween);
        } else if (tween.elem.style && (tween.elem.style[jQuery.cssProps[tween.prop]] != null || jQuery.cssHooks[tween.prop])) {
          jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
        } else {
          tween.elem[tween.prop] = tween.now;
        }
      }
    }
  }; // Support: IE <=9
  // Panic based approach to setting things on disconnected nodes

  Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
    set: function set(tween) {
      if (tween.elem.nodeType && tween.elem.parentNode) {
        tween.elem[tween.prop] = tween.now;
      }
    }
  };
  jQuery.easing = {
    linear: function linear(p) {
      return p;
    },
    swing: function swing(p) {
      return 0.5 - Math.cos(p * Math.PI) / 2;
    }
  };
  jQuery.fx = Tween.prototype.init; // Back Compat <1.8 extension point

  jQuery.fx.step = {};
  var fxNow,
      timerId,
      rfxtypes = /^(?:toggle|show|hide)$/,
      rfxnum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i"),
      rrun = /queueHooks$/,
      animationPrefilters = [defaultPrefilter],
      tweeners = {
    "*": [function (prop, value) {
      var tween = this.createTween(prop, value),
          target = tween.cur(),
          parts = rfxnum.exec(value),
          unit = parts && parts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
          // Starting value computation is required for potential unit mismatches
      start = (jQuery.cssNumber[prop] || unit !== "px" && +target) && rfxnum.exec(jQuery.css(tween.elem, prop)),
          scale = 1,
          maxIterations = 20;

      if (start && start[3] !== unit) {
        // Trust units reported by jQuery.css
        unit = unit || start[3]; // Make sure we update the tween properties later on

        parts = parts || []; // Iteratively approximate from a nonzero starting point

        start = +target || 1;

        do {
          // If previous iteration zeroed out, double until we get *something*
          // Use a string for doubling factor so we don't accidentally see scale as unchanged below
          scale = scale || ".5"; // Adjust and apply

          start = start / scale;
          jQuery.style(tween.elem, prop, start + unit); // Update scale, tolerating zero or NaN from tween.cur()
          // And breaking the loop if scale is unchanged or perfect, or if we've just had enough
        } while (scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations);
      } // Update tween properties


      if (parts) {
        start = tween.start = +start || +target || 0;
        tween.unit = unit; // If a +=/-= token was provided, we're doing a relative animation

        tween.end = parts[1] ? start + (parts[1] + 1) * parts[2] : +parts[2];
      }

      return tween;
    }]
  }; // Animations created synchronously will run synchronously

  function createFxNow() {
    setTimeout(function () {
      fxNow = undefined;
    });
    return fxNow = jQuery.now();
  } // Generate parameters to create a standard animation


  function genFx(type, includeWidth) {
    var which,
        attrs = {
      height: type
    },
        i = 0; // if we include width, step value is 1 to do all cssExpand values,
    // if we don't include width, step value is 2 to skip over Left and Right

    includeWidth = includeWidth ? 1 : 0;

    for (; i < 4; i += 2 - includeWidth) {
      which = cssExpand[i];
      attrs["margin" + which] = attrs["padding" + which] = type;
    }

    if (includeWidth) {
      attrs.opacity = attrs.width = type;
    }

    return attrs;
  }

  function createTween(value, prop, animation) {
    var tween,
        collection = (tweeners[prop] || []).concat(tweeners["*"]),
        index = 0,
        length = collection.length;

    for (; index < length; index++) {
      if (tween = collection[index].call(animation, prop, value)) {
        // we're done with this property
        return tween;
      }
    }
  }

  function defaultPrefilter(elem, props, opts) {
    /* jshint validthis: true */
    var prop,
        value,
        toggle,
        tween,
        hooks,
        oldfire,
        display,
        checkDisplay,
        anim = this,
        orig = {},
        style = elem.style,
        hidden = elem.nodeType && isHidden(elem),
        dataShow = jQuery._data(elem, "fxshow"); // handle queue: false promises


    if (!opts.queue) {
      hooks = jQuery._queueHooks(elem, "fx");

      if (hooks.unqueued == null) {
        hooks.unqueued = 0;
        oldfire = hooks.empty.fire;

        hooks.empty.fire = function () {
          if (!hooks.unqueued) {
            oldfire();
          }
        };
      }

      hooks.unqueued++;
      anim.always(function () {
        // doing this makes sure that the complete handler will be called
        // before this completes
        anim.always(function () {
          hooks.unqueued--;

          if (!jQuery.queue(elem, "fx").length) {
            hooks.empty.fire();
          }
        });
      });
    } // height/width overflow pass


    if (elem.nodeType === 1 && ("height" in props || "width" in props)) {
      // Make sure that nothing sneaks out
      // Record all 3 overflow attributes because IE does not
      // change the overflow attribute when overflowX and
      // overflowY are set to the same value
      opts.overflow = [style.overflow, style.overflowX, style.overflowY]; // Set display property to inline-block for height/width
      // animations on inline elements that are having width/height animated

      display = jQuery.css(elem, "display"); // Test default display if display is currently "none"

      checkDisplay = display === "none" ? jQuery._data(elem, "olddisplay") || defaultDisplay(elem.nodeName) : display;

      if (checkDisplay === "inline" && jQuery.css(elem, "float") === "none") {
        // inline-level elements accept inline-block;
        // block-level elements need to be inline with layout
        if (!support.inlineBlockNeedsLayout || defaultDisplay(elem.nodeName) === "inline") {
          style.display = "inline-block";
        } else {
          style.zoom = 1;
        }
      }
    }

    if (opts.overflow) {
      style.overflow = "hidden";

      if (!support.shrinkWrapBlocks()) {
        anim.always(function () {
          style.overflow = opts.overflow[0];
          style.overflowX = opts.overflow[1];
          style.overflowY = opts.overflow[2];
        });
      }
    } // show/hide pass


    for (prop in props) {
      value = props[prop];

      if (rfxtypes.exec(value)) {
        delete props[prop];
        toggle = toggle || value === "toggle";

        if (value === (hidden ? "hide" : "show")) {
          // If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
          if (value === "show" && dataShow && dataShow[prop] !== undefined) {
            hidden = true;
          } else {
            continue;
          }
        }

        orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop); // Any non-fx value stops us from restoring the original display value
      } else {
        display = undefined;
      }
    }

    if (!jQuery.isEmptyObject(orig)) {
      if (dataShow) {
        if ("hidden" in dataShow) {
          hidden = dataShow.hidden;
        }
      } else {
        dataShow = jQuery._data(elem, "fxshow", {});
      } // store state if its toggle - enables .stop().toggle() to "reverse"


      if (toggle) {
        dataShow.hidden = !hidden;
      }

      if (hidden) {
        jQuery(elem).show();
      } else {
        anim.done(function () {
          jQuery(elem).hide();
        });
      }

      anim.done(function () {
        var prop;

        jQuery._removeData(elem, "fxshow");

        for (prop in orig) {
          jQuery.style(elem, prop, orig[prop]);
        }
      });

      for (prop in orig) {
        tween = createTween(hidden ? dataShow[prop] : 0, prop, anim);

        if (!(prop in dataShow)) {
          dataShow[prop] = tween.start;

          if (hidden) {
            tween.end = tween.start;
            tween.start = prop === "width" || prop === "height" ? 1 : 0;
          }
        }
      } // If this is a noop like .hide().hide(), restore an overwritten display value

    } else if ((display === "none" ? defaultDisplay(elem.nodeName) : display) === "inline") {
      style.display = display;
    }
  }

  function propFilter(props, specialEasing) {
    var index, name, easing, value, hooks; // camelCase, specialEasing and expand cssHook pass

    for (index in props) {
      name = jQuery.camelCase(index);
      easing = specialEasing[name];
      value = props[index];

      if (jQuery.isArray(value)) {
        easing = value[1];
        value = props[index] = value[0];
      }

      if (index !== name) {
        props[name] = value;
        delete props[index];
      }

      hooks = jQuery.cssHooks[name];

      if (hooks && "expand" in hooks) {
        value = hooks.expand(value);
        delete props[name]; // not quite $.extend, this wont overwrite keys already present.
        // also - reusing 'index' from above because we have the correct "name"

        for (index in value) {
          if (!(index in props)) {
            props[index] = value[index];
            specialEasing[index] = easing;
          }
        }
      } else {
        specialEasing[name] = easing;
      }
    }
  }

  function Animation(elem, properties, options) {
    var result,
        stopped,
        index = 0,
        length = animationPrefilters.length,
        deferred = jQuery.Deferred().always(function () {
      // don't match elem in the :animated selector
      delete tick.elem;
    }),
        tick = function tick() {
      if (stopped) {
        return false;
      }

      var currentTime = fxNow || createFxNow(),
          remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
          // archaic crash bug won't allow us to use 1 - ( 0.5 || 0 ) (#12497)
      temp = remaining / animation.duration || 0,
          percent = 1 - temp,
          index = 0,
          length = animation.tweens.length;

      for (; index < length; index++) {
        animation.tweens[index].run(percent);
      }

      deferred.notifyWith(elem, [animation, percent, remaining]);

      if (percent < 1 && length) {
        return remaining;
      } else {
        deferred.resolveWith(elem, [animation]);
        return false;
      }
    },
        animation = deferred.promise({
      elem: elem,
      props: jQuery.extend({}, properties),
      opts: jQuery.extend(true, {
        specialEasing: {}
      }, options),
      originalProperties: properties,
      originalOptions: options,
      startTime: fxNow || createFxNow(),
      duration: options.duration,
      tweens: [],
      createTween: function createTween(prop, end) {
        var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
        animation.tweens.push(tween);
        return tween;
      },
      stop: function stop(gotoEnd) {
        var index = 0,
            // if we are going to the end, we want to run all the tweens
        // otherwise we skip this part
        length = gotoEnd ? animation.tweens.length : 0;

        if (stopped) {
          return this;
        }

        stopped = true;

        for (; index < length; index++) {
          animation.tweens[index].run(1);
        } // resolve when we played the last frame
        // otherwise, reject


        if (gotoEnd) {
          deferred.resolveWith(elem, [animation, gotoEnd]);
        } else {
          deferred.rejectWith(elem, [animation, gotoEnd]);
        }

        return this;
      }
    }),
        props = animation.props;

    propFilter(props, animation.opts.specialEasing);

    for (; index < length; index++) {
      result = animationPrefilters[index].call(animation, elem, props, animation.opts);

      if (result) {
        return result;
      }
    }

    jQuery.map(props, createTween, animation);

    if (jQuery.isFunction(animation.opts.start)) {
      animation.opts.start.call(elem, animation);
    }

    jQuery.fx.timer(jQuery.extend(tick, {
      elem: elem,
      anim: animation,
      queue: animation.opts.queue
    })); // attach callbacks from options

    return animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
  }

  jQuery.Animation = jQuery.extend(Animation, {
    tweener: function tweener(props, callback) {
      if (jQuery.isFunction(props)) {
        callback = props;
        props = ["*"];
      } else {
        props = props.split(" ");
      }

      var prop,
          index = 0,
          length = props.length;

      for (; index < length; index++) {
        prop = props[index];
        tweeners[prop] = tweeners[prop] || [];
        tweeners[prop].unshift(callback);
      }
    },
    prefilter: function prefilter(callback, prepend) {
      if (prepend) {
        animationPrefilters.unshift(callback);
      } else {
        animationPrefilters.push(callback);
      }
    }
  });

  jQuery.speed = function (speed, easing, fn) {
    var opt = speed && _typeof2(speed) === "object" ? jQuery.extend({}, speed) : {
      complete: fn || !fn && easing || jQuery.isFunction(speed) && speed,
      duration: speed,
      easing: fn && easing || easing && !jQuery.isFunction(easing) && easing
    };
    opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration : opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[opt.duration] : jQuery.fx.speeds._default; // normalize opt.queue - true/undefined/null -> "fx"

    if (opt.queue == null || opt.queue === true) {
      opt.queue = "fx";
    } // Queueing


    opt.old = opt.complete;

    opt.complete = function () {
      if (jQuery.isFunction(opt.old)) {
        opt.old.call(this);
      }

      if (opt.queue) {
        jQuery.dequeue(this, opt.queue);
      }
    };

    return opt;
  };

  jQuery.fn.extend({
    fadeTo: function fadeTo(speed, to, easing, callback) {
      // show any hidden elements after setting opacity to 0
      return this.filter(isHidden).css("opacity", 0).show() // animate to the value specified
      .end().animate({
        opacity: to
      }, speed, easing, callback);
    },
    animate: function animate(prop, speed, easing, callback) {
      var empty = jQuery.isEmptyObject(prop),
          optall = jQuery.speed(speed, easing, callback),
          doAnimation = function doAnimation() {
        // Operate on a copy of prop so per-property easing won't be lost
        var anim = Animation(this, jQuery.extend({}, prop), optall); // Empty animations, or finishing resolves immediately

        if (empty || jQuery._data(this, "finish")) {
          anim.stop(true);
        }
      };

      doAnimation.finish = doAnimation;
      return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
    },
    stop: function stop(type, clearQueue, gotoEnd) {
      var stopQueue = function stopQueue(hooks) {
        var stop = hooks.stop;
        delete hooks.stop;
        stop(gotoEnd);
      };

      if (typeof type !== "string") {
        gotoEnd = clearQueue;
        clearQueue = type;
        type = undefined;
      }

      if (clearQueue && type !== false) {
        this.queue(type || "fx", []);
      }

      return this.each(function () {
        var dequeue = true,
            index = type != null && type + "queueHooks",
            timers = jQuery.timers,
            data = jQuery._data(this);

        if (index) {
          if (data[index] && data[index].stop) {
            stopQueue(data[index]);
          }
        } else {
          for (index in data) {
            if (data[index] && data[index].stop && rrun.test(index)) {
              stopQueue(data[index]);
            }
          }
        }

        for (index = timers.length; index--;) {
          if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
            timers[index].anim.stop(gotoEnd);
            dequeue = false;
            timers.splice(index, 1);
          }
        } // start the next in the queue if the last step wasn't forced
        // timers currently will call their complete callbacks, which will dequeue
        // but only if they were gotoEnd


        if (dequeue || !gotoEnd) {
          jQuery.dequeue(this, type);
        }
      });
    },
    finish: function finish(type) {
      if (type !== false) {
        type = type || "fx";
      }

      return this.each(function () {
        var index,
            data = jQuery._data(this),
            queue = data[type + "queue"],
            hooks = data[type + "queueHooks"],
            timers = jQuery.timers,
            length = queue ? queue.length : 0; // enable finishing flag on private data


        data.finish = true; // empty the queue first

        jQuery.queue(this, type, []);

        if (hooks && hooks.stop) {
          hooks.stop.call(this, true);
        } // look for any active animations, and finish them


        for (index = timers.length; index--;) {
          if (timers[index].elem === this && timers[index].queue === type) {
            timers[index].anim.stop(true);
            timers.splice(index, 1);
          }
        } // look for any animations in the old queue and finish them


        for (index = 0; index < length; index++) {
          if (queue[index] && queue[index].finish) {
            queue[index].finish.call(this);
          }
        } // turn off finishing flag


        delete data.finish;
      });
    }
  });
  jQuery.each(["toggle", "show", "hide"], function (i, name) {
    var cssFn = jQuery.fn[name];

    jQuery.fn[name] = function (speed, easing, callback) {
      return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
    };
  }); // Generate shortcuts for custom animations

  jQuery.each({
    slideDown: genFx("show"),
    slideUp: genFx("hide"),
    slideToggle: genFx("toggle"),
    fadeIn: {
      opacity: "show"
    },
    fadeOut: {
      opacity: "hide"
    },
    fadeToggle: {
      opacity: "toggle"
    }
  }, function (name, props) {
    jQuery.fn[name] = function (speed, easing, callback) {
      return this.animate(props, speed, easing, callback);
    };
  });
  jQuery.timers = [];

  jQuery.fx.tick = function () {
    var timer,
        timers = jQuery.timers,
        i = 0;
    fxNow = jQuery.now();

    for (; i < timers.length; i++) {
      timer = timers[i]; // Checks the timer has not already been removed

      if (!timer() && timers[i] === timer) {
        timers.splice(i--, 1);
      }
    }

    if (!timers.length) {
      jQuery.fx.stop();
    }

    fxNow = undefined;
  };

  jQuery.fx.timer = function (timer) {
    jQuery.timers.push(timer);

    if (timer()) {
      jQuery.fx.start();
    } else {
      jQuery.timers.pop();
    }
  };

  jQuery.fx.interval = 13;

  jQuery.fx.start = function () {
    if (!timerId) {
      timerId = setInterval(jQuery.fx.tick, jQuery.fx.interval);
    }
  };

  jQuery.fx.stop = function () {
    clearInterval(timerId);
    timerId = null;
  };

  jQuery.fx.speeds = {
    slow: 600,
    fast: 200,
    // Default speed
    _default: 400
  }; // Based off of the plugin by Clint Helfers, with permission.
  // http://blindsignals.com/index.php/2009/07/jquery-delay/

  jQuery.fn.delay = function (time, type) {
    time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
    type = type || "fx";
    return this.queue(type, function (next, hooks) {
      var timeout = setTimeout(next, time);

      hooks.stop = function () {
        clearTimeout(timeout);
      };
    });
  };

  (function () {
    // Minified: var a,b,c,d,e
    var input, div, select, a, opt; // Setup

    div = document.createElement("div");
    div.setAttribute("className", "t");
    div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
    a = div.getElementsByTagName("a")[0]; // First batch of tests.

    select = document.createElement("select");
    opt = select.appendChild(document.createElement("option"));
    input = div.getElementsByTagName("input")[0];
    a.style.cssText = "top:1px"; // Test setAttribute on camelCase class. If it works, we need attrFixes when doing get/setAttribute (ie6/7)

    support.getSetAttribute = div.className !== "t"; // Get the style information from getAttribute
    // (IE uses .cssText instead)

    support.style = /top/.test(a.getAttribute("style")); // Make sure that URLs aren't manipulated
    // (IE normalizes it by default)

    support.hrefNormalized = a.getAttribute("href") === "/a"; // Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)

    support.checkOn = !!input.value; // Make sure that a selected-by-default option has a working selected property.
    // (WebKit defaults to false instead of true, IE too, if it's in an optgroup)

    support.optSelected = opt.selected; // Tests for enctype support on a form (#6743)

    support.enctype = !!document.createElement("form").enctype; // Make sure that the options inside disabled selects aren't marked as disabled
    // (WebKit marks them as disabled)

    select.disabled = true;
    support.optDisabled = !opt.disabled; // Support: IE8 only
    // Check if we can trust getAttribute("value")

    input = document.createElement("input");
    input.setAttribute("value", "");
    support.input = input.getAttribute("value") === ""; // Check if an input maintains its value after becoming a radio

    input.value = "t";
    input.setAttribute("type", "radio");
    support.radioValue = input.value === "t";
  })();

  var rreturn = /\r/g;
  jQuery.fn.extend({
    val: function val(value) {
      var hooks,
          ret,
          isFunction,
          elem = this[0];

      if (!arguments.length) {
        if (elem) {
          hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];

          if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
            return ret;
          }

          ret = elem.value;
          return typeof ret === "string" ? // handle most common string cases
          ret.replace(rreturn, "") : // handle cases where value is null/undef or number
          ret == null ? "" : ret;
        }

        return;
      }

      isFunction = jQuery.isFunction(value);
      return this.each(function (i) {
        var val;

        if (this.nodeType !== 1) {
          return;
        }

        if (isFunction) {
          val = value.call(this, i, jQuery(this).val());
        } else {
          val = value;
        } // Treat null/undefined as ""; convert numbers to string


        if (val == null) {
          val = "";
        } else if (typeof val === "number") {
          val += "";
        } else if (jQuery.isArray(val)) {
          val = jQuery.map(val, function (value) {
            return value == null ? "" : value + "";
          });
        }

        hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()]; // If set returns undefined, fall back to normal setting

        if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
          this.value = val;
        }
      });
    }
  });
  jQuery.extend({
    valHooks: {
      option: {
        get: function get(elem) {
          var val = jQuery.find.attr(elem, "value");
          return val != null ? val : // Support: IE10-11+
          // option.text throws exceptions (#14686, #14858)
          jQuery.trim(jQuery.text(elem));
        }
      },
      select: {
        get: function get(elem) {
          var value,
              option,
              options = elem.options,
              index = elem.selectedIndex,
              one = elem.type === "select-one" || index < 0,
              values = one ? null : [],
              max = one ? index + 1 : options.length,
              i = index < 0 ? max : one ? index : 0; // Loop through all the selected options

          for (; i < max; i++) {
            option = options[i]; // oldIE doesn't update selected after form reset (#2551)

            if ((option.selected || i === index) && ( // Don't return options that are disabled or in a disabled optgroup
            support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null) && (!option.parentNode.disabled || !jQuery.nodeName(option.parentNode, "optgroup"))) {
              // Get the specific value for the option
              value = jQuery(option).val(); // We don't need an array for one selects

              if (one) {
                return value;
              } // Multi-Selects return an array


              values.push(value);
            }
          }

          return values;
        },
        set: function set(elem, value) {
          var optionSet,
              option,
              options = elem.options,
              values = jQuery.makeArray(value),
              i = options.length;

          while (i--) {
            option = options[i];

            if (jQuery.inArray(jQuery.valHooks.option.get(option), values) >= 0) {
              // Support: IE6
              // When new option element is added to select box we need to
              // force reflow of newly added node in order to workaround delay
              // of initialization properties
              try {
                option.selected = optionSet = true;
              } catch (_) {
                // Will be executed only in IE6
                option.scrollHeight;
              }
            } else {
              option.selected = false;
            }
          } // Force browsers to behave consistently when non-matching value is set


          if (!optionSet) {
            elem.selectedIndex = -1;
          }

          return options;
        }
      }
    }
  }); // Radios and checkboxes getter/setter

  jQuery.each(["radio", "checkbox"], function () {
    jQuery.valHooks[this] = {
      set: function set(elem, value) {
        if (jQuery.isArray(value)) {
          return elem.checked = jQuery.inArray(jQuery(elem).val(), value) >= 0;
        }
      }
    };

    if (!support.checkOn) {
      jQuery.valHooks[this].get = function (elem) {
        // Support: Webkit
        // "" is returned instead of "on" if a value isn't specified
        return elem.getAttribute("value") === null ? "on" : elem.value;
      };
    }
  });
  var nodeHook,
      boolHook,
      attrHandle = jQuery.expr.attrHandle,
      ruseDefault = /^(?:checked|selected)$/i,
      getSetAttribute = support.getSetAttribute,
      getSetInput = support.input;
  jQuery.fn.extend({
    attr: function attr(name, value) {
      return access(this, jQuery.attr, name, value, arguments.length > 1);
    },
    removeAttr: function removeAttr(name) {
      return this.each(function () {
        jQuery.removeAttr(this, name);
      });
    }
  });
  jQuery.extend({
    attr: function attr(elem, name, value) {
      var hooks,
          ret,
          nType = elem.nodeType; // don't get/set attributes on text, comment and attribute nodes

      if (!elem || nType === 3 || nType === 8 || nType === 2) {
        return;
      } // Fallback to prop when attributes are not supported


      if (_typeof2(elem.getAttribute) === strundefined) {
        return jQuery.prop(elem, name, value);
      } // All attributes are lowercase
      // Grab necessary hook if one is defined


      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        name = name.toLowerCase();
        hooks = jQuery.attrHooks[name] || (jQuery.expr.match.bool.test(name) ? boolHook : nodeHook);
      }

      if (value !== undefined) {
        if (value === null) {
          jQuery.removeAttr(elem, name);
        } else if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        } else {
          elem.setAttribute(name, value + "");
          return value;
        }
      } else if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      } else {
        ret = jQuery.find.attr(elem, name); // Non-existent attributes return null, we normalize to undefined

        return ret == null ? undefined : ret;
      }
    },
    removeAttr: function removeAttr(elem, value) {
      var name,
          propName,
          i = 0,
          attrNames = value && value.match(rnotwhite);

      if (attrNames && elem.nodeType === 1) {
        while (name = attrNames[i++]) {
          propName = jQuery.propFix[name] || name; // Boolean attributes get special treatment (#10870)

          if (jQuery.expr.match.bool.test(name)) {
            // Set corresponding property to false
            if (getSetInput && getSetAttribute || !ruseDefault.test(name)) {
              elem[propName] = false; // Support: IE<9
              // Also clear defaultChecked/defaultSelected (if appropriate)
            } else {
              elem[jQuery.camelCase("default-" + name)] = elem[propName] = false;
            } // See #9699 for explanation of this approach (setting first, then removal)

          } else {
            jQuery.attr(elem, name, "");
          }

          elem.removeAttribute(getSetAttribute ? name : propName);
        }
      }
    },
    attrHooks: {
      type: {
        set: function set(elem, value) {
          if (!support.radioValue && value === "radio" && jQuery.nodeName(elem, "input")) {
            // Setting the type on a radio button after the value resets the value in IE6-9
            // Reset value to default in case type is set after value during creation
            var val = elem.value;
            elem.setAttribute("type", value);

            if (val) {
              elem.value = val;
            }

            return value;
          }
        }
      }
    }
  }); // Hook for boolean attributes

  boolHook = {
    set: function set(elem, value, name) {
      if (value === false) {
        // Remove boolean attributes when set to false
        jQuery.removeAttr(elem, name);
      } else if (getSetInput && getSetAttribute || !ruseDefault.test(name)) {
        // IE<8 needs the *property* name
        elem.setAttribute(!getSetAttribute && jQuery.propFix[name] || name, name); // Use defaultChecked and defaultSelected for oldIE
      } else {
        elem[jQuery.camelCase("default-" + name)] = elem[name] = true;
      }

      return name;
    }
  }; // Retrieve booleans specially

  jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (i, name) {
    var getter = attrHandle[name] || jQuery.find.attr;
    attrHandle[name] = getSetInput && getSetAttribute || !ruseDefault.test(name) ? function (elem, name, isXML) {
      var ret, handle;

      if (!isXML) {
        // Avoid an infinite loop by temporarily removing this function from the getter
        handle = attrHandle[name];
        attrHandle[name] = ret;
        ret = getter(elem, name, isXML) != null ? name.toLowerCase() : null;
        attrHandle[name] = handle;
      }

      return ret;
    } : function (elem, name, isXML) {
      if (!isXML) {
        return elem[jQuery.camelCase("default-" + name)] ? name.toLowerCase() : null;
      }
    };
  }); // fix oldIE attroperties

  if (!getSetInput || !getSetAttribute) {
    jQuery.attrHooks.value = {
      set: function set(elem, value, name) {
        if (jQuery.nodeName(elem, "input")) {
          // Does not return so that setAttribute is also used
          elem.defaultValue = value;
        } else {
          // Use nodeHook if defined (#1954); otherwise setAttribute is fine
          return nodeHook && nodeHook.set(elem, value, name);
        }
      }
    };
  } // IE6/7 do not support getting/setting some attributes with get/setAttribute


  if (!getSetAttribute) {
    // Use this for any attribute in IE6/7
    // This fixes almost every IE6/7 issue
    nodeHook = {
      set: function set(elem, value, name) {
        // Set the existing or create a new attribute node
        var ret = elem.getAttributeNode(name);

        if (!ret) {
          elem.setAttributeNode(ret = elem.ownerDocument.createAttribute(name));
        }

        ret.value = value += ""; // Break association with cloned elements by also using setAttribute (#9646)

        if (name === "value" || value === elem.getAttribute(name)) {
          return value;
        }
      }
    }; // Some attributes are constructed with empty-string values when not defined

    attrHandle.id = attrHandle.name = attrHandle.coords = function (elem, name, isXML) {
      var ret;

      if (!isXML) {
        return (ret = elem.getAttributeNode(name)) && ret.value !== "" ? ret.value : null;
      }
    }; // Fixing value retrieval on a button requires this module


    jQuery.valHooks.button = {
      get: function get(elem, name) {
        var ret = elem.getAttributeNode(name);

        if (ret && ret.specified) {
          return ret.value;
        }
      },
      set: nodeHook.set
    }; // Set contenteditable to false on removals(#10429)
    // Setting to empty string throws an error as an invalid value

    jQuery.attrHooks.contenteditable = {
      set: function set(elem, value, name) {
        nodeHook.set(elem, value === "" ? false : value, name);
      }
    }; // Set width and height to auto instead of 0 on empty string( Bug #8150 )
    // This is for removals

    jQuery.each(["width", "height"], function (i, name) {
      jQuery.attrHooks[name] = {
        set: function set(elem, value) {
          if (value === "") {
            elem.setAttribute(name, "auto");
            return value;
          }
        }
      };
    });
  }

  if (!support.style) {
    jQuery.attrHooks.style = {
      get: function get(elem) {
        // Return undefined in the case of empty string
        // Note: IE uppercases css property names, but if we were to .toLowerCase()
        // .cssText, that would destroy case senstitivity in URL's, like in "background"
        return elem.style.cssText || undefined;
      },
      set: function set(elem, value) {
        return elem.style.cssText = value + "";
      }
    };
  }

  var rfocusable = /^(?:input|select|textarea|button|object)$/i,
      rclickable = /^(?:a|area)$/i;
  jQuery.fn.extend({
    prop: function prop(name, value) {
      return access(this, jQuery.prop, name, value, arguments.length > 1);
    },
    removeProp: function removeProp(name) {
      name = jQuery.propFix[name] || name;
      return this.each(function () {
        // try/catch handles cases where IE balks (such as removing a property on window)
        try {
          this[name] = undefined;
          delete this[name];
        } catch (e) {}
      });
    }
  });
  jQuery.extend({
    propFix: {
      "for": "htmlFor",
      "class": "className"
    },
    prop: function prop(elem, name, value) {
      var ret,
          hooks,
          notxml,
          nType = elem.nodeType; // don't get/set properties on text, comment and attribute nodes

      if (!elem || nType === 3 || nType === 8 || nType === 2) {
        return;
      }

      notxml = nType !== 1 || !jQuery.isXMLDoc(elem);

      if (notxml) {
        // Fix name and attach hooks
        name = jQuery.propFix[name] || name;
        hooks = jQuery.propHooks[name];
      }

      if (value !== undefined) {
        return hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined ? ret : elem[name] = value;
      } else {
        return hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null ? ret : elem[name];
      }
    },
    propHooks: {
      tabIndex: {
        get: function get(elem) {
          // elem.tabIndex doesn't always return the correct value when it hasn't been explicitly set
          // http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
          // Use proper attribute retrieval(#12072)
          var tabindex = jQuery.find.attr(elem, "tabindex");
          return tabindex ? parseInt(tabindex, 10) : rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href ? 0 : -1;
        }
      }
    }
  }); // Some attributes require a special call on IE
  // http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx

  if (!support.hrefNormalized) {
    // href/src property should get the full normalized URL (#10299/#12915)
    jQuery.each(["href", "src"], function (i, name) {
      jQuery.propHooks[name] = {
        get: function get(elem) {
          return elem.getAttribute(name, 4);
        }
      };
    });
  } // Support: Safari, IE9+
  // mis-reports the default selected property of an option
  // Accessing the parent's selectedIndex property fixes it


  if (!support.optSelected) {
    jQuery.propHooks.selected = {
      get: function get(elem) {
        var parent = elem.parentNode;

        if (parent) {
          parent.selectedIndex; // Make sure that it also works with optgroups, see #5701

          if (parent.parentNode) {
            parent.parentNode.selectedIndex;
          }
        }

        return null;
      }
    };
  }

  jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    jQuery.propFix[this.toLowerCase()] = this;
  }); // IE6/7 call enctype encoding

  if (!support.enctype) {
    jQuery.propFix.enctype = "encoding";
  }

  var rclass = /[\t\r\n\f]/g;
  jQuery.fn.extend({
    addClass: function addClass(value) {
      var classes,
          elem,
          cur,
          clazz,
          j,
          finalValue,
          i = 0,
          len = this.length,
          proceed = typeof value === "string" && value;

      if (jQuery.isFunction(value)) {
        return this.each(function (j) {
          jQuery(this).addClass(value.call(this, j, this.className));
        });
      }

      if (proceed) {
        // The disjunction here is for better compressibility (see removeClass)
        classes = (value || "").match(rnotwhite) || [];

        for (; i < len; i++) {
          elem = this[i];
          cur = elem.nodeType === 1 && (elem.className ? (" " + elem.className + " ").replace(rclass, " ") : " ");

          if (cur) {
            j = 0;

            while (clazz = classes[j++]) {
              if (cur.indexOf(" " + clazz + " ") < 0) {
                cur += clazz + " ";
              }
            } // only assign if different to avoid unneeded rendering.


            finalValue = jQuery.trim(cur);

            if (elem.className !== finalValue) {
              elem.className = finalValue;
            }
          }
        }
      }

      return this;
    },
    removeClass: function removeClass(value) {
      var classes,
          elem,
          cur,
          clazz,
          j,
          finalValue,
          i = 0,
          len = this.length,
          proceed = arguments.length === 0 || typeof value === "string" && value;

      if (jQuery.isFunction(value)) {
        return this.each(function (j) {
          jQuery(this).removeClass(value.call(this, j, this.className));
        });
      }

      if (proceed) {
        classes = (value || "").match(rnotwhite) || [];

        for (; i < len; i++) {
          elem = this[i]; // This expression is here for better compressibility (see addClass)

          cur = elem.nodeType === 1 && (elem.className ? (" " + elem.className + " ").replace(rclass, " ") : "");

          if (cur) {
            j = 0;

            while (clazz = classes[j++]) {
              // Remove *all* instances
              while (cur.indexOf(" " + clazz + " ") >= 0) {
                cur = cur.replace(" " + clazz + " ", " ");
              }
            } // only assign if different to avoid unneeded rendering.


            finalValue = value ? jQuery.trim(cur) : "";

            if (elem.className !== finalValue) {
              elem.className = finalValue;
            }
          }
        }
      }

      return this;
    },
    toggleClass: function toggleClass(value, stateVal) {
      var type = _typeof2(value);

      if (typeof stateVal === "boolean" && type === "string") {
        return stateVal ? this.addClass(value) : this.removeClass(value);
      }

      if (jQuery.isFunction(value)) {
        return this.each(function (i) {
          jQuery(this).toggleClass(value.call(this, i, this.className, stateVal), stateVal);
        });
      }

      return this.each(function () {
        if (type === "string") {
          // toggle individual class names
          var className,
              i = 0,
              self = jQuery(this),
              classNames = value.match(rnotwhite) || [];

          while (className = classNames[i++]) {
            // check each className given, space separated list
            if (self.hasClass(className)) {
              self.removeClass(className);
            } else {
              self.addClass(className);
            }
          } // Toggle whole class name

        } else if (type === strundefined || type === "boolean") {
          if (this.className) {
            // store className if set
            jQuery._data(this, "__className__", this.className);
          } // If the element has a class name or if we're passed "false",
          // then remove the whole classname (if there was one, the above saved it).
          // Otherwise bring back whatever was previously saved (if anything),
          // falling back to the empty string if nothing was stored.


          this.className = this.className || value === false ? "" : jQuery._data(this, "__className__") || "";
        }
      });
    },
    hasClass: function hasClass(selector) {
      var className = " " + selector + " ",
          i = 0,
          l = this.length;

      for (; i < l; i++) {
        if (this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf(className) >= 0) {
          return true;
        }
      }

      return false;
    }
  }); // Return jQuery for attributes-only inclusion

  jQuery.each(("blur focus focusin focusout load resize scroll unload click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup error contextmenu").split(" "), function (i, name) {
    // Handle event binding
    jQuery.fn[name] = function (data, fn) {
      return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
    };
  });
  jQuery.fn.extend({
    hover: function hover(fnOver, fnOut) {
      return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
    },
    bind: function bind(types, data, fn) {
      return this.on(types, null, data, fn);
    },
    unbind: function unbind(types, fn) {
      return this.off(types, null, fn);
    },
    delegate: function delegate(selector, types, data, fn) {
      return this.on(types, selector, data, fn);
    },
    undelegate: function undelegate(selector, types, fn) {
      // ( namespace ) or ( selector, types [, fn] )
      return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
    }
  });
  var nonce = jQuery.now();
  var rquery = /\?/;
  var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;

  jQuery.parseJSON = function (data) {
    // Attempt to parse using the native JSON parser first
    if (window.JSON && window.JSON.parse) {
      // Support: Android 2.3
      // Workaround failure to string-cast null input
      return window.JSON.parse(data + "");
    }

    var requireNonComma,
        depth = null,
        str = jQuery.trim(data + ""); // Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
    // after removing valid tokens

    return str && !jQuery.trim(str.replace(rvalidtokens, function (token, comma, open, close) {
      // Force termination if we see a misplaced comma
      if (requireNonComma && comma) {
        depth = 0;
      } // Perform no more replacements after returning to outermost depth


      if (depth === 0) {
        return token;
      } // Commas must not follow "[", "{", or ","


      requireNonComma = open || comma; // Determine new depth
      // array/object open ("[" or "{"): depth += true - false (increment)
      // array/object close ("]" or "}"): depth += false - true (decrement)
      // other cases ("," or primitive): depth += true - true (numeric cast)

      depth += !close - !open; // Remove this token

      return "";
    })) ? Function("return " + str)() : jQuery.error("Invalid JSON: " + data);
  }; // Cross-browser xml parsing


  jQuery.parseXML = function (data) {
    var xml, tmp;

    if (!data || typeof data !== "string") {
      return null;
    }

    try {
      if (window.DOMParser) {
        // Standard
        tmp = new DOMParser();
        xml = tmp.parseFromString(data, "text/xml");
      } else {
        // IE
        xml = new ActiveXObject("Microsoft.XMLDOM");
        xml.async = "false";
        xml.loadXML(data);
      }
    } catch (e) {
      xml = undefined;
    }

    if (!xml || !xml.documentElement || xml.getElementsByTagName("parsererror").length) {
      jQuery.error("Invalid XML: " + data);
    }

    return xml;
  };

  var // Document location
  ajaxLocParts,
      ajaxLocation,
      rhash = /#.*$/,
      rts = /([?&])_=[^&]*/,
      rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,
      // IE leaves an \r character at EOL
  // #7653, #8125, #8152: local protocol detection
  rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      rnoContent = /^(?:GET|HEAD)$/,
      rprotocol = /^\/\//,
      rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

  /* Prefilters
   * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
   * 2) These are called:
   *    - BEFORE asking for a transport
   *    - AFTER param serialization (s.data is a string if s.processData is true)
   * 3) key is the dataType
   * 4) the catchall symbol "*" can be used
   * 5) execution will start with transport dataType and THEN continue down to "*" if needed
   */
  prefilters = {},

  /* Transports bindings
   * 1) key is the dataType
   * 2) the catchall symbol "*" can be used
   * 3) selection will start with transport dataType and THEN go to "*" if needed
   */
  transports = {},
      // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
  allTypes = "*/".concat("*"); // #8138, IE may throw an exception when accessing
  // a field from window.location if document.domain has been set

  try {
    ajaxLocation = location.href;
  } catch (e) {
    // Use the href attribute of an A element
    // since IE will modify it given document.location
    ajaxLocation = document.createElement("a");
    ajaxLocation.href = "";
    ajaxLocation = ajaxLocation.href;
  } // Segment location into parts


  ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || []; // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport

  function addToPrefiltersOrTransports(structure) {
    // dataTypeExpression is optional and defaults to "*"
    return function (dataTypeExpression, func) {
      if (typeof dataTypeExpression !== "string") {
        func = dataTypeExpression;
        dataTypeExpression = "*";
      }

      var dataType,
          i = 0,
          dataTypes = dataTypeExpression.toLowerCase().match(rnotwhite) || [];

      if (jQuery.isFunction(func)) {
        // For each dataType in the dataTypeExpression
        while (dataType = dataTypes[i++]) {
          // Prepend if requested
          if (dataType.charAt(0) === "+") {
            dataType = dataType.slice(1) || "*";
            (structure[dataType] = structure[dataType] || []).unshift(func); // Otherwise append
          } else {
            (structure[dataType] = structure[dataType] || []).push(func);
          }
        }
      }
    };
  } // Base inspection function for prefilters and transports


  function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
    var inspected = {},
        seekingTransport = structure === transports;

    function inspect(dataType) {
      var selected;
      inspected[dataType] = true;
      jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
        var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);

        if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
          options.dataTypes.unshift(dataTypeOrTransport);
          inspect(dataTypeOrTransport);
          return false;
        } else if (seekingTransport) {
          return !(selected = dataTypeOrTransport);
        }
      });
      return selected;
    }

    return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
  } // A special extend for ajax options
  // that takes "flat" options (not to be deep extended)
  // Fixes #9887


  function ajaxExtend(target, src) {
    var deep,
        key,
        flatOptions = jQuery.ajaxSettings.flatOptions || {};

    for (key in src) {
      if (src[key] !== undefined) {
        (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
      }
    }

    if (deep) {
      jQuery.extend(true, target, deep);
    }

    return target;
  }
  /* Handles responses to an ajax request:
   * - finds the right dataType (mediates between content-type and expected dataType)
   * - returns the corresponding response
   */


  function ajaxHandleResponses(s, jqXHR, responses) {
    var firstDataType,
        ct,
        finalDataType,
        type,
        contents = s.contents,
        dataTypes = s.dataTypes; // Remove auto dataType and get content-type in the process

    while (dataTypes[0] === "*") {
      dataTypes.shift();

      if (ct === undefined) {
        ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
      }
    } // Check if we're dealing with a known content-type


    if (ct) {
      for (type in contents) {
        if (contents[type] && contents[type].test(ct)) {
          dataTypes.unshift(type);
          break;
        }
      }
    } // Check to see if we have a response for the expected dataType


    if (dataTypes[0] in responses) {
      finalDataType = dataTypes[0];
    } else {
      // Try convertible dataTypes
      for (type in responses) {
        if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
          finalDataType = type;
          break;
        }

        if (!firstDataType) {
          firstDataType = type;
        }
      } // Or just use first one


      finalDataType = finalDataType || firstDataType;
    } // If we found a dataType
    // We add the dataType to the list if needed
    // and return the corresponding response


    if (finalDataType) {
      if (finalDataType !== dataTypes[0]) {
        dataTypes.unshift(finalDataType);
      }

      return responses[finalDataType];
    }
  }
  /* Chain conversions given the request and the original response
   * Also sets the responseXXX fields on the jqXHR instance
   */


  function ajaxConvert(s, response, jqXHR, isSuccess) {
    var conv2,
        current,
        conv,
        tmp,
        prev,
        converters = {},
        // Work with a copy of dataTypes in case we need to modify it for conversion
    dataTypes = s.dataTypes.slice(); // Create converters map with lowercased keys

    if (dataTypes[1]) {
      for (conv in s.converters) {
        converters[conv.toLowerCase()] = s.converters[conv];
      }
    }

    current = dataTypes.shift(); // Convert to each sequential dataType

    while (current) {
      if (s.responseFields[current]) {
        jqXHR[s.responseFields[current]] = response;
      } // Apply the dataFilter if provided


      if (!prev && isSuccess && s.dataFilter) {
        response = s.dataFilter(response, s.dataType);
      }

      prev = current;
      current = dataTypes.shift();

      if (current) {
        // There's only work to do if current dataType is non-auto
        if (current === "*") {
          current = prev; // Convert response if prev dataType is non-auto and differs from current
        } else if (prev !== "*" && prev !== current) {
          // Seek a direct converter
          conv = converters[prev + " " + current] || converters["* " + current]; // If none found, seek a pair

          if (!conv) {
            for (conv2 in converters) {
              // If conv2 outputs current
              tmp = conv2.split(" ");

              if (tmp[1] === current) {
                // If prev can be converted to accepted input
                conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];

                if (conv) {
                  // Condense equivalence converters
                  if (conv === true) {
                    conv = converters[conv2]; // Otherwise, insert the intermediate dataType
                  } else if (converters[conv2] !== true) {
                    current = tmp[0];
                    dataTypes.unshift(tmp[1]);
                  }

                  break;
                }
              }
            }
          } // Apply converter (if not an equivalence)


          if (conv !== true) {
            // Unless errors are allowed to bubble, catch and return them
            if (conv && s["throws"]) {
              response = conv(response);
            } else {
              try {
                response = conv(response);
              } catch (e) {
                return {
                  state: "parsererror",
                  error: conv ? e : "No conversion from " + prev + " to " + current
                };
              }
            }
          }
        }
      }
    }

    return {
      state: "success",
      data: response
    };
  }

  jQuery.extend({
    // Counter for holding the number of active queries
    active: 0,
    // Last-Modified header cache for next request
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: ajaxLocation,
      type: "GET",
      isLocal: rlocalProtocol.test(ajaxLocParts[1]),
      global: true,
      processData: true,
      async: true,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",

      /*
      timeout: 0,
      data: null,
      dataType: null,
      username: null,
      password: null,
      cache: null,
      throws: false,
      traditional: false,
      headers: {},
      */
      accepts: {
        "*": allTypes,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /xml/,
        html: /html/,
        json: /json/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      // Data converters
      // Keys separate source (or catchall "*") and destination types with a single space
      converters: {
        // Convert anything to text
        "* text": String,
        // Text to html (true = no transformation)
        "text html": true,
        // Evaluate text as a json expression
        "text json": jQuery.parseJSON,
        // Parse text as xml
        "text xml": jQuery.parseXML
      },
      // For options that shouldn't be deep extended:
      // you can add your own custom options here if
      // and when you create one that shouldn't be
      // deep extended (see ajaxExtend)
      flatOptions: {
        url: true,
        context: true
      }
    },
    // Creates a full fledged settings object into target
    // with both ajaxSettings and settings fields.
    // If target is omitted, writes into ajaxSettings.
    ajaxSetup: function ajaxSetup(target, settings) {
      return settings ? // Building a settings object
      ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
      ajaxExtend(jQuery.ajaxSettings, target);
    },
    ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
    ajaxTransport: addToPrefiltersOrTransports(transports),
    // Main method
    ajax: function ajax(url, options) {
      // If url is an object, simulate pre-1.5 signature
      if (_typeof2(url) === "object") {
        options = url;
        url = undefined;
      } // Force options to be an object


      options = options || {};

      var // Cross-domain detection vars
      parts,
          // Loop variable
      i,
          // URL without anti-cache param
      cacheURL,
          // Response headers as string
      responseHeadersString,
          // timeout handle
      timeoutTimer,
          // To know if global events are to be dispatched
      fireGlobals,
          transport,
          // Response headers
      responseHeaders,
          // Create the final options object
      s = jQuery.ajaxSetup({}, options),
          // Callbacks context
      callbackContext = s.context || s,
          // Context for global events is callbackContext if it is a DOM node or jQuery collection
      globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
          // Deferreds
      deferred = jQuery.Deferred(),
          completeDeferred = jQuery.Callbacks("once memory"),
          // Status-dependent callbacks
      _statusCode = s.statusCode || {},
          // Headers (they are sent all at once)
      requestHeaders = {},
          requestHeadersNames = {},
          // The jqXHR state
      state = 0,
          // Default abort message
      strAbort = "canceled",
          // Fake xhr
      jqXHR = {
        readyState: 0,
        // Builds headers hashtable if needed
        getResponseHeader: function getResponseHeader(key) {
          var match;

          if (state === 2) {
            if (!responseHeaders) {
              responseHeaders = {};

              while (match = rheaders.exec(responseHeadersString)) {
                responseHeaders[match[1].toLowerCase()] = match[2];
              }
            }

            match = responseHeaders[key.toLowerCase()];
          }

          return match == null ? null : match;
        },
        // Raw string
        getAllResponseHeaders: function getAllResponseHeaders() {
          return state === 2 ? responseHeadersString : null;
        },
        // Caches the header
        setRequestHeader: function setRequestHeader(name, value) {
          var lname = name.toLowerCase();

          if (!state) {
            name = requestHeadersNames[lname] = requestHeadersNames[lname] || name;
            requestHeaders[name] = value;
          }

          return this;
        },
        // Overrides response content-type header
        overrideMimeType: function overrideMimeType(type) {
          if (!state) {
            s.mimeType = type;
          }

          return this;
        },
        // Status-dependent callbacks
        statusCode: function statusCode(map) {
          var code;

          if (map) {
            if (state < 2) {
              for (code in map) {
                // Lazy-add the new callback in a way that preserves old ones
                _statusCode[code] = [_statusCode[code], map[code]];
              }
            } else {
              // Execute the appropriate callbacks
              jqXHR.always(map[jqXHR.status]);
            }
          }

          return this;
        },
        // Cancel the request
        abort: function abort(statusText) {
          var finalText = statusText || strAbort;

          if (transport) {
            transport.abort(finalText);
          }

          done(0, finalText);
          return this;
        }
      }; // Attach deferreds


      deferred.promise(jqXHR).complete = completeDeferred.add;
      jqXHR.success = jqXHR.done;
      jqXHR.error = jqXHR.fail; // Remove hash character (#7531: and string promotion)
      // Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
      // Handle falsy url in the settings object (#10093: consistency with old signature)
      // We also use the url parameter if available

      s.url = ((url || s.url || ajaxLocation) + "").replace(rhash, "").replace(rprotocol, ajaxLocParts[1] + "//"); // Alias method option to type as per ticket #12004

      s.type = options.method || options.type || s.method || s.type; // Extract dataTypes list

      s.dataTypes = jQuery.trim(s.dataType || "*").toLowerCase().match(rnotwhite) || [""]; // A cross-domain request is in order when we have a protocol:host:port mismatch

      if (s.crossDomain == null) {
        parts = rurl.exec(s.url.toLowerCase());
        s.crossDomain = !!(parts && (parts[1] !== ajaxLocParts[1] || parts[2] !== ajaxLocParts[2] || (parts[3] || (parts[1] === "http:" ? "80" : "443")) !== (ajaxLocParts[3] || (ajaxLocParts[1] === "http:" ? "80" : "443"))));
      } // Convert data if not already a string


      if (s.data && s.processData && typeof s.data !== "string") {
        s.data = jQuery.param(s.data, s.traditional);
      } // Apply prefilters


      inspectPrefiltersOrTransports(prefilters, s, options, jqXHR); // If request was aborted inside a prefilter, stop there

      if (state === 2) {
        return jqXHR;
      } // We can fire global events as of now if asked to
      // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)


      fireGlobals = jQuery.event && s.global; // Watch for a new set of requests

      if (fireGlobals && jQuery.active++ === 0) {
        jQuery.event.trigger("ajaxStart");
      } // Uppercase the type


      s.type = s.type.toUpperCase(); // Determine if request has content

      s.hasContent = !rnoContent.test(s.type); // Save the URL in case we're toying with the If-Modified-Since
      // and/or If-None-Match header later on

      cacheURL = s.url; // More options handling for requests with no content

      if (!s.hasContent) {
        // If data is available, append data to url
        if (s.data) {
          cacheURL = s.url += (rquery.test(cacheURL) ? "&" : "?") + s.data; // #9682: remove data so that it's not used in an eventual retry

          delete s.data;
        } // Add anti-cache in url if needed


        if (s.cache === false) {
          s.url = rts.test(cacheURL) ? // If there is already a '_' parameter, set its value
          cacheURL.replace(rts, "$1_=" + nonce++) : // Otherwise add one to the end
          cacheURL + (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++;
        }
      } // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.


      if (s.ifModified) {
        if (jQuery.lastModified[cacheURL]) {
          jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
        }

        if (jQuery.etag[cacheURL]) {
          jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
        }
      } // Set the correct header, if data is being sent


      if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
        jqXHR.setRequestHeader("Content-Type", s.contentType);
      } // Set the Accepts header for the server, depending on the dataType


      jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]); // Check for headers option

      for (i in s.headers) {
        jqXHR.setRequestHeader(i, s.headers[i]);
      } // Allow custom headers/mimetypes and early abort


      if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || state === 2)) {
        // Abort if not done already and return
        return jqXHR.abort();
      } // aborting is no longer a cancellation


      strAbort = "abort"; // Install callbacks on deferreds

      for (i in {
        success: 1,
        error: 1,
        complete: 1
      }) {
        jqXHR[i](s[i]);
      } // Get transport


      transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR); // If no transport, we auto-abort

      if (!transport) {
        done(-1, "No Transport");
      } else {
        jqXHR.readyState = 1; // Send global event

        if (fireGlobals) {
          globalEventContext.trigger("ajaxSend", [jqXHR, s]);
        } // Timeout


        if (s.async && s.timeout > 0) {
          timeoutTimer = setTimeout(function () {
            jqXHR.abort("timeout");
          }, s.timeout);
        }

        try {
          state = 1;
          transport.send(requestHeaders, done);
        } catch (e) {
          // Propagate exception as error if not done
          if (state < 2) {
            done(-1, e); // Simply rethrow otherwise
          } else {
            throw e;
          }
        }
      } // Callback for when everything is done


      function done(status, nativeStatusText, responses, headers) {
        var isSuccess,
            success,
            error,
            response,
            modified,
            statusText = nativeStatusText; // Called once

        if (state === 2) {
          return;
        } // State is "done" now


        state = 2; // Clear timeout if it exists

        if (timeoutTimer) {
          clearTimeout(timeoutTimer);
        } // Dereference transport for early garbage collection
        // (no matter how long the jqXHR object will be used)


        transport = undefined; // Cache response headers

        responseHeadersString = headers || ""; // Set readyState

        jqXHR.readyState = status > 0 ? 4 : 0; // Determine if successful

        isSuccess = status >= 200 && status < 300 || status === 304; // Get response data

        if (responses) {
          response = ajaxHandleResponses(s, jqXHR, responses);
        } // Convert no matter what (that way responseXXX fields are always set)


        response = ajaxConvert(s, response, jqXHR, isSuccess); // If successful, handle type chaining

        if (isSuccess) {
          // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
          if (s.ifModified) {
            modified = jqXHR.getResponseHeader("Last-Modified");

            if (modified) {
              jQuery.lastModified[cacheURL] = modified;
            }

            modified = jqXHR.getResponseHeader("etag");

            if (modified) {
              jQuery.etag[cacheURL] = modified;
            }
          } // if no content


          if (status === 204 || s.type === "HEAD") {
            statusText = "nocontent"; // if not modified
          } else if (status === 304) {
            statusText = "notmodified"; // If we have data, let's convert it
          } else {
            statusText = response.state;
            success = response.data;
            error = response.error;
            isSuccess = !error;
          }
        } else {
          // We extract error from statusText
          // then normalize statusText and status for non-aborts
          error = statusText;

          if (status || !statusText) {
            statusText = "error";

            if (status < 0) {
              status = 0;
            }
          }
        } // Set data for the fake xhr object


        jqXHR.status = status;
        jqXHR.statusText = (nativeStatusText || statusText) + ""; // Success/Error

        if (isSuccess) {
          deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
        } else {
          deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
        } // Status-dependent callbacks


        jqXHR.statusCode(_statusCode);
        _statusCode = undefined;

        if (fireGlobals) {
          globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
        } // Complete


        completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

        if (fireGlobals) {
          globalEventContext.trigger("ajaxComplete", [jqXHR, s]); // Handle the global AJAX counter

          if (! --jQuery.active) {
            jQuery.event.trigger("ajaxStop");
          }
        }
      }

      return jqXHR;
    },
    getJSON: function getJSON(url, data, callback) {
      return jQuery.get(url, data, callback, "json");
    },
    getScript: function getScript(url, callback) {
      return jQuery.get(url, undefined, callback, "script");
    }
  });
  jQuery.each(["get", "post"], function (i, method) {
    jQuery[method] = function (url, data, callback, type) {
      // shift arguments if data argument was omitted
      if (jQuery.isFunction(data)) {
        type = type || callback;
        callback = data;
        data = undefined;
      }

      return jQuery.ajax({
        url: url,
        type: method,
        dataType: type,
        data: data,
        success: callback
      });
    };
  });

  jQuery._evalUrl = function (url) {
    return jQuery.ajax({
      url: url,
      type: "GET",
      dataType: "script",
      async: false,
      global: false,
      "throws": true
    });
  };

  jQuery.fn.extend({
    wrapAll: function wrapAll(html) {
      if (jQuery.isFunction(html)) {
        return this.each(function (i) {
          jQuery(this).wrapAll(html.call(this, i));
        });
      }

      if (this[0]) {
        // The elements to wrap the target around
        var wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

        if (this[0].parentNode) {
          wrap.insertBefore(this[0]);
        }

        wrap.map(function () {
          var elem = this;

          while (elem.firstChild && elem.firstChild.nodeType === 1) {
            elem = elem.firstChild;
          }

          return elem;
        }).append(this);
      }

      return this;
    },
    wrapInner: function wrapInner(html) {
      if (jQuery.isFunction(html)) {
        return this.each(function (i) {
          jQuery(this).wrapInner(html.call(this, i));
        });
      }

      return this.each(function () {
        var self = jQuery(this),
            contents = self.contents();

        if (contents.length) {
          contents.wrapAll(html);
        } else {
          self.append(html);
        }
      });
    },
    wrap: function wrap(html) {
      var isFunction = jQuery.isFunction(html);
      return this.each(function (i) {
        jQuery(this).wrapAll(isFunction ? html.call(this, i) : html);
      });
    },
    unwrap: function unwrap() {
      return this.parent().each(function () {
        if (!jQuery.nodeName(this, "body")) {
          jQuery(this).replaceWith(this.childNodes);
        }
      }).end();
    }
  });

  jQuery.expr.filters.hidden = function (elem) {
    // Support: Opera <= 12.12
    // Opera reports offsetWidths and offsetHeights less than zero on some elements
    return elem.offsetWidth <= 0 && elem.offsetHeight <= 0 || !support.reliableHiddenOffsets() && (elem.style && elem.style.display || jQuery.css(elem, "display")) === "none";
  };

  jQuery.expr.filters.visible = function (elem) {
    return !jQuery.expr.filters.hidden(elem);
  };

  var r20 = /%20/g,
      rbracket = /\[\]$/,
      rCRLF = /\r?\n/g,
      rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
      rsubmittable = /^(?:input|select|textarea|keygen)/i;

  function buildParams(prefix, obj, traditional, add) {
    var name;

    if (jQuery.isArray(obj)) {
      // Serialize array item.
      jQuery.each(obj, function (i, v) {
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v);
        } else {
          // Item is non-scalar (array or object), encode its numeric index.
          buildParams(prefix + "[" + (_typeof2(v) === "object" ? i : "") + "]", v, traditional, add);
        }
      });
    } else if (!traditional && jQuery.type(obj) === "object") {
      // Serialize object item.
      for (name in obj) {
        buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
      }
    } else {
      // Serialize scalar item.
      add(prefix, obj);
    }
  } // Serialize an array of form elements or a set of
  // key/values into a query string


  jQuery.param = function (a, traditional) {
    var prefix,
        s = [],
        add = function add(key, value) {
      // If value is a function, invoke it and return its value
      value = jQuery.isFunction(value) ? value() : value == null ? "" : value;
      s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value);
    }; // Set traditional to true for jQuery <= 1.3.2 behavior.


    if (traditional === undefined) {
      traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
    } // If an array was passed in, assume that it is an array of form elements.


    if (jQuery.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
      // Serialize the form elements
      jQuery.each(a, function () {
        add(this.name, this.value);
      });
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in a) {
        buildParams(prefix, a[prefix], traditional, add);
      }
    } // Return the resulting serialization


    return s.join("&").replace(r20, "+");
  };

  jQuery.fn.extend({
    serialize: function serialize() {
      return jQuery.param(this.serializeArray());
    },
    serializeArray: function serializeArray() {
      return this.map(function () {
        // Can add propHook for "elements" to filter or add form elements
        var elements = jQuery.prop(this, "elements");
        return elements ? jQuery.makeArray(elements) : this;
      }).filter(function () {
        var type = this.type; // Use .is(":disabled") so that fieldset[disabled] works

        return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
      }).map(function (i, elem) {
        var val = jQuery(this).val();
        return val == null ? null : jQuery.isArray(val) ? jQuery.map(val, function (val) {
          return {
            name: elem.name,
            value: val.replace(rCRLF, "\r\n")
          };
        }) : {
          name: elem.name,
          value: val.replace(rCRLF, "\r\n")
        };
      }).get();
    }
  }); // Create the request object
  // (This is still attached to ajaxSettings for backward compatibility)

  jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ? // Support: IE6+
  function () {
    // XHR cannot access local files, always use ActiveX for that case
    return !this.isLocal && // Support: IE7-8
    // oldIE XHR does not support non-RFC2616 methods (#13240)
    // See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
    // and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
    // Although this check for six methods instead of eight
    // since IE also does not support "trace" and "connect"
    /^(get|post|head|put|delete|options)$/i.test(this.type) && createStandardXHR() || createActiveXHR();
  } : // For all other browsers, use the standard XMLHttpRequest object
  createStandardXHR;
  var xhrId = 0,
      xhrCallbacks = {},
      xhrSupported = jQuery.ajaxSettings.xhr(); // Support: IE<10
  // Open requests must be manually aborted on unload (#5280)
  // See https://support.microsoft.com/kb/2856746 for more info

  if (window.attachEvent) {
    window.attachEvent("onunload", function () {
      for (var key in xhrCallbacks) {
        xhrCallbacks[key](undefined, true);
      }
    });
  } // Determine support properties


  support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
  xhrSupported = support.ajax = !!xhrSupported; // Create transport if the browser can provide an xhr

  if (xhrSupported) {
    jQuery.ajaxTransport(function (options) {
      // Cross domain only allowed if supported through XMLHttpRequest
      if (!options.crossDomain || support.cors) {
        var _callback;

        return {
          send: function send(headers, complete) {
            var i,
                xhr = options.xhr(),
                id = ++xhrId; // Open the socket

            xhr.open(options.type, options.url, options.async, options.username, options.password); // Apply custom fields if provided

            if (options.xhrFields) {
              for (i in options.xhrFields) {
                xhr[i] = options.xhrFields[i];
              }
            } // Override mime type if needed


            if (options.mimeType && xhr.overrideMimeType) {
              xhr.overrideMimeType(options.mimeType);
            } // X-Requested-With header
            // For cross-domain requests, seeing as conditions for a preflight are
            // akin to a jigsaw puzzle, we simply never set it to be sure.
            // (it can always be set on a per-request basis or even using ajaxSetup)
            // For same-domain requests, won't change header if already provided.


            if (!options.crossDomain && !headers["X-Requested-With"]) {
              headers["X-Requested-With"] = "XMLHttpRequest";
            } // Set headers


            for (i in headers) {
              // Support: IE<9
              // IE's ActiveXObject throws a 'Type Mismatch' exception when setting
              // request header to a null-value.
              //
              // To keep consistent with other XHR implementations, cast the value
              // to string and ignore `undefined`.
              if (headers[i] !== undefined) {
                xhr.setRequestHeader(i, headers[i] + "");
              }
            } // Do send the request
            // This may raise an exception which is actually
            // handled in jQuery.ajax (so no try/catch here)


            xhr.send(options.hasContent && options.data || null); // Listener

            _callback = function callback(_, isAbort) {
              var status, statusText, responses; // Was never called and is aborted or complete

              if (_callback && (isAbort || xhr.readyState === 4)) {
                // Clean up
                delete xhrCallbacks[id];
                _callback = undefined;
                xhr.onreadystatechange = jQuery.noop; // Abort manually if needed

                if (isAbort) {
                  if (xhr.readyState !== 4) {
                    xhr.abort();
                  }
                } else {
                  responses = {};
                  status = xhr.status; // Support: IE<10
                  // Accessing binary-data responseText throws an exception
                  // (#11426)

                  if (typeof xhr.responseText === "string") {
                    responses.text = xhr.responseText;
                  } // Firefox throws an exception when accessing
                  // statusText for faulty cross-domain requests


                  try {
                    statusText = xhr.statusText;
                  } catch (e) {
                    // We normalize with Webkit giving an empty statusText
                    statusText = "";
                  } // Filter status for non standard behaviors
                  // If the request is local and we have data: assume a success
                  // (success with no data won't get notified, that's the best we
                  // can do given current implementations)


                  if (!status && options.isLocal && !options.crossDomain) {
                    status = responses.text ? 200 : 404; // IE - #1450: sometimes returns 1223 when it should be 204
                  } else if (status === 1223) {
                    status = 204;
                  }
                }
              } // Call complete if needed


              if (responses) {
                complete(status, statusText, responses, xhr.getAllResponseHeaders());
              }
            };

            if (!options.async) {
              // if we're in sync mode we fire the callback
              _callback();
            } else if (xhr.readyState === 4) {
              // (IE6 & IE7) if it's in cache and has been
              // retrieved directly we need to fire the callback
              setTimeout(_callback);
            } else {
              // Add to the list of active xhr callbacks
              xhr.onreadystatechange = xhrCallbacks[id] = _callback;
            }
          },
          abort: function abort() {
            if (_callback) {
              _callback(undefined, true);
            }
          }
        };
      }
    });
  } // Functions to create xhrs


  function createStandardXHR() {
    try {
      return new window.XMLHttpRequest();
    } catch (e) {}
  }

  function createActiveXHR() {
    try {
      return new window.ActiveXObject("Microsoft.XMLHTTP");
    } catch (e) {}
  } // Install script dataType


  jQuery.ajaxSetup({
    accepts: {
      script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
    },
    contents: {
      script: /(?:java|ecma)script/
    },
    converters: {
      "text script": function textScript(text) {
        jQuery.globalEval(text);
        return text;
      }
    }
  }); // Handle cache's special case and global

  jQuery.ajaxPrefilter("script", function (s) {
    if (s.cache === undefined) {
      s.cache = false;
    }

    if (s.crossDomain) {
      s.type = "GET";
      s.global = false;
    }
  }); // Bind script tag hack transport

  jQuery.ajaxTransport("script", function (s) {
    // This transport only deals with cross domain requests
    if (s.crossDomain) {
      var script,
          head = document.head || jQuery("head")[0] || document.documentElement;
      return {
        send: function send(_, callback) {
          script = document.createElement("script");
          script.async = true;

          if (s.scriptCharset) {
            script.charset = s.scriptCharset;
          }

          script.src = s.url; // Attach handlers for all browsers

          script.onload = script.onreadystatechange = function (_, isAbort) {
            if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
              // Handle memory leak in IE
              script.onload = script.onreadystatechange = null; // Remove the script

              if (script.parentNode) {
                script.parentNode.removeChild(script);
              } // Dereference the script


              script = null; // Callback if not abort

              if (!isAbort) {
                callback(200, "success");
              }
            }
          }; // Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
          // Use native DOM manipulation to avoid our domManip AJAX trickery


          head.insertBefore(script, head.firstChild);
        },
        abort: function abort() {
          if (script) {
            script.onload(undefined, true);
          }
        }
      };
    }
  });
  var oldCallbacks = [],
      rjsonp = /(=)\?(?=&|$)|\?\?/; // Default jsonp settings

  jQuery.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function jsonpCallback() {
      var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce++;
      this[callback] = true;
      return callback;
    }
  }); // Detect, normalize options and install callbacks for jsonp requests

  jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
    var callbackName,
        overwritten,
        responseContainer,
        jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && !(s.contentType || "").indexOf("application/x-www-form-urlencoded") && rjsonp.test(s.data) && "data"); // Handle iff the expected data type is "jsonp" or we have a parameter to set

    if (jsonProp || s.dataTypes[0] === "jsonp") {
      // Get callback name, remembering preexisting value associated with it
      callbackName = s.jsonpCallback = jQuery.isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback; // Insert callback into url or form data

      if (jsonProp) {
        s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
      } else if (s.jsonp !== false) {
        s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
      } // Use data converter to retrieve json after script execution


      s.converters["script json"] = function () {
        if (!responseContainer) {
          jQuery.error(callbackName + " was not called");
        }

        return responseContainer[0];
      }; // force json dataType


      s.dataTypes[0] = "json"; // Install callback

      overwritten = window[callbackName];

      window[callbackName] = function () {
        responseContainer = arguments;
      }; // Clean-up function (fires after converters)


      jqXHR.always(function () {
        // Restore preexisting value
        window[callbackName] = overwritten; // Save back as free

        if (s[callbackName]) {
          // make sure that re-using the options doesn't screw things around
          s.jsonpCallback = originalSettings.jsonpCallback; // save the callback name for future use

          oldCallbacks.push(callbackName);
        } // Call if it was a function and we have a response


        if (responseContainer && jQuery.isFunction(overwritten)) {
          overwritten(responseContainer[0]);
        }

        responseContainer = overwritten = undefined;
      }); // Delegate to script

      return "script";
    }
  }); // data: string of html
  // context (optional): If specified, the fragment will be created in this context, defaults to document
  // keepScripts (optional): If true, will include scripts passed in the html string

  jQuery.parseHTML = function (data, context, keepScripts) {
    if (!data || typeof data !== "string") {
      return null;
    }

    if (typeof context === "boolean") {
      keepScripts = context;
      context = false;
    }

    context = context || document;
    var parsed = rsingleTag.exec(data),
        scripts = !keepScripts && []; // Single tag

    if (parsed) {
      return [context.createElement(parsed[1])];
    }

    parsed = jQuery.buildFragment([data], context, scripts);

    if (scripts && scripts.length) {
      jQuery(scripts).remove();
    }

    return jQuery.merge([], parsed.childNodes);
  }; // Keep a copy of the old load method


  var _load = jQuery.fn.load;
  /**
   * Load a url into a page
   */

  jQuery.fn.load = function (url, params, callback) {
    if (typeof url !== "string" && _load) {
      return _load.apply(this, arguments);
    }

    var selector,
        response,
        type,
        self = this,
        off = url.indexOf(" ");

    if (off >= 0) {
      selector = jQuery.trim(url.slice(off, url.length));
      url = url.slice(0, off);
    } // If it's a function


    if (jQuery.isFunction(params)) {
      // We assume that it's the callback
      callback = params;
      params = undefined; // Otherwise, build a param string
    } else if (params && _typeof2(params) === "object") {
      type = "POST";
    } // If we have elements to modify, make the request


    if (self.length > 0) {
      jQuery.ajax({
        url: url,
        // if "type" variable is undefined, then "GET" method will be used
        type: type,
        dataType: "html",
        data: params
      }).done(function (responseText) {
        // Save response for use in complete callback
        response = arguments;
        self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
        // Exclude scripts to avoid IE 'Permission Denied' errors
        jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
        responseText);
      }).complete(callback && function (jqXHR, status) {
        self.each(callback, response || [jqXHR.responseText, status, jqXHR]);
      });
    }

    return this;
  }; // Attach a bunch of functions for handling common AJAX events


  jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (i, type) {
    jQuery.fn[type] = function (fn) {
      return this.on(type, fn);
    };
  });

  jQuery.expr.filters.animated = function (elem) {
    return jQuery.grep(jQuery.timers, function (fn) {
      return elem === fn.elem;
    }).length;
  };

  var docElem = window.document.documentElement;
  /**
   * Gets a window from an element
   */

  function getWindow(elem) {
    return jQuery.isWindow(elem) ? elem : elem.nodeType === 9 ? elem.defaultView || elem.parentWindow : false;
  }

  jQuery.offset = {
    setOffset: function setOffset(elem, options, i) {
      var curPosition,
          curLeft,
          curCSSTop,
          curTop,
          curOffset,
          curCSSLeft,
          calculatePosition,
          position = jQuery.css(elem, "position"),
          curElem = jQuery(elem),
          props = {}; // set position first, in-case top/left are set even on static elem

      if (position === "static") {
        elem.style.position = "relative";
      }

      curOffset = curElem.offset();
      curCSSTop = jQuery.css(elem, "top");
      curCSSLeft = jQuery.css(elem, "left");
      calculatePosition = (position === "absolute" || position === "fixed") && jQuery.inArray("auto", [curCSSTop, curCSSLeft]) > -1; // need to be able to calculate position if either top or left is auto and position is either absolute or fixed

      if (calculatePosition) {
        curPosition = curElem.position();
        curTop = curPosition.top;
        curLeft = curPosition.left;
      } else {
        curTop = parseFloat(curCSSTop) || 0;
        curLeft = parseFloat(curCSSLeft) || 0;
      }

      if (jQuery.isFunction(options)) {
        options = options.call(elem, i, curOffset);
      }

      if (options.top != null) {
        props.top = options.top - curOffset.top + curTop;
      }

      if (options.left != null) {
        props.left = options.left - curOffset.left + curLeft;
      }

      if ("using" in options) {
        options.using.call(elem, props);
      } else {
        curElem.css(props);
      }
    }
  };
  jQuery.fn.extend({
    offset: function offset(options) {
      if (arguments.length) {
        return options === undefined ? this : this.each(function (i) {
          jQuery.offset.setOffset(this, options, i);
        });
      }

      var docElem,
          win,
          box = {
        top: 0,
        left: 0
      },
          elem = this[0],
          doc = elem && elem.ownerDocument;

      if (!doc) {
        return;
      }

      docElem = doc.documentElement; // Make sure it's not a disconnected DOM node

      if (!jQuery.contains(docElem, elem)) {
        return box;
      } // If we don't have gBCR, just use 0,0 rather than error
      // BlackBerry 5, iOS 3 (original iPhone)


      if (_typeof2(elem.getBoundingClientRect) !== strundefined) {
        box = elem.getBoundingClientRect();
      }

      win = getWindow(doc);
      return {
        top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
        left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0)
      };
    },
    position: function position() {
      if (!this[0]) {
        return;
      }

      var offsetParent,
          offset,
          parentOffset = {
        top: 0,
        left: 0
      },
          elem = this[0]; // fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent

      if (jQuery.css(elem, "position") === "fixed") {
        // we assume that getBoundingClientRect is available when computed position is fixed
        offset = elem.getBoundingClientRect();
      } else {
        // Get *real* offsetParent
        offsetParent = this.offsetParent(); // Get correct offsets

        offset = this.offset();

        if (!jQuery.nodeName(offsetParent[0], "html")) {
          parentOffset = offsetParent.offset();
        } // Add offsetParent borders


        parentOffset.top += jQuery.css(offsetParent[0], "borderTopWidth", true);
        parentOffset.left += jQuery.css(offsetParent[0], "borderLeftWidth", true);
      } // Subtract parent offsets and element margins
      // note: when an element has margin: auto the offsetLeft and marginLeft
      // are the same in Safari causing offset.left to incorrectly be 0


      return {
        top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
        left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
      };
    },
    offsetParent: function offsetParent() {
      return this.map(function () {
        var offsetParent = this.offsetParent || docElem;

        while (offsetParent && !jQuery.nodeName(offsetParent, "html") && jQuery.css(offsetParent, "position") === "static") {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || docElem;
      });
    }
  }); // Create scrollLeft and scrollTop methods

  jQuery.each({
    scrollLeft: "pageXOffset",
    scrollTop: "pageYOffset"
  }, function (method, prop) {
    var top = /Y/.test(prop);

    jQuery.fn[method] = function (val) {
      return access(this, function (elem, method, val) {
        var win = getWindow(elem);

        if (val === undefined) {
          return win ? prop in win ? win[prop] : win.document.documentElement[method] : elem[method];
        }

        if (win) {
          win.scrollTo(!top ? val : jQuery(win).scrollLeft(), top ? val : jQuery(win).scrollTop());
        } else {
          elem[method] = val;
        }
      }, method, val, arguments.length, null);
    };
  }); // Add the top/left cssHooks using jQuery.fn.position
  // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
  // getComputedStyle returns percent when specified for top/left/bottom/right
  // rather than make the css module depend on the offset module, we just check for it here

  jQuery.each(["top", "left"], function (i, prop) {
    jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
      if (computed) {
        computed = curCSS(elem, prop); // if curCSS returns percentage, fallback to offset

        return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
      }
    });
  }); // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods

  jQuery.each({
    Height: "height",
    Width: "width"
  }, function (name, type) {
    jQuery.each({
      padding: "inner" + name,
      content: type,
      "": "outer" + name
    }, function (defaultExtra, funcName) {
      // margin is only for outerHeight, outerWidth
      jQuery.fn[funcName] = function (margin, value) {
        var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
            extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
        return access(this, function (elem, type, value) {
          var doc;

          if (jQuery.isWindow(elem)) {
            // As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
            // isn't a whole lot we can do. See pull request at this URL for discussion:
            // https://github.com/jquery/jquery/pull/764
            return elem.document.documentElement["client" + name];
          } // Get document width or height


          if (elem.nodeType === 9) {
            doc = elem.documentElement; // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height], whichever is greatest
            // unfortunately, this causes bug #3838 in IE6/8 only, but there is currently no good, small way to fix it.

            return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
          }

          return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
          jQuery.css(elem, type, extra) : // Set width or height on the element
          jQuery.style(elem, type, value, extra);
        }, type, chainable ? margin : undefined, chainable, null);
      };
    });
  }); // The number of elements contained in the matched element set

  jQuery.fn.size = function () {
    return this.length;
  };

  jQuery.fn.andSelf = jQuery.fn.addBack; // Register as a named AMD module, since jQuery can be concatenated with other
  // files that may use define, but not via a proper concatenation script that
  // understands anonymous AMD modules. A named AMD is safest and most robust
  // way to register. Lowercase jquery is used because AMD module names are
  // derived from file names, and jQuery is normally delivered in a lowercase
  // file name. Do this after creating the global so that if an AMD module wants
  // to call noConflict to hide this version of jQuery, it will work.
  // Note that for maximum portability, libraries that are not jQuery should
  // declare themselves as anonymous modules, and avoid setting a global if an
  // AMD loader is present. jQuery is a special case. For more information, see
  // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

  if (typeof define === "function" && define.amd) {
    define("jquery", [], function () {
      return jQuery;
    });
  }

  var // Map over jQuery in case of overwrite
  _jQuery = window.jQuery,
      // Map over the $ in case of overwrite
  _$ = window.$;

  jQuery.noConflict = function (deep) {
    if (window.$ === jQuery) {
      window.$ = _$;
    }

    if (deep && window.jQuery === jQuery) {
      window.jQuery = _jQuery;
    }

    return jQuery;
  }; // Expose jQuery and $ identifiers, even in
  // AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
  // and CommonJS for browser emulators (#13566)


  if (_typeof2(noGlobal) === strundefined) {
    window.jQuery = window.$ = jQuery;
  }

  return jQuery;
});
/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict'; // TAB CLASS DEFINITION
  // ====================

  var Tab = function Tab(element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element); // jscs:enable requireDollarBeforejQueryAssignment
  };

  Tab.VERSION = '3.3.7';
  Tab.TRANSITION_DURATION = 150;

  Tab.prototype.show = function () {
    var $this = this.element;
    var $ul = $this.closest('ul:not(.dropdown-menu)');
    var selector = $this.data('target');

    if (!selector) {
      selector = $this.attr('href');
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return;
    var $previous = $ul.find('.active:last a');
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    });
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    });
    $previous.trigger(hideEvent);
    $this.trigger(showEvent);
    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
    var $target = $(selector);
    this.activate($this.closest('li'), $ul);
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      });
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      });
    });
  };

  Tab.prototype.activate = function (element, container, callback) {
    var $active = container.find('> .active');
    var transition = callback && $.support.transition && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length);

    function next() {
      $active.removeClass('active').find('> .dropdown-menu > .active').removeClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', false);
      element.addClass('active').find('[data-toggle="tab"]').attr('aria-expanded', true);

      if (transition) {
        element[0].offsetWidth; // reflow for transition

        element.addClass('in');
      } else {
        element.removeClass('fade');
      }

      if (element.parent('.dropdown-menu').length) {
        element.closest('li.dropdown').addClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', true);
      }

      callback && callback();
    }

    $active.length && transition ? $active.one('bsTransitionEnd', next).emulateTransitionEnd(Tab.TRANSITION_DURATION) : next();
    $active.removeClass('in');
  }; // TAB PLUGIN DEFINITION
  // =====================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.tab');
      if (!data) $this.data('bs.tab', data = new Tab(this));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.tab;
  $.fn.tab = Plugin;
  $.fn.tab.Constructor = Tab; // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old;
    return this;
  }; // TAB DATA-API
  // ============


  var clickHandler = function clickHandler(e) {
    e.preventDefault();
    Plugin.call($(this), 'show');
  };

  $(document).on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler).on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler);
}(jQuery);
/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict'; // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function Collapse(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Collapse.DEFAULTS, options);
    this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],' + '[data-toggle="collapse"][data-target="#' + element.id + '"]');
    this.transitioning = null;

    if (this.options.parent) {
      this.$parent = this.getParent();
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger);
    }

    if (this.options.toggle) this.toggle();
  };

  Collapse.VERSION = '3.3.7';
  Collapse.TRANSITION_DURATION = 350;
  Collapse.DEFAULTS = {
    toggle: true
  };

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width');
    return hasWidth ? 'width' : 'height';
  };

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return;
    var activesData;
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing');

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse');
      if (activesData && activesData.transitioning) return;
    }

    var startEvent = $.Event('show.bs.collapse');
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;

    if (actives && actives.length) {
      Plugin.call(actives, 'hide');
      activesData || actives.data('bs.collapse', null);
    }

    var dimension = this.dimension();
    this.$element.removeClass('collapse').addClass('collapsing')[dimension](0).attr('aria-expanded', true);
    this.$trigger.removeClass('collapsed').attr('aria-expanded', true);
    this.transitioning = 1;

    var complete = function complete() {
      this.$element.removeClass('collapsing').addClass('collapse in')[dimension]('');
      this.transitioning = 0;
      this.$element.trigger('shown.bs.collapse');
    };

    if (!$.support.transition) return complete.call(this);
    var scrollSize = $.camelCase(['scroll', dimension].join('-'));
    this.$element.one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
  };

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return;
    var startEvent = $.Event('hide.bs.collapse');
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;
    var dimension = this.dimension();
    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;
    this.$element.addClass('collapsing').removeClass('collapse in').attr('aria-expanded', false);
    this.$trigger.addClass('collapsed').attr('aria-expanded', false);
    this.transitioning = 1;

    var complete = function complete() {
      this.transitioning = 0;
      this.$element.removeClass('collapsing').addClass('collapse').trigger('hidden.bs.collapse');
    };

    if (!$.support.transition) return complete.call(this);
    this.$element[dimension](0).one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
  };

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']();
  };

  Collapse.prototype.getParent = function () {
    return $(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($.proxy(function (i, element) {
      var $element = $(element);
      this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
    }, this)).end();
  };

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in');
    $element.attr('aria-expanded', isOpen);
    $trigger.toggleClass('collapsed', !isOpen).attr('aria-expanded', isOpen);
  };

  function getTargetFromTrigger($trigger) {
    var href;
    var target = $trigger.attr('data-target') || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7

    return $(target);
  } // COLLAPSE PLUGIN DEFINITION
  // ==========================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.collapse');
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), _typeof2(option) == 'object' && option);
      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false;
      if (!data) $this.data('bs.collapse', data = new Collapse(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.collapse;
  $.fn.collapse = Plugin;
  $.fn.collapse.Constructor = Collapse; // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old;
    return this;
  }; // COLLAPSE DATA-API
  // =================


  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this = $(this);
    if (!$this.attr('data-target')) e.preventDefault();
    var $target = getTargetFromTrigger($this);
    var data = $target.data('bs.collapse');
    var option = data ? 'toggle' : $this.data();
    Plugin.call($target, option);
  });
}(jQuery);
/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function Tooltip(element, options) {
    this.type = null;
    this.options = null;
    this.enabled = null;
    this.timeout = null;
    this.hoverState = null;
    this.$element = null;
    this.inState = null;
    this.init('tooltip', element, options);
  };

  Tooltip.VERSION = '3.3.7';
  Tooltip.TRANSITION_DURATION = 150;
  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  };

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled = true;
    this.type = type;
    this.$element = $(element);
    this.options = this.getOptions(options);
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport);
    this.inState = {
      click: false,
      hover: false,
      focus: false
    };

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!');
    }

    var triggers = this.options.trigger.split(' ');

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i];

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
      } else if (trigger != 'manual') {
        var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin';
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout';
        this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
      }
    }

    this.options.selector ? this._options = $.extend({}, this.options, {
      trigger: 'manual',
      selector: ''
    }) : this.fixTitle();
  };

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS;
  };

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options);

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      };
    }

    return options;
  };

  Tooltip.prototype.getDelegateOptions = function () {
    var options = {};
    var defaults = this.getDefaults();
    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value;
    });
    return options;
  };

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
      $(obj.currentTarget).data('bs.' + this.type, self);
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true;
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in';
      return;
    }

    clearTimeout(self.timeout);
    self.hoverState = 'in';
    if (!self.options.delay || !self.options.delay.show) return self.show();
    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show();
    }, self.options.delay.show);
  };

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true;
    }

    return false;
  };

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
      $(obj.currentTarget).data('bs.' + this.type, self);
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false;
    }

    if (self.isInStateTrue()) return;
    clearTimeout(self.timeout);
    self.hoverState = 'out';
    if (!self.options.delay || !self.options.delay.hide) return self.hide();
    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide();
    }, self.options.delay.hide);
  };

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type);

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e);
      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
      if (e.isDefaultPrevented() || !inDom) return;
      var that = this;
      var $tip = this.tip();
      var tipId = this.getUID(this.type);
      this.setContent();
      $tip.attr('id', tipId);
      this.$element.attr('aria-describedby', tipId);
      if (this.options.animation) $tip.addClass('fade');
      var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;
      var autoToken = /\s?auto?\s?/i;
      var autoPlace = autoToken.test(placement);
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top';
      $tip.detach().css({
        top: 0,
        left: 0,
        display: 'block'
      }).addClass(placement).data('bs.' + this.type, this);
      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
      this.$element.trigger('inserted.bs.' + this.type);
      var pos = this.getPosition();
      var actualWidth = $tip[0].offsetWidth;
      var actualHeight = $tip[0].offsetHeight;

      if (autoPlace) {
        var orgPlacement = placement;
        var viewportDim = this.getPosition(this.$viewport);
        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top' : placement == 'top' && pos.top - actualHeight < viewportDim.top ? 'bottom' : placement == 'right' && pos.right + actualWidth > viewportDim.width ? 'left' : placement == 'left' && pos.left - actualWidth < viewportDim.left ? 'right' : placement;
        $tip.removeClass(orgPlacement).addClass(placement);
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
      this.applyPlacement(calculatedOffset, placement);

      var complete = function complete() {
        var prevHoverState = that.hoverState;
        that.$element.trigger('shown.bs.' + that.type);
        that.hoverState = null;
        if (prevHoverState == 'out') that.leave(that);
      };

      $.support.transition && this.$tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
    }
  };

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip = this.tip();
    var width = $tip[0].offsetWidth;
    var height = $tip[0].offsetHeight; // manually read margins because getBoundingClientRect includes difference

    var marginTop = parseInt($tip.css('margin-top'), 10);
    var marginLeft = parseInt($tip.css('margin-left'), 10); // we must check for NaN for ie 8/9

    if (isNaN(marginTop)) marginTop = 0;
    if (isNaN(marginLeft)) marginLeft = 0;
    offset.top += marginTop;
    offset.left += marginLeft; // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0

    $.offset.setOffset($tip[0], $.extend({
      using: function using(props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        });
      }
    }, offset), 0);
    $tip.addClass('in'); // check to see if placing tip in new offset caused the tip to resize itself

    var actualWidth = $tip[0].offsetWidth;
    var actualHeight = $tip[0].offsetHeight;

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight;
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
    if (delta.left) offset.left += delta.left;else offset.top += delta.top;
    var isVertical = /top|bottom/.test(placement);
    var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
    $tip.offset(offset);
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
  };

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow().css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isVertical ? 'top' : 'left', '');
  };

  Tooltip.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();
    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
    $tip.removeClass('fade in top bottom left right');
  };

  Tooltip.prototype.hide = function (callback) {
    var that = this;
    var $tip = $(this.$tip);
    var e = $.Event('hide.bs.' + this.type);

    function complete() {
      if (that.hoverState != 'in') $tip.detach();

      if (that.$element) {
        // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element.removeAttr('aria-describedby').trigger('hidden.bs.' + that.type);
      }

      callback && callback();
    }

    this.$element.trigger(e);
    if (e.isDefaultPrevented()) return;
    $tip.removeClass('in');
    $.support.transition && $tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
    this.hoverState = null;
    return this;
  };

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element;

    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
    }
  };

  Tooltip.prototype.hasContent = function () {
    return this.getTitle();
  };

  Tooltip.prototype.getPosition = function ($element) {
    $element = $element || this.$element;
    var el = $element[0];
    var isBody = el.tagName == 'BODY';
    var elRect = el.getBoundingClientRect();

    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, {
        width: elRect.right - elRect.left,
        height: elRect.bottom - elRect.top
      });
    }

    var isSvg = window.SVGElement && el instanceof window.SVGElement; // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280

    var elOffset = isBody ? {
      top: 0,
      left: 0
    } : isSvg ? null : $element.offset();
    var scroll = {
      scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop()
    };
    var outerDims = isBody ? {
      width: $(window).width(),
      height: $(window).height()
    } : null;
    return $.extend({}, elRect, scroll, outerDims, elOffset);
  };

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? {
      top: pos.top + pos.height,
      left: pos.left + pos.width / 2 - actualWidth / 2
    } : placement == 'top' ? {
      top: pos.top - actualHeight,
      left: pos.left + pos.width / 2 - actualWidth / 2
    } : placement == 'left' ? {
      top: pos.top + pos.height / 2 - actualHeight / 2,
      left: pos.left - actualWidth
    } :
    /* placement == 'right' */
    {
      top: pos.top + pos.height / 2 - actualHeight / 2,
      left: pos.left + pos.width
    };
  };

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = {
      top: 0,
      left: 0
    };
    if (!this.$viewport) return delta;
    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
    var viewportDimensions = this.getPosition(this.$viewport);

    if (/right|left/.test(placement)) {
      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;

      if (topEdgeOffset < viewportDimensions.top) {
        // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset;
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
        // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
      }
    } else {
      var leftEdgeOffset = pos.left - viewportPadding;
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;

      if (leftEdgeOffset < viewportDimensions.left) {
        // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset;
      } else if (rightEdgeOffset > viewportDimensions.right) {
        // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
      }
    }

    return delta;
  };

  Tooltip.prototype.getTitle = function () {
    var title;
    var $e = this.$element;
    var o = this.options;
    title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);
    return title;
  };

  Tooltip.prototype.getUID = function (prefix) {
    do {
      prefix += ~~(Math.random() * 1000000);
    } while (document.getElementById(prefix));

    return prefix;
  };

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template);

      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!');
      }
    }

    return this.$tip;
  };

  Tooltip.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
  };

  Tooltip.prototype.enable = function () {
    this.enabled = true;
  };

  Tooltip.prototype.disable = function () {
    this.enabled = false;
  };

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled;
  };

  Tooltip.prototype.toggle = function (e) {
    var self = this;

    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type);

      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions());
        $(e.currentTarget).data('bs.' + this.type, self);
      }
    }

    if (e) {
      self.inState.click = !self.inState.click;
      if (self.isInStateTrue()) self.enter(self);else self.leave(self);
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
    }
  };

  Tooltip.prototype.destroy = function () {
    var that = this;
    clearTimeout(this.timeout);
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type);

      if (that.$tip) {
        that.$tip.detach();
      }

      that.$tip = null;
      that.$arrow = null;
      that.$viewport = null;
      that.$element = null;
    });
  }; // TOOLTIP PLUGIN DEFINITION
  // =========================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.tooltip');
      var options = _typeof2(option) == 'object' && option;
      if (!data && /destroy|hide/.test(option)) return;
      if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.tooltip;
  $.fn.tooltip = Plugin;
  $.fn.tooltip.Constructor = Tooltip; // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old;
    return this;
  };
}(jQuery);
/*! jQuery Validation Plugin - v1.19.0 - 11/28/2018
 * https://jqueryvalidation.org/
 * Copyright (c) 2018 Jörn Zaefferer; Licensed MIT */

!function (a) {
  "function" == typeof define && define.amd ? define(["jquery"], a) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = a(require("jquery")) : a(jQuery);
}(function (a) {
  a.extend(a.fn, {
    validate: function validate(b) {
      if (!this.length) return void (b && b.debug && window.console && console.warn("Nothing selected, can't validate, returning nothing."));
      var c = a.data(this[0], "validator");
      return c ? c : (this.attr("novalidate", "novalidate"), c = new a.validator(b, this[0]), a.data(this[0], "validator", c), c.settings.onsubmit && (this.on("click.validate", ":submit", function (b) {
        c.submitButton = b.currentTarget, a(this).hasClass("cancel") && (c.cancelSubmit = !0), void 0 !== a(this).attr("formnovalidate") && (c.cancelSubmit = !0);
      }), this.on("submit.validate", function (b) {
        function d() {
          var d, e;
          return c.submitButton && (c.settings.submitHandler || c.formSubmitted) && (d = a("<input type='hidden'/>").attr("name", c.submitButton.name).val(a(c.submitButton).val()).appendTo(c.currentForm)), !(c.settings.submitHandler && !c.settings.debug) || (e = c.settings.submitHandler.call(c, c.currentForm, b), d && d.remove(), void 0 !== e && e);
        }

        return c.settings.debug && b.preventDefault(), c.cancelSubmit ? (c.cancelSubmit = !1, d()) : c.form() ? c.pendingRequest ? (c.formSubmitted = !0, !1) : d() : (c.focusInvalid(), !1);
      })), c);
    },
    valid: function valid() {
      var b, c, d;
      return a(this[0]).is("form") ? b = this.validate().form() : (d = [], b = !0, c = a(this[0].form).validate(), this.each(function () {
        b = c.element(this) && b, b || (d = d.concat(c.errorList));
      }), c.errorList = d), b;
    },
    rules: function rules(b, c) {
      var d,
          e,
          f,
          g,
          h,
          i,
          j = this[0],
          k = "undefined" != typeof this.attr("contenteditable") && "false" !== this.attr("contenteditable");

      if (null != j && (!j.form && k && (j.form = this.closest("form")[0], j.name = this.attr("name")), null != j.form)) {
        if (b) switch (d = a.data(j.form, "validator").settings, e = d.rules, f = a.validator.staticRules(j), b) {
          case "add":
            a.extend(f, a.validator.normalizeRule(c)), delete f.messages, e[j.name] = f, c.messages && (d.messages[j.name] = a.extend(d.messages[j.name], c.messages));
            break;

          case "remove":
            return c ? (i = {}, a.each(c.split(/\s/), function (a, b) {
              i[b] = f[b], delete f[b];
            }), i) : (delete e[j.name], f);
        }
        return g = a.validator.normalizeRules(a.extend({}, a.validator.classRules(j), a.validator.attributeRules(j), a.validator.dataRules(j), a.validator.staticRules(j)), j), g.required && (h = g.required, delete g.required, g = a.extend({
          required: h
        }, g)), g.remote && (h = g.remote, delete g.remote, g = a.extend(g, {
          remote: h
        })), g;
      }
    }
  }), a.extend(a.expr.pseudos || a.expr[":"], {
    blank: function blank(b) {
      return !a.trim("" + a(b).val());
    },
    filled: function filled(b) {
      var c = a(b).val();
      return null !== c && !!a.trim("" + c);
    },
    unchecked: function unchecked(b) {
      return !a(b).prop("checked");
    }
  }), a.validator = function (b, c) {
    this.settings = a.extend(!0, {}, a.validator.defaults, b), this.currentForm = c, this.init();
  }, a.validator.format = function (b, c) {
    return 1 === arguments.length ? function () {
      var c = a.makeArray(arguments);
      return c.unshift(b), a.validator.format.apply(this, c);
    } : void 0 === c ? b : (arguments.length > 2 && c.constructor !== Array && (c = a.makeArray(arguments).slice(1)), c.constructor !== Array && (c = [c]), a.each(c, function (a, c) {
      b = b.replace(new RegExp("\\{" + a + "\\}", "g"), function () {
        return c;
      });
    }), b);
  }, a.extend(a.validator, {
    defaults: {
      messages: {},
      groups: {},
      rules: {},
      errorClass: "error",
      pendingClass: "pending",
      validClass: "valid",
      errorElement: "label",
      focusCleanup: !1,
      focusInvalid: !0,
      errorContainer: a([]),
      errorLabelContainer: a([]),
      onsubmit: !0,
      ignore: ":hidden",
      ignoreTitle: !1,
      onfocusin: function onfocusin(a) {
        this.lastActive = a, this.settings.focusCleanup && (this.settings.unhighlight && this.settings.unhighlight.call(this, a, this.settings.errorClass, this.settings.validClass), this.hideThese(this.errorsFor(a)));
      },
      onfocusout: function onfocusout(a) {
        this.checkable(a) || !(a.name in this.submitted) && this.optional(a) || this.element(a);
      },
      onkeyup: function onkeyup(b, c) {
        var d = [16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225];
        9 === c.which && "" === this.elementValue(b) || a.inArray(c.keyCode, d) !== -1 || (b.name in this.submitted || b.name in this.invalid) && this.element(b);
      },
      onclick: function onclick(a) {
        a.name in this.submitted ? this.element(a) : a.parentNode.name in this.submitted && this.element(a.parentNode);
      },
      highlight: function highlight(b, c, d) {
        "radio" === b.type ? this.findByName(b.name).addClass(c).removeClass(d) : a(b).addClass(c).removeClass(d);
      },
      unhighlight: function unhighlight(b, c, d) {
        "radio" === b.type ? this.findByName(b.name).removeClass(c).addClass(d) : a(b).removeClass(c).addClass(d);
      }
    },
    setDefaults: function setDefaults(b) {
      a.extend(a.validator.defaults, b);
    },
    messages: {
      required: "This field is required.",
      remote: "Please fix this field.",
      email: "Please enter a valid email address.",
      url: "Please enter a valid URL.",
      date: "Please enter a valid date.",
      dateISO: "Please enter a valid date (ISO).",
      number: "Please enter a valid number.",
      digits: "Please enter only digits.",
      equalTo: "Please enter the same value again.",
      maxlength: a.validator.format("Please enter no more than {0} characters."),
      minlength: a.validator.format("Please enter at least {0} characters."),
      rangelength: a.validator.format("Please enter a value between {0} and {1} characters long."),
      range: a.validator.format("Please enter a value between {0} and {1}."),
      max: a.validator.format("Please enter a value less than or equal to {0}."),
      min: a.validator.format("Please enter a value greater than or equal to {0}."),
      step: a.validator.format("Please enter a multiple of {0}.")
    },
    autoCreateRanges: !1,
    prototype: {
      init: function init() {
        function b(b) {
          var c = "undefined" != typeof a(this).attr("contenteditable") && "false" !== a(this).attr("contenteditable");

          if (!this.form && c && (this.form = a(this).closest("form")[0], this.name = a(this).attr("name")), d === this.form) {
            var e = a.data(this.form, "validator"),
                f = "on" + b.type.replace(/^validate/, ""),
                g = e.settings;
            g[f] && !a(this).is(g.ignore) && g[f].call(e, this, b);
          }
        }

        this.labelContainer = a(this.settings.errorLabelContainer), this.errorContext = this.labelContainer.length && this.labelContainer || a(this.currentForm), this.containers = a(this.settings.errorContainer).add(this.settings.errorLabelContainer), this.submitted = {}, this.valueCache = {}, this.pendingRequest = 0, this.pending = {}, this.invalid = {}, this.reset();
        var c,
            d = this.currentForm,
            e = this.groups = {};
        a.each(this.settings.groups, function (b, c) {
          "string" == typeof c && (c = c.split(/\s/)), a.each(c, function (a, c) {
            e[c] = b;
          });
        }), c = this.settings.rules, a.each(c, function (b, d) {
          c[b] = a.validator.normalizeRule(d);
        }), a(this.currentForm).on("focusin.validate focusout.validate keyup.validate", ":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']", b).on("click.validate", "select, option, [type='radio'], [type='checkbox']", b), this.settings.invalidHandler && a(this.currentForm).on("invalid-form.validate", this.settings.invalidHandler);
      },
      form: function form() {
        return this.checkForm(), a.extend(this.submitted, this.errorMap), this.invalid = a.extend({}, this.errorMap), this.valid() || a(this.currentForm).triggerHandler("invalid-form", [this]), this.showErrors(), this.valid();
      },
      checkForm: function checkForm() {
        this.prepareForm();

        for (var a = 0, b = this.currentElements = this.elements(); b[a]; a++) {
          this.check(b[a]);
        }

        return this.valid();
      },
      element: function element(b) {
        var c,
            d,
            e = this.clean(b),
            f = this.validationTargetFor(e),
            g = this,
            h = !0;
        return void 0 === f ? delete this.invalid[e.name] : (this.prepareElement(f), this.currentElements = a(f), d = this.groups[f.name], d && a.each(this.groups, function (a, b) {
          b === d && a !== f.name && (e = g.validationTargetFor(g.clean(g.findByName(a))), e && e.name in g.invalid && (g.currentElements.push(e), h = g.check(e) && h));
        }), c = this.check(f) !== !1, h = h && c, c ? this.invalid[f.name] = !1 : this.invalid[f.name] = !0, this.numberOfInvalids() || (this.toHide = this.toHide.add(this.containers)), this.showErrors(), a(b).attr("aria-invalid", !c)), h;
      },
      showErrors: function showErrors(b) {
        if (b) {
          var c = this;
          a.extend(this.errorMap, b), this.errorList = a.map(this.errorMap, function (a, b) {
            return {
              message: a,
              element: c.findByName(b)[0]
            };
          }), this.successList = a.grep(this.successList, function (a) {
            return !(a.name in b);
          });
        }

        this.settings.showErrors ? this.settings.showErrors.call(this, this.errorMap, this.errorList) : this.defaultShowErrors();
      },
      resetForm: function resetForm() {
        a.fn.resetForm && a(this.currentForm).resetForm(), this.invalid = {}, this.submitted = {}, this.prepareForm(), this.hideErrors();
        var b = this.elements().removeData("previousValue").removeAttr("aria-invalid");
        this.resetElements(b);
      },
      resetElements: function resetElements(a) {
        var b;
        if (this.settings.unhighlight) for (b = 0; a[b]; b++) {
          this.settings.unhighlight.call(this, a[b], this.settings.errorClass, ""), this.findByName(a[b].name).removeClass(this.settings.validClass);
        } else a.removeClass(this.settings.errorClass).removeClass(this.settings.validClass);
      },
      numberOfInvalids: function numberOfInvalids() {
        return this.objectLength(this.invalid);
      },
      objectLength: function objectLength(a) {
        var b,
            c = 0;

        for (b in a) {
          void 0 !== a[b] && null !== a[b] && a[b] !== !1 && c++;
        }

        return c;
      },
      hideErrors: function hideErrors() {
        this.hideThese(this.toHide);
      },
      hideThese: function hideThese(a) {
        a.not(this.containers).text(""), this.addWrapper(a).hide();
      },
      valid: function valid() {
        return 0 === this.size();
      },
      size: function size() {
        return this.errorList.length;
      },
      focusInvalid: function focusInvalid() {
        if (this.settings.focusInvalid) try {
          a(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(":visible").focus().trigger("focusin");
        } catch (b) {}
      },
      findLastActive: function findLastActive() {
        var b = this.lastActive;
        return b && 1 === a.grep(this.errorList, function (a) {
          return a.element.name === b.name;
        }).length && b;
      },
      elements: function elements() {
        var b = this,
            c = {};
        return a(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function () {
          var d = this.name || a(this).attr("name"),
              e = "undefined" != typeof a(this).attr("contenteditable") && "false" !== a(this).attr("contenteditable");
          return !d && b.settings.debug && window.console && console.error("%o has no name assigned", this), e && (this.form = a(this).closest("form")[0], this.name = d), this.form === b.currentForm && !(d in c || !b.objectLength(a(this).rules())) && (c[d] = !0, !0);
        });
      },
      clean: function clean(b) {
        return a(b)[0];
      },
      errors: function errors() {
        var b = this.settings.errorClass.split(" ").join(".");
        return a(this.settings.errorElement + "." + b, this.errorContext);
      },
      resetInternals: function resetInternals() {
        this.successList = [], this.errorList = [], this.errorMap = {}, this.toShow = a([]), this.toHide = a([]);
      },
      reset: function reset() {
        this.resetInternals(), this.currentElements = a([]);
      },
      prepareForm: function prepareForm() {
        this.reset(), this.toHide = this.errors().add(this.containers);
      },
      prepareElement: function prepareElement(a) {
        this.reset(), this.toHide = this.errorsFor(a);
      },
      elementValue: function elementValue(b) {
        var c,
            d,
            e = a(b),
            f = b.type,
            g = "undefined" != typeof e.attr("contenteditable") && "false" !== e.attr("contenteditable");
        return "radio" === f || "checkbox" === f ? this.findByName(b.name).filter(":checked").val() : "number" === f && "undefined" != typeof b.validity ? b.validity.badInput ? "NaN" : e.val() : (c = g ? e.text() : e.val(), "file" === f ? "C:\\fakepath\\" === c.substr(0, 12) ? c.substr(12) : (d = c.lastIndexOf("/"), d >= 0 ? c.substr(d + 1) : (d = c.lastIndexOf("\\"), d >= 0 ? c.substr(d + 1) : c)) : "string" == typeof c ? c.replace(/\r/g, "") : c);
      },
      check: function check(b) {
        b = this.validationTargetFor(this.clean(b));
        var c,
            d,
            e,
            f,
            g = a(b).rules(),
            h = a.map(g, function (a, b) {
          return b;
        }).length,
            i = !1,
            j = this.elementValue(b);
        "function" == typeof g.normalizer ? f = g.normalizer : "function" == typeof this.settings.normalizer && (f = this.settings.normalizer), f && (j = f.call(b, j), delete g.normalizer);

        for (d in g) {
          e = {
            method: d,
            parameters: g[d]
          };

          try {
            if (c = a.validator.methods[d].call(this, j, b, e.parameters), "dependency-mismatch" === c && 1 === h) {
              i = !0;
              continue;
            }

            if (i = !1, "pending" === c) return void (this.toHide = this.toHide.not(this.errorsFor(b)));
            if (!c) return this.formatAndAdd(b, e), !1;
          } catch (k) {
            throw this.settings.debug && window.console && console.log("Exception occurred when checking element " + b.id + ", check the '" + e.method + "' method.", k), k instanceof TypeError && (k.message += ".  Exception occurred when checking element " + b.id + ", check the '" + e.method + "' method."), k;
          }
        }

        if (!i) return this.objectLength(g) && this.successList.push(b), !0;
      },
      customDataMessage: function customDataMessage(b, c) {
        return a(b).data("msg" + c.charAt(0).toUpperCase() + c.substring(1).toLowerCase()) || a(b).data("msg");
      },
      customMessage: function customMessage(a, b) {
        var c = this.settings.messages[a];
        return c && (c.constructor === String ? c : c[b]);
      },
      findDefined: function findDefined() {
        for (var a = 0; a < arguments.length; a++) {
          if (void 0 !== arguments[a]) return arguments[a];
        }
      },
      defaultMessage: function defaultMessage(b, c) {
        "string" == typeof c && (c = {
          method: c
        });
        var d = this.findDefined(this.customMessage(b.name, c.method), this.customDataMessage(b, c.method), !this.settings.ignoreTitle && b.title || void 0, a.validator.messages[c.method], "<strong>Warning: No message defined for " + b.name + "</strong>"),
            e = /\$?\{(\d+)\}/g;
        return "function" == typeof d ? d = d.call(this, c.parameters, b) : e.test(d) && (d = a.validator.format(d.replace(e, "{$1}"), c.parameters)), d;
      },
      formatAndAdd: function formatAndAdd(a, b) {
        var c = this.defaultMessage(a, b);
        this.errorList.push({
          message: c,
          element: a,
          method: b.method
        }), this.errorMap[a.name] = c, this.submitted[a.name] = c;
      },
      addWrapper: function addWrapper(a) {
        return this.settings.wrapper && (a = a.add(a.parent(this.settings.wrapper))), a;
      },
      defaultShowErrors: function defaultShowErrors() {
        var a, b, c;

        for (a = 0; this.errorList[a]; a++) {
          c = this.errorList[a], this.settings.highlight && this.settings.highlight.call(this, c.element, this.settings.errorClass, this.settings.validClass), this.showLabel(c.element, c.message);
        }

        if (this.errorList.length && (this.toShow = this.toShow.add(this.containers)), this.settings.success) for (a = 0; this.successList[a]; a++) {
          this.showLabel(this.successList[a]);
        }
        if (this.settings.unhighlight) for (a = 0, b = this.validElements(); b[a]; a++) {
          this.settings.unhighlight.call(this, b[a], this.settings.errorClass, this.settings.validClass);
        }
        this.toHide = this.toHide.not(this.toShow), this.hideErrors(), this.addWrapper(this.toShow).show();
      },
      validElements: function validElements() {
        return this.currentElements.not(this.invalidElements());
      },
      invalidElements: function invalidElements() {
        return a(this.errorList).map(function () {
          return this.element;
        });
      },
      showLabel: function showLabel(b, c) {
        var d,
            e,
            f,
            g,
            h = this.errorsFor(b),
            i = this.idOrName(b),
            j = a(b).attr("aria-describedby");
        h.length ? (h.removeClass(this.settings.validClass).addClass(this.settings.errorClass), h.html(c)) : (h = a("<" + this.settings.errorElement + ">").attr("id", i + "-error").addClass(this.settings.errorClass).html(c || ""), d = h, this.settings.wrapper && (d = h.hide().show().wrap("<" + this.settings.wrapper + "/>").parent()), this.labelContainer.length ? this.labelContainer.append(d) : this.settings.errorPlacement ? this.settings.errorPlacement.call(this, d, a(b)) : d.insertAfter(b), h.is("label") ? h.attr("for", i) : 0 === h.parents("label[for='" + this.escapeCssMeta(i) + "']").length && (f = h.attr("id"), j ? j.match(new RegExp("\\b" + this.escapeCssMeta(f) + "\\b")) || (j += " " + f) : j = f, a(b).attr("aria-describedby", j), e = this.groups[b.name], e && (g = this, a.each(g.groups, function (b, c) {
          c === e && a("[name='" + g.escapeCssMeta(b) + "']", g.currentForm).attr("aria-describedby", h.attr("id"));
        })))), !c && this.settings.success && (h.text(""), "string" == typeof this.settings.success ? h.addClass(this.settings.success) : this.settings.success(h, b)), this.toShow = this.toShow.add(h);
      },
      errorsFor: function errorsFor(b) {
        var c = this.escapeCssMeta(this.idOrName(b)),
            d = a(b).attr("aria-describedby"),
            e = "label[for='" + c + "'], label[for='" + c + "'] *";
        return d && (e = e + ", #" + this.escapeCssMeta(d).replace(/\s+/g, ", #")), this.errors().filter(e);
      },
      escapeCssMeta: function escapeCssMeta(a) {
        return a.replace(/([\\!"#$%&'()*+,.\/:;<=>?@\[\]^`{|}~])/g, "\\$1");
      },
      idOrName: function idOrName(a) {
        return this.groups[a.name] || (this.checkable(a) ? a.name : a.id || a.name);
      },
      validationTargetFor: function validationTargetFor(b) {
        return this.checkable(b) && (b = this.findByName(b.name)), a(b).not(this.settings.ignore)[0];
      },
      checkable: function checkable(a) {
        return /radio|checkbox/i.test(a.type);
      },
      findByName: function findByName(b) {
        return a(this.currentForm).find("[name='" + this.escapeCssMeta(b) + "']");
      },
      getLength: function getLength(b, c) {
        switch (c.nodeName.toLowerCase()) {
          case "select":
            return a("option:selected", c).length;

          case "input":
            if (this.checkable(c)) return this.findByName(c.name).filter(":checked").length;
        }

        return b.length;
      },
      depend: function depend(a, b) {
        return !this.dependTypes[_typeof2(a)] || this.dependTypes[_typeof2(a)](a, b);
      },
      dependTypes: {
        "boolean": function boolean(a) {
          return a;
        },
        string: function string(b, c) {
          return !!a(b, c.form).length;
        },
        "function": function _function(a, b) {
          return a(b);
        }
      },
      optional: function optional(b) {
        var c = this.elementValue(b);
        return !a.validator.methods.required.call(this, c, b) && "dependency-mismatch";
      },
      startRequest: function startRequest(b) {
        this.pending[b.name] || (this.pendingRequest++, a(b).addClass(this.settings.pendingClass), this.pending[b.name] = !0);
      },
      stopRequest: function stopRequest(b, c) {
        this.pendingRequest--, this.pendingRequest < 0 && (this.pendingRequest = 0), delete this.pending[b.name], a(b).removeClass(this.settings.pendingClass), c && 0 === this.pendingRequest && this.formSubmitted && this.form() ? (a(this.currentForm).submit(), this.submitButton && a("input:hidden[name='" + this.submitButton.name + "']", this.currentForm).remove(), this.formSubmitted = !1) : !c && 0 === this.pendingRequest && this.formSubmitted && (a(this.currentForm).triggerHandler("invalid-form", [this]), this.formSubmitted = !1);
      },
      previousValue: function previousValue(b, c) {
        return c = "string" == typeof c && c || "remote", a.data(b, "previousValue") || a.data(b, "previousValue", {
          old: null,
          valid: !0,
          message: this.defaultMessage(b, {
            method: c
          })
        });
      },
      destroy: function destroy() {
        this.resetForm(), a(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur").find(".validate-lessThan-blur").off(".validate-lessThan").removeClass("validate-lessThan-blur").find(".validate-lessThanEqual-blur").off(".validate-lessThanEqual").removeClass("validate-lessThanEqual-blur").find(".validate-greaterThanEqual-blur").off(".validate-greaterThanEqual").removeClass("validate-greaterThanEqual-blur").find(".validate-greaterThan-blur").off(".validate-greaterThan").removeClass("validate-greaterThan-blur");
      }
    },
    classRuleSettings: {
      required: {
        required: !0
      },
      email: {
        email: !0
      },
      url: {
        url: !0
      },
      date: {
        date: !0
      },
      dateISO: {
        dateISO: !0
      },
      number: {
        number: !0
      },
      digits: {
        digits: !0
      },
      creditcard: {
        creditcard: !0
      }
    },
    addClassRules: function addClassRules(b, c) {
      b.constructor === String ? this.classRuleSettings[b] = c : a.extend(this.classRuleSettings, b);
    },
    classRules: function classRules(b) {
      var c = {},
          d = a(b).attr("class");
      return d && a.each(d.split(" "), function () {
        this in a.validator.classRuleSettings && a.extend(c, a.validator.classRuleSettings[this]);
      }), c;
    },
    normalizeAttributeRule: function normalizeAttributeRule(a, b, c, d) {
      /min|max|step/.test(c) && (null === b || /number|range|text/.test(b)) && (d = Number(d), isNaN(d) && (d = void 0)), d || 0 === d ? a[c] = d : b === c && "range" !== b && (a[c] = !0);
    },
    attributeRules: function attributeRules(b) {
      var c,
          d,
          e = {},
          f = a(b),
          g = b.getAttribute("type");

      for (c in a.validator.methods) {
        "required" === c ? (d = b.getAttribute(c), "" === d && (d = !0), d = !!d) : d = f.attr(c), this.normalizeAttributeRule(e, g, c, d);
      }

      return e.maxlength && /-1|2147483647|524288/.test(e.maxlength) && delete e.maxlength, e;
    },
    dataRules: function dataRules(b) {
      var c,
          d,
          e = {},
          f = a(b),
          g = b.getAttribute("type");

      for (c in a.validator.methods) {
        d = f.data("rule" + c.charAt(0).toUpperCase() + c.substring(1).toLowerCase()), "" === d && (d = !0), this.normalizeAttributeRule(e, g, c, d);
      }

      return e;
    },
    staticRules: function staticRules(b) {
      var c = {},
          d = a.data(b.form, "validator");
      return d.settings.rules && (c = a.validator.normalizeRule(d.settings.rules[b.name]) || {}), c;
    },
    normalizeRules: function normalizeRules(b, c) {
      return a.each(b, function (d, e) {
        if (e === !1) return void delete b[d];

        if (e.param || e.depends) {
          var f = !0;

          switch (_typeof2(e.depends)) {
            case "string":
              f = !!a(e.depends, c.form).length;
              break;

            case "function":
              f = e.depends.call(c, c);
          }

          f ? b[d] = void 0 === e.param || e.param : (a.data(c.form, "validator").resetElements(a(c)), delete b[d]);
        }
      }), a.each(b, function (d, e) {
        b[d] = a.isFunction(e) && "normalizer" !== d ? e(c) : e;
      }), a.each(["minlength", "maxlength"], function () {
        b[this] && (b[this] = Number(b[this]));
      }), a.each(["rangelength", "range"], function () {
        var c;
        b[this] && (a.isArray(b[this]) ? b[this] = [Number(b[this][0]), Number(b[this][1])] : "string" == typeof b[this] && (c = b[this].replace(/[\[\]]/g, "").split(/[\s,]+/), b[this] = [Number(c[0]), Number(c[1])]));
      }), a.validator.autoCreateRanges && (null != b.min && null != b.max && (b.range = [b.min, b.max], delete b.min, delete b.max), null != b.minlength && null != b.maxlength && (b.rangelength = [b.minlength, b.maxlength], delete b.minlength, delete b.maxlength)), b;
    },
    normalizeRule: function normalizeRule(b) {
      if ("string" == typeof b) {
        var c = {};
        a.each(b.split(/\s/), function () {
          c[this] = !0;
        }), b = c;
      }

      return b;
    },
    addMethod: function addMethod(b, c, d) {
      a.validator.methods[b] = c, a.validator.messages[b] = void 0 !== d ? d : a.validator.messages[b], c.length < 3 && a.validator.addClassRules(b, a.validator.normalizeRule(b));
    },
    methods: {
      required: function required(b, c, d) {
        if (!this.depend(d, c)) return "dependency-mismatch";

        if ("select" === c.nodeName.toLowerCase()) {
          var e = a(c).val();
          return e && e.length > 0;
        }

        return this.checkable(c) ? this.getLength(b, c) > 0 : void 0 !== b && null !== b && b.length > 0;
      },
      email: function email(a, b) {
        return this.optional(b) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(a);
      },
      url: function url(a, b) {
        return this.optional(b) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i.test(a);
      },
      date: function () {
        var a = !1;
        return function (b, c) {
          return a || (a = !0, this.settings.debug && window.console && console.warn("The `date` method is deprecated and will be removed in version '2.0.0'.\nPlease don't use it, since it relies on the Date constructor, which\nbehaves very differently across browsers and locales. Use `dateISO`\ninstead or one of the locale specific methods in `localizations/`\nand `additional-methods.js`.")), this.optional(c) || !/Invalid|NaN/.test(new Date(b).toString());
        };
      }(),
      dateISO: function dateISO(a, b) {
        return this.optional(b) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(a);
      },
      number: function number(a, b) {
        return this.optional(b) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a);
      },
      digits: function digits(a, b) {
        return this.optional(b) || /^\d+$/.test(a);
      },
      minlength: function minlength(b, c, d) {
        var e = a.isArray(b) ? b.length : this.getLength(b, c);
        return this.optional(c) || e >= d;
      },
      maxlength: function maxlength(b, c, d) {
        var e = a.isArray(b) ? b.length : this.getLength(b, c);
        return this.optional(c) || e <= d;
      },
      rangelength: function rangelength(b, c, d) {
        var e = a.isArray(b) ? b.length : this.getLength(b, c);
        return this.optional(c) || e >= d[0] && e <= d[1];
      },
      min: function min(a, b, c) {
        return this.optional(b) || a >= c;
      },
      max: function max(a, b, c) {
        return this.optional(b) || a <= c;
      },
      range: function range(a, b, c) {
        return this.optional(b) || a >= c[0] && a <= c[1];
      },
      step: function step(b, c, d) {
        var e,
            f = a(c).attr("type"),
            g = "Step attribute on input type " + f + " is not supported.",
            h = ["text", "number", "range"],
            i = new RegExp("\\b" + f + "\\b"),
            j = f && !i.test(h.join()),
            k = function k(a) {
          var b = ("" + a).match(/(?:\.(\d+))?$/);
          return b && b[1] ? b[1].length : 0;
        },
            l = function l(a) {
          return Math.round(a * Math.pow(10, e));
        },
            m = !0;

        if (j) throw new Error(g);
        return e = k(d), (k(b) > e || l(b) % l(d) !== 0) && (m = !1), this.optional(c) || m;
      },
      equalTo: function equalTo(b, c, d) {
        var e = a(d);
        return this.settings.onfocusout && e.not(".validate-equalTo-blur").length && e.addClass("validate-equalTo-blur").on("blur.validate-equalTo", function () {
          a(c).valid();
        }), b === e.val();
      },
      remote: function remote(b, c, d, e) {
        if (this.optional(c)) return "dependency-mismatch";
        e = "string" == typeof e && e || "remote";
        var f,
            g,
            h,
            i = this.previousValue(c, e);
        return this.settings.messages[c.name] || (this.settings.messages[c.name] = {}), i.originalMessage = i.originalMessage || this.settings.messages[c.name][e], this.settings.messages[c.name][e] = i.message, d = "string" == typeof d && {
          url: d
        } || d, h = a.param(a.extend({
          data: b
        }, d.data)), i.old === h ? i.valid : (i.old = h, f = this, this.startRequest(c), g = {}, g[c.name] = b, a.ajax(a.extend(!0, {
          mode: "abort",
          port: "validate" + c.name,
          dataType: "json",
          data: g,
          context: f.currentForm,
          success: function success(a) {
            var d,
                g,
                h,
                j = a === !0 || "true" === a;
            f.settings.messages[c.name][e] = i.originalMessage, j ? (h = f.formSubmitted, f.resetInternals(), f.toHide = f.errorsFor(c), f.formSubmitted = h, f.successList.push(c), f.invalid[c.name] = !1, f.showErrors()) : (d = {}, g = a || f.defaultMessage(c, {
              method: e,
              parameters: b
            }), d[c.name] = i.message = g, f.invalid[c.name] = !0, f.showErrors(d)), i.valid = j, f.stopRequest(c, j);
          }
        }, d)), "pending");
      }
    }
  });
  var b,
      c = {};
  return a.ajaxPrefilter ? a.ajaxPrefilter(function (a, b, d) {
    var e = a.port;
    "abort" === a.mode && (c[e] && c[e].abort(), c[e] = d);
  }) : (b = a.ajax, a.ajax = function (d) {
    var e = ("mode" in d ? d : a.ajaxSettings).mode,
        f = ("port" in d ? d : a.ajaxSettings).port;
    return "abort" === e ? (c[f] && c[f].abort(), c[f] = b.apply(this, arguments), c[f]) : b.apply(this, arguments);
  }), a;
});
/*!
 * bootstrap-fileinput v4.5.1
 * http://plugins.krajee.com/file-input
 *
 * Author: Kartik Visweswaran
 * Copyright: 2014 - 2018, Kartik Visweswaran, Krajee.com
 *
 * Licensed under the BSD 3-Clause
 * https://github.com/kartik-v/bootstrap-fileinput/blob/master/LICENSE.md
 */

!function (e) {
  "use strict";

  "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(require("jquery")) : e(window.jQuery);
}(function (e) {
  "use strict";

  var t, i;
  e.fn.fileinputLocales = {}, e.fn.fileinputThemes = {}, String.prototype.setTokens = function (e) {
    var t,
        i,
        a = this.toString();

    for (t in e) {
      e.hasOwnProperty(t) && (i = new RegExp("{" + t + "}", "g"), a = a.replace(i, e[t]));
    }

    return a;
  }, t = {
    FRAMES: ".kv-preview-thumb",
    SORT_CSS: "file-sortable",
    OBJECT_PARAMS: '<param name="controller" value="true" />\n<param name="allowFullScreen" value="true" />\n<param name="allowScriptAccess" value="always" />\n<param name="autoPlay" value="false" />\n<param name="autoStart" value="false" />\n<param name="quality" value="high" />\n',
    DEFAULT_PREVIEW: '<div class="file-preview-other">\n<span class="{previewFileIconClass}">{previewFileIcon}</span>\n</div>',
    MODAL_ID: "kvFileinputModal",
    MODAL_EVENTS: ["show", "shown", "hide", "hidden", "loaded"],
    objUrl: window.URL || window.webkitURL,
    compare: function compare(e, t, i) {
      return void 0 !== e && (i ? e === t : e.match(t));
    },
    isIE: function isIE(e) {
      if ("Microsoft Internet Explorer" !== navigator.appName) return !1;
      if (10 === e) return new RegExp("msie\\s" + e, "i").test(navigator.userAgent);
      var t,
          i = document.createElement("div");
      return i.innerHTML = "\x3c!--[if IE " + e + "]> <i></i> <![endif]--\x3e", t = i.getElementsByTagName("i").length, document.body.appendChild(i), i.parentNode.removeChild(i), t;
    },
    canAssignFilesToInput: function canAssignFilesToInput() {
      var e = document.createElement("input");

      try {
        return e.type = "file", e.files = null, !0;
      } catch (e) {
        return !1;
      }
    },
    getDragDropFolders: function getDragDropFolders(e) {
      var t,
          i,
          a = e.length,
          r = 0;
      if (a > 0 && e[0].webkitGetAsEntry()) for (t = 0; t < a; t++) {
        (i = e[t].webkitGetAsEntry()) && i.isDirectory && r++;
      }
      return r;
    },
    initModal: function initModal(t) {
      var i = e("body");
      i.length && t.appendTo(i);
    },
    isEmpty: function isEmpty(t, i) {
      return null == t || 0 === t.length || i && "" === e.trim(t);
    },
    isArray: function isArray(e) {
      return Array.isArray(e) || "[object Array]" === Object.prototype.toString.call(e);
    },
    ifSet: function ifSet(e, t, i) {
      return i = i || "", t && "object" == _typeof2(t) && e in t ? t[e] : i;
    },
    cleanArray: function cleanArray(e) {
      return e instanceof Array || (e = []), e.filter(function (e) {
        return null != e;
      });
    },
    spliceArray: function spliceArray(t, i, a) {
      var r,
          n,
          s = 0,
          o = [];
      if (!(t instanceof Array)) return [];

      for (n = e.extend(!0, [], t), a && n.reverse(), r = 0; r < n.length; r++) {
        r !== i && (o[s] = n[r], s++);
      }

      return a && o.reverse(), o;
    },
    getNum: function getNum(e, t) {
      return t = t || 0, "number" == typeof e ? e : ("string" == typeof e && (e = parseFloat(e)), isNaN(e) ? t : e);
    },
    hasFileAPISupport: function hasFileAPISupport() {
      return !(!window.File || !window.FileReader);
    },
    hasDragDropSupport: function hasDragDropSupport() {
      var e = document.createElement("div");
      return !t.isIE(9) && (void 0 !== e.draggable || void 0 !== e.ondragstart && void 0 !== e.ondrop);
    },
    hasFileUploadSupport: function hasFileUploadSupport() {
      return t.hasFileAPISupport() && window.FormData;
    },
    hasBlobSupport: function hasBlobSupport() {
      try {
        return !!window.Blob && Boolean(new Blob());
      } catch (e) {
        return !1;
      }
    },
    hasArrayBufferViewSupport: function hasArrayBufferViewSupport() {
      try {
        return 100 === new Blob([new Uint8Array(100)]).size;
      } catch (e) {
        return !1;
      }
    },
    dataURI2Blob: function dataURI2Blob(e) {
      var i,
          a,
          r,
          n,
          s,
          o,
          l = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder,
          d = t.hasBlobSupport();
      if (!((d || l) && window.atob && window.ArrayBuffer && window.Uint8Array)) return null;

      for (i = e.split(",")[0].indexOf("base64") >= 0 ? atob(e.split(",")[1]) : decodeURIComponent(e.split(",")[1]), a = new ArrayBuffer(i.length), r = new Uint8Array(a), n = 0; n < i.length; n += 1) {
        r[n] = i.charCodeAt(n);
      }

      return s = e.split(",")[0].split(":")[1].split(";")[0], d ? new Blob([t.hasArrayBufferViewSupport() ? r : a], {
        type: s
      }) : ((o = new l()).append(a), o.getBlob(s));
    },
    arrayBuffer2String: function arrayBuffer2String(e) {
      if (window.TextDecoder) return new TextDecoder("utf-8").decode(e);
      var t,
          i,
          a,
          r,
          n = Array.prototype.slice.apply(new Uint8Array(e)),
          s = "",
          o = 0;

      for (t = n.length; o < t;) {
        switch ((i = n[o++]) >> 4) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
            s += String.fromCharCode(i);
            break;

          case 12:
          case 13:
            a = n[o++], s += String.fromCharCode((31 & i) << 6 | 63 & a);
            break;

          case 14:
            a = n[o++], r = n[o++], s += String.fromCharCode((15 & i) << 12 | (63 & a) << 6 | (63 & r) << 0);
        }
      }

      return s;
    },
    isHtml: function isHtml(e) {
      var t = document.createElement("div");
      t.innerHTML = e;

      for (var i = t.childNodes, a = i.length; a--;) {
        if (1 === i[a].nodeType) return !0;
      }

      return !1;
    },
    isSvg: function isSvg(e) {
      return e.match(/^\s*<\?xml/i) && (e.match(/<!DOCTYPE svg/i) || e.match(/<svg/i));
    },
    getMimeType: function getMimeType(e, t, i) {
      switch (e) {
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
          return "image/jpeg";

        case "89504E47":
          return "image/png";

        case "47494638":
          return "image/gif";

        case "49492a00":
          return "image/tiff";

        case "52494646":
          return "image/webp";

        case "66747970":
          return "video/3gp";

        case "4f676753":
          return "video/ogg";

        case "1a45dfa3":
          return "video/mkv";

        case "000001ba":
        case "000001b3":
          return "video/mpeg";

        case "3026b275":
          return "video/wmv";

        case "25504446":
          return "application/pdf";

        case "25215053":
          return "application/ps";

        case "504b0304":
        case "504b0506":
        case "504b0508":
          return "application/zip";

        case "377abcaf":
          return "application/7z";

        case "75737461":
          return "application/tar";

        case "7801730d":
          return "application/dmg";

        default:
          switch (e.substring(0, 6)) {
            case "435753":
              return "application/x-shockwave-flash";

            case "494433":
              return "audio/mp3";

            case "425a68":
              return "application/bzip";

            default:
              switch (e.substring(0, 4)) {
                case "424d":
                  return "image/bmp";

                case "fffb":
                  return "audio/mp3";

                case "4d5a":
                  return "application/exe";

                case "1f9d":
                case "1fa0":
                  return "application/zip";

                case "1f8b":
                  return "application/gzip";

                default:
                  return t && !t.match(/[^\u0000-\u007f]/) ? "application/text-plain" : i;
              }

          }

      }
    },
    addCss: function addCss(e, t) {
      e.removeClass(t).addClass(t);
    },
    getElement: function getElement(i, a, r) {
      return t.isEmpty(i) || t.isEmpty(i[a]) ? r : e(i[a]);
    },
    uniqId: function uniqId() {
      return Math.round(new Date().getTime()) + "_" + Math.round(100 * Math.random());
    },
    htmlEncode: function htmlEncode(e, t) {
      return void 0 === e ? t || null : e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    },
    replaceTags: function replaceTags(t, i) {
      var a = t;
      return i ? (e.each(i, function (e, t) {
        "function" == typeof t && (t = t()), a = a.split(e).join(t);
      }), a) : a;
    },
    cleanMemory: function cleanMemory(e) {
      var i = e.is("img") ? e.attr("src") : e.find("source").attr("src");
      t.objUrl.revokeObjectURL(i);
    },
    findFileName: function findFileName(e) {
      var t = e.lastIndexOf("/");
      return -1 === t && (t = e.lastIndexOf("\\")), e.split(e.substring(t, t + 1)).pop();
    },
    checkFullScreen: function checkFullScreen() {
      return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
    },
    toggleFullScreen: function toggleFullScreen(e) {
      var i = document,
          a = i.documentElement;
      a && e && !t.checkFullScreen() ? a.requestFullscreen ? a.requestFullscreen() : a.msRequestFullscreen ? a.msRequestFullscreen() : a.mozRequestFullScreen ? a.mozRequestFullScreen() : a.webkitRequestFullscreen && a.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT) : i.exitFullscreen ? i.exitFullscreen() : i.msExitFullscreen ? i.msExitFullscreen() : i.mozCancelFullScreen ? i.mozCancelFullScreen() : i.webkitExitFullscreen && i.webkitExitFullscreen();
    },
    moveArray: function moveArray(t, i, a, r) {
      var n = e.extend(!0, [], t);
      if (r && n.reverse(), a >= n.length) for (var s = a - n.length; 1 + s--;) {
        n.push(void 0);
      }
      return n.splice(a, 0, n.splice(i, 1)[0]), r && n.reverse(), n;
    },
    cleanZoomCache: function cleanZoomCache(e) {
      var t = e.closest(".kv-zoom-cache-theme");
      t.length || (t = e.closest(".kv-zoom-cache")), t.remove();
    },
    closeButton: function closeButton(e) {
      return '<button type="button" class="' + (e = e ? "close " + e : "close") + '" aria-label="Close">\n  <span aria-hidden="true">&times;</span>\n</button>';
    },
    getRotation: function getRotation(e) {
      switch (e) {
        case 2:
          return "rotateY(180deg)";

        case 3:
          return "rotate(180deg)";

        case 4:
          return "rotate(180deg) rotateY(180deg)";

        case 5:
          return "rotate(270deg) rotateY(180deg)";

        case 6:
          return "rotate(90deg)";

        case 7:
          return "rotate(90deg) rotateY(180deg)";

        case 8:
          return "rotate(270deg)";

        default:
          return "";
      }
    },
    setTransform: function setTransform(e, t) {
      e && (e.style.transform = t, e.style.webkitTransform = t, e.style["-moz-transform"] = t, e.style["-ms-transform"] = t, e.style["-o-transform"] = t);
    },
    setImageOrientation: function setImageOrientation(e, i, a) {
      if (e && e.length) {
        var r = "load.fileinputimageorient";
        e.off(r).on(r, function () {
          var r = e.get(0),
              n = i && i.length ? i.get(0) : null,
              s = r.offsetHeight,
              o = r.offsetWidth,
              l = t.getRotation(a);
          if (e.data("orientation", a), n && i.data("orientation", a), a < 5) return t.setTransform(r, l), void t.setTransform(n, l);
          var d = Math.atan(o / s),
              c = Math.sqrt(Math.pow(s, 2) + Math.pow(o, 2)),
              h = c ? s / Math.cos(Math.PI / 2 + d) / c : 1,
              p = " scale(" + Math.abs(h) + ")";
          t.setTransform(r, l + p), t.setTransform(n, l + p);
        });
      }
    }
  }, (i = function i(_i17, a) {
    this.$element = e(_i17), this.$parent = this.$element.parent(), this._validate() && (this.isPreviewable = t.hasFileAPISupport(), this.isIE9 = t.isIE(9), this.isIE10 = t.isIE(10), (this.isPreviewable || this.isIE9) && (this._init(a), this._listen()), this.$element.removeClass("file-loading"));
  }).prototype = {
    constructor: i,
    _cleanup: function _cleanup() {
      this.reader = null, this.formdata = {}, this.uploadCount = 0, this.uploadStatus = {}, this.uploadLog = [], this.uploadAsyncCount = 0, this.loadedImages = [], this.totalImagesCount = 0, this.ajaxRequests = [], this.clearStack(), this.fileBatchCompleted = !0, this.isPreviewable || (this.showPreview = !1), this.isError = !1, this.ajaxAborted = !1, this.cancelling = !1;
    },
    _init: function _init(i, a) {
      var r,
          n,
          s,
          o,
          l = this,
          d = l.$element;
      l.options = i, e.each(i, function (e, i) {
        switch (e) {
          case "minFileCount":
          case "maxFileCount":
          case "minFileSize":
          case "maxFileSize":
          case "maxFilePreviewSize":
          case "resizeImageQuality":
          case "resizeIfSizeMoreThan":
          case "progressUploadThreshold":
          case "initialPreviewCount":
          case "zoomModalHeight":
          case "minImageHeight":
          case "maxImageHeight":
          case "minImageWidth":
          case "maxImageWidth":
            l[e] = t.getNum(i);
            break;

          default:
            l[e] = i;
        }
      }), l.rtl && (o = l.previewZoomButtonIcons.prev, l.previewZoomButtonIcons.prev = l.previewZoomButtonIcons.next, l.previewZoomButtonIcons.next = o), a || l._cleanup(), l.$form = d.closest("form"), l._initTemplateDefaults(), l.uploadFileAttr = t.isEmpty(d.attr("name")) ? "file_data" : d.attr("name"), s = l._getLayoutTemplate("progress"), l.progressTemplate = s.replace("{class}", l.progressClass), l.progressCompleteTemplate = s.replace("{class}", l.progressCompleteClass), l.progressErrorTemplate = s.replace("{class}", l.progressErrorClass), l.isDisabled = d.attr("disabled") || d.attr("readonly"), l.isDisabled && d.attr("disabled", !0), l.isClickable = l.browseOnZoneClick && l.showPreview && (l.dropZoneEnabled || !t.isEmpty(l.defaultPreviewContent)), l.isAjaxUpload = t.hasFileUploadSupport() && !t.isEmpty(l.uploadUrl), l.dropZoneEnabled = t.hasDragDropSupport() && l.dropZoneEnabled, l.isAjaxUpload || (l.dropZoneEnabled = l.dropZoneEnabled && t.canAssignFilesToInput()), l.slug = "function" == typeof i.slugCallback ? i.slugCallback : l._slugDefault, l.mainTemplate = l.showCaption ? l._getLayoutTemplate("main1") : l._getLayoutTemplate("main2"), l.captionTemplate = l._getLayoutTemplate("caption"), l.previewGenericTemplate = l._getPreviewTemplate("generic"), !l.imageCanvas && l.resizeImage && (l.maxImageWidth || l.maxImageHeight) && (l.imageCanvas = document.createElement("canvas"), l.imageCanvasContext = l.imageCanvas.getContext("2d")), t.isEmpty(d.attr("id")) && d.attr("id", t.uniqId()), l.namespace = ".fileinput_" + d.attr("id").replace(/-/g, "_"), void 0 === l.$container ? l.$container = l._createContainer() : l._refreshContainer(), n = l.$container, l.$dropZone = n.find(".file-drop-zone"), l.$progress = n.find(".kv-upload-progress"), l.$btnUpload = n.find(".fileinput-upload"), l.$captionContainer = t.getElement(i, "elCaptionContainer", n.find(".file-caption")), l.$caption = t.getElement(i, "elCaptionText", n.find(".file-caption-name")), t.isEmpty(l.msgPlaceholder) || (r = d.attr("multiple") ? l.filePlural : l.fileSingle, l.$caption.attr("placeholder", l.msgPlaceholder.replace("{files}", r))), l.$captionIcon = l.$captionContainer.find(".file-caption-icon"), l.$previewContainer = t.getElement(i, "elPreviewContainer", n.find(".file-preview")), l.$preview = t.getElement(i, "elPreviewImage", n.find(".file-preview-thumbnails")), l.$previewStatus = t.getElement(i, "elPreviewStatus", n.find(".file-preview-status")), l.$errorContainer = t.getElement(i, "elErrorContainer", l.$previewContainer.find(".kv-fileinput-error")), l._validateDisabled(), t.isEmpty(l.msgErrorClass) || t.addCss(l.$errorContainer, l.msgErrorClass), a ? l._errorsExist() || l.$errorContainer.hide() : (l.$errorContainer.hide(), l.previewInitId = "preview-" + t.uniqId(), l._initPreviewCache(), l._initPreview(!0), l._initPreviewActions(), l.$parent.hasClass("file-loading") && (l.$container.insertBefore(l.$parent), l.$parent.remove())), l._setFileDropZoneTitle(), d.attr("disabled") && l.disable(), l._initZoom(), l.hideThumbnailContent && t.addCss(l.$preview, "hide-content");
    },
    _initTemplateDefaults: function _initTemplateDefaults() {
      var i,
          a,
          r,
          n,
          s,
          o,
          l,
          d,
          c,
          h = this;
      i = t.closeButton("fileinput-remove"), a = '<div id="' + t.MODAL_ID + '" class="file-zoom-dialog modal fade" tabindex="-1" aria-labelledby="' + t.MODAL_ID + 'Label"></div>', r = '<div class="file-preview-frame {frameClass}" id="{previewId}" data-fileindex="{fileindex}" data-template="{template}"', n = '<video class="kv-preview-data file-preview-video" controls {style}>\n<source src="{data}" type="{type}">\n' + t.DEFAULT_PREVIEW + "\n</video>\n", s = '\x3c!--suppress ALL --\x3e<audio class="kv-preview-data file-preview-audio" controls {style}>\n<source src="{data}" type="{type}">\n' + t.DEFAULT_PREVIEW + "\n</audio>\n", l = '<embed class="kv-preview-data file-preview-pdf" src="{data}" type="application/pdf" {style}>\n', o = '<object class="kv-preview-data file-preview-object file-object {typeCss}" data="{data}" type="{type}" {style}>\n<param name="movie" value="{caption}" />\n' + t.OBJECT_PARAMS + " " + t.DEFAULT_PREVIEW + "\n</object>\n", d = '<div class="kv-preview-data file-preview-other-frame" {style}>\n' + t.DEFAULT_PREVIEW + "\n</div>\n", c = {
        width: "100%",
        height: "100%",
        "min-height": "480px"
      }, h._isPdfRendered() && (l = h.pdfRendererTemplate.replace("{renderer}", h.pdfRendererUrl)), h.defaults = {
        layoutTemplates: {
          main1: '{preview}\n<div class="kv-upload-progress kv-hidden"></div><div class="clearfix"></div>\n<div class="input-group {class}">\n  {caption}\n<div class="input-group-btn input-group-append">\n      {remove}\n      {cancel}\n      {upload}\n      {browse}\n    </div>\n</div>',
          main2: '{preview}\n<div class="kv-upload-progress kv-hidden"></div>\n<div class="clearfix"></div>\n{remove}\n{cancel}\n{upload}\n{browse}\n',
          preview: '<div class="file-preview {class}">\n    {close}    <div class="{dropClass}">\n    <div class="file-preview-thumbnails">\n    </div>\n    <div class="clearfix"></div>    <div class="file-preview-status text-center text-success"></div>\n    <div class="kv-fileinput-error"></div>\n    </div>\n</div>',
          close: i,
          fileIcon: '<i class="glyphicon glyphicon-file"></i>',
          caption: '<div class="file-caption form-control {class}" tabindex="500">\n  <span class="file-caption-icon"></span>\n  <input class="file-caption-name" onkeydown="return false;" onpaste="return false;">\n</div>',
          modalMain: a,
          modal: '<div class="modal-dialog modal-lg{rtl}" role="document">\n  <div class="modal-content">\n    <div class="modal-header">\n      <h5 class="modal-title">{heading}</h5>\n      <span class="kv-zoom-title"></span>\n      <div class="kv-zoom-actions">{toggleheader}{fullscreen}{borderless}{close}</div>\n    </div>\n    <div class="modal-body">\n      <div class="floating-buttons"></div>\n      <div class="kv-zoom-body file-zoom-content {zoomFrameClass}"></div>\n{prev} {next}\n    </div>\n  </div>\n</div>\n',
          progress: '<div class="progress">\n    <div class="{class}" role="progressbar" aria-valuenow="{percent}" aria-valuemin="0" aria-valuemax="100" style="width:{percent}%;">\n        {status}\n     </div>\n</div>',
          size: " <samp>({sizeText})</samp>",
          footer: '<div class="file-thumbnail-footer">\n    <div class="file-footer-caption" title="{caption}">\n        <div class="file-caption-info">{caption}</div>\n        <div class="file-size-info">{size}</div>\n    </div>\n    {progress}\n{indicator}\n{actions}\n</div>',
          indicator: '<div class="file-upload-indicator" title="{indicatorTitle}">{indicator}</div>',
          actions: '<div class="file-actions">\n    <div class="file-footer-buttons">\n        {download} {upload} {delete} {zoom} {other}    </div>\n</div>\n{drag}\n<div class="clearfix"></div>',
          actionDelete: '<button type="button" class="kv-file-remove {removeClass}" title="{removeTitle}" {dataUrl}{dataKey}>{removeIcon}</button>\n',
          actionUpload: '<button type="button" class="kv-file-upload {uploadClass}" title="{uploadTitle}">{uploadIcon}</button>',
          actionDownload: '<a class="kv-file-download {downloadClass}" title="{downloadTitle}" href="{downloadUrl}" download="{caption}" target="_blank">{downloadIcon}</a>',
          actionZoom: '<button type="button" class="kv-file-zoom {zoomClass}" title="{zoomTitle}">{zoomIcon}</button>',
          actionDrag: '<span class="file-drag-handle {dragClass}" title="{dragTitle}">{dragIcon}</span>',
          btnDefault: '<button type="{type}" tabindex="500" title="{title}" class="{css}" {status}>{icon} {label}</button>',
          btnLink: '<a href="{href}" tabindex="500" title="{title}" class="{css}" {status}>{icon} {label}</a>',
          btnBrowse: '<div tabindex="500" class="{css}" {status}>{icon} {label}</div>',
          zoomCache: '<div class="kv-zoom-cache" style="display:none">{zoomContent}</div>'
        },
        previewMarkupTags: {
          tagBefore1: '<div class="file-preview-frame {frameClass}" id="{previewId}" data-fileindex="{fileindex}" data-template="{template}"><div class="kv-file-content">\n',
          tagBefore2: '<div class="file-preview-frame {frameClass}" id="{previewId}" data-fileindex="{fileindex}" data-template="{template}" title="{caption}"><div class="kv-file-content">\n',
          tagAfter: "</div>{footer}\n</div>\n"
        },
        previewContentTemplates: {
          generic: "{content}\n",
          html: '<div class="kv-preview-data file-preview-html" title="{caption}" {style}>{data}</div>\n',
          image: '<img src="{data}" class="file-preview-image kv-preview-data" title="{caption}" alt="{caption}" {style}>\n',
          text: '<textarea class="kv-preview-data file-preview-text" title="{caption}" readonly {style}>{data}</textarea>\n',
          office: '<iframe class="kv-preview-data file-preview-office" src="https://view.officeapps.live.com/op/embed.aspx?src={data}" {style}></iframe>',
          gdocs: '<iframe class="kv-preview-data file-preview-gdocs" src="https://docs.google.com/gview?url={data}&embedded=true" {style}></iframe>',
          video: n,
          audio: s,
          flash: '<embed class="kv-preview-data file-preview-flash" src="{data}" type="application/x-shockwave-flash" {style}>\n',
          object: o,
          pdf: l,
          other: d
        },
        allowedPreviewTypes: ["image", "html", "text", "video", "audio", "flash", "pdf", "object"],
        previewTemplates: {},
        previewSettings: {
          image: {
            width: "auto",
            height: "auto",
            "max-width": "100%",
            "max-height": "100%"
          },
          html: {
            width: "213px",
            height: "160px"
          },
          text: {
            width: "213px",
            height: "160px"
          },
          office: {
            width: "213px",
            height: "160px"
          },
          gdocs: {
            width: "213px",
            height: "160px"
          },
          video: {
            width: "213px",
            height: "160px"
          },
          audio: {
            width: "100%",
            height: "30px"
          },
          flash: {
            width: "213px",
            height: "160px"
          },
          object: {
            width: "213px",
            height: "160px"
          },
          pdf: {
            width: "100%",
            height: "160px"
          },
          other: {
            width: "213px",
            height: "160px"
          }
        },
        previewSettingsSmall: {
          image: {
            width: "auto",
            height: "auto",
            "max-width": "100%",
            "max-height": "100%"
          },
          html: {
            width: "100%",
            height: "160px"
          },
          text: {
            width: "100%",
            height: "160px"
          },
          office: {
            width: "100%",
            height: "160px"
          },
          gdocs: {
            width: "100%",
            height: "160px"
          },
          video: {
            width: "100%",
            height: "auto"
          },
          audio: {
            width: "100%",
            height: "30px"
          },
          flash: {
            width: "100%",
            height: "auto"
          },
          object: {
            width: "100%",
            height: "auto"
          },
          pdf: {
            width: "100%",
            height: "160px"
          },
          other: {
            width: "100%",
            height: "160px"
          }
        },
        previewZoomSettings: {
          image: {
            width: "auto",
            height: "auto",
            "max-width": "100%",
            "max-height": "100%"
          },
          html: c,
          text: c,
          office: {
            width: "100%",
            height: "100%",
            "max-width": "100%",
            "min-height": "480px"
          },
          gdocs: {
            width: "100%",
            height: "100%",
            "max-width": "100%",
            "min-height": "480px"
          },
          video: {
            width: "auto",
            height: "100%",
            "max-width": "100%"
          },
          audio: {
            width: "100%",
            height: "30px"
          },
          flash: {
            width: "auto",
            height: "480px"
          },
          object: {
            width: "auto",
            height: "100%",
            "max-width": "100%",
            "min-height": "480px"
          },
          pdf: c,
          other: {
            width: "auto",
            height: "100%",
            "min-height": "480px"
          }
        },
        fileTypeSettings: {
          image: function image(e, i) {
            return t.compare(e, "image.*") && !t.compare(e, /(tiff?|wmf)$/i) || t.compare(i, /\.(gif|png|jpe?g)$/i);
          },
          html: function html(e, i) {
            return t.compare(e, "text/html") || t.compare(i, /\.(htm|html)$/i);
          },
          office: function office(e, i) {
            return t.compare(e, /(word|excel|powerpoint|office)$/i) || t.compare(i, /\.(docx?|xlsx?|pptx?|pps|potx?)$/i);
          },
          gdocs: function gdocs(e, i) {
            return t.compare(e, /(word|excel|powerpoint|office|iwork-pages|tiff?)$/i) || t.compare(i, /\.(docx?|xlsx?|pptx?|pps|potx?|rtf|ods|odt|pages|ai|dxf|ttf|tiff?|wmf|e?ps)$/i);
          },
          text: function text(e, i) {
            return t.compare(e, "text.*") || t.compare(i, /\.(xml|javascript)$/i) || t.compare(i, /\.(txt|md|csv|nfo|ini|json|php|js|css)$/i);
          },
          video: function video(e, i) {
            return t.compare(e, "video.*") && (t.compare(e, /(ogg|mp4|mp?g|mov|webm|3gp)$/i) || t.compare(i, /\.(og?|mp4|webm|mp?g|mov|3gp)$/i));
          },
          audio: function audio(e, i) {
            return t.compare(e, "audio.*") && (t.compare(i, /(ogg|mp3|mp?g|wav)$/i) || t.compare(i, /\.(og?|mp3|mp?g|wav)$/i));
          },
          flash: function flash(e, i) {
            return t.compare(e, "application/x-shockwave-flash", !0) || t.compare(i, /\.(swf)$/i);
          },
          pdf: function pdf(e, i) {
            return t.compare(e, "application/pdf", !0) || t.compare(i, /\.(pdf)$/i);
          },
          object: function object() {
            return !0;
          },
          other: function other() {
            return !0;
          }
        },
        fileActionSettings: {
          showRemove: !0,
          showUpload: !0,
          showDownload: !0,
          showZoom: !0,
          showDrag: !0,
          removeIcon: '<i class="glyphicon glyphicon-trash"></i>',
          removeClass: "btn btn-sm btn-kv btn-default btn-outline-secondary",
          removeErrorClass: "btn btn-sm btn-kv btn-danger",
          removeTitle: "Remove file",
          uploadIcon: '<i class="glyphicon glyphicon-upload"></i>',
          uploadClass: "btn btn-sm btn-kv btn-default btn-outline-secondary",
          uploadTitle: "Upload file",
          uploadRetryIcon: '<i class="glyphicon glyphicon-repeat"></i>',
          uploadRetryTitle: "Retry upload",
          downloadIcon: '<i class="glyphicon glyphicon-download"></i>',
          downloadClass: "btn btn-sm btn-kv btn-default btn-outline-secondary",
          downloadTitle: "Download file",
          zoomIcon: '<i class="glyphicon glyphicon-zoom-in"></i>',
          zoomClass: "btn btn-sm btn-kv btn-default btn-outline-secondary",
          zoomTitle: "View Details",
          dragIcon: '<i class="glyphicon glyphicon-move"></i>',
          dragClass: "text-info",
          dragTitle: "Move / Rearrange",
          dragSettings: {},
          indicatorNew: '<i class="glyphicon glyphicon-plus-sign text-warning"></i>',
          indicatorSuccess: '<i class="glyphicon glyphicon-ok-sign text-success"></i>',
          indicatorError: '<i class="glyphicon glyphicon-exclamation-sign text-danger"></i>',
          indicatorLoading: '<i class="glyphicon glyphicon-hourglass text-muted"></i>',
          indicatorNewTitle: "Not uploaded yet",
          indicatorSuccessTitle: "Uploaded",
          indicatorErrorTitle: "Upload Error",
          indicatorLoadingTitle: "Uploading ..."
        }
      }, e.each(h.defaults, function (t, i) {
        "allowedPreviewTypes" !== t ? h[t] = e.extend(!0, {}, i, h[t]) : void 0 === h.allowedPreviewTypes && (h.allowedPreviewTypes = i);
      }), h._initPreviewTemplates();
    },
    _initPreviewTemplates: function _initPreviewTemplates() {
      var i,
          a = this,
          r = a.previewMarkupTags,
          n = r.tagAfter;
      e.each(a.previewContentTemplates, function (e, s) {
        t.isEmpty(a.previewTemplates[e]) && (i = r.tagBefore2, "generic" !== e && "image" !== e && "html" !== e && "text" !== e || (i = r.tagBefore1), a._isPdfRendered() && "pdf" === e && (i = i.replace("kv-file-content", "kv-file-content kv-pdf-rendered")), a.previewTemplates[e] = i + s + n);
      });
    },
    _initPreviewCache: function _initPreviewCache() {
      var i = this;
      i.previewCache = {
        data: {},
        init: function init() {
          var e = i.initialPreview;
          e.length > 0 && !t.isArray(e) && (e = e.split(i.initialPreviewDelimiter)), i.previewCache.data = {
            content: e,
            config: i.initialPreviewConfig,
            tags: i.initialPreviewThumbTags
          };
        },
        count: function count() {
          return i.previewCache.data && i.previewCache.data.content ? i.previewCache.data.content.length : 0;
        },
        get: function get(a, r) {
          var n,
              s,
              o,
              l,
              d,
              c,
              h,
              p = "init_" + a,
              u = i.previewCache.data,
              f = u.config[a],
              m = u.content[a],
              g = i.previewInitId + "-" + p,
              v = t.ifSet("previewAsData", f, i.initialPreviewAsData),
              w = function w(e, a, r, n, s, o, l, d, c) {
            return d = " file-preview-initial " + t.SORT_CSS + (d ? " " + d : ""), i._generatePreviewTemplate(e, a, r, n, s, !1, null, d, o, l, c);
          };

          return m ? (r = void 0 === r || r, o = t.ifSet("type", f, i.initialPreviewFileType || "generic"), d = t.ifSet("filename", f, t.ifSet("caption", f)), c = t.ifSet("filetype", f, o), l = i.previewCache.footer(a, r, f && f.size || null), h = t.ifSet("frameClass", f), n = v ? w(o, m, d, c, g, l, p, h) : w("generic", m, d, c, g, l, p, h, o).setTokens({
            content: u.content[a]
          }), u.tags.length && u.tags[a] && (n = t.replaceTags(n, u.tags[a])), t.isEmpty(f) || t.isEmpty(f.frameAttr) || ((s = e(document.createElement("div")).html(n)).find(".file-preview-initial").attr(f.frameAttr), n = s.html(), s.remove()), n) : "";
        },
        add: function add(e, a, r, n) {
          var s,
              o = i.previewCache.data;
          return t.isArray(e) || (e = e.split(i.initialPreviewDelimiter)), n ? (s = o.content.push(e) - 1, o.config[s] = a, o.tags[s] = r) : (s = e.length - 1, o.content = e, o.config = a, o.tags = r), i.previewCache.data = o, s;
        },
        set: function set(e, a, r, n) {
          var s,
              o = i.previewCache.data;

          if (e && e.length && (t.isArray(e) || (e = e.split(i.initialPreviewDelimiter)), e.filter(function (e) {
            return null !== e;
          }).length)) {
            if (void 0 === o.content && (o.content = []), void 0 === o.config && (o.config = []), void 0 === o.tags && (o.tags = []), n) {
              for (s = 0; s < e.length; s++) {
                e[s] && o.content.push(e[s]);
              }

              for (s = 0; s < a.length; s++) {
                a[s] && o.config.push(a[s]);
              }

              for (s = 0; s < r.length; s++) {
                r[s] && o.tags.push(r[s]);
              }
            } else o.content = e, o.config = a, o.tags = r;

            i.previewCache.data = o;
          }
        },
        unset: function unset(e) {
          var a = i.previewCache.count(),
              r = i.reversePreviewOrder;

          if (a) {
            if (1 === a) return i.previewCache.data.content = [], i.previewCache.data.config = [], i.previewCache.data.tags = [], i.initialPreview = [], i.initialPreviewConfig = [], void (i.initialPreviewThumbTags = []);
            i.previewCache.data.content = t.spliceArray(i.previewCache.data.content, e, r), i.previewCache.data.config = t.spliceArray(i.previewCache.data.config, e, r), i.previewCache.data.tags = t.spliceArray(i.previewCache.data.tags, e, r);
          }
        },
        out: function out() {
          var e,
              t,
              a = "",
              r = i.previewCache.count();
          if (0 === r) return {
            content: "",
            caption: ""
          };

          for (e = 0; e < r; e++) {
            t = i.previewCache.get(e), a = i.reversePreviewOrder ? t + a : a + t;
          }

          return {
            content: a,
            caption: i._getMsgSelected(r)
          };
        },
        footer: function footer(e, a, r) {
          var n = i.previewCache.data || {};
          if (t.isEmpty(n.content)) return "";
          (t.isEmpty(n.config) || t.isEmpty(n.config[e])) && (n.config[e] = {}), a = void 0 === a || a;

          var s,
              o = n.config[e],
              l = t.ifSet("caption", o),
              d = t.ifSet("width", o, "auto"),
              c = t.ifSet("url", o, !1),
              h = t.ifSet("key", o, null),
              p = i.fileActionSettings,
              u = i.initialPreviewShowDelete || !1,
              f = o.downloadUrl || i.initialPreviewDownloadUrl || "",
              m = o.filename || o.caption || "",
              g = !!f,
              v = t.ifSet("showRemove", o, t.ifSet("showRemove", p, u)),
              w = t.ifSet("showDownload", o, t.ifSet("showDownload", p, g)),
              _ = t.ifSet("showZoom", o, t.ifSet("showZoom", p, !0)),
              b = t.ifSet("showDrag", o, t.ifSet("showDrag", p, !0)),
              C = !1 === c && a;

          return w = w && !1 !== o.downloadUrl && !!f, s = i._renderFileActions(!1, w, v, _, b, C, c, h, !0, f, m), i._getLayoutTemplate("footer").setTokens({
            progress: i._renderThumbProgress(),
            actions: s,
            caption: l,
            size: i._getSize(r),
            width: d,
            indicator: ""
          });
        }
      }, i.previewCache.init();
    },
    _isPdfRendered: function _isPdfRendered() {
      var e = this.usePdfRenderer;
      return ("function" == typeof e ? e() : !!e) && this.pdfRendererUrl;
    },
    _handler: function _handler(e, t, i) {
      var a = this.namespace,
          r = t.split(" ").join(a + " ") + a;
      e && e.length && e.off(r).on(r, i);
    },
    _log: function _log(e) {
      var t = this.$element.attr("id");
      t && (e = '"' + t + '": ' + e), e = "bootstrap-fileinput: " + e, void 0 !== window.console.log ? window.console.log(e) : window.alert(e);
    },
    _validate: function _validate() {
      var e = "file" === this.$element.attr("type");
      return e || this._log('The input "type" must be set to "file" for initializing the "bootstrap-fileinput" plugin.'), e;
    },
    _errorsExist: function _errorsExist() {
      var t;
      return !!this.$errorContainer.find("li").length || ((t = e(document.createElement("div")).html(this.$errorContainer.html())).find(".kv-error-close").remove(), t.find("ul").remove(), !!e.trim(t.text()).length);
    },
    _errorHandler: function _errorHandler(e, t) {
      var i = this,
          a = e.target.error,
          r = function r(e) {
        i._showError(e.replace("{name}", t));
      };

      a.code === a.NOT_FOUND_ERR ? r(i.msgFileNotFound) : a.code === a.SECURITY_ERR ? r(i.msgFileSecured) : a.code === a.NOT_READABLE_ERR ? r(i.msgFileNotReadable) : a.code === a.ABORT_ERR ? r(i.msgFilePreviewAborted) : r(i.msgFilePreviewError);
    },
    _addError: function _addError(e) {
      var t = this,
          i = t.$errorContainer;
      e && i.length && (i.html(t.errorCloseButton + e), t._handler(i.find(".kv-error-close"), "click", function () {
        setTimeout(function () {
          t.showPreview && !t.getFrames().length && t.clear(), i.fadeOut("slow");
        }, 10);
      }));
    },
    _setValidationError: function _setValidationError(e) {
      e = (e ? e + " " : "") + "has-error", this.$container.removeClass(e).addClass("has-error"), t.addCss(this.$captionContainer, "is-invalid");
    },
    _resetErrors: function _resetErrors(e) {
      var t = this.$errorContainer;
      this.isError = !1, this.$container.removeClass("has-error"), this.$captionContainer.removeClass("is-invalid"), t.html(""), e ? t.fadeOut("slow") : t.hide();
    },
    _showFolderError: function _showFolderError(e) {
      var t,
          i = this.$errorContainer;
      e && (this.isAjaxUpload || this._clearFileInput(), t = this.msgFoldersNotAllowed.replace("{n}", e), this._addError(t), this._setValidationError(), i.fadeIn(800), this._raise("filefoldererror", [e, t]));
    },
    _showUploadError: function _showUploadError(e, t, i) {
      var a = this.$errorContainer,
          r = i || "fileuploaderror",
          n = t && t.id ? '<li data-file-id="' + t.id + '">' + e + "</li>" : "<li>" + e + "</li>";
      return 0 === a.find("ul").length ? this._addError("<ul>" + n + "</ul>") : a.find("ul").append(n), a.fadeIn(800), this._raise(r, [t, e]), this._setValidationError("file-input-new"), !0;
    },
    _showError: function _showError(e, t, i) {
      var a = this.$errorContainer,
          r = i || "fileerror";
      return (t = t || {}).reader = this.reader, this._addError(e), a.fadeIn(800), this._raise(r, [t, e]), this.isAjaxUpload || this._clearFileInput(), this._setValidationError("file-input-new"), this.$btnUpload.attr("disabled", !0), !0;
    },
    _noFilesError: function _noFilesError(e) {
      var t = this.minFileCount > 1 ? this.filePlural : this.fileSingle,
          i = this.msgFilesTooLess.replace("{n}", this.minFileCount).replace("{files}", t),
          a = this.$errorContainer;
      this._addError(i), this.isError = !0, this._updateFileDetails(0), a.fadeIn(800), this._raise("fileerror", [e, i]), this._clearFileInput(), this._setValidationError();
    },
    _parseError: function _parseError(t, i, a, r) {
      var n,
          s = e.trim(a + ""),
          o = void 0 !== i.responseJSON && void 0 !== i.responseJSON.error ? i.responseJSON.error : i.responseText;
      return this.cancelling && this.msgUploadAborted && (s = this.msgUploadAborted), this.showAjaxErrorDetails && o && (n = (o = e.trim(o.replace(/\n\s*\n/g, "\n"))).length ? "<pre>" + o + "</pre>" : "", s += s ? n : o), s || (s = this.msgAjaxError.replace("{operation}", t)), this.cancelling = !1, r ? "<b>" + r + ": </b>" + s : s;
    },
    _parseFileType: function _parseFileType(e, i) {
      var a,
          r,
          n,
          s = this.allowedPreviewTypes || [];
      if ("application/text-plain" === e) return "text";

      for (n = 0; n < s.length; n++) {
        if (r = s[n], a = (0, this.fileTypeSettings[r])(e, i) ? r : "", !t.isEmpty(a)) return a;
      }

      return "other";
    },
    _getPreviewIcon: function _getPreviewIcon(t) {
      var i,
          a = this,
          r = null;
      return t && t.indexOf(".") > -1 && (i = t.split(".").pop(), a.previewFileIconSettings && (r = a.previewFileIconSettings[i] || a.previewFileIconSettings[i.toLowerCase()] || null), a.previewFileExtSettings && e.each(a.previewFileExtSettings, function (e, t) {
        a.previewFileIconSettings[e] && t(i) && (r = a.previewFileIconSettings[e]);
      })), r;
    },
    _parseFilePreviewIcon: function _parseFilePreviewIcon(e, t) {
      var i = this._getPreviewIcon(t) || this.previewFileIcon,
          a = e;
      return a.indexOf("{previewFileIcon}") > -1 && (a = a.setTokens({
        previewFileIconClass: this.previewFileIconClass,
        previewFileIcon: i
      })), a;
    },
    _raise: function _raise(t, i) {
      var a = e.Event(t);
      if (void 0 !== i ? this.$element.trigger(a, i) : this.$element.trigger(a), a.isDefaultPrevented() || !1 === a.result) return !1;

      switch (t) {
        case "filebatchuploadcomplete":
        case "filebatchuploadsuccess":
        case "fileuploaded":
        case "fileclear":
        case "filecleared":
        case "filereset":
        case "fileerror":
        case "filefoldererror":
        case "fileuploaderror":
        case "filebatchuploaderror":
        case "filedeleteerror":
        case "filecustomerror":
        case "filesuccessremove":
          break;

        default:
          this.ajaxAborted || (this.ajaxAborted = a.result);
      }

      return !0;
    },
    _listenFullScreen: function _listenFullScreen(e) {
      var t,
          i,
          a = this.$modal;
      a && a.length && (t = a && a.find(".btn-fullscreen"), i = a && a.find(".btn-borderless"), t.length && i.length && (t.removeClass("active").attr("aria-pressed", "false"), i.removeClass("active").attr("aria-pressed", "false"), e ? t.addClass("active").attr("aria-pressed", "true") : i.addClass("active").attr("aria-pressed", "true"), a.hasClass("file-zoom-fullscreen") ? this._maximizeZoomDialog() : e ? this._maximizeZoomDialog() : i.removeClass("active").attr("aria-pressed", "false")));
    },
    _listen: function _listen() {
      var i = this,
          a = i.$element,
          r = i.$form,
          n = i.$container;
      i._handler(a, "click", function (e) {
        a.hasClass("file-no-browse") && (a.data("zoneClicked") ? a.data("zoneClicked", !1) : e.preventDefault());
      }), i._handler(a, "change", e.proxy(i._change, i)), i.showBrowse && i._handler(i.$btnFile, "click", e.proxy(i._browse, i)), i._handler(n.find(".fileinput-remove:not([disabled])"), "click", e.proxy(i.clear, i)), i._handler(n.find(".fileinput-cancel"), "click", e.proxy(i.cancel, i)), i._initDragDrop(), i._handler(r, "reset", e.proxy(i.clear, i)), i.isAjaxUpload || i._handler(r, "submit", e.proxy(i._submitForm, i)), i._handler(i.$container.find(".fileinput-upload"), "click", e.proxy(i._uploadClick, i)), i._handler(e(window), "resize", function () {
        i._listenFullScreen(screen.width === window.innerWidth && screen.height === window.innerHeight);
      }), i._handler(e(document), "webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange", function () {
        i._listenFullScreen(t.checkFullScreen());
      }), i._autoFitContent(), i._initClickable(), i._refreshPreview();
    },
    _autoFitContent: function _autoFitContent() {
      var t,
          i = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
          a = this,
          r = i < 400 ? a.previewSettingsSmall || a.defaults.previewSettingsSmall : a.previewSettings || a.defaults.previewSettings;
      e.each(r, function (e, i) {
        t = ".file-preview-frame .file-preview-" + e, a.$preview.find(t + ".kv-preview-data," + t + " .kv-preview-data").css(i);
      });
    },
    _scanDroppedItems: function _scanDroppedItems(e, t, i) {
      i = i || "";

      var a,
          r,
          _n2,
          s = this,
          o = function o(e) {
        s._log("Error scanning dropped files!"), s._log(e);
      };

      e.isFile ? e.file(function (e) {
        t.push(e);
      }, o) : e.isDirectory && (r = e.createReader(), (_n2 = function n() {
        r.readEntries(function (r) {
          if (r && r.length > 0) {
            for (a = 0; a < r.length; a++) {
              s._scanDroppedItems(r[a], t, i + e.name + "/");
            }

            _n2();
          }

          return null;
        }, o);
      })());
    },
    _initDragDrop: function _initDragDrop() {
      var t = this.$dropZone;
      this.dropZoneEnabled && this.showPreview && (this._handler(t, "dragenter dragover", e.proxy(this._zoneDragEnter, this)), this._handler(t, "dragleave", e.proxy(this._zoneDragLeave, this)), this._handler(t, "drop", e.proxy(this._zoneDrop, this)), this._handler(e(document), "dragenter dragover drop", this._zoneDragDropInit));
    },
    _zoneDragDropInit: function _zoneDragDropInit(e) {
      e.stopPropagation(), e.preventDefault();
    },
    _zoneDragEnter: function _zoneDragEnter(i) {
      var a = e.inArray("Files", i.originalEvent.dataTransfer.types) > -1;
      if (this._zoneDragDropInit(i), this.isDisabled || !a) return i.originalEvent.dataTransfer.effectAllowed = "none", void (i.originalEvent.dataTransfer.dropEffect = "none");
      t.addCss(this.$dropZone, "file-highlighted");
    },
    _zoneDragLeave: function _zoneDragLeave(e) {
      this._zoneDragDropInit(e), this.isDisabled || this.$dropZone.removeClass("file-highlighted");
    },
    _zoneDrop: function _zoneDrop(e) {
      var i,
          a = this,
          r = a.$element,
          n = e.originalEvent.dataTransfer,
          s = n.files,
          o = n.items,
          l = t.getDragDropFolders(o),
          d = function d() {
        a.isAjaxUpload ? a._change(e, s) : (a.changeTriggered = !0, r.get(0).files = s, setTimeout(function () {
          a.changeTriggered = !1, r.trigger("change" + a.namespace);
        }, 10)), a.$dropZone.removeClass("file-highlighted");
      };

      if (e.preventDefault(), !a.isDisabled && !t.isEmpty(s)) if (l > 0) {
        if (!a.isAjaxUpload) return void a._showFolderError(l);

        for (s = [], i = 0; i < o.length; i++) {
          var c = o[i].webkitGetAsEntry();
          c && a._scanDroppedItems(c, s);
        }

        setTimeout(function () {
          d();
        }, 500);
      } else d();
    },
    _uploadClick: function _uploadClick(e) {
      var i,
          a = this.$container.find(".fileinput-upload"),
          r = !a.hasClass("disabled") && t.isEmpty(a.attr("disabled"));
      e && e.isDefaultPrevented() || (this.isAjaxUpload ? (e.preventDefault(), r && this.upload()) : r && "submit" !== a.attr("type") && ((i = a.closest("form")).length && i.trigger("submit"), e.preventDefault()));
    },
    _submitForm: function _submitForm() {
      return this._isFileSelectionValid() && !this._abort({});
    },
    _clearPreview: function _clearPreview() {
      var i = this.$preview;
      (this.showUploadedThumbs ? this.getFrames(":not(.file-preview-success)") : this.getFrames()).each(function () {
        var a = e(this);
        a.remove(), t.cleanZoomCache(i.find("#zoom-" + a.attr("id")));
      }), this.getFrames().length && this.showPreview || this._resetUpload(), this._validateDefaultPreview();
    },
    _initSortable: function _initSortable() {
      var i,
          a = this,
          r = a.$preview,
          n = "." + t.SORT_CSS,
          s = a.reversePreviewOrder;
      window.KvSortable && 0 !== r.find(n).length && (i = {
        handle: ".drag-handle-init",
        dataIdAttr: "data-preview-id",
        scroll: !1,
        draggable: n,
        onSort: function onSort(i) {
          var r = i.oldIndex,
              n = i.newIndex,
              o = 0;
          a.initialPreview = t.moveArray(a.initialPreview, r, n, s), a.initialPreviewConfig = t.moveArray(a.initialPreviewConfig, r, n, s), a.previewCache.init(), a.getFrames(".file-preview-initial").each(function () {
            e(this).attr("data-fileindex", "init_" + o), o++;
          }), a._raise("filesorted", {
            previewId: e(i.item).attr("id"),
            oldIndex: r,
            newIndex: n,
            stack: a.initialPreviewConfig
          });
        }
      }, r.data("kvsortable") && r.kvsortable("destroy"), e.extend(!0, i, a.fileActionSettings.dragSettings), r.kvsortable(i));
    },
    _setPreviewContent: function _setPreviewContent(e) {
      this.$preview.html(e), this._autoFitContent();
    },
    _initPreview: function _initPreview(e) {
      var i,
          a = this.initialCaption || "";
      if (!this.previewCache.count()) return this._clearPreview(), void (e ? this._setCaption(a) : this._initCaption());
      i = this.previewCache.out(), a = e && this.initialCaption ? this.initialCaption : i.caption, this._setPreviewContent(i.content), this._setInitThumbAttr(), this._setCaption(a), this._initSortable(), t.isEmpty(i.content) || this.$container.removeClass("file-input-new");
    },
    _getZoomButton: function _getZoomButton(e) {
      var t = this.previewZoomButtonIcons[e],
          i = this.previewZoomButtonClasses[e],
          a = ' title="' + (this.previewZoomButtonTitles[e] || "") + '" ' + ("close" === e ? ' data-dismiss="modal" aria-hidden="true"' : "");
      return "fullscreen" !== e && "borderless" !== e && "toggleheader" !== e || (a += ' data-toggle="button" aria-pressed="false" autocomplete="off"'), '<button type="button" class="' + i + " btn-" + e + '"' + a + ">" + t + "</button>";
    },
    _getModalContent: function _getModalContent() {
      return this._getLayoutTemplate("modal").setTokens({
        rtl: this.rtl ? " kv-rtl" : "",
        zoomFrameClass: this.frameClass,
        heading: this.msgZoomModalHeading,
        prev: this._getZoomButton("prev"),
        next: this._getZoomButton("next"),
        toggleheader: this._getZoomButton("toggleheader"),
        fullscreen: this._getZoomButton("fullscreen"),
        borderless: this._getZoomButton("borderless"),
        close: this._getZoomButton("close")
      });
    },
    _listenModalEvent: function _listenModalEvent(e) {
      var i = this,
          a = i.$modal;
      a.on(e + ".bs.modal", function (r) {
        var n = a.find(".btn-fullscreen"),
            s = a.find(".btn-borderless");
        i._raise("filezoom" + e, function (e) {
          return {
            sourceEvent: e,
            previewId: a.data("previewId"),
            modal: a
          };
        }(r)), "shown" === e && (s.removeClass("active").attr("aria-pressed", "false"), n.removeClass("active").attr("aria-pressed", "false"), a.hasClass("file-zoom-fullscreen") && (i._maximizeZoomDialog(), t.checkFullScreen() ? n.addClass("active").attr("aria-pressed", "true") : s.addClass("active").attr("aria-pressed", "true")));
      });
    },
    _initZoom: function _initZoom() {
      var i,
          a = this,
          r = a._getLayoutTemplate("modalMain"),
          n = "#" + t.MODAL_ID;

      a.showPreview && (a.$modal = e(n), a.$modal && a.$modal.length || (i = e(document.createElement("div")).html(r).insertAfter(a.$container), a.$modal = e(n).insertBefore(i), i.remove()), t.initModal(a.$modal), a.$modal.html(a._getModalContent()), e.each(t.MODAL_EVENTS, function (e, t) {
        a._listenModalEvent(t);
      }));
    },
    _initZoomButtons: function _initZoomButtons() {
      var t,
          i,
          a = this.$modal.data("previewId") || "",
          r = this.getFrames().toArray(),
          n = r.length,
          s = this.$modal.find(".btn-prev"),
          o = this.$modal.find(".btn-next");
      if (r.length < 2) return s.hide(), void o.hide();
      s.show(), o.show(), n && (t = e(r[0]), i = e(r[n - 1]), s.removeAttr("disabled"), o.removeAttr("disabled"), t.length && t.attr("id") === a && s.attr("disabled", !0), i.length && i.attr("id") === a && o.attr("disabled", !0));
    },
    _maximizeZoomDialog: function _maximizeZoomDialog() {
      var t = this.$modal,
          i = t.find(".modal-header:visible"),
          a = t.find(".modal-footer:visible"),
          r = t.find(".modal-body"),
          n = e(window).height();
      t.addClass("file-zoom-fullscreen"), i && i.length && (n -= i.outerHeight(!0)), a && a.length && (n -= a.outerHeight(!0)), r && r.length && (n -= r.outerHeight(!0) - r.height()), t.find(".kv-zoom-body").height(n);
    },
    _resizeZoomDialog: function _resizeZoomDialog(e) {
      var i = this.$modal,
          a = i.find(".btn-fullscreen"),
          r = i.find(".btn-borderless");
      if (i.hasClass("file-zoom-fullscreen")) t.toggleFullScreen(!1), e ? a.hasClass("active") || (i.removeClass("file-zoom-fullscreen"), this._resizeZoomDialog(!0), r.hasClass("active") && r.removeClass("active").attr("aria-pressed", "false")) : a.hasClass("active") ? a.removeClass("active").attr("aria-pressed", "false") : (i.removeClass("file-zoom-fullscreen"), this.$modal.find(".kv-zoom-body").css("height", this.zoomModalHeight));else {
        if (!e) return void this._maximizeZoomDialog();
        t.toggleFullScreen(!0);
      }
      i.focus();
    },
    _setZoomContent: function _setZoomContent(i, a) {
      var r,
          n,
          s,
          o,
          l,
          d,
          c,
          h,
          p = this,
          u = i.attr("id"),
          f = p.$modal,
          m = f.find(".btn-prev"),
          g = f.find(".btn-next"),
          v = f.find(".btn-fullscreen"),
          w = f.find(".btn-borderless"),
          _ = f.find(".btn-toggleheader"),
          b = p.$preview.find("#zoom-" + u);

      n = b.attr("data-template") || "generic", s = (r = b.find(".kv-file-content")).length ? r.html() : "", o = (i.data("caption") || "") + " " + (i.data("size") || ""), f.find(".kv-zoom-title").attr("title", e("<div/>").html(o).text()).html(o), l = f.find(".kv-zoom-body"), f.removeClass("kv-single-content"), a ? (h = l.addClass("file-thumb-loading").clone().insertAfter(l), l.html(s).hide(), h.fadeOut("fast", function () {
        l.fadeIn("fast", function () {
          l.removeClass("file-thumb-loading");
        }), h.remove();
      })) : l.html(s), (c = p.previewZoomSettings[n]) && (d = l.find(".kv-preview-data"), t.addCss(d, "file-zoom-detail"), e.each(c, function (e, t) {
        d.css(e, t), (d.attr("width") && "width" === e || d.attr("height") && "height" === e) && d.removeAttr(e);
      })), f.data("previewId", u), p._handler(m, "click", function () {
        p._zoomSlideShow("prev", u);
      }), p._handler(g, "click", function () {
        p._zoomSlideShow("next", u);
      }), p._handler(v, "click", function () {
        p._resizeZoomDialog(!0);
      }), p._handler(w, "click", function () {
        p._resizeZoomDialog(!1);
      }), p._handler(_, "click", function () {
        var e,
            t = f.find(".modal-header"),
            i = f.find(".modal-body .floating-buttons"),
            a = t.find(".kv-zoom-actions"),
            r = function r(e) {
          var i = p.$modal.find(".kv-zoom-body"),
              a = p.zoomModalHeight;
          f.hasClass("file-zoom-fullscreen") && (a = i.outerHeight(!0), e || (a -= t.outerHeight(!0))), i.css("height", e ? a + e : a);
        };

        t.is(":visible") ? (e = t.outerHeight(!0), t.slideUp("slow", function () {
          a.find(".btn").appendTo(i), r(e);
        })) : (i.find(".btn").appendTo(a), t.slideDown("slow", function () {
          r();
        })), f.focus();
      }), p._handler(f, "keydown", function (e) {
        var t = e.which || e.keyCode;
        37 !== t || m.attr("disabled") || p._zoomSlideShow("prev", u), 39 !== t || g.attr("disabled") || p._zoomSlideShow("next", u);
      });
    },
    _zoomPreview: function _zoomPreview(e) {
      var i,
          a = this.$modal;
      if (!e.length) throw "Cannot zoom to detailed preview!";
      t.initModal(a), a.html(this._getModalContent()), i = e.closest(t.FRAMES), this._setZoomContent(i), a.modal("show"), this._initZoomButtons();
    },
    _zoomSlideShow: function _zoomSlideShow(t, i) {
      var a,
          r,
          n,
          s = this.$modal.find(".kv-zoom-actions .btn-" + t),
          o = this.getFrames().toArray(),
          l = o.length;

      if (!s.attr("disabled")) {
        for (r = 0; r < l; r++) {
          if (e(o[r]).attr("id") === i) {
            n = "prev" === t ? r - 1 : r + 1;
            break;
          }
        }

        n < 0 || n >= l || !o[n] || ((a = e(o[n])).length && this._setZoomContent(a, !0), this._initZoomButtons(), this._raise("filezoom" + t, {
          previewId: i,
          modal: this.$modal
        }));
      }
    },
    _initZoomButton: function _initZoomButton() {
      var t = this;
      t.$preview.find(".kv-file-zoom").each(function () {
        var i = e(this);

        t._handler(i, "click", function () {
          t._zoomPreview(i);
        });
      });
    },
    _inputFileCount: function _inputFileCount() {
      return this.$element.get(0).files.length;
    },
    _refreshPreview: function _refreshPreview() {
      var e;
      this._inputFileCount() && this.showPreview && this.isPreviewable && (this.isAjaxUpload ? (e = this.getFileStack(), this.filestack = [], e.length ? this._clearFileInput() : e = this.$element.get(0).files) : e = this.$element.get(0).files, e && e.length && (this.readFiles(e), this._setFileDropZoneTitle()));
    },
    _clearObjects: function _clearObjects(t) {
      t.find("video audio").each(function () {
        this.pause(), e(this).remove();
      }), t.find("img object div").each(function () {
        e(this).remove();
      });
    },
    _clearFileInput: function _clearFileInput() {
      var t,
          i,
          a,
          r = this.$element;
      this._inputFileCount() && (t = r.closest("form"), i = e(document.createElement("form")), a = e(document.createElement("div")), r.before(a), t.length ? t.after(i) : a.after(i), i.append(r).trigger("reset"), a.before(r).remove(), i.remove());
    },
    _resetUpload: function _resetUpload() {
      this.uploadCache = {
        content: [],
        config: [],
        tags: [],
        append: !0
      }, this.uploadCount = 0, this.uploadStatus = {}, this.uploadLog = [], this.uploadAsyncCount = 0, this.loadedImages = [], this.totalImagesCount = 0, this.$btnUpload.removeAttr("disabled"), this._setProgress(0), this.$progress.hide(), this._resetErrors(!1), this.ajaxAborted = !1, this.ajaxRequests = [], this._resetCanvas(), this.cacheInitialPreview = {}, this.overwriteInitial && (this.initialPreview = [], this.initialPreviewConfig = [], this.initialPreviewThumbTags = [], this.previewCache.data = {
        content: [],
        config: [],
        tags: []
      });
    },
    _resetCanvas: function _resetCanvas() {
      this.canvas && this.imageCanvasContext && this.imageCanvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
    },
    _hasInitialPreview: function _hasInitialPreview() {
      return !this.overwriteInitial && this.previewCache.count();
    },
    _resetPreview: function _resetPreview() {
      var e, t;
      this.previewCache.count() ? (e = this.previewCache.out(), this._setPreviewContent(e.content), this._setInitThumbAttr(), t = this.initialCaption ? this.initialCaption : e.caption, this._setCaption(t)) : (this._clearPreview(), this._initCaption()), this.showPreview && (this._initZoom(), this._initSortable());
    },
    _clearDefaultPreview: function _clearDefaultPreview() {
      this.$preview.find(".file-default-preview").remove();
    },
    _validateDefaultPreview: function _validateDefaultPreview() {
      this.showPreview && !t.isEmpty(this.defaultPreviewContent) && (this._setPreviewContent('<div class="file-default-preview">' + this.defaultPreviewContent + "</div>"), this.$container.removeClass("file-input-new"), this._initClickable());
    },
    _resetPreviewThumbs: function _resetPreviewThumbs(e) {
      var t;
      if (e) return this._clearPreview(), void this.clearStack();
      this._hasInitialPreview() ? (t = this.previewCache.out(), this._setPreviewContent(t.content), this._setInitThumbAttr(), this._setCaption(t.caption), this._initPreviewActions()) : this._clearPreview();
    },
    _getLayoutTemplate: function _getLayoutTemplate(e) {
      var i = this.layoutTemplates[e];
      return t.isEmpty(this.customLayoutTags) ? i : t.replaceTags(i, this.customLayoutTags);
    },
    _getPreviewTemplate: function _getPreviewTemplate(e) {
      var i = this.previewTemplates[e];
      return t.isEmpty(this.customPreviewTags) ? i : t.replaceTags(i, this.customPreviewTags);
    },
    _getOutData: function _getOutData(e, t, i) {
      return e = e || {}, t = t || {}, i = i || this.filestack.slice(0) || {}, {
        form: this.formdata,
        files: i,
        filenames: this.filenames,
        filescount: this.getFilesCount(),
        extra: this._getExtraData(),
        response: t,
        reader: this.reader,
        jqXHR: e
      };
    },
    _getMsgSelected: function _getMsgSelected(e) {
      var t = 1 === e ? this.fileSingle : this.filePlural;
      return e > 0 ? this.msgSelected.replace("{n}", e).replace("{files}", t) : this.msgNoFilesSelected;
    },
    _getFrame: function _getFrame(t) {
      var i = e("#" + t);
      return i.length ? i : (this._log('Invalid thumb frame with id: "' + t + '".'), null);
    },
    _getThumbs: function _getThumbs(e) {
      return e = e || "", this.getFrames(":not(.file-preview-initial)" + e);
    },
    _getExtraData: function _getExtraData(e, t) {
      var i = this.uploadExtraData;
      return "function" == typeof this.uploadExtraData && (i = this.uploadExtraData(e, t)), i;
    },
    _initXhr: function _initXhr(e, t, i) {
      var a = this;
      return e.upload && e.upload.addEventListener("progress", function (e) {
        var r = 0,
            n = e.total,
            s = e.loaded || e.position;
        e.lengthComputable && (r = Math.floor(s / n * 100)), t ? a._setAsyncUploadStatus(t, r, i) : a._setProgress(r);
      }, !1), e;
    },
    _initAjaxSettings: function _initAjaxSettings() {
      this._ajaxSettings = e.extend(!0, {}, this.ajaxSettings), this._ajaxDeleteSettings = e.extend(!0, {}, this.ajaxDeleteSettings);
    },
    _mergeAjaxCallback: function _mergeAjaxCallback(e, t, i) {
      var a,
          r = this._ajaxSettings,
          n = this.mergeAjaxCallbacks;
      "delete" === i && (r = this._ajaxDeleteSettings, n = this.mergeAjaxDeleteCallbacks), a = r[e], r[e] = n && "function" == typeof a ? "before" === n ? function () {
        a.apply(this, arguments), t.apply(this, arguments);
      } : function () {
        t.apply(this, arguments), a.apply(this, arguments);
      } : t;
    },
    _ajaxSubmit: function _ajaxSubmit(t, i, a, r, n, s) {
      var o,
          l = this;
      l._raise("filepreajax", [n, s]) && (l._uploadExtra(n, s), l._initAjaxSettings(), l._mergeAjaxCallback("beforeSend", t), l._mergeAjaxCallback("success", i), l._mergeAjaxCallback("complete", a), l._mergeAjaxCallback("error", r), o = e.extend(!0, {}, {
        xhr: function xhr() {
          var t = e.ajaxSettings.xhr();
          return l._initXhr(t, n, l.getFileStack().length);
        },
        url: s && l.uploadUrlThumb ? l.uploadUrlThumb : l.uploadUrl,
        type: "POST",
        dataType: "json",
        data: l.formdata,
        cache: !1,
        processData: !1,
        contentType: !1
      }, l._ajaxSettings), l.ajaxRequests.push(e.ajax(o)));
    },
    _mergeArray: function _mergeArray(e, i) {
      var a = t.cleanArray(this[e]),
          r = t.cleanArray(i);
      this[e] = a.concat(r);
    },
    _initUploadSuccess: function _initUploadSuccess(i, a, r) {
      var n,
          s,
          o,
          l,
          d,
          c,
          h,
          p,
          u,
          f = this;
      f.showPreview && "object" == _typeof2(i) && !e.isEmptyObject(i) && void 0 !== i.initialPreview && i.initialPreview.length > 0 && (f.hasInitData = !0, c = i.initialPreview || [], h = i.initialPreviewConfig || [], p = i.initialPreviewThumbTags || [], n = void 0 === i.append || i.append, c.length > 0 && !t.isArray(c) && (c = c.split(f.initialPreviewDelimiter)), f._mergeArray("initialPreview", c), f._mergeArray("initialPreviewConfig", h), f._mergeArray("initialPreviewThumbTags", p), void 0 !== a ? r ? (u = a.attr("data-fileindex"), f.uploadCache.content[u] = c[0], f.uploadCache.config[u] = h[0] || [], f.uploadCache.tags[u] = p[0] || [], f.uploadCache.append = n) : (o = f.previewCache.add(c, h[0], p[0], n), s = f.previewCache.get(o, !1), (d = (l = e(document.createElement("div")).html(s).hide().insertAfter(a)).find(".kv-zoom-cache")) && d.length && d.insertAfter(a), a.fadeOut("slow", function () {
        var e = l.find(".file-preview-frame");
        e && e.length && e.insertBefore(a).fadeIn("slow").css("display:inline-block"), f._initPreviewActions(), f._clearFileInput(), t.cleanZoomCache(f.$preview.find("#zoom-" + a.attr("id"))), a.remove(), l.remove(), f._initSortable();
      })) : (f.previewCache.set(c, h, p, n), f._initPreview(), f._initPreviewActions()));
    },
    _initSuccessThumbs: function _initSuccessThumbs() {
      var i = this;
      i.showPreview && i._getThumbs(t.FRAMES + ".file-preview-success").each(function () {
        var a = e(this),
            r = i.$preview,
            n = a.find(".kv-file-remove");
        n.removeAttr("disabled"), i._handler(n, "click", function () {
          var e = a.attr("id"),
              n = i._raise("filesuccessremove", [e, a.attr("data-fileindex")]);

          t.cleanMemory(a), !1 !== n && a.fadeOut("slow", function () {
            t.cleanZoomCache(r.find("#zoom-" + e)), a.remove(), i.getFrames().length || i.reset();
          });
        });
      });
    },
    _checkAsyncComplete: function _checkAsyncComplete() {
      var t, i;

      for (i = 0; i < this.filestack.length; i++) {
        if (this.filestack[i] && (t = this.previewInitId + "-" + i, -1 === e.inArray(t, this.uploadLog))) return !1;
      }

      return this.uploadAsyncCount === this.uploadLog.length;
    },
    _uploadExtra: function _uploadExtra(t, i) {
      var a = this,
          r = a._getExtraData(t, i);

      0 !== r.length && e.each(r, function (e, t) {
        a.formdata.append(e, t);
      });
    },
    _uploadSingle: function _uploadSingle(i, a) {
      var r,
          n,
          s,
          o,
          l,
          d,
          c,
          h,
          p,
          u,
          f,
          m = this,
          g = m.getFileStack().length,
          v = new FormData(),
          w = m.previewInitId + "-" + i,
          _ = m.filestack.length > 0 || !e.isEmptyObject(m.uploadExtraData),
          b = e("#" + w).find(".file-thumb-progress"),
          C = {
        id: w,
        index: i
      };

      m.formdata = v, m.showPreview && (n = e("#" + w + ":not(.file-preview-initial)"), o = n.find(".kv-file-upload"), l = n.find(".kv-file-remove"), b.show()), 0 === g || !_ || o && o.hasClass("disabled") || m._abort(C) || (f = function f(e, t) {
        d || m.updateStack(e, void 0), m.uploadLog.push(t), m._checkAsyncComplete() && (m.fileBatchCompleted = !0);
      }, s = function s() {
        var e,
            i,
            a,
            r = m.uploadCache,
            n = 0,
            s = m.cacheInitialPreview;
        m.fileBatchCompleted && (s && s.content && (n = s.content.length), setTimeout(function () {
          var o = 0 === m.getFileStack(!0).length;

          if (m.showPreview) {
            if (m.previewCache.set(r.content, r.config, r.tags, r.append), n) {
              for (i = 0; i < r.content.length; i++) {
                a = i + n, s.content[a] = r.content[i], s.config.length && (s.config[a] = r.config[i]), s.tags.length && (s.tags[a] = r.tags[i]);
              }

              m.initialPreview = t.cleanArray(s.content), m.initialPreviewConfig = t.cleanArray(s.config), m.initialPreviewThumbTags = t.cleanArray(s.tags);
            } else m.initialPreview = r.content, m.initialPreviewConfig = r.config, m.initialPreviewThumbTags = r.tags;

            m.cacheInitialPreview = {}, m.hasInitData && (m._initPreview(), m._initPreviewActions());
          }

          m.unlock(o), o && m._clearFileInput(), e = m.$preview.find(".file-preview-initial"), m.uploadAsync && e.length && (t.addCss(e, t.SORT_CSS), m._initSortable()), m._raise("filebatchuploadcomplete", [m.filestack, m._getExtraData()]), m.uploadCount = 0, m.uploadStatus = {}, m.uploadLog = [], m._setProgress(101), m.ajaxAborted = !1;
        }, 100));
      }, c = function c(s) {
        r = m._getOutData(s), m.fileBatchCompleted = !1, a || (m.ajaxAborted = !1), m.showPreview && (n.hasClass("file-preview-success") || (m._setThumbStatus(n, "Loading"), t.addCss(n, "file-uploading")), o.attr("disabled", !0), l.attr("disabled", !0)), a || m.lock(), m._raise("filepreupload", [r, w, i]), e.extend(!0, C, r), m._abort(C) && (s.abort(), a || (m._setThumbStatus(n, "New"), n.removeClass("file-uploading"), o.removeAttr("disabled"), l.removeAttr("disabled"), m.unlock()), m._setProgressCancelled());
      }, h = function h(s, l, c) {
        var h = m.showPreview && n.attr("id") ? n.attr("id") : w;
        r = m._getOutData(c, s), e.extend(!0, C, r), setTimeout(function () {
          t.isEmpty(s) || t.isEmpty(s.error) ? (m.showPreview && (m._setThumbStatus(n, "Success"), o.hide(), m._initUploadSuccess(s, n, a), m._setProgress(101, b)), m._raise("fileuploaded", [r, h, i]), a ? f(i, h) : m.updateStack(i, void 0)) : (d = !0, m._showUploadError(s.error, C), m._setPreviewError(n, i, m.filestack[i], m.retryErrorUploads), m.retryErrorUploads || o.hide(), a && f(i, h), m._setProgress(101, e("#" + h).find(".file-thumb-progress"), m.msgUploadError));
        }, 100);
      }, p = function p() {
        setTimeout(function () {
          m.showPreview && (o.removeAttr("disabled"), l.removeAttr("disabled"), n.removeClass("file-uploading")), a ? s() : (m.unlock(!1), m._clearFileInput()), m._initSuccessThumbs();
        }, 100);
      }, u = function u(t, r, s) {
        var l = m.ajaxOperations.uploadThumb,
            c = m._parseError(l, t, s, a && m.filestack[i].name ? m.filestack[i].name : null);

        d = !0, setTimeout(function () {
          a && f(i, w), m.uploadStatus[w] = 100, m._setPreviewError(n, i, m.filestack[i], m.retryErrorUploads), m.retryErrorUploads || o.hide(), e.extend(!0, C, m._getOutData(t)), m._setProgress(101, b, m.msgAjaxProgressError.replace("{operation}", l)), m._setProgress(101, e("#" + w).find(".file-thumb-progress"), m.msgUploadError), m._showUploadError(c, C);
        }, 100);
      }, v.append(m.uploadFileAttr, m.filestack[i], m.filenames[i]), v.append("file_id", i), m._ajaxSubmit(c, h, p, u, w, i));
    },
    _uploadBatch: function _uploadBatch() {
      var i,
          a,
          r,
          n,
          s,
          o = this,
          l = o.filestack,
          d = l.length,
          c = o.filestack.length > 0 || !e.isEmptyObject(o.uploadExtraData);
      o.formdata = new FormData(), 0 !== d && c && !o._abort({}) && (s = function s() {
        e.each(l, function (e) {
          o.updateStack(e, void 0);
        }), o._clearFileInput();
      }, i = function i(_i18) {
        o.lock();

        var a = o._getOutData(_i18);

        o.ajaxAborted = !1, o.showPreview && o._getThumbs().each(function () {
          var i = e(this),
              a = i.find(".kv-file-upload"),
              r = i.find(".kv-file-remove");
          i.hasClass("file-preview-success") || (o._setThumbStatus(i, "Loading"), t.addCss(i, "file-uploading")), a.attr("disabled", !0), r.attr("disabled", !0);
        }), o._raise("filebatchpreupload", [a]), o._abort(a) && (_i18.abort(), o._getThumbs().each(function () {
          var t = e(this),
              i = t.find(".kv-file-upload"),
              a = t.find(".kv-file-remove");
          t.hasClass("file-preview-loading") && (o._setThumbStatus(t, "New"), t.removeClass("file-uploading")), i.removeAttr("disabled"), a.removeAttr("disabled");
        }), o._setProgressCancelled());
      }, a = function a(i, _a, r) {
        var n = o._getOutData(r, i),
            l = 0,
            d = o._getThumbs(":not(.file-preview-success)"),
            c = t.isEmpty(i) || t.isEmpty(i.errorkeys) ? [] : i.errorkeys;

        t.isEmpty(i) || t.isEmpty(i.error) ? (o._raise("filebatchuploadsuccess", [n]), s(), o.showPreview ? (d.each(function () {
          var t = e(this);
          o._setThumbStatus(t, "Success"), t.removeClass("file-uploading"), t.find(".kv-file-upload").hide().removeAttr("disabled");
        }), o._initUploadSuccess(i)) : o.reset(), o._setProgress(101)) : (o.showPreview && (d.each(function () {
          var t = e(this),
              i = t.attr("data-fileindex");
          t.removeClass("file-uploading"), t.find(".kv-file-upload").removeAttr("disabled"), t.find(".kv-file-remove").removeAttr("disabled"), 0 === c.length || -1 !== e.inArray(l, c) ? (o._setPreviewError(t, i, o.filestack[i], o.retryErrorUploads), o.retryErrorUploads || (t.find(".kv-file-upload").hide(), o.updateStack(i, void 0))) : (t.find(".kv-file-upload").hide(), o._setThumbStatus(t, "Success"), o.updateStack(i, void 0)), t.hasClass("file-preview-error") && !o.retryErrorUploads || l++;
        }), o._initUploadSuccess(i)), o._showUploadError(i.error, n, "filebatchuploaderror"), o._setProgress(101, o.$progress, o.msgUploadError));
      }, n = function n() {
        o.unlock(), o._initSuccessThumbs(), o._clearFileInput(), o._raise("filebatchuploadcomplete", [o.filestack, o._getExtraData()]);
      }, r = function r(t, i, a) {
        var r = o._getOutData(t),
            n = o.ajaxOperations.uploadBatch,
            s = o._parseError(n, t, a);

        o._showUploadError(s, r, "filebatchuploaderror"), o.uploadFileCount = d - 1, o.showPreview && (o._getThumbs().each(function () {
          var t = e(this),
              i = t.attr("data-fileindex");
          t.removeClass("file-uploading"), void 0 !== o.filestack[i] && o._setPreviewError(t);
        }), o._getThumbs().removeClass("file-uploading"), o._getThumbs(" .kv-file-upload").removeAttr("disabled"), o._getThumbs(" .kv-file-delete").removeAttr("disabled"), o._setProgress(101, o.$progress, o.msgAjaxProgressError.replace("{operation}", n)));
      }, e.each(l, function (e, i) {
        t.isEmpty(l[e]) || o.formdata.append(o.uploadFileAttr, i, o.filenames[e]);
      }), o._ajaxSubmit(i, a, n, r));
    },
    _uploadExtraOnly: function _uploadExtraOnly() {
      var e,
          i,
          a,
          r,
          n = this,
          s = {};
      n.formdata = new FormData(), n._abort(s) || (e = function e(_e2) {
        n.lock();

        var t = n._getOutData(_e2);

        n._raise("filebatchpreupload", [t]), n._setProgress(50), s.data = t, s.xhr = _e2, n._abort(s) && (_e2.abort(), n._setProgressCancelled());
      }, i = function i(e, _i19, a) {
        var r = n._getOutData(a, e);

        t.isEmpty(e) || t.isEmpty(e.error) ? (n._raise("filebatchuploadsuccess", [r]), n._clearFileInput(), n._initUploadSuccess(e), n._setProgress(101)) : n._showUploadError(e.error, r, "filebatchuploaderror");
      }, a = function a() {
        n.unlock(), n._clearFileInput(), n._raise("filebatchuploadcomplete", [n.filestack, n._getExtraData()]);
      }, r = function r(e, t, i) {
        var a = n._getOutData(e),
            r = n.ajaxOperations.uploadExtra,
            o = n._parseError(r, e, i);

        s.data = a, n._showUploadError(o, a, "filebatchuploaderror"), n._setProgress(101, n.$progress, n.msgAjaxProgressError.replace("{operation}", r));
      }, n._ajaxSubmit(e, i, a, r));
    },
    _deleteFileIndex: function _deleteFileIndex(i) {
      var a = i.attr("data-fileindex"),
          r = this.reversePreviewOrder;
      "init_" === a.substring(0, 5) && (a = parseInt(a.replace("init_", "")), this.initialPreview = t.spliceArray(this.initialPreview, a, r), this.initialPreviewConfig = t.spliceArray(this.initialPreviewConfig, a, r), this.initialPreviewThumbTags = t.spliceArray(this.initialPreviewThumbTags, a, r), this.getFrames().each(function () {
        var t = e(this),
            i = t.attr("data-fileindex");
        "init_" === i.substring(0, 5) && (i = parseInt(i.replace("init_", ""))) > a && (i--, t.attr("data-fileindex", "init_" + i));
      }), this.uploadAsync && (this.cacheInitialPreview = this.getPreview()));
    },
    _initFileActions: function _initFileActions() {
      var i = this,
          a = i.$preview;
      i.showPreview && (i._initZoomButton(), i.getFrames(" .kv-file-remove").each(function () {
        var r,
            n,
            s,
            o = e(this),
            l = o.closest(t.FRAMES),
            d = l.attr("id"),
            c = l.attr("data-fileindex");

        i._handler(o, "click", function () {
          if (!1 === i._raise("filepreremove", [d, c]) || !i._validateMinCount()) return !1;
          r = l.hasClass("file-preview-error"), t.cleanMemory(l), l.fadeOut("slow", function () {
            t.cleanZoomCache(a.find("#zoom-" + d)), i.updateStack(c, void 0), i._clearObjects(l), l.remove(), d && r && i.$errorContainer.find('li[data-file-id="' + d + '"]').fadeOut("fast", function () {
              e(this).remove(), i._errorsExist() || i._resetErrors();
            }), i._clearFileInput();
            var o = i.getFileStack(!0),
                h = i.previewCache.count(),
                p = o.length,
                u = i.showPreview && i.getFrames().length;
            0 !== p || 0 !== h || u ? (s = (n = h + p) > 1 ? i._getMsgSelected(n) : o[0] ? i._getFileNames()[0] : "", i._setCaption(s)) : i.reset(), i._raise("fileremoved", [d, c]);
          });
        });
      }), i.getFrames(" .kv-file-upload").each(function () {
        var a = e(this);

        i._handler(a, "click", function () {
          var e = a.closest(t.FRAMES),
              r = e.attr("data-fileindex");
          i.$progress.hide(), e.hasClass("file-preview-error") && !i.retryErrorUploads || i._uploadSingle(r, !1);
        });
      }));
    },
    _initPreviewActions: function _initPreviewActions() {
      var i = this,
          a = i.$preview,
          r = i.deleteExtraData || {},
          n = t.FRAMES + " .kv-file-remove",
          s = i.fileActionSettings,
          o = s.removeClass,
          l = s.removeErrorClass,
          d = function d() {
        var e = i.isAjaxUpload ? i.previewCache.count() : i._inputFileCount();
        a.find(t.FRAMES).length || e || (i._setCaption(""), i.reset(), i.initialCaption = "");
      };

      i._initZoomButton(), a.find(n).each(function () {
        var n,
            s,
            c,
            h = e(this),
            p = h.data("url") || i.deleteUrl,
            u = h.data("key");

        if (!t.isEmpty(p) && void 0 !== u) {
          var f,
              m,
              g,
              v,
              w = h.closest(t.FRAMES),
              _ = i.previewCache.data,
              b = w.attr("data-fileindex");
          b = parseInt(b.replace("init_", "")), g = t.isEmpty(_.config) && t.isEmpty(_.config[b]) ? null : _.config[b], "function" == typeof (v = t.isEmpty(g) || t.isEmpty(g.extra) ? r : g.extra) && (v = v()), m = {
            id: h.attr("id"),
            key: u,
            extra: v
          }, n = function n(e) {
            i.ajaxAborted = !1, i._raise("filepredelete", [u, e, v]), i._abort() ? e.abort() : (h.removeClass(l), t.addCss(w, "file-uploading"), t.addCss(h, "disabled " + o));
          }, s = function s(e, r, n) {
            var s, c;
            if (!t.isEmpty(e) && !t.isEmpty(e.error)) return m.jqXHR = n, m.response = e, i._showError(e.error, m, "filedeleteerror"), w.removeClass("file-uploading"), h.removeClass("disabled " + o).addClass(l), void d();
            w.removeClass("file-uploading").addClass("file-deleted"), w.fadeOut("slow", function () {
              b = parseInt(w.attr("data-fileindex").replace("init_", "")), i.previewCache.unset(b), i._deleteFileIndex(w), s = i.previewCache.count(), c = s > 0 ? i._getMsgSelected(s) : "", i._setCaption(c), i._raise("filedeleted", [u, n, v]), t.cleanZoomCache(a.find("#zoom-" + w.attr("id"))), i._clearObjects(w), w.remove(), d();
            });
          }, c = function c(e, t, a) {
            var r = i.ajaxOperations.deleteThumb,
                n = i._parseError(r, e, a);

            m.jqXHR = e, m.response = {}, i._showError(n, m, "filedeleteerror"), w.removeClass("file-uploading"), h.removeClass("disabled " + o).addClass(l), d();
          }, i._initAjaxSettings(), i._mergeAjaxCallback("beforeSend", n, "delete"), i._mergeAjaxCallback("success", s, "delete"), i._mergeAjaxCallback("error", c, "delete"), f = e.extend(!0, {}, {
            url: p,
            type: "POST",
            dataType: "json",
            data: e.extend(!0, {}, {
              key: u
            }, v)
          }, i._ajaxDeleteSettings), i._handler(h, "click", function () {
            if (!i._validateMinCount()) return !1;
            i.ajaxAborted = !1, i._raise("filebeforedelete", [u, v]), i.ajaxAborted instanceof Promise ? i.ajaxAborted.then(function (t) {
              t || e.ajax(f);
            }) : i.ajaxAborted || e.ajax(f);
          });
        }
      });
    },
    _hideFileIcon: function _hideFileIcon() {
      this.overwriteInitial && this.$captionContainer.removeClass("icon-visible");
    },
    _showFileIcon: function _showFileIcon() {
      t.addCss(this.$captionContainer, "icon-visible");
    },
    _getSize: function _getSize(t) {
      var i,
          a,
          r,
          n = parseFloat(t),
          s = this.fileSizeGetter;
      return e.isNumeric(t) && e.isNumeric(n) ? ("function" == typeof s ? r = s(n) : 0 === n ? r = "0.00 B" : (i = Math.floor(Math.log(n) / Math.log(1024)), a = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], r = 1 * (n / Math.pow(1024, i)).toFixed(2) + " " + a[i]), this._getLayoutTemplate("size").replace("{sizeText}", r)) : "";
    },
    _generatePreviewTemplate: function _generatePreviewTemplate(i, a, r, n, s, o, l, d, c, h, p) {
      var u,
          f = this,
          m = f.slug(r),
          g = "",
          v = "",
          w = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 400 ? f.previewSettingsSmall[i] || f.defaults.previewSettingsSmall[i] : f.previewSettings[i] || f.defaults.previewSettings[i],
          _ = c || f._renderFileFooter(m, l, "auto", o),
          b = f._getPreviewIcon(r),
          C = "type-default",
          y = b && f.preferIconicPreview,
          x = b && f.preferIconicZoomPreview;

      return w && e.each(w, function (e, t) {
        v += e + ":" + t + ";";
      }), u = function u(a, o, l, c) {
        var u = l ? "zoom-" + s : s,
            g = f._getPreviewTemplate(a),
            w = (d || "") + " " + c;

        return f.frameClass && (w = f.frameClass + " " + w), l && (w = w.replace(" " + t.SORT_CSS, "")), g = f._parseFilePreviewIcon(g, r), "text" === a && (o = t.htmlEncode(o)), "object" !== i || n || e.each(f.defaults.fileTypeSettings, function (e, t) {
          "object" !== e && "other" !== e && t(r, n) && (C = "type-" + e);
        }), g.setTokens({
          previewId: u,
          caption: m,
          frameClass: w,
          type: n,
          fileindex: h,
          typeCss: C,
          footer: _,
          data: o,
          template: p || i,
          style: v ? 'style="' + v + '"' : ""
        });
      }, h = h || s.slice(s.lastIndexOf("-") + 1), f.fileActionSettings.showZoom && (g = u(x ? "other" : i, a, !0, "kv-zoom-thumb")), g = "\n" + f._getLayoutTemplate("zoomCache").replace("{zoomContent}", g), u(y ? "other" : i, a, !1, "kv-preview-thumb") + g;
    },
    _addToPreview: function _addToPreview(e, t) {
      return this.reversePreviewOrder ? e.prepend(t) : e.append(t);
    },
    _previewDefault: function _previewDefault(i, a, r) {
      var n = this.$preview;

      if (this.showPreview) {
        var s,
            o = i ? i.name : "",
            l = i ? i.type : "",
            d = i.size || 0,
            c = this.slug(o),
            h = !0 === r && !this.isAjaxUpload,
            p = t.objUrl.createObjectURL(i);
        this._clearDefaultPreview(), s = this._generatePreviewTemplate("other", p, o, l, a, h, d), this._addToPreview(n, s), this._setThumbAttr(a, c, d), !0 === r && this.isAjaxUpload && this._setThumbStatus(e("#" + a), "Error");
      }
    },
    _previewFile: function _previewFile(e, t, i, a, r, n) {
      if (this.showPreview) {
        var s,
            o = t ? t.name : "",
            l = n.type,
            d = n.name,
            c = this._parseFileType(l, o),
            h = this.allowedPreviewTypes,
            p = this.allowedPreviewMimeTypes,
            u = this.$preview,
            f = t.size || 0,
            m = h && h.indexOf(c) >= 0,
            g = p && -1 !== p.indexOf(l),
            v = "text" === c || "html" === c || "image" === c ? i.target.result : r;

        if ("html" === c && this.purifyHtml && window.DOMPurify && (v = window.DOMPurify.sanitize(v)), m || g) {
          s = this._generatePreviewTemplate(c, v, o, l, a, !1, f), this._clearDefaultPreview(), this._addToPreview(u, s);
          var w = u.find("#" + a + " img");

          this._validateImageOrientation(w, t, a, d, l, f, v);
        } else this._previewDefault(t, a);

        this._setThumbAttr(a, d, f), this._initSortable();
      }
    },
    _setThumbAttr: function _setThumbAttr(t, i, a) {
      var r = e("#" + t);
      r.length && (a = a && a > 0 ? this._getSize(a) : "", r.data({
        caption: i,
        size: a
      }));
    },
    _setInitThumbAttr: function _setInitThumbAttr() {
      var e,
          i,
          a,
          r,
          n = this.previewCache.data,
          s = this.previewCache.count();
      if (0 !== s) for (var o = 0; o < s; o++) {
        e = n.config[o], r = this.previewInitId + "-init_" + o, i = t.ifSet("caption", e, t.ifSet("filename", e)), a = t.ifSet("size", e), this._setThumbAttr(r, i, a);
      }
    },
    _slugDefault: function _slugDefault(e) {
      return t.isEmpty(e) ? "" : String(e).replace(/[\[\]\/\{}:;#%=\(\)\*\+\?\\\^\$\|<>&"']/g, "_");
    },
    _updateFileDetails: function _updateFileDetails(e) {
      var i = this.$element,
          a = this.getFileStack(),
          r = t.isIE(9) && t.findFileName(i.val()) || i[0].files[0] && i[0].files[0].name || a.length && a[0].name || "",
          n = this.slug(r),
          s = this.isAjaxUpload ? a.length : e,
          o = this.previewCache.count() + s,
          l = 1 === s ? n : this._getMsgSelected(o);
      this.isError ? (this.$previewContainer.removeClass("file-thumb-loading"), this.$previewStatus.html(""), this.$captionContainer.removeClass("icon-visible")) : this._showFileIcon(), this._setCaption(l, this.isError), this.$container.removeClass("file-input-new file-input-ajax-new"), 1 === arguments.length && this._raise("fileselect", [e, n]), this.previewCache.count() && this._initPreviewActions();
    },
    _setThumbStatus: function _setThumbStatus(e, t) {
      if (this.showPreview) {
        var i = "indicator" + t,
            a = i + "Title",
            r = "file-preview-" + t.toLowerCase(),
            n = e.find(".file-upload-indicator"),
            s = this.fileActionSettings;
        e.removeClass("file-preview-success file-preview-error file-preview-loading"), "Success" === t && e.find(".file-drag-handle").remove(), n.html(s[i]), n.attr("title", s[a]), e.addClass(r), "Error" !== t || this.retryErrorUploads || e.find(".kv-file-upload").attr("disabled", !0);
      }
    },
    _setProgressCancelled: function _setProgressCancelled() {
      this._setProgress(101, this.$progress, this.msgCancelled);
    },
    _setProgress: function _setProgress(e, i, a) {
      var r,
          n = Math.min(e, 100),
          s = this.progressUploadThreshold,
          o = e <= 100 ? this.progressTemplate : this.progressCompleteTemplate,
          l = n < 100 ? this.progressTemplate : a ? this.progressErrorTemplate : o;
      i = i || this.$progress, t.isEmpty(l) || (r = s && n > s && e <= 100 ? l.setTokens({
        percent: s,
        status: this.msgUploadThreshold
      }) : l.setTokens({
        percent: n,
        status: e > 100 ? this.msgUploadEnd : n + "%"
      }), i.html(r), a && i.find('[role="progressbar"]').html(a));
    },
    _setFileDropZoneTitle: function _setFileDropZoneTitle() {
      var e,
          i = this.$container.find(".file-drop-zone"),
          a = this.dropZoneTitle;
      this.isClickable && (e = t.isEmpty(this.$element.attr("multiple")) ? this.fileSingle : this.filePlural, a += this.dropZoneClickTitle.replace("{files}", e)), i.find("." + this.dropZoneTitleClass).remove(), !this.showPreview || 0 === i.length || this.getFileStack().length > 0 || !this.dropZoneEnabled || !this.isAjaxUpload && this.$element.files || (0 === i.find(t.FRAMES).length && t.isEmpty(this.defaultPreviewContent) && i.prepend('<div class="' + this.dropZoneTitleClass + '">' + a + "</div>"), this.$container.removeClass("file-input-new"), t.addCss(this.$container, "file-input-ajax-new"));
    },
    _setAsyncUploadStatus: function _setAsyncUploadStatus(t, i, a) {
      var r = 0;
      this._setProgress(i, e("#" + t).find(".file-thumb-progress")), this.uploadStatus[t] = i, e.each(this.uploadStatus, function (e, t) {
        r += t;
      }), this._setProgress(Math.floor(r / a));
    },
    _validateMinCount: function _validateMinCount() {
      var e = this.isAjaxUpload ? this.getFileStack().length : this._inputFileCount();
      return !(this.validateInitialCount && this.minFileCount > 0 && this._getFileCount(e - 1) < this.minFileCount) || (this._noFilesError({}), !1);
    },
    _getFileCount: function _getFileCount(e) {
      return this.validateInitialCount && !this.overwriteInitial && (e += this.previewCache.count()), e;
    },
    _getFileId: function _getFileId(e) {
      var t,
          i = this.generateFileId;
      return "function" == typeof i ? i(e, event) : e && (t = String(e.webkitRelativePath || e.fileName || e.name || null)) ? e.size + "-" + t.replace(/[^0-9a-zA-Z_-]/gim, "") : null;
    },
    _getFileName: function _getFileName(e) {
      return e && e.name ? this.slug(e.name) : void 0;
    },
    _getFileIds: function _getFileIds(e) {
      return this.fileids.filter(function (t) {
        return e ? void 0 !== t : null != t;
      });
    },
    _getFileNames: function _getFileNames(e) {
      return this.filenames.filter(function (t) {
        return e ? void 0 !== t : null != t;
      });
    },
    _setPreviewError: function _setPreviewError(e, t, i, a) {
      void 0 !== t && this.updateStack(t, i), this.showPreview && (!this.removeFromPreviewOnError || a ? (this._setThumbStatus(e, "Error"), this._refreshUploadButton(e, a)) : e.remove());
    },
    _refreshUploadButton: function _refreshUploadButton(e, t) {
      var i = e.find(".kv-file-upload"),
          a = this.fileActionSettings,
          r = a.uploadIcon,
          n = a.uploadTitle;
      i.length && (t && (r = a.uploadRetryIcon, n = a.uploadRetryTitle), i.attr("title", n).html(r));
    },
    _checkDimensions: function _checkDimensions(e, i, a, r, n, s, o) {
      var l,
          d,
          c,
          h = this[("Small" === i ? "min" : "max") + "Image" + s];
      !t.isEmpty(h) && a.length && (c = a[0], d = "Width" === s ? c.naturalWidth || c.width : c.naturalHeight || c.height, ("Small" === i ? d >= h : d <= h) || (l = this["msgImage" + s + i].setTokens({
        name: n,
        size: h
      }), this._showUploadError(l, o), this._setPreviewError(r, e, null)));
    },
    _getExifObj: function _getExifObj(e) {
      var t = null;

      try {
        t = window.piexif ? window.piexif.load(e) : null;
      } catch (e) {
        t = null;
      }

      return t || this._log("Error loading the piexif.js library."), t;
    },
    _validateImageOrientation: function _validateImageOrientation(e, i, a, r, n, s, o) {
      var l, d;
      (d = (l = e.length && this.autoOrientImage ? this._getExifObj(o) : null) ? l["0th"][piexif.ImageIFD.Orientation] : null) ? (t.setImageOrientation(e, this.$preview.find("#zoom-" + a + " img"), d), this._raise("fileimageoriented", {
        $img: e,
        file: i
      }), this._validateImage(a, r, n, s, o, l)) : this._validateImage(a, r, n, s, o, l);
    },
    _validateImage: function _validateImage(t, i, a, r, n, s) {
      var o,
          l,
          d,
          c = this,
          h = c.$preview,
          p = h.find("#" + t),
          u = p.attr("data-fileindex"),
          f = p.find("img");
      i = i || "Untitled", f.one("load", function () {
        l = p.width(), d = h.width(), l > d && f.css("width", "100%"), o = {
          ind: u,
          id: t
        }, c._checkDimensions(u, "Small", f, p, i, "Width", o), c._checkDimensions(u, "Small", f, p, i, "Height", o), c.resizeImage || (c._checkDimensions(u, "Large", f, p, i, "Width", o), c._checkDimensions(u, "Large", f, p, i, "Height", o)), c._raise("fileimageloaded", [t]), c.loadedImages.push({
          ind: u,
          img: f,
          thumb: p,
          pid: t,
          typ: a,
          siz: r,
          validated: !1,
          imgData: n,
          exifObj: s
        }), p.data("exif", s), c._validateAllImages();
      }).one("error", function () {
        c._raise("fileimageloaderror", [t]);
      }).each(function () {
        this.complete ? e(this).trigger("load") : this.error && e(this).trigger("error");
      });
    },
    _validateAllImages: function _validateAllImages() {
      var e,
          t,
          i,
          a = {
        val: 0
      },
          r = this.loadedImages.length,
          n = this.resizeIfSizeMoreThan;
      if (r === this.totalImagesCount && (this._raise("fileimagesloaded"), this.resizeImage)) for (e = 0; e < this.loadedImages.length; e++) {
        (t = this.loadedImages[e]).validated || ((i = t.siz) && i > 1e3 * n && this._getResizedImage(t, a, r), this.loadedImages[e].validated = !0);
      }
    },
    _getResizedImage: function _getResizedImage(i, a, r) {
      var n,
          s,
          o,
          l,
          d,
          c,
          h = this,
          p = e(i.img)[0],
          u = p.naturalWidth,
          f = p.naturalHeight,
          m = 1,
          g = h.maxImageWidth || u,
          v = h.maxImageHeight || f,
          w = !(!u || !f),
          _ = h.imageCanvas,
          b = h.imageCanvasContext,
          C = i.typ,
          y = i.pid,
          x = i.ind,
          T = i.thumb,
          E = i.exifObj;

      if (d = function d(e, t, i) {
        h.isAjaxUpload ? h._showUploadError(e, t, i) : h._showError(e, t, i), h._setPreviewError(T, x);
      }, h.filestack[x] && w && !(u <= g && f <= v) || (w && h.filestack[x] && h._raise("fileimageresized", [y, x]), a.val++, a.val === r && h._raise("fileimagesresized"), w)) {
        C = C || h.resizeDefaultImageType, s = u > g, o = f > v, m = "width" === h.resizePreference ? s ? g / u : o ? v / f : 1 : o ? v / f : s ? g / u : 1, h._resetCanvas(), u *= m, f *= m, _.width = u, _.height = f;

        try {
          b.drawImage(p, 0, 0, u, f), l = _.toDataURL(C, h.resizeQuality), E && (c = window.piexif.dump(E), l = window.piexif.insert(c, l)), n = t.dataURI2Blob(l), h.filestack[x] = n, h._raise("fileimageresized", [y, x]), a.val++, a.val === r && h._raise("fileimagesresized", [void 0, void 0]), n instanceof Blob || d(h.msgImageResizeError, {
            id: y,
            index: x
          }, "fileimageresizeerror");
        } catch (e) {
          a.val++, a.val === r && h._raise("fileimagesresized", [void 0, void 0]), d(h.msgImageResizeException.replace("{errors}", e.message), {
            id: y,
            index: x
          }, "fileimageresizeexception");
        }
      } else d(h.msgImageResizeError, {
        id: y,
        index: x
      }, "fileimageresizeerror");
    },
    _initBrowse: function _initBrowse(e) {
      var i = this.$element;
      this.showBrowse ? this.$btnFile = e.find(".btn-file").append(i) : (i.appendTo(e).attr("tabindex", -1), t.addCss(i, "file-no-browse"));
    },
    _initClickable: function _initClickable() {
      var i,
          a,
          r = this;
      r.isClickable && (i = r.$dropZone, r.isAjaxUpload || (a = r.$preview.find(".file-default-preview")).length && (i = a), t.addCss(i, "clickable"), i.attr("tabindex", -1), r._handler(i, "click", function (t) {
        var a = e(t.target);
        e(r.elErrorContainer + ":visible").length || a.parents(".file-preview-thumbnails").length && !a.parents(".file-default-preview").length || (r.$element.data("zoneClicked", !0).trigger("click"), i.blur());
      }));
    },
    _initCaption: function _initCaption() {
      var e = this.initialCaption || "";
      return this.overwriteInitial || t.isEmpty(e) ? (this.$caption.val(""), !1) : (this._setCaption(e), !0);
    },
    _setCaption: function _setCaption(i, a) {
      var r,
          n,
          s,
          o,
          l,
          d = this.getFileStack();

      if (this.$caption.length) {
        if (this.$captionContainer.removeClass("icon-visible"), a) r = e("<div>" + this.msgValidationError + "</div>").text(), l = (o = d.length) ? 1 === o && d[0] ? this._getFileNames()[0] : this._getMsgSelected(o) : this._getMsgSelected(this.msgNo), n = t.isEmpty(i) ? l : i, s = '<span class="' + this.msgValidationErrorClass + '">' + this.msgValidationErrorIcon + "</span>";else {
          if (t.isEmpty(i)) return;
          n = r = e("<div>" + i + "</div>").text(), s = this._getLayoutTemplate("fileIcon");
        }
        this.$captionContainer.addClass("icon-visible"), this.$caption.attr("title", r).val(n), this.$captionIcon.html(s);
      }
    },
    _createContainer: function _createContainer() {
      var t = {
        class: "file-input file-input-new" + (this.rtl ? " kv-rtl" : "")
      },
          i = e(document.createElement("div")).attr(t).html(this._renderMain());
      return i.insertBefore(this.$element), this._initBrowse(i), this.theme && i.addClass("theme-" + this.theme), i;
    },
    _refreshContainer: function _refreshContainer() {
      var e = this.$container;
      this.$element.insertAfter(e), e.html(this._renderMain()), this._initBrowse(e), this._validateDisabled();
    },
    _validateDisabled: function _validateDisabled() {
      this.$caption.attr({
        readonly: this.isDisabled
      });
    },
    _renderMain: function _renderMain() {
      var e = this.dropZoneEnabled ? " file-drop-zone" : "file-drop-disabled",
          t = this.showClose ? this._getLayoutTemplate("close") : "",
          i = this.showPreview ? this._getLayoutTemplate("preview").setTokens({
        class: this.previewClass,
        dropClass: e
      }) : "",
          a = this.isDisabled ? this.captionClass + " file-caption-disabled" : this.captionClass,
          r = this.captionTemplate.setTokens({
        class: a + " kv-fileinput-caption"
      });
      return this.mainTemplate.setTokens({
        class: this.mainClass + (!this.showBrowse && this.showCaption ? " no-browse" : ""),
        preview: i,
        close: t,
        caption: r,
        upload: this._renderButton("upload"),
        remove: this._renderButton("remove"),
        cancel: this._renderButton("cancel"),
        browse: this._renderButton("browse")
      });
    },
    _renderButton: function _renderButton(e) {
      var i = this._getLayoutTemplate("btnDefault"),
          a = this[e + "Class"],
          r = this[e + "Title"],
          n = this[e + "Icon"],
          s = this[e + "Label"],
          o = this.isDisabled ? " disabled" : "",
          l = "button";

      switch (e) {
        case "remove":
          if (!this.showRemove) return "";
          break;

        case "cancel":
          if (!this.showCancel) return "";
          a += " kv-hidden";
          break;

        case "upload":
          if (!this.showUpload) return "";
          this.isAjaxUpload && !this.isDisabled ? i = this._getLayoutTemplate("btnLink").replace("{href}", this.uploadUrl) : l = "submit";
          break;

        case "browse":
          if (!this.showBrowse) return "";
          i = this._getLayoutTemplate("btnBrowse");
          break;

        default:
          return "";
      }

      return a += "browse" === e ? " btn-file" : " fileinput-" + e + " fileinput-" + e + "-button", t.isEmpty(s) || (s = ' <span class="' + this.buttonLabelClass + '">' + s + "</span>"), i.setTokens({
        type: l,
        css: a,
        title: r,
        status: o,
        icon: n,
        label: s
      });
    },
    _renderThumbProgress: function _renderThumbProgress() {
      return '<div class="file-thumb-progress kv-hidden">' + this.progressTemplate.setTokens({
        percent: "0",
        status: this.msgUploadBegin
      }) + "</div>";
    },
    _renderFileFooter: function _renderFileFooter(e, i, a, r) {
      var n,
          s = this.fileActionSettings,
          o = s.showRemove,
          l = s.showDrag,
          d = s.showUpload,
          c = s.showZoom,
          h = this._getLayoutTemplate("footer"),
          p = this._getLayoutTemplate("indicator"),
          u = r ? s.indicatorError : s.indicatorNew,
          f = r ? s.indicatorErrorTitle : s.indicatorNewTitle,
          m = p.setTokens({
        indicator: u,
        indicatorTitle: f
      });

      return i = this._getSize(i), n = this.isAjaxUpload ? h.setTokens({
        actions: this._renderFileActions(d, !1, o, c, l, !1, !1, !1),
        caption: e,
        size: i,
        width: a,
        progress: this._renderThumbProgress(),
        indicator: m
      }) : h.setTokens({
        actions: this._renderFileActions(!1, !1, !1, c, l, !1, !1, !1),
        caption: e,
        size: i,
        width: a,
        progress: "",
        indicator: m
      }), n = t.replaceTags(n, this.previewThumbTags);
    },
    _renderFileActions: function _renderFileActions(e, t, i, a, r, n, s, o, l, d, c) {
      if (!(e || t || i || a || r)) return "";

      var h,
          p = !1 === s ? "" : ' data-url="' + s + '"',
          u = !1 === o ? "" : ' data-key="' + o + '"',
          f = "",
          m = "",
          g = "",
          v = "",
          w = "",
          _ = this._getLayoutTemplate("actions"),
          b = this.fileActionSettings,
          C = this.otherActionButtons.setTokens({
        dataKey: u,
        key: o
      }),
          y = n ? b.removeClass + " disabled" : b.removeClass;

      return i && (f = this._getLayoutTemplate("actionDelete").setTokens({
        removeClass: y,
        removeIcon: b.removeIcon,
        removeTitle: b.removeTitle,
        dataUrl: p,
        dataKey: u,
        key: o
      })), e && (m = this._getLayoutTemplate("actionUpload").setTokens({
        uploadClass: b.uploadClass,
        uploadIcon: b.uploadIcon,
        uploadTitle: b.uploadTitle
      })), t && (g = (g = this._getLayoutTemplate("actionDownload").setTokens({
        downloadClass: b.downloadClass,
        downloadIcon: b.downloadIcon,
        downloadTitle: b.downloadTitle,
        downloadUrl: d || this.initialPreviewDownloadUrl
      })).setTokens({
        filename: c,
        key: o
      })), a && (v = this._getLayoutTemplate("actionZoom").setTokens({
        zoomClass: b.zoomClass,
        zoomIcon: b.zoomIcon,
        zoomTitle: b.zoomTitle
      })), r && l && (h = "drag-handle-init " + b.dragClass, w = this._getLayoutTemplate("actionDrag").setTokens({
        dragClass: h,
        dragTitle: b.dragTitle,
        dragIcon: b.dragIcon
      })), _.setTokens({
        delete: f,
        upload: m,
        download: g,
        zoom: v,
        drag: w,
        other: C
      });
    },
    _browse: function _browse(e) {
      e && e.isDefaultPrevented() || !this._raise("filebrowse") || (this.isError && !this.isAjaxUpload && this.clear(), this.$captionContainer.focus());
    },
    _filterDuplicate: function _filterDuplicate(e, t, i) {
      var a = this._getFileId(e);

      a && i && i.indexOf(a) > -1 || (i || (i = []), t.push(e), i.push(a));
    },
    _change: function _change(i) {
      var a = this;

      if (!a.changeTriggered) {
        var r,
            n,
            s,
            o,
            l,
            d,
            c,
            h,
            p,
            u,
            f,
            m = a.$element,
            g = arguments.length > 1,
            v = a.isAjaxUpload,
            w = [],
            _ = g ? arguments[1] : m.get(0).files,
            b = !v && t.isEmpty(m.attr("multiple")) ? 1 : a.maxFileCount,
            C = a.filestack.length,
            y = t.isEmpty(m.attr("multiple")) && C > 0,
            x = a._getFileIds();

        if (a.reader = null, a._resetUpload(), a._hideFileIcon(), a.dropZoneEnabled && a.$container.find(".file-drop-zone ." + a.dropZoneTitleClass).remove(), v ? e.each(_, function (e, t) {
          a._filterDuplicate(t, w, x);
        }) : (_ = i.target && void 0 === i.target.files ? i.target.value ? [{
          name: i.target.value.replace(/^.+\\/, "")
        }] : [] : i.target.files || {}, w = _), t.isEmpty(w) || 0 === w.length) return v || a.clear(), void a._raise("fileselectnone");

        if (a._resetErrors(), n = w.length, r = a._getFileCount(v ? a.getFileStack().length + n : n), b > 0 && r > b) {
          if (!a.autoReplace || n > b) return s = a.autoReplace && n > b ? n : r, o = b, f = a.msgFilesTooMany.replace("{m}", o).replace("{n}", s), a.isError = (l = f, d = null, c = null, h = null, p = e.extend(!0, {}, a._getOutData({}, {}, _), {
            id: c,
            index: h
          }), u = {
            id: c,
            index: h,
            file: d,
            files: _
          }, v ? a._showUploadError(l, p) : a._showError(l, u)), a.$captionContainer.removeClass("icon-visible"), a._setCaption("", !0), void a.$container.removeClass("file-input-new file-input-ajax-new");
          r > b && a._resetPreviewThumbs(v);
        } else !v || y ? (a._resetPreviewThumbs(!1), y && a.clearStack()) : !v || 0 !== C || a.previewCache.count() && !a.overwriteInitial || a._resetPreviewThumbs(!0);

        a.isPreviewable ? a.readFiles(w) : a._updateFileDetails(1);
      }
    },
    _abort: function _abort(t) {
      var i;
      return this.ajaxAborted && "object" == _typeof2(this.ajaxAborted) && void 0 !== this.ajaxAborted.message ? ((i = e.extend(!0, {}, this._getOutData(), t)).abortData = this.ajaxAborted.data || {}, i.abortMessage = this.ajaxAborted.message, this._setProgress(101, this.$progress, this.msgCancelled), this._showUploadError(this.ajaxAborted.message, i, "filecustomerror"), this.cancel(), !0) : !!this.ajaxAborted;
    },
    _resetFileStack: function _resetFileStack() {
      var i = this,
          a = 0,
          r = [],
          n = [],
          s = [];
      i._getThumbs().each(function () {
        var o = e(this),
            l = o.attr("data-fileindex"),
            d = i.filestack[l],
            c = o.attr("id");
        "-1" !== l && -1 !== l && (void 0 !== d ? (r[a] = d, n[a] = i._getFileName(d), s[a] = i._getFileId(d), o.attr({
          id: i.previewInitId + "-" + a,
          "data-fileindex": a
        }), a++) : o.attr({
          id: "uploaded-" + t.uniqId(),
          "data-fileindex": "-1"
        }), i.$preview.find("#zoom-" + c).attr({
          id: "zoom-" + o.attr("id"),
          "data-fileindex": o.attr("data-fileindex")
        }));
      }), i.filestack = r, i.filenames = n, i.fileids = s;
    },
    _isFileSelectionValid: function _isFileSelectionValid(e) {
      return e = e || 0, this.required && !this.getFilesCount() ? (this.$errorContainer.html(""), this._showUploadError(this.msgFileRequired), !1) : !(this.minFileCount > 0 && this._getFileCount(e) < this.minFileCount) || (this._noFilesError({}), !1);
    },
    clearStack: function clearStack() {
      return this.filestack = [], this.filenames = [], this.fileids = [], this.$element;
    },
    updateStack: function updateStack(e, t) {
      return this.filestack[e] = t, this.filenames[e] = this._getFileName(t), this.fileids[e] = t && this._getFileId(t) || null, this.$element;
    },
    addToStack: function addToStack(e) {
      return this.filestack.push(e), this.filenames.push(this._getFileName(e)), this.fileids.push(this._getFileId(e)), this.$element;
    },
    getFileStack: function getFileStack(e) {
      return this.filestack.filter(function (t) {
        return e ? void 0 !== t : null != t;
      });
    },
    getFilesCount: function getFilesCount() {
      var e = this.isAjaxUpload ? this.getFileStack().length : this._inputFileCount();
      return this._getFileCount(e);
    },
    readFiles: function readFiles(i) {
      this.reader = new FileReader();

      var _a2,
          r = this,
          n = r.$element,
          s = r.$preview,
          o = r.reader,
          l = r.$previewContainer,
          d = r.$previewStatus,
          c = r.msgLoading,
          h = r.msgProgress,
          p = r.previewInitId,
          u = i.length,
          f = r.fileTypeSettings,
          m = r.filestack.length,
          g = r.allowedFileTypes,
          v = g ? g.length : 0,
          w = r.allowedFileExtensions,
          _ = t.isEmpty(w) ? "" : w.join(", "),
          b = r.maxFilePreviewSize && parseFloat(r.maxFilePreviewSize),
          C = s.length && (!b || isNaN(b)),
          y = function y(t, n, s, o) {
        var l,
            d = e.extend(!0, {}, r._getOutData({}, {}, i), {
          id: s,
          index: o
        }),
            c = {
          id: s,
          index: o,
          file: n,
          files: i
        };
        r._previewDefault(n, s, !0), r.isAjaxUpload ? (r.addToStack(void 0), setTimeout(function () {
          _a2(o + 1);
        }, 100)) : u = 0, r._initFileActions(), (l = e("#" + s)).find(".kv-file-upload").hide(), r.removeFromPreviewOnError && l.remove(), r.isError = r.isAjaxUpload ? r._showUploadError(t, d) : r._showError(t, c), r._updateFileDetails(u);
      };

      r.loadedImages = [], r.totalImagesCount = 0, e.each(i, function (e, t) {
        var i = r.fileTypeSettings.image;
        i && i(t.type) && r.totalImagesCount++;
      }), (_a2 = function a(x) {
        if (t.isEmpty(n.attr("multiple")) && (u = 1), x >= u) return r.isAjaxUpload && r.filestack.length > 0 ? r._raise("filebatchselected", [r.getFileStack()]) : r._raise("filebatchselected", [i]), l.removeClass("file-thumb-loading"), void d.html("");

        var T,
            E,
            S,
            k,
            F,
            P,
            I,
            A,
            D,
            z,
            $,
            j,
            U = p + "-" + (m + x),
            B = i[x],
            R = f.text,
            O = f.image,
            L = f.html,
            M = B && B.name ? r.slug(B.name) : "",
            Z = (B && B.size || 0) / 1e3,
            N = "",
            H = B ? t.objUrl.createObjectURL(B) : null,
            W = 0,
            q = "",
            V = 0,
            K = function K() {
          var e = h.setTokens({
            index: x + 1,
            files: u,
            percent: 50,
            name: M
          });
          setTimeout(function () {
            d.html(e), r._updateFileDetails(u), _a2(x + 1);
          }, 100), r._raise("fileloaded", [B, U, x, o]);
        };

        if (B) {
          if (v > 0) for (E = 0; E < v; E++) {
            P = g[E], I = r.msgFileTypes[P] || P, q += 0 === E ? I : ", " + I;
          }

          if (!1 !== M) {
            if (0 === M.length) return S = r.msgInvalidFileName.replace("{name}", t.htmlEncode(B.name, "[unknown]")), void y(S, B, U, x);
            if (t.isEmpty(w) || (N = new RegExp("\\.(" + w.join("|") + ")$", "i")), T = Z.toFixed(2), r.maxFileSize > 0 && Z > r.maxFileSize) return S = r.msgSizeTooLarge.setTokens({
              name: M,
              size: T,
              maxSize: r.maxFileSize
            }), void y(S, B, U, x);
            if (null !== r.minFileSize && Z <= t.getNum(r.minFileSize)) return S = r.msgSizeTooSmall.setTokens({
              name: M,
              size: T,
              minSize: r.minFileSize
            }), void y(S, B, U, x);

            if (!t.isEmpty(g) && t.isArray(g)) {
              for (E = 0; E < g.length; E += 1) {
                k = g[E], W += (A = f[k]) && "function" == typeof A && A(B.type, B.name) ? 1 : 0;
              }

              if (0 === W) return S = r.msgInvalidFileType.setTokens({
                name: M,
                types: q
              }), void y(S, B, U, x);
            }

            if (0 === W && !t.isEmpty(w) && t.isArray(w) && !t.isEmpty(N) && (F = t.compare(M, N), 0 === (W += t.isEmpty(F) ? 0 : F.length))) return S = r.msgInvalidFileExtension.setTokens({
              name: M,
              extensions: _
            }), void y(S, B, U, x);
            if (!r.showPreview) return r.isAjaxUpload && r.addToStack(B), setTimeout(function () {
              _a2(x + 1), r._updateFileDetails(u);
            }, 100), void r._raise("fileloaded", [B, U, x, o]);
            if (!C && Z > b) return r.addToStack(B), l.addClass("file-thumb-loading"), r._previewDefault(B, U), r._initFileActions(), r._updateFileDetails(u), void _a2(x + 1);
            s.length && void 0 !== FileReader ? (D = R(B.type, M), z = L(B.type, M), $ = O(B.type, M), d.html(c.replace("{index}", x + 1).replace("{files}", u)), l.addClass("file-thumb-loading"), o.onerror = function (e) {
              r._errorHandler(e, M);
            }, o.onload = function (i) {
              var a,
                  n,
                  s,
                  l,
                  d,
                  c,
                  h,
                  p,
                  u = [];

              if (n = {
                name: M,
                type: B.type
              }, e.each(f, function (e, t) {
                "object" !== e && "other" !== e && t(B.type, M) && V++;
              }), 0 === V) {
                for (s = new Uint8Array(i.target.result), E = 0; E < s.length; E++) {
                  l = s[E].toString(16), u.push(l);
                }

                if (a = u.join("").toLowerCase().substring(0, 8), c = t.getMimeType(a, "", ""), t.isEmpty(c) && (d = t.arrayBuffer2String(o.result), c = t.isSvg(d) ? "image/svg+xml" : t.getMimeType(a, d, B.type)), n = {
                  name: M,
                  type: c
                }, D = R(c, ""), z = L(c, ""), $ = O(c, ""), (j = D || z) || $) return h = j, (p = new FileReader()).onerror = function (e) {
                  r._errorHandler(e, M);
                }, p.onload = function (e) {
                  r._previewFile(x, B, e, U, H, n), r._initFileActions(), K();
                }, void (h ? p.readAsText(B, r.textEncoding) : p.readAsDataURL(B));
              }

              r._previewFile(x, B, i, U, H, n), r._initFileActions(), K();
            }, o.onprogress = function (e) {
              if (e.lengthComputable) {
                var t = e.loaded / e.total * 100,
                    i = Math.ceil(t);
                S = h.setTokens({
                  index: x + 1,
                  files: u,
                  percent: i,
                  name: M
                }), setTimeout(function () {
                  d.html(S);
                }, 100);
              }
            }, D || z ? o.readAsText(B, r.textEncoding) : $ ? o.readAsDataURL(B) : o.readAsArrayBuffer(B)) : (r._previewDefault(B, U), setTimeout(function () {
              _a2(x + 1), r._updateFileDetails(u);
            }, 100), r._raise("fileloaded", [B, U, x, o])), r.addToStack(B);
          } else _a2(x + 1);
        }
      })(0), r._updateFileDetails(u, !1);
    },
    lock: function lock() {
      return this._resetErrors(), this.disable(), this.showRemove && this.$container.find(".fileinput-remove").hide(), this.showCancel && this.$container.find(".fileinput-cancel").show(), this._raise("filelock", [this.filestack, this._getExtraData()]), this.$element;
    },
    unlock: function unlock(e) {
      return void 0 === e && (e = !0), this.enable(), this.showCancel && this.$container.find(".fileinput-cancel").hide(), this.showRemove && this.$container.find(".fileinput-remove").show(), e && this._resetFileStack(), this._raise("fileunlock", [this.filestack, this._getExtraData()]), this.$element;
    },
    cancel: function cancel() {
      var t,
          i = this,
          a = i.ajaxRequests,
          r = a.length;
      if (r > 0) for (t = 0; t < r; t += 1) {
        i.cancelling = !0, a[t].abort();
      }
      return i._setProgressCancelled(), i._getThumbs().each(function () {
        var t = e(this),
            a = t.attr("data-fileindex");
        t.removeClass("file-uploading"), void 0 !== i.filestack[a] && (t.find(".kv-file-upload").removeClass("disabled").removeAttr("disabled"), t.find(".kv-file-remove").removeClass("disabled").removeAttr("disabled")), i.unlock();
      }), i.$element;
    },
    clear: function clear() {
      var i,
          a = this;
      if (a._raise("fileclear")) return a.$btnUpload.removeAttr("disabled"), a._getThumbs().find("video,audio,img").each(function () {
        t.cleanMemory(e(this));
      }), a._clearFileInput(), a._resetUpload(), a.clearStack(), a._resetErrors(!0), a._hasInitialPreview() ? (a._showFileIcon(), a._resetPreview(), a._initPreviewActions(), a.$container.removeClass("file-input-new")) : (a._getThumbs().each(function () {
        a._clearObjects(e(this));
      }), a.isAjaxUpload && (a.previewCache.data = {}), a.$preview.html(""), i = !a.overwriteInitial && a.initialCaption.length > 0 ? a.initialCaption : "", a.$caption.attr("title", "").val(i), t.addCss(a.$container, "file-input-new"), a._validateDefaultPreview()), 0 === a.$container.find(t.FRAMES).length && (a._initCaption() || a.$captionContainer.removeClass("icon-visible")), a._hideFileIcon(), a._raise("filecleared"), a.$captionContainer.focus(), a._setFileDropZoneTitle(), a.$element;
    },
    reset: function reset() {
      if (this._raise("filereset")) return this._resetPreview(), this.$container.find(".fileinput-filename").text(""), t.addCss(this.$container, "file-input-new"), (this.getFrames().length || this.dropZoneEnabled) && this.$container.removeClass("file-input-new"), this.clearStack(), this.formdata = {}, this._setFileDropZoneTitle(), this.$element;
    },
    disable: function disable() {
      return this.isDisabled = !0, this._raise("filedisabled"), this.$element.attr("disabled", "disabled"), this.$container.find(".kv-fileinput-caption").addClass("file-caption-disabled"), this.$container.find(".fileinput-remove, .fileinput-upload, .file-preview-frame button").attr("disabled", !0), t.addCss(this.$container.find(".btn-file"), "disabled"), this._initDragDrop(), this.$element;
    },
    enable: function enable() {
      return this.isDisabled = !1, this._raise("fileenabled"), this.$element.removeAttr("disabled"), this.$container.find(".kv-fileinput-caption").removeClass("file-caption-disabled"), this.$container.find(".fileinput-remove, .fileinput-upload, .file-preview-frame button").removeAttr("disabled"), this.$container.find(".btn-file").removeClass("disabled"), this._initDragDrop(), this.$element;
    },
    upload: function upload() {
      var i,
          a,
          r,
          n = this.getFileStack().length,
          s = !e.isEmptyObject(this._getExtraData());
      if (this.isAjaxUpload && !this.isDisabled && this._isFileSelectionValid(n)) if (this._resetUpload(), 0 !== n || s) {
        if (this.$progress.show(), this.uploadCount = 0, this.uploadStatus = {}, this.uploadLog = [], this.lock(), this._setProgress(2), 0 === n && s) this._uploadExtraOnly();else {
          if (r = this.filestack.length, this.hasInitData = !1, !this.uploadAsync) return this._uploadBatch(), this.$element;

          for (a = this._getOutData(), this._raise("filebatchpreupload", [a]), this.fileBatchCompleted = !1, this.uploadCache = {
            content: [],
            config: [],
            tags: [],
            append: !0
          }, this.uploadAsyncCount = this.getFileStack().length, i = 0; i < r; i++) {
            this.uploadCache.content[i] = null, this.uploadCache.config[i] = null, this.uploadCache.tags[i] = null;
          }

          for (this.$preview.find(".file-preview-initial").removeClass(t.SORT_CSS), this._initSortable(), this.cacheInitialPreview = this.getPreview(), i = 0; i < r; i++) {
            this.filestack[i] && this._uploadSingle(i, !0);
          }
        }
      } else this._showUploadError(this.msgUploadEmpty);
    },
    destroy: function destroy() {
      var t = this.$form,
          i = this.$container,
          a = this.$element,
          r = this.namespace;
      return e(document).off(r), e(window).off(r), t && t.length && t.off(r), this.isAjaxUpload && this._clearFileInput(), this._cleanup(), this._initPreviewCache(), a.insertBefore(i).off(r).removeData(), i.off().remove(), a;
    },
    refresh: function refresh(i) {
      var a = this.$element;
      return i = "object" != _typeof2(i) || t.isEmpty(i) ? this.options : e.extend(!0, {}, this.options, i), this._init(i, !0), this._listen(), a;
    },
    zoom: function zoom(e) {
      var i = this._getFrame(e),
          a = this.$modal;

      i && (t.initModal(a), a.html(this._getModalContent()), this._setZoomContent(i), a.modal("show"), this._initZoomButtons());
    },
    getExif: function getExif(e) {
      var t = this._getFrame(e);

      return t && t.data("exif") || null;
    },
    getFrames: function getFrames(i) {
      var a;
      return i = i || "", a = this.$preview.find(t.FRAMES + i), this.reversePreviewOrder && (a = e(a.get().reverse())), a;
    },
    getPreview: function getPreview() {
      return {
        content: this.initialPreview,
        config: this.initialPreviewConfig,
        tags: this.initialPreviewThumbTags
      };
    }
  }, e.fn.fileinput = function (a) {
    if (t.hasFileAPISupport() || t.isIE(9)) {
      var r = Array.apply(null, arguments),
          n = [];

      switch (r.shift(), this.each(function () {
        var s,
            o = e(this),
            l = o.data("fileinput"),
            d = "object" == _typeof2(a) && a,
            c = d.theme || o.data("theme"),
            h = {},
            p = {},
            u = d.language || o.data("language") || e.fn.fileinput.defaults.language || "en";
        l || (c && (p = e.fn.fileinputThemes[c] || {}), "en" === u || t.isEmpty(e.fn.fileinputLocales[u]) || (h = e.fn.fileinputLocales[u] || {}), s = e.extend(!0, {}, e.fn.fileinput.defaults, p, e.fn.fileinputLocales.en, h, d, o.data()), l = new i(this, s), o.data("fileinput", l)), "string" == typeof a && n.push(l[a].apply(l, r));
      }), n.length) {
        case 0:
          return this;

        case 1:
          return n[0];

        default:
          return n;
      }
    }
  }, e.fn.fileinput.defaults = {
    language: "en",
    showCaption: !0,
    showBrowse: !0,
    showPreview: !0,
    showRemove: !0,
    showUpload: !0,
    showCancel: !0,
    showClose: !0,
    showUploadedThumbs: !0,
    browseOnZoneClick: !1,
    autoReplace: !1,
    autoOrientImage: !1,
    required: !1,
    rtl: !1,
    hideThumbnailContent: !1,
    generateFileId: null,
    previewClass: "",
    captionClass: "",
    frameClass: "krajee-default",
    mainClass: "file-caption-main",
    mainTemplate: null,
    purifyHtml: !0,
    fileSizeGetter: null,
    initialCaption: "",
    initialPreview: [],
    initialPreviewDelimiter: "*$$*",
    initialPreviewAsData: !1,
    initialPreviewFileType: "image",
    initialPreviewConfig: [],
    initialPreviewThumbTags: [],
    previewThumbTags: {},
    initialPreviewShowDelete: !0,
    initialPreviewDownloadUrl: "",
    removeFromPreviewOnError: !1,
    deleteUrl: "",
    deleteExtraData: {},
    overwriteInitial: !0,
    previewZoomButtonIcons: {
      prev: '<i class="glyphicon glyphicon-triangle-left"></i>',
      next: '<i class="glyphicon glyphicon-triangle-right"></i>',
      toggleheader: '<i class="glyphicon glyphicon-resize-vertical"></i>',
      fullscreen: '<i class="glyphicon glyphicon-fullscreen"></i>',
      borderless: '<i class="glyphicon glyphicon-resize-full"></i>',
      close: '<i class="glyphicon glyphicon-remove"></i>'
    },
    previewZoomButtonClasses: {
      prev: "btn btn-navigate",
      next: "btn btn-navigate",
      toggleheader: "btn btn-sm btn-kv btn-default btn-outline-secondary",
      fullscreen: "btn btn-sm btn-kv btn-default btn-outline-secondary",
      borderless: "btn btn-sm btn-kv btn-default btn-outline-secondary",
      close: "btn btn-sm btn-kv btn-default btn-outline-secondary"
    },
    previewTemplates: {},
    previewContentTemplates: {},
    preferIconicPreview: !1,
    preferIconicZoomPreview: !1,
    allowedPreviewTypes: void 0,
    allowedPreviewMimeTypes: null,
    allowedFileTypes: null,
    allowedFileExtensions: null,
    defaultPreviewContent: null,
    customLayoutTags: {},
    customPreviewTags: {},
    previewFileIcon: '<i class="glyphicon glyphicon-file"></i>',
    previewFileIconClass: "file-other-icon",
    previewFileIconSettings: {},
    previewFileExtSettings: {},
    buttonLabelClass: "hidden-xs",
    browseIcon: '<i class="glyphicon glyphicon-folder-open"></i>&nbsp;',
    browseClass: "btn btn-primary",
    removeIcon: '<i class="glyphicon glyphicon-trash"></i>',
    removeClass: "btn btn-default btn-secondary",
    cancelIcon: '<i class="glyphicon glyphicon-ban-circle"></i>',
    cancelClass: "btn btn-default btn-secondary",
    uploadIcon: '<i class="glyphicon glyphicon-upload"></i>',
    uploadClass: "btn btn-default btn-secondary",
    uploadUrl: null,
    uploadUrlThumb: null,
    uploadAsync: !0,
    uploadExtraData: {},
    zoomModalHeight: 480,
    minImageWidth: null,
    minImageHeight: null,
    maxImageWidth: null,
    maxImageHeight: null,
    resizeImage: !1,
    resizePreference: "width",
    resizeQuality: .92,
    resizeDefaultImageType: "image/jpeg",
    resizeIfSizeMoreThan: 0,
    minFileSize: 0,
    maxFileSize: 0,
    maxFilePreviewSize: 25600,
    minFileCount: 0,
    maxFileCount: 0,
    validateInitialCount: !1,
    msgValidationErrorClass: "text-danger",
    msgValidationErrorIcon: '<i class="glyphicon glyphicon-exclamation-sign"></i> ',
    msgErrorClass: "file-error-message",
    progressThumbClass: "progress-bar bg-success progress-bar-success progress-bar-striped active",
    progressClass: "progress-bar bg-success progress-bar-success progress-bar-striped active",
    progressCompleteClass: "progress-bar bg-success progress-bar-success",
    progressErrorClass: "progress-bar bg-danger progress-bar-danger",
    progressUploadThreshold: 99,
    previewFileType: "image",
    elCaptionContainer: null,
    elCaptionText: null,
    elPreviewContainer: null,
    elPreviewImage: null,
    elPreviewStatus: null,
    elErrorContainer: null,
    errorCloseButton: t.closeButton("kv-error-close"),
    slugCallback: null,
    dropZoneEnabled: !0,
    dropZoneTitleClass: "file-drop-zone-title",
    fileActionSettings: {},
    otherActionButtons: "",
    textEncoding: "UTF-8",
    ajaxSettings: {},
    ajaxDeleteSettings: {},
    showAjaxErrorDetails: !0,
    mergeAjaxCallbacks: !1,
    mergeAjaxDeleteCallbacks: !1,
    retryErrorUploads: !0,
    reversePreviewOrder: !1
  }, e.fn.fileinputLocales.en = {
    fileSingle: "file",
    filePlural: "files",
    browseLabel: "Browse &hellip;",
    removeLabel: "Remove",
    removeTitle: "Clear selected files",
    cancelLabel: "Cancel",
    cancelTitle: "Abort ongoing upload",
    uploadLabel: "Upload",
    uploadTitle: "Upload selected files",
    msgNo: "No",
    msgNoFilesSelected: "No files selected",
    msgCancelled: "Cancelled",
    msgPlaceholder: "Select {files}...",
    msgZoomModalHeading: "Detailed Preview",
    msgFileRequired: "You must select a file to upload.",
    msgSizeTooSmall: 'File "{name}" (<b>{size} KB</b>) is too small and must be larger than <b>{minSize} KB</b>.',
    msgSizeTooLarge: 'File "{name}" (<b>{size} KB</b>) exceeds maximum allowed upload size of <b>{maxSize} KB</b>.',
    msgFilesTooLess: "You must select at least <b>{n}</b> {files} to upload.",
    msgFilesTooMany: "Number of files selected for upload <b>({n})</b> exceeds maximum allowed limit of <b>{m}</b>.",
    msgFileNotFound: 'File "{name}" not found!',
    msgFileSecured: 'Security restrictions prevent reading the file "{name}".',
    msgFileNotReadable: 'File "{name}" is not readable.',
    msgFilePreviewAborted: 'File preview aborted for "{name}".',
    msgFilePreviewError: 'An error occurred while reading the file "{name}".',
    msgInvalidFileName: 'Invalid or unsupported characters in file name "{name}".',
    msgInvalidFileType: 'Invalid type for file "{name}". Only "{types}" files are supported.',
    msgInvalidFileExtension: 'Invalid extension for file "{name}". Only "{extensions}" files are supported.',
    msgFileTypes: {
      image: "image",
      html: "HTML",
      text: "text",
      video: "video",
      audio: "audio",
      flash: "flash",
      pdf: "PDF",
      object: "object"
    },
    msgUploadAborted: "The file upload was aborted",
    msgUploadThreshold: "Processing...",
    msgUploadBegin: "Initializing...",
    msgUploadEnd: "Done",
    msgUploadEmpty: "No valid data available for upload.",
    msgUploadError: "Error",
    msgValidationError: "Validation Error",
    msgLoading: "Loading file {index} of {files} &hellip;",
    msgProgress: "Loading file {index} of {files} - {name} - {percent}% completed.",
    msgSelected: "{n} {files} selected",
    msgFoldersNotAllowed: "Drag & drop files only! {n} folder(s) dropped were skipped.",
    msgImageWidthSmall: 'Width of image file "{name}" must be at least {size} px.',
    msgImageHeightSmall: 'Height of image file "{name}" must be at least {size} px.',
    msgImageWidthLarge: 'Width of image file "{name}" cannot exceed {size} px.',
    msgImageHeightLarge: 'Height of image file "{name}" cannot exceed {size} px.',
    msgImageResizeError: "Could not get the image dimensions to resize.",
    msgImageResizeException: "Error while resizing the image.<pre>{errors}</pre>",
    msgAjaxError: "Something went wrong with the {operation} operation. Please try again later!",
    msgAjaxProgressError: "{operation} failed",
    ajaxOperations: {
      deleteThumb: "file delete",
      uploadThumb: "file upload",
      uploadBatch: "batch file upload",
      uploadExtra: "form data upload"
    },
    dropZoneTitle: "Drag & drop files here &hellip;",
    dropZoneClickTitle: "<br>(or click to select {files})",
    previewZoomButtonTitles: {
      prev: "View previous file",
      next: "View next file",
      toggleheader: "Toggle header",
      fullscreen: "Toggle full screen",
      borderless: "Toggle borderless mode",
      close: "Close detailed preview"
    },
    usePdfRenderer: function usePdfRenderer() {
      return !!navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/i);
    },
    pdfRendererUrl: "",
    pdfRendererTemplate: '<iframe class="kv-preview-data file-preview-pdf" src="{renderer}?file={data}" {style}></iframe>'
  }, e.fn.fileinput.Constructor = i, e(document).ready(function () {
    var t = e("input.file[type=file]");
    t.length && t.fileinput();
  });
});
/*!
 * Masonry PACKAGED v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

!function (t, e) {
  "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
    return e(t, i);
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery);
}(window, function (t, e) {
  "use strict";

  function i(i, r, a) {
    function h(t, e, n) {
      var o,
          r = "$()." + i + '("' + e + '")';
      return t.each(function (t, h) {
        var u = a.data(h, i);
        if (!u) return void s(i + " not initialized. Cannot call methods, i.e. " + r);
        var d = u[e];
        if (!d || "_" == e.charAt(0)) return void s(r + " is not a valid method");
        var l = d.apply(u, n);
        o = void 0 === o ? l : o;
      }), void 0 !== o ? o : t;
    }

    function u(t, e) {
      t.each(function (t, n) {
        var o = a.data(n, i);
        o ? (o.option(e), o._init()) : (o = new r(n, e), a.data(n, i, o));
      });
    }

    a = a || e || t.jQuery, a && (r.prototype.option || (r.prototype.option = function (t) {
      a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t));
    }), a.fn[i] = function (t) {
      if ("string" == typeof t) {
        var e = o.call(arguments, 1);
        return h(this, t, e);
      }

      return u(this, t), this;
    }, n(a));
  }

  function n(t) {
    !t || t && t.bridget || (t.bridget = i);
  }

  var o = Array.prototype.slice,
      r = t.console,
      s = "undefined" == typeof r ? function () {} : function (t) {
    r.error(t);
  };
  return n(e || t.jQuery), i;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e() : t.EvEmitter = e();
}("undefined" != typeof window ? window : this, function () {
  function t() {}

  var e = t.prototype;
  return e.on = function (t, e) {
    if (t && e) {
      var i = this._events = this._events || {},
          n = i[t] = i[t] || [];
      return -1 == n.indexOf(e) && n.push(e), this;
    }
  }, e.once = function (t, e) {
    if (t && e) {
      this.on(t, e);
      var i = this._onceEvents = this._onceEvents || {},
          n = i[t] = i[t] || {};
      return n[e] = !0, this;
    }
  }, e.off = function (t, e) {
    var i = this._events && this._events[t];

    if (i && i.length) {
      var n = i.indexOf(e);
      return -1 != n && i.splice(n, 1), this;
    }
  }, e.emitEvent = function (t, e) {
    var i = this._events && this._events[t];

    if (i && i.length) {
      i = i.slice(0), e = e || [];

      for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
        var r = i[o],
            s = n && n[r];
        s && (this.off(t, r), delete n[r]), r.apply(this, e);
      }

      return this;
    }
  }, e.allOff = function () {
    delete this._events, delete this._onceEvents;
  }, t;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e() : t.getSize = e();
}(window, function () {
  "use strict";

  function t(t) {
    var e = parseFloat(t),
        i = -1 == t.indexOf("%") && !isNaN(e);
    return i && e;
  }

  function e() {}

  function i() {
    for (var t = {
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0,
      outerWidth: 0,
      outerHeight: 0
    }, e = 0; u > e; e++) {
      var i = h[e];
      t[i] = 0;
    }

    return t;
  }

  function n(t) {
    var e = getComputedStyle(t);
    return e || a("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e;
  }

  function o() {
    if (!d) {
      d = !0;
      var e = document.createElement("div");
      e.style.width = "200px", e.style.padding = "1px 2px 3px 4px", e.style.borderStyle = "solid", e.style.borderWidth = "1px 2px 3px 4px", e.style.boxSizing = "border-box";
      var i = document.body || document.documentElement;
      i.appendChild(e);
      var o = n(e);
      s = 200 == Math.round(t(o.width)), r.isBoxSizeOuter = s, i.removeChild(e);
    }
  }

  function r(e) {
    if (o(), "string" == typeof e && (e = document.querySelector(e)), e && "object" == _typeof2(e) && e.nodeType) {
      var r = n(e);
      if ("none" == r.display) return i();
      var a = {};
      a.width = e.offsetWidth, a.height = e.offsetHeight;

      for (var d = a.isBorderBox = "border-box" == r.boxSizing, l = 0; u > l; l++) {
        var c = h[l],
            f = r[c],
            m = parseFloat(f);
        a[c] = isNaN(m) ? 0 : m;
      }

      var p = a.paddingLeft + a.paddingRight,
          g = a.paddingTop + a.paddingBottom,
          y = a.marginLeft + a.marginRight,
          v = a.marginTop + a.marginBottom,
          _ = a.borderLeftWidth + a.borderRightWidth,
          z = a.borderTopWidth + a.borderBottomWidth,
          E = d && s,
          b = t(r.width);

      b !== !1 && (a.width = b + (E ? 0 : p + _));
      var x = t(r.height);
      return x !== !1 && (a.height = x + (E ? 0 : g + z)), a.innerWidth = a.width - (p + _), a.innerHeight = a.height - (g + z), a.outerWidth = a.width + y, a.outerHeight = a.height + v, a;
    }
  }

  var s,
      a = "undefined" == typeof console ? e : function (t) {
    console.error(t);
  },
      h = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
      u = h.length,
      d = !1;
  return r;
}), function (t, e) {
  "use strict";

  "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e() : t.matchesSelector = e();
}(window, function () {
  "use strict";

  var t = function () {
    var t = window.Element.prototype;
    if (t.matches) return "matches";
    if (t.matchesSelector) return "matchesSelector";

    for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
      var n = e[i],
          o = n + "MatchesSelector";
      if (t[o]) return o;
    }
  }();

  return function (e, i) {
    return e[t](i);
  };
}), function (t, e) {
  "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (i) {
    return e(t, i);
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector);
}(window, function (t, e) {
  var i = {};
  i.extend = function (t, e) {
    for (var i in e) {
      t[i] = e[i];
    }

    return t;
  }, i.modulo = function (t, e) {
    return (t % e + e) % e;
  };
  var n = Array.prototype.slice;
  i.makeArray = function (t) {
    if (Array.isArray(t)) return t;
    if (null === t || void 0 === t) return [];
    var e = "object" == _typeof2(t) && "number" == typeof t.length;
    return e ? n.call(t) : [t];
  }, i.removeFrom = function (t, e) {
    var i = t.indexOf(e);
    -1 != i && t.splice(i, 1);
  }, i.getParent = function (t, i) {
    for (; t.parentNode && t != document.body;) {
      if (t = t.parentNode, e(t, i)) return t;
    }
  }, i.getQueryElement = function (t) {
    return "string" == typeof t ? document.querySelector(t) : t;
  }, i.handleEvent = function (t) {
    var e = "on" + t.type;
    this[e] && this[e](t);
  }, i.filterFindElements = function (t, n) {
    t = i.makeArray(t);
    var o = [];
    return t.forEach(function (t) {
      if (t instanceof HTMLElement) {
        if (!n) return void o.push(t);
        e(t, n) && o.push(t);

        for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++) {
          o.push(i[r]);
        }
      }
    }), o;
  }, i.debounceMethod = function (t, e, i) {
    i = i || 100;
    var n = t.prototype[e],
        o = e + "Timeout";

    t.prototype[e] = function () {
      var t = this[o];
      clearTimeout(t);
      var e = arguments,
          r = this;
      this[o] = setTimeout(function () {
        n.apply(r, e), delete r[o];
      }, i);
    };
  }, i.docReady = function (t) {
    var e = document.readyState;
    "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
  }, i.toDashed = function (t) {
    return t.replace(/(.)([A-Z])/g, function (t, e, i) {
      return e + "-" + i;
    }).toLowerCase();
  };
  var o = t.console;
  return i.htmlInit = function (e, n) {
    i.docReady(function () {
      var r = i.toDashed(n),
          s = "data-" + r,
          a = document.querySelectorAll("[" + s + "]"),
          h = document.querySelectorAll(".js-" + r),
          u = i.makeArray(a).concat(i.makeArray(h)),
          d = s + "-options",
          l = t.jQuery;
      u.forEach(function (t) {
        var i,
            r = t.getAttribute(s) || t.getAttribute(d);

        try {
          i = r && JSON.parse(r);
        } catch (a) {
          return void (o && o.error("Error parsing " + s + " on " + t.className + ": " + a));
        }

        var h = new e(t, i);
        l && l.data(t, n, h);
      });
    });
  }, i;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize));
}(window, function (t, e) {
  "use strict";

  function i(t) {
    for (var e in t) {
      return !1;
    }

    return e = null, !0;
  }

  function n(t, e) {
    t && (this.element = t, this.layout = e, this.position = {
      x: 0,
      y: 0
    }, this._create());
  }

  function o(t) {
    return t.replace(/([A-Z])/g, function (t) {
      return "-" + t.toLowerCase();
    });
  }

  var r = document.documentElement.style,
      s = "string" == typeof r.transition ? "transition" : "WebkitTransition",
      a = "string" == typeof r.transform ? "transform" : "WebkitTransform",
      h = {
    WebkitTransition: "webkitTransitionEnd",
    transition: "transitionend"
  }[s],
      u = {
    transform: a,
    transition: s,
    transitionDuration: s + "Duration",
    transitionProperty: s + "Property",
    transitionDelay: s + "Delay"
  },
      d = n.prototype = Object.create(t.prototype);
  d.constructor = n, d._create = function () {
    this._transn = {
      ingProperties: {},
      clean: {},
      onEnd: {}
    }, this.css({
      position: "absolute"
    });
  }, d.handleEvent = function (t) {
    var e = "on" + t.type;
    this[e] && this[e](t);
  }, d.getSize = function () {
    this.size = e(this.element);
  }, d.css = function (t) {
    var e = this.element.style;

    for (var i in t) {
      var n = u[i] || i;
      e[n] = t[i];
    }
  }, d.getPosition = function () {
    var t = getComputedStyle(this.element),
        e = this.layout._getOption("originLeft"),
        i = this.layout._getOption("originTop"),
        n = t[e ? "left" : "right"],
        o = t[i ? "top" : "bottom"],
        r = parseFloat(n),
        s = parseFloat(o),
        a = this.layout.size;

    -1 != n.indexOf("%") && (r = r / 100 * a.width), -1 != o.indexOf("%") && (s = s / 100 * a.height), r = isNaN(r) ? 0 : r, s = isNaN(s) ? 0 : s, r -= e ? a.paddingLeft : a.paddingRight, s -= i ? a.paddingTop : a.paddingBottom, this.position.x = r, this.position.y = s;
  }, d.layoutPosition = function () {
    var t = this.layout.size,
        e = {},
        i = this.layout._getOption("originLeft"),
        n = this.layout._getOption("originTop"),
        o = i ? "paddingLeft" : "paddingRight",
        r = i ? "left" : "right",
        s = i ? "right" : "left",
        a = this.position.x + t[o];

    e[r] = this.getXValue(a), e[s] = "";
    var h = n ? "paddingTop" : "paddingBottom",
        u = n ? "top" : "bottom",
        d = n ? "bottom" : "top",
        l = this.position.y + t[h];
    e[u] = this.getYValue(l), e[d] = "", this.css(e), this.emitEvent("layout", [this]);
  }, d.getXValue = function (t) {
    var e = this.layout._getOption("horizontal");

    return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px";
  }, d.getYValue = function (t) {
    var e = this.layout._getOption("horizontal");

    return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px";
  }, d._transitionTo = function (t, e) {
    this.getPosition();
    var i = this.position.x,
        n = this.position.y,
        o = t == this.position.x && e == this.position.y;
    if (this.setPosition(t, e), o && !this.isTransitioning) return void this.layoutPosition();
    var r = t - i,
        s = e - n,
        a = {};
    a.transform = this.getTranslate(r, s), this.transition({
      to: a,
      onTransitionEnd: {
        transform: this.layoutPosition
      },
      isCleaning: !0
    });
  }, d.getTranslate = function (t, e) {
    var i = this.layout._getOption("originLeft"),
        n = this.layout._getOption("originTop");

    return t = i ? t : -t, e = n ? e : -e, "translate3d(" + t + "px, " + e + "px, 0)";
  }, d.goTo = function (t, e) {
    this.setPosition(t, e), this.layoutPosition();
  }, d.moveTo = d._transitionTo, d.setPosition = function (t, e) {
    this.position.x = parseFloat(t), this.position.y = parseFloat(e);
  }, d._nonTransition = function (t) {
    this.css(t.to), t.isCleaning && this._removeStyles(t.to);

    for (var e in t.onTransitionEnd) {
      t.onTransitionEnd[e].call(this);
    }
  }, d.transition = function (t) {
    if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(t);
    var e = this._transn;

    for (var i in t.onTransitionEnd) {
      e.onEnd[i] = t.onTransitionEnd[i];
    }

    for (i in t.to) {
      e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
    }

    if (t.from) {
      this.css(t.from);
      var n = this.element.offsetHeight;
      n = null;
    }

    this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0;
  };
  var l = "opacity," + o(a);
  d.enableTransition = function () {
    if (!this.isTransitioning) {
      var t = this.layout.options.transitionDuration;
      t = "number" == typeof t ? t + "ms" : t, this.css({
        transitionProperty: l,
        transitionDuration: t,
        transitionDelay: this.staggerDelay || 0
      }), this.element.addEventListener(h, this, !1);
    }
  }, d.onwebkitTransitionEnd = function (t) {
    this.ontransitionend(t);
  }, d.onotransitionend = function (t) {
    this.ontransitionend(t);
  };
  var c = {
    "-webkit-transform": "transform"
  };
  d.ontransitionend = function (t) {
    if (t.target === this.element) {
      var e = this._transn,
          n = c[t.propertyName] || t.propertyName;

      if (delete e.ingProperties[n], i(e.ingProperties) && this.disableTransition(), n in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[n]), n in e.onEnd) {
        var o = e.onEnd[n];
        o.call(this), delete e.onEnd[n];
      }

      this.emitEvent("transitionEnd", [this]);
    }
  }, d.disableTransition = function () {
    this.removeTransitionStyles(), this.element.removeEventListener(h, this, !1), this.isTransitioning = !1;
  }, d._removeStyles = function (t) {
    var e = {};

    for (var i in t) {
      e[i] = "";
    }

    this.css(e);
  };
  var f = {
    transitionProperty: "",
    transitionDuration: "",
    transitionDelay: ""
  };
  return d.removeTransitionStyles = function () {
    this.css(f);
  }, d.stagger = function (t) {
    t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms";
  }, d.removeElem = function () {
    this.element.parentNode.removeChild(this.element), this.css({
      display: ""
    }), this.emitEvent("remove", [this]);
  }, d.remove = function () {
    return s && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function () {
      this.removeElem();
    }), void this.hide()) : void this.removeElem();
  }, d.reveal = function () {
    delete this.isHidden, this.css({
      display: ""
    });
    var t = this.layout.options,
        e = {},
        i = this.getHideRevealTransitionEndProperty("visibleStyle");
    e[i] = this.onRevealTransitionEnd, this.transition({
      from: t.hiddenStyle,
      to: t.visibleStyle,
      isCleaning: !0,
      onTransitionEnd: e
    });
  }, d.onRevealTransitionEnd = function () {
    this.isHidden || this.emitEvent("reveal");
  }, d.getHideRevealTransitionEndProperty = function (t) {
    var e = this.layout.options[t];
    if (e.opacity) return "opacity";

    for (var i in e) {
      return i;
    }
  }, d.hide = function () {
    this.isHidden = !0, this.css({
      display: ""
    });
    var t = this.layout.options,
        e = {},
        i = this.getHideRevealTransitionEndProperty("hiddenStyle");
    e[i] = this.onHideTransitionEnd, this.transition({
      from: t.visibleStyle,
      to: t.hiddenStyle,
      isCleaning: !0,
      onTransitionEnd: e
    });
  }, d.onHideTransitionEnd = function () {
    this.isHidden && (this.css({
      display: "none"
    }), this.emitEvent("hide"));
  }, d.destroy = function () {
    this.css({
      position: "",
      left: "",
      right: "",
      top: "",
      bottom: "",
      transition: "",
      transform: ""
    });
  }, n;
}), function (t, e) {
  "use strict";

  "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function (i, n, o, r) {
    return e(t, i, n, o, r);
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item);
}(window, function (t, e, i, n, o) {
  "use strict";

  function r(t, e) {
    var i = n.getQueryElement(t);
    if (!i) return void (h && h.error("Bad element for " + this.constructor.namespace + ": " + (i || t)));
    this.element = i, u && (this.$element = u(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(e);
    var o = ++l;
    this.element.outlayerGUID = o, c[o] = this, this._create();

    var r = this._getOption("initLayout");

    r && this.layout();
  }

  function s(t) {
    function e() {
      t.apply(this, arguments);
    }

    return e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e;
  }

  function a(t) {
    if ("number" == typeof t) return t;
    var e = t.match(/(^\d*\.?\d*)(\w*)/),
        i = e && e[1],
        n = e && e[2];
    if (!i.length) return 0;
    i = parseFloat(i);
    var o = m[n] || 1;
    return i * o;
  }

  var h = t.console,
      u = t.jQuery,
      d = function d() {},
      l = 0,
      c = {};

  r.namespace = "outlayer", r.Item = o, r.defaults = {
    containerStyle: {
      position: "relative"
    },
    initLayout: !0,
    originLeft: !0,
    originTop: !0,
    resize: !0,
    resizeContainer: !0,
    transitionDuration: "0.4s",
    hiddenStyle: {
      opacity: 0,
      transform: "scale(0.001)"
    },
    visibleStyle: {
      opacity: 1,
      transform: "scale(1)"
    }
  };
  var f = r.prototype;
  n.extend(f, e.prototype), f.option = function (t) {
    n.extend(this.options, t);
  }, f._getOption = function (t) {
    var e = this.constructor.compatOptions[t];
    return e && void 0 !== this.options[e] ? this.options[e] : this.options[t];
  }, r.compatOptions = {
    initLayout: "isInitLayout",
    horizontal: "isHorizontal",
    layoutInstant: "isLayoutInstant",
    originLeft: "isOriginLeft",
    originTop: "isOriginTop",
    resize: "isResizeBound",
    resizeContainer: "isResizingContainer"
  }, f._create = function () {
    this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle);

    var t = this._getOption("resize");

    t && this.bindResize();
  }, f.reloadItems = function () {
    this.items = this._itemize(this.element.children);
  }, f._itemize = function (t) {
    for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
      var r = e[o],
          s = new i(r, this);
      n.push(s);
    }

    return n;
  }, f._filterFindItemElements = function (t) {
    return n.filterFindElements(t, this.options.itemSelector);
  }, f.getItemElements = function () {
    return this.items.map(function (t) {
      return t.element;
    });
  }, f.layout = function () {
    this._resetLayout(), this._manageStamps();

    var t = this._getOption("layoutInstant"),
        e = void 0 !== t ? t : !this._isLayoutInited;

    this.layoutItems(this.items, e), this._isLayoutInited = !0;
  }, f._init = f.layout, f._resetLayout = function () {
    this.getSize();
  }, f.getSize = function () {
    this.size = i(this.element);
  }, f._getMeasurement = function (t, e) {
    var n,
        o = this.options[t];
    o ? ("string" == typeof o ? n = this.element.querySelector(o) : o instanceof HTMLElement && (n = o), this[t] = n ? i(n)[e] : o) : this[t] = 0;
  }, f.layoutItems = function (t, e) {
    t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout();
  }, f._getItemsForLayout = function (t) {
    return t.filter(function (t) {
      return !t.isIgnored;
    });
  }, f._layoutItems = function (t, e) {
    if (this._emitCompleteOnItems("layout", t), t && t.length) {
      var i = [];
      t.forEach(function (t) {
        var n = this._getItemLayoutPosition(t);

        n.item = t, n.isInstant = e || t.isLayoutInstant, i.push(n);
      }, this), this._processLayoutQueue(i);
    }
  }, f._getItemLayoutPosition = function () {
    return {
      x: 0,
      y: 0
    };
  }, f._processLayoutQueue = function (t) {
    this.updateStagger(), t.forEach(function (t, e) {
      this._positionItem(t.item, t.x, t.y, t.isInstant, e);
    }, this);
  }, f.updateStagger = function () {
    var t = this.options.stagger;
    return null === t || void 0 === t ? void (this.stagger = 0) : (this.stagger = a(t), this.stagger);
  }, f._positionItem = function (t, e, i, n, o) {
    n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i));
  }, f._postLayout = function () {
    this.resizeContainer();
  }, f.resizeContainer = function () {
    var t = this._getOption("resizeContainer");

    if (t) {
      var e = this._getContainerSize();

      e && (this._setContainerMeasure(e.width, !0), this._setContainerMeasure(e.height, !1));
    }
  }, f._getContainerSize = d, f._setContainerMeasure = function (t, e) {
    if (void 0 !== t) {
      var i = this.size;
      i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px";
    }
  }, f._emitCompleteOnItems = function (t, e) {
    function i() {
      o.dispatchEvent(t + "Complete", null, [e]);
    }

    function n() {
      s++, s == r && i();
    }

    var o = this,
        r = e.length;
    if (!e || !r) return void i();
    var s = 0;
    e.forEach(function (e) {
      e.once(t, n);
    });
  }, f.dispatchEvent = function (t, e, i) {
    var n = e ? [e].concat(i) : i;
    if (this.emitEvent(t, n), u) if (this.$element = this.$element || u(this.element), e) {
      var o = u.Event(e);
      o.type = t, this.$element.trigger(o, i);
    } else this.$element.trigger(t, i);
  }, f.ignore = function (t) {
    var e = this.getItem(t);
    e && (e.isIgnored = !0);
  }, f.unignore = function (t) {
    var e = this.getItem(t);
    e && delete e.isIgnored;
  }, f.stamp = function (t) {
    t = this._find(t), t && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this));
  }, f.unstamp = function (t) {
    t = this._find(t), t && t.forEach(function (t) {
      n.removeFrom(this.stamps, t), this.unignore(t);
    }, this);
  }, f._find = function (t) {
    return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), t = n.makeArray(t)) : void 0;
  }, f._manageStamps = function () {
    this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
  }, f._getBoundingRect = function () {
    var t = this.element.getBoundingClientRect(),
        e = this.size;
    this._boundingRect = {
      left: t.left + e.paddingLeft + e.borderLeftWidth,
      top: t.top + e.paddingTop + e.borderTopWidth,
      right: t.right - (e.paddingRight + e.borderRightWidth),
      bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
    };
  }, f._manageStamp = d, f._getElementOffset = function (t) {
    var e = t.getBoundingClientRect(),
        n = this._boundingRect,
        o = i(t),
        r = {
      left: e.left - n.left - o.marginLeft,
      top: e.top - n.top - o.marginTop,
      right: n.right - e.right - o.marginRight,
      bottom: n.bottom - e.bottom - o.marginBottom
    };
    return r;
  }, f.handleEvent = n.handleEvent, f.bindResize = function () {
    t.addEventListener("resize", this), this.isResizeBound = !0;
  }, f.unbindResize = function () {
    t.removeEventListener("resize", this), this.isResizeBound = !1;
  }, f.onresize = function () {
    this.resize();
  }, n.debounceMethod(r, "onresize", 100), f.resize = function () {
    this.isResizeBound && this.needsResizeLayout() && this.layout();
  }, f.needsResizeLayout = function () {
    var t = i(this.element),
        e = this.size && t;
    return e && t.innerWidth !== this.size.innerWidth;
  }, f.addItems = function (t) {
    var e = this._itemize(t);

    return e.length && (this.items = this.items.concat(e)), e;
  }, f.appended = function (t) {
    var e = this.addItems(t);
    e.length && (this.layoutItems(e, !0), this.reveal(e));
  }, f.prepended = function (t) {
    var e = this._itemize(t);

    if (e.length) {
      var i = this.items.slice(0);
      this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i);
    }
  }, f.reveal = function (t) {
    if (this._emitCompleteOnItems("reveal", t), t && t.length) {
      var e = this.updateStagger();
      t.forEach(function (t, i) {
        t.stagger(i * e), t.reveal();
      });
    }
  }, f.hide = function (t) {
    if (this._emitCompleteOnItems("hide", t), t && t.length) {
      var e = this.updateStagger();
      t.forEach(function (t, i) {
        t.stagger(i * e), t.hide();
      });
    }
  }, f.revealItemElements = function (t) {
    var e = this.getItems(t);
    this.reveal(e);
  }, f.hideItemElements = function (t) {
    var e = this.getItems(t);
    this.hide(e);
  }, f.getItem = function (t) {
    for (var e = 0; e < this.items.length; e++) {
      var i = this.items[e];
      if (i.element == t) return i;
    }
  }, f.getItems = function (t) {
    t = n.makeArray(t);
    var e = [];
    return t.forEach(function (t) {
      var i = this.getItem(t);
      i && e.push(i);
    }, this), e;
  }, f.remove = function (t) {
    var e = this.getItems(t);
    this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function (t) {
      t.remove(), n.removeFrom(this.items, t);
    }, this);
  }, f.destroy = function () {
    var t = this.element.style;
    t.height = "", t.position = "", t.width = "", this.items.forEach(function (t) {
      t.destroy();
    }), this.unbindResize();
    var e = this.element.outlayerGUID;
    delete c[e], delete this.element.outlayerGUID, u && u.removeData(this.element, this.constructor.namespace);
  }, r.data = function (t) {
    t = n.getQueryElement(t);
    var e = t && t.outlayerGUID;
    return e && c[e];
  }, r.create = function (t, e) {
    var i = s(r);
    return i.defaults = n.extend({}, r.defaults), n.extend(i.defaults, e), i.compatOptions = n.extend({}, r.compatOptions), i.namespace = t, i.data = r.data, i.Item = s(o), n.htmlInit(i, t), u && u.bridget && u.bridget(t, i), i;
  };
  var m = {
    ms: 1,
    s: 1e3
  };
  return r.Item = o, r;
}), function (t, e) {
  "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize);
}(window, function (t, e) {
  var i = t.create("masonry");
  i.compatOptions.fitWidth = "isFitWidth";
  var n = i.prototype;
  return n._resetLayout = function () {
    this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];

    for (var t = 0; t < this.cols; t++) {
      this.colYs.push(0);
    }

    this.maxY = 0, this.horizontalColIndex = 0;
  }, n.measureColumns = function () {
    if (this.getContainerWidth(), !this.columnWidth) {
      var t = this.items[0],
          i = t && t.element;
      this.columnWidth = i && e(i).outerWidth || this.containerWidth;
    }

    var n = this.columnWidth += this.gutter,
        o = this.containerWidth + this.gutter,
        r = o / n,
        s = n - o % n,
        a = s && 1 > s ? "round" : "floor";
    r = Math[a](r), this.cols = Math.max(r, 1);
  }, n.getContainerWidth = function () {
    var t = this._getOption("fitWidth"),
        i = t ? this.element.parentNode : this.element,
        n = e(i);

    this.containerWidth = n && n.innerWidth;
  }, n._getItemLayoutPosition = function (t) {
    t.getSize();
    var e = t.size.outerWidth % this.columnWidth,
        i = e && 1 > e ? "round" : "ceil",
        n = Math[i](t.size.outerWidth / this.columnWidth);
    n = Math.min(n, this.cols);

    for (var o = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", r = this[o](n, t), s = {
      x: this.columnWidth * r.col,
      y: r.y
    }, a = r.y + t.size.outerHeight, h = n + r.col, u = r.col; h > u; u++) {
      this.colYs[u] = a;
    }

    return s;
  }, n._getTopColPosition = function (t) {
    var e = this._getTopColGroup(t),
        i = Math.min.apply(Math, e);

    return {
      col: e.indexOf(i),
      y: i
    };
  }, n._getTopColGroup = function (t) {
    if (2 > t) return this.colYs;

    for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++) {
      e[n] = this._getColGroupY(n, t);
    }

    return e;
  }, n._getColGroupY = function (t, e) {
    if (2 > e) return this.colYs[t];
    var i = this.colYs.slice(t, t + e);
    return Math.max.apply(Math, i);
  }, n._getHorizontalColPosition = function (t, e) {
    var i = this.horizontalColIndex % this.cols,
        n = t > 1 && i + t > this.cols;
    i = n ? 0 : i;
    var o = e.size.outerWidth && e.size.outerHeight;
    return this.horizontalColIndex = o ? i + t : this.horizontalColIndex, {
      col: i,
      y: this._getColGroupY(i, t)
    };
  }, n._manageStamp = function (t) {
    var i = e(t),
        n = this._getElementOffset(t),
        o = this._getOption("originLeft"),
        r = o ? n.left : n.right,
        s = r + i.outerWidth,
        a = Math.floor(r / this.columnWidth);

    a = Math.max(0, a);
    var h = Math.floor(s / this.columnWidth);
    h -= s % this.columnWidth ? 0 : 1, h = Math.min(this.cols - 1, h);

    for (var u = this._getOption("originTop"), d = (u ? n.top : n.bottom) + i.outerHeight, l = a; h >= l; l++) {
      this.colYs[l] = Math.max(d, this.colYs[l]);
    }
  }, n._getContainerSize = function () {
    this.maxY = Math.max.apply(Math, this.colYs);
    var t = {
      height: this.maxY
    };
    return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t;
  }, n._getContainerFitWidth = function () {
    for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];) {
      t++;
    }

    return (this.cols - t) * this.columnWidth - this.gutter;
  }, n.needsResizeLayout = function () {
    var t = this.containerWidth;
    return this.getContainerWidth(), t != this.containerWidth;
  }, i;
});
/*!
 * Isotope PACKAGED v3.0.6
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * https://isotope.metafizzy.co
 * Copyright 2010-2018 Metafizzy
 */

!function (t, e) {
  "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
    return e(t, i);
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery);
}(window, function (t, e) {
  "use strict";

  function i(i, s, a) {
    function u(t, e, o) {
      var n,
          s = "$()." + i + '("' + e + '")';
      return t.each(function (t, u) {
        var h = a.data(u, i);
        if (!h) return void r(i + " not initialized. Cannot call methods, i.e. " + s);
        var d = h[e];
        if (!d || "_" == e.charAt(0)) return void r(s + " is not a valid method");
        var l = d.apply(h, o);
        n = void 0 === n ? l : n;
      }), void 0 !== n ? n : t;
    }

    function h(t, e) {
      t.each(function (t, o) {
        var n = a.data(o, i);
        n ? (n.option(e), n._init()) : (n = new s(o, e), a.data(o, i, n));
      });
    }

    a = a || e || t.jQuery, a && (s.prototype.option || (s.prototype.option = function (t) {
      a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t));
    }), a.fn[i] = function (t) {
      if ("string" == typeof t) {
        var e = n.call(arguments, 1);
        return u(this, t, e);
      }

      return h(this, t), this;
    }, o(a));
  }

  function o(t) {
    !t || t && t.bridget || (t.bridget = i);
  }

  var n = Array.prototype.slice,
      s = t.console,
      r = "undefined" == typeof s ? function () {} : function (t) {
    s.error(t);
  };
  return o(e || t.jQuery), i;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e() : t.EvEmitter = e();
}("undefined" != typeof window ? window : this, function () {
  function t() {}

  var e = t.prototype;
  return e.on = function (t, e) {
    if (t && e) {
      var i = this._events = this._events || {},
          o = i[t] = i[t] || [];
      return o.indexOf(e) == -1 && o.push(e), this;
    }
  }, e.once = function (t, e) {
    if (t && e) {
      this.on(t, e);
      var i = this._onceEvents = this._onceEvents || {},
          o = i[t] = i[t] || {};
      return o[e] = !0, this;
    }
  }, e.off = function (t, e) {
    var i = this._events && this._events[t];

    if (i && i.length) {
      var o = i.indexOf(e);
      return o != -1 && i.splice(o, 1), this;
    }
  }, e.emitEvent = function (t, e) {
    var i = this._events && this._events[t];

    if (i && i.length) {
      i = i.slice(0), e = e || [];

      for (var o = this._onceEvents && this._onceEvents[t], n = 0; n < i.length; n++) {
        var s = i[n],
            r = o && o[s];
        r && (this.off(t, s), delete o[s]), s.apply(this, e);
      }

      return this;
    }
  }, e.allOff = function () {
    delete this._events, delete this._onceEvents;
  }, t;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e() : t.getSize = e();
}(window, function () {
  "use strict";

  function t(t) {
    var e = parseFloat(t),
        i = t.indexOf("%") == -1 && !isNaN(e);
    return i && e;
  }

  function e() {}

  function i() {
    for (var t = {
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0,
      outerWidth: 0,
      outerHeight: 0
    }, e = 0; e < h; e++) {
      var i = u[e];
      t[i] = 0;
    }

    return t;
  }

  function o(t) {
    var e = getComputedStyle(t);
    return e || a("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e;
  }

  function n() {
    if (!d) {
      d = !0;
      var e = document.createElement("div");
      e.style.width = "200px", e.style.padding = "1px 2px 3px 4px", e.style.borderStyle = "solid", e.style.borderWidth = "1px 2px 3px 4px", e.style.boxSizing = "border-box";
      var i = document.body || document.documentElement;
      i.appendChild(e);
      var n = o(e);
      r = 200 == Math.round(t(n.width)), s.isBoxSizeOuter = r, i.removeChild(e);
    }
  }

  function s(e) {
    if (n(), "string" == typeof e && (e = document.querySelector(e)), e && "object" == _typeof2(e) && e.nodeType) {
      var s = o(e);
      if ("none" == s.display) return i();
      var a = {};
      a.width = e.offsetWidth, a.height = e.offsetHeight;

      for (var d = a.isBorderBox = "border-box" == s.boxSizing, l = 0; l < h; l++) {
        var f = u[l],
            c = s[f],
            m = parseFloat(c);
        a[f] = isNaN(m) ? 0 : m;
      }

      var p = a.paddingLeft + a.paddingRight,
          y = a.paddingTop + a.paddingBottom,
          g = a.marginLeft + a.marginRight,
          v = a.marginTop + a.marginBottom,
          _ = a.borderLeftWidth + a.borderRightWidth,
          z = a.borderTopWidth + a.borderBottomWidth,
          I = d && r,
          x = t(s.width);

      x !== !1 && (a.width = x + (I ? 0 : p + _));
      var S = t(s.height);
      return S !== !1 && (a.height = S + (I ? 0 : y + z)), a.innerWidth = a.width - (p + _), a.innerHeight = a.height - (y + z), a.outerWidth = a.width + g, a.outerHeight = a.height + v, a;
    }
  }

  var r,
      a = "undefined" == typeof console ? e : function (t) {
    console.error(t);
  },
      u = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
      h = u.length,
      d = !1;
  return s;
}), function (t, e) {
  "use strict";

  "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e() : t.matchesSelector = e();
}(window, function () {
  "use strict";

  var t = function () {
    var t = window.Element.prototype;
    if (t.matches) return "matches";
    if (t.matchesSelector) return "matchesSelector";

    for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
      var o = e[i],
          n = o + "MatchesSelector";
      if (t[n]) return n;
    }
  }();

  return function (e, i) {
    return e[t](i);
  };
}), function (t, e) {
  "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (i) {
    return e(t, i);
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector);
}(window, function (t, e) {
  var i = {};
  i.extend = function (t, e) {
    for (var i in e) {
      t[i] = e[i];
    }

    return t;
  }, i.modulo = function (t, e) {
    return (t % e + e) % e;
  };
  var o = Array.prototype.slice;
  i.makeArray = function (t) {
    if (Array.isArray(t)) return t;
    if (null === t || void 0 === t) return [];
    var e = "object" == _typeof2(t) && "number" == typeof t.length;
    return e ? o.call(t) : [t];
  }, i.removeFrom = function (t, e) {
    var i = t.indexOf(e);
    i != -1 && t.splice(i, 1);
  }, i.getParent = function (t, i) {
    for (; t.parentNode && t != document.body;) {
      if (t = t.parentNode, e(t, i)) return t;
    }
  }, i.getQueryElement = function (t) {
    return "string" == typeof t ? document.querySelector(t) : t;
  }, i.handleEvent = function (t) {
    var e = "on" + t.type;
    this[e] && this[e](t);
  }, i.filterFindElements = function (t, o) {
    t = i.makeArray(t);
    var n = [];
    return t.forEach(function (t) {
      if (t instanceof HTMLElement) {
        if (!o) return void n.push(t);
        e(t, o) && n.push(t);

        for (var i = t.querySelectorAll(o), s = 0; s < i.length; s++) {
          n.push(i[s]);
        }
      }
    }), n;
  }, i.debounceMethod = function (t, e, i) {
    i = i || 100;
    var o = t.prototype[e],
        n = e + "Timeout";

    t.prototype[e] = function () {
      var t = this[n];
      clearTimeout(t);
      var e = arguments,
          s = this;
      this[n] = setTimeout(function () {
        o.apply(s, e), delete s[n];
      }, i);
    };
  }, i.docReady = function (t) {
    var e = document.readyState;
    "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
  }, i.toDashed = function (t) {
    return t.replace(/(.)([A-Z])/g, function (t, e, i) {
      return e + "-" + i;
    }).toLowerCase();
  };
  var n = t.console;
  return i.htmlInit = function (e, o) {
    i.docReady(function () {
      var s = i.toDashed(o),
          r = "data-" + s,
          a = document.querySelectorAll("[" + r + "]"),
          u = document.querySelectorAll(".js-" + s),
          h = i.makeArray(a).concat(i.makeArray(u)),
          d = r + "-options",
          l = t.jQuery;
      h.forEach(function (t) {
        var i,
            s = t.getAttribute(r) || t.getAttribute(d);

        try {
          i = s && JSON.parse(s);
        } catch (a) {
          return void (n && n.error("Error parsing " + r + " on " + t.className + ": " + a));
        }

        var u = new e(t, i);
        l && l.data(t, o, u);
      });
    });
  }, i;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize));
}(window, function (t, e) {
  "use strict";

  function i(t) {
    for (var e in t) {
      return !1;
    }

    return e = null, !0;
  }

  function o(t, e) {
    t && (this.element = t, this.layout = e, this.position = {
      x: 0,
      y: 0
    }, this._create());
  }

  function n(t) {
    return t.replace(/([A-Z])/g, function (t) {
      return "-" + t.toLowerCase();
    });
  }

  var s = document.documentElement.style,
      r = "string" == typeof s.transition ? "transition" : "WebkitTransition",
      a = "string" == typeof s.transform ? "transform" : "WebkitTransform",
      u = {
    WebkitTransition: "webkitTransitionEnd",
    transition: "transitionend"
  }[r],
      h = {
    transform: a,
    transition: r,
    transitionDuration: r + "Duration",
    transitionProperty: r + "Property",
    transitionDelay: r + "Delay"
  },
      d = o.prototype = Object.create(t.prototype);
  d.constructor = o, d._create = function () {
    this._transn = {
      ingProperties: {},
      clean: {},
      onEnd: {}
    }, this.css({
      position: "absolute"
    });
  }, d.handleEvent = function (t) {
    var e = "on" + t.type;
    this[e] && this[e](t);
  }, d.getSize = function () {
    this.size = e(this.element);
  }, d.css = function (t) {
    var e = this.element.style;

    for (var i in t) {
      var o = h[i] || i;
      e[o] = t[i];
    }
  }, d.getPosition = function () {
    var t = getComputedStyle(this.element),
        e = this.layout._getOption("originLeft"),
        i = this.layout._getOption("originTop"),
        o = t[e ? "left" : "right"],
        n = t[i ? "top" : "bottom"],
        s = parseFloat(o),
        r = parseFloat(n),
        a = this.layout.size;

    o.indexOf("%") != -1 && (s = s / 100 * a.width), n.indexOf("%") != -1 && (r = r / 100 * a.height), s = isNaN(s) ? 0 : s, r = isNaN(r) ? 0 : r, s -= e ? a.paddingLeft : a.paddingRight, r -= i ? a.paddingTop : a.paddingBottom, this.position.x = s, this.position.y = r;
  }, d.layoutPosition = function () {
    var t = this.layout.size,
        e = {},
        i = this.layout._getOption("originLeft"),
        o = this.layout._getOption("originTop"),
        n = i ? "paddingLeft" : "paddingRight",
        s = i ? "left" : "right",
        r = i ? "right" : "left",
        a = this.position.x + t[n];

    e[s] = this.getXValue(a), e[r] = "";
    var u = o ? "paddingTop" : "paddingBottom",
        h = o ? "top" : "bottom",
        d = o ? "bottom" : "top",
        l = this.position.y + t[u];
    e[h] = this.getYValue(l), e[d] = "", this.css(e), this.emitEvent("layout", [this]);
  }, d.getXValue = function (t) {
    var e = this.layout._getOption("horizontal");

    return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px";
  }, d.getYValue = function (t) {
    var e = this.layout._getOption("horizontal");

    return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px";
  }, d._transitionTo = function (t, e) {
    this.getPosition();
    var i = this.position.x,
        o = this.position.y,
        n = t == this.position.x && e == this.position.y;
    if (this.setPosition(t, e), n && !this.isTransitioning) return void this.layoutPosition();
    var s = t - i,
        r = e - o,
        a = {};
    a.transform = this.getTranslate(s, r), this.transition({
      to: a,
      onTransitionEnd: {
        transform: this.layoutPosition
      },
      isCleaning: !0
    });
  }, d.getTranslate = function (t, e) {
    var i = this.layout._getOption("originLeft"),
        o = this.layout._getOption("originTop");

    return t = i ? t : -t, e = o ? e : -e, "translate3d(" + t + "px, " + e + "px, 0)";
  }, d.goTo = function (t, e) {
    this.setPosition(t, e), this.layoutPosition();
  }, d.moveTo = d._transitionTo, d.setPosition = function (t, e) {
    this.position.x = parseFloat(t), this.position.y = parseFloat(e);
  }, d._nonTransition = function (t) {
    this.css(t.to), t.isCleaning && this._removeStyles(t.to);

    for (var e in t.onTransitionEnd) {
      t.onTransitionEnd[e].call(this);
    }
  }, d.transition = function (t) {
    if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(t);
    var e = this._transn;

    for (var i in t.onTransitionEnd) {
      e.onEnd[i] = t.onTransitionEnd[i];
    }

    for (i in t.to) {
      e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
    }

    if (t.from) {
      this.css(t.from);
      var o = this.element.offsetHeight;
      o = null;
    }

    this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0;
  };
  var l = "opacity," + n(a);
  d.enableTransition = function () {
    if (!this.isTransitioning) {
      var t = this.layout.options.transitionDuration;
      t = "number" == typeof t ? t + "ms" : t, this.css({
        transitionProperty: l,
        transitionDuration: t,
        transitionDelay: this.staggerDelay || 0
      }), this.element.addEventListener(u, this, !1);
    }
  }, d.onwebkitTransitionEnd = function (t) {
    this.ontransitionend(t);
  }, d.onotransitionend = function (t) {
    this.ontransitionend(t);
  };
  var f = {
    "-webkit-transform": "transform"
  };
  d.ontransitionend = function (t) {
    if (t.target === this.element) {
      var e = this._transn,
          o = f[t.propertyName] || t.propertyName;

      if (delete e.ingProperties[o], i(e.ingProperties) && this.disableTransition(), o in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[o]), o in e.onEnd) {
        var n = e.onEnd[o];
        n.call(this), delete e.onEnd[o];
      }

      this.emitEvent("transitionEnd", [this]);
    }
  }, d.disableTransition = function () {
    this.removeTransitionStyles(), this.element.removeEventListener(u, this, !1), this.isTransitioning = !1;
  }, d._removeStyles = function (t) {
    var e = {};

    for (var i in t) {
      e[i] = "";
    }

    this.css(e);
  };
  var c = {
    transitionProperty: "",
    transitionDuration: "",
    transitionDelay: ""
  };
  return d.removeTransitionStyles = function () {
    this.css(c);
  }, d.stagger = function (t) {
    t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms";
  }, d.removeElem = function () {
    this.element.parentNode.removeChild(this.element), this.css({
      display: ""
    }), this.emitEvent("remove", [this]);
  }, d.remove = function () {
    return r && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function () {
      this.removeElem();
    }), void this.hide()) : void this.removeElem();
  }, d.reveal = function () {
    delete this.isHidden, this.css({
      display: ""
    });
    var t = this.layout.options,
        e = {},
        i = this.getHideRevealTransitionEndProperty("visibleStyle");
    e[i] = this.onRevealTransitionEnd, this.transition({
      from: t.hiddenStyle,
      to: t.visibleStyle,
      isCleaning: !0,
      onTransitionEnd: e
    });
  }, d.onRevealTransitionEnd = function () {
    this.isHidden || this.emitEvent("reveal");
  }, d.getHideRevealTransitionEndProperty = function (t) {
    var e = this.layout.options[t];
    if (e.opacity) return "opacity";

    for (var i in e) {
      return i;
    }
  }, d.hide = function () {
    this.isHidden = !0, this.css({
      display: ""
    });
    var t = this.layout.options,
        e = {},
        i = this.getHideRevealTransitionEndProperty("hiddenStyle");
    e[i] = this.onHideTransitionEnd, this.transition({
      from: t.visibleStyle,
      to: t.hiddenStyle,
      isCleaning: !0,
      onTransitionEnd: e
    });
  }, d.onHideTransitionEnd = function () {
    this.isHidden && (this.css({
      display: "none"
    }), this.emitEvent("hide"));
  }, d.destroy = function () {
    this.css({
      position: "",
      left: "",
      right: "",
      top: "",
      bottom: "",
      transition: "",
      transform: ""
    });
  }, o;
}), function (t, e) {
  "use strict";

  "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function (i, o, n, s) {
    return e(t, i, o, n, s);
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item);
}(window, function (t, e, i, o, n) {
  "use strict";

  function s(t, e) {
    var i = o.getQueryElement(t);
    if (!i) return void (u && u.error("Bad element for " + this.constructor.namespace + ": " + (i || t)));
    this.element = i, h && (this.$element = h(this.element)), this.options = o.extend({}, this.constructor.defaults), this.option(e);
    var n = ++l;
    this.element.outlayerGUID = n, f[n] = this, this._create();

    var s = this._getOption("initLayout");

    s && this.layout();
  }

  function r(t) {
    function e() {
      t.apply(this, arguments);
    }

    return e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e;
  }

  function a(t) {
    if ("number" == typeof t) return t;
    var e = t.match(/(^\d*\.?\d*)(\w*)/),
        i = e && e[1],
        o = e && e[2];
    if (!i.length) return 0;
    i = parseFloat(i);
    var n = m[o] || 1;
    return i * n;
  }

  var u = t.console,
      h = t.jQuery,
      d = function d() {},
      l = 0,
      f = {};

  s.namespace = "outlayer", s.Item = n, s.defaults = {
    containerStyle: {
      position: "relative"
    },
    initLayout: !0,
    originLeft: !0,
    originTop: !0,
    resize: !0,
    resizeContainer: !0,
    transitionDuration: "0.4s",
    hiddenStyle: {
      opacity: 0,
      transform: "scale(0.001)"
    },
    visibleStyle: {
      opacity: 1,
      transform: "scale(1)"
    }
  };
  var c = s.prototype;
  o.extend(c, e.prototype), c.option = function (t) {
    o.extend(this.options, t);
  }, c._getOption = function (t) {
    var e = this.constructor.compatOptions[t];
    return e && void 0 !== this.options[e] ? this.options[e] : this.options[t];
  }, s.compatOptions = {
    initLayout: "isInitLayout",
    horizontal: "isHorizontal",
    layoutInstant: "isLayoutInstant",
    originLeft: "isOriginLeft",
    originTop: "isOriginTop",
    resize: "isResizeBound",
    resizeContainer: "isResizingContainer"
  }, c._create = function () {
    this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), o.extend(this.element.style, this.options.containerStyle);

    var t = this._getOption("resize");

    t && this.bindResize();
  }, c.reloadItems = function () {
    this.items = this._itemize(this.element.children);
  }, c._itemize = function (t) {
    for (var e = this._filterFindItemElements(t), i = this.constructor.Item, o = [], n = 0; n < e.length; n++) {
      var s = e[n],
          r = new i(s, this);
      o.push(r);
    }

    return o;
  }, c._filterFindItemElements = function (t) {
    return o.filterFindElements(t, this.options.itemSelector);
  }, c.getItemElements = function () {
    return this.items.map(function (t) {
      return t.element;
    });
  }, c.layout = function () {
    this._resetLayout(), this._manageStamps();

    var t = this._getOption("layoutInstant"),
        e = void 0 !== t ? t : !this._isLayoutInited;

    this.layoutItems(this.items, e), this._isLayoutInited = !0;
  }, c._init = c.layout, c._resetLayout = function () {
    this.getSize();
  }, c.getSize = function () {
    this.size = i(this.element);
  }, c._getMeasurement = function (t, e) {
    var o,
        n = this.options[t];
    n ? ("string" == typeof n ? o = this.element.querySelector(n) : n instanceof HTMLElement && (o = n), this[t] = o ? i(o)[e] : n) : this[t] = 0;
  }, c.layoutItems = function (t, e) {
    t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout();
  }, c._getItemsForLayout = function (t) {
    return t.filter(function (t) {
      return !t.isIgnored;
    });
  }, c._layoutItems = function (t, e) {
    if (this._emitCompleteOnItems("layout", t), t && t.length) {
      var i = [];
      t.forEach(function (t) {
        var o = this._getItemLayoutPosition(t);

        o.item = t, o.isInstant = e || t.isLayoutInstant, i.push(o);
      }, this), this._processLayoutQueue(i);
    }
  }, c._getItemLayoutPosition = function () {
    return {
      x: 0,
      y: 0
    };
  }, c._processLayoutQueue = function (t) {
    this.updateStagger(), t.forEach(function (t, e) {
      this._positionItem(t.item, t.x, t.y, t.isInstant, e);
    }, this);
  }, c.updateStagger = function () {
    var t = this.options.stagger;
    return null === t || void 0 === t ? void (this.stagger = 0) : (this.stagger = a(t), this.stagger);
  }, c._positionItem = function (t, e, i, o, n) {
    o ? t.goTo(e, i) : (t.stagger(n * this.stagger), t.moveTo(e, i));
  }, c._postLayout = function () {
    this.resizeContainer();
  }, c.resizeContainer = function () {
    var t = this._getOption("resizeContainer");

    if (t) {
      var e = this._getContainerSize();

      e && (this._setContainerMeasure(e.width, !0), this._setContainerMeasure(e.height, !1));
    }
  }, c._getContainerSize = d, c._setContainerMeasure = function (t, e) {
    if (void 0 !== t) {
      var i = this.size;
      i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px";
    }
  }, c._emitCompleteOnItems = function (t, e) {
    function i() {
      n.dispatchEvent(t + "Complete", null, [e]);
    }

    function o() {
      r++, r == s && i();
    }

    var n = this,
        s = e.length;
    if (!e || !s) return void i();
    var r = 0;
    e.forEach(function (e) {
      e.once(t, o);
    });
  }, c.dispatchEvent = function (t, e, i) {
    var o = e ? [e].concat(i) : i;
    if (this.emitEvent(t, o), h) if (this.$element = this.$element || h(this.element), e) {
      var n = h.Event(e);
      n.type = t, this.$element.trigger(n, i);
    } else this.$element.trigger(t, i);
  }, c.ignore = function (t) {
    var e = this.getItem(t);
    e && (e.isIgnored = !0);
  }, c.unignore = function (t) {
    var e = this.getItem(t);
    e && delete e.isIgnored;
  }, c.stamp = function (t) {
    t = this._find(t), t && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this));
  }, c.unstamp = function (t) {
    t = this._find(t), t && t.forEach(function (t) {
      o.removeFrom(this.stamps, t), this.unignore(t);
    }, this);
  }, c._find = function (t) {
    if (t) return "string" == typeof t && (t = this.element.querySelectorAll(t)), t = o.makeArray(t);
  }, c._manageStamps = function () {
    this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
  }, c._getBoundingRect = function () {
    var t = this.element.getBoundingClientRect(),
        e = this.size;
    this._boundingRect = {
      left: t.left + e.paddingLeft + e.borderLeftWidth,
      top: t.top + e.paddingTop + e.borderTopWidth,
      right: t.right - (e.paddingRight + e.borderRightWidth),
      bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
    };
  }, c._manageStamp = d, c._getElementOffset = function (t) {
    var e = t.getBoundingClientRect(),
        o = this._boundingRect,
        n = i(t),
        s = {
      left: e.left - o.left - n.marginLeft,
      top: e.top - o.top - n.marginTop,
      right: o.right - e.right - n.marginRight,
      bottom: o.bottom - e.bottom - n.marginBottom
    };
    return s;
  }, c.handleEvent = o.handleEvent, c.bindResize = function () {
    t.addEventListener("resize", this), this.isResizeBound = !0;
  }, c.unbindResize = function () {
    t.removeEventListener("resize", this), this.isResizeBound = !1;
  }, c.onresize = function () {
    this.resize();
  }, o.debounceMethod(s, "onresize", 100), c.resize = function () {
    this.isResizeBound && this.needsResizeLayout() && this.layout();
  }, c.needsResizeLayout = function () {
    var t = i(this.element),
        e = this.size && t;
    return e && t.innerWidth !== this.size.innerWidth;
  }, c.addItems = function (t) {
    var e = this._itemize(t);

    return e.length && (this.items = this.items.concat(e)), e;
  }, c.appended = function (t) {
    var e = this.addItems(t);
    e.length && (this.layoutItems(e, !0), this.reveal(e));
  }, c.prepended = function (t) {
    var e = this._itemize(t);

    if (e.length) {
      var i = this.items.slice(0);
      this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i);
    }
  }, c.reveal = function (t) {
    if (this._emitCompleteOnItems("reveal", t), t && t.length) {
      var e = this.updateStagger();
      t.forEach(function (t, i) {
        t.stagger(i * e), t.reveal();
      });
    }
  }, c.hide = function (t) {
    if (this._emitCompleteOnItems("hide", t), t && t.length) {
      var e = this.updateStagger();
      t.forEach(function (t, i) {
        t.stagger(i * e), t.hide();
      });
    }
  }, c.revealItemElements = function (t) {
    var e = this.getItems(t);
    this.reveal(e);
  }, c.hideItemElements = function (t) {
    var e = this.getItems(t);
    this.hide(e);
  }, c.getItem = function (t) {
    for (var e = 0; e < this.items.length; e++) {
      var i = this.items[e];
      if (i.element == t) return i;
    }
  }, c.getItems = function (t) {
    t = o.makeArray(t);
    var e = [];
    return t.forEach(function (t) {
      var i = this.getItem(t);
      i && e.push(i);
    }, this), e;
  }, c.remove = function (t) {
    var e = this.getItems(t);
    this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function (t) {
      t.remove(), o.removeFrom(this.items, t);
    }, this);
  }, c.destroy = function () {
    var t = this.element.style;
    t.height = "", t.position = "", t.width = "", this.items.forEach(function (t) {
      t.destroy();
    }), this.unbindResize();
    var e = this.element.outlayerGUID;
    delete f[e], delete this.element.outlayerGUID, h && h.removeData(this.element, this.constructor.namespace);
  }, s.data = function (t) {
    t = o.getQueryElement(t);
    var e = t && t.outlayerGUID;
    return e && f[e];
  }, s.create = function (t, e) {
    var i = r(s);
    return i.defaults = o.extend({}, s.defaults), o.extend(i.defaults, e), i.compatOptions = o.extend({}, s.compatOptions), i.namespace = t, i.data = s.data, i.Item = r(n), o.htmlInit(i, t), h && h.bridget && h.bridget(t, i), i;
  };
  var m = {
    ms: 1,
    s: 1e3
  };
  return s.Item = n, s;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("isotope-layout/js/item", ["outlayer/outlayer"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(require("outlayer")) : (t.Isotope = t.Isotope || {}, t.Isotope.Item = e(t.Outlayer));
}(window, function (t) {
  "use strict";

  function e() {
    t.Item.apply(this, arguments);
  }

  var i = e.prototype = Object.create(t.Item.prototype),
      o = i._create;
  i._create = function () {
    this.id = this.layout.itemGUID++, o.call(this), this.sortData = {};
  }, i.updateSortData = function () {
    if (!this.isIgnored) {
      this.sortData.id = this.id, this.sortData["original-order"] = this.id, this.sortData.random = Math.random();
      var t = this.layout.options.getSortData,
          e = this.layout._sorters;

      for (var i in t) {
        var o = e[i];
        this.sortData[i] = o(this.element, this);
      }
    }
  };
  var n = i.destroy;
  return i.destroy = function () {
    n.apply(this, arguments), this.css({
      display: ""
    });
  }, e;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("isotope-layout/js/layout-mode", ["get-size/get-size", "outlayer/outlayer"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(require("get-size"), require("outlayer")) : (t.Isotope = t.Isotope || {}, t.Isotope.LayoutMode = e(t.getSize, t.Outlayer));
}(window, function (t, e) {
  "use strict";

  function i(t) {
    this.isotope = t, t && (this.options = t.options[this.namespace], this.element = t.element, this.items = t.filteredItems, this.size = t.size);
  }

  var o = i.prototype,
      n = ["_resetLayout", "_getItemLayoutPosition", "_manageStamp", "_getContainerSize", "_getElementOffset", "needsResizeLayout", "_getOption"];
  return n.forEach(function (t) {
    o[t] = function () {
      return e.prototype[t].apply(this.isotope, arguments);
    };
  }), o.needsVerticalResizeLayout = function () {
    var e = t(this.isotope.element),
        i = this.isotope.size && e;
    return i && e.innerHeight != this.isotope.size.innerHeight;
  }, o._getMeasurement = function () {
    this.isotope._getMeasurement.apply(this, arguments);
  }, o.getColumnWidth = function () {
    this.getSegmentSize("column", "Width");
  }, o.getRowHeight = function () {
    this.getSegmentSize("row", "Height");
  }, o.getSegmentSize = function (t, e) {
    var i = t + e,
        o = "outer" + e;

    if (this._getMeasurement(i, o), !this[i]) {
      var n = this.getFirstItemSize();
      this[i] = n && n[o] || this.isotope.size["inner" + e];
    }
  }, o.getFirstItemSize = function () {
    var e = this.isotope.filteredItems[0];
    return e && e.element && t(e.element);
  }, o.layout = function () {
    this.isotope.layout.apply(this.isotope, arguments);
  }, o.getSize = function () {
    this.isotope.getSize(), this.size = this.isotope.size;
  }, i.modes = {}, i.create = function (t, e) {
    function n() {
      i.apply(this, arguments);
    }

    return n.prototype = Object.create(o), n.prototype.constructor = n, e && (n.options = e), n.prototype.namespace = t, i.modes[t] = n, n;
  }, i;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("masonry-layout/masonry", ["outlayer/outlayer", "get-size/get-size"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize);
}(window, function (t, e) {
  var i = t.create("masonry");
  i.compatOptions.fitWidth = "isFitWidth";
  var o = i.prototype;
  return o._resetLayout = function () {
    this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];

    for (var t = 0; t < this.cols; t++) {
      this.colYs.push(0);
    }

    this.maxY = 0, this.horizontalColIndex = 0;
  }, o.measureColumns = function () {
    if (this.getContainerWidth(), !this.columnWidth) {
      var t = this.items[0],
          i = t && t.element;
      this.columnWidth = i && e(i).outerWidth || this.containerWidth;
    }

    var o = this.columnWidth += this.gutter,
        n = this.containerWidth + this.gutter,
        s = n / o,
        r = o - n % o,
        a = r && r < 1 ? "round" : "floor";
    s = Math[a](s), this.cols = Math.max(s, 1);
  }, o.getContainerWidth = function () {
    var t = this._getOption("fitWidth"),
        i = t ? this.element.parentNode : this.element,
        o = e(i);

    this.containerWidth = o && o.innerWidth;
  }, o._getItemLayoutPosition = function (t) {
    t.getSize();
    var e = t.size.outerWidth % this.columnWidth,
        i = e && e < 1 ? "round" : "ceil",
        o = Math[i](t.size.outerWidth / this.columnWidth);
    o = Math.min(o, this.cols);

    for (var n = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", s = this[n](o, t), r = {
      x: this.columnWidth * s.col,
      y: s.y
    }, a = s.y + t.size.outerHeight, u = o + s.col, h = s.col; h < u; h++) {
      this.colYs[h] = a;
    }

    return r;
  }, o._getTopColPosition = function (t) {
    var e = this._getTopColGroup(t),
        i = Math.min.apply(Math, e);

    return {
      col: e.indexOf(i),
      y: i
    };
  }, o._getTopColGroup = function (t) {
    if (t < 2) return this.colYs;

    for (var e = [], i = this.cols + 1 - t, o = 0; o < i; o++) {
      e[o] = this._getColGroupY(o, t);
    }

    return e;
  }, o._getColGroupY = function (t, e) {
    if (e < 2) return this.colYs[t];
    var i = this.colYs.slice(t, t + e);
    return Math.max.apply(Math, i);
  }, o._getHorizontalColPosition = function (t, e) {
    var i = this.horizontalColIndex % this.cols,
        o = t > 1 && i + t > this.cols;
    i = o ? 0 : i;
    var n = e.size.outerWidth && e.size.outerHeight;
    return this.horizontalColIndex = n ? i + t : this.horizontalColIndex, {
      col: i,
      y: this._getColGroupY(i, t)
    };
  }, o._manageStamp = function (t) {
    var i = e(t),
        o = this._getElementOffset(t),
        n = this._getOption("originLeft"),
        s = n ? o.left : o.right,
        r = s + i.outerWidth,
        a = Math.floor(s / this.columnWidth);

    a = Math.max(0, a);
    var u = Math.floor(r / this.columnWidth);
    u -= r % this.columnWidth ? 0 : 1, u = Math.min(this.cols - 1, u);

    for (var h = this._getOption("originTop"), d = (h ? o.top : o.bottom) + i.outerHeight, l = a; l <= u; l++) {
      this.colYs[l] = Math.max(d, this.colYs[l]);
    }
  }, o._getContainerSize = function () {
    this.maxY = Math.max.apply(Math, this.colYs);
    var t = {
      height: this.maxY
    };
    return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t;
  }, o._getContainerFitWidth = function () {
    for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];) {
      t++;
    }

    return (this.cols - t) * this.columnWidth - this.gutter;
  }, o.needsResizeLayout = function () {
    var t = this.containerWidth;
    return this.getContainerWidth(), t != this.containerWidth;
  }, i;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/masonry", ["../layout-mode", "masonry-layout/masonry"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(require("../layout-mode"), require("masonry-layout")) : e(t.Isotope.LayoutMode, t.Masonry);
}(window, function (t, e) {
  "use strict";

  var i = t.create("masonry"),
      o = i.prototype,
      n = {
    _getElementOffset: !0,
    layout: !0,
    _getMeasurement: !0
  };

  for (var s in e.prototype) {
    n[s] || (o[s] = e.prototype[s]);
  }

  var r = o.measureColumns;

  o.measureColumns = function () {
    this.items = this.isotope.filteredItems, r.call(this);
  };

  var a = o._getOption;
  return o._getOption = function (t) {
    return "fitWidth" == t ? void 0 !== this.options.isFitWidth ? this.options.isFitWidth : this.options.fitWidth : a.apply(this.isotope, arguments);
  }, i;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/fit-rows", ["../layout-mode"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) ? module.exports = e(require("../layout-mode")) : e(t.Isotope.LayoutMode);
}(window, function (t) {
  "use strict";

  var e = t.create("fitRows"),
      i = e.prototype;
  return i._resetLayout = function () {
    this.x = 0, this.y = 0, this.maxY = 0, this._getMeasurement("gutter", "outerWidth");
  }, i._getItemLayoutPosition = function (t) {
    t.getSize();
    var e = t.size.outerWidth + this.gutter,
        i = this.isotope.size.innerWidth + this.gutter;
    0 !== this.x && e + this.x > i && (this.x = 0, this.y = this.maxY);
    var o = {
      x: this.x,
      y: this.y
    };
    return this.maxY = Math.max(this.maxY, this.y + t.size.outerHeight), this.x += e, o;
  }, i._getContainerSize = function () {
    return {
      height: this.maxY
    };
  }, e;
}), function (t, e) {
  "function" == typeof define && define.amd ? define("isotope-layout/js/layout-modes/vertical", ["../layout-mode"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(require("../layout-mode")) : e(t.Isotope.LayoutMode);
}(window, function (t) {
  "use strict";

  var e = t.create("vertical", {
    horizontalAlignment: 0
  }),
      i = e.prototype;
  return i._resetLayout = function () {
    this.y = 0;
  }, i._getItemLayoutPosition = function (t) {
    t.getSize();
    var e = (this.isotope.size.innerWidth - t.size.outerWidth) * this.options.horizontalAlignment,
        i = this.y;
    return this.y += t.size.outerHeight, {
      x: e,
      y: i
    };
  }, i._getContainerSize = function () {
    return {
      height: this.y
    };
  }, e;
}), function (t, e) {
  "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size", "desandro-matches-selector/matches-selector", "fizzy-ui-utils/utils", "isotope-layout/js/item", "isotope-layout/js/layout-mode", "isotope-layout/js/layout-modes/masonry", "isotope-layout/js/layout-modes/fit-rows", "isotope-layout/js/layout-modes/vertical"], function (i, o, n, s, r, a) {
    return e(t, i, o, n, s, r, a);
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = e(t, require("outlayer"), require("get-size"), require("desandro-matches-selector"), require("fizzy-ui-utils"), require("isotope-layout/js/item"), require("isotope-layout/js/layout-mode"), require("isotope-layout/js/layout-modes/masonry"), require("isotope-layout/js/layout-modes/fit-rows"), require("isotope-layout/js/layout-modes/vertical")) : t.Isotope = e(t, t.Outlayer, t.getSize, t.matchesSelector, t.fizzyUIUtils, t.Isotope.Item, t.Isotope.LayoutMode);
}(window, function (t, e, i, o, n, s, r) {
  function a(t, e) {
    return function (i, o) {
      for (var n = 0; n < t.length; n++) {
        var s = t[n],
            r = i.sortData[s],
            a = o.sortData[s];

        if (r > a || r < a) {
          var u = void 0 !== e[s] ? e[s] : e,
              h = u ? 1 : -1;
          return (r > a ? 1 : -1) * h;
        }
      }

      return 0;
    };
  }

  var u = t.jQuery,
      h = String.prototype.trim ? function (t) {
    return t.trim();
  } : function (t) {
    return t.replace(/^\s+|\s+$/g, "");
  },
      d = e.create("isotope", {
    layoutMode: "masonry",
    isJQueryFiltering: !0,
    sortAscending: !0
  });
  d.Item = s, d.LayoutMode = r;
  var l = d.prototype;
  l._create = function () {
    this.itemGUID = 0, this._sorters = {}, this._getSorters(), e.prototype._create.call(this), this.modes = {}, this.filteredItems = this.items, this.sortHistory = ["original-order"];

    for (var t in r.modes) {
      this._initLayoutMode(t);
    }
  }, l.reloadItems = function () {
    this.itemGUID = 0, e.prototype.reloadItems.call(this);
  }, l._itemize = function () {
    for (var t = e.prototype._itemize.apply(this, arguments), i = 0; i < t.length; i++) {
      var o = t[i];
      o.id = this.itemGUID++;
    }

    return this._updateItemsSortData(t), t;
  }, l._initLayoutMode = function (t) {
    var e = r.modes[t],
        i = this.options[t] || {};
    this.options[t] = e.options ? n.extend(e.options, i) : i, this.modes[t] = new e(this);
  }, l.layout = function () {
    return !this._isLayoutInited && this._getOption("initLayout") ? void this.arrange() : void this._layout();
  }, l._layout = function () {
    var t = this._getIsInstant();

    this._resetLayout(), this._manageStamps(), this.layoutItems(this.filteredItems, t), this._isLayoutInited = !0;
  }, l.arrange = function (t) {
    this.option(t), this._getIsInstant();

    var e = this._filter(this.items);

    this.filteredItems = e.matches, this._bindArrangeComplete(), this._isInstant ? this._noTransition(this._hideReveal, [e]) : this._hideReveal(e), this._sort(), this._layout();
  }, l._init = l.arrange, l._hideReveal = function (t) {
    this.reveal(t.needReveal), this.hide(t.needHide);
  }, l._getIsInstant = function () {
    var t = this._getOption("layoutInstant"),
        e = void 0 !== t ? t : !this._isLayoutInited;

    return this._isInstant = e, e;
  }, l._bindArrangeComplete = function () {
    function t() {
      e && i && o && n.dispatchEvent("arrangeComplete", null, [n.filteredItems]);
    }

    var e,
        i,
        o,
        n = this;
    this.once("layoutComplete", function () {
      e = !0, t();
    }), this.once("hideComplete", function () {
      i = !0, t();
    }), this.once("revealComplete", function () {
      o = !0, t();
    });
  }, l._filter = function (t) {
    var e = this.options.filter;
    e = e || "*";

    for (var i = [], o = [], n = [], s = this._getFilterTest(e), r = 0; r < t.length; r++) {
      var a = t[r];

      if (!a.isIgnored) {
        var u = s(a);
        u && i.push(a), u && a.isHidden ? o.push(a) : u || a.isHidden || n.push(a);
      }
    }

    return {
      matches: i,
      needReveal: o,
      needHide: n
    };
  }, l._getFilterTest = function (t) {
    return u && this.options.isJQueryFiltering ? function (e) {
      return u(e.element).is(t);
    } : "function" == typeof t ? function (e) {
      return t(e.element);
    } : function (e) {
      return o(e.element, t);
    };
  }, l.updateSortData = function (t) {
    var e;
    t ? (t = n.makeArray(t), e = this.getItems(t)) : e = this.items, this._getSorters(), this._updateItemsSortData(e);
  }, l._getSorters = function () {
    var t = this.options.getSortData;

    for (var e in t) {
      var i = t[e];
      this._sorters[e] = f(i);
    }
  }, l._updateItemsSortData = function (t) {
    for (var e = t && t.length, i = 0; e && i < e; i++) {
      var o = t[i];
      o.updateSortData();
    }
  };

  var f = function () {
    function t(t) {
      if ("string" != typeof t) return t;
      var i = h(t).split(" "),
          o = i[0],
          n = o.match(/^\[(.+)\]$/),
          s = n && n[1],
          r = e(s, o),
          a = d.sortDataParsers[i[1]];
      return t = a ? function (t) {
        return t && a(r(t));
      } : function (t) {
        return t && r(t);
      };
    }

    function e(t, e) {
      return t ? function (e) {
        return e.getAttribute(t);
      } : function (t) {
        var i = t.querySelector(e);
        return i && i.textContent;
      };
    }

    return t;
  }();

  d.sortDataParsers = {
    parseInt: function (_parseInt) {
      function parseInt(_x) {
        return _parseInt.apply(this, arguments);
      }

      parseInt.toString = function () {
        return _parseInt.toString();
      };

      return parseInt;
    }(function (t) {
      return parseInt(t, 10);
    }),
    parseFloat: function (_parseFloat) {
      function parseFloat(_x2) {
        return _parseFloat.apply(this, arguments);
      }

      parseFloat.toString = function () {
        return _parseFloat.toString();
      };

      return parseFloat;
    }(function (t) {
      return parseFloat(t);
    })
  }, l._sort = function () {
    if (this.options.sortBy) {
      var t = n.makeArray(this.options.sortBy);
      this._getIsSameSortBy(t) || (this.sortHistory = t.concat(this.sortHistory));
      var e = a(this.sortHistory, this.options.sortAscending);
      this.filteredItems.sort(e);
    }
  }, l._getIsSameSortBy = function (t) {
    for (var e = 0; e < t.length; e++) {
      if (t[e] != this.sortHistory[e]) return !1;
    }

    return !0;
  }, l._mode = function () {
    var t = this.options.layoutMode,
        e = this.modes[t];
    if (!e) throw new Error("No layout mode: " + t);
    return e.options = this.options[t], e;
  }, l._resetLayout = function () {
    e.prototype._resetLayout.call(this), this._mode()._resetLayout();
  }, l._getItemLayoutPosition = function (t) {
    return this._mode()._getItemLayoutPosition(t);
  }, l._manageStamp = function (t) {
    this._mode()._manageStamp(t);
  }, l._getContainerSize = function () {
    return this._mode()._getContainerSize();
  }, l.needsResizeLayout = function () {
    return this._mode().needsResizeLayout();
  }, l.appended = function (t) {
    var e = this.addItems(t);

    if (e.length) {
      var i = this._filterRevealAdded(e);

      this.filteredItems = this.filteredItems.concat(i);
    }
  }, l.prepended = function (t) {
    var e = this._itemize(t);

    if (e.length) {
      this._resetLayout(), this._manageStamps();

      var i = this._filterRevealAdded(e);

      this.layoutItems(this.filteredItems), this.filteredItems = i.concat(this.filteredItems), this.items = e.concat(this.items);
    }
  }, l._filterRevealAdded = function (t) {
    var e = this._filter(t);

    return this.hide(e.needHide), this.reveal(e.matches), this.layoutItems(e.matches, !0), e.matches;
  }, l.insert = function (t) {
    var e = this.addItems(t);

    if (e.length) {
      var i,
          o,
          n = e.length;

      for (i = 0; i < n; i++) {
        o = e[i], this.element.appendChild(o.element);
      }

      var s = this._filter(e).matches;

      for (i = 0; i < n; i++) {
        e[i].isLayoutInstant = !0;
      }

      for (this.arrange(), i = 0; i < n; i++) {
        delete e[i].isLayoutInstant;
      }

      this.reveal(s);
    }
  };
  var c = l.remove;
  return l.remove = function (t) {
    t = n.makeArray(t);
    var e = this.getItems(t);
    c.call(this, t);

    for (var i = e && e.length, o = 0; i && o < i; o++) {
      var s = e[o];
      n.removeFrom(this.filteredItems, s);
    }
  }, l.shuffle = function () {
    for (var t = 0; t < this.items.length; t++) {
      var e = this.items[t];
      e.sortData.random = Math.random();
    }

    this.options.sortBy = "random", this._sort(), this._layout();
  }, l._noTransition = function (t, e) {
    var i = this.options.transitionDuration;
    this.options.transitionDuration = 0;
    var o = t.apply(this, e);
    return this.options.transitionDuration = i, o;
  }, l.getFilteredItemElements = function () {
    return this.filteredItems.map(function (t) {
      return t.element;
    });
  }, d;
});
/*!
 * Packery layout mode PACKAGED v2.0.1
 * sub-classes Packery
 */

/**
 * Rect
 * low-level utility class for basic geometry
 */

(function (window, factory) {
  // universal module definition

  /* jshint strict: false */

  /* globals define, module */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define('packery/js/rect', factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof2(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Packery = window.Packery || {};
    window.Packery.Rect = factory();
  }
})(window, function factory() {
  // -------------------------- Rect -------------------------- //
  function Rect(props) {
    // extend properties from defaults
    for (var prop in Rect.defaults) {
      this[prop] = Rect.defaults[prop];
    }

    for (prop in props) {
      this[prop] = props[prop];
    }
  }

  Rect.defaults = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  var proto = Rect.prototype;
  /**
   * Determines whether or not this rectangle wholly encloses another rectangle or point.
   * @param {Rect} rect
   * @returns {Boolean}
  **/

  proto.contains = function (rect) {
    // points don't have width or height
    var otherWidth = rect.width || 0;
    var otherHeight = rect.height || 0;
    return this.x <= rect.x && this.y <= rect.y && this.x + this.width >= rect.x + otherWidth && this.y + this.height >= rect.y + otherHeight;
  };
  /**
   * Determines whether or not the rectangle intersects with another.
   * @param {Rect} rect
   * @returns {Boolean}
  **/


  proto.overlaps = function (rect) {
    var thisRight = this.x + this.width;
    var thisBottom = this.y + this.height;
    var rectRight = rect.x + rect.width;
    var rectBottom = rect.y + rect.height; // http://stackoverflow.com/a/306332

    return this.x < rectRight && thisRight > rect.x && this.y < rectBottom && thisBottom > rect.y;
  };
  /**
   * @param {Rect} rect - the overlapping rect
   * @returns {Array} freeRects - rects representing the area around the rect
  **/


  proto.getMaximalFreeRects = function (rect) {
    // if no intersection, return false
    if (!this.overlaps(rect)) {
      return false;
    }

    var freeRects = [];
    var freeRect;
    var thisRight = this.x + this.width;
    var thisBottom = this.y + this.height;
    var rectRight = rect.x + rect.width;
    var rectBottom = rect.y + rect.height; // top

    if (this.y < rect.y) {
      freeRect = new Rect({
        x: this.x,
        y: this.y,
        width: this.width,
        height: rect.y - this.y
      });
      freeRects.push(freeRect);
    } // right


    if (thisRight > rectRight) {
      freeRect = new Rect({
        x: rectRight,
        y: this.y,
        width: thisRight - rectRight,
        height: this.height
      });
      freeRects.push(freeRect);
    } // bottom


    if (thisBottom > rectBottom) {
      freeRect = new Rect({
        x: this.x,
        y: rectBottom,
        width: this.width,
        height: thisBottom - rectBottom
      });
      freeRects.push(freeRect);
    } // left


    if (this.x < rect.x) {
      freeRect = new Rect({
        x: this.x,
        y: this.y,
        width: rect.x - this.x,
        height: this.height
      });
      freeRects.push(freeRect);
    }

    return freeRects;
  };

  proto.canFit = function (rect) {
    return this.width >= rect.width && this.height >= rect.height;
  };

  return Rect;
});
/**
 * Packer
 * bin-packing algorithm
 */


(function (window, factory) {
  // universal module definition

  /* jshint strict: false */

  /* globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define('packery/js/packer', ['./rect'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof2(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('./rect'));
  } else {
    // browser global
    var Packery = window.Packery = window.Packery || {};
    Packery.Packer = factory(Packery.Rect);
  }
})(window, function factory(Rect) {
  // -------------------------- Packer -------------------------- //

  /**
   * @param {Number} width
   * @param {Number} height
   * @param {String} sortDirection
   *   topLeft for vertical, leftTop for horizontal
   */
  function Packer(width, height, sortDirection) {
    this.width = width || 0;
    this.height = height || 0;
    this.sortDirection = sortDirection || 'downwardLeftToRight';
    this.reset();
  }

  var proto = Packer.prototype;

  proto.reset = function () {
    this.spaces = [];
    var initialSpace = new Rect({
      x: 0,
      y: 0,
      width: this.width,
      height: this.height
    });
    this.spaces.push(initialSpace); // set sorter

    this.sorter = sorters[this.sortDirection] || sorters.downwardLeftToRight;
  }; // change x and y of rect to fit with in Packer's available spaces


  proto.pack = function (rect) {
    for (var i = 0; i < this.spaces.length; i++) {
      var space = this.spaces[i];

      if (space.canFit(rect)) {
        this.placeInSpace(rect, space);
        break;
      }
    }
  };

  proto.columnPack = function (rect) {
    for (var i = 0; i < this.spaces.length; i++) {
      var space = this.spaces[i];
      var canFitInSpaceColumn = space.x <= rect.x && space.x + space.width >= rect.x + rect.width && space.height >= rect.height - 0.01; // fudge number for rounding error

      if (canFitInSpaceColumn) {
        rect.y = space.y;
        this.placed(rect);
        break;
      }
    }
  };

  proto.rowPack = function (rect) {
    for (var i = 0; i < this.spaces.length; i++) {
      var space = this.spaces[i];
      var canFitInSpaceRow = space.y <= rect.y && space.y + space.height >= rect.y + rect.height && space.width >= rect.width - 0.01; // fudge number for rounding error

      if (canFitInSpaceRow) {
        rect.x = space.x;
        this.placed(rect);
        break;
      }
    }
  };

  proto.placeInSpace = function (rect, space) {
    // place rect in space
    rect.x = space.x;
    rect.y = space.y;
    this.placed(rect);
  }; // update spaces with placed rect


  proto.placed = function (rect) {
    // update spaces
    var revisedSpaces = [];

    for (var i = 0; i < this.spaces.length; i++) {
      var space = this.spaces[i];
      var newSpaces = space.getMaximalFreeRects(rect); // add either the original space or the new spaces to the revised spaces

      if (newSpaces) {
        revisedSpaces.push.apply(revisedSpaces, newSpaces);
      } else {
        revisedSpaces.push(space);
      }
    }

    this.spaces = revisedSpaces;
    this.mergeSortSpaces();
  };

  proto.mergeSortSpaces = function () {
    // remove redundant spaces
    Packer.mergeRects(this.spaces);
    this.spaces.sort(this.sorter);
  }; // add a space back


  proto.addSpace = function (rect) {
    this.spaces.push(rect);
    this.mergeSortSpaces();
  }; // -------------------------- utility functions -------------------------- //

  /**
   * Remove redundant rectangle from array of rectangles
   * @param {Array} rects: an array of Rects
   * @returns {Array} rects: an array of Rects
  **/


  Packer.mergeRects = function (rects) {
    var i = 0;
    var rect = rects[i];

    rectLoop: while (rect) {
      var j = 0;
      var compareRect = rects[i + j];

      while (compareRect) {
        if (compareRect == rect) {
          j++; // next
        } else if (compareRect.contains(rect)) {
          // remove rect
          rects.splice(i, 1);
          rect = rects[i]; // set next rect

          continue rectLoop; // bail on compareLoop
        } else if (rect.contains(compareRect)) {
          // remove compareRect
          rects.splice(i + j, 1);
        } else {
          j++;
        }

        compareRect = rects[i + j]; // set next compareRect
      }

      i++;
      rect = rects[i];
    }

    return rects;
  }; // -------------------------- sorters -------------------------- //
  // functions for sorting rects in order


  var sorters = {
    // top down, then left to right
    downwardLeftToRight: function downwardLeftToRight(a, b) {
      return a.y - b.y || a.x - b.x;
    },
    // left to right, then top down
    rightwardTopToBottom: function rightwardTopToBottom(a, b) {
      return a.x - b.x || a.y - b.y;
    }
  }; // --------------------------  -------------------------- //

  return Packer;
});
/**
 * Packery Item Element
**/


(function (window, factory) {
  // universal module definition

  /* jshint strict: false */

  /* globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define('packery/js/item', ['outlayer/outlayer', './rect'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof2(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('outlayer'), require('./rect'));
  } else {
    // browser global
    window.Packery.Item = factory(window.Outlayer, window.Packery.Rect);
  }
})(window, function factory(Outlayer, Rect) {
  // -------------------------- Item -------------------------- //
  var docElemStyle = document.documentElement.style;
  var transformProperty = typeof docElemStyle.transform == 'string' ? 'transform' : 'WebkitTransform'; // sub-class Item

  var Item = function PackeryItem() {
    Outlayer.Item.apply(this, arguments);
  };

  var proto = Item.prototype = Object.create(Outlayer.Item.prototype);
  var __create = proto._create;

  proto._create = function () {
    // call default _create logic
    __create.call(this);

    this.rect = new Rect();
  };

  var _moveTo = proto.moveTo;

  proto.moveTo = function (x, y) {
    // don't shift 1px while dragging
    var dx = Math.abs(this.position.x - x);
    var dy = Math.abs(this.position.y - y);
    var canHackGoTo = this.layout.dragItemCount && !this.isPlacing && !this.isTransitioning && dx < 1 && dy < 1;

    if (canHackGoTo) {
      this.goTo(x, y);
      return;
    }

    _moveTo.apply(this, arguments);
  }; // -------------------------- placing -------------------------- //


  proto.enablePlacing = function () {
    this.removeTransitionStyles(); // remove transform property from transition

    if (this.isTransitioning && transformProperty) {
      this.element.style[transformProperty] = 'none';
    }

    this.isTransitioning = false;
    this.getSize();

    this.layout._setRectSize(this.element, this.rect);

    this.isPlacing = true;
  };

  proto.disablePlacing = function () {
    this.isPlacing = false;
  }; // -----  ----- //
  // remove element from DOM


  proto.removeElem = function () {
    this.element.parentNode.removeChild(this.element); // add space back to packer

    this.layout.packer.addSpace(this.rect);
    this.emitEvent('remove', [this]);
  }; // ----- dropPlaceholder ----- //


  proto.showDropPlaceholder = function () {
    var dropPlaceholder = this.dropPlaceholder;

    if (!dropPlaceholder) {
      // create dropPlaceholder
      dropPlaceholder = this.dropPlaceholder = document.createElement('div');
      dropPlaceholder.className = 'packery-drop-placeholder';
      dropPlaceholder.style.position = 'absolute';
    }

    dropPlaceholder.style.width = this.size.width + 'px';
    dropPlaceholder.style.height = this.size.height + 'px';
    this.positionDropPlaceholder();
    this.layout.element.appendChild(dropPlaceholder);
  };

  proto.positionDropPlaceholder = function () {
    this.dropPlaceholder.style[transformProperty] = 'translate(' + this.rect.x + 'px, ' + this.rect.y + 'px)';
  };

  proto.hideDropPlaceholder = function () {
    this.layout.element.removeChild(this.dropPlaceholder);
  }; // -----  ----- //


  return Item;
});
/*!
 * Packery v2.0.0
 * Gapless, draggable grid layouts
 *
 * Licensed GPLv3 for open source use
 * or Packery Commercial License for commercial use
 *
 * http://packery.metafizzy.co
 * Copyright 2016 Metafizzy
 */


(function (window, factory) {
  // universal module definition

  /* jshint strict: false */

  /* globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define('packery/js/packery', ['get-size/get-size', 'outlayer/outlayer', './rect', './packer', './item'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof2(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('get-size'), require('outlayer'), require('./rect'), require('./packer'), require('./item'));
  } else {
    // browser global
    window.Packery = factory(window.getSize, window.Outlayer, window.Packery.Rect, window.Packery.Packer, window.Packery.Item);
  }
})(window, function factory(getSize, Outlayer, Rect, Packer, Item) {
  // ----- Rect ----- //
  // allow for pixel rounding errors IE8-IE11 & Firefox; #227
  Rect.prototype.canFit = function (rect) {
    return this.width >= rect.width - 1 && this.height >= rect.height - 1;
  }; // -------------------------- Packery -------------------------- //
  // create an Outlayer layout class


  var Packery = Outlayer.create('packery');
  Packery.Item = Item;
  var proto = Packery.prototype;

  proto._create = function () {
    // call super
    Outlayer.prototype._create.call(this); // initial properties


    this.packer = new Packer(); // packer for drop targets

    this.shiftPacker = new Packer();
    this.isEnabled = true;
    this.dragItemCount = 0; // create drag handlers

    var _this = this;

    this.handleDraggabilly = {
      dragStart: function dragStart() {
        _this.itemDragStart(this.element);
      },
      dragMove: function dragMove() {
        _this.itemDragMove(this.element, this.position.x, this.position.y);
      },
      dragEnd: function dragEnd() {
        _this.itemDragEnd(this.element);
      }
    };
    this.handleUIDraggable = {
      start: function handleUIDraggableStart(event, ui) {
        // HTML5 may trigger dragstart, dismiss HTML5 dragging
        if (!ui) {
          return;
        }

        _this.itemDragStart(event.currentTarget);
      },
      drag: function handleUIDraggableDrag(event, ui) {
        if (!ui) {
          return;
        }

        _this.itemDragMove(event.currentTarget, ui.position.left, ui.position.top);
      },
      stop: function handleUIDraggableStop(event, ui) {
        if (!ui) {
          return;
        }

        _this.itemDragEnd(event.currentTarget);
      }
    };
  }; // ----- init & layout ----- //

  /**
   * logic before any new layout
   */


  proto._resetLayout = function () {
    this.getSize();

    this._getMeasurements(); // reset packer


    var width, height, sortDirection; // packer settings, if horizontal or vertical

    if (this._getOption('horizontal')) {
      width = Infinity;
      height = this.size.innerHeight + this.gutter;
      sortDirection = 'rightwardTopToBottom';
    } else {
      width = this.size.innerWidth + this.gutter;
      height = Infinity;
      sortDirection = 'downwardLeftToRight';
    }

    this.packer.width = this.shiftPacker.width = width;
    this.packer.height = this.shiftPacker.height = height;
    this.packer.sortDirection = this.shiftPacker.sortDirection = sortDirection;
    this.packer.reset(); // layout

    this.maxY = 0;
    this.maxX = 0;
  };
  /**
   * update columnWidth, rowHeight, & gutter
   * @private
   */


  proto._getMeasurements = function () {
    this._getMeasurement('columnWidth', 'width');

    this._getMeasurement('rowHeight', 'height');

    this._getMeasurement('gutter', 'width');
  };

  proto._getItemLayoutPosition = function (item) {
    this._setRectSize(item.element, item.rect);

    if (this.isShifting || this.dragItemCount > 0) {
      var packMethod = this._getPackMethod();

      this.packer[packMethod](item.rect);
    } else {
      this.packer.pack(item.rect);
    }

    this._setMaxXY(item.rect);

    return item.rect;
  };

  proto.shiftLayout = function () {
    this.isShifting = true;
    this.layout();
    delete this.isShifting;
  };

  proto._getPackMethod = function () {
    return this._getOption('horizontal') ? 'rowPack' : 'columnPack';
  };
  /**
   * set max X and Y value, for size of container
   * @param {Packery.Rect} rect
   * @private
   */


  proto._setMaxXY = function (rect) {
    this.maxX = Math.max(rect.x + rect.width, this.maxX);
    this.maxY = Math.max(rect.y + rect.height, this.maxY);
  };
  /**
   * set the width and height of a rect, applying columnWidth and rowHeight
   * @param {Element} elem
   * @param {Packery.Rect} rect
   */


  proto._setRectSize = function (elem, rect) {
    var size = getSize(elem);
    var w = size.outerWidth;
    var h = size.outerHeight; // size for columnWidth and rowHeight, if available
    // only check if size is non-zero, #177

    if (w || h) {
      w = this._applyGridGutter(w, this.columnWidth);
      h = this._applyGridGutter(h, this.rowHeight);
    } // rect must fit in packer


    rect.width = Math.min(w, this.packer.width);
    rect.height = Math.min(h, this.packer.height);
  };
  /**
   * fits item to columnWidth/rowHeight and adds gutter
   * @param {Number} measurement - item width or height
   * @param {Number} gridSize - columnWidth or rowHeight
   * @returns measurement
   */


  proto._applyGridGutter = function (measurement, gridSize) {
    // just add gutter if no gridSize
    if (!gridSize) {
      return measurement + this.gutter;
    }

    gridSize += this.gutter; // fit item to columnWidth/rowHeight

    var remainder = measurement % gridSize;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    measurement = Math[mathMethod](measurement / gridSize) * gridSize;
    return measurement;
  };

  proto._getContainerSize = function () {
    if (this._getOption('horizontal')) {
      return {
        width: this.maxX - this.gutter
      };
    } else {
      return {
        height: this.maxY - this.gutter
      };
    }
  }; // -------------------------- stamp -------------------------- //

  /**
   * makes space for element
   * @param {Element} elem
   */


  proto._manageStamp = function (elem) {
    var item = this.getItem(elem);
    var rect;

    if (item && item.isPlacing) {
      rect = item.rect;
    } else {
      var offset = this._getElementOffset(elem);

      rect = new Rect({
        x: this._getOption('originLeft') ? offset.left : offset.right,
        y: this._getOption('originTop') ? offset.top : offset.bottom
      });
    }

    this._setRectSize(elem, rect); // save its space in the packer


    this.packer.placed(rect);

    this._setMaxXY(rect);
  }; // -------------------------- methods -------------------------- //


  function verticalSorter(a, b) {
    return a.position.y - b.position.y || a.position.x - b.position.x;
  }

  function horizontalSorter(a, b) {
    return a.position.x - b.position.x || a.position.y - b.position.y;
  }

  proto.sortItemsByPosition = function () {
    var sorter = this._getOption('horizontal') ? horizontalSorter : verticalSorter;
    this.items.sort(sorter);
  };
  /**
   * Fit item element in its current position
   * Packery will position elements around it
   * useful for expanding elements
   *
   * @param {Element} elem
   * @param {Number} x - horizontal destination position, optional
   * @param {Number} y - vertical destination position, optional
   */


  proto.fit = function (elem, x, y) {
    var item = this.getItem(elem);

    if (!item) {
      return;
    } // stamp item to get it out of layout


    this.stamp(item.element); // set placing flag

    item.enablePlacing();
    this.updateShiftTargets(item); // fall back to current position for fitting

    x = x === undefined ? item.rect.x : x;
    y = y === undefined ? item.rect.y : y; // position it best at its destination

    this.shift(item, x, y);

    this._bindFitEvents(item);

    item.moveTo(item.rect.x, item.rect.y); // layout everything else

    this.shiftLayout(); // return back to regularly scheduled programming

    this.unstamp(item.element);
    this.sortItemsByPosition();
    item.disablePlacing();
  };
  /**
   * emit event when item is fit and other items are laid out
   * @param {Packery.Item} item
   * @private
   */


  proto._bindFitEvents = function (item) {
    var _this = this;

    var ticks = 0;

    function onLayout() {
      ticks++;

      if (ticks != 2) {
        return;
      }

      _this.dispatchEvent('fitComplete', null, [item]);
    } // when item is laid out


    item.once('layout', onLayout); // when all items are laid out

    this.once('layoutComplete', onLayout);
  }; // -------------------------- resize -------------------------- //
  // debounced, layout on resize


  proto.resize = function () {
    // don't trigger if size did not change
    // or if resize was unbound. See #285, outlayer#9
    if (!this.isResizeBound || !this.needsResizeLayout()) {
      return;
    }

    if (this.options.shiftPercentResize) {
      this.resizeShiftPercentLayout();
    } else {
      this.layout();
    }
  };
  /**
   * check if layout is needed post layout
   * @returns Boolean
   */


  proto.needsResizeLayout = function () {
    var size = getSize(this.element);
    var innerSize = this._getOption('horizontal') ? 'innerHeight' : 'innerWidth';
    return size[innerSize] != this.size[innerSize];
  };

  proto.resizeShiftPercentLayout = function () {
    var items = this._getItemsForLayout(this.items);

    var isHorizontal = this._getOption('horizontal');

    var coord = isHorizontal ? 'y' : 'x';
    var measure = isHorizontal ? 'height' : 'width';
    var segmentName = isHorizontal ? 'rowHeight' : 'columnWidth';
    var innerSize = isHorizontal ? 'innerHeight' : 'innerWidth'; // proportional re-align items

    var previousSegment = this[segmentName];
    previousSegment = previousSegment && previousSegment + this.gutter;

    if (previousSegment) {
      this._getMeasurements();

      var currentSegment = this[segmentName] + this.gutter;
      items.forEach(function (item) {
        var seg = Math.round(item.rect[coord] / previousSegment);
        item.rect[coord] = seg * currentSegment;
      });
    } else {
      var currentSize = getSize(this.element)[innerSize] + this.gutter;
      var previousSize = this.packer[measure];
      items.forEach(function (item) {
        item.rect[coord] = item.rect[coord] / previousSize * currentSize;
      });
    }

    this.shiftLayout();
  }; // -------------------------- drag -------------------------- //

  /**
   * handle an item drag start event
   * @param {Element} elem
   */


  proto.itemDragStart = function (elem) {
    if (!this.isEnabled) {
      return;
    }

    this.stamp(elem); // this.ignore( elem );

    var item = this.getItem(elem);

    if (!item) {
      return;
    }

    item.enablePlacing();
    item.showDropPlaceholder();
    this.dragItemCount++;
    this.updateShiftTargets(item);
  };

  proto.updateShiftTargets = function (dropItem) {
    this.shiftPacker.reset(); // pack stamps

    this._getBoundingRect();

    var isOriginLeft = this._getOption('originLeft');

    var isOriginTop = this._getOption('originTop');

    this.stamps.forEach(function (stamp) {
      // ignore dragged item
      var item = this.getItem(stamp);

      if (item && item.isPlacing) {
        return;
      }

      var offset = this._getElementOffset(stamp);

      var rect = new Rect({
        x: isOriginLeft ? offset.left : offset.right,
        y: isOriginTop ? offset.top : offset.bottom
      });

      this._setRectSize(stamp, rect); // save its space in the packer


      this.shiftPacker.placed(rect);
    }, this); // reset shiftTargets

    var isHorizontal = this._getOption('horizontal');

    var segmentName = isHorizontal ? 'rowHeight' : 'columnWidth';
    var measure = isHorizontal ? 'height' : 'width';
    this.shiftTargetKeys = [];
    this.shiftTargets = [];
    var boundsSize;
    var segment = this[segmentName];
    segment = segment && segment + this.gutter;

    if (segment) {
      var segmentSpan = Math.ceil(dropItem.rect[measure] / segment);
      var segs = Math.floor((this.shiftPacker[measure] + this.gutter) / segment);
      boundsSize = (segs - segmentSpan) * segment; // add targets on top

      for (var i = 0; i < segs; i++) {
        this._addShiftTarget(i * segment, 0, boundsSize);
      }
    } else {
      boundsSize = this.shiftPacker[measure] + this.gutter - dropItem.rect[measure];

      this._addShiftTarget(0, 0, boundsSize);
    } // pack each item to measure where shiftTargets are


    var items = this._getItemsForLayout(this.items);

    var packMethod = this._getPackMethod();

    items.forEach(function (item) {
      var rect = item.rect;

      this._setRectSize(item.element, rect);

      this.shiftPacker[packMethod](rect); // add top left corner

      this._addShiftTarget(rect.x, rect.y, boundsSize); // add bottom left / top right corner


      var cornerX = isHorizontal ? rect.x + rect.width : rect.x;
      var cornerY = isHorizontal ? rect.y : rect.y + rect.height;

      this._addShiftTarget(cornerX, cornerY, boundsSize);

      if (segment) {
        // add targets for each column on bottom / row on right
        var segSpan = Math.round(rect[measure] / segment);

        for (var i = 1; i < segSpan; i++) {
          var segX = isHorizontal ? cornerX : rect.x + segment * i;
          var segY = isHorizontal ? rect.y + segment * i : cornerY;

          this._addShiftTarget(segX, segY, boundsSize);
        }
      }
    }, this);
  };

  proto._addShiftTarget = function (x, y, boundsSize) {
    var checkCoord = this._getOption('horizontal') ? y : x;

    if (checkCoord !== 0 && checkCoord > boundsSize) {
      return;
    } // create string for a key, easier to keep track of what targets


    var key = x + ',' + y;
    var hasKey = this.shiftTargetKeys.indexOf(key) != -1;

    if (hasKey) {
      return;
    }

    this.shiftTargetKeys.push(key);
    this.shiftTargets.push({
      x: x,
      y: y
    });
  }; // -------------------------- drop -------------------------- //


  proto.shift = function (item, x, y) {
    var shiftPosition;
    var minDistance = Infinity;
    var position = {
      x: x,
      y: y
    };
    this.shiftTargets.forEach(function (target) {
      var distance = getDistance(target, position);

      if (distance < minDistance) {
        shiftPosition = target;
        minDistance = distance;
      }
    });
    item.rect.x = shiftPosition.x;
    item.rect.y = shiftPosition.y;
  };

  function getDistance(a, b) {
    var dx = b.x - a.x;
    var dy = b.y - a.y;
    return Math.sqrt(dx * dx + dy * dy);
  } // -------------------------- drag move -------------------------- //


  var DRAG_THROTTLE_TIME = 120;
  /**
   * handle an item drag move event
   * @param {Element} elem
   * @param {Number} x - horizontal change in position
   * @param {Number} y - vertical change in position
   */

  proto.itemDragMove = function (elem, x, y) {
    var item = this.isEnabled && this.getItem(elem);

    if (!item) {
      return;
    }

    x -= this.size.paddingLeft;
    y -= this.size.paddingTop;

    var _this = this;

    function onDrag() {
      _this.shift(item, x, y);

      item.positionDropPlaceholder();

      _this.layout();
    } // throttle


    var now = new Date();

    if (this._itemDragTime && now - this._itemDragTime < DRAG_THROTTLE_TIME) {
      clearTimeout(this.dragTimeout);
      this.dragTimeout = setTimeout(onDrag, DRAG_THROTTLE_TIME);
    } else {
      onDrag();
      this._itemDragTime = now;
    }
  }; // -------------------------- drag end -------------------------- //

  /**
   * handle an item drag end event
   * @param {Element} elem
   */


  proto.itemDragEnd = function (elem) {
    var item = this.isEnabled && this.getItem(elem);

    if (!item) {
      return;
    }

    clearTimeout(this.dragTimeout);
    item.element.classList.add('is-positioning-post-drag');
    var completeCount = 0;

    var _this = this;

    function onDragEndLayoutComplete() {
      completeCount++;

      if (completeCount != 2) {
        return;
      } // reset drag item


      item.element.classList.remove('is-positioning-post-drag');
      item.hideDropPlaceholder();

      _this.dispatchEvent('dragItemPositioned', null, [item]);
    }

    item.once('layout', onDragEndLayoutComplete);
    this.once('layoutComplete', onDragEndLayoutComplete);
    item.moveTo(item.rect.x, item.rect.y);
    this.layout();
    this.dragItemCount = Math.max(0, this.dragItemCount - 1);
    this.sortItemsByPosition();
    item.disablePlacing();
    this.unstamp(item.element);
  };
  /**
   * binds Draggabilly events
   * @param {Draggabilly} draggie
   */


  proto.bindDraggabillyEvents = function (draggie) {
    this._bindDraggabillyEvents(draggie, 'on');
  };

  proto.unbindDraggabillyEvents = function (draggie) {
    this._bindDraggabillyEvents(draggie, 'off');
  };

  proto._bindDraggabillyEvents = function (draggie, method) {
    var handlers = this.handleDraggabilly;
    draggie[method]('dragStart', handlers.dragStart);
    draggie[method]('dragMove', handlers.dragMove);
    draggie[method]('dragEnd', handlers.dragEnd);
  };
  /**
   * binds jQuery UI Draggable events
   * @param {jQuery} $elems
   */


  proto.bindUIDraggableEvents = function ($elems) {
    this._bindUIDraggableEvents($elems, 'on');
  };

  proto.unbindUIDraggableEvents = function ($elems) {
    this._bindUIDraggableEvents($elems, 'off');
  };

  proto._bindUIDraggableEvents = function ($elems, method) {
    var handlers = this.handleUIDraggable;
    $elems[method]('dragstart', handlers.start)[method]('drag', handlers.drag)[method]('dragstop', handlers.stop);
  }; // ----- destroy ----- //


  var _destroy = proto.destroy;

  proto.destroy = function () {
    _destroy.apply(this, arguments); // disable flag; prevent drag events from triggering. #72


    this.isEnabled = false;
  }; // -----  ----- //


  Packery.Rect = Rect;
  Packery.Packer = Packer;
  return Packery;
});
/*!
 * Packery layout mode v2.0.1
 * sub-classes Packery
 */

/*jshint browser: true, strict: true, undef: true, unused: true */


(function (window, factory) {
  // universal module definition
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['isotope-layout/js/layout-mode', 'packery/js/packery'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof2(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('isotope-layout/js/layout-mode'), require('packery'));
  } else {
    // browser global
    factory(window.Isotope.LayoutMode, window.Packery);
  }
})(window, function factor(LayoutMode, Packery) {
  // create an Outlayer layout class
  var PackeryMode = LayoutMode.create('packery');
  var proto = PackeryMode.prototype;
  var keepModeMethods = {
    _getElementOffset: true,
    _getMeasurement: true
  }; // inherit Packery prototype

  for (var method in Packery.prototype) {
    // do not inherit mode methods
    if (!keepModeMethods[method]) {
      proto[method] = Packery.prototype[method];
    }
  } // set packer in _resetLayout


  var _resetLayout = proto._resetLayout;

  proto._resetLayout = function () {
    this.packer = this.packer || new Packery.Packer();
    this.shiftPacker = this.shiftPacker || new Packery.Packer();

    _resetLayout.apply(this, arguments);
  };

  var _getItemLayoutPosition = proto._getItemLayoutPosition;

  proto._getItemLayoutPosition = function (item) {
    // set packery rect
    item.rect = item.rect || new Packery.Rect();
    return _getItemLayoutPosition.call(this, item);
  }; // needsResizeLayout for vertical or horizontal


  var _needsResizeLayout = proto.needsResizeLayout;

  proto.needsResizeLayout = function () {
    if (this._getOption('horizontal')) {
      return this.needsVerticalResizeLayout();
    } else {
      return _needsResizeLayout.call(this);
    }
  }; // point to mode options for horizontal


  var _getOption = proto._getOption;

  proto._getOption = function (option) {
    if (option == 'horizontal') {
      return this.options.isHorizontal !== undefined ? this.options.isHorizontal : this.options.horizontal;
    }

    return _getOption.apply(this.isotope, arguments);
  };

  return PackeryMode;
});
/*  jQuery Nice Select - v1.0
    https://github.com/hernansartorio/jquery-nice-select
    Made by Hernán Sartorio  */


!function (e) {
  e.fn.niceSelect = function (t) {
    function s(t) {
      t.after(e("<div></div>").addClass("nice-select").addClass(t.attr("class") || "").addClass(t.attr("disabled") ? "disabled" : "").attr("tabindex", t.attr("disabled") ? null : "0").html('<span class="current"></span><ul class="list"></ul>'));
      var s = t.next(),
          n = t.find("option"),
          i = t.find("option:selected");
      s.find(".current").html(i.data("display") || i.text()), n.each(function (t) {
        var n = e(this),
            i = n.data("display");
        s.find("ul").append(e("<li></li>").attr("data-value", n.val()).attr("data-display", i || null).addClass("option" + (n.is(":selected") ? " selected" : "") + (n.is(":disabled") ? " disabled" : "")).html(n.text()));
      });
    }

    if ("string" == typeof t) return "update" == t ? this.each(function () {
      var t = e(this),
          n = e(this).next(".nice-select"),
          i = n.hasClass("open");
      n.length && (n.remove(), s(t), i && t.next().trigger("click"));
    }) : "destroy" == t ? (this.each(function () {
      var t = e(this),
          s = e(this).next(".nice-select");
      s.length && (s.remove(), t.css("display", ""));
    }), 0 == e(".nice-select").length && e(document).off(".nice_select")) : console.log('Method "' + t + '" does not exist.'), this;
    this.hide(), this.each(function () {
      var t = e(this);
      t.next().hasClass("nice-select") || s(t);
    }), e(document).off(".nice_select"), e(document).on("click.nice_select", ".nice-select", function (t) {
      var s = e(this);
      e(".nice-select").not(s).removeClass("open"), s.toggleClass("open"), s.hasClass("open") ? (s.find(".option"), s.find(".focus").removeClass("focus"), s.find(".selected").addClass("focus")) : s.focus();
    }), e(document).on("click.nice_select", function (t) {
      0 === e(t.target).closest(".nice-select").length && e(".nice-select").removeClass("open").find(".option");
    }), e(document).on("click.nice_select", ".nice-select .option:not(.disabled)", function (t) {
      var s = e(this),
          n = s.closest(".nice-select");
      n.find(".selected").removeClass("selected"), s.addClass("selected");
      var i = s.data("display") || s.text();
      n.find(".current").text(i), n.prev("select").val(s.data("value")).trigger("change");
    }), e(document).on("keydown.nice_select", ".nice-select", function (t) {
      var s = e(this),
          n = e(s.find(".focus") || s.find(".list .option.selected"));
      if (32 == t.keyCode || 13 == t.keyCode) return s.hasClass("open") ? n.trigger("click") : s.trigger("click"), !1;

      if (40 == t.keyCode) {
        if (s.hasClass("open")) {
          var i = n.nextAll(".option:not(.disabled)").first();
          i.length > 0 && (s.find(".focus").removeClass("focus"), i.addClass("focus"));
        } else s.trigger("click");

        return !1;
      }

      if (38 == t.keyCode) {
        if (s.hasClass("open")) {
          var l = n.prevAll(".option:not(.disabled)").first();
          l.length > 0 && (s.find(".focus").removeClass("focus"), l.addClass("focus"));
        } else s.trigger("click");

        return !1;
      }

      if (27 == t.keyCode) s.hasClass("open") && s.trigger("click");else if (9 == t.keyCode && s.hasClass("open")) return !1;
    });
    var n = document.createElement("a").style;
    return n.cssText = "pointer-events:auto", "auto" !== n.pointerEvents && e("html").addClass("no-csspointerevents"), this;
  };
}(jQuery);
/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */

!function (a) {
  "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) ? require("jquery") : window.jQuery || window.Zepto);
}(function (a) {
  var b,
      c,
      d,
      e,
      f,
      g,
      h = "Close",
      i = "BeforeClose",
      j = "AfterClose",
      k = "BeforeAppend",
      l = "MarkupParse",
      m = "Open",
      n = "Change",
      o = "mfp",
      p = "." + o,
      q = "mfp-ready",
      r = "mfp-removing",
      s = "mfp-prevent-close",
      t = function t() {},
      u = !!window.jQuery,
      v = a(window),
      w = function w(a, c) {
    b.ev.on(o + a + p, c);
  },
      x = function x(b, c, d, e) {
    var f = document.createElement("div");
    return f.className = "mfp-" + b, d && (f.innerHTML = d), e ? c && c.appendChild(f) : (f = a(f), c && f.appendTo(c)), f;
  },
      y = function y(c, d) {
    b.ev.triggerHandler(o + c, d), b.st.callbacks && (c = c.charAt(0).toLowerCase() + c.slice(1), b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]));
  },
      z = function z(c) {
    return c === g && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)), g = c), b.currTemplate.closeBtn;
  },
      A = function A() {
    a.magnificPopup.instance || (b = new t(), b.init(), a.magnificPopup.instance = b);
  },
      B = function B() {
    var a = document.createElement("p").style,
        b = ["ms", "O", "Moz", "Webkit"];
    if (void 0 !== a.transition) return !0;

    for (; b.length;) {
      if (b.pop() + "Transition" in a) return !0;
    }

    return !1;
  };

  t.prototype = {
    constructor: t,
    init: function init() {
      var c = navigator.appVersion;
      b.isLowIE = b.isIE8 = document.all && !document.addEventListener, b.isAndroid = /android/gi.test(c), b.isIOS = /iphone|ipad|ipod/gi.test(c), b.supportsTransition = B(), b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), d = a(document), b.popupsCache = {};
    },
    open: function open(c) {
      var e;

      if (c.isObj === !1) {
        b.items = c.items.toArray(), b.index = 0;
        var g,
            h = c.items;

        for (e = 0; e < h.length; e++) {
          if (g = h[e], g.parsed && (g = g.el[0]), g === c.el[0]) {
            b.index = e;
            break;
          }
        }
      } else b.items = a.isArray(c.items) ? c.items : [c.items], b.index = c.index || 0;

      if (b.isOpen) return void b.updateItemHTML();
      b.types = [], f = "", c.mainEl && c.mainEl.length ? b.ev = c.mainEl.eq(0) : b.ev = d, c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}), b.currTemplate = b.popupsCache[c.key]) : b.currTemplate = {}, b.st = a.extend(!0, {}, a.magnificPopup.defaults, c), b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos, b.st.modal && (b.st.closeOnContentClick = !1, b.st.closeOnBgClick = !1, b.st.showCloseBtn = !1, b.st.enableEscapeKey = !1), b.bgOverlay || (b.bgOverlay = x("bg").on("click" + p, function () {
        b.close();
      }), b.wrap = x("wrap").attr("tabindex", -1).on("click" + p, function (a) {
        b._checkIfClose(a.target) && b.close();
      }), b.container = x("container", b.wrap)), b.contentContainer = x("content"), b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading));
      var i = a.magnificPopup.modules;

      for (e = 0; e < i.length; e++) {
        var j = i[e];
        j = j.charAt(0).toUpperCase() + j.slice(1), b["init" + j].call(b);
      }

      y("BeforeOpen"), b.st.showCloseBtn && (b.st.closeBtnInside ? (w(l, function (a, b, c, d) {
        c.close_replaceWith = z(d.type);
      }), f += " mfp-close-btn-in") : b.wrap.append(z())), b.st.alignTop && (f += " mfp-align-top"), b.fixedContentPos ? b.wrap.css({
        overflow: b.st.overflowY,
        overflowX: "hidden",
        overflowY: b.st.overflowY
      }) : b.wrap.css({
        top: v.scrollTop(),
        position: "absolute"
      }), (b.st.fixedBgPos === !1 || "auto" === b.st.fixedBgPos && !b.fixedContentPos) && b.bgOverlay.css({
        height: d.height(),
        position: "absolute"
      }), b.st.enableEscapeKey && d.on("keyup" + p, function (a) {
        27 === a.keyCode && b.close();
      }), v.on("resize" + p, function () {
        b.updateSize();
      }), b.st.closeOnContentClick || (f += " mfp-auto-cursor"), f && b.wrap.addClass(f);
      var k = b.wH = v.height(),
          n = {};

      if (b.fixedContentPos && b._hasScrollBar(k)) {
        var o = b._getScrollbarSize();

        o && (n.marginRight = o);
      }

      b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : n.overflow = "hidden");
      var r = b.st.mainClass;
      return b.isIE7 && (r += " mfp-ie7"), r && b._addClassToMFP(r), b.updateItemHTML(), y("BuildControls"), a("html").css(n), b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)), b._lastFocusedEl = document.activeElement, setTimeout(function () {
        b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q), d.on("focusin" + p, b._onFocusIn);
      }, 16), b.isOpen = !0, b.updateSize(k), y(m), c;
    },
    close: function close() {
      b.isOpen && (y(i), b.isOpen = !1, b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(r), setTimeout(function () {
        b._close();
      }, b.st.removalDelay)) : b._close());
    },
    _close: function _close() {
      y(h);
      var c = r + " " + q + " ";

      if (b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c += b.st.mainClass + " "), b._removeClassFromMFP(c), b.fixedContentPos) {
        var e = {
          marginRight: ""
        };
        b.isIE7 ? a("body, html").css("overflow", "") : e.overflow = "", a("html").css(e);
      }

      d.off("keyup" + p + " focusin" + p), b.ev.off(p), b.wrap.attr("class", "mfp-wrap").removeAttr("style"), b.bgOverlay.attr("class", "mfp-bg"), b.container.attr("class", "mfp-container"), !b.st.showCloseBtn || b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0 || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(), b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(), b.currItem = null, b.content = null, b.currTemplate = null, b.prevHeight = 0, y(j);
    },
    updateSize: function updateSize(a) {
      if (b.isIOS) {
        var c = document.documentElement.clientWidth / window.innerWidth,
            d = window.innerHeight * c;
        b.wrap.css("height", d), b.wH = d;
      } else b.wH = a || v.height();

      b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize");
    },
    updateItemHTML: function updateItemHTML() {
      var c = b.items[b.index];
      b.contentContainer.detach(), b.content && b.content.detach(), c.parsed || (c = b.parseEl(b.index));
      var d = c.type;

      if (y("BeforeChange", [b.currItem ? b.currItem.type : "", d]), b.currItem = c, !b.currTemplate[d]) {
        var f = b.st[d] ? b.st[d].markup : !1;
        y("FirstMarkupParse", f), f ? b.currTemplate[d] = a(f) : b.currTemplate[d] = !0;
      }

      e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder");
      var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);
      b.appendContent(g, d), c.preloaded = !0, y(n, c), e = c.type, b.container.prepend(b.contentContainer), y("AfterChange");
    },
    appendContent: function appendContent(a, c) {
      b.content = a, a ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : b.content = a : b.content = "", y(k), b.container.addClass("mfp-" + c + "-holder"), b.contentContainer.append(b.content);
    },
    parseEl: function parseEl(c) {
      var d,
          e = b.items[c];

      if (e.tagName ? e = {
        el: a(e)
      } : (d = e.type, e = {
        data: e,
        src: e.src
      }), e.el) {
        for (var f = b.types, g = 0; g < f.length; g++) {
          if (e.el.hasClass("mfp-" + f[g])) {
            d = f[g];
            break;
          }
        }

        e.src = e.el.attr("data-mfp-src"), e.src || (e.src = e.el.attr("href"));
      }

      return e.type = d || b.st.type || "inline", e.index = c, e.parsed = !0, b.items[c] = e, y("ElementParse", e), b.items[c];
    },
    addGroup: function addGroup(a, c) {
      var d = function d(_d) {
        _d.mfpEl = this, b._openClick(_d, a, c);
      };

      c || (c = {});
      var e = "click.magnificPopup";
      c.mainEl = a, c.items ? (c.isObj = !0, a.off(e).on(e, d)) : (c.isObj = !1, c.delegate ? a.off(e).on(e, c.delegate, d) : (c.items = a, a.off(e).on(e, d)));
    },
    _openClick: function _openClick(c, d, e) {
      var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;

      if (f || !(2 === c.which || c.ctrlKey || c.metaKey || c.altKey || c.shiftKey)) {
        var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;
        if (g) if (a.isFunction(g)) {
          if (!g.call(b)) return !0;
        } else if (v.width() < g) return !0;
        c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()), e.el = a(c.mfpEl), e.delegate && (e.items = d.find(e.delegate)), b.open(e);
      }
    },
    updateStatus: function updateStatus(a, d) {
      if (b.preloader) {
        c !== a && b.container.removeClass("mfp-s-" + c), d || "loading" !== a || (d = b.st.tLoading);
        var e = {
          status: a,
          text: d
        };
        y("UpdateStatus", e), a = e.status, d = e.text, b.preloader.html(d), b.preloader.find("a").on("click", function (a) {
          a.stopImmediatePropagation();
        }), b.container.addClass("mfp-s-" + a), c = a;
      }
    },
    _checkIfClose: function _checkIfClose(c) {
      if (!a(c).hasClass(s)) {
        var d = b.st.closeOnContentClick,
            e = b.st.closeOnBgClick;
        if (d && e) return !0;
        if (!b.content || a(c).hasClass("mfp-close") || b.preloader && c === b.preloader[0]) return !0;

        if (c === b.content[0] || a.contains(b.content[0], c)) {
          if (d) return !0;
        } else if (e && a.contains(document, c)) return !0;

        return !1;
      }
    },
    _addClassToMFP: function _addClassToMFP(a) {
      b.bgOverlay.addClass(a), b.wrap.addClass(a);
    },
    _removeClassFromMFP: function _removeClassFromMFP(a) {
      this.bgOverlay.removeClass(a), b.wrap.removeClass(a);
    },
    _hasScrollBar: function _hasScrollBar(a) {
      return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height());
    },
    _setFocus: function _setFocus() {
      (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus();
    },
    _onFocusIn: function _onFocusIn(c) {
      return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target) ? void 0 : (b._setFocus(), !1);
    },
    _parseMarkup: function _parseMarkup(b, c, d) {
      var e;
      d.data && (c = a.extend(d.data, c)), y(l, [b, c, d]), a.each(c, function (c, d) {
        if (void 0 === d || d === !1) return !0;

        if (e = c.split("_"), e.length > 1) {
          var f = b.find(p + "-" + e[0]);

          if (f.length > 0) {
            var g = e[1];
            "replaceWith" === g ? f[0] !== d[0] && f.replaceWith(d) : "img" === g ? f.is("img") ? f.attr("src", d) : f.replaceWith(a("<img>").attr("src", d).attr("class", f.attr("class"))) : f.attr(e[1], d);
          }
        } else b.find(p + "-" + c).html(d);
      });
    },
    _getScrollbarSize: function _getScrollbarSize() {
      if (void 0 === b.scrollbarSize) {
        var a = document.createElement("div");
        a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(a), b.scrollbarSize = a.offsetWidth - a.clientWidth, document.body.removeChild(a);
      }

      return b.scrollbarSize;
    }
  }, a.magnificPopup = {
    instance: null,
    proto: t.prototype,
    modules: [],
    open: function open(b, c) {
      return A(), b = b ? a.extend(!0, {}, b) : {}, b.isObj = !0, b.index = c || 0, this.instance.open(b);
    },
    close: function close() {
      return a.magnificPopup.instance && a.magnificPopup.instance.close();
    },
    registerModule: function registerModule(b, c) {
      c.options && (a.magnificPopup.defaults[b] = c.options), a.extend(this.proto, c.proto), this.modules.push(b);
    },
    defaults: {
      disableOn: 0,
      key: null,
      midClick: !1,
      mainClass: "",
      preloader: !0,
      focus: "",
      closeOnContentClick: !1,
      closeOnBgClick: !0,
      closeBtnInside: !0,
      showCloseBtn: !0,
      enableEscapeKey: !0,
      modal: !1,
      alignTop: !1,
      removalDelay: 0,
      prependTo: null,
      fixedContentPos: "auto",
      fixedBgPos: "auto",
      overflowY: "auto",
      closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
      tClose: "Close (Esc)",
      tLoading: "Loading...",
      autoFocusLast: !0
    }
  }, a.fn.magnificPopup = function (c) {
    A();
    var d = a(this);
    if ("string" == typeof c) {
      if ("open" === c) {
        var e,
            f = u ? d.data("magnificPopup") : d[0].magnificPopup,
            g = parseInt(arguments[1], 10) || 0;
        f.items ? e = f.items[g] : (e = d, f.delegate && (e = e.find(f.delegate)), e = e.eq(g)), b._openClick({
          mfpEl: e
        }, d, f);
      } else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1));
    } else c = a.extend(!0, {}, c), u ? d.data("magnificPopup", c) : d[0].magnificPopup = c, b.addGroup(d, c);
    return d;
  };

  var C,
      D,
      E,
      F = "inline",
      G = function G() {
    E && (D.after(E.addClass(C)).detach(), E = null);
  };

  a.magnificPopup.registerModule(F, {
    options: {
      hiddenClass: "hide",
      markup: "",
      tNotFound: "Content not found"
    },
    proto: {
      initInline: function initInline() {
        b.types.push(F), w(h + "." + F, function () {
          G();
        });
      },
      getInline: function getInline(c, d) {
        if (G(), c.src) {
          var e = b.st.inline,
              f = a(c.src);

          if (f.length) {
            var g = f[0].parentNode;
            g && g.tagName && (D || (C = e.hiddenClass, D = x(C), C = "mfp-" + C), E = f.after(D).detach().removeClass(C)), b.updateStatus("ready");
          } else b.updateStatus("error", e.tNotFound), f = a("<div>");

          return c.inlineElement = f, f;
        }

        return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d;
      }
    }
  });

  var H,
      I = "ajax",
      J = function J() {
    H && a(document.body).removeClass(H);
  },
      K = function K() {
    J(), b.req && b.req.abort();
  };

  a.magnificPopup.registerModule(I, {
    options: {
      settings: null,
      cursor: "mfp-ajax-cur",
      tError: '<a href="%url%">The content</a> could not be loaded.'
    },
    proto: {
      initAjax: function initAjax() {
        b.types.push(I), H = b.st.ajax.cursor, w(h + "." + I, K), w("BeforeChange." + I, K);
      },
      getAjax: function getAjax(c) {
        H && a(document.body).addClass(H), b.updateStatus("loading");
        var d = a.extend({
          url: c.src,
          success: function success(d, e, f) {
            var g = {
              data: d,
              xhr: f
            };
            y("ParseAjax", g), b.appendContent(a(g.data), I), c.finished = !0, J(), b._setFocus(), setTimeout(function () {
              b.wrap.addClass(q);
            }, 16), b.updateStatus("ready"), y("AjaxContentAdded");
          },
          error: function error() {
            J(), c.finished = c.loadError = !0, b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src));
          }
        }, b.st.ajax.settings);
        return b.req = a.ajax(d), "";
      }
    }
  });

  var L,
      M = function M(c) {
    if (c.data && void 0 !== c.data.title) return c.data.title;
    var d = b.st.image.titleSrc;

    if (d) {
      if (a.isFunction(d)) return d.call(b, c);
      if (c.el) return c.el.attr(d) || "";
    }

    return "";
  };

  a.magnificPopup.registerModule("image", {
    options: {
      markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
      cursor: "mfp-zoom-out-cur",
      titleSrc: "title",
      verticalFit: !0,
      tError: '<a href="%url%">The image</a> could not be loaded.'
    },
    proto: {
      initImage: function initImage() {
        var c = b.st.image,
            d = ".image";
        b.types.push("image"), w(m + d, function () {
          "image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor);
        }), w(h + d, function () {
          c.cursor && a(document.body).removeClass(c.cursor), v.off("resize" + p);
        }), w("Resize" + d, b.resizeImage), b.isLowIE && w("AfterChange", b.resizeImage);
      },
      resizeImage: function resizeImage() {
        var a = b.currItem;

        if (a && a.img && b.st.image.verticalFit) {
          var c = 0;
          b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)), a.img.css("max-height", b.wH - c);
        }
      },
      _onImageHasSize: function _onImageHasSize(a) {
        a.img && (a.hasSize = !0, L && clearInterval(L), a.isCheckingImgSize = !1, y("ImageHasSize", a), a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), a.imgHidden = !1));
      },
      findImageSize: function findImageSize(a) {
        var c = 0,
            d = a.img[0],
            e = function e(f) {
          L && clearInterval(L), L = setInterval(function () {
            return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(L), c++, void (3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)));
          }, f);
        };

        e(1);
      },
      getImage: function getImage(c, d) {
        var e = 0,
            f = function f() {
          c && (c.img[0].complete ? (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")), c.hasSize = !0, c.loaded = !0, y("ImageLoadComplete")) : (e++, 200 > e ? setTimeout(f, 100) : g()));
        },
            g = function g() {
          c && (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))), c.hasSize = !0, c.loaded = !0, c.loadError = !0);
        },
            h = b.st.image,
            i = d.find(".mfp-img");

        if (i.length) {
          var j = document.createElement("img");
          j.className = "mfp-img", c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")), c.img = a(j).on("load.mfploader", f).on("error.mfploader", g), j.src = c.src, i.is("img") && (c.img = c.img.clone()), j = c.img[0], j.naturalWidth > 0 ? c.hasSize = !0 : j.width || (c.hasSize = !1);
        }

        return b._parseMarkup(d, {
          title: M(c),
          img_replaceWith: c.img
        }, c), b.resizeImage(), c.hasSize ? (L && clearInterval(L), c.loadError ? (d.addClass("mfp-loading"), b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"), b.updateStatus("ready")), d) : (b.updateStatus("loading"), c.loading = !0, c.hasSize || (c.imgHidden = !0, d.addClass("mfp-loading"), b.findImageSize(c)), d);
      }
    }
  });

  var N,
      O = function O() {
    return void 0 === N && (N = void 0 !== document.createElement("p").style.MozTransform), N;
  };

  a.magnificPopup.registerModule("zoom", {
    options: {
      enabled: !1,
      easing: "ease-in-out",
      duration: 300,
      opener: function opener(a) {
        return a.is("img") ? a : a.find("img");
      }
    },
    proto: {
      initZoom: function initZoom() {
        var a,
            c = b.st.zoom,
            d = ".zoom";

        if (c.enabled && b.supportsTransition) {
          var e,
              f,
              g = c.duration,
              j = function j(a) {
            var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                d = "all " + c.duration / 1e3 + "s " + c.easing,
                e = {
              position: "fixed",
              zIndex: 9999,
              left: 0,
              top: 0,
              "-webkit-backface-visibility": "hidden"
            },
                f = "transition";
            return e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d, b.css(e), b;
          },
              k = function k() {
            b.content.css("visibility", "visible");
          };

          w("BuildControls" + d, function () {
            if (b._allowZoom()) {
              if (clearTimeout(e), b.content.css("visibility", "hidden"), a = b._getItemToZoom(), !a) return void k();
              f = j(a), f.css(b._getOffset()), b.wrap.append(f), e = setTimeout(function () {
                f.css(b._getOffset(!0)), e = setTimeout(function () {
                  k(), setTimeout(function () {
                    f.remove(), a = f = null, y("ZoomAnimationEnded");
                  }, 16);
                }, g);
              }, 16);
            }
          }), w(i + d, function () {
            if (b._allowZoom()) {
              if (clearTimeout(e), b.st.removalDelay = g, !a) {
                if (a = b._getItemToZoom(), !a) return;
                f = j(a);
              }

              f.css(b._getOffset(!0)), b.wrap.append(f), b.content.css("visibility", "hidden"), setTimeout(function () {
                f.css(b._getOffset());
              }, 16);
            }
          }), w(h + d, function () {
            b._allowZoom() && (k(), f && f.remove(), a = null);
          });
        }
      },
      _allowZoom: function _allowZoom() {
        return "image" === b.currItem.type;
      },
      _getItemToZoom: function _getItemToZoom() {
        return b.currItem.hasSize ? b.currItem.img : !1;
      },
      _getOffset: function _getOffset(c) {
        var d;
        d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
        var e = d.offset(),
            f = parseInt(d.css("padding-top"), 10),
            g = parseInt(d.css("padding-bottom"), 10);
        e.top -= a(window).scrollTop() - f;
        var h = {
          width: d.width(),
          height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f
        };
        return O() ? h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)" : (h.left = e.left, h.top = e.top), h;
      }
    }
  });

  var P = "iframe",
      Q = "//about:blank",
      R = function R(a) {
    if (b.currTemplate[P]) {
      var c = b.currTemplate[P].find("iframe");
      c.length && (a || (c[0].src = Q), b.isIE8 && c.css("display", a ? "block" : "none"));
    }
  };

  a.magnificPopup.registerModule(P, {
    options: {
      markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
      srcAction: "iframe_src",
      patterns: {
        youtube: {
          index: "youtube.com",
          id: "v=",
          src: "//www.youtube.com/embed/%id%?autoplay=1"
        },
        vimeo: {
          index: "vimeo.com/",
          id: "/",
          src: "//player.vimeo.com/video/%id%?autoplay=1"
        },
        gmaps: {
          index: "//maps.google.",
          src: "%id%&output=embed"
        }
      }
    },
    proto: {
      initIframe: function initIframe() {
        b.types.push(P), w("BeforeChange", function (a, b, c) {
          b !== c && (b === P ? R() : c === P && R(!0));
        }), w(h + "." + P, function () {
          R();
        });
      },
      getIframe: function getIframe(c, d) {
        var e = c.src,
            f = b.st.iframe;
        a.each(f.patterns, function () {
          return e.indexOf(this.index) > -1 ? (this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)), e = this.src.replace("%id%", e), !1) : void 0;
        });
        var g = {};
        return f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d;
      }
    }
  });

  var S = function S(a) {
    var c = b.items.length;
    return a > c - 1 ? a - c : 0 > a ? c + a : a;
  },
      T = function T(a, b, c) {
    return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c);
  };

  a.magnificPopup.registerModule("gallery", {
    options: {
      enabled: !1,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      preload: [0, 2],
      navigateByImgClick: !0,
      arrows: !0,
      tPrev: "Previous (Left arrow key)",
      tNext: "Next (Right arrow key)",
      tCounter: "%curr% of %total%"
    },
    proto: {
      initGallery: function initGallery() {
        var c = b.st.gallery,
            e = ".mfp-gallery";
        return b.direction = !0, c && c.enabled ? (f += " mfp-gallery", w(m + e, function () {
          c.navigateByImgClick && b.wrap.on("click" + e, ".mfp-img", function () {
            return b.items.length > 1 ? (b.next(), !1) : void 0;
          }), d.on("keydown" + e, function (a) {
            37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next();
          });
        }), w("UpdateStatus" + e, function (a, c) {
          c.text && (c.text = T(c.text, b.currItem.index, b.items.length));
        }), w(l + e, function (a, d, e, f) {
          var g = b.items.length;
          e.counter = g > 1 ? T(c.tCounter, f.index, g) : "";
        }), w("BuildControls" + e, function () {
          if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
            var d = c.arrowMarkup,
                e = b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(s),
                f = b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(s);
            e.click(function () {
              b.prev();
            }), f.click(function () {
              b.next();
            }), b.container.append(e.add(f));
          }
        }), w(n + e, function () {
          b._preloadTimeout && clearTimeout(b._preloadTimeout), b._preloadTimeout = setTimeout(function () {
            b.preloadNearbyImages(), b._preloadTimeout = null;
          }, 16);
        }), void w(h + e, function () {
          d.off(e), b.wrap.off("click" + e), b.arrowRight = b.arrowLeft = null;
        })) : !1;
      },
      next: function next() {
        b.direction = !0, b.index = S(b.index + 1), b.updateItemHTML();
      },
      prev: function prev() {
        b.direction = !1, b.index = S(b.index - 1), b.updateItemHTML();
      },
      goTo: function goTo(a) {
        b.direction = a >= b.index, b.index = a, b.updateItemHTML();
      },
      preloadNearbyImages: function preloadNearbyImages() {
        var a,
            c = b.st.gallery.preload,
            d = Math.min(c[0], b.items.length),
            e = Math.min(c[1], b.items.length);

        for (a = 1; a <= (b.direction ? e : d); a++) {
          b._preloadItem(b.index + a);
        }

        for (a = 1; a <= (b.direction ? d : e); a++) {
          b._preloadItem(b.index - a);
        }
      },
      _preloadItem: function _preloadItem(c) {
        if (c = S(c), !b.items[c].preloaded) {
          var d = b.items[c];
          d.parsed || (d = b.parseEl(c)), y("LazyLoad", d), "image" === d.type && (d.img = a('<img class="mfp-img" />').on("load.mfploader", function () {
            d.hasSize = !0;
          }).on("error.mfploader", function () {
            d.hasSize = !0, d.loadError = !0, y("LazyLoadError", d);
          }).attr("src", d.src)), d.preloaded = !0;
        }
      }
    }
  });
  var U = "retina";
  a.magnificPopup.registerModule(U, {
    options: {
      replaceSrc: function replaceSrc(a) {
        return a.src.replace(/\.\w+$/, function (a) {
          return "@2x" + a;
        });
      },
      ratio: 1
    },
    proto: {
      initRetina: function initRetina() {
        if (window.devicePixelRatio > 1) {
          var a = b.st.retina,
              c = a.ratio;
          c = isNaN(c) ? c() : c, c > 1 && (w("ImageHasSize." + U, function (a, b) {
            b.img.css({
              "max-width": b.img[0].naturalWidth / c,
              width: "100%"
            });
          }), w("ElementParse." + U, function (b, d) {
            d.src = a.replaceSrc(d, c);
          }));
        }
      }
    }
  }), A();
});
/**!

 @license
 handlebars v4.0.12

Copyright (C) 2011-2017 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : _typeof2(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if ((typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object') exports["Handlebars"] = factory();else root["Handlebars"] = factory();
})(this, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId])
          /******/
          return installedModules[moduleId].exports;
        /******/
        // Create a new module (and put it into the cache)

        /******/

        var module = installedModules[moduleId] = {
          /******/
          exports: {},

          /******/
          id: moduleId,

          /******/
          loaded: false
          /******/

        };
        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        // Flag the module as loaded

        /******/

        module.loaded = true;
        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/
      // __webpack_public_path__

      /******/

      __webpack_require__.p = "";
      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(0);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;

      var _handlebarsRuntime = __webpack_require__(2);

      var _handlebarsRuntime2 = _interopRequireDefault(_handlebarsRuntime); // Compiler imports


      var _handlebarsCompilerAst = __webpack_require__(35);

      var _handlebarsCompilerAst2 = _interopRequireDefault(_handlebarsCompilerAst);

      var _handlebarsCompilerBase = __webpack_require__(36);

      var _handlebarsCompilerCompiler = __webpack_require__(41);

      var _handlebarsCompilerJavascriptCompiler = __webpack_require__(42);

      var _handlebarsCompilerJavascriptCompiler2 = _interopRequireDefault(_handlebarsCompilerJavascriptCompiler);

      var _handlebarsCompilerVisitor = __webpack_require__(39);

      var _handlebarsCompilerVisitor2 = _interopRequireDefault(_handlebarsCompilerVisitor);

      var _handlebarsNoConflict = __webpack_require__(34);

      var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

      var _create = _handlebarsRuntime2['default'].create;

      function create() {
        var hb = _create();

        hb.compile = function (input, options) {
          return _handlebarsCompilerCompiler.compile(input, options, hb);
        };

        hb.precompile = function (input, options) {
          return _handlebarsCompilerCompiler.precompile(input, options, hb);
        };

        hb.AST = _handlebarsCompilerAst2['default'];
        hb.Compiler = _handlebarsCompilerCompiler.Compiler;
        hb.JavaScriptCompiler = _handlebarsCompilerJavascriptCompiler2['default'];
        hb.Parser = _handlebarsCompilerBase.parser;
        hb.parse = _handlebarsCompilerBase.parse;
        return hb;
      }

      var inst = create();
      inst.create = create;

      _handlebarsNoConflict2['default'](inst);

      inst.Visitor = _handlebarsCompilerVisitor2['default'];
      inst['default'] = inst;
      exports['default'] = inst;
      module.exports = exports['default'];
      /***/
    },
    /* 1 */

    /***/
    function (module, exports) {
      "use strict";

      exports["default"] = function (obj) {
        return obj && obj.__esModule ? obj : {
          "default": obj
        };
      };

      exports.__esModule = true;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireWildcard = __webpack_require__(3)['default'];

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;

      var _handlebarsBase = __webpack_require__(4);

      var base = _interopRequireWildcard(_handlebarsBase); // Each of these augment the Handlebars object. No need to setup here.
      // (This is done to easily share code between commonjs and browse envs)


      var _handlebarsSafeString = __webpack_require__(21);

      var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

      var _handlebarsException = __webpack_require__(6);

      var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

      var _handlebarsUtils = __webpack_require__(5);

      var Utils = _interopRequireWildcard(_handlebarsUtils);

      var _handlebarsRuntime = __webpack_require__(22);

      var runtime = _interopRequireWildcard(_handlebarsRuntime);

      var _handlebarsNoConflict = __webpack_require__(34);

      var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict); // For compatibility and usage outside of module systems, make the Handlebars object a namespace


      function create() {
        var hb = new base.HandlebarsEnvironment();
        Utils.extend(hb, base);
        hb.SafeString = _handlebarsSafeString2['default'];
        hb.Exception = _handlebarsException2['default'];
        hb.Utils = Utils;
        hb.escapeExpression = Utils.escapeExpression;
        hb.VM = runtime;

        hb.template = function (spec) {
          return runtime.template(spec, hb);
        };

        return hb;
      }

      var inst = create();
      inst.create = create;

      _handlebarsNoConflict2['default'](inst);

      inst['default'] = inst;
      exports['default'] = inst;
      module.exports = exports['default'];
      /***/
    },
    /* 3 */

    /***/
    function (module, exports) {
      "use strict";

      exports["default"] = function (obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};

          if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }

          newObj["default"] = obj;
          return newObj;
        }
      };

      exports.__esModule = true;
      /***/
    },
    /* 4 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;
      exports.HandlebarsEnvironment = HandlebarsEnvironment;

      var _utils = __webpack_require__(5);

      var _exception = __webpack_require__(6);

      var _exception2 = _interopRequireDefault(_exception);

      var _helpers = __webpack_require__(10);

      var _decorators = __webpack_require__(18);

      var _logger = __webpack_require__(20);

      var _logger2 = _interopRequireDefault(_logger);

      var VERSION = '4.0.12';
      exports.VERSION = VERSION;
      var COMPILER_REVISION = 7;
      exports.COMPILER_REVISION = COMPILER_REVISION;
      var REVISION_CHANGES = {
        1: '<= 1.0.rc.2',
        // 1.0.rc.2 is actually rev2 but doesn't report it
        2: '== 1.0.0-rc.3',
        3: '== 1.0.0-rc.4',
        4: '== 1.x.x',
        5: '== 2.0.0-alpha.x',
        6: '>= 2.0.0-beta.1',
        7: '>= 4.0.0'
      };
      exports.REVISION_CHANGES = REVISION_CHANGES;
      var objectType = '[object Object]';

      function HandlebarsEnvironment(helpers, partials, decorators) {
        this.helpers = helpers || {};
        this.partials = partials || {};
        this.decorators = decorators || {};

        _helpers.registerDefaultHelpers(this);

        _decorators.registerDefaultDecorators(this);
      }

      HandlebarsEnvironment.prototype = {
        constructor: HandlebarsEnvironment,
        logger: _logger2['default'],
        log: _logger2['default'].log,
        registerHelper: function registerHelper(name, fn) {
          if (_utils.toString.call(name) === objectType) {
            if (fn) {
              throw new _exception2['default']('Arg not supported with multiple helpers');
            }

            _utils.extend(this.helpers, name);
          } else {
            this.helpers[name] = fn;
          }
        },
        unregisterHelper: function unregisterHelper(name) {
          delete this.helpers[name];
        },
        registerPartial: function registerPartial(name, partial) {
          if (_utils.toString.call(name) === objectType) {
            _utils.extend(this.partials, name);
          } else {
            if (typeof partial === 'undefined') {
              throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
            }

            this.partials[name] = partial;
          }
        },
        unregisterPartial: function unregisterPartial(name) {
          delete this.partials[name];
        },
        registerDecorator: function registerDecorator(name, fn) {
          if (_utils.toString.call(name) === objectType) {
            if (fn) {
              throw new _exception2['default']('Arg not supported with multiple decorators');
            }

            _utils.extend(this.decorators, name);
          } else {
            this.decorators[name] = fn;
          }
        },
        unregisterDecorator: function unregisterDecorator(name) {
          delete this.decorators[name];
        }
      };
      var log = _logger2['default'].log;
      exports.log = log;
      exports.createFrame = _utils.createFrame;
      exports.logger = _logger2['default'];
      /***/
    },
    /* 5 */

    /***/
    function (module, exports) {
      'use strict';

      exports.__esModule = true;
      exports.extend = extend;
      exports.indexOf = indexOf;
      exports.escapeExpression = escapeExpression;
      exports.isEmpty = isEmpty;
      exports.createFrame = createFrame;
      exports.blockParams = blockParams;
      exports.appendContextPath = appendContextPath;
      var escape = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '`': '&#x60;',
        '=': '&#x3D;'
      };
      var badChars = /[&<>"'`=]/g,
          possible = /[&<>"'`=]/;

      function escapeChar(chr) {
        return escape[chr];
      }

      function extend(obj
      /* , ...source */
      ) {
        for (var i = 1; i < arguments.length; i++) {
          for (var key in arguments[i]) {
            if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
              obj[key] = arguments[i][key];
            }
          }
        }

        return obj;
      }

      var toString = Object.prototype.toString;
      exports.toString = toString; // Sourced from lodash
      // https://github.com/bestiejs/lodash/blob/master/LICENSE.txt

      /* eslint-disable func-style */

      var isFunction = function isFunction(value) {
        return typeof value === 'function';
      }; // fallback for older versions of Chrome and Safari

      /* istanbul ignore next */


      if (isFunction(/x/)) {
        exports.isFunction = isFunction = function isFunction(value) {
          return typeof value === 'function' && toString.call(value) === '[object Function]';
        };
      }

      exports.isFunction = isFunction;
      /* eslint-enable func-style */

      /* istanbul ignore next */

      var isArray = Array.isArray || function (value) {
        return value && _typeof2(value) === 'object' ? toString.call(value) === '[object Array]' : false;
      };

      exports.isArray = isArray; // Older IE versions do not directly support indexOf so we must implement our own, sadly.

      function indexOf(array, value) {
        for (var i = 0, len = array.length; i < len; i++) {
          if (array[i] === value) {
            return i;
          }
        }

        return -1;
      }

      function escapeExpression(string) {
        if (typeof string !== 'string') {
          // don't escape SafeStrings, since they're already safe
          if (string && string.toHTML) {
            return string.toHTML();
          } else if (string == null) {
            return '';
          } else if (!string) {
            return string + '';
          } // Force a string conversion as this will be done by the append regardless and
          // the regex test will do this transparently behind the scenes, causing issues if
          // an object's to string has escaped characters in it.


          string = '' + string;
        }

        if (!possible.test(string)) {
          return string;
        }

        return string.replace(badChars, escapeChar);
      }

      function isEmpty(value) {
        if (!value && value !== 0) {
          return true;
        } else if (isArray(value) && value.length === 0) {
          return true;
        } else {
          return false;
        }
      }

      function createFrame(object) {
        var frame = extend({}, object);
        frame._parent = object;
        return frame;
      }

      function blockParams(params, ids) {
        params.path = ids;
        return params;
      }

      function appendContextPath(contextPath, id) {
        return (contextPath ? contextPath + '.' : '') + id;
      }
      /***/

    },
    /* 6 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _Object$defineProperty = __webpack_require__(7)['default'];

      exports.__esModule = true;
      var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

      function Exception(message, node) {
        var loc = node && node.loc,
            line = undefined,
            column = undefined;

        if (loc) {
          line = loc.start.line;
          column = loc.start.column;
          message += ' - ' + line + ':' + column;
        }

        var tmp = Error.prototype.constructor.call(this, message); // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.

        for (var idx = 0; idx < errorProps.length; idx++) {
          this[errorProps[idx]] = tmp[errorProps[idx]];
        }
        /* istanbul ignore else */


        if (Error.captureStackTrace) {
          Error.captureStackTrace(this, Exception);
        }

        try {
          if (loc) {
            this.lineNumber = line; // Work around issue under safari where we can't directly set the column value

            /* istanbul ignore next */

            if (_Object$defineProperty) {
              Object.defineProperty(this, 'column', {
                value: column,
                enumerable: true
              });
            } else {
              this.column = column;
            }
          }
        } catch (nop) {
          /* Ignore if the browser is very particular */
        }
      }

      Exception.prototype = new Error();
      exports['default'] = Exception;
      module.exports = exports['default'];
      /***/
    },
    /* 7 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(8),
        __esModule: true
      };
      /***/
    },
    /* 8 */

    /***/
    function (module, exports, __webpack_require__) {
      var $ = __webpack_require__(9);

      module.exports = function defineProperty(it, key, desc) {
        return $.setDesc(it, key, desc);
      };
      /***/

    },
    /* 9 */

    /***/
    function (module, exports) {
      var $Object = Object;
      module.exports = {
        create: $Object.create,
        getProto: $Object.getPrototypeOf,
        isEnum: {}.propertyIsEnumerable,
        getDesc: $Object.getOwnPropertyDescriptor,
        setDesc: $Object.defineProperty,
        setDescs: $Object.defineProperties,
        getKeys: $Object.keys,
        getNames: $Object.getOwnPropertyNames,
        getSymbols: $Object.getOwnPropertySymbols,
        each: [].forEach
      };
      /***/
    },
    /* 10 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;
      exports.registerDefaultHelpers = registerDefaultHelpers;

      var _helpersBlockHelperMissing = __webpack_require__(11);

      var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

      var _helpersEach = __webpack_require__(12);

      var _helpersEach2 = _interopRequireDefault(_helpersEach);

      var _helpersHelperMissing = __webpack_require__(13);

      var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

      var _helpersIf = __webpack_require__(14);

      var _helpersIf2 = _interopRequireDefault(_helpersIf);

      var _helpersLog = __webpack_require__(15);

      var _helpersLog2 = _interopRequireDefault(_helpersLog);

      var _helpersLookup = __webpack_require__(16);

      var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

      var _helpersWith = __webpack_require__(17);

      var _helpersWith2 = _interopRequireDefault(_helpersWith);

      function registerDefaultHelpers(instance) {
        _helpersBlockHelperMissing2['default'](instance);

        _helpersEach2['default'](instance);

        _helpersHelperMissing2['default'](instance);

        _helpersIf2['default'](instance);

        _helpersLog2['default'](instance);

        _helpersLookup2['default'](instance);

        _helpersWith2['default'](instance);
      }
      /***/

    },
    /* 11 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      exports.__esModule = true;

      var _utils = __webpack_require__(5);

      exports['default'] = function (instance) {
        instance.registerHelper('blockHelperMissing', function (context, options) {
          var inverse = options.inverse,
              fn = options.fn;

          if (context === true) {
            return fn(this);
          } else if (context === false || context == null) {
            return inverse(this);
          } else if (_utils.isArray(context)) {
            if (context.length > 0) {
              if (options.ids) {
                options.ids = [options.name];
              }

              return instance.helpers.each(context, options);
            } else {
              return inverse(this);
            }
          } else {
            if (options.data && options.ids) {
              var data = _utils.createFrame(options.data);

              data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
              options = {
                data: data
              };
            }

            return fn(context, options);
          }
        });
      };

      module.exports = exports['default'];
      /***/
    },
    /* 12 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;

      var _utils = __webpack_require__(5);

      var _exception = __webpack_require__(6);

      var _exception2 = _interopRequireDefault(_exception);

      exports['default'] = function (instance) {
        instance.registerHelper('each', function (context, options) {
          if (!options) {
            throw new _exception2['default']('Must pass iterator to #each');
          }

          var fn = options.fn,
              inverse = options.inverse,
              i = 0,
              ret = '',
              data = undefined,
              contextPath = undefined;

          if (options.data && options.ids) {
            contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
          }

          if (_utils.isFunction(context)) {
            context = context.call(this);
          }

          if (options.data) {
            data = _utils.createFrame(options.data);
          }

          function execIteration(field, index, last) {
            if (data) {
              data.key = field;
              data.index = index;
              data.first = index === 0;
              data.last = !!last;

              if (contextPath) {
                data.contextPath = contextPath + field;
              }
            }

            ret = ret + fn(context[field], {
              data: data,
              blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
            });
          }

          if (context && _typeof2(context) === 'object') {
            if (_utils.isArray(context)) {
              for (var j = context.length; i < j; i++) {
                if (i in context) {
                  execIteration(i, i, i === context.length - 1);
                }
              }
            } else {
              var priorKey = undefined;

              for (var key in context) {
                if (context.hasOwnProperty(key)) {
                  // We're running the iterations one step out of sync so we can detect
                  // the last iteration without have to scan the object twice and create
                  // an itermediate keys array.
                  if (priorKey !== undefined) {
                    execIteration(priorKey, i - 1);
                  }

                  priorKey = key;
                  i++;
                }
              }

              if (priorKey !== undefined) {
                execIteration(priorKey, i - 1, true);
              }
            }
          }

          if (i === 0) {
            ret = inverse(this);
          }

          return ret;
        });
      };

      module.exports = exports['default'];
      /***/
    },
    /* 13 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;

      var _exception = __webpack_require__(6);

      var _exception2 = _interopRequireDefault(_exception);

      exports['default'] = function (instance) {
        instance.registerHelper('helperMissing', function ()
        /* [args, ]options */
        {
          if (arguments.length === 1) {
            // A missing field in a {{foo}} construct.
            return undefined;
          } else {
            // Someone is actually trying to call something, blow up.
            throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
          }
        });
      };

      module.exports = exports['default'];
      /***/
    },
    /* 14 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      exports.__esModule = true;

      var _utils = __webpack_require__(5);

      exports['default'] = function (instance) {
        instance.registerHelper('if', function (conditional, options) {
          if (_utils.isFunction(conditional)) {
            conditional = conditional.call(this);
          } // Default behavior is to render the positive path if the value is truthy and not empty.
          // The `includeZero` option may be set to treat the condtional as purely not empty based on the
          // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.


          if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
            return options.inverse(this);
          } else {
            return options.fn(this);
          }
        });
        instance.registerHelper('unless', function (conditional, options) {
          return instance.helpers['if'].call(this, conditional, {
            fn: options.inverse,
            inverse: options.fn,
            hash: options.hash
          });
        });
      };

      module.exports = exports['default'];
      /***/
    },
    /* 15 */

    /***/
    function (module, exports) {
      'use strict';

      exports.__esModule = true;

      exports['default'] = function (instance) {
        instance.registerHelper('log', function ()
        /* message, options */
        {
          var args = [undefined],
              options = arguments[arguments.length - 1];

          for (var i = 0; i < arguments.length - 1; i++) {
            args.push(arguments[i]);
          }

          var level = 1;

          if (options.hash.level != null) {
            level = options.hash.level;
          } else if (options.data && options.data.level != null) {
            level = options.data.level;
          }

          args[0] = level;
          instance.log.apply(instance, args);
        });
      };

      module.exports = exports['default'];
      /***/
    },
    /* 16 */

    /***/
    function (module, exports) {
      'use strict';

      exports.__esModule = true;

      exports['default'] = function (instance) {
        instance.registerHelper('lookup', function (obj, field) {
          return obj && obj[field];
        });
      };

      module.exports = exports['default'];
      /***/
    },
    /* 17 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      exports.__esModule = true;

      var _utils = __webpack_require__(5);

      exports['default'] = function (instance) {
        instance.registerHelper('with', function (context, options) {
          if (_utils.isFunction(context)) {
            context = context.call(this);
          }

          var fn = options.fn;

          if (!_utils.isEmpty(context)) {
            var data = options.data;

            if (options.data && options.ids) {
              data = _utils.createFrame(options.data);
              data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
            }

            return fn(context, {
              data: data,
              blockParams: _utils.blockParams([context], [data && data.contextPath])
            });
          } else {
            return options.inverse(this);
          }
        });
      };

      module.exports = exports['default'];
      /***/
    },
    /* 18 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;
      exports.registerDefaultDecorators = registerDefaultDecorators;

      var _decoratorsInline = __webpack_require__(19);

      var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

      function registerDefaultDecorators(instance) {
        _decoratorsInline2['default'](instance);
      }
      /***/

    },
    /* 19 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      exports.__esModule = true;

      var _utils = __webpack_require__(5);

      exports['default'] = function (instance) {
        instance.registerDecorator('inline', function (fn, props, container, options) {
          var ret = fn;

          if (!props.partials) {
            props.partials = {};

            ret = function ret(context, options) {
              // Create a new partials stack frame prior to exec.
              var original = container.partials;
              container.partials = _utils.extend({}, original, props.partials);
              var ret = fn(context, options);
              container.partials = original;
              return ret;
            };
          }

          props.partials[options.args[0]] = options.fn;
          return ret;
        });
      };

      module.exports = exports['default'];
      /***/
    },
    /* 20 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      exports.__esModule = true;

      var _utils = __webpack_require__(5);

      var logger = {
        methodMap: ['debug', 'info', 'warn', 'error'],
        level: 'info',
        // Maps a given level value to the `methodMap` indexes above.
        lookupLevel: function lookupLevel(level) {
          if (typeof level === 'string') {
            var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());

            if (levelMap >= 0) {
              level = levelMap;
            } else {
              level = parseInt(level, 10);
            }
          }

          return level;
        },
        // Can be overridden in the host environment
        log: function log(level) {
          level = logger.lookupLevel(level);

          if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
            var method = logger.methodMap[level];

            if (!console[method]) {
              // eslint-disable-line no-console
              method = 'log';
            }

            for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              message[_key - 1] = arguments[_key];
            }

            console[method].apply(console, message); // eslint-disable-line no-console
          }
        }
      };
      exports['default'] = logger;
      module.exports = exports['default'];
      /***/
    },
    /* 21 */

    /***/
    function (module, exports) {
      // Build out our basic SafeString type
      'use strict';

      exports.__esModule = true;

      function SafeString(string) {
        this.string = string;
      }

      SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
        return '' + this.string;
      };

      exports['default'] = SafeString;
      module.exports = exports['default'];
      /***/
    },
    /* 22 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _Object$seal = __webpack_require__(23)['default'];

      var _interopRequireWildcard = __webpack_require__(3)['default'];

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;
      exports.checkRevision = checkRevision;
      exports.template = template;
      exports.wrapProgram = wrapProgram;
      exports.resolvePartial = resolvePartial;
      exports.invokePartial = invokePartial;
      exports.noop = noop;

      var _utils = __webpack_require__(5);

      var Utils = _interopRequireWildcard(_utils);

      var _exception = __webpack_require__(6);

      var _exception2 = _interopRequireDefault(_exception);

      var _base = __webpack_require__(4);

      function checkRevision(compilerInfo) {
        var compilerRevision = compilerInfo && compilerInfo[0] || 1,
            currentRevision = _base.COMPILER_REVISION;

        if (compilerRevision !== currentRevision) {
          if (compilerRevision < currentRevision) {
            var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
                compilerVersions = _base.REVISION_CHANGES[compilerRevision];
            throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
          } else {
            // Use the embedded version info since the runtime doesn't know about this revision yet
            throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
          }
        }
      }

      function template(templateSpec, env) {
        /* istanbul ignore next */
        if (!env) {
          throw new _exception2['default']('No environment passed to template');
        }

        if (!templateSpec || !templateSpec.main) {
          throw new _exception2['default']('Unknown template object: ' + _typeof2(templateSpec));
        }

        templateSpec.main.decorator = templateSpec.main_d; // Note: Using env.VM references rather than local var references throughout this section to allow
        // for external users to override these as psuedo-supported APIs.

        env.VM.checkRevision(templateSpec.compiler);

        function invokePartialWrapper(partial, context, options) {
          if (options.hash) {
            context = Utils.extend({}, context, options.hash);

            if (options.ids) {
              options.ids[0] = true;
            }
          }

          partial = env.VM.resolvePartial.call(this, partial, context, options);
          var result = env.VM.invokePartial.call(this, partial, context, options);

          if (result == null && env.compile) {
            options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
            result = options.partials[options.name](context, options);
          }

          if (result != null) {
            if (options.indent) {
              var lines = result.split('\n');

              for (var i = 0, l = lines.length; i < l; i++) {
                if (!lines[i] && i + 1 === l) {
                  break;
                }

                lines[i] = options.indent + lines[i];
              }

              result = lines.join('\n');
            }

            return result;
          } else {
            throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
          }
        } // Just add water


        var container = {
          strict: function strict(obj, name) {
            if (!(name in obj)) {
              throw new _exception2['default']('"' + name + '" not defined in ' + obj);
            }

            return obj[name];
          },
          lookup: function lookup(depths, name) {
            var len = depths.length;

            for (var i = 0; i < len; i++) {
              if (depths[i] && depths[i][name] != null) {
                return depths[i][name];
              }
            }
          },
          lambda: function lambda(current, context) {
            return typeof current === 'function' ? current.call(context) : current;
          },
          escapeExpression: Utils.escapeExpression,
          invokePartial: invokePartialWrapper,
          fn: function fn(i) {
            var ret = templateSpec[i];
            ret.decorator = templateSpec[i + '_d'];
            return ret;
          },
          programs: [],
          program: function program(i, data, declaredBlockParams, blockParams, depths) {
            var programWrapper = this.programs[i],
                fn = this.fn(i);

            if (data || depths || blockParams || declaredBlockParams) {
              programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
            } else if (!programWrapper) {
              programWrapper = this.programs[i] = wrapProgram(this, i, fn);
            }

            return programWrapper;
          },
          data: function data(value, depth) {
            while (value && depth--) {
              value = value._parent;
            }

            return value;
          },
          merge: function merge(param, common) {
            var obj = param || common;

            if (param && common && param !== common) {
              obj = Utils.extend({}, common, param);
            }

            return obj;
          },
          // An empty object to use as replacement for null-contexts
          nullContext: _Object$seal({}),
          noop: env.VM.noop,
          compilerInfo: templateSpec.compiler
        };

        function ret(context) {
          var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
          var data = options.data;

          ret._setup(options);

          if (!options.partial && templateSpec.useData) {
            data = initData(context, data);
          }

          var depths = undefined,
              blockParams = templateSpec.useBlockParams ? [] : undefined;

          if (templateSpec.useDepths) {
            if (options.depths) {
              depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
            } else {
              depths = [context];
            }
          }

          function main(context
          /*, options*/
          ) {
            return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
          }

          main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
          return main(context, options);
        }

        ret.isTop = true;

        ret._setup = function (options) {
          if (!options.partial) {
            container.helpers = container.merge(options.helpers, env.helpers);

            if (templateSpec.usePartial) {
              container.partials = container.merge(options.partials, env.partials);
            }

            if (templateSpec.usePartial || templateSpec.useDecorators) {
              container.decorators = container.merge(options.decorators, env.decorators);
            }
          } else {
            container.helpers = options.helpers;
            container.partials = options.partials;
            container.decorators = options.decorators;
          }
        };

        ret._child = function (i, data, blockParams, depths) {
          if (templateSpec.useBlockParams && !blockParams) {
            throw new _exception2['default']('must pass block params');
          }

          if (templateSpec.useDepths && !depths) {
            throw new _exception2['default']('must pass parent depths');
          }

          return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
        };

        return ret;
      }

      function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
        function prog(context) {
          var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
          var currentDepths = depths;

          if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
            currentDepths = [context].concat(depths);
          }

          return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
        }

        prog = executeDecorators(fn, prog, container, depths, data, blockParams);
        prog.program = i;
        prog.depth = depths ? depths.length : 0;
        prog.blockParams = declaredBlockParams || 0;
        return prog;
      }

      function resolvePartial(partial, context, options) {
        if (!partial) {
          if (options.name === '@partial-block') {
            partial = options.data['partial-block'];
          } else {
            partial = options.partials[options.name];
          }
        } else if (!partial.call && !options.name) {
          // This is a dynamic partial that returned a string
          options.name = partial;
          partial = options.partials[partial];
        }

        return partial;
      }

      function invokePartial(partial, context, options) {
        // Use the current closure context to save the partial-block if this partial
        var currentPartialBlock = options.data && options.data['partial-block'];
        options.partial = true;

        if (options.ids) {
          options.data.contextPath = options.ids[0] || options.data.contextPath;
        }

        var partialBlock = undefined;

        if (options.fn && options.fn !== noop) {
          (function () {
            options.data = _base.createFrame(options.data); // Wrapper function to get access to currentPartialBlock from the closure

            var fn = options.fn;

            partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
              var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1]; // Restore the partial-block from the closure for the execution of the block
              // i.e. the part inside the block of the partial call.

              options.data = _base.createFrame(options.data);
              options.data['partial-block'] = currentPartialBlock;
              return fn(context, options);
            };

            if (fn.partials) {
              options.partials = Utils.extend({}, options.partials, fn.partials);
            }
          })();
        }

        if (partial === undefined && partialBlock) {
          partial = partialBlock;
        }

        if (partial === undefined) {
          throw new _exception2['default']('The partial ' + options.name + ' could not be found');
        } else if (partial instanceof Function) {
          return partial(context, options);
        }
      }

      function noop() {
        return '';
      }

      function initData(context, data) {
        if (!data || !('root' in data)) {
          data = data ? _base.createFrame(data) : {};
          data.root = context;
        }

        return data;
      }

      function executeDecorators(fn, prog, container, depths, data, blockParams) {
        if (fn.decorator) {
          var props = {};
          prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
          Utils.extend(prog, props);
        }

        return prog;
      }
      /***/

    },
    /* 23 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(24),
        __esModule: true
      };
      /***/
    },
    /* 24 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(25);

      module.exports = __webpack_require__(30).Object.seal;
      /***/
    },
    /* 25 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.17 Object.seal(O)
      var isObject = __webpack_require__(26);

      __webpack_require__(27)('seal', function ($seal) {
        return function seal(it) {
          return $seal && isObject(it) ? $seal(it) : it;
        };
      });
      /***/

    },
    /* 26 */

    /***/
    function (module, exports) {
      module.exports = function (it) {
        return _typeof2(it) === 'object' ? it !== null : typeof it === 'function';
      };
      /***/

    },
    /* 27 */

    /***/
    function (module, exports, __webpack_require__) {
      // most Object methods by ES6 should accept primitives
      var $export = __webpack_require__(28),
          core = __webpack_require__(30),
          fails = __webpack_require__(33);

      module.exports = function (KEY, exec) {
        var fn = (core.Object || {})[KEY] || Object[KEY],
            exp = {};
        exp[KEY] = exec(fn);
        $export($export.S + $export.F * fails(function () {
          fn(1);
        }), 'Object', exp);
      };
      /***/

    },
    /* 28 */

    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__(29),
          core = __webpack_require__(30),
          ctx = __webpack_require__(31),
          PROTOTYPE = 'prototype';

      var $export = function $export(type, name, source) {
        var IS_FORCED = type & $export.F,
            IS_GLOBAL = type & $export.G,
            IS_STATIC = type & $export.S,
            IS_PROTO = type & $export.P,
            IS_BIND = type & $export.B,
            IS_WRAP = type & $export.W,
            exports = IS_GLOBAL ? core : core[name] || (core[name] = {}),
            target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE],
            key,
            own,
            out;
        if (IS_GLOBAL) source = name;

        for (key in source) {
          // contains in native
          own = !IS_FORCED && target && key in target;
          if (own && key in exports) continue; // export native or passed

          out = own ? target[key] : source[key]; // prevent global pollution for namespaces

          exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
          : IS_BIND && own ? ctx(out, global) // wrap global constructors for prevent change them in library
          : IS_WRAP && target[key] == out ? function (C) {
            var F = function F(param) {
              return this instanceof C ? new C(param) : C(param);
            };

            F[PROTOTYPE] = C[PROTOTYPE];
            return F; // make static versions for prototype methods
          }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
          if (IS_PROTO) (exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
        }
      }; // type bitmap


      $export.F = 1; // forced

      $export.G = 2; // global

      $export.S = 4; // static

      $export.P = 8; // proto

      $export.B = 16; // bind

      $export.W = 32; // wrap

      module.exports = $export;
      /***/
    },
    /* 29 */

    /***/
    function (module, exports) {
      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
      if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

      /***/
    },
    /* 30 */

    /***/
    function (module, exports) {
      var core = module.exports = {
        version: '1.2.6'
      };
      if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

      /***/
    },
    /* 31 */

    /***/
    function (module, exports, __webpack_require__) {
      // optional / simple context binding
      var aFunction = __webpack_require__(32);

      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;

        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };

          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };

          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }

        return function ()
        /* ...args */
        {
          return fn.apply(that, arguments);
        };
      };
      /***/

    },
    /* 32 */

    /***/
    function (module, exports) {
      module.exports = function (it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
      };
      /***/

    },
    /* 33 */

    /***/
    function (module, exports) {
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };
      /***/

    },
    /* 34 */

    /***/
    function (module, exports) {
      /* WEBPACK VAR INJECTION */
      (function (global) {
        /* global window */
        'use strict';

        exports.__esModule = true;

        exports['default'] = function (Handlebars) {
          /* istanbul ignore next */
          var root = typeof global !== 'undefined' ? global : window,
              $Handlebars = root.Handlebars;
          /* istanbul ignore next */

          Handlebars.noConflict = function () {
            if (root.Handlebars === Handlebars) {
              root.Handlebars = $Handlebars;
            }

            return Handlebars;
          };
        };

        module.exports = exports['default'];
        /* WEBPACK VAR INJECTION */
      }).call(exports, function () {
        return this;
      }());
      /***/
    },
    /* 35 */

    /***/
    function (module, exports) {
      'use strict';

      exports.__esModule = true;
      var AST = {
        // Public API used to evaluate derived attributes regarding AST nodes
        helpers: {
          // a mustache is definitely a helper if:
          // * it is an eligible helper, and
          // * it has at least one parameter or hash segment
          helperExpression: function helperExpression(node) {
            return node.type === 'SubExpression' || (node.type === 'MustacheStatement' || node.type === 'BlockStatement') && !!(node.params && node.params.length || node.hash);
          },
          scopedId: function scopedId(path) {
            return /^\.|this\b/.test(path.original);
          },
          // an ID is simple if it only has one part, and that part is not
          // `..` or `this`.
          simpleId: function simpleId(path) {
            return path.parts.length === 1 && !AST.helpers.scopedId(path) && !path.depth;
          }
        }
      }; // Must be exported as an object rather than the root of the module as the jison lexer
      // must modify the object to operate properly.

      exports['default'] = AST;
      module.exports = exports['default'];
      /***/
    },
    /* 36 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      var _interopRequireWildcard = __webpack_require__(3)['default'];

      exports.__esModule = true;
      exports.parse = parse;

      var _parser = __webpack_require__(37);

      var _parser2 = _interopRequireDefault(_parser);

      var _whitespaceControl = __webpack_require__(38);

      var _whitespaceControl2 = _interopRequireDefault(_whitespaceControl);

      var _helpers = __webpack_require__(40);

      var Helpers = _interopRequireWildcard(_helpers);

      var _utils = __webpack_require__(5);

      exports.parser = _parser2['default'];
      var yy = {};

      _utils.extend(yy, Helpers);

      function parse(input, options) {
        // Just return if an already-compiled AST was passed in.
        if (input.type === 'Program') {
          return input;
        }

        _parser2['default'].yy = yy; // Altering the shared object here, but this is ok as parser is a sync operation

        yy.locInfo = function (locInfo) {
          return new yy.SourceLocation(options && options.srcName, locInfo);
        };

        var strip = new _whitespaceControl2['default'](options);
        return strip.accept(_parser2['default'].parse(input));
      }
      /***/

    },
    /* 37 */

    /***/
    function (module, exports) {
      // File ignored in coverage tests via setting in .istanbul.yml

      /* Jison generated parser */
      "use strict";

      exports.__esModule = true;

      var handlebars = function () {
        var parser = {
          trace: function trace() {},
          yy: {},
          symbols_: {
            "error": 2,
            "root": 3,
            "program": 4,
            "EOF": 5,
            "program_repetition0": 6,
            "statement": 7,
            "mustache": 8,
            "block": 9,
            "rawBlock": 10,
            "partial": 11,
            "partialBlock": 12,
            "content": 13,
            "COMMENT": 14,
            "CONTENT": 15,
            "openRawBlock": 16,
            "rawBlock_repetition_plus0": 17,
            "END_RAW_BLOCK": 18,
            "OPEN_RAW_BLOCK": 19,
            "helperName": 20,
            "openRawBlock_repetition0": 21,
            "openRawBlock_option0": 22,
            "CLOSE_RAW_BLOCK": 23,
            "openBlock": 24,
            "block_option0": 25,
            "closeBlock": 26,
            "openInverse": 27,
            "block_option1": 28,
            "OPEN_BLOCK": 29,
            "openBlock_repetition0": 30,
            "openBlock_option0": 31,
            "openBlock_option1": 32,
            "CLOSE": 33,
            "OPEN_INVERSE": 34,
            "openInverse_repetition0": 35,
            "openInverse_option0": 36,
            "openInverse_option1": 37,
            "openInverseChain": 38,
            "OPEN_INVERSE_CHAIN": 39,
            "openInverseChain_repetition0": 40,
            "openInverseChain_option0": 41,
            "openInverseChain_option1": 42,
            "inverseAndProgram": 43,
            "INVERSE": 44,
            "inverseChain": 45,
            "inverseChain_option0": 46,
            "OPEN_ENDBLOCK": 47,
            "OPEN": 48,
            "mustache_repetition0": 49,
            "mustache_option0": 50,
            "OPEN_UNESCAPED": 51,
            "mustache_repetition1": 52,
            "mustache_option1": 53,
            "CLOSE_UNESCAPED": 54,
            "OPEN_PARTIAL": 55,
            "partialName": 56,
            "partial_repetition0": 57,
            "partial_option0": 58,
            "openPartialBlock": 59,
            "OPEN_PARTIAL_BLOCK": 60,
            "openPartialBlock_repetition0": 61,
            "openPartialBlock_option0": 62,
            "param": 63,
            "sexpr": 64,
            "OPEN_SEXPR": 65,
            "sexpr_repetition0": 66,
            "sexpr_option0": 67,
            "CLOSE_SEXPR": 68,
            "hash": 69,
            "hash_repetition_plus0": 70,
            "hashSegment": 71,
            "ID": 72,
            "EQUALS": 73,
            "blockParams": 74,
            "OPEN_BLOCK_PARAMS": 75,
            "blockParams_repetition_plus0": 76,
            "CLOSE_BLOCK_PARAMS": 77,
            "path": 78,
            "dataName": 79,
            "STRING": 80,
            "NUMBER": 81,
            "BOOLEAN": 82,
            "UNDEFINED": 83,
            "NULL": 84,
            "DATA": 85,
            "pathSegments": 86,
            "SEP": 87,
            "$accept": 0,
            "$end": 1
          },
          terminals_: {
            2: "error",
            5: "EOF",
            14: "COMMENT",
            15: "CONTENT",
            18: "END_RAW_BLOCK",
            19: "OPEN_RAW_BLOCK",
            23: "CLOSE_RAW_BLOCK",
            29: "OPEN_BLOCK",
            33: "CLOSE",
            34: "OPEN_INVERSE",
            39: "OPEN_INVERSE_CHAIN",
            44: "INVERSE",
            47: "OPEN_ENDBLOCK",
            48: "OPEN",
            51: "OPEN_UNESCAPED",
            54: "CLOSE_UNESCAPED",
            55: "OPEN_PARTIAL",
            60: "OPEN_PARTIAL_BLOCK",
            65: "OPEN_SEXPR",
            68: "CLOSE_SEXPR",
            72: "ID",
            73: "EQUALS",
            75: "OPEN_BLOCK_PARAMS",
            77: "CLOSE_BLOCK_PARAMS",
            80: "STRING",
            81: "NUMBER",
            82: "BOOLEAN",
            83: "UNDEFINED",
            84: "NULL",
            85: "DATA",
            87: "SEP"
          },
          productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 1], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
          performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$
          /*``*/
          ) {
            var $0 = $$.length - 1;

            switch (yystate) {
              case 1:
                return $$[$0 - 1];
                break;

              case 2:
                this.$ = yy.prepareProgram($$[$0]);
                break;

              case 3:
                this.$ = $$[$0];
                break;

              case 4:
                this.$ = $$[$0];
                break;

              case 5:
                this.$ = $$[$0];
                break;

              case 6:
                this.$ = $$[$0];
                break;

              case 7:
                this.$ = $$[$0];
                break;

              case 8:
                this.$ = $$[$0];
                break;

              case 9:
                this.$ = {
                  type: 'CommentStatement',
                  value: yy.stripComment($$[$0]),
                  strip: yy.stripFlags($$[$0], $$[$0]),
                  loc: yy.locInfo(this._$)
                };
                break;

              case 10:
                this.$ = {
                  type: 'ContentStatement',
                  original: $$[$0],
                  value: $$[$0],
                  loc: yy.locInfo(this._$)
                };
                break;

              case 11:
                this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
                break;

              case 12:
                this.$ = {
                  path: $$[$0 - 3],
                  params: $$[$0 - 2],
                  hash: $$[$0 - 1]
                };
                break;

              case 13:
                this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
                break;

              case 14:
                this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
                break;

              case 15:
                this.$ = {
                  open: $$[$0 - 5],
                  path: $$[$0 - 4],
                  params: $$[$0 - 3],
                  hash: $$[$0 - 2],
                  blockParams: $$[$0 - 1],
                  strip: yy.stripFlags($$[$0 - 5], $$[$0])
                };
                break;

              case 16:
                this.$ = {
                  path: $$[$0 - 4],
                  params: $$[$0 - 3],
                  hash: $$[$0 - 2],
                  blockParams: $$[$0 - 1],
                  strip: yy.stripFlags($$[$0 - 5], $$[$0])
                };
                break;

              case 17:
                this.$ = {
                  path: $$[$0 - 4],
                  params: $$[$0 - 3],
                  hash: $$[$0 - 2],
                  blockParams: $$[$0 - 1],
                  strip: yy.stripFlags($$[$0 - 5], $$[$0])
                };
                break;

              case 18:
                this.$ = {
                  strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]),
                  program: $$[$0]
                };
                break;

              case 19:
                var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$),
                    program = yy.prepareProgram([inverse], $$[$0 - 1].loc);
                program.chained = true;
                this.$ = {
                  strip: $$[$0 - 2].strip,
                  program: program,
                  chain: true
                };
                break;

              case 20:
                this.$ = $$[$0];
                break;

              case 21:
                this.$ = {
                  path: $$[$0 - 1],
                  strip: yy.stripFlags($$[$0 - 2], $$[$0])
                };
                break;

              case 22:
                this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
                break;

              case 23:
                this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
                break;

              case 24:
                this.$ = {
                  type: 'PartialStatement',
                  name: $$[$0 - 3],
                  params: $$[$0 - 2],
                  hash: $$[$0 - 1],
                  indent: '',
                  strip: yy.stripFlags($$[$0 - 4], $$[$0]),
                  loc: yy.locInfo(this._$)
                };
                break;

              case 25:
                this.$ = yy.preparePartialBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
                break;

              case 26:
                this.$ = {
                  path: $$[$0 - 3],
                  params: $$[$0 - 2],
                  hash: $$[$0 - 1],
                  strip: yy.stripFlags($$[$0 - 4], $$[$0])
                };
                break;

              case 27:
                this.$ = $$[$0];
                break;

              case 28:
                this.$ = $$[$0];
                break;

              case 29:
                this.$ = {
                  type: 'SubExpression',
                  path: $$[$0 - 3],
                  params: $$[$0 - 2],
                  hash: $$[$0 - 1],
                  loc: yy.locInfo(this._$)
                };
                break;

              case 30:
                this.$ = {
                  type: 'Hash',
                  pairs: $$[$0],
                  loc: yy.locInfo(this._$)
                };
                break;

              case 31:
                this.$ = {
                  type: 'HashPair',
                  key: yy.id($$[$0 - 2]),
                  value: $$[$0],
                  loc: yy.locInfo(this._$)
                };
                break;

              case 32:
                this.$ = yy.id($$[$0 - 1]);
                break;

              case 33:
                this.$ = $$[$0];
                break;

              case 34:
                this.$ = $$[$0];
                break;

              case 35:
                this.$ = {
                  type: 'StringLiteral',
                  value: $$[$0],
                  original: $$[$0],
                  loc: yy.locInfo(this._$)
                };
                break;

              case 36:
                this.$ = {
                  type: 'NumberLiteral',
                  value: Number($$[$0]),
                  original: Number($$[$0]),
                  loc: yy.locInfo(this._$)
                };
                break;

              case 37:
                this.$ = {
                  type: 'BooleanLiteral',
                  value: $$[$0] === 'true',
                  original: $$[$0] === 'true',
                  loc: yy.locInfo(this._$)
                };
                break;

              case 38:
                this.$ = {
                  type: 'UndefinedLiteral',
                  original: undefined,
                  value: undefined,
                  loc: yy.locInfo(this._$)
                };
                break;

              case 39:
                this.$ = {
                  type: 'NullLiteral',
                  original: null,
                  value: null,
                  loc: yy.locInfo(this._$)
                };
                break;

              case 40:
                this.$ = $$[$0];
                break;

              case 41:
                this.$ = $$[$0];
                break;

              case 42:
                this.$ = yy.preparePath(true, $$[$0], this._$);
                break;

              case 43:
                this.$ = yy.preparePath(false, $$[$0], this._$);
                break;

              case 44:
                $$[$0 - 2].push({
                  part: yy.id($$[$0]),
                  original: $$[$0],
                  separator: $$[$0 - 1]
                });
                this.$ = $$[$0 - 2];
                break;

              case 45:
                this.$ = [{
                  part: yy.id($$[$0]),
                  original: $$[$0]
                }];
                break;

              case 46:
                this.$ = [];
                break;

              case 47:
                $$[$0 - 1].push($$[$0]);
                break;

              case 48:
                this.$ = [$$[$0]];
                break;

              case 49:
                $$[$0 - 1].push($$[$0]);
                break;

              case 50:
                this.$ = [];
                break;

              case 51:
                $$[$0 - 1].push($$[$0]);
                break;

              case 58:
                this.$ = [];
                break;

              case 59:
                $$[$0 - 1].push($$[$0]);
                break;

              case 64:
                this.$ = [];
                break;

              case 65:
                $$[$0 - 1].push($$[$0]);
                break;

              case 70:
                this.$ = [];
                break;

              case 71:
                $$[$0 - 1].push($$[$0]);
                break;

              case 78:
                this.$ = [];
                break;

              case 79:
                $$[$0 - 1].push($$[$0]);
                break;

              case 82:
                this.$ = [];
                break;

              case 83:
                $$[$0 - 1].push($$[$0]);
                break;

              case 86:
                this.$ = [];
                break;

              case 87:
                $$[$0 - 1].push($$[$0]);
                break;

              case 90:
                this.$ = [];
                break;

              case 91:
                $$[$0 - 1].push($$[$0]);
                break;

              case 94:
                this.$ = [];
                break;

              case 95:
                $$[$0 - 1].push($$[$0]);
                break;

              case 98:
                this.$ = [$$[$0]];
                break;

              case 99:
                $$[$0 - 1].push($$[$0]);
                break;

              case 100:
                this.$ = [$$[$0]];
                break;

              case 101:
                $$[$0 - 1].push($$[$0]);
                break;
            }
          },
          table: [{
            3: 1,
            4: 2,
            5: [2, 46],
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            1: [3]
          }, {
            5: [1, 4]
          }, {
            5: [2, 2],
            7: 5,
            8: 6,
            9: 7,
            10: 8,
            11: 9,
            12: 10,
            13: 11,
            14: [1, 12],
            15: [1, 20],
            16: 17,
            19: [1, 23],
            24: 15,
            27: 16,
            29: [1, 21],
            34: [1, 22],
            39: [2, 2],
            44: [2, 2],
            47: [2, 2],
            48: [1, 13],
            51: [1, 14],
            55: [1, 18],
            59: 19,
            60: [1, 24]
          }, {
            1: [2, 1]
          }, {
            5: [2, 47],
            14: [2, 47],
            15: [2, 47],
            19: [2, 47],
            29: [2, 47],
            34: [2, 47],
            39: [2, 47],
            44: [2, 47],
            47: [2, 47],
            48: [2, 47],
            51: [2, 47],
            55: [2, 47],
            60: [2, 47]
          }, {
            5: [2, 3],
            14: [2, 3],
            15: [2, 3],
            19: [2, 3],
            29: [2, 3],
            34: [2, 3],
            39: [2, 3],
            44: [2, 3],
            47: [2, 3],
            48: [2, 3],
            51: [2, 3],
            55: [2, 3],
            60: [2, 3]
          }, {
            5: [2, 4],
            14: [2, 4],
            15: [2, 4],
            19: [2, 4],
            29: [2, 4],
            34: [2, 4],
            39: [2, 4],
            44: [2, 4],
            47: [2, 4],
            48: [2, 4],
            51: [2, 4],
            55: [2, 4],
            60: [2, 4]
          }, {
            5: [2, 5],
            14: [2, 5],
            15: [2, 5],
            19: [2, 5],
            29: [2, 5],
            34: [2, 5],
            39: [2, 5],
            44: [2, 5],
            47: [2, 5],
            48: [2, 5],
            51: [2, 5],
            55: [2, 5],
            60: [2, 5]
          }, {
            5: [2, 6],
            14: [2, 6],
            15: [2, 6],
            19: [2, 6],
            29: [2, 6],
            34: [2, 6],
            39: [2, 6],
            44: [2, 6],
            47: [2, 6],
            48: [2, 6],
            51: [2, 6],
            55: [2, 6],
            60: [2, 6]
          }, {
            5: [2, 7],
            14: [2, 7],
            15: [2, 7],
            19: [2, 7],
            29: [2, 7],
            34: [2, 7],
            39: [2, 7],
            44: [2, 7],
            47: [2, 7],
            48: [2, 7],
            51: [2, 7],
            55: [2, 7],
            60: [2, 7]
          }, {
            5: [2, 8],
            14: [2, 8],
            15: [2, 8],
            19: [2, 8],
            29: [2, 8],
            34: [2, 8],
            39: [2, 8],
            44: [2, 8],
            47: [2, 8],
            48: [2, 8],
            51: [2, 8],
            55: [2, 8],
            60: [2, 8]
          }, {
            5: [2, 9],
            14: [2, 9],
            15: [2, 9],
            19: [2, 9],
            29: [2, 9],
            34: [2, 9],
            39: [2, 9],
            44: [2, 9],
            47: [2, 9],
            48: [2, 9],
            51: [2, 9],
            55: [2, 9],
            60: [2, 9]
          }, {
            20: 25,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 36,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            4: 37,
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            39: [2, 46],
            44: [2, 46],
            47: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            4: 38,
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            44: [2, 46],
            47: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            13: 40,
            15: [1, 20],
            17: 39
          }, {
            20: 42,
            56: 41,
            64: 43,
            65: [1, 44],
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            4: 45,
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            47: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            5: [2, 10],
            14: [2, 10],
            15: [2, 10],
            18: [2, 10],
            19: [2, 10],
            29: [2, 10],
            34: [2, 10],
            39: [2, 10],
            44: [2, 10],
            47: [2, 10],
            48: [2, 10],
            51: [2, 10],
            55: [2, 10],
            60: [2, 10]
          }, {
            20: 46,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 47,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 48,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 42,
            56: 49,
            64: 43,
            65: [1, 44],
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            33: [2, 78],
            49: 50,
            65: [2, 78],
            72: [2, 78],
            80: [2, 78],
            81: [2, 78],
            82: [2, 78],
            83: [2, 78],
            84: [2, 78],
            85: [2, 78]
          }, {
            23: [2, 33],
            33: [2, 33],
            54: [2, 33],
            65: [2, 33],
            68: [2, 33],
            72: [2, 33],
            75: [2, 33],
            80: [2, 33],
            81: [2, 33],
            82: [2, 33],
            83: [2, 33],
            84: [2, 33],
            85: [2, 33]
          }, {
            23: [2, 34],
            33: [2, 34],
            54: [2, 34],
            65: [2, 34],
            68: [2, 34],
            72: [2, 34],
            75: [2, 34],
            80: [2, 34],
            81: [2, 34],
            82: [2, 34],
            83: [2, 34],
            84: [2, 34],
            85: [2, 34]
          }, {
            23: [2, 35],
            33: [2, 35],
            54: [2, 35],
            65: [2, 35],
            68: [2, 35],
            72: [2, 35],
            75: [2, 35],
            80: [2, 35],
            81: [2, 35],
            82: [2, 35],
            83: [2, 35],
            84: [2, 35],
            85: [2, 35]
          }, {
            23: [2, 36],
            33: [2, 36],
            54: [2, 36],
            65: [2, 36],
            68: [2, 36],
            72: [2, 36],
            75: [2, 36],
            80: [2, 36],
            81: [2, 36],
            82: [2, 36],
            83: [2, 36],
            84: [2, 36],
            85: [2, 36]
          }, {
            23: [2, 37],
            33: [2, 37],
            54: [2, 37],
            65: [2, 37],
            68: [2, 37],
            72: [2, 37],
            75: [2, 37],
            80: [2, 37],
            81: [2, 37],
            82: [2, 37],
            83: [2, 37],
            84: [2, 37],
            85: [2, 37]
          }, {
            23: [2, 38],
            33: [2, 38],
            54: [2, 38],
            65: [2, 38],
            68: [2, 38],
            72: [2, 38],
            75: [2, 38],
            80: [2, 38],
            81: [2, 38],
            82: [2, 38],
            83: [2, 38],
            84: [2, 38],
            85: [2, 38]
          }, {
            23: [2, 39],
            33: [2, 39],
            54: [2, 39],
            65: [2, 39],
            68: [2, 39],
            72: [2, 39],
            75: [2, 39],
            80: [2, 39],
            81: [2, 39],
            82: [2, 39],
            83: [2, 39],
            84: [2, 39],
            85: [2, 39]
          }, {
            23: [2, 43],
            33: [2, 43],
            54: [2, 43],
            65: [2, 43],
            68: [2, 43],
            72: [2, 43],
            75: [2, 43],
            80: [2, 43],
            81: [2, 43],
            82: [2, 43],
            83: [2, 43],
            84: [2, 43],
            85: [2, 43],
            87: [1, 51]
          }, {
            72: [1, 35],
            86: 52
          }, {
            23: [2, 45],
            33: [2, 45],
            54: [2, 45],
            65: [2, 45],
            68: [2, 45],
            72: [2, 45],
            75: [2, 45],
            80: [2, 45],
            81: [2, 45],
            82: [2, 45],
            83: [2, 45],
            84: [2, 45],
            85: [2, 45],
            87: [2, 45]
          }, {
            52: 53,
            54: [2, 82],
            65: [2, 82],
            72: [2, 82],
            80: [2, 82],
            81: [2, 82],
            82: [2, 82],
            83: [2, 82],
            84: [2, 82],
            85: [2, 82]
          }, {
            25: 54,
            38: 56,
            39: [1, 58],
            43: 57,
            44: [1, 59],
            45: 55,
            47: [2, 54]
          }, {
            28: 60,
            43: 61,
            44: [1, 59],
            47: [2, 56]
          }, {
            13: 63,
            15: [1, 20],
            18: [1, 62]
          }, {
            15: [2, 48],
            18: [2, 48]
          }, {
            33: [2, 86],
            57: 64,
            65: [2, 86],
            72: [2, 86],
            80: [2, 86],
            81: [2, 86],
            82: [2, 86],
            83: [2, 86],
            84: [2, 86],
            85: [2, 86]
          }, {
            33: [2, 40],
            65: [2, 40],
            72: [2, 40],
            80: [2, 40],
            81: [2, 40],
            82: [2, 40],
            83: [2, 40],
            84: [2, 40],
            85: [2, 40]
          }, {
            33: [2, 41],
            65: [2, 41],
            72: [2, 41],
            80: [2, 41],
            81: [2, 41],
            82: [2, 41],
            83: [2, 41],
            84: [2, 41],
            85: [2, 41]
          }, {
            20: 65,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            26: 66,
            47: [1, 67]
          }, {
            30: 68,
            33: [2, 58],
            65: [2, 58],
            72: [2, 58],
            75: [2, 58],
            80: [2, 58],
            81: [2, 58],
            82: [2, 58],
            83: [2, 58],
            84: [2, 58],
            85: [2, 58]
          }, {
            33: [2, 64],
            35: 69,
            65: [2, 64],
            72: [2, 64],
            75: [2, 64],
            80: [2, 64],
            81: [2, 64],
            82: [2, 64],
            83: [2, 64],
            84: [2, 64],
            85: [2, 64]
          }, {
            21: 70,
            23: [2, 50],
            65: [2, 50],
            72: [2, 50],
            80: [2, 50],
            81: [2, 50],
            82: [2, 50],
            83: [2, 50],
            84: [2, 50],
            85: [2, 50]
          }, {
            33: [2, 90],
            61: 71,
            65: [2, 90],
            72: [2, 90],
            80: [2, 90],
            81: [2, 90],
            82: [2, 90],
            83: [2, 90],
            84: [2, 90],
            85: [2, 90]
          }, {
            20: 75,
            33: [2, 80],
            50: 72,
            63: 73,
            64: 76,
            65: [1, 44],
            69: 74,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            72: [1, 80]
          }, {
            23: [2, 42],
            33: [2, 42],
            54: [2, 42],
            65: [2, 42],
            68: [2, 42],
            72: [2, 42],
            75: [2, 42],
            80: [2, 42],
            81: [2, 42],
            82: [2, 42],
            83: [2, 42],
            84: [2, 42],
            85: [2, 42],
            87: [1, 51]
          }, {
            20: 75,
            53: 81,
            54: [2, 84],
            63: 82,
            64: 76,
            65: [1, 44],
            69: 83,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            26: 84,
            47: [1, 67]
          }, {
            47: [2, 55]
          }, {
            4: 85,
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            39: [2, 46],
            44: [2, 46],
            47: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            47: [2, 20]
          }, {
            20: 86,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            4: 87,
            6: 3,
            14: [2, 46],
            15: [2, 46],
            19: [2, 46],
            29: [2, 46],
            34: [2, 46],
            47: [2, 46],
            48: [2, 46],
            51: [2, 46],
            55: [2, 46],
            60: [2, 46]
          }, {
            26: 88,
            47: [1, 67]
          }, {
            47: [2, 57]
          }, {
            5: [2, 11],
            14: [2, 11],
            15: [2, 11],
            19: [2, 11],
            29: [2, 11],
            34: [2, 11],
            39: [2, 11],
            44: [2, 11],
            47: [2, 11],
            48: [2, 11],
            51: [2, 11],
            55: [2, 11],
            60: [2, 11]
          }, {
            15: [2, 49],
            18: [2, 49]
          }, {
            20: 75,
            33: [2, 88],
            58: 89,
            63: 90,
            64: 76,
            65: [1, 44],
            69: 91,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            65: [2, 94],
            66: 92,
            68: [2, 94],
            72: [2, 94],
            80: [2, 94],
            81: [2, 94],
            82: [2, 94],
            83: [2, 94],
            84: [2, 94],
            85: [2, 94]
          }, {
            5: [2, 25],
            14: [2, 25],
            15: [2, 25],
            19: [2, 25],
            29: [2, 25],
            34: [2, 25],
            39: [2, 25],
            44: [2, 25],
            47: [2, 25],
            48: [2, 25],
            51: [2, 25],
            55: [2, 25],
            60: [2, 25]
          }, {
            20: 93,
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 75,
            31: 94,
            33: [2, 60],
            63: 95,
            64: 76,
            65: [1, 44],
            69: 96,
            70: 77,
            71: 78,
            72: [1, 79],
            75: [2, 60],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 75,
            33: [2, 66],
            36: 97,
            63: 98,
            64: 76,
            65: [1, 44],
            69: 99,
            70: 77,
            71: 78,
            72: [1, 79],
            75: [2, 66],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 75,
            22: 100,
            23: [2, 52],
            63: 101,
            64: 76,
            65: [1, 44],
            69: 102,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            20: 75,
            33: [2, 92],
            62: 103,
            63: 104,
            64: 76,
            65: [1, 44],
            69: 105,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            33: [1, 106]
          }, {
            33: [2, 79],
            65: [2, 79],
            72: [2, 79],
            80: [2, 79],
            81: [2, 79],
            82: [2, 79],
            83: [2, 79],
            84: [2, 79],
            85: [2, 79]
          }, {
            33: [2, 81]
          }, {
            23: [2, 27],
            33: [2, 27],
            54: [2, 27],
            65: [2, 27],
            68: [2, 27],
            72: [2, 27],
            75: [2, 27],
            80: [2, 27],
            81: [2, 27],
            82: [2, 27],
            83: [2, 27],
            84: [2, 27],
            85: [2, 27]
          }, {
            23: [2, 28],
            33: [2, 28],
            54: [2, 28],
            65: [2, 28],
            68: [2, 28],
            72: [2, 28],
            75: [2, 28],
            80: [2, 28],
            81: [2, 28],
            82: [2, 28],
            83: [2, 28],
            84: [2, 28],
            85: [2, 28]
          }, {
            23: [2, 30],
            33: [2, 30],
            54: [2, 30],
            68: [2, 30],
            71: 107,
            72: [1, 108],
            75: [2, 30]
          }, {
            23: [2, 98],
            33: [2, 98],
            54: [2, 98],
            68: [2, 98],
            72: [2, 98],
            75: [2, 98]
          }, {
            23: [2, 45],
            33: [2, 45],
            54: [2, 45],
            65: [2, 45],
            68: [2, 45],
            72: [2, 45],
            73: [1, 109],
            75: [2, 45],
            80: [2, 45],
            81: [2, 45],
            82: [2, 45],
            83: [2, 45],
            84: [2, 45],
            85: [2, 45],
            87: [2, 45]
          }, {
            23: [2, 44],
            33: [2, 44],
            54: [2, 44],
            65: [2, 44],
            68: [2, 44],
            72: [2, 44],
            75: [2, 44],
            80: [2, 44],
            81: [2, 44],
            82: [2, 44],
            83: [2, 44],
            84: [2, 44],
            85: [2, 44],
            87: [2, 44]
          }, {
            54: [1, 110]
          }, {
            54: [2, 83],
            65: [2, 83],
            72: [2, 83],
            80: [2, 83],
            81: [2, 83],
            82: [2, 83],
            83: [2, 83],
            84: [2, 83],
            85: [2, 83]
          }, {
            54: [2, 85]
          }, {
            5: [2, 13],
            14: [2, 13],
            15: [2, 13],
            19: [2, 13],
            29: [2, 13],
            34: [2, 13],
            39: [2, 13],
            44: [2, 13],
            47: [2, 13],
            48: [2, 13],
            51: [2, 13],
            55: [2, 13],
            60: [2, 13]
          }, {
            38: 56,
            39: [1, 58],
            43: 57,
            44: [1, 59],
            45: 112,
            46: 111,
            47: [2, 76]
          }, {
            33: [2, 70],
            40: 113,
            65: [2, 70],
            72: [2, 70],
            75: [2, 70],
            80: [2, 70],
            81: [2, 70],
            82: [2, 70],
            83: [2, 70],
            84: [2, 70],
            85: [2, 70]
          }, {
            47: [2, 18]
          }, {
            5: [2, 14],
            14: [2, 14],
            15: [2, 14],
            19: [2, 14],
            29: [2, 14],
            34: [2, 14],
            39: [2, 14],
            44: [2, 14],
            47: [2, 14],
            48: [2, 14],
            51: [2, 14],
            55: [2, 14],
            60: [2, 14]
          }, {
            33: [1, 114]
          }, {
            33: [2, 87],
            65: [2, 87],
            72: [2, 87],
            80: [2, 87],
            81: [2, 87],
            82: [2, 87],
            83: [2, 87],
            84: [2, 87],
            85: [2, 87]
          }, {
            33: [2, 89]
          }, {
            20: 75,
            63: 116,
            64: 76,
            65: [1, 44],
            67: 115,
            68: [2, 96],
            69: 117,
            70: 77,
            71: 78,
            72: [1, 79],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            33: [1, 118]
          }, {
            32: 119,
            33: [2, 62],
            74: 120,
            75: [1, 121]
          }, {
            33: [2, 59],
            65: [2, 59],
            72: [2, 59],
            75: [2, 59],
            80: [2, 59],
            81: [2, 59],
            82: [2, 59],
            83: [2, 59],
            84: [2, 59],
            85: [2, 59]
          }, {
            33: [2, 61],
            75: [2, 61]
          }, {
            33: [2, 68],
            37: 122,
            74: 123,
            75: [1, 121]
          }, {
            33: [2, 65],
            65: [2, 65],
            72: [2, 65],
            75: [2, 65],
            80: [2, 65],
            81: [2, 65],
            82: [2, 65],
            83: [2, 65],
            84: [2, 65],
            85: [2, 65]
          }, {
            33: [2, 67],
            75: [2, 67]
          }, {
            23: [1, 124]
          }, {
            23: [2, 51],
            65: [2, 51],
            72: [2, 51],
            80: [2, 51],
            81: [2, 51],
            82: [2, 51],
            83: [2, 51],
            84: [2, 51],
            85: [2, 51]
          }, {
            23: [2, 53]
          }, {
            33: [1, 125]
          }, {
            33: [2, 91],
            65: [2, 91],
            72: [2, 91],
            80: [2, 91],
            81: [2, 91],
            82: [2, 91],
            83: [2, 91],
            84: [2, 91],
            85: [2, 91]
          }, {
            33: [2, 93]
          }, {
            5: [2, 22],
            14: [2, 22],
            15: [2, 22],
            19: [2, 22],
            29: [2, 22],
            34: [2, 22],
            39: [2, 22],
            44: [2, 22],
            47: [2, 22],
            48: [2, 22],
            51: [2, 22],
            55: [2, 22],
            60: [2, 22]
          }, {
            23: [2, 99],
            33: [2, 99],
            54: [2, 99],
            68: [2, 99],
            72: [2, 99],
            75: [2, 99]
          }, {
            73: [1, 109]
          }, {
            20: 75,
            63: 126,
            64: 76,
            65: [1, 44],
            72: [1, 35],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            5: [2, 23],
            14: [2, 23],
            15: [2, 23],
            19: [2, 23],
            29: [2, 23],
            34: [2, 23],
            39: [2, 23],
            44: [2, 23],
            47: [2, 23],
            48: [2, 23],
            51: [2, 23],
            55: [2, 23],
            60: [2, 23]
          }, {
            47: [2, 19]
          }, {
            47: [2, 77]
          }, {
            20: 75,
            33: [2, 72],
            41: 127,
            63: 128,
            64: 76,
            65: [1, 44],
            69: 129,
            70: 77,
            71: 78,
            72: [1, 79],
            75: [2, 72],
            78: 26,
            79: 27,
            80: [1, 28],
            81: [1, 29],
            82: [1, 30],
            83: [1, 31],
            84: [1, 32],
            85: [1, 34],
            86: 33
          }, {
            5: [2, 24],
            14: [2, 24],
            15: [2, 24],
            19: [2, 24],
            29: [2, 24],
            34: [2, 24],
            39: [2, 24],
            44: [2, 24],
            47: [2, 24],
            48: [2, 24],
            51: [2, 24],
            55: [2, 24],
            60: [2, 24]
          }, {
            68: [1, 130]
          }, {
            65: [2, 95],
            68: [2, 95],
            72: [2, 95],
            80: [2, 95],
            81: [2, 95],
            82: [2, 95],
            83: [2, 95],
            84: [2, 95],
            85: [2, 95]
          }, {
            68: [2, 97]
          }, {
            5: [2, 21],
            14: [2, 21],
            15: [2, 21],
            19: [2, 21],
            29: [2, 21],
            34: [2, 21],
            39: [2, 21],
            44: [2, 21],
            47: [2, 21],
            48: [2, 21],
            51: [2, 21],
            55: [2, 21],
            60: [2, 21]
          }, {
            33: [1, 131]
          }, {
            33: [2, 63]
          }, {
            72: [1, 133],
            76: 132
          }, {
            33: [1, 134]
          }, {
            33: [2, 69]
          }, {
            15: [2, 12]
          }, {
            14: [2, 26],
            15: [2, 26],
            19: [2, 26],
            29: [2, 26],
            34: [2, 26],
            47: [2, 26],
            48: [2, 26],
            51: [2, 26],
            55: [2, 26],
            60: [2, 26]
          }, {
            23: [2, 31],
            33: [2, 31],
            54: [2, 31],
            68: [2, 31],
            72: [2, 31],
            75: [2, 31]
          }, {
            33: [2, 74],
            42: 135,
            74: 136,
            75: [1, 121]
          }, {
            33: [2, 71],
            65: [2, 71],
            72: [2, 71],
            75: [2, 71],
            80: [2, 71],
            81: [2, 71],
            82: [2, 71],
            83: [2, 71],
            84: [2, 71],
            85: [2, 71]
          }, {
            33: [2, 73],
            75: [2, 73]
          }, {
            23: [2, 29],
            33: [2, 29],
            54: [2, 29],
            65: [2, 29],
            68: [2, 29],
            72: [2, 29],
            75: [2, 29],
            80: [2, 29],
            81: [2, 29],
            82: [2, 29],
            83: [2, 29],
            84: [2, 29],
            85: [2, 29]
          }, {
            14: [2, 15],
            15: [2, 15],
            19: [2, 15],
            29: [2, 15],
            34: [2, 15],
            39: [2, 15],
            44: [2, 15],
            47: [2, 15],
            48: [2, 15],
            51: [2, 15],
            55: [2, 15],
            60: [2, 15]
          }, {
            72: [1, 138],
            77: [1, 137]
          }, {
            72: [2, 100],
            77: [2, 100]
          }, {
            14: [2, 16],
            15: [2, 16],
            19: [2, 16],
            29: [2, 16],
            34: [2, 16],
            44: [2, 16],
            47: [2, 16],
            48: [2, 16],
            51: [2, 16],
            55: [2, 16],
            60: [2, 16]
          }, {
            33: [1, 139]
          }, {
            33: [2, 75]
          }, {
            33: [2, 32]
          }, {
            72: [2, 101],
            77: [2, 101]
          }, {
            14: [2, 17],
            15: [2, 17],
            19: [2, 17],
            29: [2, 17],
            34: [2, 17],
            39: [2, 17],
            44: [2, 17],
            47: [2, 17],
            48: [2, 17],
            51: [2, 17],
            55: [2, 17],
            60: [2, 17]
          }],
          defaultActions: {
            4: [2, 1],
            55: [2, 55],
            57: [2, 20],
            61: [2, 57],
            74: [2, 81],
            83: [2, 85],
            87: [2, 18],
            91: [2, 89],
            102: [2, 53],
            105: [2, 93],
            111: [2, 19],
            112: [2, 77],
            117: [2, 97],
            120: [2, 63],
            123: [2, 69],
            124: [2, 12],
            136: [2, 75],
            137: [2, 32]
          },
          parseError: function parseError(str, hash) {
            throw new Error(str);
          },
          parse: function parse(input) {
            var self = this,
                stack = [0],
                vstack = [null],
                lstack = [],
                table = this.table,
                yytext = "",
                yylineno = 0,
                yyleng = 0,
                recovering = 0,
                TERROR = 2,
                EOF = 1;
            this.lexer.setInput(input);
            this.lexer.yy = this.yy;
            this.yy.lexer = this.lexer;
            this.yy.parser = this;
            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
            var yyloc = this.lexer.yylloc;
            lstack.push(yyloc);
            var ranges = this.lexer.options && this.lexer.options.ranges;
            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;

            function popStack(n) {
              stack.length = stack.length - 2 * n;
              vstack.length = vstack.length - n;
              lstack.length = lstack.length - n;
            }

            function lex() {
              var token;
              token = self.lexer.lex() || 1;

              if (typeof token !== "number") {
                token = self.symbols_[token] || token;
              }

              return token;
            }

            var symbol,
                preErrorSymbol,
                state,
                action,
                a,
                r,
                yyval = {},
                p,
                len,
                newState,
                expected;

            while (true) {
              state = stack[stack.length - 1];

              if (this.defaultActions[state]) {
                action = this.defaultActions[state];
              } else {
                if (symbol === null || typeof symbol == "undefined") {
                  symbol = lex();
                }

                action = table[state] && table[state][symbol];
              }

              if (typeof action === "undefined" || !action.length || !action[0]) {
                var errStr = "";

                if (!recovering) {
                  expected = [];

                  for (p in table[state]) {
                    if (this.terminals_[p] && p > 2) {
                      expected.push("'" + this.terminals_[p] + "'");
                    }
                  }

                  if (this.lexer.showPosition) {
                    errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                  } else {
                    errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
                  }

                  this.parseError(errStr, {
                    text: this.lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: this.lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                  });
                }
              }

              if (action[0] instanceof Array && action.length > 1) {
                throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
              }

              switch (action[0]) {
                case 1:
                  stack.push(symbol);
                  vstack.push(this.lexer.yytext);
                  lstack.push(this.lexer.yylloc);
                  stack.push(action[1]);
                  symbol = null;

                  if (!preErrorSymbol) {
                    yyleng = this.lexer.yyleng;
                    yytext = this.lexer.yytext;
                    yylineno = this.lexer.yylineno;
                    yyloc = this.lexer.yylloc;
                    if (recovering > 0) recovering--;
                  } else {
                    symbol = preErrorSymbol;
                    preErrorSymbol = null;
                  }

                  break;

                case 2:
                  len = this.productions_[action[1]][1];
                  yyval.$ = vstack[vstack.length - len];
                  yyval._$ = {
                    first_line: lstack[lstack.length - (len || 1)].first_line,
                    last_line: lstack[lstack.length - 1].last_line,
                    first_column: lstack[lstack.length - (len || 1)].first_column,
                    last_column: lstack[lstack.length - 1].last_column
                  };

                  if (ranges) {
                    yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
                  }

                  r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);

                  if (typeof r !== "undefined") {
                    return r;
                  }

                  if (len) {
                    stack = stack.slice(0, -1 * len * 2);
                    vstack = vstack.slice(0, -1 * len);
                    lstack = lstack.slice(0, -1 * len);
                  }

                  stack.push(this.productions_[action[1]][0]);
                  vstack.push(yyval.$);
                  lstack.push(yyval._$);
                  newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                  stack.push(newState);
                  break;

                case 3:
                  return true;
              }
            }

            return true;
          }
        };
        /* Jison generated lexer */

        var lexer = function () {
          var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
              if (this.yy.parser) {
                this.yy.parser.parseError(str, hash);
              } else {
                throw new Error(str);
              }
            },
            setInput: function setInput(input) {
              this._input = input;
              this._more = this._less = this.done = false;
              this.yylineno = this.yyleng = 0;
              this.yytext = this.matched = this.match = '';
              this.conditionStack = ['INITIAL'];
              this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              };
              if (this.options.ranges) this.yylloc.range = [0, 0];
              this.offset = 0;
              return this;
            },
            input: function input() {
              var ch = this._input[0];
              this.yytext += ch;
              this.yyleng++;
              this.offset++;
              this.match += ch;
              this.matched += ch;
              var lines = ch.match(/(?:\r\n?|\n).*/g);

              if (lines) {
                this.yylineno++;
                this.yylloc.last_line++;
              } else {
                this.yylloc.last_column++;
              }

              if (this.options.ranges) this.yylloc.range[1]++;
              this._input = this._input.slice(1);
              return ch;
            },
            unput: function unput(ch) {
              var len = ch.length;
              var lines = ch.split(/(?:\r\n?|\n)/g);
              this._input = ch + this._input;
              this.yytext = this.yytext.substr(0, this.yytext.length - len - 1); //this.yyleng -= len;

              this.offset -= len;
              var oldLines = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1);
              this.matched = this.matched.substr(0, this.matched.length - 1);
              if (lines.length - 1) this.yylineno -= lines.length - 1;
              var r = this.yylloc.range;
              this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
              };

              if (this.options.ranges) {
                this.yylloc.range = [r[0], r[0] + this.yyleng - len];
              }

              return this;
            },
            more: function more() {
              this._more = true;
              return this;
            },
            less: function less(n) {
              this.unput(this.match.slice(n));
            },
            pastInput: function pastInput() {
              var past = this.matched.substr(0, this.matched.length - this.match.length);
              return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var next = this.match;

              if (next.length < 20) {
                next += this._input.substr(0, 20 - next.length);
              }

              return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var pre = this.pastInput();
              var c = new Array(pre.length + 1).join("-");
              return pre + this.upcomingInput() + "\n" + c + "^";
            },
            next: function next() {
              if (this.done) {
                return this.EOF;
              }

              if (!this._input) this.done = true;
              var token, match, tempMatch, index, col, lines;

              if (!this._more) {
                this.yytext = '';
                this.match = '';
              }

              var rules = this._currentRules();

              for (var i = 0; i < rules.length; i++) {
                tempMatch = this._input.match(this.rules[rules[i]]);

                if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                  match = tempMatch;
                  index = i;
                  if (!this.options.flex) break;
                }
              }

              if (match) {
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {
                  first_line: this.yylloc.last_line,
                  last_line: this.yylineno + 1,
                  first_column: this.yylloc.last_column,
                  last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;

                if (this.options.ranges) {
                  this.yylloc.range = [this.offset, this.offset += this.yyleng];
                }

                this._more = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) this.done = false;
                if (token) return token;else return;
              }

              if (this._input === "") {
                return this.EOF;
              } else {
                return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                  text: "",
                  token: null,
                  line: this.yylineno
                });
              }
            },
            lex: function lex() {
              var r = this.next();

              if (typeof r !== 'undefined') {
                return r;
              } else {
                return this.lex();
              }
            },
            begin: function begin(condition) {
              this.conditionStack.push(condition);
            },
            popState: function popState() {
              return this.conditionStack.pop();
            },
            _currentRules: function _currentRules() {
              return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
            },
            topState: function topState() {
              return this.conditionStack[this.conditionStack.length - 2];
            },
            pushState: function begin(condition) {
              this.begin(condition);
            }
          };
          lexer.options = {};

          lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START
          /*``*/
          ) {
            function strip(start, end) {
              return yy_.yytext = yy_.yytext.substr(start, yy_.yyleng - end);
            }

            var YYSTATE = YY_START;

            switch ($avoiding_name_collisions) {
              case 0:
                if (yy_.yytext.slice(-2) === "\\\\") {
                  strip(0, 1);
                  this.begin("mu");
                } else if (yy_.yytext.slice(-1) === "\\") {
                  strip(0, 1);
                  this.begin("emu");
                } else {
                  this.begin("mu");
                }

                if (yy_.yytext) return 15;
                break;

              case 1:
                return 15;
                break;

              case 2:
                this.popState();
                return 15;
                break;

              case 3:
                this.begin('raw');
                return 15;
                break;

              case 4:
                this.popState(); // Should be using `this.topState()` below, but it currently
                // returns the second top instead of the first top. Opened an
                // issue about it at https://github.com/zaach/jison/issues/291

                if (this.conditionStack[this.conditionStack.length - 1] === 'raw') {
                  return 15;
                } else {
                  yy_.yytext = yy_.yytext.substr(5, yy_.yyleng - 9);
                  return 'END_RAW_BLOCK';
                }

                break;

              case 5:
                return 15;
                break;

              case 6:
                this.popState();
                return 14;
                break;

              case 7:
                return 65;
                break;

              case 8:
                return 68;
                break;

              case 9:
                return 19;
                break;

              case 10:
                this.popState();
                this.begin('raw');
                return 23;
                break;

              case 11:
                return 55;
                break;

              case 12:
                return 60;
                break;

              case 13:
                return 29;
                break;

              case 14:
                return 47;
                break;

              case 15:
                this.popState();
                return 44;
                break;

              case 16:
                this.popState();
                return 44;
                break;

              case 17:
                return 34;
                break;

              case 18:
                return 39;
                break;

              case 19:
                return 51;
                break;

              case 20:
                return 48;
                break;

              case 21:
                this.unput(yy_.yytext);
                this.popState();
                this.begin('com');
                break;

              case 22:
                this.popState();
                return 14;
                break;

              case 23:
                return 48;
                break;

              case 24:
                return 73;
                break;

              case 25:
                return 72;
                break;

              case 26:
                return 72;
                break;

              case 27:
                return 87;
                break;

              case 28:
                // ignore whitespace
                break;

              case 29:
                this.popState();
                return 54;
                break;

              case 30:
                this.popState();
                return 33;
                break;

              case 31:
                yy_.yytext = strip(1, 2).replace(/\\"/g, '"');
                return 80;
                break;

              case 32:
                yy_.yytext = strip(1, 2).replace(/\\'/g, "'");
                return 80;
                break;

              case 33:
                return 85;
                break;

              case 34:
                return 82;
                break;

              case 35:
                return 82;
                break;

              case 36:
                return 83;
                break;

              case 37:
                return 84;
                break;

              case 38:
                return 81;
                break;

              case 39:
                return 75;
                break;

              case 40:
                return 77;
                break;

              case 41:
                return 72;
                break;

              case 42:
                yy_.yytext = yy_.yytext.replace(/\\([\\\]])/g, '$1');
                return 72;
                break;

              case 43:
                return 'INVALID';
                break;

              case 44:
                return 5;
                break;
            }
          };

          lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]*?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/];
          lexer.conditions = {
            "mu": {
              "rules": [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44],
              "inclusive": false
            },
            "emu": {
              "rules": [2],
              "inclusive": false
            },
            "com": {
              "rules": [6],
              "inclusive": false
            },
            "raw": {
              "rules": [3, 4, 5],
              "inclusive": false
            },
            "INITIAL": {
              "rules": [0, 1, 44],
              "inclusive": true
            }
          };
          return lexer;
        }();

        parser.lexer = lexer;

        function Parser() {
          this.yy = {};
        }

        Parser.prototype = parser;
        parser.Parser = Parser;
        return new Parser();
      }();

      exports["default"] = handlebars;
      module.exports = exports["default"];
      /***/
    },
    /* 38 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;

      var _visitor = __webpack_require__(39);

      var _visitor2 = _interopRequireDefault(_visitor);

      function WhitespaceControl() {
        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
        this.options = options;
      }

      WhitespaceControl.prototype = new _visitor2['default']();

      WhitespaceControl.prototype.Program = function (program) {
        var doStandalone = !this.options.ignoreStandalone;
        var isRoot = !this.isRootSeen;
        this.isRootSeen = true;
        var body = program.body;

        for (var i = 0, l = body.length; i < l; i++) {
          var current = body[i],
              strip = this.accept(current);

          if (!strip) {
            continue;
          }

          var _isPrevWhitespace = isPrevWhitespace(body, i, isRoot),
              _isNextWhitespace = isNextWhitespace(body, i, isRoot),
              openStandalone = strip.openStandalone && _isPrevWhitespace,
              closeStandalone = strip.closeStandalone && _isNextWhitespace,
              inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;

          if (strip.close) {
            omitRight(body, i, true);
          }

          if (strip.open) {
            omitLeft(body, i, true);
          }

          if (doStandalone && inlineStandalone) {
            omitRight(body, i);

            if (omitLeft(body, i)) {
              // If we are on a standalone node, save the indent info for partials
              if (current.type === 'PartialStatement') {
                // Pull out the whitespace from the final line
                current.indent = /([ \t]+$)/.exec(body[i - 1].original)[1];
              }
            }
          }

          if (doStandalone && openStandalone) {
            omitRight((current.program || current.inverse).body); // Strip out the previous content node if it's whitespace only

            omitLeft(body, i);
          }

          if (doStandalone && closeStandalone) {
            // Always strip the next node
            omitRight(body, i);
            omitLeft((current.inverse || current.program).body);
          }
        }

        return program;
      };

      WhitespaceControl.prototype.BlockStatement = WhitespaceControl.prototype.DecoratorBlock = WhitespaceControl.prototype.PartialBlockStatement = function (block) {
        this.accept(block.program);
        this.accept(block.inverse); // Find the inverse program that is involed with whitespace stripping.

        var program = block.program || block.inverse,
            inverse = block.program && block.inverse,
            firstInverse = inverse,
            lastInverse = inverse;

        if (inverse && inverse.chained) {
          firstInverse = inverse.body[0].program; // Walk the inverse chain to find the last inverse that is actually in the chain.

          while (lastInverse.chained) {
            lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
          }
        }

        var strip = {
          open: block.openStrip.open,
          close: block.closeStrip.close,
          // Determine the standalone candiacy. Basically flag our content as being possibly standalone
          // so our parent can determine if we actually are standalone
          openStandalone: isNextWhitespace(program.body),
          closeStandalone: isPrevWhitespace((firstInverse || program).body)
        };

        if (block.openStrip.close) {
          omitRight(program.body, null, true);
        }

        if (inverse) {
          var inverseStrip = block.inverseStrip;

          if (inverseStrip.open) {
            omitLeft(program.body, null, true);
          }

          if (inverseStrip.close) {
            omitRight(firstInverse.body, null, true);
          }

          if (block.closeStrip.open) {
            omitLeft(lastInverse.body, null, true);
          } // Find standalone else statments


          if (!this.options.ignoreStandalone && isPrevWhitespace(program.body) && isNextWhitespace(firstInverse.body)) {
            omitLeft(program.body);
            omitRight(firstInverse.body);
          }
        } else if (block.closeStrip.open) {
          omitLeft(program.body, null, true);
        }

        return strip;
      };

      WhitespaceControl.prototype.Decorator = WhitespaceControl.prototype.MustacheStatement = function (mustache) {
        return mustache.strip;
      };

      WhitespaceControl.prototype.PartialStatement = WhitespaceControl.prototype.CommentStatement = function (node) {
        /* istanbul ignore next */
        var strip = node.strip || {};
        return {
          inlineStandalone: true,
          open: strip.open,
          close: strip.close
        };
      };

      function isPrevWhitespace(body, i, isRoot) {
        if (i === undefined) {
          i = body.length;
        } // Nodes that end with newlines are considered whitespace (but are special
        // cased for strip operations)


        var prev = body[i - 1],
            sibling = body[i - 2];

        if (!prev) {
          return isRoot;
        }

        if (prev.type === 'ContentStatement') {
          return (sibling || !isRoot ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(prev.original);
        }
      }

      function isNextWhitespace(body, i, isRoot) {
        if (i === undefined) {
          i = -1;
        }

        var next = body[i + 1],
            sibling = body[i + 2];

        if (!next) {
          return isRoot;
        }

        if (next.type === 'ContentStatement') {
          return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
        }
      } // Marks the node to the right of the position as omitted.
      // I.e. {{foo}}' ' will mark the ' ' node as omitted.
      //
      // If i is undefined, then the first child will be marked as such.
      //
      // If mulitple is truthy then all whitespace will be stripped out until non-whitespace
      // content is met.


      function omitRight(body, i, multiple) {
        var current = body[i == null ? 0 : i + 1];

        if (!current || current.type !== 'ContentStatement' || !multiple && current.rightStripped) {
          return;
        }

        var original = current.value;
        current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, '');
        current.rightStripped = current.value !== original;
      } // Marks the node to the left of the position as omitted.
      // I.e. ' '{{foo}} will mark the ' ' node as omitted.
      //
      // If i is undefined then the last child will be marked as such.
      //
      // If mulitple is truthy then all whitespace will be stripped out until non-whitespace
      // content is met.


      function omitLeft(body, i, multiple) {
        var current = body[i == null ? body.length - 1 : i - 1];

        if (!current || current.type !== 'ContentStatement' || !multiple && current.leftStripped) {
          return;
        } // We omit the last node if it's whitespace only and not preceeded by a non-content node.


        var original = current.value;
        current.value = current.value.replace(multiple ? /\s+$/ : /[ \t]+$/, '');
        current.leftStripped = current.value !== original;
        return current.leftStripped;
      }

      exports['default'] = WhitespaceControl;
      module.exports = exports['default'];
      /***/
    },
    /* 39 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;

      var _exception = __webpack_require__(6);

      var _exception2 = _interopRequireDefault(_exception);

      function Visitor() {
        this.parents = [];
      }

      Visitor.prototype = {
        constructor: Visitor,
        mutating: false,
        // Visits a given value. If mutating, will replace the value if necessary.
        acceptKey: function acceptKey(node, name) {
          var value = this.accept(node[name]);

          if (this.mutating) {
            // Hacky sanity check: This may have a few false positives for type for the helper
            // methods but will generally do the right thing without a lot of overhead.
            if (value && !Visitor.prototype[value.type]) {
              throw new _exception2['default']('Unexpected node type "' + value.type + '" found when accepting ' + name + ' on ' + node.type);
            }

            node[name] = value;
          }
        },
        // Performs an accept operation with added sanity check to ensure
        // required keys are not removed.
        acceptRequired: function acceptRequired(node, name) {
          this.acceptKey(node, name);

          if (!node[name]) {
            throw new _exception2['default'](node.type + ' requires ' + name);
          }
        },
        // Traverses a given array. If mutating, empty respnses will be removed
        // for child elements.
        acceptArray: function acceptArray(array) {
          for (var i = 0, l = array.length; i < l; i++) {
            this.acceptKey(array, i);

            if (!array[i]) {
              array.splice(i, 1);
              i--;
              l--;
            }
          }
        },
        accept: function accept(object) {
          if (!object) {
            return;
          }
          /* istanbul ignore next: Sanity code */


          if (!this[object.type]) {
            throw new _exception2['default']('Unknown type: ' + object.type, object);
          }

          if (this.current) {
            this.parents.unshift(this.current);
          }

          this.current = object;
          var ret = this[object.type](object);
          this.current = this.parents.shift();

          if (!this.mutating || ret) {
            return ret;
          } else if (ret !== false) {
            return object;
          }
        },
        Program: function Program(program) {
          this.acceptArray(program.body);
        },
        MustacheStatement: visitSubExpression,
        Decorator: visitSubExpression,
        BlockStatement: visitBlock,
        DecoratorBlock: visitBlock,
        PartialStatement: visitPartial,
        PartialBlockStatement: function PartialBlockStatement(partial) {
          visitPartial.call(this, partial);
          this.acceptKey(partial, 'program');
        },
        ContentStatement: function ContentStatement()
        /* content */
        {},
        CommentStatement: function CommentStatement()
        /* comment */
        {},
        SubExpression: visitSubExpression,
        PathExpression: function PathExpression()
        /* path */
        {},
        StringLiteral: function StringLiteral()
        /* string */
        {},
        NumberLiteral: function NumberLiteral()
        /* number */
        {},
        BooleanLiteral: function BooleanLiteral()
        /* bool */
        {},
        UndefinedLiteral: function UndefinedLiteral()
        /* literal */
        {},
        NullLiteral: function NullLiteral()
        /* literal */
        {},
        Hash: function Hash(hash) {
          this.acceptArray(hash.pairs);
        },
        HashPair: function HashPair(pair) {
          this.acceptRequired(pair, 'value');
        }
      };

      function visitSubExpression(mustache) {
        this.acceptRequired(mustache, 'path');
        this.acceptArray(mustache.params);
        this.acceptKey(mustache, 'hash');
      }

      function visitBlock(block) {
        visitSubExpression.call(this, block);
        this.acceptKey(block, 'program');
        this.acceptKey(block, 'inverse');
      }

      function visitPartial(partial) {
        this.acceptRequired(partial, 'name');
        this.acceptArray(partial.params);
        this.acceptKey(partial, 'hash');
      }

      exports['default'] = Visitor;
      module.exports = exports['default'];
      /***/
    },
    /* 40 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;
      exports.SourceLocation = SourceLocation;
      exports.id = id;
      exports.stripFlags = stripFlags;
      exports.stripComment = stripComment;
      exports.preparePath = preparePath;
      exports.prepareMustache = prepareMustache;
      exports.prepareRawBlock = prepareRawBlock;
      exports.prepareBlock = prepareBlock;
      exports.prepareProgram = prepareProgram;
      exports.preparePartialBlock = preparePartialBlock;

      var _exception = __webpack_require__(6);

      var _exception2 = _interopRequireDefault(_exception);

      function validateClose(open, close) {
        close = close.path ? close.path.original : close;

        if (open.path.original !== close) {
          var errorNode = {
            loc: open.path.loc
          };
          throw new _exception2['default'](open.path.original + " doesn't match " + close, errorNode);
        }
      }

      function SourceLocation(source, locInfo) {
        this.source = source;
        this.start = {
          line: locInfo.first_line,
          column: locInfo.first_column
        };
        this.end = {
          line: locInfo.last_line,
          column: locInfo.last_column
        };
      }

      function id(token) {
        if (/^\[.*\]$/.test(token)) {
          return token.substr(1, token.length - 2);
        } else {
          return token;
        }
      }

      function stripFlags(open, close) {
        return {
          open: open.charAt(2) === '~',
          close: close.charAt(close.length - 3) === '~'
        };
      }

      function stripComment(comment) {
        return comment.replace(/^\{\{~?!-?-?/, '').replace(/-?-?~?\}\}$/, '');
      }

      function preparePath(data, parts, loc) {
        loc = this.locInfo(loc);
        var original = data ? '@' : '',
            dig = [],
            depth = 0;

        for (var i = 0, l = parts.length; i < l; i++) {
          var part = parts[i].part,
              // If we have [] syntax then we do not treat path references as operators,
          // i.e. foo.[this] resolves to approximately context.foo['this']
          isLiteral = parts[i].original !== part;
          original += (parts[i].separator || '') + part;

          if (!isLiteral && (part === '..' || part === '.' || part === 'this')) {
            if (dig.length > 0) {
              throw new _exception2['default']('Invalid path: ' + original, {
                loc: loc
              });
            } else if (part === '..') {
              depth++;
            }
          } else {
            dig.push(part);
          }
        }

        return {
          type: 'PathExpression',
          data: data,
          depth: depth,
          parts: dig,
          original: original,
          loc: loc
        };
      }

      function prepareMustache(path, params, hash, open, strip, locInfo) {
        // Must use charAt to support IE pre-10
        var escapeFlag = open.charAt(3) || open.charAt(2),
            escaped = escapeFlag !== '{' && escapeFlag !== '&';
        var decorator = /\*/.test(open);
        return {
          type: decorator ? 'Decorator' : 'MustacheStatement',
          path: path,
          params: params,
          hash: hash,
          escaped: escaped,
          strip: strip,
          loc: this.locInfo(locInfo)
        };
      }

      function prepareRawBlock(openRawBlock, contents, close, locInfo) {
        validateClose(openRawBlock, close);
        locInfo = this.locInfo(locInfo);
        var program = {
          type: 'Program',
          body: contents,
          strip: {},
          loc: locInfo
        };
        return {
          type: 'BlockStatement',
          path: openRawBlock.path,
          params: openRawBlock.params,
          hash: openRawBlock.hash,
          program: program,
          openStrip: {},
          inverseStrip: {},
          closeStrip: {},
          loc: locInfo
        };
      }

      function prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
        if (close && close.path) {
          validateClose(openBlock, close);
        }

        var decorator = /\*/.test(openBlock.open);
        program.blockParams = openBlock.blockParams;
        var inverse = undefined,
            inverseStrip = undefined;

        if (inverseAndProgram) {
          if (decorator) {
            throw new _exception2['default']('Unexpected inverse block on decorator', inverseAndProgram);
          }

          if (inverseAndProgram.chain) {
            inverseAndProgram.program.body[0].closeStrip = close.strip;
          }

          inverseStrip = inverseAndProgram.strip;
          inverse = inverseAndProgram.program;
        }

        if (inverted) {
          inverted = inverse;
          inverse = program;
          program = inverted;
        }

        return {
          type: decorator ? 'DecoratorBlock' : 'BlockStatement',
          path: openBlock.path,
          params: openBlock.params,
          hash: openBlock.hash,
          program: program,
          inverse: inverse,
          openStrip: openBlock.strip,
          inverseStrip: inverseStrip,
          closeStrip: close && close.strip,
          loc: this.locInfo(locInfo)
        };
      }

      function prepareProgram(statements, loc) {
        if (!loc && statements.length) {
          var firstLoc = statements[0].loc,
              lastLoc = statements[statements.length - 1].loc;
          /* istanbul ignore else */

          if (firstLoc && lastLoc) {
            loc = {
              source: firstLoc.source,
              start: {
                line: firstLoc.start.line,
                column: firstLoc.start.column
              },
              end: {
                line: lastLoc.end.line,
                column: lastLoc.end.column
              }
            };
          }
        }

        return {
          type: 'Program',
          body: statements,
          strip: {},
          loc: loc
        };
      }

      function preparePartialBlock(open, program, close, locInfo) {
        validateClose(open, close);
        return {
          type: 'PartialBlockStatement',
          name: open.path,
          params: open.params,
          hash: open.hash,
          program: program,
          openStrip: open.strip,
          closeStrip: close && close.strip,
          loc: this.locInfo(locInfo)
        };
      }
      /***/

    },
    /* 41 */

    /***/
    function (module, exports, __webpack_require__) {
      /* eslint-disable new-cap */
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;
      exports.Compiler = Compiler;
      exports.precompile = precompile;
      exports.compile = compile;

      var _exception = __webpack_require__(6);

      var _exception2 = _interopRequireDefault(_exception);

      var _utils = __webpack_require__(5);

      var _ast = __webpack_require__(35);

      var _ast2 = _interopRequireDefault(_ast);

      var slice = [].slice;

      function Compiler() {} // the foundHelper register will disambiguate helper lookup from finding a
      // function in a context. This is necessary for mustache compatibility, which
      // requires that context functions in blocks are evaluated by blockHelperMissing,
      // and then proceed as if the resulting value was provided to blockHelperMissing.


      Compiler.prototype = {
        compiler: Compiler,
        equals: function equals(other) {
          var len = this.opcodes.length;

          if (other.opcodes.length !== len) {
            return false;
          }

          for (var i = 0; i < len; i++) {
            var opcode = this.opcodes[i],
                otherOpcode = other.opcodes[i];

            if (opcode.opcode !== otherOpcode.opcode || !argEquals(opcode.args, otherOpcode.args)) {
              return false;
            }
          } // We know that length is the same between the two arrays because they are directly tied
          // to the opcode behavior above.


          len = this.children.length;

          for (var i = 0; i < len; i++) {
            if (!this.children[i].equals(other.children[i])) {
              return false;
            }
          }

          return true;
        },
        guid: 0,
        compile: function compile(program, options) {
          this.sourceNode = [];
          this.opcodes = [];
          this.children = [];
          this.options = options;
          this.stringParams = options.stringParams;
          this.trackIds = options.trackIds;
          options.blockParams = options.blockParams || []; // These changes will propagate to the other compiler components

          var knownHelpers = options.knownHelpers;
          options.knownHelpers = {
            'helperMissing': true,
            'blockHelperMissing': true,
            'each': true,
            'if': true,
            'unless': true,
            'with': true,
            'log': true,
            'lookup': true
          };

          if (knownHelpers) {
            // the next line should use "Object.keys", but the code has been like this a long time and changing it, might
            // cause backwards-compatibility issues... It's an old library...
            // eslint-disable-next-line guard-for-in
            for (var _name in knownHelpers) {
              this.options.knownHelpers[_name] = knownHelpers[_name];
            }
          }

          return this.accept(program);
        },
        compileProgram: function compileProgram(program) {
          var childCompiler = new this.compiler(),
              // eslint-disable-line new-cap
          result = childCompiler.compile(program, this.options),
              guid = this.guid++;
          this.usePartial = this.usePartial || result.usePartial;
          this.children[guid] = result;
          this.useDepths = this.useDepths || result.useDepths;
          return guid;
        },
        accept: function accept(node) {
          /* istanbul ignore next: Sanity code */
          if (!this[node.type]) {
            throw new _exception2['default']('Unknown type: ' + node.type, node);
          }

          this.sourceNode.unshift(node);
          var ret = this[node.type](node);
          this.sourceNode.shift();
          return ret;
        },
        Program: function Program(program) {
          this.options.blockParams.unshift(program.blockParams);
          var body = program.body,
              bodyLength = body.length;

          for (var i = 0; i < bodyLength; i++) {
            this.accept(body[i]);
          }

          this.options.blockParams.shift();
          this.isSimple = bodyLength === 1;
          this.blockParams = program.blockParams ? program.blockParams.length : 0;
          return this;
        },
        BlockStatement: function BlockStatement(block) {
          transformLiteralToPath(block);
          var program = block.program,
              inverse = block.inverse;
          program = program && this.compileProgram(program);
          inverse = inverse && this.compileProgram(inverse);
          var type = this.classifySexpr(block);

          if (type === 'helper') {
            this.helperSexpr(block, program, inverse);
          } else if (type === 'simple') {
            this.simpleSexpr(block); // now that the simple mustache is resolved, we need to
            // evaluate it by executing `blockHelperMissing`

            this.opcode('pushProgram', program);
            this.opcode('pushProgram', inverse);
            this.opcode('emptyHash');
            this.opcode('blockValue', block.path.original);
          } else {
            this.ambiguousSexpr(block, program, inverse); // now that the simple mustache is resolved, we need to
            // evaluate it by executing `blockHelperMissing`

            this.opcode('pushProgram', program);
            this.opcode('pushProgram', inverse);
            this.opcode('emptyHash');
            this.opcode('ambiguousBlockValue');
          }

          this.opcode('append');
        },
        DecoratorBlock: function DecoratorBlock(decorator) {
          var program = decorator.program && this.compileProgram(decorator.program);
          var params = this.setupFullMustacheParams(decorator, program, undefined),
              path = decorator.path;
          this.useDecorators = true;
          this.opcode('registerDecorator', params.length, path.original);
        },
        PartialStatement: function PartialStatement(partial) {
          this.usePartial = true;
          var program = partial.program;

          if (program) {
            program = this.compileProgram(partial.program);
          }

          var params = partial.params;

          if (params.length > 1) {
            throw new _exception2['default']('Unsupported number of partial arguments: ' + params.length, partial);
          } else if (!params.length) {
            if (this.options.explicitPartialContext) {
              this.opcode('pushLiteral', 'undefined');
            } else {
              params.push({
                type: 'PathExpression',
                parts: [],
                depth: 0
              });
            }
          }

          var partialName = partial.name.original,
              isDynamic = partial.name.type === 'SubExpression';

          if (isDynamic) {
            this.accept(partial.name);
          }

          this.setupFullMustacheParams(partial, program, undefined, true);
          var indent = partial.indent || '';

          if (this.options.preventIndent && indent) {
            this.opcode('appendContent', indent);
            indent = '';
          }

          this.opcode('invokePartial', isDynamic, partialName, indent);
          this.opcode('append');
        },
        PartialBlockStatement: function PartialBlockStatement(partialBlock) {
          this.PartialStatement(partialBlock);
        },
        MustacheStatement: function MustacheStatement(mustache) {
          this.SubExpression(mustache);

          if (mustache.escaped && !this.options.noEscape) {
            this.opcode('appendEscaped');
          } else {
            this.opcode('append');
          }
        },
        Decorator: function Decorator(decorator) {
          this.DecoratorBlock(decorator);
        },
        ContentStatement: function ContentStatement(content) {
          if (content.value) {
            this.opcode('appendContent', content.value);
          }
        },
        CommentStatement: function CommentStatement() {},
        SubExpression: function SubExpression(sexpr) {
          transformLiteralToPath(sexpr);
          var type = this.classifySexpr(sexpr);

          if (type === 'simple') {
            this.simpleSexpr(sexpr);
          } else if (type === 'helper') {
            this.helperSexpr(sexpr);
          } else {
            this.ambiguousSexpr(sexpr);
          }
        },
        ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
          var path = sexpr.path,
              name = path.parts[0],
              isBlock = program != null || inverse != null;
          this.opcode('getContext', path.depth);
          this.opcode('pushProgram', program);
          this.opcode('pushProgram', inverse);
          path.strict = true;
          this.accept(path);
          this.opcode('invokeAmbiguous', name, isBlock);
        },
        simpleSexpr: function simpleSexpr(sexpr) {
          var path = sexpr.path;
          path.strict = true;
          this.accept(path);
          this.opcode('resolvePossibleLambda');
        },
        helperSexpr: function helperSexpr(sexpr, program, inverse) {
          var params = this.setupFullMustacheParams(sexpr, program, inverse),
              path = sexpr.path,
              name = path.parts[0];

          if (this.options.knownHelpers[name]) {
            this.opcode('invokeKnownHelper', params.length, name);
          } else if (this.options.knownHelpersOnly) {
            throw new _exception2['default']('You specified knownHelpersOnly, but used the unknown helper ' + name, sexpr);
          } else {
            path.strict = true;
            path.falsy = true;
            this.accept(path);
            this.opcode('invokeHelper', params.length, path.original, _ast2['default'].helpers.simpleId(path));
          }
        },
        PathExpression: function PathExpression(path) {
          this.addDepth(path.depth);
          this.opcode('getContext', path.depth);

          var name = path.parts[0],
              scoped = _ast2['default'].helpers.scopedId(path),
              blockParamId = !path.depth && !scoped && this.blockParamIndex(name);

          if (blockParamId) {
            this.opcode('lookupBlockParam', blockParamId, path.parts);
          } else if (!name) {
            // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
            this.opcode('pushContext');
          } else if (path.data) {
            this.options.data = true;
            this.opcode('lookupData', path.depth, path.parts, path.strict);
          } else {
            this.opcode('lookupOnContext', path.parts, path.falsy, path.strict, scoped);
          }
        },
        StringLiteral: function StringLiteral(string) {
          this.opcode('pushString', string.value);
        },
        NumberLiteral: function NumberLiteral(number) {
          this.opcode('pushLiteral', number.value);
        },
        BooleanLiteral: function BooleanLiteral(bool) {
          this.opcode('pushLiteral', bool.value);
        },
        UndefinedLiteral: function UndefinedLiteral() {
          this.opcode('pushLiteral', 'undefined');
        },
        NullLiteral: function NullLiteral() {
          this.opcode('pushLiteral', 'null');
        },
        Hash: function Hash(hash) {
          var pairs = hash.pairs,
              i = 0,
              l = pairs.length;
          this.opcode('pushHash');

          for (; i < l; i++) {
            this.pushParam(pairs[i].value);
          }

          while (i--) {
            this.opcode('assignToHash', pairs[i].key);
          }

          this.opcode('popHash');
        },
        // HELPERS
        opcode: function opcode(name) {
          this.opcodes.push({
            opcode: name,
            args: slice.call(arguments, 1),
            loc: this.sourceNode[0].loc
          });
        },
        addDepth: function addDepth(depth) {
          if (!depth) {
            return;
          }

          this.useDepths = true;
        },
        classifySexpr: function classifySexpr(sexpr) {
          var isSimple = _ast2['default'].helpers.simpleId(sexpr.path);

          var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]); // a mustache is an eligible helper if:
          // * its id is simple (a single part, not `this` or `..`)

          var isHelper = !isBlockParam && _ast2['default'].helpers.helperExpression(sexpr); // if a mustache is an eligible helper but not a definite
          // helper, it is ambiguous, and will be resolved in a later
          // pass or at runtime.


          var isEligible = !isBlockParam && (isHelper || isSimple); // if ambiguous, we can possibly resolve the ambiguity now
          // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.

          if (isEligible && !isHelper) {
            var _name2 = sexpr.path.parts[0],
                options = this.options;

            if (options.knownHelpers[_name2]) {
              isHelper = true;
            } else if (options.knownHelpersOnly) {
              isEligible = false;
            }
          }

          if (isHelper) {
            return 'helper';
          } else if (isEligible) {
            return 'ambiguous';
          } else {
            return 'simple';
          }
        },
        pushParams: function pushParams(params) {
          for (var i = 0, l = params.length; i < l; i++) {
            this.pushParam(params[i]);
          }
        },
        pushParam: function pushParam(val) {
          var value = val.value != null ? val.value : val.original || '';

          if (this.stringParams) {
            if (value.replace) {
              value = value.replace(/^(\.?\.\/)*/g, '').replace(/\//g, '.');
            }

            if (val.depth) {
              this.addDepth(val.depth);
            }

            this.opcode('getContext', val.depth || 0);
            this.opcode('pushStringParam', value, val.type);

            if (val.type === 'SubExpression') {
              // SubExpressions get evaluated and passed in
              // in string params mode.
              this.accept(val);
            }
          } else {
            if (this.trackIds) {
              var blockParamIndex = undefined;

              if (val.parts && !_ast2['default'].helpers.scopedId(val) && !val.depth) {
                blockParamIndex = this.blockParamIndex(val.parts[0]);
              }

              if (blockParamIndex) {
                var blockParamChild = val.parts.slice(1).join('.');
                this.opcode('pushId', 'BlockParam', blockParamIndex, blockParamChild);
              } else {
                value = val.original || value;

                if (value.replace) {
                  value = value.replace(/^this(?:\.|$)/, '').replace(/^\.\//, '').replace(/^\.$/, '');
                }

                this.opcode('pushId', val.type, value);
              }
            }

            this.accept(val);
          }
        },
        setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
          var params = sexpr.params;
          this.pushParams(params);
          this.opcode('pushProgram', program);
          this.opcode('pushProgram', inverse);

          if (sexpr.hash) {
            this.accept(sexpr.hash);
          } else {
            this.opcode('emptyHash', omitEmpty);
          }

          return params;
        },
        blockParamIndex: function blockParamIndex(name) {
          for (var depth = 0, len = this.options.blockParams.length; depth < len; depth++) {
            var blockParams = this.options.blockParams[depth],
                param = blockParams && _utils.indexOf(blockParams, name);

            if (blockParams && param >= 0) {
              return [depth, param];
            }
          }
        }
      };

      function precompile(input, options, env) {
        if (input == null || typeof input !== 'string' && input.type !== 'Program') {
          throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.precompile. You passed ' + input);
        }

        options = options || {};

        if (!('data' in options)) {
          options.data = true;
        }

        if (options.compat) {
          options.useDepths = true;
        }

        var ast = env.parse(input, options),
            environment = new env.Compiler().compile(ast, options);
        return new env.JavaScriptCompiler().compile(environment, options);
      }

      function compile(input, options, env) {
        if (options === undefined) options = {};

        if (input == null || typeof input !== 'string' && input.type !== 'Program') {
          throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.compile. You passed ' + input);
        }

        options = _utils.extend({}, options);

        if (!('data' in options)) {
          options.data = true;
        }

        if (options.compat) {
          options.useDepths = true;
        }

        var compiled = undefined;

        function compileInput() {
          var ast = env.parse(input, options),
              environment = new env.Compiler().compile(ast, options),
              templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
          return env.template(templateSpec);
        } // Template is only compiled on first use and cached after that point.


        function ret(context, execOptions) {
          if (!compiled) {
            compiled = compileInput();
          }

          return compiled.call(this, context, execOptions);
        }

        ret._setup = function (setupOptions) {
          if (!compiled) {
            compiled = compileInput();
          }

          return compiled._setup(setupOptions);
        };

        ret._child = function (i, data, blockParams, depths) {
          if (!compiled) {
            compiled = compileInput();
          }

          return compiled._child(i, data, blockParams, depths);
        };

        return ret;
      }

      function argEquals(a, b) {
        if (a === b) {
          return true;
        }

        if (_utils.isArray(a) && _utils.isArray(b) && a.length === b.length) {
          for (var i = 0; i < a.length; i++) {
            if (!argEquals(a[i], b[i])) {
              return false;
            }
          }

          return true;
        }
      }

      function transformLiteralToPath(sexpr) {
        if (!sexpr.path.parts) {
          var literal = sexpr.path; // Casting to string here to make false and 0 literal values play nicely with the rest
          // of the system.

          sexpr.path = {
            type: 'PathExpression',
            data: false,
            depth: 0,
            parts: [literal.original + ''],
            original: literal.original + '',
            loc: literal.loc
          };
        }
      }
      /***/

    },
    /* 42 */

    /***/
    function (module, exports, __webpack_require__) {
      'use strict';

      var _interopRequireDefault = __webpack_require__(1)['default'];

      exports.__esModule = true;

      var _base = __webpack_require__(4);

      var _exception = __webpack_require__(6);

      var _exception2 = _interopRequireDefault(_exception);

      var _utils = __webpack_require__(5);

      var _codeGen = __webpack_require__(43);

      var _codeGen2 = _interopRequireDefault(_codeGen);

      function Literal(value) {
        this.value = value;
      }

      function JavaScriptCompiler() {}

      JavaScriptCompiler.prototype = {
        // PUBLIC API: You can override these methods in a subclass to provide
        // alternative compiled forms for name lookup and buffering semantics
        nameLookup: function nameLookup(parent, name
        /* , type*/
        ) {
          if (JavaScriptCompiler.isValidJavaScriptVariableName(name)) {
            return [parent, '.', name];
          } else {
            return [parent, '[', JSON.stringify(name), ']'];
          }
        },
        depthedLookup: function depthedLookup(name) {
          return [this.aliasable('container.lookup'), '(depths, "', name, '")'];
        },
        compilerInfo: function compilerInfo() {
          var revision = _base.COMPILER_REVISION,
              versions = _base.REVISION_CHANGES[revision];
          return [revision, versions];
        },
        appendToBuffer: function appendToBuffer(source, location, explicit) {
          // Force a source as this simplifies the merge logic.
          if (!_utils.isArray(source)) {
            source = [source];
          }

          source = this.source.wrap(source, location);

          if (this.environment.isSimple) {
            return ['return ', source, ';'];
          } else if (explicit) {
            // This is a case where the buffer operation occurs as a child of another
            // construct, generally braces. We have to explicitly output these buffer
            // operations to ensure that the emitted code goes in the correct location.
            return ['buffer += ', source, ';'];
          } else {
            source.appendToBuffer = true;
            return source;
          }
        },
        initializeBuffer: function initializeBuffer() {
          return this.quotedString('');
        },
        // END PUBLIC API
        compile: function compile(environment, options, context, asObject) {
          this.environment = environment;
          this.options = options;
          this.stringParams = this.options.stringParams;
          this.trackIds = this.options.trackIds;
          this.precompile = !asObject;
          this.name = this.environment.name;
          this.isChild = !!context;
          this.context = context || {
            decorators: [],
            programs: [],
            environments: []
          };
          this.preamble();
          this.stackSlot = 0;
          this.stackVars = [];
          this.aliases = {};
          this.registers = {
            list: []
          };
          this.hashes = [];
          this.compileStack = [];
          this.inlineStack = [];
          this.blockParams = [];
          this.compileChildren(environment, options);
          this.useDepths = this.useDepths || environment.useDepths || environment.useDecorators || this.options.compat;
          this.useBlockParams = this.useBlockParams || environment.useBlockParams;
          var opcodes = environment.opcodes,
              opcode = undefined,
              firstLoc = undefined,
              i = undefined,
              l = undefined;

          for (i = 0, l = opcodes.length; i < l; i++) {
            opcode = opcodes[i];
            this.source.currentLocation = opcode.loc;
            firstLoc = firstLoc || opcode.loc;
            this[opcode.opcode].apply(this, opcode.args);
          } // Flush any trailing content that might be pending.


          this.source.currentLocation = firstLoc;
          this.pushSource('');
          /* istanbul ignore next */

          if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
            throw new _exception2['default']('Compile completed with content left on stack');
          }

          if (!this.decorators.isEmpty()) {
            this.useDecorators = true;
            this.decorators.prepend('var decorators = container.decorators;\n');
            this.decorators.push('return fn;');

            if (asObject) {
              this.decorators = Function.apply(this, ['fn', 'props', 'container', 'depth0', 'data', 'blockParams', 'depths', this.decorators.merge()]);
            } else {
              this.decorators.prepend('function(fn, props, container, depth0, data, blockParams, depths) {\n');
              this.decorators.push('}\n');
              this.decorators = this.decorators.merge();
            }
          } else {
            this.decorators = undefined;
          }

          var fn = this.createFunctionContext(asObject);

          if (!this.isChild) {
            var ret = {
              compiler: this.compilerInfo(),
              main: fn
            };

            if (this.decorators) {
              ret.main_d = this.decorators; // eslint-disable-line camelcase

              ret.useDecorators = true;
            }

            var _context = this.context;
            var programs = _context.programs;
            var decorators = _context.decorators;

            for (i = 0, l = programs.length; i < l; i++) {
              if (programs[i]) {
                ret[i] = programs[i];

                if (decorators[i]) {
                  ret[i + '_d'] = decorators[i];
                  ret.useDecorators = true;
                }
              }
            }

            if (this.environment.usePartial) {
              ret.usePartial = true;
            }

            if (this.options.data) {
              ret.useData = true;
            }

            if (this.useDepths) {
              ret.useDepths = true;
            }

            if (this.useBlockParams) {
              ret.useBlockParams = true;
            }

            if (this.options.compat) {
              ret.compat = true;
            }

            if (!asObject) {
              ret.compiler = JSON.stringify(ret.compiler);
              this.source.currentLocation = {
                start: {
                  line: 1,
                  column: 0
                }
              };
              ret = this.objectLiteral(ret);

              if (options.srcName) {
                ret = ret.toStringWithSourceMap({
                  file: options.destName
                });
                ret.map = ret.map && ret.map.toString();
              } else {
                ret = ret.toString();
              }
            } else {
              ret.compilerOptions = this.options;
            }

            return ret;
          } else {
            return fn;
          }
        },
        preamble: function preamble() {
          // track the last context pushed into place to allow skipping the
          // getContext opcode when it would be a noop
          this.lastContext = 0;
          this.source = new _codeGen2['default'](this.options.srcName);
          this.decorators = new _codeGen2['default'](this.options.srcName);
        },
        createFunctionContext: function createFunctionContext(asObject) {
          var varDeclarations = '';
          var locals = this.stackVars.concat(this.registers.list);

          if (locals.length > 0) {
            varDeclarations += ', ' + locals.join(', ');
          } // Generate minimizer alias mappings
          //
          // When using true SourceNodes, this will update all references to the given alias
          // as the source nodes are reused in situ. For the non-source node compilation mode,
          // aliases will not be used, but this case is already being run on the client and
          // we aren't concern about minimizing the template size.


          var aliasCount = 0;

          for (var alias in this.aliases) {
            // eslint-disable-line guard-for-in
            var node = this.aliases[alias];

            if (this.aliases.hasOwnProperty(alias) && node.children && node.referenceCount > 1) {
              varDeclarations += ', alias' + ++aliasCount + '=' + alias;
              node.children[0] = 'alias' + aliasCount;
            }
          }

          var params = ['container', 'depth0', 'helpers', 'partials', 'data'];

          if (this.useBlockParams || this.useDepths) {
            params.push('blockParams');
          }

          if (this.useDepths) {
            params.push('depths');
          } // Perform a second pass over the output to merge content when possible


          var source = this.mergeSource(varDeclarations);

          if (asObject) {
            params.push(source);
            return Function.apply(this, params);
          } else {
            return this.source.wrap(['function(', params.join(','), ') {\n  ', source, '}']);
          }
        },
        mergeSource: function mergeSource(varDeclarations) {
          var isSimple = this.environment.isSimple,
              appendOnly = !this.forceBuffer,
              appendFirst = undefined,
              sourceSeen = undefined,
              bufferStart = undefined,
              bufferEnd = undefined;
          this.source.each(function (line) {
            if (line.appendToBuffer) {
              if (bufferStart) {
                line.prepend('  + ');
              } else {
                bufferStart = line;
              }

              bufferEnd = line;
            } else {
              if (bufferStart) {
                if (!sourceSeen) {
                  appendFirst = true;
                } else {
                  bufferStart.prepend('buffer += ');
                }

                bufferEnd.add(';');
                bufferStart = bufferEnd = undefined;
              }

              sourceSeen = true;

              if (!isSimple) {
                appendOnly = false;
              }
            }
          });

          if (appendOnly) {
            if (bufferStart) {
              bufferStart.prepend('return ');
              bufferEnd.add(';');
            } else if (!sourceSeen) {
              this.source.push('return "";');
            }
          } else {
            varDeclarations += ', buffer = ' + (appendFirst ? '' : this.initializeBuffer());

            if (bufferStart) {
              bufferStart.prepend('return buffer + ');
              bufferEnd.add(';');
            } else {
              this.source.push('return buffer;');
            }
          }

          if (varDeclarations) {
            this.source.prepend('var ' + varDeclarations.substring(2) + (appendFirst ? '' : ';\n'));
          }

          return this.source.merge();
        },
        // [blockValue]
        //
        // On stack, before: hash, inverse, program, value
        // On stack, after: return value of blockHelperMissing
        //
        // The purpose of this opcode is to take a block of the form
        // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
        // replace it on the stack with the result of properly
        // invoking blockHelperMissing.
        blockValue: function blockValue(name) {
          var blockHelperMissing = this.aliasable('helpers.blockHelperMissing'),
              params = [this.contextName(0)];
          this.setupHelperArgs(name, 0, params);
          var blockName = this.popStack();
          params.splice(1, 0, blockName);
          this.push(this.source.functionCall(blockHelperMissing, 'call', params));
        },
        // [ambiguousBlockValue]
        //
        // On stack, before: hash, inverse, program, value
        // Compiler value, before: lastHelper=value of last found helper, if any
        // On stack, after, if no lastHelper: same as [blockValue]
        // On stack, after, if lastHelper: value
        ambiguousBlockValue: function ambiguousBlockValue() {
          // We're being a bit cheeky and reusing the options value from the prior exec
          var blockHelperMissing = this.aliasable('helpers.blockHelperMissing'),
              params = [this.contextName(0)];
          this.setupHelperArgs('', 0, params, true);
          this.flushInline();
          var current = this.topStack();
          params.splice(1, 0, current);
          this.pushSource(['if (!', this.lastHelper, ') { ', current, ' = ', this.source.functionCall(blockHelperMissing, 'call', params), '}']);
        },
        // [appendContent]
        //
        // On stack, before: ...
        // On stack, after: ...
        //
        // Appends the string value of `content` to the current buffer
        appendContent: function appendContent(content) {
          if (this.pendingContent) {
            content = this.pendingContent + content;
          } else {
            this.pendingLocation = this.source.currentLocation;
          }

          this.pendingContent = content;
        },
        // [append]
        //
        // On stack, before: value, ...
        // On stack, after: ...
        //
        // Coerces `value` to a String and appends it to the current buffer.
        //
        // If `value` is truthy, or 0, it is coerced into a string and appended
        // Otherwise, the empty string is appended
        append: function append() {
          if (this.isInline()) {
            this.replaceStack(function (current) {
              return [' != null ? ', current, ' : ""'];
            });
            this.pushSource(this.appendToBuffer(this.popStack()));
          } else {
            var local = this.popStack();
            this.pushSource(['if (', local, ' != null) { ', this.appendToBuffer(local, undefined, true), ' }']);

            if (this.environment.isSimple) {
              this.pushSource(['else { ', this.appendToBuffer("''", undefined, true), ' }']);
            }
          }
        },
        // [appendEscaped]
        //
        // On stack, before: value, ...
        // On stack, after: ...
        //
        // Escape `value` and append it to the buffer
        appendEscaped: function appendEscaped() {
          this.pushSource(this.appendToBuffer([this.aliasable('container.escapeExpression'), '(', this.popStack(), ')']));
        },
        // [getContext]
        //
        // On stack, before: ...
        // On stack, after: ...
        // Compiler value, after: lastContext=depth
        //
        // Set the value of the `lastContext` compiler value to the depth
        getContext: function getContext(depth) {
          this.lastContext = depth;
        },
        // [pushContext]
        //
        // On stack, before: ...
        // On stack, after: currentContext, ...
        //
        // Pushes the value of the current context onto the stack.
        pushContext: function pushContext() {
          this.pushStackLiteral(this.contextName(this.lastContext));
        },
        // [lookupOnContext]
        //
        // On stack, before: ...
        // On stack, after: currentContext[name], ...
        //
        // Looks up the value of `name` on the current context and pushes
        // it onto the stack.
        lookupOnContext: function lookupOnContext(parts, falsy, strict, scoped) {
          var i = 0;

          if (!scoped && this.options.compat && !this.lastContext) {
            // The depthed query is expected to handle the undefined logic for the root level that
            // is implemented below, so we evaluate that directly in compat mode
            this.push(this.depthedLookup(parts[i++]));
          } else {
            this.pushContext();
          }

          this.resolvePath('context', parts, i, falsy, strict);
        },
        // [lookupBlockParam]
        //
        // On stack, before: ...
        // On stack, after: blockParam[name], ...
        //
        // Looks up the value of `parts` on the given block param and pushes
        // it onto the stack.
        lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
          this.useBlockParams = true;
          this.push(['blockParams[', blockParamId[0], '][', blockParamId[1], ']']);
          this.resolvePath('context', parts, 1);
        },
        // [lookupData]
        //
        // On stack, before: ...
        // On stack, after: data, ...
        //
        // Push the data lookup operator
        lookupData: function lookupData(depth, parts, strict) {
          if (!depth) {
            this.pushStackLiteral('data');
          } else {
            this.pushStackLiteral('container.data(data, ' + depth + ')');
          }

          this.resolvePath('data', parts, 0, true, strict);
        },
        resolvePath: function resolvePath(type, parts, i, falsy, strict) {
          // istanbul ignore next
          var _this = this;

          if (this.options.strict || this.options.assumeObjects) {
            this.push(strictLookup(this.options.strict && strict, this, parts, type));
            return;
          }

          var len = parts.length;

          for (; i < len; i++) {
            /* eslint-disable no-loop-func */
            this.replaceStack(function (current) {
              var lookup = _this.nameLookup(current, parts[i], type); // We want to ensure that zero and false are handled properly if the context (falsy flag)
              // needs to have the special handling for these values.


              if (!falsy) {
                return [' != null ? ', lookup, ' : ', current];
              } else {
                // Otherwise we can use generic falsy handling
                return [' && ', lookup];
              }
            });
            /* eslint-enable no-loop-func */
          }
        },
        // [resolvePossibleLambda]
        //
        // On stack, before: value, ...
        // On stack, after: resolved value, ...
        //
        // If the `value` is a lambda, replace it on the stack by
        // the return value of the lambda
        resolvePossibleLambda: function resolvePossibleLambda() {
          this.push([this.aliasable('container.lambda'), '(', this.popStack(), ', ', this.contextName(0), ')']);
        },
        // [pushStringParam]
        //
        // On stack, before: ...
        // On stack, after: string, currentContext, ...
        //
        // This opcode is designed for use in string mode, which
        // provides the string value of a parameter along with its
        // depth rather than resolving it immediately.
        pushStringParam: function pushStringParam(string, type) {
          this.pushContext();
          this.pushString(type); // If it's a subexpression, the string result
          // will be pushed after this opcode.

          if (type !== 'SubExpression') {
            if (typeof string === 'string') {
              this.pushString(string);
            } else {
              this.pushStackLiteral(string);
            }
          }
        },
        emptyHash: function emptyHash(omitEmpty) {
          if (this.trackIds) {
            this.push('{}'); // hashIds
          }

          if (this.stringParams) {
            this.push('{}'); // hashContexts

            this.push('{}'); // hashTypes
          }

          this.pushStackLiteral(omitEmpty ? 'undefined' : '{}');
        },
        pushHash: function pushHash() {
          if (this.hash) {
            this.hashes.push(this.hash);
          }

          this.hash = {
            values: [],
            types: [],
            contexts: [],
            ids: []
          };
        },
        popHash: function popHash() {
          var hash = this.hash;
          this.hash = this.hashes.pop();

          if (this.trackIds) {
            this.push(this.objectLiteral(hash.ids));
          }

          if (this.stringParams) {
            this.push(this.objectLiteral(hash.contexts));
            this.push(this.objectLiteral(hash.types));
          }

          this.push(this.objectLiteral(hash.values));
        },
        // [pushString]
        //
        // On stack, before: ...
        // On stack, after: quotedString(string), ...
        //
        // Push a quoted version of `string` onto the stack
        pushString: function pushString(string) {
          this.pushStackLiteral(this.quotedString(string));
        },
        // [pushLiteral]
        //
        // On stack, before: ...
        // On stack, after: value, ...
        //
        // Pushes a value onto the stack. This operation prevents
        // the compiler from creating a temporary variable to hold
        // it.
        pushLiteral: function pushLiteral(value) {
          this.pushStackLiteral(value);
        },
        // [pushProgram]
        //
        // On stack, before: ...
        // On stack, after: program(guid), ...
        //
        // Push a program expression onto the stack. This takes
        // a compile-time guid and converts it into a runtime-accessible
        // expression.
        pushProgram: function pushProgram(guid) {
          if (guid != null) {
            this.pushStackLiteral(this.programExpression(guid));
          } else {
            this.pushStackLiteral(null);
          }
        },
        // [registerDecorator]
        //
        // On stack, before: hash, program, params..., ...
        // On stack, after: ...
        //
        // Pops off the decorator's parameters, invokes the decorator,
        // and inserts the decorator into the decorators list.
        registerDecorator: function registerDecorator(paramSize, name) {
          var foundDecorator = this.nameLookup('decorators', name, 'decorator'),
              options = this.setupHelperArgs(name, paramSize);
          this.decorators.push(['fn = ', this.decorators.functionCall(foundDecorator, '', ['fn', 'props', 'container', options]), ' || fn;']);
        },
        // [invokeHelper]
        //
        // On stack, before: hash, inverse, program, params..., ...
        // On stack, after: result of helper invocation
        //
        // Pops off the helper's parameters, invokes the helper,
        // and pushes the helper's return value onto the stack.
        //
        // If the helper is not found, `helperMissing` is called.
        invokeHelper: function invokeHelper(paramSize, name, isSimple) {
          var nonHelper = this.popStack(),
              helper = this.setupHelper(paramSize, name),
              simple = isSimple ? [helper.name, ' || '] : '';
          var lookup = ['('].concat(simple, nonHelper);

          if (!this.options.strict) {
            lookup.push(' || ', this.aliasable('helpers.helperMissing'));
          }

          lookup.push(')');
          this.push(this.source.functionCall(lookup, 'call', helper.callParams));
        },
        // [invokeKnownHelper]
        //
        // On stack, before: hash, inverse, program, params..., ...
        // On stack, after: result of helper invocation
        //
        // This operation is used when the helper is known to exist,
        // so a `helperMissing` fallback is not required.
        invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
          var helper = this.setupHelper(paramSize, name);
          this.push(this.source.functionCall(helper.name, 'call', helper.callParams));
        },
        // [invokeAmbiguous]
        //
        // On stack, before: hash, inverse, program, params..., ...
        // On stack, after: result of disambiguation
        //
        // This operation is used when an expression like `{{foo}}`
        // is provided, but we don't know at compile-time whether it
        // is a helper or a path.
        //
        // This operation emits more code than the other options,
        // and can be avoided by passing the `knownHelpers` and
        // `knownHelpersOnly` flags at compile-time.
        invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
          this.useRegister('helper');
          var nonHelper = this.popStack();
          this.emptyHash();
          var helper = this.setupHelper(0, name, helperCall);
          var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');
          var lookup = ['(', '(helper = ', helperName, ' || ', nonHelper, ')'];

          if (!this.options.strict) {
            lookup[0] = '(helper = ';
            lookup.push(' != null ? helper : ', this.aliasable('helpers.helperMissing'));
          }

          this.push(['(', lookup, helper.paramsInit ? ['),(', helper.paramsInit] : [], '),', '(typeof helper === ', this.aliasable('"function"'), ' ? ', this.source.functionCall('helper', 'call', helper.callParams), ' : helper))']);
        },
        // [invokePartial]
        //
        // On stack, before: context, ...
        // On stack after: result of partial invocation
        //
        // This operation pops off a context, invokes a partial with that context,
        // and pushes the result of the invocation back.
        invokePartial: function invokePartial(isDynamic, name, indent) {
          var params = [],
              options = this.setupParams(name, 1, params);

          if (isDynamic) {
            name = this.popStack();
            delete options.name;
          }

          if (indent) {
            options.indent = JSON.stringify(indent);
          }

          options.helpers = 'helpers';
          options.partials = 'partials';
          options.decorators = 'container.decorators';

          if (!isDynamic) {
            params.unshift(this.nameLookup('partials', name, 'partial'));
          } else {
            params.unshift(name);
          }

          if (this.options.compat) {
            options.depths = 'depths';
          }

          options = this.objectLiteral(options);
          params.push(options);
          this.push(this.source.functionCall('container.invokePartial', '', params));
        },
        // [assignToHash]
        //
        // On stack, before: value, ..., hash, ...
        // On stack, after: ..., hash, ...
        //
        // Pops a value off the stack and assigns it to the current hash
        assignToHash: function assignToHash(key) {
          var value = this.popStack(),
              context = undefined,
              type = undefined,
              id = undefined;

          if (this.trackIds) {
            id = this.popStack();
          }

          if (this.stringParams) {
            type = this.popStack();
            context = this.popStack();
          }

          var hash = this.hash;

          if (context) {
            hash.contexts[key] = context;
          }

          if (type) {
            hash.types[key] = type;
          }

          if (id) {
            hash.ids[key] = id;
          }

          hash.values[key] = value;
        },
        pushId: function pushId(type, name, child) {
          if (type === 'BlockParam') {
            this.pushStackLiteral('blockParams[' + name[0] + '].path[' + name[1] + ']' + (child ? ' + ' + JSON.stringify('.' + child) : ''));
          } else if (type === 'PathExpression') {
            this.pushString(name);
          } else if (type === 'SubExpression') {
            this.pushStackLiteral('true');
          } else {
            this.pushStackLiteral('null');
          }
        },
        // HELPERS
        compiler: JavaScriptCompiler,
        compileChildren: function compileChildren(environment, options) {
          var children = environment.children,
              child = undefined,
              compiler = undefined;

          for (var i = 0, l = children.length; i < l; i++) {
            child = children[i];
            compiler = new this.compiler(); // eslint-disable-line new-cap

            var existing = this.matchExistingProgram(child);

            if (existing == null) {
              this.context.programs.push(''); // Placeholder to prevent name conflicts for nested children

              var index = this.context.programs.length;
              child.index = index;
              child.name = 'program' + index;
              this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
              this.context.decorators[index] = compiler.decorators;
              this.context.environments[index] = child;
              this.useDepths = this.useDepths || compiler.useDepths;
              this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
              child.useDepths = this.useDepths;
              child.useBlockParams = this.useBlockParams;
            } else {
              child.index = existing.index;
              child.name = 'program' + existing.index;
              this.useDepths = this.useDepths || existing.useDepths;
              this.useBlockParams = this.useBlockParams || existing.useBlockParams;
            }
          }
        },
        matchExistingProgram: function matchExistingProgram(child) {
          for (var i = 0, len = this.context.environments.length; i < len; i++) {
            var environment = this.context.environments[i];

            if (environment && environment.equals(child)) {
              return environment;
            }
          }
        },
        programExpression: function programExpression(guid) {
          var child = this.environment.children[guid],
              programParams = [child.index, 'data', child.blockParams];

          if (this.useBlockParams || this.useDepths) {
            programParams.push('blockParams');
          }

          if (this.useDepths) {
            programParams.push('depths');
          }

          return 'container.program(' + programParams.join(', ') + ')';
        },
        useRegister: function useRegister(name) {
          if (!this.registers[name]) {
            this.registers[name] = true;
            this.registers.list.push(name);
          }
        },
        push: function push(expr) {
          if (!(expr instanceof Literal)) {
            expr = this.source.wrap(expr);
          }

          this.inlineStack.push(expr);
          return expr;
        },
        pushStackLiteral: function pushStackLiteral(item) {
          this.push(new Literal(item));
        },
        pushSource: function pushSource(source) {
          if (this.pendingContent) {
            this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
            this.pendingContent = undefined;
          }

          if (source) {
            this.source.push(source);
          }
        },
        replaceStack: function replaceStack(callback) {
          var prefix = ['('],
              stack = undefined,
              createdStack = undefined,
              usedLiteral = undefined;
          /* istanbul ignore next */

          if (!this.isInline()) {
            throw new _exception2['default']('replaceStack on non-inline');
          } // We want to merge the inline statement into the replacement statement via ','


          var top = this.popStack(true);

          if (top instanceof Literal) {
            // Literals do not need to be inlined
            stack = [top.value];
            prefix = ['(', stack];
            usedLiteral = true;
          } else {
            // Get or create the current stack name for use by the inline
            createdStack = true;

            var _name = this.incrStack();

            prefix = ['((', this.push(_name), ' = ', top, ')'];
            stack = this.topStack();
          }

          var item = callback.call(this, stack);

          if (!usedLiteral) {
            this.popStack();
          }

          if (createdStack) {
            this.stackSlot--;
          }

          this.push(prefix.concat(item, ')'));
        },
        incrStack: function incrStack() {
          this.stackSlot++;

          if (this.stackSlot > this.stackVars.length) {
            this.stackVars.push('stack' + this.stackSlot);
          }

          return this.topStackName();
        },
        topStackName: function topStackName() {
          return 'stack' + this.stackSlot;
        },
        flushInline: function flushInline() {
          var inlineStack = this.inlineStack;
          this.inlineStack = [];

          for (var i = 0, len = inlineStack.length; i < len; i++) {
            var entry = inlineStack[i];
            /* istanbul ignore if */

            if (entry instanceof Literal) {
              this.compileStack.push(entry);
            } else {
              var stack = this.incrStack();
              this.pushSource([stack, ' = ', entry, ';']);
              this.compileStack.push(stack);
            }
          }
        },
        isInline: function isInline() {
          return this.inlineStack.length;
        },
        popStack: function popStack(wrapped) {
          var inline = this.isInline(),
              item = (inline ? this.inlineStack : this.compileStack).pop();

          if (!wrapped && item instanceof Literal) {
            return item.value;
          } else {
            if (!inline) {
              /* istanbul ignore next */
              if (!this.stackSlot) {
                throw new _exception2['default']('Invalid stack pop');
              }

              this.stackSlot--;
            }

            return item;
          }
        },
        topStack: function topStack() {
          var stack = this.isInline() ? this.inlineStack : this.compileStack,
              item = stack[stack.length - 1];
          /* istanbul ignore if */

          if (item instanceof Literal) {
            return item.value;
          } else {
            return item;
          }
        },
        contextName: function contextName(context) {
          if (this.useDepths && context) {
            return 'depths[' + context + ']';
          } else {
            return 'depth' + context;
          }
        },
        quotedString: function quotedString(str) {
          return this.source.quotedString(str);
        },
        objectLiteral: function objectLiteral(obj) {
          return this.source.objectLiteral(obj);
        },
        aliasable: function aliasable(name) {
          var ret = this.aliases[name];

          if (ret) {
            ret.referenceCount++;
            return ret;
          }

          ret = this.aliases[name] = this.source.wrap(name);
          ret.aliasable = true;
          ret.referenceCount = 1;
          return ret;
        },
        setupHelper: function setupHelper(paramSize, name, blockHelper) {
          var params = [],
              paramsInit = this.setupHelperArgs(name, paramSize, params, blockHelper);
          var foundHelper = this.nameLookup('helpers', name, 'helper'),
              callContext = this.aliasable(this.contextName(0) + ' != null ? ' + this.contextName(0) + ' : (container.nullContext || {})');
          return {
            params: params,
            paramsInit: paramsInit,
            name: foundHelper,
            callParams: [callContext].concat(params)
          };
        },
        setupParams: function setupParams(helper, paramSize, params) {
          var options = {},
              contexts = [],
              types = [],
              ids = [],
              objectArgs = !params,
              param = undefined;

          if (objectArgs) {
            params = [];
          }

          options.name = this.quotedString(helper);
          options.hash = this.popStack();

          if (this.trackIds) {
            options.hashIds = this.popStack();
          }

          if (this.stringParams) {
            options.hashTypes = this.popStack();
            options.hashContexts = this.popStack();
          }

          var inverse = this.popStack(),
              program = this.popStack(); // Avoid setting fn and inverse if neither are set. This allows
          // helpers to do a check for `if (options.fn)`

          if (program || inverse) {
            options.fn = program || 'container.noop';
            options.inverse = inverse || 'container.noop';
          } // The parameters go on to the stack in order (making sure that they are evaluated in order)
          // so we need to pop them off the stack in reverse order


          var i = paramSize;

          while (i--) {
            param = this.popStack();
            params[i] = param;

            if (this.trackIds) {
              ids[i] = this.popStack();
            }

            if (this.stringParams) {
              types[i] = this.popStack();
              contexts[i] = this.popStack();
            }
          }

          if (objectArgs) {
            options.args = this.source.generateArray(params);
          }

          if (this.trackIds) {
            options.ids = this.source.generateArray(ids);
          }

          if (this.stringParams) {
            options.types = this.source.generateArray(types);
            options.contexts = this.source.generateArray(contexts);
          }

          if (this.options.data) {
            options.data = 'data';
          }

          if (this.useBlockParams) {
            options.blockParams = 'blockParams';
          }

          return options;
        },
        setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
          var options = this.setupParams(helper, paramSize, params);
          options = this.objectLiteral(options);

          if (useRegister) {
            this.useRegister('options');
            params.push('options');
            return ['options=', options];
          } else if (params) {
            params.push(options);
            return '';
          } else {
            return options;
          }
        }
      };

      (function () {
        var reservedWords = ('break else new var' + ' case finally return void' + ' catch for switch while' + ' continue function this with' + ' default if throw' + ' delete in try' + ' do instanceof typeof' + ' abstract enum int short' + ' boolean export interface static' + ' byte extends long super' + ' char final native synchronized' + ' class float package throws' + ' const goto private transient' + ' debugger implements protected volatile' + ' double import public let yield await' + ' null true false').split(' ');
        var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};

        for (var i = 0, l = reservedWords.length; i < l; i++) {
          compilerWords[reservedWords[i]] = true;
        }
      })();

      JavaScriptCompiler.isValidJavaScriptVariableName = function (name) {
        return !JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
      };

      function strictLookup(requireTerminal, compiler, parts, type) {
        var stack = compiler.popStack(),
            i = 0,
            len = parts.length;

        if (requireTerminal) {
          len--;
        }

        for (; i < len; i++) {
          stack = compiler.nameLookup(stack, parts[i], type);
        }

        if (requireTerminal) {
          return [compiler.aliasable('container.strict'), '(', stack, ', ', compiler.quotedString(parts[i]), ')'];
        } else {
          return stack;
        }
      }

      exports['default'] = JavaScriptCompiler;
      module.exports = exports['default'];
      /***/
    },
    /* 43 */

    /***/
    function (module, exports, __webpack_require__) {
      /* global define */
      'use strict';

      exports.__esModule = true;

      var _utils = __webpack_require__(5);

      var SourceNode = undefined;

      try {
        /* istanbul ignore next */
        if (false) {
          // We don't support this in AMD environments. For these environments, we asusme that
          // they are running on the browser and thus have no need for the source-map library.
          var SourceMap = require('source-map');

          SourceNode = SourceMap.SourceNode;
        }
      } catch (err) {}
      /* NOP */

      /* istanbul ignore if: tested but not covered in istanbul due to dist build  */


      if (!SourceNode) {
        SourceNode = function SourceNode(line, column, srcFile, chunks) {
          this.src = '';

          if (chunks) {
            this.add(chunks);
          }
        };
        /* istanbul ignore next */


        SourceNode.prototype = {
          add: function add(chunks) {
            if (_utils.isArray(chunks)) {
              chunks = chunks.join('');
            }

            this.src += chunks;
          },
          prepend: function prepend(chunks) {
            if (_utils.isArray(chunks)) {
              chunks = chunks.join('');
            }

            this.src = chunks + this.src;
          },
          toStringWithSourceMap: function toStringWithSourceMap() {
            return {
              code: this.toString()
            };
          },
          toString: function toString() {
            return this.src;
          }
        };
      }

      function castChunk(chunk, codeGen, loc) {
        if (_utils.isArray(chunk)) {
          var ret = [];

          for (var i = 0, len = chunk.length; i < len; i++) {
            ret.push(codeGen.wrap(chunk[i], loc));
          }

          return ret;
        } else if (typeof chunk === 'boolean' || typeof chunk === 'number') {
          // Handle primitives that the SourceNode will throw up on
          return chunk + '';
        }

        return chunk;
      }

      function CodeGen(srcFile) {
        this.srcFile = srcFile;
        this.source = [];
      }

      CodeGen.prototype = {
        isEmpty: function isEmpty() {
          return !this.source.length;
        },
        prepend: function prepend(source, loc) {
          this.source.unshift(this.wrap(source, loc));
        },
        push: function push(source, loc) {
          this.source.push(this.wrap(source, loc));
        },
        merge: function merge() {
          var source = this.empty();
          this.each(function (line) {
            source.add(['  ', line, '\n']);
          });
          return source;
        },
        each: function each(iter) {
          for (var i = 0, len = this.source.length; i < len; i++) {
            iter(this.source[i]);
          }
        },
        empty: function empty() {
          var loc = this.currentLocation || {
            start: {}
          };
          return new SourceNode(loc.start.line, loc.start.column, this.srcFile);
        },
        wrap: function wrap(chunk) {
          var loc = arguments.length <= 1 || arguments[1] === undefined ? this.currentLocation || {
            start: {}
          } : arguments[1];

          if (chunk instanceof SourceNode) {
            return chunk;
          }

          chunk = castChunk(chunk, this, loc);
          return new SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
        },
        functionCall: function functionCall(fn, type, params) {
          params = this.generateList(params);
          return this.wrap([fn, type ? '.' + type + '(' : '(', params, ')']);
        },
        quotedString: function quotedString(str) {
          return '"' + (str + '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\u2028/g, "\\u2028") // Per Ecma-262 7.3 + 7.8.4
          .replace(/\u2029/g, "\\u2029") + '"';
        },
        objectLiteral: function objectLiteral(obj) {
          var pairs = [];

          for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
              var value = castChunk(obj[key], this);

              if (value !== 'undefined') {
                pairs.push([this.quotedString(key), ':', value]);
              }
            }
          }

          var ret = this.generateList(pairs);
          ret.prepend('{');
          ret.add('}');
          return ret;
        },
        generateList: function generateList(entries) {
          var ret = this.empty();

          for (var i = 0, len = entries.length; i < len; i++) {
            if (i) {
              ret.add(',');
            }

            ret.add(castChunk(entries[i], this));
          }

          return ret;
        },
        generateArray: function generateArray(entries) {
          var ret = this.generateList(entries);
          ret.prepend('[');
          ret.add(']');
          return ret;
        }
      };
      exports['default'] = CodeGen;
      module.exports = exports['default'];
      /***/
    }])
  );
});

;
/*!
 * Datepicker for Bootstrap v1.8.0 (https://github.com/uxsolutions/bootstrap-datepicker)
 *
 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
 */

!function (a) {
  "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) ? require("jquery") : jQuery);
}(function (a, b) {
  function c() {
    return new Date(Date.UTC.apply(Date, arguments));
  }

  function d() {
    var a = new Date();
    return c(a.getFullYear(), a.getMonth(), a.getDate());
  }

  function e(a, b) {
    return a.getUTCFullYear() === b.getUTCFullYear() && a.getUTCMonth() === b.getUTCMonth() && a.getUTCDate() === b.getUTCDate();
  }

  function f(c, d) {
    return function () {
      return d !== b && a.fn.datepicker.deprecated(d), this[c].apply(this, arguments);
    };
  }

  function g(a) {
    return a && !isNaN(a.getTime());
  }

  function h(b, c) {
    function d(a, b) {
      return b.toLowerCase();
    }

    var e,
        f = a(b).data(),
        g = {},
        h = new RegExp("^" + c.toLowerCase() + "([A-Z])");
    c = new RegExp("^" + c.toLowerCase());

    for (var i in f) {
      c.test(i) && (e = i.replace(h, d), g[e] = f[i]);
    }

    return g;
  }

  function i(b) {
    var c = {};

    if (q[b] || (b = b.split("-")[0], q[b])) {
      var d = q[b];
      return a.each(p, function (a, b) {
        b in d && (c[b] = d[b]);
      }), c;
    }
  }

  var j = function () {
    var b = {
      get: function get(a) {
        return this.slice(a)[0];
      },
      contains: function contains(a) {
        for (var b = a && a.valueOf(), c = 0, d = this.length; c < d; c++) {
          if (0 <= this[c].valueOf() - b && this[c].valueOf() - b < 864e5) return c;
        }

        return -1;
      },
      remove: function remove(a) {
        this.splice(a, 1);
      },
      replace: function replace(b) {
        b && (a.isArray(b) || (b = [b]), this.clear(), this.push.apply(this, b));
      },
      clear: function clear() {
        this.length = 0;
      },
      copy: function copy() {
        var a = new j();
        return a.replace(this), a;
      }
    };
    return function () {
      var c = [];
      return c.push.apply(c, arguments), a.extend(c, b), c;
    };
  }(),
      k = function k(b, c) {
    a.data(b, "datepicker", this), this._process_options(c), this.dates = new j(), this.viewDate = this.o.defaultViewDate, this.focusDate = null, this.element = a(b), this.isInput = this.element.is("input"), this.inputField = this.isInput ? this.element : this.element.find("input"), this.component = !!this.element.hasClass("date") && this.element.find(".add-on, .input-group-addon, .btn"), this.component && 0 === this.component.length && (this.component = !1), this.isInline = !this.component && this.element.is("div"), this.picker = a(r.template), this._check_template(this.o.templates.leftArrow) && this.picker.find(".prev").html(this.o.templates.leftArrow), this._check_template(this.o.templates.rightArrow) && this.picker.find(".next").html(this.o.templates.rightArrow), this._buildEvents(), this._attachEvents(), this.isInline ? this.picker.addClass("datepicker-inline").appendTo(this.element) : this.picker.addClass("datepicker-dropdown dropdown-menu"), this.o.rtl && this.picker.addClass("datepicker-rtl"), this.o.calendarWeeks && this.picker.find(".datepicker-days .datepicker-switch, thead .datepicker-title, tfoot .today, tfoot .clear").attr("colspan", function (a, b) {
      return Number(b) + 1;
    }), this._process_options({
      startDate: this._o.startDate,
      endDate: this._o.endDate,
      daysOfWeekDisabled: this.o.daysOfWeekDisabled,
      daysOfWeekHighlighted: this.o.daysOfWeekHighlighted,
      datesDisabled: this.o.datesDisabled
    }), this._allow_update = !1, this.setViewMode(this.o.startView), this._allow_update = !0, this.fillDow(), this.fillMonths(), this.update(), this.isInline && this.show();
  };

  k.prototype = {
    constructor: k,
    _resolveViewName: function _resolveViewName(b) {
      return a.each(r.viewModes, function (c, d) {
        if (b === c || a.inArray(b, d.names) !== -1) return b = c, !1;
      }), b;
    },
    _resolveDaysOfWeek: function _resolveDaysOfWeek(b) {
      return a.isArray(b) || (b = b.split(/[,\s]*/)), a.map(b, Number);
    },
    _check_template: function _check_template(c) {
      try {
        if (c === b || "" === c) return !1;
        if ((c.match(/[<>]/g) || []).length <= 0) return !0;
        var d = a(c);
        return d.length > 0;
      } catch (a) {
        return !1;
      }
    },
    _process_options: function _process_options(b) {
      this._o = a.extend({}, this._o, b);
      var e = this.o = a.extend({}, this._o),
          f = e.language;
      q[f] || (f = f.split("-")[0], q[f] || (f = o.language)), e.language = f, e.startView = this._resolveViewName(e.startView), e.minViewMode = this._resolveViewName(e.minViewMode), e.maxViewMode = this._resolveViewName(e.maxViewMode), e.startView = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, e.startView)), e.multidate !== !0 && (e.multidate = Number(e.multidate) || !1, e.multidate !== !1 && (e.multidate = Math.max(0, e.multidate))), e.multidateSeparator = String(e.multidateSeparator), e.weekStart %= 7, e.weekEnd = (e.weekStart + 6) % 7;
      var g = r.parseFormat(e.format);
      e.startDate !== -(1 / 0) && (e.startDate ? e.startDate instanceof Date ? e.startDate = this._local_to_utc(this._zero_time(e.startDate)) : e.startDate = r.parseDate(e.startDate, g, e.language, e.assumeNearbyYear) : e.startDate = -(1 / 0)), e.endDate !== 1 / 0 && (e.endDate ? e.endDate instanceof Date ? e.endDate = this._local_to_utc(this._zero_time(e.endDate)) : e.endDate = r.parseDate(e.endDate, g, e.language, e.assumeNearbyYear) : e.endDate = 1 / 0), e.daysOfWeekDisabled = this._resolveDaysOfWeek(e.daysOfWeekDisabled || []), e.daysOfWeekHighlighted = this._resolveDaysOfWeek(e.daysOfWeekHighlighted || []), e.datesDisabled = e.datesDisabled || [], a.isArray(e.datesDisabled) || (e.datesDisabled = e.datesDisabled.split(",")), e.datesDisabled = a.map(e.datesDisabled, function (a) {
        return r.parseDate(a, g, e.language, e.assumeNearbyYear);
      });
      var h = String(e.orientation).toLowerCase().split(/\s+/g),
          i = e.orientation.toLowerCase();
      if (h = a.grep(h, function (a) {
        return /^auto|left|right|top|bottom$/.test(a);
      }), e.orientation = {
        x: "auto",
        y: "auto"
      }, i && "auto" !== i) {
        if (1 === h.length) switch (h[0]) {
          case "top":
          case "bottom":
            e.orientation.y = h[0];
            break;

          case "left":
          case "right":
            e.orientation.x = h[0];
        } else i = a.grep(h, function (a) {
          return /^left|right$/.test(a);
        }), e.orientation.x = i[0] || "auto", i = a.grep(h, function (a) {
          return /^top|bottom$/.test(a);
        }), e.orientation.y = i[0] || "auto";
      } else ;
      if (e.defaultViewDate instanceof Date || "string" == typeof e.defaultViewDate) e.defaultViewDate = r.parseDate(e.defaultViewDate, g, e.language, e.assumeNearbyYear);else if (e.defaultViewDate) {
        var j = e.defaultViewDate.year || new Date().getFullYear(),
            k = e.defaultViewDate.month || 0,
            l = e.defaultViewDate.day || 1;
        e.defaultViewDate = c(j, k, l);
      } else e.defaultViewDate = d();
    },
    _events: [],
    _secondaryEvents: [],
    _applyEvents: function _applyEvents(a) {
      for (var c, d, e, f = 0; f < a.length; f++) {
        c = a[f][0], 2 === a[f].length ? (d = b, e = a[f][1]) : 3 === a[f].length && (d = a[f][1], e = a[f][2]), c.on(e, d);
      }
    },
    _unapplyEvents: function _unapplyEvents(a) {
      for (var c, d, e, f = 0; f < a.length; f++) {
        c = a[f][0], 2 === a[f].length ? (e = b, d = a[f][1]) : 3 === a[f].length && (e = a[f][1], d = a[f][2]), c.off(d, e);
      }
    },
    _buildEvents: function _buildEvents() {
      var b = {
        keyup: a.proxy(function (b) {
          a.inArray(b.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1 && this.update();
        }, this),
        keydown: a.proxy(this.keydown, this),
        paste: a.proxy(this.paste, this)
      };
      this.o.showOnFocus === !0 && (b.focus = a.proxy(this.show, this)), this.isInput ? this._events = [[this.element, b]] : this.component && this.inputField.length ? this._events = [[this.inputField, b], [this.component, {
        click: a.proxy(this.show, this)
      }]] : this._events = [[this.element, {
        click: a.proxy(this.show, this),
        keydown: a.proxy(this.keydown, this)
      }]], this._events.push([this.element, "*", {
        blur: a.proxy(function (a) {
          this._focused_from = a.target;
        }, this)
      }], [this.element, {
        blur: a.proxy(function (a) {
          this._focused_from = a.target;
        }, this)
      }]), this.o.immediateUpdates && this._events.push([this.element, {
        "changeYear changeMonth": a.proxy(function (a) {
          this.update(a.date);
        }, this)
      }]), this._secondaryEvents = [[this.picker, {
        click: a.proxy(this.click, this)
      }], [this.picker, ".prev, .next", {
        click: a.proxy(this.navArrowsClick, this)
      }], [this.picker, ".day:not(.disabled)", {
        click: a.proxy(this.dayCellClick, this)
      }], [a(window), {
        resize: a.proxy(this.place, this)
      }], [a(document), {
        "mousedown touchstart": a.proxy(function (a) {
          this.element.is(a.target) || this.element.find(a.target).length || this.picker.is(a.target) || this.picker.find(a.target).length || this.isInline || this.hide();
        }, this)
      }]];
    },
    _attachEvents: function _attachEvents() {
      this._detachEvents(), this._applyEvents(this._events);
    },
    _detachEvents: function _detachEvents() {
      this._unapplyEvents(this._events);
    },
    _attachSecondaryEvents: function _attachSecondaryEvents() {
      this._detachSecondaryEvents(), this._applyEvents(this._secondaryEvents);
    },
    _detachSecondaryEvents: function _detachSecondaryEvents() {
      this._unapplyEvents(this._secondaryEvents);
    },
    _trigger: function _trigger(b, c) {
      var d = c || this.dates.get(-1),
          e = this._utc_to_local(d);

      this.element.trigger({
        type: b,
        date: e,
        viewMode: this.viewMode,
        dates: a.map(this.dates, this._utc_to_local),
        format: a.proxy(function (a, b) {
          0 === arguments.length ? (a = this.dates.length - 1, b = this.o.format) : "string" == typeof a && (b = a, a = this.dates.length - 1), b = b || this.o.format;
          var c = this.dates.get(a);
          return r.formatDate(c, b, this.o.language);
        }, this)
      });
    },
    show: function show() {
      if (!(this.inputField.prop("disabled") || this.inputField.prop("readonly") && this.o.enableOnReadonly === !1)) return this.isInline || this.picker.appendTo(this.o.container), this.place(), this.picker.show(), this._attachSecondaryEvents(), this._trigger("show"), (window.navigator.msMaxTouchPoints || "ontouchstart" in document) && this.o.disableTouchKeyboard && a(this.element).blur(), this;
    },
    hide: function hide() {
      return this.isInline || !this.picker.is(":visible") ? this : (this.focusDate = null, this.picker.hide().detach(), this._detachSecondaryEvents(), this.setViewMode(this.o.startView), this.o.forceParse && this.inputField.val() && this.setValue(), this._trigger("hide"), this);
    },
    destroy: function destroy() {
      return this.hide(), this._detachEvents(), this._detachSecondaryEvents(), this.picker.remove(), delete this.element.data().datepicker, this.isInput || delete this.element.data().date, this;
    },
    paste: function paste(b) {
      var c;
      if (b.originalEvent.clipboardData && b.originalEvent.clipboardData.types && a.inArray("text/plain", b.originalEvent.clipboardData.types) !== -1) c = b.originalEvent.clipboardData.getData("text/plain");else {
        if (!window.clipboardData) return;
        c = window.clipboardData.getData("Text");
      }
      this.setDate(c), this.update(), b.preventDefault();
    },
    _utc_to_local: function _utc_to_local(a) {
      if (!a) return a;
      var b = new Date(a.getTime() + 6e4 * a.getTimezoneOffset());
      return b.getTimezoneOffset() !== a.getTimezoneOffset() && (b = new Date(a.getTime() + 6e4 * b.getTimezoneOffset())), b;
    },
    _local_to_utc: function _local_to_utc(a) {
      return a && new Date(a.getTime() - 6e4 * a.getTimezoneOffset());
    },
    _zero_time: function _zero_time(a) {
      return a && new Date(a.getFullYear(), a.getMonth(), a.getDate());
    },
    _zero_utc_time: function _zero_utc_time(a) {
      return a && c(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate());
    },
    getDates: function getDates() {
      return a.map(this.dates, this._utc_to_local);
    },
    getUTCDates: function getUTCDates() {
      return a.map(this.dates, function (a) {
        return new Date(a);
      });
    },
    getDate: function getDate() {
      return this._utc_to_local(this.getUTCDate());
    },
    getUTCDate: function getUTCDate() {
      var a = this.dates.get(-1);
      return a !== b ? new Date(a) : null;
    },
    clearDates: function clearDates() {
      this.inputField.val(""), this.update(), this._trigger("changeDate"), this.o.autoclose && this.hide();
    },
    setDates: function setDates() {
      var b = a.isArray(arguments[0]) ? arguments[0] : arguments;
      return this.update.apply(this, b), this._trigger("changeDate"), this.setValue(), this;
    },
    setUTCDates: function setUTCDates() {
      var b = a.isArray(arguments[0]) ? arguments[0] : arguments;
      return this.setDates.apply(this, a.map(b, this._utc_to_local)), this;
    },
    setDate: f("setDates"),
    setUTCDate: f("setUTCDates"),
    remove: f("destroy", "Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead"),
    setValue: function setValue() {
      var a = this.getFormattedDate();
      return this.inputField.val(a), this;
    },
    getFormattedDate: function getFormattedDate(c) {
      c === b && (c = this.o.format);
      var d = this.o.language;
      return a.map(this.dates, function (a) {
        return r.formatDate(a, c, d);
      }).join(this.o.multidateSeparator);
    },
    getStartDate: function getStartDate() {
      return this.o.startDate;
    },
    setStartDate: function setStartDate(a) {
      return this._process_options({
        startDate: a
      }), this.update(), this.updateNavArrows(), this;
    },
    getEndDate: function getEndDate() {
      return this.o.endDate;
    },
    setEndDate: function setEndDate(a) {
      return this._process_options({
        endDate: a
      }), this.update(), this.updateNavArrows(), this;
    },
    setDaysOfWeekDisabled: function setDaysOfWeekDisabled(a) {
      return this._process_options({
        daysOfWeekDisabled: a
      }), this.update(), this;
    },
    setDaysOfWeekHighlighted: function setDaysOfWeekHighlighted(a) {
      return this._process_options({
        daysOfWeekHighlighted: a
      }), this.update(), this;
    },
    setDatesDisabled: function setDatesDisabled(a) {
      return this._process_options({
        datesDisabled: a
      }), this.update(), this;
    },
    place: function place() {
      if (this.isInline) return this;
      var b = this.picker.outerWidth(),
          c = this.picker.outerHeight(),
          d = 10,
          e = a(this.o.container),
          f = e.width(),
          g = "body" === this.o.container ? a(document).scrollTop() : e.scrollTop(),
          h = e.offset(),
          i = [0];
      this.element.parents().each(function () {
        var b = a(this).css("z-index");
        "auto" !== b && 0 !== Number(b) && i.push(Number(b));
      });
      var j = Math.max.apply(Math, i) + this.o.zIndexOffset,
          k = this.component ? this.component.parent().offset() : this.element.offset(),
          l = this.component ? this.component.outerHeight(!0) : this.element.outerHeight(!1),
          m = this.component ? this.component.outerWidth(!0) : this.element.outerWidth(!1),
          n = k.left - h.left,
          o = k.top - h.top;
      "body" !== this.o.container && (o += g), this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left"), "auto" !== this.o.orientation.x ? (this.picker.addClass("datepicker-orient-" + this.o.orientation.x), "right" === this.o.orientation.x && (n -= b - m)) : k.left < 0 ? (this.picker.addClass("datepicker-orient-left"), n -= k.left - d) : n + b > f ? (this.picker.addClass("datepicker-orient-right"), n += m - b) : this.o.rtl ? this.picker.addClass("datepicker-orient-right") : this.picker.addClass("datepicker-orient-left");
      var p,
          q = this.o.orientation.y;

      if ("auto" === q && (p = -g + o - c, q = p < 0 ? "bottom" : "top"), this.picker.addClass("datepicker-orient-" + q), "top" === q ? o -= c + parseInt(this.picker.css("padding-top")) : o += l, this.o.rtl) {
        var r = f - (n + m);
        this.picker.css({
          top: o,
          right: r,
          zIndex: j
        });
      } else this.picker.css({
        top: o,
        left: n,
        zIndex: j
      });

      return this;
    },
    _allow_update: !0,
    update: function update() {
      if (!this._allow_update) return this;
      var b = this.dates.copy(),
          c = [],
          d = !1;
      return arguments.length ? (a.each(arguments, a.proxy(function (a, b) {
        b instanceof Date && (b = this._local_to_utc(b)), c.push(b);
      }, this)), d = !0) : (c = this.isInput ? this.element.val() : this.element.data("date") || this.inputField.val(), c = c && this.o.multidate ? c.split(this.o.multidateSeparator) : [c], delete this.element.data().date), c = a.map(c, a.proxy(function (a) {
        return r.parseDate(a, this.o.format, this.o.language, this.o.assumeNearbyYear);
      }, this)), c = a.grep(c, a.proxy(function (a) {
        return !this.dateWithinRange(a) || !a;
      }, this), !0), this.dates.replace(c), this.o.updateViewDate && (this.dates.length ? this.viewDate = new Date(this.dates.get(-1)) : this.viewDate < this.o.startDate ? this.viewDate = new Date(this.o.startDate) : this.viewDate > this.o.endDate ? this.viewDate = new Date(this.o.endDate) : this.viewDate = this.o.defaultViewDate), d ? (this.setValue(), this.element.change()) : this.dates.length && String(b) !== String(this.dates) && d && (this._trigger("changeDate"), this.element.change()), !this.dates.length && b.length && (this._trigger("clearDate"), this.element.change()), this.fill(), this;
    },
    fillDow: function fillDow() {
      if (this.o.showWeekDays) {
        var b = this.o.weekStart,
            c = "<tr>";

        for (this.o.calendarWeeks && (c += '<th class="cw">&#160;</th>'); b < this.o.weekStart + 7;) {
          c += '<th class="dow', a.inArray(b, this.o.daysOfWeekDisabled) !== -1 && (c += " disabled"), c += '">' + q[this.o.language].daysMin[b++ % 7] + "</th>";
        }

        c += "</tr>", this.picker.find(".datepicker-days thead").append(c);
      }
    },
    fillMonths: function fillMonths() {
      for (var a, b = this._utc_to_local(this.viewDate), c = "", d = 0; d < 12; d++) {
        a = b && b.getMonth() === d ? " focused" : "", c += '<span class="month' + a + '">' + q[this.o.language].monthsShort[d] + "</span>";
      }

      this.picker.find(".datepicker-months td").html(c);
    },
    setRange: function setRange(b) {
      b && b.length ? this.range = a.map(b, function (a) {
        return a.valueOf();
      }) : delete this.range, this.fill();
    },
    getClassNames: function getClassNames(b) {
      var c = [],
          f = this.viewDate.getUTCFullYear(),
          g = this.viewDate.getUTCMonth(),
          h = d();
      return b.getUTCFullYear() < f || b.getUTCFullYear() === f && b.getUTCMonth() < g ? c.push("old") : (b.getUTCFullYear() > f || b.getUTCFullYear() === f && b.getUTCMonth() > g) && c.push("new"), this.focusDate && b.valueOf() === this.focusDate.valueOf() && c.push("focused"), this.o.todayHighlight && e(b, h) && c.push("today"), this.dates.contains(b) !== -1 && c.push("active"), this.dateWithinRange(b) || c.push("disabled"), this.dateIsDisabled(b) && c.push("disabled", "disabled-date"), a.inArray(b.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1 && c.push("highlighted"), this.range && (b > this.range[0] && b < this.range[this.range.length - 1] && c.push("range"), a.inArray(b.valueOf(), this.range) !== -1 && c.push("selected"), b.valueOf() === this.range[0] && c.push("range-start"), b.valueOf() === this.range[this.range.length - 1] && c.push("range-end")), c;
    },
    _fill_yearsView: function _fill_yearsView(c, d, e, f, g, h, i) {
      for (var j, k, l, m = "", n = e / 10, o = this.picker.find(c), p = Math.floor(f / e) * e, q = p + 9 * n, r = Math.floor(this.viewDate.getFullYear() / n) * n, s = a.map(this.dates, function (a) {
        return Math.floor(a.getUTCFullYear() / n) * n;
      }), t = p - n; t <= q + n; t += n) {
        j = [d], k = null, t === p - n ? j.push("old") : t === q + n && j.push("new"), a.inArray(t, s) !== -1 && j.push("active"), (t < g || t > h) && j.push("disabled"), t === r && j.push("focused"), i !== a.noop && (l = i(new Date(t, 0, 1)), l === b ? l = {} : "boolean" == typeof l ? l = {
          enabled: l
        } : "string" == typeof l && (l = {
          classes: l
        }), l.enabled === !1 && j.push("disabled"), l.classes && (j = j.concat(l.classes.split(/\s+/))), l.tooltip && (k = l.tooltip)), m += '<span class="' + j.join(" ") + '"' + (k ? ' title="' + k + '"' : "") + ">" + t + "</span>";
      }

      o.find(".datepicker-switch").text(p + "-" + q), o.find("td").html(m);
    },
    fill: function fill() {
      var d,
          e,
          f = new Date(this.viewDate),
          g = f.getUTCFullYear(),
          h = f.getUTCMonth(),
          i = this.o.startDate !== -(1 / 0) ? this.o.startDate.getUTCFullYear() : -(1 / 0),
          j = this.o.startDate !== -(1 / 0) ? this.o.startDate.getUTCMonth() : -(1 / 0),
          k = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCFullYear() : 1 / 0,
          l = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCMonth() : 1 / 0,
          m = q[this.o.language].today || q.en.today || "",
          n = q[this.o.language].clear || q.en.clear || "",
          o = q[this.o.language].titleFormat || q.en.titleFormat;

      if (!isNaN(g) && !isNaN(h)) {
        this.picker.find(".datepicker-days .datepicker-switch").text(r.formatDate(f, o, this.o.language)), this.picker.find("tfoot .today").text(m).css("display", this.o.todayBtn === !0 || "linked" === this.o.todayBtn ? "table-cell" : "none"), this.picker.find("tfoot .clear").text(n).css("display", this.o.clearBtn === !0 ? "table-cell" : "none"), this.picker.find("thead .datepicker-title").text(this.o.title).css("display", "string" == typeof this.o.title && "" !== this.o.title ? "table-cell" : "none"), this.updateNavArrows(), this.fillMonths();
        var p = c(g, h, 0),
            s = p.getUTCDate();
        p.setUTCDate(s - (p.getUTCDay() - this.o.weekStart + 7) % 7);
        var t = new Date(p);
        p.getUTCFullYear() < 100 && t.setUTCFullYear(p.getUTCFullYear()), t.setUTCDate(t.getUTCDate() + 42), t = t.valueOf();

        for (var u, v, w = []; p.valueOf() < t;) {
          if (u = p.getUTCDay(), u === this.o.weekStart && (w.push("<tr>"), this.o.calendarWeeks)) {
            var x = new Date(+p + (this.o.weekStart - u - 7) % 7 * 864e5),
                y = new Date(Number(x) + (11 - x.getUTCDay()) % 7 * 864e5),
                z = new Date(Number(z = c(y.getUTCFullYear(), 0, 1)) + (11 - z.getUTCDay()) % 7 * 864e5),
                A = (y - z) / 864e5 / 7 + 1;
            w.push('<td class="cw">' + A + "</td>");
          }

          v = this.getClassNames(p), v.push("day");
          var B = p.getUTCDate();
          this.o.beforeShowDay !== a.noop && (e = this.o.beforeShowDay(this._utc_to_local(p)), e === b ? e = {} : "boolean" == typeof e ? e = {
            enabled: e
          } : "string" == typeof e && (e = {
            classes: e
          }), e.enabled === !1 && v.push("disabled"), e.classes && (v = v.concat(e.classes.split(/\s+/))), e.tooltip && (d = e.tooltip), e.content && (B = e.content)), v = a.isFunction(a.uniqueSort) ? a.uniqueSort(v) : a.unique(v), w.push('<td class="' + v.join(" ") + '"' + (d ? ' title="' + d + '"' : "") + ' data-date="' + p.getTime().toString() + '">' + B + "</td>"), d = null, u === this.o.weekEnd && w.push("</tr>"), p.setUTCDate(p.getUTCDate() + 1);
        }

        this.picker.find(".datepicker-days tbody").html(w.join(""));
        var C = q[this.o.language].monthsTitle || q.en.monthsTitle || "Months",
            D = this.picker.find(".datepicker-months").find(".datepicker-switch").text(this.o.maxViewMode < 2 ? C : g).end().find("tbody span").removeClass("active");

        if (a.each(this.dates, function (a, b) {
          b.getUTCFullYear() === g && D.eq(b.getUTCMonth()).addClass("active");
        }), (g < i || g > k) && D.addClass("disabled"), g === i && D.slice(0, j).addClass("disabled"), g === k && D.slice(l + 1).addClass("disabled"), this.o.beforeShowMonth !== a.noop) {
          var E = this;
          a.each(D, function (c, d) {
            var e = new Date(g, c, 1),
                f = E.o.beforeShowMonth(e);
            f === b ? f = {} : "boolean" == typeof f ? f = {
              enabled: f
            } : "string" == typeof f && (f = {
              classes: f
            }), f.enabled !== !1 || a(d).hasClass("disabled") || a(d).addClass("disabled"), f.classes && a(d).addClass(f.classes), f.tooltip && a(d).prop("title", f.tooltip);
          });
        }

        this._fill_yearsView(".datepicker-years", "year", 10, g, i, k, this.o.beforeShowYear), this._fill_yearsView(".datepicker-decades", "decade", 100, g, i, k, this.o.beforeShowDecade), this._fill_yearsView(".datepicker-centuries", "century", 1e3, g, i, k, this.o.beforeShowCentury);
      }
    },
    updateNavArrows: function updateNavArrows() {
      if (this._allow_update) {
        var a,
            b,
            c = new Date(this.viewDate),
            d = c.getUTCFullYear(),
            e = c.getUTCMonth(),
            f = this.o.startDate !== -(1 / 0) ? this.o.startDate.getUTCFullYear() : -(1 / 0),
            g = this.o.startDate !== -(1 / 0) ? this.o.startDate.getUTCMonth() : -(1 / 0),
            h = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCFullYear() : 1 / 0,
            i = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCMonth() : 1 / 0,
            j = 1;

        switch (this.viewMode) {
          case 4:
            j *= 10;

          case 3:
            j *= 10;

          case 2:
            j *= 10;

          case 1:
            a = Math.floor(d / j) * j < f, b = Math.floor(d / j) * j + j > h;
            break;

          case 0:
            a = d <= f && e < g, b = d >= h && e > i;
        }

        this.picker.find(".prev").toggleClass("disabled", a), this.picker.find(".next").toggleClass("disabled", b);
      }
    },
    click: function click(b) {
      b.preventDefault(), b.stopPropagation();
      var e, f, g, h;
      e = a(b.target), e.hasClass("datepicker-switch") && this.viewMode !== this.o.maxViewMode && this.setViewMode(this.viewMode + 1), e.hasClass("today") && !e.hasClass("day") && (this.setViewMode(0), this._setDate(d(), "linked" === this.o.todayBtn ? null : "view")), e.hasClass("clear") && this.clearDates(), e.hasClass("disabled") || (e.hasClass("month") || e.hasClass("year") || e.hasClass("decade") || e.hasClass("century")) && (this.viewDate.setUTCDate(1), f = 1, 1 === this.viewMode ? (h = e.parent().find("span").index(e), g = this.viewDate.getUTCFullYear(), this.viewDate.setUTCMonth(h)) : (h = 0, g = Number(e.text()), this.viewDate.setUTCFullYear(g)), this._trigger(r.viewModes[this.viewMode - 1].e, this.viewDate), this.viewMode === this.o.minViewMode ? this._setDate(c(g, h, f)) : (this.setViewMode(this.viewMode - 1), this.fill())), this.picker.is(":visible") && this._focused_from && this._focused_from.focus(), delete this._focused_from;
    },
    dayCellClick: function dayCellClick(b) {
      var c = a(b.currentTarget),
          d = c.data("date"),
          e = new Date(d);
      this.o.updateViewDate && (e.getUTCFullYear() !== this.viewDate.getUTCFullYear() && this._trigger("changeYear", this.viewDate), e.getUTCMonth() !== this.viewDate.getUTCMonth() && this._trigger("changeMonth", this.viewDate)), this._setDate(e);
    },
    navArrowsClick: function navArrowsClick(b) {
      var c = a(b.currentTarget),
          d = c.hasClass("prev") ? -1 : 1;
      0 !== this.viewMode && (d *= 12 * r.viewModes[this.viewMode].navStep), this.viewDate = this.moveMonth(this.viewDate, d), this._trigger(r.viewModes[this.viewMode].e, this.viewDate), this.fill();
    },
    _toggle_multidate: function _toggle_multidate(a) {
      var b = this.dates.contains(a);
      if (a || this.dates.clear(), b !== -1 ? (this.o.multidate === !0 || this.o.multidate > 1 || this.o.toggleActive) && this.dates.remove(b) : this.o.multidate === !1 ? (this.dates.clear(), this.dates.push(a)) : this.dates.push(a), "number" == typeof this.o.multidate) for (; this.dates.length > this.o.multidate;) {
        this.dates.remove(0);
      }
    },
    _setDate: function _setDate(a, b) {
      b && "date" !== b || this._toggle_multidate(a && new Date(a)), (!b && this.o.updateViewDate || "view" === b) && (this.viewDate = a && new Date(a)), this.fill(), this.setValue(), b && "view" === b || this._trigger("changeDate"), this.inputField.trigger("change"), !this.o.autoclose || b && "date" !== b || this.hide();
    },
    moveDay: function moveDay(a, b) {
      var c = new Date(a);
      return c.setUTCDate(a.getUTCDate() + b), c;
    },
    moveWeek: function moveWeek(a, b) {
      return this.moveDay(a, 7 * b);
    },
    moveMonth: function moveMonth(a, b) {
      if (!g(a)) return this.o.defaultViewDate;
      if (!b) return a;
      var c,
          d,
          e = new Date(a.valueOf()),
          f = e.getUTCDate(),
          h = e.getUTCMonth(),
          i = Math.abs(b);
      if (b = b > 0 ? 1 : -1, 1 === i) d = b === -1 ? function () {
        return e.getUTCMonth() === h;
      } : function () {
        return e.getUTCMonth() !== c;
      }, c = h + b, e.setUTCMonth(c), c = (c + 12) % 12;else {
        for (var j = 0; j < i; j++) {
          e = this.moveMonth(e, b);
        }

        c = e.getUTCMonth(), e.setUTCDate(f), d = function d() {
          return c !== e.getUTCMonth();
        };
      }

      for (; d();) {
        e.setUTCDate(--f), e.setUTCMonth(c);
      }

      return e;
    },
    moveYear: function moveYear(a, b) {
      return this.moveMonth(a, 12 * b);
    },
    moveAvailableDate: function moveAvailableDate(a, b, c) {
      do {
        if (a = this[c](a, b), !this.dateWithinRange(a)) return !1;
        c = "moveDay";
      } while (this.dateIsDisabled(a));

      return a;
    },
    weekOfDateIsDisabled: function weekOfDateIsDisabled(b) {
      return a.inArray(b.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
    },
    dateIsDisabled: function dateIsDisabled(b) {
      return this.weekOfDateIsDisabled(b) || a.grep(this.o.datesDisabled, function (a) {
        return e(b, a);
      }).length > 0;
    },
    dateWithinRange: function dateWithinRange(a) {
      return a >= this.o.startDate && a <= this.o.endDate;
    },
    keydown: function keydown(a) {
      if (!this.picker.is(":visible")) return void (40 !== a.keyCode && 27 !== a.keyCode || (this.show(), a.stopPropagation()));
      var b,
          c,
          d = !1,
          e = this.focusDate || this.viewDate;

      switch (a.keyCode) {
        case 27:
          this.focusDate ? (this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.fill()) : this.hide(), a.preventDefault(), a.stopPropagation();
          break;

        case 37:
        case 38:
        case 39:
        case 40:
          if (!this.o.keyboardNavigation || 7 === this.o.daysOfWeekDisabled.length) break;
          b = 37 === a.keyCode || 38 === a.keyCode ? -1 : 1, 0 === this.viewMode ? a.ctrlKey ? (c = this.moveAvailableDate(e, b, "moveYear"), c && this._trigger("changeYear", this.viewDate)) : a.shiftKey ? (c = this.moveAvailableDate(e, b, "moveMonth"), c && this._trigger("changeMonth", this.viewDate)) : 37 === a.keyCode || 39 === a.keyCode ? c = this.moveAvailableDate(e, b, "moveDay") : this.weekOfDateIsDisabled(e) || (c = this.moveAvailableDate(e, b, "moveWeek")) : 1 === this.viewMode ? (38 !== a.keyCode && 40 !== a.keyCode || (b *= 4), c = this.moveAvailableDate(e, b, "moveMonth")) : 2 === this.viewMode && (38 !== a.keyCode && 40 !== a.keyCode || (b *= 4), c = this.moveAvailableDate(e, b, "moveYear")), c && (this.focusDate = this.viewDate = c, this.setValue(), this.fill(), a.preventDefault());
          break;

        case 13:
          if (!this.o.forceParse) break;
          e = this.focusDate || this.dates.get(-1) || this.viewDate, this.o.keyboardNavigation && (this._toggle_multidate(e), d = !0), this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.setValue(), this.fill(), this.picker.is(":visible") && (a.preventDefault(), a.stopPropagation(), this.o.autoclose && this.hide());
          break;

        case 9:
          this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.fill(), this.hide();
      }

      d && (this.dates.length ? this._trigger("changeDate") : this._trigger("clearDate"), this.inputField.trigger("change"));
    },
    setViewMode: function setViewMode(a) {
      this.viewMode = a, this.picker.children("div").hide().filter(".datepicker-" + r.viewModes[this.viewMode].clsName).show(), this.updateNavArrows(), this._trigger("changeViewMode", new Date(this.viewDate));
    }
  };

  var l = function l(b, c) {
    a.data(b, "datepicker", this), this.element = a(b), this.inputs = a.map(c.inputs, function (a) {
      return a.jquery ? a[0] : a;
    }), delete c.inputs, this.keepEmptyValues = c.keepEmptyValues, delete c.keepEmptyValues, n.call(a(this.inputs), c).on("changeDate", a.proxy(this.dateUpdated, this)), this.pickers = a.map(this.inputs, function (b) {
      return a.data(b, "datepicker");
    }), this.updateDates();
  };

  l.prototype = {
    updateDates: function updateDates() {
      this.dates = a.map(this.pickers, function (a) {
        return a.getUTCDate();
      }), this.updateRanges();
    },
    updateRanges: function updateRanges() {
      var b = a.map(this.dates, function (a) {
        return a.valueOf();
      });
      a.each(this.pickers, function (a, c) {
        c.setRange(b);
      });
    },
    clearDates: function clearDates() {
      a.each(this.pickers, function (a, b) {
        b.clearDates();
      });
    },
    dateUpdated: function dateUpdated(c) {
      if (!this.updating) {
        this.updating = !0;
        var d = a.data(c.target, "datepicker");

        if (d !== b) {
          var e = d.getUTCDate(),
              f = this.keepEmptyValues,
              g = a.inArray(c.target, this.inputs),
              h = g - 1,
              i = g + 1,
              j = this.inputs.length;

          if (g !== -1) {
            if (a.each(this.pickers, function (a, b) {
              b.getUTCDate() || b !== d && f || b.setUTCDate(e);
            }), e < this.dates[h]) for (; h >= 0 && e < this.dates[h];) {
              this.pickers[h--].setUTCDate(e);
            } else if (e > this.dates[i]) for (; i < j && e > this.dates[i];) {
              this.pickers[i++].setUTCDate(e);
            }
            this.updateDates(), delete this.updating;
          }
        }
      }
    },
    destroy: function destroy() {
      a.map(this.pickers, function (a) {
        a.destroy();
      }), a(this.inputs).off("changeDate", this.dateUpdated), delete this.element.data().datepicker;
    },
    remove: f("destroy", "Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead")
  };

  var m = a.fn.datepicker,
      n = function n(c) {
    var d = Array.apply(null, arguments);
    d.shift();
    var e;
    if (this.each(function () {
      var b = a(this),
          f = b.data("datepicker"),
          g = "object" == _typeof2(c) && c;

      if (!f) {
        var j = h(this, "date"),
            m = a.extend({}, o, j, g),
            n = i(m.language),
            p = a.extend({}, o, n, j, g);
        b.hasClass("input-daterange") || p.inputs ? (a.extend(p, {
          inputs: p.inputs || b.find("input").toArray()
        }), f = new l(this, p)) : f = new k(this, p), b.data("datepicker", f);
      }

      "string" == typeof c && "function" == typeof f[c] && (e = f[c].apply(f, d));
    }), e === b || e instanceof k || e instanceof l) return this;
    if (this.length > 1) throw new Error("Using only allowed for the collection of a single element (" + c + " function)");
    return e;
  };

  a.fn.datepicker = n;
  var o = a.fn.datepicker.defaults = {
    assumeNearbyYear: !1,
    autoclose: !1,
    beforeShowDay: a.noop,
    beforeShowMonth: a.noop,
    beforeShowYear: a.noop,
    beforeShowDecade: a.noop,
    beforeShowCentury: a.noop,
    calendarWeeks: !1,
    clearBtn: !1,
    toggleActive: !1,
    daysOfWeekDisabled: [],
    daysOfWeekHighlighted: [],
    datesDisabled: [],
    endDate: 1 / 0,
    forceParse: !0,
    format: "mm/dd/yyyy",
    keepEmptyValues: !1,
    keyboardNavigation: !0,
    language: "en",
    minViewMode: 0,
    maxViewMode: 4,
    multidate: !1,
    multidateSeparator: ",",
    orientation: "auto",
    rtl: !1,
    startDate: -(1 / 0),
    startView: 0,
    todayBtn: !1,
    todayHighlight: !1,
    updateViewDate: !0,
    weekStart: 0,
    disableTouchKeyboard: !1,
    enableOnReadonly: !0,
    showOnFocus: !0,
    zIndexOffset: 10,
    container: "body",
    immediateUpdates: !1,
    title: "",
    templates: {
      leftArrow: "&#x00AB;",
      rightArrow: "&#x00BB;"
    },
    showWeekDays: !0
  },
      p = a.fn.datepicker.locale_opts = ["format", "rtl", "weekStart"];
  a.fn.datepicker.Constructor = k;
  var q = a.fn.datepicker.dates = {
    en: {
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      today: "Today",
      clear: "Clear",
      titleFormat: "MM yyyy"
    }
  },
      r = {
    viewModes: [{
      names: ["days", "month"],
      clsName: "days",
      e: "changeMonth"
    }, {
      names: ["months", "year"],
      clsName: "months",
      e: "changeYear",
      navStep: 1
    }, {
      names: ["years", "decade"],
      clsName: "years",
      e: "changeDecade",
      navStep: 10
    }, {
      names: ["decades", "century"],
      clsName: "decades",
      e: "changeCentury",
      navStep: 100
    }, {
      names: ["centuries", "millennium"],
      clsName: "centuries",
      e: "changeMillennium",
      navStep: 1e3
    }],
    validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
    nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
    parseFormat: function parseFormat(a) {
      if ("function" == typeof a.toValue && "function" == typeof a.toDisplay) return a;
      var b = a.replace(this.validParts, "\0").split("\0"),
          c = a.match(this.validParts);
      if (!b || !b.length || !c || 0 === c.length) throw new Error("Invalid date format.");
      return {
        separators: b,
        parts: c
      };
    },
    parseDate: function parseDate(c, e, f, g) {
      function h(a, b) {
        return b === !0 && (b = 10), a < 100 && (a += 2e3, a > new Date().getFullYear() + b && (a -= 100)), a;
      }

      function i() {
        var a = this.slice(0, j[n].length),
            b = j[n].slice(0, a.length);
        return a.toLowerCase() === b.toLowerCase();
      }

      if (!c) return b;
      if (c instanceof Date) return c;
      if ("string" == typeof e && (e = r.parseFormat(e)), e.toValue) return e.toValue(c, e, f);
      var j,
          l,
          m,
          n,
          o,
          p = {
        d: "moveDay",
        m: "moveMonth",
        w: "moveWeek",
        y: "moveYear"
      },
          s = {
        yesterday: "-1d",
        today: "+0d",
        tomorrow: "+1d"
      };

      if (c in s && (c = s[c]), /^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/i.test(c)) {
        for (j = c.match(/([\-+]\d+)([dmwy])/gi), c = new Date(), n = 0; n < j.length; n++) {
          l = j[n].match(/([\-+]\d+)([dmwy])/i), m = Number(l[1]), o = p[l[2].toLowerCase()], c = k.prototype[o](c, m);
        }

        return k.prototype._zero_utc_time(c);
      }

      j = c && c.match(this.nonpunctuation) || [];
      var t,
          u,
          v = {},
          w = ["yyyy", "yy", "M", "MM", "m", "mm", "d", "dd"],
          x = {
        yyyy: function yyyy(a, b) {
          return a.setUTCFullYear(g ? h(b, g) : b);
        },
        m: function m(a, b) {
          if (isNaN(a)) return a;

          for (b -= 1; b < 0;) {
            b += 12;
          }

          for (b %= 12, a.setUTCMonth(b); a.getUTCMonth() !== b;) {
            a.setUTCDate(a.getUTCDate() - 1);
          }

          return a;
        },
        d: function d(a, b) {
          return a.setUTCDate(b);
        }
      };
      x.yy = x.yyyy, x.M = x.MM = x.mm = x.m, x.dd = x.d, c = d();
      var y = e.parts.slice();

      if (j.length !== y.length && (y = a(y).filter(function (b, c) {
        return a.inArray(c, w) !== -1;
      }).toArray()), j.length === y.length) {
        var z;

        for (n = 0, z = y.length; n < z; n++) {
          if (t = parseInt(j[n], 10), l = y[n], isNaN(t)) switch (l) {
            case "MM":
              u = a(q[f].months).filter(i), t = a.inArray(u[0], q[f].months) + 1;
              break;

            case "M":
              u = a(q[f].monthsShort).filter(i), t = a.inArray(u[0], q[f].monthsShort) + 1;
          }
          v[l] = t;
        }

        var A, B;

        for (n = 0; n < w.length; n++) {
          B = w[n], B in v && !isNaN(v[B]) && (A = new Date(c), x[B](A, v[B]), isNaN(A) || (c = A));
        }
      }

      return c;
    },
    formatDate: function formatDate(b, c, d) {
      if (!b) return "";
      if ("string" == typeof c && (c = r.parseFormat(c)), c.toDisplay) return c.toDisplay(b, c, d);
      var e = {
        d: b.getUTCDate(),
        D: q[d].daysShort[b.getUTCDay()],
        DD: q[d].days[b.getUTCDay()],
        m: b.getUTCMonth() + 1,
        M: q[d].monthsShort[b.getUTCMonth()],
        MM: q[d].months[b.getUTCMonth()],
        yy: b.getUTCFullYear().toString().substring(2),
        yyyy: b.getUTCFullYear()
      };
      e.dd = (e.d < 10 ? "0" : "") + e.d, e.mm = (e.m < 10 ? "0" : "") + e.m, b = [];

      for (var f = a.extend([], c.separators), g = 0, h = c.parts.length; g <= h; g++) {
        f.length && b.push(f.shift()), b.push(e[c.parts[g]]);
      }

      return b.join("");
    },
    headTemplate: '<thead><tr><th colspan="7" class="datepicker-title"></th></tr><tr><th class="prev">' + o.templates.leftArrow + '</th><th colspan="5" class="datepicker-switch"></th><th class="next">' + o.templates.rightArrow + "</th></tr></thead>",
    contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
    footTemplate: '<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'
  };
  r.template = '<div class="datepicker"><div class="datepicker-days"><table class="table-condensed">' + r.headTemplate + "<tbody></tbody>" + r.footTemplate + '</table></div><div class="datepicker-months"><table class="table-condensed">' + r.headTemplate + r.contTemplate + r.footTemplate + '</table></div><div class="datepicker-years"><table class="table-condensed">' + r.headTemplate + r.contTemplate + r.footTemplate + '</table></div><div class="datepicker-decades"><table class="table-condensed">' + r.headTemplate + r.contTemplate + r.footTemplate + '</table></div><div class="datepicker-centuries"><table class="table-condensed">' + r.headTemplate + r.contTemplate + r.footTemplate + "</table></div></div>", a.fn.datepicker.DPGlobal = r, a.fn.datepicker.noConflict = function () {
    return a.fn.datepicker = m, this;
  }, a.fn.datepicker.version = "1.8.0", a.fn.datepicker.deprecated = function (a) {
    var b = window.console;
    b && b.warn && b.warn("DEPRECATED: " + a);
  }, a(document).on("focus.datepicker.data-api click.datepicker.data-api", '[data-provide="datepicker"]', function (b) {
    var c = a(this);
    c.data("datepicker") || (b.preventDefault(), n.call(c, "show"));
  }), a(function () {
    n.call(a('[data-provide="datepicker-inline"]'));
  });
});
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.moment = t();
}(this, function () {
  "use strict";

  var e, i;

  function c() {
    return e.apply(null, arguments);
  }

  function o(e) {
    return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
  }

  function u(e) {
    return null != e && "[object Object]" === Object.prototype.toString.call(e);
  }

  function l(e) {
    return void 0 === e;
  }

  function d(e) {
    return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
  }

  function h(e) {
    return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
  }

  function f(e, t) {
    var n,
        s = [];

    for (n = 0; n < e.length; ++n) {
      s.push(t(e[n], n));
    }

    return s;
  }

  function m(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }

  function _(e, t) {
    for (var n in t) {
      m(t, n) && (e[n] = t[n]);
    }

    return m(t, "toString") && (e.toString = t.toString), m(t, "valueOf") && (e.valueOf = t.valueOf), e;
  }

  function y(e, t, n, s) {
    return Ot(e, t, n, s, !0).utc();
  }

  function g(e) {
    return null == e._pf && (e._pf = {
      empty: !1,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: !1,
      invalidMonth: null,
      invalidFormat: !1,
      userInvalidated: !1,
      iso: !1,
      parsedDateParts: [],
      meridiem: null,
      rfc2822: !1,
      weekdayMismatch: !1
    }), e._pf;
  }

  function p(e) {
    if (null == e._isValid) {
      var t = g(e),
          n = i.call(t.parsedDateParts, function (e) {
        return null != e;
      }),
          s = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
      if (e._strict && (s = s && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour), null != Object.isFrozen && Object.isFrozen(e)) return s;
      e._isValid = s;
    }

    return e._isValid;
  }

  function v(e) {
    var t = y(NaN);
    return null != e ? _(g(t), e) : g(t).userInvalidated = !0, t;
  }

  i = Array.prototype.some ? Array.prototype.some : function (e) {
    for (var t = Object(this), n = t.length >>> 0, s = 0; s < n; s++) {
      if (s in t && e.call(this, t[s], s, t)) return !0;
    }

    return !1;
  };
  var r = c.momentProperties = [];

  function w(e, t) {
    var n, s, i;
    if (l(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), l(t._i) || (e._i = t._i), l(t._f) || (e._f = t._f), l(t._l) || (e._l = t._l), l(t._strict) || (e._strict = t._strict), l(t._tzm) || (e._tzm = t._tzm), l(t._isUTC) || (e._isUTC = t._isUTC), l(t._offset) || (e._offset = t._offset), l(t._pf) || (e._pf = g(t)), l(t._locale) || (e._locale = t._locale), 0 < r.length) for (n = 0; n < r.length; n++) {
      l(i = t[s = r[n]]) || (e[s] = i);
    }
    return e;
  }

  var t = !1;

  function M(e) {
    w(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === t && (t = !0, c.updateOffset(this), t = !1);
  }

  function S(e) {
    return e instanceof M || null != e && null != e._isAMomentObject;
  }

  function D(e) {
    return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
  }

  function k(e) {
    var t = +e,
        n = 0;
    return 0 !== t && isFinite(t) && (n = D(t)), n;
  }

  function a(e, t, n) {
    var s,
        i = Math.min(e.length, t.length),
        r = Math.abs(e.length - t.length),
        a = 0;

    for (s = 0; s < i; s++) {
      (n && e[s] !== t[s] || !n && k(e[s]) !== k(t[s])) && a++;
    }

    return a + r;
  }

  function Y(e) {
    !1 === c.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
  }

  function n(i, r) {
    var a = !0;
    return _(function () {
      if (null != c.deprecationHandler && c.deprecationHandler(null, i), a) {
        for (var e, t = [], n = 0; n < arguments.length; n++) {
          if (e = "", "object" == _typeof2(arguments[n])) {
            for (var s in e += "\n[" + n + "] ", arguments[0]) {
              e += s + ": " + arguments[0][s] + ", ";
            }

            e = e.slice(0, -2);
          } else e = arguments[n];

          t.push(e);
        }

        Y(i + "\nArguments: " + Array.prototype.slice.call(t).join("") + "\n" + new Error().stack), a = !1;
      }

      return r.apply(this, arguments);
    }, r);
  }

  var s,
      O = {};

  function T(e, t) {
    null != c.deprecationHandler && c.deprecationHandler(e, t), O[e] || (Y(t), O[e] = !0);
  }

  function x(e) {
    return e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
  }

  function b(e, t) {
    var n,
        s = _({}, e);

    for (n in t) {
      m(t, n) && (u(e[n]) && u(t[n]) ? (s[n] = {}, _(s[n], e[n]), _(s[n], t[n])) : null != t[n] ? s[n] = t[n] : delete s[n]);
    }

    for (n in e) {
      m(e, n) && !m(t, n) && u(e[n]) && (s[n] = _({}, s[n]));
    }

    return s;
  }

  function P(e) {
    null != e && this.set(e);
  }

  c.suppressDeprecationWarnings = !1, c.deprecationHandler = null, s = Object.keys ? Object.keys : function (e) {
    var t,
        n = [];

    for (t in e) {
      m(e, t) && n.push(t);
    }

    return n;
  };
  var W = {};

  function H(e, t) {
    var n = e.toLowerCase();
    W[n] = W[n + "s"] = W[t] = e;
  }

  function R(e) {
    return "string" == typeof e ? W[e] || W[e.toLowerCase()] : void 0;
  }

  function C(e) {
    var t,
        n,
        s = {};

    for (n in e) {
      m(e, n) && (t = R(n)) && (s[t] = e[n]);
    }

    return s;
  }

  var F = {};

  function L(e, t) {
    F[e] = t;
  }

  function U(e, t, n) {
    var s = "" + Math.abs(e),
        i = t - s.length;
    return (0 <= e ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + s;
  }

  var N = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      G = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      V = {},
      E = {};

  function I(e, t, n, s) {
    var i = s;
    "string" == typeof s && (i = function i() {
      return this[s]();
    }), e && (E[e] = i), t && (E[t[0]] = function () {
      return U(i.apply(this, arguments), t[1], t[2]);
    }), n && (E[n] = function () {
      return this.localeData().ordinal(i.apply(this, arguments), e);
    });
  }

  function A(e, t) {
    return e.isValid() ? (t = j(t, e.localeData()), V[t] = V[t] || function (s) {
      var e,
          i,
          t,
          r = s.match(N);

      for (e = 0, i = r.length; e < i; e++) {
        E[r[e]] ? r[e] = E[r[e]] : r[e] = (t = r[e]).match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "");
      }

      return function (e) {
        var t,
            n = "";

        for (t = 0; t < i; t++) {
          n += x(r[t]) ? r[t].call(e, s) : r[t];
        }

        return n;
      };
    }(t), V[t](e)) : e.localeData().invalidDate();
  }

  function j(e, t) {
    var n = 5;

    function s(e) {
      return t.longDateFormat(e) || e;
    }

    for (G.lastIndex = 0; 0 <= n && G.test(e);) {
      e = e.replace(G, s), G.lastIndex = 0, n -= 1;
    }

    return e;
  }

  var Z = /\d/,
      z = /\d\d/,
      $ = /\d{3}/,
      q = /\d{4}/,
      J = /[+-]?\d{6}/,
      B = /\d\d?/,
      Q = /\d\d\d\d?/,
      X = /\d\d\d\d\d\d?/,
      K = /\d{1,3}/,
      ee = /\d{1,4}/,
      te = /[+-]?\d{1,6}/,
      ne = /\d+/,
      se = /[+-]?\d+/,
      ie = /Z|[+-]\d\d:?\d\d/gi,
      re = /Z|[+-]\d\d(?::?\d\d)?/gi,
      ae = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      oe = {};

  function ue(e, n, s) {
    oe[e] = x(n) ? n : function (e, t) {
      return e && s ? s : n;
    };
  }

  function le(e, t) {
    return m(oe, e) ? oe[e](t._strict, t._locale) : new RegExp(de(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, n, s, i) {
      return t || n || s || i;
    })));
  }

  function de(e) {
    return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  }

  var he = {};

  function ce(e, n) {
    var t,
        s = n;

    for ("string" == typeof e && (e = [e]), d(n) && (s = function s(e, t) {
      t[n] = k(e);
    }), t = 0; t < e.length; t++) {
      he[e[t]] = s;
    }
  }

  function fe(e, i) {
    ce(e, function (e, t, n, s) {
      n._w = n._w || {}, i(e, n._w, n, s);
    });
  }

  var me = 0,
      _e = 1,
      ye = 2,
      ge = 3,
      pe = 4,
      ve = 5,
      we = 6,
      Me = 7,
      Se = 8;

  function De(e) {
    return ke(e) ? 366 : 365;
  }

  function ke(e) {
    return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
  }

  I("Y", 0, 0, function () {
    var e = this.year();
    return e <= 9999 ? "" + e : "+" + e;
  }), I(0, ["YY", 2], 0, function () {
    return this.year() % 100;
  }), I(0, ["YYYY", 4], 0, "year"), I(0, ["YYYYY", 5], 0, "year"), I(0, ["YYYYYY", 6, !0], 0, "year"), H("year", "y"), L("year", 1), ue("Y", se), ue("YY", B, z), ue("YYYY", ee, q), ue("YYYYY", te, J), ue("YYYYYY", te, J), ce(["YYYYY", "YYYYYY"], me), ce("YYYY", function (e, t) {
    t[me] = 2 === e.length ? c.parseTwoDigitYear(e) : k(e);
  }), ce("YY", function (e, t) {
    t[me] = c.parseTwoDigitYear(e);
  }), ce("Y", function (e, t) {
    t[me] = parseInt(e, 10);
  }), c.parseTwoDigitYear = function (e) {
    return k(e) + (68 < k(e) ? 1900 : 2e3);
  };
  var Ye,
      Oe = Te("FullYear", !0);

  function Te(t, n) {
    return function (e) {
      return null != e ? (be(this, t, e), c.updateOffset(this, n), this) : xe(this, t);
    };
  }

  function xe(e, t) {
    return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
  }

  function be(e, t, n) {
    e.isValid() && !isNaN(n) && ("FullYear" === t && ke(e.year()) && 1 === e.month() && 29 === e.date() ? e._d["set" + (e._isUTC ? "UTC" : "") + t](n, e.month(), Pe(n, e.month())) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
  }

  function Pe(e, t) {
    if (isNaN(e) || isNaN(t)) return NaN;
    var n,
        s = (t % (n = 12) + n) % n;
    return e += (t - s) / 12, 1 === s ? ke(e) ? 29 : 28 : 31 - s % 7 % 2;
  }

  Ye = Array.prototype.indexOf ? Array.prototype.indexOf : function (e) {
    var t;

    for (t = 0; t < this.length; ++t) {
      if (this[t] === e) return t;
    }

    return -1;
  }, I("M", ["MM", 2], "Mo", function () {
    return this.month() + 1;
  }), I("MMM", 0, 0, function (e) {
    return this.localeData().monthsShort(this, e);
  }), I("MMMM", 0, 0, function (e) {
    return this.localeData().months(this, e);
  }), H("month", "M"), L("month", 8), ue("M", B), ue("MM", B, z), ue("MMM", function (e, t) {
    return t.monthsShortRegex(e);
  }), ue("MMMM", function (e, t) {
    return t.monthsRegex(e);
  }), ce(["M", "MM"], function (e, t) {
    t[_e] = k(e) - 1;
  }), ce(["MMM", "MMMM"], function (e, t, n, s) {
    var i = n._locale.monthsParse(e, s, n._strict);

    null != i ? t[_e] = i : g(n).invalidMonth = e;
  });
  var We = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      He = "January_February_March_April_May_June_July_August_September_October_November_December".split("_");
  var Re = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");

  function Ce(e, t) {
    var n;
    if (!e.isValid()) return e;
    if ("string" == typeof t) if (/^\d+$/.test(t)) t = k(t);else if (!d(t = e.localeData().monthsParse(t))) return e;
    return n = Math.min(e.date(), Pe(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
  }

  function Fe(e) {
    return null != e ? (Ce(this, e), c.updateOffset(this, !0), this) : xe(this, "Month");
  }

  var Le = ae;
  var Ue = ae;

  function Ne() {
    function e(e, t) {
      return t.length - e.length;
    }

    var t,
        n,
        s = [],
        i = [],
        r = [];

    for (t = 0; t < 12; t++) {
      n = y([2e3, t]), s.push(this.monthsShort(n, "")), i.push(this.months(n, "")), r.push(this.months(n, "")), r.push(this.monthsShort(n, ""));
    }

    for (s.sort(e), i.sort(e), r.sort(e), t = 0; t < 12; t++) {
      s[t] = de(s[t]), i[t] = de(i[t]);
    }

    for (t = 0; t < 24; t++) {
      r[t] = de(r[t]);
    }

    this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i");
  }

  function Ge(e) {
    var t = new Date(Date.UTC.apply(null, arguments));
    return e < 100 && 0 <= e && isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e), t;
  }

  function Ve(e, t, n) {
    var s = 7 + t - n;
    return -((7 + Ge(e, 0, s).getUTCDay() - t) % 7) + s - 1;
  }

  function Ee(e, t, n, s, i) {
    var r,
        a,
        o = 1 + 7 * (t - 1) + (7 + n - s) % 7 + Ve(e, s, i);
    return a = o <= 0 ? De(r = e - 1) + o : o > De(e) ? (r = e + 1, o - De(e)) : (r = e, o), {
      year: r,
      dayOfYear: a
    };
  }

  function Ie(e, t, n) {
    var s,
        i,
        r = Ve(e.year(), t, n),
        a = Math.floor((e.dayOfYear() - r - 1) / 7) + 1;
    return a < 1 ? s = a + Ae(i = e.year() - 1, t, n) : a > Ae(e.year(), t, n) ? (s = a - Ae(e.year(), t, n), i = e.year() + 1) : (i = e.year(), s = a), {
      week: s,
      year: i
    };
  }

  function Ae(e, t, n) {
    var s = Ve(e, t, n),
        i = Ve(e + 1, t, n);
    return (De(e) - s + i) / 7;
  }

  I("w", ["ww", 2], "wo", "week"), I("W", ["WW", 2], "Wo", "isoWeek"), H("week", "w"), H("isoWeek", "W"), L("week", 5), L("isoWeek", 5), ue("w", B), ue("ww", B, z), ue("W", B), ue("WW", B, z), fe(["w", "ww", "W", "WW"], function (e, t, n, s) {
    t[s.substr(0, 1)] = k(e);
  });
  I("d", 0, "do", "day"), I("dd", 0, 0, function (e) {
    return this.localeData().weekdaysMin(this, e);
  }), I("ddd", 0, 0, function (e) {
    return this.localeData().weekdaysShort(this, e);
  }), I("dddd", 0, 0, function (e) {
    return this.localeData().weekdays(this, e);
  }), I("e", 0, 0, "weekday"), I("E", 0, 0, "isoWeekday"), H("day", "d"), H("weekday", "e"), H("isoWeekday", "E"), L("day", 11), L("weekday", 11), L("isoWeekday", 11), ue("d", B), ue("e", B), ue("E", B), ue("dd", function (e, t) {
    return t.weekdaysMinRegex(e);
  }), ue("ddd", function (e, t) {
    return t.weekdaysShortRegex(e);
  }), ue("dddd", function (e, t) {
    return t.weekdaysRegex(e);
  }), fe(["dd", "ddd", "dddd"], function (e, t, n, s) {
    var i = n._locale.weekdaysParse(e, s, n._strict);

    null != i ? t.d = i : g(n).invalidWeekday = e;
  }), fe(["d", "e", "E"], function (e, t, n, s) {
    t[s] = k(e);
  });
  var je = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_");
  var Ze = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_");
  var ze = "Su_Mo_Tu_We_Th_Fr_Sa".split("_");
  var $e = ae;
  var qe = ae;
  var Je = ae;

  function Be() {
    function e(e, t) {
      return t.length - e.length;
    }

    var t,
        n,
        s,
        i,
        r,
        a = [],
        o = [],
        u = [],
        l = [];

    for (t = 0; t < 7; t++) {
      n = y([2e3, 1]).day(t), s = this.weekdaysMin(n, ""), i = this.weekdaysShort(n, ""), r = this.weekdays(n, ""), a.push(s), o.push(i), u.push(r), l.push(s), l.push(i), l.push(r);
    }

    for (a.sort(e), o.sort(e), u.sort(e), l.sort(e), t = 0; t < 7; t++) {
      o[t] = de(o[t]), u[t] = de(u[t]), l[t] = de(l[t]);
    }

    this._weekdaysRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + u.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + a.join("|") + ")", "i");
  }

  function Qe() {
    return this.hours() % 12 || 12;
  }

  function Xe(e, t) {
    I(e, 0, 0, function () {
      return this.localeData().meridiem(this.hours(), this.minutes(), t);
    });
  }

  function Ke(e, t) {
    return t._meridiemParse;
  }

  I("H", ["HH", 2], 0, "hour"), I("h", ["hh", 2], 0, Qe), I("k", ["kk", 2], 0, function () {
    return this.hours() || 24;
  }), I("hmm", 0, 0, function () {
    return "" + Qe.apply(this) + U(this.minutes(), 2);
  }), I("hmmss", 0, 0, function () {
    return "" + Qe.apply(this) + U(this.minutes(), 2) + U(this.seconds(), 2);
  }), I("Hmm", 0, 0, function () {
    return "" + this.hours() + U(this.minutes(), 2);
  }), I("Hmmss", 0, 0, function () {
    return "" + this.hours() + U(this.minutes(), 2) + U(this.seconds(), 2);
  }), Xe("a", !0), Xe("A", !1), H("hour", "h"), L("hour", 13), ue("a", Ke), ue("A", Ke), ue("H", B), ue("h", B), ue("k", B), ue("HH", B, z), ue("hh", B, z), ue("kk", B, z), ue("hmm", Q), ue("hmmss", X), ue("Hmm", Q), ue("Hmmss", X), ce(["H", "HH"], ge), ce(["k", "kk"], function (e, t, n) {
    var s = k(e);
    t[ge] = 24 === s ? 0 : s;
  }), ce(["a", "A"], function (e, t, n) {
    n._isPm = n._locale.isPM(e), n._meridiem = e;
  }), ce(["h", "hh"], function (e, t, n) {
    t[ge] = k(e), g(n).bigHour = !0;
  }), ce("hmm", function (e, t, n) {
    var s = e.length - 2;
    t[ge] = k(e.substr(0, s)), t[pe] = k(e.substr(s)), g(n).bigHour = !0;
  }), ce("hmmss", function (e, t, n) {
    var s = e.length - 4,
        i = e.length - 2;
    t[ge] = k(e.substr(0, s)), t[pe] = k(e.substr(s, 2)), t[ve] = k(e.substr(i)), g(n).bigHour = !0;
  }), ce("Hmm", function (e, t, n) {
    var s = e.length - 2;
    t[ge] = k(e.substr(0, s)), t[pe] = k(e.substr(s));
  }), ce("Hmmss", function (e, t, n) {
    var s = e.length - 4,
        i = e.length - 2;
    t[ge] = k(e.substr(0, s)), t[pe] = k(e.substr(s, 2)), t[ve] = k(e.substr(i));
  });
  var et,
      tt = Te("Hours", !0),
      nt = {
    calendar: {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    },
    longDateFormat: {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    },
    invalidDate: "Invalid date",
    ordinal: "%d",
    dayOfMonthOrdinalParse: /\d{1,2}/,
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    },
    months: He,
    monthsShort: Re,
    week: {
      dow: 0,
      doy: 6
    },
    weekdays: je,
    weekdaysMin: ze,
    weekdaysShort: Ze,
    meridiemParse: /[ap]\.?m?\.?/i
  },
      st = {},
      it = {};

  function rt(e) {
    return e ? e.toLowerCase().replace("_", "-") : e;
  }

  function at(e) {
    var t = null;
    if (!st[e] && "undefined" != typeof module && module && module.exports) try {
      t = et._abbr, require("./locale/" + e), ot(t);
    } catch (e) {}
    return st[e];
  }

  function ot(e, t) {
    var n;
    return e && ((n = l(t) ? lt(e) : ut(e, t)) ? et = n : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), et._abbr;
  }

  function ut(e, t) {
    if (null === t) return delete st[e], null;
    var n,
        s = nt;
    if (t.abbr = e, null != st[e]) T("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), s = st[e]._config;else if (null != t.parentLocale) if (null != st[t.parentLocale]) s = st[t.parentLocale]._config;else {
      if (null == (n = at(t.parentLocale))) return it[t.parentLocale] || (it[t.parentLocale] = []), it[t.parentLocale].push({
        name: e,
        config: t
      }), null;
      s = n._config;
    }
    return st[e] = new P(b(s, t)), it[e] && it[e].forEach(function (e) {
      ut(e.name, e.config);
    }), ot(e), st[e];
  }

  function lt(e) {
    var t;
    if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return et;

    if (!o(e)) {
      if (t = at(e)) return t;
      e = [e];
    }

    return function (e) {
      for (var t, n, s, i, r = 0; r < e.length;) {
        for (t = (i = rt(e[r]).split("-")).length, n = (n = rt(e[r + 1])) ? n.split("-") : null; 0 < t;) {
          if (s = at(i.slice(0, t).join("-"))) return s;
          if (n && n.length >= t && a(i, n, !0) >= t - 1) break;
          t--;
        }

        r++;
      }

      return et;
    }(e);
  }

  function dt(e) {
    var t,
        n = e._a;
    return n && -2 === g(e).overflow && (t = n[_e] < 0 || 11 < n[_e] ? _e : n[ye] < 1 || n[ye] > Pe(n[me], n[_e]) ? ye : n[ge] < 0 || 24 < n[ge] || 24 === n[ge] && (0 !== n[pe] || 0 !== n[ve] || 0 !== n[we]) ? ge : n[pe] < 0 || 59 < n[pe] ? pe : n[ve] < 0 || 59 < n[ve] ? ve : n[we] < 0 || 999 < n[we] ? we : -1, g(e)._overflowDayOfYear && (t < me || ye < t) && (t = ye), g(e)._overflowWeeks && -1 === t && (t = Me), g(e)._overflowWeekday && -1 === t && (t = Se), g(e).overflow = t), e;
  }

  function ht(e, t, n) {
    return null != e ? e : null != t ? t : n;
  }

  function ct(e) {
    var t,
        n,
        s,
        i,
        r,
        a = [];

    if (!e._d) {
      var o, u;

      for (o = e, u = new Date(c.now()), s = o._useUTC ? [u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()] : [u.getFullYear(), u.getMonth(), u.getDate()], e._w && null == e._a[ye] && null == e._a[_e] && function (e) {
        var t, n, s, i, r, a, o, u;
        if (null != (t = e._w).GG || null != t.W || null != t.E) r = 1, a = 4, n = ht(t.GG, e._a[me], Ie(Tt(), 1, 4).year), s = ht(t.W, 1), ((i = ht(t.E, 1)) < 1 || 7 < i) && (u = !0);else {
          r = e._locale._week.dow, a = e._locale._week.doy;
          var l = Ie(Tt(), r, a);
          n = ht(t.gg, e._a[me], l.year), s = ht(t.w, l.week), null != t.d ? ((i = t.d) < 0 || 6 < i) && (u = !0) : null != t.e ? (i = t.e + r, (t.e < 0 || 6 < t.e) && (u = !0)) : i = r;
        }
        s < 1 || s > Ae(n, r, a) ? g(e)._overflowWeeks = !0 : null != u ? g(e)._overflowWeekday = !0 : (o = Ee(n, s, i, r, a), e._a[me] = o.year, e._dayOfYear = o.dayOfYear);
      }(e), null != e._dayOfYear && (r = ht(e._a[me], s[me]), (e._dayOfYear > De(r) || 0 === e._dayOfYear) && (g(e)._overflowDayOfYear = !0), n = Ge(r, 0, e._dayOfYear), e._a[_e] = n.getUTCMonth(), e._a[ye] = n.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t) {
        e._a[t] = a[t] = s[t];
      }

      for (; t < 7; t++) {
        e._a[t] = a[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
      }

      24 === e._a[ge] && 0 === e._a[pe] && 0 === e._a[ve] && 0 === e._a[we] && (e._nextDay = !0, e._a[ge] = 0), e._d = (e._useUTC ? Ge : function (e, t, n, s, i, r, a) {
        var o = new Date(e, t, n, s, i, r, a);
        return e < 100 && 0 <= e && isFinite(o.getFullYear()) && o.setFullYear(e), o;
      }).apply(null, a), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[ge] = 24), e._w && void 0 !== e._w.d && e._w.d !== i && (g(e).weekdayMismatch = !0);
    }
  }

  var ft = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      mt = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      _t = /Z|[+-]\d\d(?::?\d\d)?/,
      yt = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/]],
      gt = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
      pt = /^\/?Date\((\-?\d+)/i;

  function vt(e) {
    var t,
        n,
        s,
        i,
        r,
        a,
        o = e._i,
        u = ft.exec(o) || mt.exec(o);

    if (u) {
      for (g(e).iso = !0, t = 0, n = yt.length; t < n; t++) {
        if (yt[t][1].exec(u[1])) {
          i = yt[t][0], s = !1 !== yt[t][2];
          break;
        }
      }

      if (null == i) return void (e._isValid = !1);

      if (u[3]) {
        for (t = 0, n = gt.length; t < n; t++) {
          if (gt[t][1].exec(u[3])) {
            r = (u[2] || " ") + gt[t][0];
            break;
          }
        }

        if (null == r) return void (e._isValid = !1);
      }

      if (!s && null != r) return void (e._isValid = !1);

      if (u[4]) {
        if (!_t.exec(u[4])) return void (e._isValid = !1);
        a = "Z";
      }

      e._f = i + (r || "") + (a || ""), kt(e);
    } else e._isValid = !1;
  }

  var wt = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

  function Mt(e, t, n, s, i, r) {
    var a = [function (e) {
      var t = parseInt(e, 10);
      {
        if (t <= 49) return 2e3 + t;
        if (t <= 999) return 1900 + t;
      }
      return t;
    }(e), Re.indexOf(t), parseInt(n, 10), parseInt(s, 10), parseInt(i, 10)];
    return r && a.push(parseInt(r, 10)), a;
  }

  var St = {
    UT: 0,
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
  };

  function Dt(e) {
    var t,
        n,
        s,
        i = wt.exec(e._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));

    if (i) {
      var r = Mt(i[4], i[3], i[2], i[5], i[6], i[7]);
      if (t = i[1], n = r, s = e, t && Ze.indexOf(t) !== new Date(n[0], n[1], n[2]).getDay() && (g(s).weekdayMismatch = !0, !(s._isValid = !1))) return;
      e._a = r, e._tzm = function (e, t, n) {
        if (e) return St[e];
        if (t) return 0;
        var s = parseInt(n, 10),
            i = s % 100;
        return (s - i) / 100 * 60 + i;
      }(i[8], i[9], i[10]), e._d = Ge.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), g(e).rfc2822 = !0;
    } else e._isValid = !1;
  }

  function kt(e) {
    if (e._f !== c.ISO_8601) {
      if (e._f !== c.RFC_2822) {
        e._a = [], g(e).empty = !0;
        var t,
            n,
            s,
            i,
            r,
            a,
            o,
            u,
            l = "" + e._i,
            d = l.length,
            h = 0;

        for (s = j(e._f, e._locale).match(N) || [], t = 0; t < s.length; t++) {
          i = s[t], (n = (l.match(le(i, e)) || [])[0]) && (0 < (r = l.substr(0, l.indexOf(n))).length && g(e).unusedInput.push(r), l = l.slice(l.indexOf(n) + n.length), h += n.length), E[i] ? (n ? g(e).empty = !1 : g(e).unusedTokens.push(i), a = i, u = e, null != (o = n) && m(he, a) && he[a](o, u._a, u, a)) : e._strict && !n && g(e).unusedTokens.push(i);
        }

        g(e).charsLeftOver = d - h, 0 < l.length && g(e).unusedInput.push(l), e._a[ge] <= 12 && !0 === g(e).bigHour && 0 < e._a[ge] && (g(e).bigHour = void 0), g(e).parsedDateParts = e._a.slice(0), g(e).meridiem = e._meridiem, e._a[ge] = function (e, t, n) {
          var s;
          if (null == n) return t;
          return null != e.meridiemHour ? e.meridiemHour(t, n) : (null != e.isPM && ((s = e.isPM(n)) && t < 12 && (t += 12), s || 12 !== t || (t = 0)), t);
        }(e._locale, e._a[ge], e._meridiem), ct(e), dt(e);
      } else Dt(e);
    } else vt(e);
  }

  function Yt(e) {
    var t,
        n,
        s,
        i,
        r = e._i,
        a = e._f;
    return e._locale = e._locale || lt(e._l), null === r || void 0 === a && "" === r ? v({
      nullInput: !0
    }) : ("string" == typeof r && (e._i = r = e._locale.preparse(r)), S(r) ? new M(dt(r)) : (h(r) ? e._d = r : o(a) ? function (e) {
      var t, n, s, i, r;
      if (0 === e._f.length) return g(e).invalidFormat = !0, e._d = new Date(NaN);

      for (i = 0; i < e._f.length; i++) {
        r = 0, t = w({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[i], kt(t), p(t) && (r += g(t).charsLeftOver, r += 10 * g(t).unusedTokens.length, g(t).score = r, (null == s || r < s) && (s = r, n = t));
      }

      _(e, n || t);
    }(e) : a ? kt(e) : l(n = (t = e)._i) ? t._d = new Date(c.now()) : h(n) ? t._d = new Date(n.valueOf()) : "string" == typeof n ? (s = t, null === (i = pt.exec(s._i)) ? (vt(s), !1 === s._isValid && (delete s._isValid, Dt(s), !1 === s._isValid && (delete s._isValid, c.createFromInputFallback(s)))) : s._d = new Date(+i[1])) : o(n) ? (t._a = f(n.slice(0), function (e) {
      return parseInt(e, 10);
    }), ct(t)) : u(n) ? function (e) {
      if (!e._d) {
        var t = C(e._i);
        e._a = f([t.year, t.month, t.day || t.date, t.hour, t.minute, t.second, t.millisecond], function (e) {
          return e && parseInt(e, 10);
        }), ct(e);
      }
    }(t) : d(n) ? t._d = new Date(n) : c.createFromInputFallback(t), p(e) || (e._d = null), e));
  }

  function Ot(e, t, n, s, i) {
    var r,
        a = {};
    return !0 !== n && !1 !== n || (s = n, n = void 0), (u(e) && function (e) {
      if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
      var t;

      for (t in e) {
        if (e.hasOwnProperty(t)) return !1;
      }

      return !0;
    }(e) || o(e) && 0 === e.length) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = i, a._l = n, a._i = e, a._f = t, a._strict = s, (r = new M(dt(Yt(a))))._nextDay && (r.add(1, "d"), r._nextDay = void 0), r;
  }

  function Tt(e, t, n, s) {
    return Ot(e, t, n, s, !1);
  }

  c.createFromInputFallback = n("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (e) {
    e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
  }), c.ISO_8601 = function () {}, c.RFC_2822 = function () {};
  var xt = n("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
    var e = Tt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : v();
  }),
      bt = n("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
    var e = Tt.apply(null, arguments);
    return this.isValid() && e.isValid() ? this < e ? this : e : v();
  });

  function Pt(e, t) {
    var n, s;
    if (1 === t.length && o(t[0]) && (t = t[0]), !t.length) return Tt();

    for (n = t[0], s = 1; s < t.length; ++s) {
      t[s].isValid() && !t[s][e](n) || (n = t[s]);
    }

    return n;
  }

  var Wt = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

  function Ht(e) {
    var t = C(e),
        n = t.year || 0,
        s = t.quarter || 0,
        i = t.month || 0,
        r = t.week || t.isoWeek || 0,
        a = t.day || 0,
        o = t.hour || 0,
        u = t.minute || 0,
        l = t.second || 0,
        d = t.millisecond || 0;
    this._isValid = function (e) {
      for (var t in e) {
        if (-1 === Ye.call(Wt, t) || null != e[t] && isNaN(e[t])) return !1;
      }

      for (var n = !1, s = 0; s < Wt.length; ++s) {
        if (e[Wt[s]]) {
          if (n) return !1;
          parseFloat(e[Wt[s]]) !== k(e[Wt[s]]) && (n = !0);
        }
      }

      return !0;
    }(t), this._milliseconds = +d + 1e3 * l + 6e4 * u + 1e3 * o * 60 * 60, this._days = +a + 7 * r, this._months = +i + 3 * s + 12 * n, this._data = {}, this._locale = lt(), this._bubble();
  }

  function Rt(e) {
    return e instanceof Ht;
  }

  function Ct(e) {
    return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
  }

  function Ft(e, n) {
    I(e, 0, 0, function () {
      var e = this.utcOffset(),
          t = "+";
      return e < 0 && (e = -e, t = "-"), t + U(~~(e / 60), 2) + n + U(~~e % 60, 2);
    });
  }

  Ft("Z", ":"), Ft("ZZ", ""), ue("Z", re), ue("ZZ", re), ce(["Z", "ZZ"], function (e, t, n) {
    n._useUTC = !0, n._tzm = Ut(re, e);
  });
  var Lt = /([\+\-]|\d\d)/gi;

  function Ut(e, t) {
    var n = (t || "").match(e);
    if (null === n) return null;
    var s = ((n[n.length - 1] || []) + "").match(Lt) || ["-", 0, 0],
        i = 60 * s[1] + k(s[2]);
    return 0 === i ? 0 : "+" === s[0] ? i : -i;
  }

  function Nt(e, t) {
    var n, s;
    return t._isUTC ? (n = t.clone(), s = (S(e) || h(e) ? e.valueOf() : Tt(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + s), c.updateOffset(n, !1), n) : Tt(e).local();
  }

  function Gt(e) {
    return 15 * -Math.round(e._d.getTimezoneOffset() / 15);
  }

  function Vt() {
    return !!this.isValid() && this._isUTC && 0 === this._offset;
  }

  c.updateOffset = function () {};

  var Et = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,
      It = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

  function At(e, t) {
    var n,
        s,
        i,
        r = e,
        a = null;
    return Rt(e) ? r = {
      ms: e._milliseconds,
      d: e._days,
      M: e._months
    } : d(e) ? (r = {}, t ? r[t] = e : r.milliseconds = e) : (a = Et.exec(e)) ? (n = "-" === a[1] ? -1 : 1, r = {
      y: 0,
      d: k(a[ye]) * n,
      h: k(a[ge]) * n,
      m: k(a[pe]) * n,
      s: k(a[ve]) * n,
      ms: k(Ct(1e3 * a[we])) * n
    }) : (a = It.exec(e)) ? (n = "-" === a[1] ? -1 : 1, r = {
      y: jt(a[2], n),
      M: jt(a[3], n),
      w: jt(a[4], n),
      d: jt(a[5], n),
      h: jt(a[6], n),
      m: jt(a[7], n),
      s: jt(a[8], n)
    }) : null == r ? r = {} : "object" == _typeof2(r) && ("from" in r || "to" in r) && (i = function (e, t) {
      var n;
      if (!e.isValid() || !t.isValid()) return {
        milliseconds: 0,
        months: 0
      };
      t = Nt(t, e), e.isBefore(t) ? n = Zt(e, t) : ((n = Zt(t, e)).milliseconds = -n.milliseconds, n.months = -n.months);
      return n;
    }(Tt(r.from), Tt(r.to)), (r = {}).ms = i.milliseconds, r.M = i.months), s = new Ht(r), Rt(e) && m(e, "_locale") && (s._locale = e._locale), s;
  }

  function jt(e, t) {
    var n = e && parseFloat(e.replace(",", "."));
    return (isNaN(n) ? 0 : n) * t;
  }

  function Zt(e, t) {
    var n = {
      milliseconds: 0,
      months: 0
    };
    return n.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
  }

  function zt(s, i) {
    return function (e, t) {
      var n;
      return null === t || isNaN(+t) || (T(i, "moment()." + i + "(period, number) is deprecated. Please use moment()." + i + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), n = e, e = t, t = n), $t(this, At(e = "string" == typeof e ? +e : e, t), s), this;
    };
  }

  function $t(e, t, n, s) {
    var i = t._milliseconds,
        r = Ct(t._days),
        a = Ct(t._months);
    e.isValid() && (s = null == s || s, a && Ce(e, xe(e, "Month") + a * n), r && be(e, "Date", xe(e, "Date") + r * n), i && e._d.setTime(e._d.valueOf() + i * n), s && c.updateOffset(e, r || a));
  }

  At.fn = Ht.prototype, At.invalid = function () {
    return At(NaN);
  };
  var qt = zt(1, "add"),
      Jt = zt(-1, "subtract");

  function Bt(e, t) {
    var n = 12 * (t.year() - e.year()) + (t.month() - e.month()),
        s = e.clone().add(n, "months");
    return -(n + (t - s < 0 ? (t - s) / (s - e.clone().add(n - 1, "months")) : (t - s) / (e.clone().add(n + 1, "months") - s))) || 0;
  }

  function Qt(e) {
    var t;
    return void 0 === e ? this._locale._abbr : (null != (t = lt(e)) && (this._locale = t), this);
  }

  c.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", c.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
  var Xt = n("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (e) {
    return void 0 === e ? this.localeData() : this.locale(e);
  });

  function Kt() {
    return this._locale;
  }

  function en(e, t) {
    I(0, [e, e.length], 0, t);
  }

  function tn(e, t, n, s, i) {
    var r;
    return null == e ? Ie(this, s, i).year : ((r = Ae(e, s, i)) < t && (t = r), function (e, t, n, s, i) {
      var r = Ee(e, t, n, s, i),
          a = Ge(r.year, 0, r.dayOfYear);
      return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
    }.call(this, e, t, n, s, i));
  }

  I(0, ["gg", 2], 0, function () {
    return this.weekYear() % 100;
  }), I(0, ["GG", 2], 0, function () {
    return this.isoWeekYear() % 100;
  }), en("gggg", "weekYear"), en("ggggg", "weekYear"), en("GGGG", "isoWeekYear"), en("GGGGG", "isoWeekYear"), H("weekYear", "gg"), H("isoWeekYear", "GG"), L("weekYear", 1), L("isoWeekYear", 1), ue("G", se), ue("g", se), ue("GG", B, z), ue("gg", B, z), ue("GGGG", ee, q), ue("gggg", ee, q), ue("GGGGG", te, J), ue("ggggg", te, J), fe(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, t, n, s) {
    t[s.substr(0, 2)] = k(e);
  }), fe(["gg", "GG"], function (e, t, n, s) {
    t[s] = c.parseTwoDigitYear(e);
  }), I("Q", 0, "Qo", "quarter"), H("quarter", "Q"), L("quarter", 7), ue("Q", Z), ce("Q", function (e, t) {
    t[_e] = 3 * (k(e) - 1);
  }), I("D", ["DD", 2], "Do", "date"), H("date", "D"), L("date", 9), ue("D", B), ue("DD", B, z), ue("Do", function (e, t) {
    return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
  }), ce(["D", "DD"], ye), ce("Do", function (e, t) {
    t[ye] = k(e.match(B)[0]);
  });
  var nn = Te("Date", !0);
  I("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), H("dayOfYear", "DDD"), L("dayOfYear", 4), ue("DDD", K), ue("DDDD", $), ce(["DDD", "DDDD"], function (e, t, n) {
    n._dayOfYear = k(e);
  }), I("m", ["mm", 2], 0, "minute"), H("minute", "m"), L("minute", 14), ue("m", B), ue("mm", B, z), ce(["m", "mm"], pe);
  var sn = Te("Minutes", !1);
  I("s", ["ss", 2], 0, "second"), H("second", "s"), L("second", 15), ue("s", B), ue("ss", B, z), ce(["s", "ss"], ve);
  var rn,
      an = Te("Seconds", !1);

  for (I("S", 0, 0, function () {
    return ~~(this.millisecond() / 100);
  }), I(0, ["SS", 2], 0, function () {
    return ~~(this.millisecond() / 10);
  }), I(0, ["SSS", 3], 0, "millisecond"), I(0, ["SSSS", 4], 0, function () {
    return 10 * this.millisecond();
  }), I(0, ["SSSSS", 5], 0, function () {
    return 100 * this.millisecond();
  }), I(0, ["SSSSSS", 6], 0, function () {
    return 1e3 * this.millisecond();
  }), I(0, ["SSSSSSS", 7], 0, function () {
    return 1e4 * this.millisecond();
  }), I(0, ["SSSSSSSS", 8], 0, function () {
    return 1e5 * this.millisecond();
  }), I(0, ["SSSSSSSSS", 9], 0, function () {
    return 1e6 * this.millisecond();
  }), H("millisecond", "ms"), L("millisecond", 16), ue("S", K, Z), ue("SS", K, z), ue("SSS", K, $), rn = "SSSS"; rn.length <= 9; rn += "S") {
    ue(rn, ne);
  }

  function on(e, t) {
    t[we] = k(1e3 * ("0." + e));
  }

  for (rn = "S"; rn.length <= 9; rn += "S") {
    ce(rn, on);
  }

  var un = Te("Milliseconds", !1);
  I("z", 0, 0, "zoneAbbr"), I("zz", 0, 0, "zoneName");
  var ln = M.prototype;

  function dn(e) {
    return e;
  }

  ln.add = qt, ln.calendar = function (e, t) {
    var n = e || Tt(),
        s = Nt(n, this).startOf("day"),
        i = c.calendarFormat(this, s) || "sameElse",
        r = t && (x(t[i]) ? t[i].call(this, n) : t[i]);
    return this.format(r || this.localeData().calendar(i, this, Tt(n)));
  }, ln.clone = function () {
    return new M(this);
  }, ln.diff = function (e, t, n) {
    var s, i, r;
    if (!this.isValid()) return NaN;
    if (!(s = Nt(e, this)).isValid()) return NaN;

    switch (i = 6e4 * (s.utcOffset() - this.utcOffset()), t = R(t)) {
      case "year":
        r = Bt(this, s) / 12;
        break;

      case "month":
        r = Bt(this, s);
        break;

      case "quarter":
        r = Bt(this, s) / 3;
        break;

      case "second":
        r = (this - s) / 1e3;
        break;

      case "minute":
        r = (this - s) / 6e4;
        break;

      case "hour":
        r = (this - s) / 36e5;
        break;

      case "day":
        r = (this - s - i) / 864e5;
        break;

      case "week":
        r = (this - s - i) / 6048e5;
        break;

      default:
        r = this - s;
    }

    return n ? r : D(r);
  }, ln.endOf = function (e) {
    return void 0 === (e = R(e)) || "millisecond" === e ? this : ("date" === e && (e = "day"), this.startOf(e).add(1, "isoWeek" === e ? "week" : e).subtract(1, "ms"));
  }, ln.format = function (e) {
    e || (e = this.isUtc() ? c.defaultFormatUtc : c.defaultFormat);
    var t = A(this, e);
    return this.localeData().postformat(t);
  }, ln.from = function (e, t) {
    return this.isValid() && (S(e) && e.isValid() || Tt(e).isValid()) ? At({
      to: this,
      from: e
    }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
  }, ln.fromNow = function (e) {
    return this.from(Tt(), e);
  }, ln.to = function (e, t) {
    return this.isValid() && (S(e) && e.isValid() || Tt(e).isValid()) ? At({
      from: this,
      to: e
    }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
  }, ln.toNow = function (e) {
    return this.to(Tt(), e);
  }, ln.get = function (e) {
    return x(this[e = R(e)]) ? this[e]() : this;
  }, ln.invalidAt = function () {
    return g(this).overflow;
  }, ln.isAfter = function (e, t) {
    var n = S(e) ? e : Tt(e);
    return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = R(t) || "millisecond") ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf());
  }, ln.isBefore = function (e, t) {
    var n = S(e) ? e : Tt(e);
    return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = R(t) || "millisecond") ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf());
  }, ln.isBetween = function (e, t, n, s) {
    var i = S(e) ? e : Tt(e),
        r = S(t) ? t : Tt(t);
    return !!(this.isValid() && i.isValid() && r.isValid()) && ("(" === (s = s || "()")[0] ? this.isAfter(i, n) : !this.isBefore(i, n)) && (")" === s[1] ? this.isBefore(r, n) : !this.isAfter(r, n));
  }, ln.isSame = function (e, t) {
    var n,
        s = S(e) ? e : Tt(e);
    return !(!this.isValid() || !s.isValid()) && ("millisecond" === (t = R(t) || "millisecond") ? this.valueOf() === s.valueOf() : (n = s.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf()));
  }, ln.isSameOrAfter = function (e, t) {
    return this.isSame(e, t) || this.isAfter(e, t);
  }, ln.isSameOrBefore = function (e, t) {
    return this.isSame(e, t) || this.isBefore(e, t);
  }, ln.isValid = function () {
    return p(this);
  }, ln.lang = Xt, ln.locale = Qt, ln.localeData = Kt, ln.max = bt, ln.min = xt, ln.parsingFlags = function () {
    return _({}, g(this));
  }, ln.set = function (e, t) {
    if ("object" == _typeof2(e)) for (var n = function (e) {
      var t = [];

      for (var n in e) {
        t.push({
          unit: n,
          priority: F[n]
        });
      }

      return t.sort(function (e, t) {
        return e.priority - t.priority;
      }), t;
    }(e = C(e)), s = 0; s < n.length; s++) {
      this[n[s].unit](e[n[s].unit]);
    } else if (x(this[e = R(e)])) return this[e](t);
    return this;
  }, ln.startOf = function (e) {
    switch (e = R(e)) {
      case "year":
        this.month(0);

      case "quarter":
      case "month":
        this.date(1);

      case "week":
      case "isoWeek":
      case "day":
      case "date":
        this.hours(0);

      case "hour":
        this.minutes(0);

      case "minute":
        this.seconds(0);

      case "second":
        this.milliseconds(0);
    }

    return "week" === e && this.weekday(0), "isoWeek" === e && this.isoWeekday(1), "quarter" === e && this.month(3 * Math.floor(this.month() / 3)), this;
  }, ln.subtract = Jt, ln.toArray = function () {
    var e = this;
    return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
  }, ln.toObject = function () {
    var e = this;
    return {
      years: e.year(),
      months: e.month(),
      date: e.date(),
      hours: e.hours(),
      minutes: e.minutes(),
      seconds: e.seconds(),
      milliseconds: e.milliseconds()
    };
  }, ln.toDate = function () {
    return new Date(this.valueOf());
  }, ln.toISOString = function (e) {
    if (!this.isValid()) return null;
    var t = !0 !== e,
        n = t ? this.clone().utc() : this;
    return n.year() < 0 || 9999 < n.year() ? A(n, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : x(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", A(n, "Z")) : A(n, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
  }, ln.inspect = function () {
    if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
    var e = "moment",
        t = "";
    this.isLocal() || (e = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", t = "Z");
    var n = "[" + e + '("]',
        s = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY",
        i = t + '[")]';
    return this.format(n + s + "-MM-DD[T]HH:mm:ss.SSS" + i);
  }, ln.toJSON = function () {
    return this.isValid() ? this.toISOString() : null;
  }, ln.toString = function () {
    return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
  }, ln.unix = function () {
    return Math.floor(this.valueOf() / 1e3);
  }, ln.valueOf = function () {
    return this._d.valueOf() - 6e4 * (this._offset || 0);
  }, ln.creationData = function () {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict
    };
  }, ln.year = Oe, ln.isLeapYear = function () {
    return ke(this.year());
  }, ln.weekYear = function (e) {
    return tn.call(this, e, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
  }, ln.isoWeekYear = function (e) {
    return tn.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
  }, ln.quarter = ln.quarters = function (e) {
    return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
  }, ln.month = Fe, ln.daysInMonth = function () {
    return Pe(this.year(), this.month());
  }, ln.week = ln.weeks = function (e) {
    var t = this.localeData().week(this);
    return null == e ? t : this.add(7 * (e - t), "d");
  }, ln.isoWeek = ln.isoWeeks = function (e) {
    var t = Ie(this, 1, 4).week;
    return null == e ? t : this.add(7 * (e - t), "d");
  }, ln.weeksInYear = function () {
    var e = this.localeData()._week;

    return Ae(this.year(), e.dow, e.doy);
  }, ln.isoWeeksInYear = function () {
    return Ae(this.year(), 1, 4);
  }, ln.date = nn, ln.day = ln.days = function (e) {
    if (!this.isValid()) return null != e ? this : NaN;
    var t,
        n,
        s = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    return null != e ? (t = e, n = this.localeData(), e = "string" != typeof t ? t : isNaN(t) ? "number" == typeof (t = n.weekdaysParse(t)) ? t : null : parseInt(t, 10), this.add(e - s, "d")) : s;
  }, ln.weekday = function (e) {
    if (!this.isValid()) return null != e ? this : NaN;
    var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return null == e ? t : this.add(e - t, "d");
  }, ln.isoWeekday = function (e) {
    if (!this.isValid()) return null != e ? this : NaN;
    if (null == e) return this.day() || 7;
    var t,
        n,
        s = (t = e, n = this.localeData(), "string" == typeof t ? n.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t);
    return this.day(this.day() % 7 ? s : s - 7);
  }, ln.dayOfYear = function (e) {
    var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
    return null == e ? t : this.add(e - t, "d");
  }, ln.hour = ln.hours = tt, ln.minute = ln.minutes = sn, ln.second = ln.seconds = an, ln.millisecond = ln.milliseconds = un, ln.utcOffset = function (e, t, n) {
    var s,
        i = this._offset || 0;
    if (!this.isValid()) return null != e ? this : NaN;
    if (null == e) return this._isUTC ? i : Gt(this);

    if ("string" == typeof e) {
      if (null === (e = Ut(re, e))) return this;
    } else Math.abs(e) < 16 && !n && (e *= 60);

    return !this._isUTC && t && (s = Gt(this)), this._offset = e, this._isUTC = !0, null != s && this.add(s, "m"), i !== e && (!t || this._changeInProgress ? $t(this, At(e - i, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, c.updateOffset(this, !0), this._changeInProgress = null)), this;
  }, ln.utc = function (e) {
    return this.utcOffset(0, e);
  }, ln.local = function (e) {
    return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Gt(this), "m")), this;
  }, ln.parseZone = function () {
    if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);else if ("string" == typeof this._i) {
      var e = Ut(ie, this._i);
      null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
    }
    return this;
  }, ln.hasAlignedHourOffset = function (e) {
    return !!this.isValid() && (e = e ? Tt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0);
  }, ln.isDST = function () {
    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
  }, ln.isLocal = function () {
    return !!this.isValid() && !this._isUTC;
  }, ln.isUtcOffset = function () {
    return !!this.isValid() && this._isUTC;
  }, ln.isUtc = Vt, ln.isUTC = Vt, ln.zoneAbbr = function () {
    return this._isUTC ? "UTC" : "";
  }, ln.zoneName = function () {
    return this._isUTC ? "Coordinated Universal Time" : "";
  }, ln.dates = n("dates accessor is deprecated. Use date instead.", nn), ln.months = n("months accessor is deprecated. Use month instead", Fe), ln.years = n("years accessor is deprecated. Use year instead", Oe), ln.zone = n("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function (e, t) {
    return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
  }), ln.isDSTShifted = n("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function () {
    if (!l(this._isDSTShifted)) return this._isDSTShifted;
    var e = {};

    if (w(e, this), (e = Yt(e))._a) {
      var t = e._isUTC ? y(e._a) : Tt(e._a);
      this._isDSTShifted = this.isValid() && 0 < a(e._a, t.toArray());
    } else this._isDSTShifted = !1;

    return this._isDSTShifted;
  });
  var hn = P.prototype;

  function cn(e, t, n, s) {
    var i = lt(),
        r = y().set(s, t);
    return i[n](r, e);
  }

  function fn(e, t, n) {
    if (d(e) && (t = e, e = void 0), e = e || "", null != t) return cn(e, t, n, "month");
    var s,
        i = [];

    for (s = 0; s < 12; s++) {
      i[s] = cn(e, s, n, "month");
    }

    return i;
  }

  function mn(e, t, n, s) {
    t = ("boolean" == typeof e ? d(t) && (n = t, t = void 0) : (t = e, e = !1, d(n = t) && (n = t, t = void 0)), t || "");
    var i,
        r = lt(),
        a = e ? r._week.dow : 0;
    if (null != n) return cn(t, (n + a) % 7, s, "day");
    var o = [];

    for (i = 0; i < 7; i++) {
      o[i] = cn(t, (i + a) % 7, s, "day");
    }

    return o;
  }

  hn.calendar = function (e, t, n) {
    var s = this._calendar[e] || this._calendar.sameElse;
    return x(s) ? s.call(t, n) : s;
  }, hn.longDateFormat = function (e) {
    var t = this._longDateFormat[e],
        n = this._longDateFormat[e.toUpperCase()];

    return t || !n ? t : (this._longDateFormat[e] = n.replace(/MMMM|MM|DD|dddd/g, function (e) {
      return e.slice(1);
    }), this._longDateFormat[e]);
  }, hn.invalidDate = function () {
    return this._invalidDate;
  }, hn.ordinal = function (e) {
    return this._ordinal.replace("%d", e);
  }, hn.preparse = dn, hn.postformat = dn, hn.relativeTime = function (e, t, n, s) {
    var i = this._relativeTime[n];
    return x(i) ? i(e, t, n, s) : i.replace(/%d/i, e);
  }, hn.pastFuture = function (e, t) {
    var n = this._relativeTime[0 < e ? "future" : "past"];
    return x(n) ? n(t) : n.replace(/%s/i, t);
  }, hn.set = function (e) {
    var t, n;

    for (n in e) {
      x(t = e[n]) ? this[n] = t : this["_" + n] = t;
    }

    this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
  }, hn.months = function (e, t) {
    return e ? o(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || We).test(t) ? "format" : "standalone"][e.month()] : o(this._months) ? this._months : this._months.standalone;
  }, hn.monthsShort = function (e, t) {
    return e ? o(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[We.test(t) ? "format" : "standalone"][e.month()] : o(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
  }, hn.monthsParse = function (e, t, n) {
    var s, i, r;
    if (this._monthsParseExact) return function (e, t, n) {
      var s,
          i,
          r,
          a = e.toLocaleLowerCase();
      if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], s = 0; s < 12; ++s) {
        r = y([2e3, s]), this._shortMonthsParse[s] = this.monthsShort(r, "").toLocaleLowerCase(), this._longMonthsParse[s] = this.months(r, "").toLocaleLowerCase();
      }
      return n ? "MMM" === t ? -1 !== (i = Ye.call(this._shortMonthsParse, a)) ? i : null : -1 !== (i = Ye.call(this._longMonthsParse, a)) ? i : null : "MMM" === t ? -1 !== (i = Ye.call(this._shortMonthsParse, a)) ? i : -1 !== (i = Ye.call(this._longMonthsParse, a)) ? i : null : -1 !== (i = Ye.call(this._longMonthsParse, a)) ? i : -1 !== (i = Ye.call(this._shortMonthsParse, a)) ? i : null;
    }.call(this, e, t, n);

    for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), s = 0; s < 12; s++) {
      if (i = y([2e3, s]), n && !this._longMonthsParse[s] && (this._longMonthsParse[s] = new RegExp("^" + this.months(i, "").replace(".", "") + "$", "i"), this._shortMonthsParse[s] = new RegExp("^" + this.monthsShort(i, "").replace(".", "") + "$", "i")), n || this._monthsParse[s] || (r = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[s] = new RegExp(r.replace(".", ""), "i")), n && "MMMM" === t && this._longMonthsParse[s].test(e)) return s;
      if (n && "MMM" === t && this._shortMonthsParse[s].test(e)) return s;
      if (!n && this._monthsParse[s].test(e)) return s;
    }
  }, hn.monthsRegex = function (e) {
    return this._monthsParseExact ? (m(this, "_monthsRegex") || Ne.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (m(this, "_monthsRegex") || (this._monthsRegex = Ue), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
  }, hn.monthsShortRegex = function (e) {
    return this._monthsParseExact ? (m(this, "_monthsRegex") || Ne.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (m(this, "_monthsShortRegex") || (this._monthsShortRegex = Le), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
  }, hn.week = function (e) {
    return Ie(e, this._week.dow, this._week.doy).week;
  }, hn.firstDayOfYear = function () {
    return this._week.doy;
  }, hn.firstDayOfWeek = function () {
    return this._week.dow;
  }, hn.weekdays = function (e, t) {
    return e ? o(this._weekdays) ? this._weekdays[e.day()] : this._weekdays[this._weekdays.isFormat.test(t) ? "format" : "standalone"][e.day()] : o(this._weekdays) ? this._weekdays : this._weekdays.standalone;
  }, hn.weekdaysMin = function (e) {
    return e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
  }, hn.weekdaysShort = function (e) {
    return e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
  }, hn.weekdaysParse = function (e, t, n) {
    var s, i, r;
    if (this._weekdaysParseExact) return function (e, t, n) {
      var s,
          i,
          r,
          a = e.toLocaleLowerCase();
      if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], s = 0; s < 7; ++s) {
        r = y([2e3, 1]).day(s), this._minWeekdaysParse[s] = this.weekdaysMin(r, "").toLocaleLowerCase(), this._shortWeekdaysParse[s] = this.weekdaysShort(r, "").toLocaleLowerCase(), this._weekdaysParse[s] = this.weekdays(r, "").toLocaleLowerCase();
      }
      return n ? "dddd" === t ? -1 !== (i = Ye.call(this._weekdaysParse, a)) ? i : null : "ddd" === t ? -1 !== (i = Ye.call(this._shortWeekdaysParse, a)) ? i : null : -1 !== (i = Ye.call(this._minWeekdaysParse, a)) ? i : null : "dddd" === t ? -1 !== (i = Ye.call(this._weekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._shortWeekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._minWeekdaysParse, a)) ? i : null : "ddd" === t ? -1 !== (i = Ye.call(this._shortWeekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._weekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._minWeekdaysParse, a)) ? i : null : -1 !== (i = Ye.call(this._minWeekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._weekdaysParse, a)) ? i : -1 !== (i = Ye.call(this._shortWeekdaysParse, a)) ? i : null;
    }.call(this, e, t, n);

    for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), s = 0; s < 7; s++) {
      if (i = y([2e3, 1]).day(s), n && !this._fullWeekdaysParse[s] && (this._fullWeekdaysParse[s] = new RegExp("^" + this.weekdays(i, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[s] = new RegExp("^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[s] = new RegExp("^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[s] || (r = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[s] = new RegExp(r.replace(".", ""), "i")), n && "dddd" === t && this._fullWeekdaysParse[s].test(e)) return s;
      if (n && "ddd" === t && this._shortWeekdaysParse[s].test(e)) return s;
      if (n && "dd" === t && this._minWeekdaysParse[s].test(e)) return s;
      if (!n && this._weekdaysParse[s].test(e)) return s;
    }
  }, hn.weekdaysRegex = function (e) {
    return this._weekdaysParseExact ? (m(this, "_weekdaysRegex") || Be.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (m(this, "_weekdaysRegex") || (this._weekdaysRegex = $e), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
  }, hn.weekdaysShortRegex = function (e) {
    return this._weekdaysParseExact ? (m(this, "_weekdaysRegex") || Be.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (m(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = qe), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
  }, hn.weekdaysMinRegex = function (e) {
    return this._weekdaysParseExact ? (m(this, "_weekdaysRegex") || Be.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (m(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Je), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
  }, hn.isPM = function (e) {
    return "p" === (e + "").toLowerCase().charAt(0);
  }, hn.meridiem = function (e, t, n) {
    return 11 < e ? n ? "pm" : "PM" : n ? "am" : "AM";
  }, ot("en", {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function ordinal(e) {
      var t = e % 10;
      return e + (1 === k(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
    }
  }), c.lang = n("moment.lang is deprecated. Use moment.locale instead.", ot), c.langData = n("moment.langData is deprecated. Use moment.localeData instead.", lt);
  var _n = Math.abs;

  function yn(e, t, n, s) {
    var i = At(t, n);
    return e._milliseconds += s * i._milliseconds, e._days += s * i._days, e._months += s * i._months, e._bubble();
  }

  function gn(e) {
    return e < 0 ? Math.floor(e) : Math.ceil(e);
  }

  function pn(e) {
    return 4800 * e / 146097;
  }

  function vn(e) {
    return 146097 * e / 4800;
  }

  function wn(e) {
    return function () {
      return this.as(e);
    };
  }

  var Mn = wn("ms"),
      Sn = wn("s"),
      Dn = wn("m"),
      kn = wn("h"),
      Yn = wn("d"),
      On = wn("w"),
      Tn = wn("M"),
      xn = wn("y");

  function bn(e) {
    return function () {
      return this.isValid() ? this._data[e] : NaN;
    };
  }

  var Pn = bn("milliseconds"),
      Wn = bn("seconds"),
      Hn = bn("minutes"),
      Rn = bn("hours"),
      Cn = bn("days"),
      Fn = bn("months"),
      Ln = bn("years");
  var Un = Math.round,
      Nn = {
    ss: 44,
    s: 45,
    m: 45,
    h: 22,
    d: 26,
    M: 11
  };
  var Gn = Math.abs;

  function Vn(e) {
    return (0 < e) - (e < 0) || +e;
  }

  function En() {
    if (!this.isValid()) return this.localeData().invalidDate();
    var e,
        t,
        n = Gn(this._milliseconds) / 1e3,
        s = Gn(this._days),
        i = Gn(this._months);
    t = D((e = D(n / 60)) / 60), n %= 60, e %= 60;
    var r = D(i / 12),
        a = i %= 12,
        o = s,
        u = t,
        l = e,
        d = n ? n.toFixed(3).replace(/\.?0+$/, "") : "",
        h = this.asSeconds();
    if (!h) return "P0D";

    var c = h < 0 ? "-" : "",
        f = Vn(this._months) !== Vn(h) ? "-" : "",
        m = Vn(this._days) !== Vn(h) ? "-" : "",
        _ = Vn(this._milliseconds) !== Vn(h) ? "-" : "";

    return c + "P" + (r ? f + r + "Y" : "") + (a ? f + a + "M" : "") + (o ? m + o + "D" : "") + (u || l || d ? "T" : "") + (u ? _ + u + "H" : "") + (l ? _ + l + "M" : "") + (d ? _ + d + "S" : "");
  }

  var In = Ht.prototype;
  return In.isValid = function () {
    return this._isValid;
  }, In.abs = function () {
    var e = this._data;
    return this._milliseconds = _n(this._milliseconds), this._days = _n(this._days), this._months = _n(this._months), e.milliseconds = _n(e.milliseconds), e.seconds = _n(e.seconds), e.minutes = _n(e.minutes), e.hours = _n(e.hours), e.months = _n(e.months), e.years = _n(e.years), this;
  }, In.add = function (e, t) {
    return yn(this, e, t, 1);
  }, In.subtract = function (e, t) {
    return yn(this, e, t, -1);
  }, In.as = function (e) {
    if (!this.isValid()) return NaN;
    var t,
        n,
        s = this._milliseconds;
    if ("month" === (e = R(e)) || "year" === e) return t = this._days + s / 864e5, n = this._months + pn(t), "month" === e ? n : n / 12;

    switch (t = this._days + Math.round(vn(this._months)), e) {
      case "week":
        return t / 7 + s / 6048e5;

      case "day":
        return t + s / 864e5;

      case "hour":
        return 24 * t + s / 36e5;

      case "minute":
        return 1440 * t + s / 6e4;

      case "second":
        return 86400 * t + s / 1e3;

      case "millisecond":
        return Math.floor(864e5 * t) + s;

      default:
        throw new Error("Unknown unit " + e);
    }
  }, In.asMilliseconds = Mn, In.asSeconds = Sn, In.asMinutes = Dn, In.asHours = kn, In.asDays = Yn, In.asWeeks = On, In.asMonths = Tn, In.asYears = xn, In.valueOf = function () {
    return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * k(this._months / 12) : NaN;
  }, In._bubble = function () {
    var e,
        t,
        n,
        s,
        i,
        r = this._milliseconds,
        a = this._days,
        o = this._months,
        u = this._data;
    return 0 <= r && 0 <= a && 0 <= o || r <= 0 && a <= 0 && o <= 0 || (r += 864e5 * gn(vn(o) + a), o = a = 0), u.milliseconds = r % 1e3, e = D(r / 1e3), u.seconds = e % 60, t = D(e / 60), u.minutes = t % 60, n = D(t / 60), u.hours = n % 24, o += i = D(pn(a += D(n / 24))), a -= gn(vn(i)), s = D(o / 12), o %= 12, u.days = a, u.months = o, u.years = s, this;
  }, In.clone = function () {
    return At(this);
  }, In.get = function (e) {
    return e = R(e), this.isValid() ? this[e + "s"]() : NaN;
  }, In.milliseconds = Pn, In.seconds = Wn, In.minutes = Hn, In.hours = Rn, In.days = Cn, In.weeks = function () {
    return D(this.days() / 7);
  }, In.months = Fn, In.years = Ln, In.humanize = function (e) {
    if (!this.isValid()) return this.localeData().invalidDate();
    var t,
        n,
        s,
        i,
        r,
        a,
        o,
        u,
        l,
        d,
        h,
        c = this.localeData(),
        f = (n = !e, s = c, i = At(t = this).abs(), r = Un(i.as("s")), a = Un(i.as("m")), o = Un(i.as("h")), u = Un(i.as("d")), l = Un(i.as("M")), d = Un(i.as("y")), (h = r <= Nn.ss && ["s", r] || r < Nn.s && ["ss", r] || a <= 1 && ["m"] || a < Nn.m && ["mm", a] || o <= 1 && ["h"] || o < Nn.h && ["hh", o] || u <= 1 && ["d"] || u < Nn.d && ["dd", u] || l <= 1 && ["M"] || l < Nn.M && ["MM", l] || d <= 1 && ["y"] || ["yy", d])[2] = n, h[3] = 0 < +t, h[4] = s, function (e, t, n, s, i) {
      return i.relativeTime(t || 1, !!n, e, s);
    }.apply(null, h));
    return e && (f = c.pastFuture(+this, f)), c.postformat(f);
  }, In.toISOString = En, In.toString = En, In.toJSON = En, In.locale = Qt, In.localeData = Kt, In.toIsoString = n("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", En), In.lang = Xt, I("X", 0, 0, "unix"), I("x", 0, 0, "valueOf"), ue("x", se), ue("X", /[+-]?\d+(\.\d{1,3})?/), ce("X", function (e, t, n) {
    n._d = new Date(1e3 * parseFloat(e, 10));
  }), ce("x", function (e, t, n) {
    n._d = new Date(k(e));
  }), c.version = "2.23.0", e = Tt, c.fn = ln, c.min = function () {
    return Pt("isBefore", [].slice.call(arguments, 0));
  }, c.max = function () {
    return Pt("isAfter", [].slice.call(arguments, 0));
  }, c.now = function () {
    return Date.now ? Date.now() : +new Date();
  }, c.utc = y, c.unix = function (e) {
    return Tt(1e3 * e);
  }, c.months = function (e, t) {
    return fn(e, t, "months");
  }, c.isDate = h, c.locale = ot, c.invalid = v, c.duration = At, c.isMoment = S, c.weekdays = function (e, t, n) {
    return mn(e, t, n, "weekdays");
  }, c.parseZone = function () {
    return Tt.apply(null, arguments).parseZone();
  }, c.localeData = lt, c.isDuration = Rt, c.monthsShort = function (e, t) {
    return fn(e, t, "monthsShort");
  }, c.weekdaysMin = function (e, t, n) {
    return mn(e, t, n, "weekdaysMin");
  }, c.defineLocale = ut, c.updateLocale = function (e, t) {
    if (null != t) {
      var n,
          s,
          i = nt;
      null != (s = at(e)) && (i = s._config), (n = new P(t = b(i, t))).parentLocale = st[e], st[e] = n, ot(e);
    } else null != st[e] && (null != st[e].parentLocale ? st[e] = st[e].parentLocale : null != st[e] && delete st[e]);

    return st[e];
  }, c.locales = function () {
    return s(st);
  }, c.weekdaysShort = function (e, t, n) {
    return mn(e, t, n, "weekdaysShort");
  }, c.normalizeUnits = R, c.relativeTimeRounding = function (e) {
    return void 0 === e ? Un : "function" == typeof e && (Un = e, !0);
  }, c.relativeTimeThreshold = function (e, t) {
    return void 0 !== Nn[e] && (void 0 === t ? Nn[e] : (Nn[e] = t, "s" === e && (Nn.ss = t - 1), !0));
  }, c.calendarFormat = function (e, t) {
    var n = e.diff(t, "days", !0);
    return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
  }, c.prototype = ln, c.HTML5_FMT = {
    DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
    DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
    DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
    DATE: "YYYY-MM-DD",
    TIME: "HH:mm",
    TIME_SECONDS: "HH:mm:ss",
    TIME_MS: "HH:mm:ss.SSS",
    WEEK: "GGGG-[W]WW",
    MONTH: "YYYY-MM"
  }, c;
});
/*
* jQuery File Download Plugin v1.4.5
*
* http://www.johnculviner.com
*
* Copyright (c) 2013 - John Culviner
*
* Licensed under the MIT license:
*   http://www.opensource.org/licenses/mit-license.php
*
* !!!!NOTE!!!!
* You must also write a cookie in conjunction with using this plugin as mentioned in the orignal post:
* http://johnculviner.com/jquery-file-download-plugin-for-ajax-like-feature-rich-file-downloads/
* !!!!NOTE!!!!
*/

(function ($, window) {
  // i'll just put them here to get evaluated on script load
  var htmlSpecialCharsRegEx = /[<>&\r\n"']/gm;
  var htmlSpecialCharsPlaceHolders = {
    '<': 'lt;',
    '>': 'gt;',
    '&': 'amp;',
    '\r': "#13;",
    '\n': "#10;",
    '"': 'quot;',
    "'": '#39;'
    /*single quotes just to be safe, IE8 doesn't support &apos;, so use &#39; instead */

  };
  $.extend({
    //
    //$.fileDownload('/path/to/url/', options)
    //  see directly below for possible 'options'
    fileDownload: function fileDownload(fileUrl, options) {
      //provide some reasonable defaults to any unspecified options below
      var settings = $.extend({
        //
        //Requires jQuery UI: provide a message to display to the user when the file download is being prepared before the browser's dialog appears
        //
        preparingMessageHtml: null,
        //
        //Requires jQuery UI: provide a message to display to the user when a file download fails
        //
        failMessageHtml: null,
        //
        //the stock android browser straight up doesn't support file downloads initiated by a non GET: http://code.google.com/p/android/issues/detail?id=1780
        //specify a message here to display if a user tries with an android browser
        //if jQuery UI is installed this will be a dialog, otherwise it will be an alert
        //Set to null to disable the message and attempt to download anyway
        //
        androidPostUnsupportedMessageHtml: "Unfortunately your Android browser doesn't support this type of file download. Please try again with a different browser.",
        //
        //Requires jQuery UI: options to pass into jQuery UI Dialog
        //
        dialogOptions: {
          modal: true
        },
        //
        //a function to call while the dowload is being prepared before the browser's dialog appears
        //Args:
        //  url - the original url attempted
        //
        prepareCallback: function prepareCallback(url) {},
        //
        //a function to call after a file download successfully completed
        //Args:
        //  url - the original url attempted
        //
        successCallback: function successCallback(url) {},
        //
        //a function to call after a file download request was canceled
        //Args:
        //  url - the original url attempted
        //
        abortCallback: function abortCallback(url) {},
        //
        //a function to call after a file download failed
        //Args:
        //  responseHtml    - the html that came back in response to the file download. this won't necessarily come back depending on the browser.
        //                      in less than IE9 a cross domain error occurs because 500+ errors cause a cross domain issue due to IE subbing out the
        //                      server's error message with a "helpful" IE built in message
        //  url             - the original url attempted
        //  error           - original error cautch from exception
        //
        failCallback: function failCallback(responseHtml, url, error) {},
        //
        // the HTTP method to use. Defaults to "GET".
        //
        httpMethod: "GET",
        //
        // if specified will perform a "httpMethod" request to the specified 'fileUrl' using the specified data.
        // data must be an object (which will be $.param serialized) or already a key=value param string
        //
        data: null,
        //
        //a period in milliseconds to poll to determine if a successful file download has occured or not
        //
        checkInterval: 100,
        //
        //the cookie name to indicate if a file download has occured
        //
        cookieName: "fileDownload",
        //
        //the cookie value for the above name to indicate that a file download has occured
        //
        cookieValue: "true",
        //
        //the cookie path for above name value pair
        //
        cookiePath: "/",
        //
        //if specified it will be used when attempting to clear the above name value pair
        //useful for when downloads are being served on a subdomain (e.g. downloads.example.com)
        //
        cookieDomain: null,
        //
        //the title for the popup second window as a download is processing in the case of a mobile browser
        //
        popupWindowTitle: "Initiating file download...",
        //
        //Functionality to encode HTML entities for a POST, need this if data is an object with properties whose values contains strings with quotation marks.
        //HTML entity encoding is done by replacing all &,<,>,',",\r,\n characters.
        //Note that some browsers will POST the string htmlentity-encoded whilst others will decode it before POSTing.
        //It is recommended that on the server, htmlentity decoding is done irrespective.
        //
        encodeHTMLEntities: true
      }, options);
      var deferred = new $.Deferred(); //Setup mobile browser detection: Partial credit: http://detectmobilebrowser.com/

      var userAgent = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase();
      var isIos; //has full support of features in iOS 4.0+, uses a new window to accomplish this.

      var isAndroid; //has full support of GET features in 4.0+ by using a new window. Non-GET is completely unsupported by the browser. See above for specifying a message.

      var isOtherMobileBrowser; //there is no way to reliably guess here so all other mobile devices will GET and POST to the current window.

      if (/ip(ad|hone|od)/.test(userAgent)) {
        isIos = true;
      } else if (userAgent.indexOf('android') !== -1) {
        isAndroid = true;
      } else {
        isOtherMobileBrowser = /avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|playbook|silk|iemobile|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|e\-|e\/|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(di|rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|xda(\-|2|g)|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4));
      }

      var httpMethodUpper = settings.httpMethod.toUpperCase();

      if (isAndroid && httpMethodUpper !== "GET" && settings.androidPostUnsupportedMessageHtml) {
        //the stock android browser straight up doesn't support file downloads initiated by non GET requests: http://code.google.com/p/android/issues/detail?id=1780
        if ($().dialog) {
          $("<div>").html(settings.androidPostUnsupportedMessageHtml).dialog(settings.dialogOptions);
        } else {
          alert(settings.androidPostUnsupportedMessageHtml);
        }

        return deferred.reject();
      }

      var $preparingDialog = null;
      var internalCallbacks = {
        onPrepare: function onPrepare(url) {
          //wire up a jquery dialog to display the preparing message if specified
          if (settings.preparingMessageHtml) {
            $preparingDialog = $("<div>").html(settings.preparingMessageHtml).dialog(settings.dialogOptions);
          } else if (settings.prepareCallback) {
            settings.prepareCallback(url);
          }
        },
        onSuccess: function onSuccess(url) {
          //remove the perparing message if it was specified
          if ($preparingDialog) {
            $preparingDialog.dialog('close');
          }

          settings.successCallback(url);
          deferred.resolve(url);
        },
        onAbort: function onAbort(url) {
          //remove the perparing message if it was specified
          if ($preparingDialog) {
            $preparingDialog.dialog('close');
          }

          ;
          settings.abortCallback(url);
          deferred.reject(url);
        },
        onFail: function onFail(responseHtml, url, error) {
          //remove the perparing message if it was specified
          if ($preparingDialog) {
            $preparingDialog.dialog('close');
          } //wire up a jquery dialog to display the fail message if specified


          if (settings.failMessageHtml) {
            $("<div>").html(settings.failMessageHtml).dialog(settings.dialogOptions);
          }

          settings.failCallback(responseHtml, url, error);
          deferred.reject(responseHtml, url);
        }
      };
      internalCallbacks.onPrepare(fileUrl); //make settings.data a param string if it exists and isn't already

      if (settings.data !== null && typeof settings.data !== "string") {
        settings.data = $.param(settings.data);
      }

      var $iframe, downloadWindow, formDoc, $form;

      if (httpMethodUpper === "GET") {
        if (settings.data !== null) {
          //need to merge any fileUrl params with the data object
          var qsStart = fileUrl.indexOf('?');

          if (qsStart !== -1) {
            //we have a querystring in the url
            if (fileUrl.substring(fileUrl.length - 1) !== "&") {
              fileUrl = fileUrl + "&";
            }
          } else {
            fileUrl = fileUrl + "?";
          }

          fileUrl = fileUrl + settings.data;
        }

        if (isIos || isAndroid) {
          downloadWindow = window.open(fileUrl);
          downloadWindow.document.title = settings.popupWindowTitle;
          window.focus();
        } else if (isOtherMobileBrowser) {
          window.location(fileUrl);
        } else {
          //create a temporary iframe that is used to request the fileUrl as a GET request
          $iframe = $("<iframe>").hide().prop("src", fileUrl).appendTo("body");
        }
      } else {
        var formInnerHtml = "";

        if (settings.data !== null) {
          $.each(settings.data.replace(/\+/g, ' ').split("&"), function () {
            var kvp = this.split("="); //Issue: When value contains sign '=' then the kvp array does have more than 2 items. We have to join value back

            var k = kvp[0];
            kvp.shift();
            var v = kvp.join("=");
            kvp = [k, v];
            var key = settings.encodeHTMLEntities ? htmlSpecialCharsEntityEncode(decodeURIComponent(kvp[0])) : decodeURIComponent(kvp[0]);

            if (key) {
              var value = settings.encodeHTMLEntities ? htmlSpecialCharsEntityEncode(decodeURIComponent(kvp[1])) : decodeURIComponent(kvp[1]);
              formInnerHtml += '<input type="hidden" name="' + key + '" value="' + value + '" />';
            }
          });
        }

        if (isOtherMobileBrowser) {
          $form = $("<form>").appendTo("body");
          $form.hide().prop('method', settings.httpMethod).prop('action', fileUrl).html(formInnerHtml);
        } else {
          if (isIos) {
            downloadWindow = window.open("about:blank");
            downloadWindow.document.title = settings.popupWindowTitle;
            formDoc = downloadWindow.document;
            window.focus();
          } else {
            $iframe = $("<iframe style='display: none' src='about:blank'></iframe>").appendTo("body");
            formDoc = getiframeDocument($iframe);
          }

          formDoc.write("<html><head></head><body><form method='" + settings.httpMethod + "' action='" + fileUrl + "'>" + formInnerHtml + "</form>" + settings.popupWindowTitle + "</body></html>");
          $form = $(formDoc).find('form');
        }

        $form.submit();
      } //check if the file download has completed every checkInterval ms


      setTimeout(checkFileDownloadComplete, settings.checkInterval);

      function checkFileDownloadComplete() {
        //has the cookie been written due to a file download occuring?
        var cookieValue = settings.cookieValue;

        if (typeof cookieValue == 'string') {
          cookieValue = cookieValue.toLowerCase();
        }

        var lowerCaseCookie = settings.cookieName.toLowerCase() + "=" + cookieValue;

        if (document.cookie.toLowerCase().indexOf(lowerCaseCookie) > -1) {
          //execute specified callback
          internalCallbacks.onSuccess(fileUrl); //remove cookie

          var cookieData = settings.cookieName + "=; path=" + settings.cookiePath + "; expires=" + new Date(0).toUTCString() + ";";
          if (settings.cookieDomain) cookieData += " domain=" + settings.cookieDomain + ";";
          document.cookie = cookieData; //remove iframe

          cleanUp(false);
          return;
        } //has an error occured?
        //if neither containers exist below then the file download is occuring on the current window


        if (downloadWindow || $iframe) {
          //has an error occured?
          try {
            var formDoc = downloadWindow ? downloadWindow.document : getiframeDocument($iframe);

            if (formDoc && formDoc.body !== null && formDoc.body.innerHTML.length) {
              var isFailure = true;

              if ($form && $form.length) {
                var $contents = $(formDoc.body).contents().first();

                try {
                  if ($contents.length && $contents[0] === $form[0]) {
                    isFailure = false;
                  }
                } catch (e) {
                  if (e && e.number == -2146828218) {
                    // IE 8-10 throw a permission denied after the form reloads on the "$contents[0] === $form[0]" comparison
                    isFailure = true;
                  } else {
                    throw e;
                  }
                }
              }

              if (isFailure) {
                // IE 8-10 don't always have the full content available right away, they need a litle bit to finish
                setTimeout(function () {
                  internalCallbacks.onFail(formDoc.body.innerHTML, fileUrl);
                  cleanUp(true);
                }, 100);
                return;
              }
            }
          } catch (err) {
            //500 error less than IE9
            internalCallbacks.onFail('', fileUrl, err);
            cleanUp(true);
            return;
          }
        } //keep checking...


        setTimeout(checkFileDownloadComplete, settings.checkInterval);
      } //gets an iframes document in a cross browser compatible manner


      function getiframeDocument($iframe) {
        var iframeDoc = $iframe[0].contentWindow || $iframe[0].contentDocument;

        if (iframeDoc.document) {
          iframeDoc = iframeDoc.document;
        }

        return iframeDoc;
      }

      function cleanUp(isFailure) {
        setTimeout(function () {
          if (downloadWindow) {
            if (isAndroid) {
              downloadWindow.close();
            }

            if (isIos) {
              if (downloadWindow.focus) {
                downloadWindow.focus(); //ios safari bug doesn't allow a window to be closed unless it is focused

                if (isFailure) {
                  downloadWindow.close();
                }
              }
            }
          } //iframe cleanup appears to randomly cause the download to fail
          //not doing it seems better than failure...
          //if ($iframe) {
          //    $iframe.remove();
          //}

        }, 0);
      }

      function htmlSpecialCharsEntityEncode(str) {
        return str.replace(htmlSpecialCharsRegEx, function (match) {
          return '&' + htmlSpecialCharsPlaceHolders[match];
        });
      }

      var promise = deferred.promise();

      promise.abort = function () {
        cleanUp();
        $iframe.attr('src', '').html('');
        internalCallbacks.onAbort(fileUrl);
      };

      return promise;
    }
  });
})(jQuery, this || window);

!function (i) {
  "use strict";

  "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery);
}(function (i) {
  "use strict";

  var e = window.Slick || {};
  (e = function () {
    var e = 0;
    return function (t, o) {
      var s,
          n = this;
      n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(t),
        appendDots: i(t),
        arrows: !0,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function customPaging(e, t) {
          return i('<button type="button" />').text(t + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: .35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3
      }, n.initials = {
        animating: !1,
        dragging: !1,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: !1,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: !1,
        slideOffset: 0,
        swipeLeft: null,
        swiping: !1,
        $list: null,
        touchObject: {},
        transformsEnabled: !1,
        unslicked: !1
      }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(t), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(t).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0);
    };
  }()).prototype.activateADA = function () {
    this.$slideTrack.find(".slick-active").attr({
      "aria-hidden": "false"
    }).find("a, input, button, select").attr({
      tabindex: "0"
    });
  }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
    var s = this;
    if ("boolean" == typeof t) o = t, t = null;else if (t < 0 || t >= s.slideCount) return !1;
    s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
      i(t).attr("data-slick-index", e);
    }), s.$slidesCache = s.$slides, s.reinit();
  }, e.prototype.animateHeight = function () {
    var i = this;

    if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.animate({
        height: e
      }, i.options.speed);
    }
  }, e.prototype.animateSlide = function (e, t) {
    var o = {},
        s = this;
    s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (e = -e), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({
      left: e
    }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
      top: e
    }, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), i({
      animStart: s.currentLeft
    }).animate({
      animStart: e
    }, {
      duration: s.options.speed,
      easing: s.options.easing,
      step: function step(i) {
        i = Math.ceil(i), !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o));
      },
      complete: function complete() {
        t && t.call();
      }
    })) : (s.applyTransition(), e = Math.ceil(e), !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () {
      s.disableTransition(), t.call();
    }, s.options.speed));
  }, e.prototype.getNavTarget = function () {
    var e = this,
        t = e.options.asNavFor;
    return t && null !== t && (t = i(t).not(e.$slider)), t;
  }, e.prototype.asNavFor = function (e) {
    var t = this.getNavTarget();
    null !== t && "object" == _typeof2(t) && t.each(function () {
      var t = i(this).slick("getSlick");
      t.unslicked || t.slideHandler(e, !0);
    });
  }, e.prototype.applyTransition = function (i) {
    var e = this,
        t = {};
    !1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.autoPlay = function () {
    var i = this;
    i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
  }, e.prototype.autoPlayClear = function () {
    var i = this;
    i.autoPlayTimer && clearInterval(i.autoPlayTimer);
  }, e.prototype.autoPlayIterator = function () {
    var i = this,
        e = i.currentSlide + i.options.slidesToScroll;
    i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e));
  }, e.prototype.buildArrows = function () {
    var e = this;
    !0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
      "aria-disabled": "true",
      tabindex: "-1"
    }));
  }, e.prototype.buildDots = function () {
    var e,
        t,
        o = this;

    if (!0 === o.options.dots) {
      for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) {
        t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
      }

      o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active");
    }
  }, e.prototype.buildOut = function () {
    var e = this;
    e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
      i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "");
    }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable");
  }, e.prototype.buildRows = function () {
    var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this;

    if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 1) {
      for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
        var d = document.createElement("div");

        for (e = 0; e < l.options.rows; e++) {
          var a = document.createElement("div");

          for (t = 0; t < l.options.slidesPerRow; t++) {
            var c = i * r + (e * l.options.slidesPerRow + t);
            n.get(c) && a.appendChild(n.get(c));
          }

          d.appendChild(a);
        }

        o.appendChild(d);
      }

      l.$slider.empty().append(o), l.$slider.children().children().children().css({
        width: 100 / l.options.slidesPerRow + "%",
        display: "inline-block"
      });
    }
  }, e.prototype.checkResponsive = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();

    if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
      s = null;

      for (o in r.breakpoints) {
        r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
      }

      null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
    }
  }, e.prototype.changeSlide = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = i(e.currentTarget);

    switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll != 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
      case "previous":
        s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
        break;

      case "next":
        s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
        break;

      case "index":
        var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
        r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");
        break;

      default:
        return;
    }
  }, e.prototype.checkNavigable = function (i) {
    var e, t;
    if (e = this.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];else for (var o in e) {
      if (i < e[o]) {
        i = t;
        break;
      }

      t = e[o];
    }
    return i;
  }, e.prototype.cleanUpEvents = function () {
    var e = this;
    e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
  }, e.prototype.cleanUpSlideEvents = function () {
    var e = this;
    e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
  }, e.prototype.cleanUpRows = function () {
    var i,
        e = this;
    e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i));
  }, e.prototype.clickHandler = function (i) {
    !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
  }, e.prototype.destroy = function (e) {
    var t = this;
    t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
      i(this).attr("style", i(this).data("originalStyling"));
    }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t]);
  }, e.prototype.disableTransition = function (i) {
    var e = this,
        t = {};
    t[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.fadeSlide = function (i, e) {
    var t = this;
    !1 === t.cssTransitions ? (t.$slides.eq(i).css({
      zIndex: t.options.zIndex
    }), t.$slides.eq(i).animate({
      opacity: 1
    }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
      opacity: 1,
      zIndex: t.options.zIndex
    }), e && setTimeout(function () {
      t.disableTransition(i), e.call();
    }, t.options.speed));
  }, e.prototype.fadeSlideOut = function (i) {
    var e = this;
    !1 === e.cssTransitions ? e.$slides.eq(i).animate({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }));
  }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
    var e = this;
    null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
  }, e.prototype.focusHandler = function () {
    var e = this;
    e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
      t.stopImmediatePropagation();
      var o = i(this);
      setTimeout(function () {
        e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay());
      }, 0);
    });
  }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
    return this.currentSlide;
  }, e.prototype.getDotCount = function () {
    var i = this,
        e = 0,
        t = 0,
        o = 0;
    if (!0 === i.options.infinite) {
      if (i.slideCount <= i.options.slidesToShow) ++o;else for (; e < i.slideCount;) {
        ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
      }
    } else if (!0 === i.options.centerMode) o = i.slideCount;else if (i.options.asNavFor) for (; e < i.slideCount;) {
      ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
    } else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
    return o - 1;
  }, e.prototype.getLeft = function (i) {
    var e,
        t,
        o,
        s,
        n = this,
        r = 0;
    return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e;
  }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
    return this.options[i];
  }, e.prototype.getNavigableIndexes = function () {
    var i,
        e = this,
        t = 0,
        o = 0,
        s = [];

    for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, i = 2 * e.slideCount); t < i;) {
      s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
    }

    return s;
  }, e.prototype.getSlick = function () {
    return this;
  }, e.prototype.getSlideCount = function () {
    var e,
        t,
        o = this;
    return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
      if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return e = n, !1;
    }), Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll;
  }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
    this.changeSlide({
      data: {
        message: "index",
        index: parseInt(i)
      }
    }, e);
  }, e.prototype.init = function (e) {
    var t = this;
    i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay());
  }, e.prototype.initADA = function () {
    var e = this,
        t = Math.ceil(e.slideCount / e.options.slidesToShow),
        o = e.getNavigableIndexes().filter(function (i) {
      return i >= 0 && i < e.slideCount;
    });
    e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
      "aria-hidden": "true",
      tabindex: "-1"
    }).find("a, input, button, select").attr({
      tabindex: "-1"
    }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
      var s = o.indexOf(t);
      i(this).attr({
        role: "tabpanel",
        id: "slick-slide" + e.instanceUid + t,
        tabindex: -1
      }), -1 !== s && i(this).attr({
        "aria-describedby": "slick-slide-control" + e.instanceUid + s
      });
    }), e.$dots.attr("role", "tablist").find("li").each(function (s) {
      var n = o[s];
      i(this).attr({
        role: "presentation"
      }), i(this).find("button").first().attr({
        role: "tab",
        id: "slick-slide-control" + e.instanceUid + s,
        "aria-controls": "slick-slide" + e.instanceUid + n,
        "aria-label": s + 1 + " of " + t,
        "aria-selected": null,
        tabindex: "-1"
      });
    }).eq(e.currentSlide).find("button").attr({
      "aria-selected": "true",
      tabindex: "0"
    }).end());

    for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) {
      e.$slides.eq(s).attr("tabindex", 0);
    }

    e.activateADA();
  }, e.prototype.initArrowEvents = function () {
    var i = this;
    !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {
      message: "previous"
    }, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {
      message: "next"
    }, i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)));
  }, e.prototype.initDotEvents = function () {
    var e = this;
    !0 === e.options.dots && (i("li", e.$dots).on("click.slick", {
      message: "index"
    }, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
  }, e.prototype.initSlideEvents = function () {
    var e = this;
    e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
  }, e.prototype.initializeEvents = function () {
    var e = this;
    e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
      action: "start"
    }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
      action: "move"
    }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
      action: "end"
    }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
      action: "end"
    }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition);
  }, e.prototype.initUI = function () {
    var i = this;
    !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show();
  }, e.prototype.keyHandler = function (i) {
    var e = this;
    i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({
      data: {
        message: !0 === e.options.rtl ? "next" : "previous"
      }
    }) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({
      data: {
        message: !0 === e.options.rtl ? "previous" : "next"
      }
    }));
  }, e.prototype.lazyLoad = function () {
    function e(e) {
      i("img[data-lazy]", e).each(function () {
        var e = i(this),
            t = i(this).attr("data-lazy"),
            o = i(this).attr("data-srcset"),
            s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
            r = document.createElement("img");
        r.onload = function () {
          e.animate({
            opacity: 0
          }, 100, function () {
            o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({
              opacity: 1
            }, 200, function () {
              e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
            }), n.$slider.trigger("lazyLoaded", [n, e, t]);
          });
        }, r.onerror = function () {
          e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t]);
        }, r.src = t;
      });
    }

    var t,
        o,
        s,
        n = this;
    if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)), s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide, s = Math.ceil(o + n.options.slidesToShow), !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)), t = n.$slider.find(".slick-slide").slice(o, s), "anticipated" === n.options.lazyLoad) for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++) {
      r < 0 && (r = n.slideCount - 1), t = (t = t.add(d.eq(r))).add(d.eq(l)), r--, l++;
    }
    e(t), n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow));
  }, e.prototype.loadSlider = function () {
    var i = this;
    i.setPosition(), i.$slideTrack.css({
      opacity: 1
    }), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
  }, e.prototype.next = e.prototype.slickNext = function () {
    this.changeSlide({
      data: {
        message: "next"
      }
    });
  }, e.prototype.orientationChange = function () {
    var i = this;
    i.checkResponsive(), i.setPosition();
  }, e.prototype.pause = e.prototype.slickPause = function () {
    var i = this;
    i.autoPlayClear(), i.paused = !0;
  }, e.prototype.play = e.prototype.slickPlay = function () {
    var i = this;
    i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1;
  }, e.prototype.postSlide = function (e) {
    var t = this;
    t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
  }, e.prototype.prev = e.prototype.slickPrev = function () {
    this.changeSlide({
      data: {
        message: "previous"
      }
    });
  }, e.prototype.preventDefault = function (i) {
    i.preventDefault();
  }, e.prototype.progressiveLazyLoad = function (e) {
    e = e || 1;
    var t,
        o,
        s,
        n,
        r,
        l = this,
        d = i("img[data-lazy]", l.$slider);
    d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function () {
      s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === l.options.adaptiveHeight && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad();
    }, r.onerror = function () {
      e < 3 ? setTimeout(function () {
        l.progressiveLazyLoad(e + 1);
      }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad());
    }, r.src = o) : l.$slider.trigger("allImagesLoaded", [l]);
  }, e.prototype.refresh = function (e) {
    var t,
        o,
        s = this;
    o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {
      currentSlide: t
    }), s.init(), e || s.changeSlide({
      data: {
        message: "index",
        index: t
      }
    }, !1);
  }, e.prototype.registerBreakpoints = function () {
    var e,
        t,
        o,
        s = this,
        n = s.options.responsive || null;

    if ("array" === i.type(n) && n.length) {
      s.respondTo = s.options.respondTo || "window";

      for (e in n) {
        if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
          for (t = n[e].breakpoint; o >= 0;) {
            s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
          }

          s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings;
        }
      }

      s.breakpoints.sort(function (i, e) {
        return s.options.mobileFirst ? i - e : e - i;
      });
    }
  }, e.prototype.reinit = function () {
    var e = this;
    e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e]);
  }, e.prototype.resize = function () {
    var e = this;
    i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
      e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition();
    }, 50));
  }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
    var o = this;
    if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i, o.slideCount < 1 || i < 0 || i > o.slideCount - 1) return !1;
    o.unload(), !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit();
  }, e.prototype.setCSS = function (i) {
    var e,
        t,
        o = this,
        s = {};
    !0 === o.options.rtl && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {}, !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)));
  }, e.prototype.setDimensions = function () {
    var i = this;
    !1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({
      padding: "0px " + i.options.centerPadding
    }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({
      padding: i.options.centerPadding + " 0px"
    })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
    var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
    !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
  }, e.prototype.setFade = function () {
    var e,
        t = this;
    t.$slides.each(function (o, s) {
      e = t.slideWidth * o * -1, !0 === t.options.rtl ? i(s).css({
        position: "relative",
        right: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      }) : i(s).css({
        position: "relative",
        left: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      });
    }), t.$slides.eq(t.currentSlide).css({
      zIndex: t.options.zIndex - 1,
      opacity: 1
    });
  }, e.prototype.setHeight = function () {
    var i = this;

    if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.css("height", e);
    }
  }, e.prototype.setOption = e.prototype.slickSetOption = function () {
    var e,
        t,
        o,
        s,
        n,
        r = this,
        l = !1;
    if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[o] = s;else if ("multiple" === n) i.each(o, function (i, e) {
      r.options[i] = e;
    });else if ("responsive" === n) for (t in s) {
      if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]];else {
        for (e = r.options.responsive.length - 1; e >= 0;) {
          r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
        }

        r.options.responsive.push(s[t]);
      }
    }
    l && (r.unload(), r.reinit());
  }, e.prototype.setPosition = function () {
    var i = this;
    i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i]);
  }, e.prototype.setProps = function () {
    var i = this,
        e = document.body.style;
    i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType;
  }, e.prototype.setSlideClasses = function (i) {
    var e,
        t,
        o,
        s,
        n = this;

    if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode) {
      var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
      e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center");
    } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = !0 === n.options.infinite ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));

    "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad();
  }, e.prototype.setupInfinite = function () {
    var e,
        t,
        o,
        s = this;

    if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (t = null, s.slideCount > s.options.slidesToShow)) {
      for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) {
        t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
      }

      for (e = 0; e < o + s.slideCount; e += 1) {
        t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
      }

      s.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
        i(this).attr("id", "");
      });
    }
  }, e.prototype.interrupt = function (i) {
    var e = this;
    i || e.autoPlay(), e.interrupted = i;
  }, e.prototype.selectHandler = function (e) {
    var t = this,
        o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
        s = parseInt(o.attr("data-slick-index"));
    s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s);
  }, e.prototype.slideHandler = function (i, e, t) {
    var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;
    if (e = e || !1, !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i)) if (!1 === e && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o));else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o));else {
      if (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide), a.updateDots(), a.updateArrows(), !0 === a.options.fade) return !0 !== t ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
        a.postSlide(s);
      })) : a.postSlide(s), void a.animateHeight();
      !0 !== t ? a.animateSlide(d, function () {
        a.postSlide(s);
      }) : a.postSlide(s);
    }
  }, e.prototype.startLoad = function () {
    var i = this;
    !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading");
  }, e.prototype.swipeDirection = function () {
    var i,
        e,
        t,
        o,
        s = this;
    return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical";
  }, e.prototype.swipeEnd = function (i) {
    var e,
        t,
        o = this;
    if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
    if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;

    if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
      switch (t = o.swipeDirection()) {
        case "left":
        case "down":
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
          break;

        case "right":
        case "up":
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1;
      }

      "vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]));
    } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {});
  }, e.prototype.swipeHandler = function (i) {
    var e = this;
    if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
      case "start":
        e.swipeStart(i);
        break;

      case "move":
        e.swipeMove(i);
        break;

      case "end":
        e.swipeEnd(i);
    }
  }, e.prototype.swipeMove = function (i) {
    var e,
        t,
        o,
        s,
        n,
        r,
        l = this;
    return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s), !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))));
  }, e.prototype.swipeStart = function (i) {
    var e,
        t = this;
    if (t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow) return t.touchObject = {}, !1;
    void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, t.dragging = !0;
  }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
    var i = this;
    null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
  }, e.prototype.unload = function () {
    var e = this;
    i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
  }, e.prototype.unslick = function (i) {
    var e = this;
    e.$slider.trigger("unslick", [e, i]), e.destroy();
  }, e.prototype.updateArrows = function () {
    var i = this;
    Math.floor(i.options.slidesToShow / 2), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
  }, e.prototype.updateDots = function () {
    var i = this;
    null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"));
  }, e.prototype.visibility = function () {
    var i = this;
    i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1);
  }, i.fn.slick = function () {
    var i,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;

    for (i = 0; i < r; i++) {
      if ("object" == _typeof2(s) || void 0 === s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), void 0 !== t) return t;
    }

    return o;
  };
});
/**
 * easytimer.js
 * Generated: 2018-12-14
 * Version: 2.4.0
 */

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.Timer = factory();
})(this, function () {
  'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
      _typeof = function _typeof(obj) {
        return _typeof2(obj);
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
      };
    }

    return _typeof(obj);
  }

  function leftPadding(string, padLength, character) {
    var i;
    var characters = '';

    if (string.length > padLength) {
      return string;
    }

    for (i = 0; i < padLength; i = i + 1) {
      characters += String(character);
    }

    return (characters + string).slice(-characters.length);
  }

  function TimeCounter() {
    this.secondTenths = 0;
    this.seconds = 0;
    this.minutes = 0;
    this.hours = 0;
    this.days = 0;
    /**
     * [toString convert the counted values on a string]
     * @param  {[array]} units           [array with the units to display]
     * @param  {[string]} separator       [separator of the units]
     * @param  {[integer]} leftZeroPadding [number of zero padding]
     * @return {[string]}                 [result string]
     */

    this.toString = function (units, separator, leftZeroPadding) {
      units = units || ['hours', 'minutes', 'seconds'];
      separator = separator || ':';
      leftZeroPadding = leftZeroPadding || 2;
      var stringTime;
      var arrayTime = [];
      var i;

      for (i = 0; i < units.length; i = i + 1) {
        if (this[units[i]] !== undefined) {
          if (units[i] === 'secondTenths') {
            arrayTime.push(this[units[i]]);
          } else {
            arrayTime.push(leftPadding(this[units[i]], leftZeroPadding, '0'));
          }
        }
      }

      stringTime = arrayTime.join(separator);
      return stringTime;
    };
  }
  /*
  * Polyfill por IE9, IE10 and IE11
  */


  var CustomEvent$1 = typeof window !== 'undefined' ? window.CustomEvent : undefined;

  if (typeof window !== 'undefined' && typeof CustomEvent$1 !== 'function') {
    CustomEvent$1 = function CustomEvent(event, params) {
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined
      };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    };

    CustomEvent$1.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent$1;
  }
  /*
   * General functions, variables and constants
   */


  var SECOND_TENTHS_PER_SECOND = 10;
  var SECONDS_PER_MINUTE = 60;
  var MINUTES_PER_HOUR = 60;
  var HOURS_PER_DAY = 24;
  var SECOND_TENTHS_POSITION = 0;
  var SECONDS_POSITION = 1;
  var MINUTES_POSITION = 2;
  var HOURS_POSITION = 3;
  var DAYS_POSITION = 4;
  var SECOND_TENTHS = 'secondTenths';
  var SECONDS = 'seconds';
  var MINUTES = 'minutes';
  var HOURS = 'hours';
  var DAYS = 'days';
  var unitsInMilliseconds = {
    secondTenths: 100,
    seconds: 1000,
    minutes: 60000,
    hours: 3600000,
    days: 86400000
  };
  var groupedUnits = {
    secondTenths: SECOND_TENTHS_PER_SECOND,
    seconds: SECONDS_PER_MINUTE,
    minutes: MINUTES_PER_HOUR,
    hours: HOURS_PER_DAY
  };
  var events = typeof module !== 'undefined' && module.exports && typeof require === 'function' ? require('events') : undefined;

  function hasDOM() {
    return typeof document !== 'undefined';
  }

  function hasEventEmitter() {
    return events;
  }

  function mod(number, module) {
    return (number % module + module) % module;
  }
  /**
   * [Timer Timer/Chronometer/Countdown compatible with AMD and NodeJS.
   * Can update time values with different time intervals: tenth of seconds,
   * seconds, minutes and hours.]
   */


  function Timer() {
    /*
    * PRIVATE variables and Functions
    */
    var counters = new TimeCounter();
    var totalCounters = new TimeCounter();
    var intervalId;
    var eventEmitter = hasDOM() ? document.createElement('span') : hasEventEmitter() ? new events.EventEmitter() : undefined;
    var running = false;
    var paused = false;
    var precision;
    var timerTypeFactor;
    var customCallback;
    var timerConfig = {};
    var currentParams;
    var targetValues;
    var startValues;
    var countdown;
    var startingDate;
    var targetDate;
    var eventData = {
      detail: {
        timer: this
      }
    };

    function updateCounters(precision, roundedValue) {
      totalCounters[precision] = roundedValue;

      if (precision === DAYS) {
        counters[precision] = roundedValue;
      } else if (roundedValue >= 0) {
        counters[precision] = mod(roundedValue, groupedUnits[precision]);
      } else {
        counters[precision] = groupedUnits[precision] - mod(roundedValue, groupedUnits[precision]);
      }
    }

    function updateDays(value) {
      return updateUnitByPrecision(value, DAYS);
    }

    function updateHours(value) {
      return updateUnitByPrecision(value, HOURS);
    }

    function updateMinutes(value) {
      return updateUnitByPrecision(value, MINUTES);
    }

    function updateSeconds(value) {
      return updateUnitByPrecision(value, SECONDS);
    }

    function updateSecondTenths(value) {
      return updateUnitByPrecision(value, SECOND_TENTHS);
    }

    function updateUnitByPrecision(value, precision) {
      var previousValue = totalCounters[precision];
      updateCounters(precision, calculateIntegerUnitQuotient(value, unitsInMilliseconds[precision]));
      return totalCounters[precision] !== previousValue;
    }

    function stopTimerAndResetCounters() {
      stopTimer();
      resetCounters();
    }

    function stopTimer() {
      clearInterval(intervalId);
      intervalId = undefined;
      running = false;
      paused = false;
    }

    function setParamsAndStartTimer(params) {
      if (!isPaused()) {
        setParams(params);
      } else {
        startingDate = calculateStartingDate();
        targetValues = setTarget(currentParams.target);
      }

      startTimer();
    }

    function startTimer() {
      var interval = unitsInMilliseconds[precision];

      if (isTargetAchieved(roundTimestamp(Date.now()))) {
        return;
      }

      intervalId = setInterval(updateTimerAndDispatchEvents, interval);
      running = true;
      paused = false;
    }

    function calculateStartingDate() {
      return roundTimestamp(Date.now()) - totalCounters.secondTenths * unitsInMilliseconds[SECOND_TENTHS] * timerTypeFactor;
    }

    function updateTimerAndDispatchEvents() {
      var currentTime = roundTimestamp(Date.now());
      var valuesUpdated = updateTimer();
      dispatchEvents(valuesUpdated);
      customCallback(eventData.detail.timer);

      if (isTargetAchieved(currentTime)) {
        stop();
        dispatchEvent('targetAchieved', eventData);
      }
    }

    function updateTimer() {
      var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : roundTimestamp(Date.now());
      var ellapsedTime = timerTypeFactor > 0 ? currentTime - startingDate : startingDate - currentTime;
      var valuesUpdated = {};
      valuesUpdated[SECOND_TENTHS] = updateSecondTenths(ellapsedTime);
      valuesUpdated[SECONDS] = updateSeconds(ellapsedTime);
      valuesUpdated[MINUTES] = updateMinutes(ellapsedTime);
      valuesUpdated[HOURS] = updateHours(ellapsedTime);
      valuesUpdated[DAYS] = updateDays(ellapsedTime);
      return valuesUpdated;
    }

    function roundTimestamp(timestamp) {
      return Math.floor(timestamp / unitsInMilliseconds[precision]) * unitsInMilliseconds[precision];
    }

    function dispatchEvents(valuesUpdated) {
      if (valuesUpdated[SECOND_TENTHS]) {
        dispatchEvent('secondTenthsUpdated', eventData);
      }

      if (valuesUpdated[SECONDS]) {
        dispatchEvent('secondsUpdated', eventData);
      }

      if (valuesUpdated[MINUTES]) {
        dispatchEvent('minutesUpdated', eventData);
      }

      if (valuesUpdated[HOURS]) {
        dispatchEvent('hoursUpdated', eventData);
      }

      if (valuesUpdated[DAYS]) {
        dispatchEvent('daysUpdated', eventData);
      }
    }

    function isTargetAchieved(currentDate) {
      return targetValues instanceof Array && currentDate >= targetDate;
    }

    function resetCounters() {
      for (var counter in counters) {
        if (counters.hasOwnProperty(counter) && typeof counters[counter] === 'number') {
          counters[counter] = 0;
        }
      }

      for (var _counter in totalCounters) {
        if (totalCounters.hasOwnProperty(_counter) && typeof totalCounters[_counter] === 'number') {
          totalCounters[_counter] = 0;
        }
      }
    }

    function setParams(params) {
      params = params || {};
      precision = typeof params.precision === 'string' ? params.precision : SECONDS;
      customCallback = typeof params.callback === 'function' ? params.callback : function () {};
      countdown = params.countdown === true;
      timerTypeFactor = countdown === true ? -1 : 1;

      if (_typeof(params.startValues) === 'object') {
        setStartValues(params.startValues);
      } else {
        startValues = null;
      }

      startingDate = calculateStartingDate();
      updateTimer();

      if (_typeof(params.target) === 'object') {
        targetValues = setTarget(params.target);
      } else if (countdown) {
        params.target = {
          seconds: 0
        };
        targetValues = setTarget(params.target);
      } else {
        targetValues = null;
      }

      timerConfig = {
        precision: precision,
        callback: customCallback,
        countdown: _typeof(params) === 'object' && params.countdown === true,
        target: targetValues,
        startValues: startValues
      };
      currentParams = params;
    }

    function configInputValues(inputValues) {
      var secondTenths, seconds, minutes, hours, days, values;

      if (_typeof(inputValues) === 'object') {
        if (inputValues instanceof Array) {
          if (inputValues.length !== 5) {
            throw new Error('Array size not valid');
          }

          values = inputValues;
        } else {
          values = [inputValues.secondTenths || 0, inputValues.seconds || 0, inputValues.minutes || 0, inputValues.hours || 0, inputValues.days || 0];
        }
      }

      secondTenths = values[SECOND_TENTHS_POSITION];
      seconds = values[SECONDS_POSITION] + calculateIntegerUnitQuotient(secondTenths, SECOND_TENTHS_PER_SECOND);
      minutes = values[MINUTES_POSITION] + calculateIntegerUnitQuotient(seconds, SECONDS_PER_MINUTE);
      hours = values[HOURS_POSITION] + calculateIntegerUnitQuotient(minutes, MINUTES_PER_HOUR);
      days = values[DAYS_POSITION] + calculateIntegerUnitQuotient(hours, HOURS_PER_DAY);
      values[SECOND_TENTHS_POSITION] = secondTenths % SECOND_TENTHS_PER_SECOND;
      values[SECONDS_POSITION] = seconds % SECONDS_PER_MINUTE;
      values[MINUTES_POSITION] = minutes % MINUTES_PER_HOUR;
      values[HOURS_POSITION] = hours % HOURS_PER_DAY;
      values[DAYS_POSITION] = days;
      return values;
    }

    function calculateIntegerUnitQuotient(unit, divisor) {
      var quotient = unit / divisor;
      return quotient < 0 ? Math.ceil(quotient) : Math.floor(quotient);
    }

    function setTarget(inputTarget) {
      if (!inputTarget) {
        return;
      }

      targetValues = configInputValues(inputTarget);
      var targetCounter = calculateTotalCounterFromValues(targetValues);
      targetDate = startingDate + targetCounter.secondTenths * unitsInMilliseconds[SECOND_TENTHS] * timerTypeFactor;
      return targetValues;
    }

    function setStartValues(inputStartValues) {
      startValues = configInputValues(inputStartValues);
      counters.secondTenths = startValues[SECOND_TENTHS_POSITION];
      counters.seconds = startValues[SECONDS_POSITION];
      counters.minutes = startValues[MINUTES_POSITION];
      counters.hours = startValues[HOURS_POSITION];
      counters.days = startValues[DAYS_POSITION];
      totalCounters = calculateTotalCounterFromValues(startValues, totalCounters);
    }

    function calculateTotalCounterFromValues(values, outputCounter) {
      var total = outputCounter || {};
      total.days = values[DAYS_POSITION];
      total.hours = total.days * HOURS_PER_DAY + values[HOURS_POSITION];
      total.minutes = total.hours * MINUTES_PER_HOUR + values[MINUTES_POSITION];
      total.seconds = total.minutes * SECONDS_PER_MINUTE + values[SECONDS_POSITION];
      total.secondTenths = total.seconds * SECOND_TENTHS_PER_SECOND + values[[SECOND_TENTHS_POSITION]];
      return total;
    }
    /*
     * PUBLIC functions
     */

    /**
     * [stop stops the timer and resets the counters. Dispatch stopped event]
     */


    function stop() {
      stopTimerAndResetCounters();
      dispatchEvent('stopped', eventData);
    }
    /**
     * [stop stops and starts the timer. Dispatch stopped event]
     */


    function reset() {
      stopTimerAndResetCounters();
      setParamsAndStartTimer(currentParams);
      dispatchEvent('reset', eventData);
    }
    /**
     * [start starts the timer configured by the params object. Dispatch started event]
     * @param  {[object]} params [Configuration parameters]
     */


    function start(params) {
      if (isRunning()) {
        return;
      }

      setParamsAndStartTimer(params);
      dispatchEvent('started', eventData);
    }
    /**
     * [pause stops the timer without resetting the counters. The timer it can be restarted with start function.
     * Dispatch paused event]
     * @return {[type]} [description]
     */


    function pause() {
      stopTimer();
      paused = true;
      dispatchEvent('paused', eventData);
    }
    /**
     * [addEventListener Adds event listener to the timer]
     * @param {[string]} event      [event to listen]
     * @param {[function]} listener   [the event listener function]
     */


    function addEventListener(event, listener) {
      if (hasDOM()) {
        eventEmitter.addEventListener(event, listener);
      } else if (hasEventEmitter()) {
        eventEmitter.on(event, listener);
      }
    }
    /**
     * [removeEventListener Removes event listener to the timer]
     * @param  {[string]} event    [event to remove listener]
     * @param  {[function]} listener [listener to remove]
     */


    function removeEventListener(event, listener) {
      if (hasDOM()) {
        eventEmitter.removeEventListener(event, listener);
      } else if (hasEventEmitter()) {
        eventEmitter.removeListener(event, listener);
      }
    }
    /**
     * [dispatchEvent dispatchs an event]
     * @param  {string} event [event to dispatch]
     */


    function dispatchEvent(event, data) {
      if (hasDOM()) {
        eventEmitter.dispatchEvent(new CustomEvent(event, data));
      } else if (hasEventEmitter()) {
        eventEmitter.emit(event, data);
      }
    }
    /**
     * [isRunning return true if the timer is running]
     * @return {Boolean}
     */


    function isRunning() {
      return running;
    }
    /**
     * [isPaused returns true if the timer is paused]
     * @return {Boolean}
     */


    function isPaused() {
      return paused;
    }
    /**
     * [getTimeValues returns the counter with the current timer values]
     * @return {[TimeCounter]}
     */


    function getTimeValues() {
      return counters;
    }
    /**
     * [getTotalTimeValues returns the counter with the current timer total values]
     * @return {[TimeCounter]}
     */


    function getTotalTimeValues() {
      return totalCounters;
    }
    /**
     * [getConfig returns the configuration paramameters]
     * @return {[type]}
     */


    function getConfig() {
      return timerConfig;
    }
    /**
     * Public API
     * Definition of Timer instance public functions
     */


    if (typeof this !== 'undefined') {
      this.start = start;
      this.pause = pause;
      this.stop = stop;
      this.reset = reset;
      this.isRunning = isRunning;
      this.isPaused = isPaused;
      this.getTimeValues = getTimeValues;
      this.getTotalTimeValues = getTotalTimeValues;
      this.getConfig = getConfig;
      this.addEventListener = addEventListener;
      this.on = addEventListener;
      this.removeEventListener = removeEventListener;
      this.off = removeEventListener;
    }
  }

  return Timer;
});
/*!
 * MediaElement.js
 * http://www.mediaelementjs.com/
 *
 * Wrapper that mimics native HTML5 MediaElement (audio and video)
 * using a variety of technologies (pure JavaScript, Flash, iframe)
 *
 * Copyright 2010-2017, John Dyer (http://j.hn/)
 * License: MIT
 *
 */


(function e(t, n, r) {
  function s(o, u) {
    if (!n[o]) {
      if (!t[o]) {
        var a = typeof require == "function" && require;
        if (!u && a) return a(o, !0);
        if (i) return i(o, !0);
        var f = new Error("Cannot find module '" + o + "'");
        throw f.code = "MODULE_NOT_FOUND", f;
      }

      var l = n[o] = {
        exports: {}
      };
      t[o][0].call(l.exports, function (e) {
        var n = t[o][1][e];
        return s(n ? n : e);
      }, l, l.exports, e, t, n, r);
    }

    return n[o].exports;
  }

  var i = typeof require == "function" && require;

  for (var o = 0; o < r.length; o++) {
    s(r[o]);
  }

  return s;
})({
  1: [function (_dereq_, module, exports) {}, {}],
  2: [function (_dereq_, module, exports) {
    (function (global) {
      var topLevel = typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : {};

      var minDoc = _dereq_(1);

      var doccy;

      if (typeof document !== 'undefined') {
        doccy = document;
      } else {
        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];

        if (!doccy) {
          doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
        }
      }

      module.exports = doccy;
    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
  }, {
    "1": 1
  }],
  3: [function (_dereq_, module, exports) {
    (function (global) {
      var win;

      if (typeof window !== "undefined") {
        win = window;
      } else if (typeof global !== "undefined") {
        win = global;
      } else if (typeof self !== "undefined") {
        win = self;
      } else {
        win = {};
      }

      module.exports = win;
    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
  }, {}],
  4: [function (_dereq_, module, exports) {
    (function (root) {
      // Store setTimeout reference so promise-polyfill will be unaffected by
      // other code modifying setTimeout (like sinon.useFakeTimers())
      var setTimeoutFunc = setTimeout;

      function noop() {} // Polyfill for Function.prototype.bind


      function bind(fn, thisArg) {
        return function () {
          fn.apply(thisArg, arguments);
        };
      }

      function Promise(fn) {
        if (_typeof2(this) !== 'object') throw new TypeError('Promises must be constructed via new');
        if (typeof fn !== 'function') throw new TypeError('not a function');
        this._state = 0;
        this._handled = false;
        this._value = undefined;
        this._deferreds = [];
        doResolve(fn, this);
      }

      function handle(self, deferred) {
        while (self._state === 3) {
          self = self._value;
        }

        if (self._state === 0) {
          self._deferreds.push(deferred);

          return;
        }

        self._handled = true;

        Promise._immediateFn(function () {
          var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;

          if (cb === null) {
            (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
            return;
          }

          var ret;

          try {
            ret = cb(self._value);
          } catch (e) {
            reject(deferred.promise, e);
            return;
          }

          resolve(deferred.promise, ret);
        });
      }

      function resolve(self, newValue) {
        try {
          // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
          if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');

          if (newValue && (_typeof2(newValue) === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;

            if (newValue instanceof Promise) {
              self._state = 3;
              self._value = newValue;
              finale(self);
              return;
            } else if (typeof then === 'function') {
              doResolve(bind(then, newValue), self);
              return;
            }
          }

          self._state = 1;
          self._value = newValue;
          finale(self);
        } catch (e) {
          reject(self, e);
        }
      }

      function reject(self, newValue) {
        self._state = 2;
        self._value = newValue;
        finale(self);
      }

      function finale(self) {
        if (self._state === 2 && self._deferreds.length === 0) {
          Promise._immediateFn(function () {
            if (!self._handled) {
              Promise._unhandledRejectionFn(self._value);
            }
          });
        }

        for (var i = 0, len = self._deferreds.length; i < len; i++) {
          handle(self, self._deferreds[i]);
        }

        self._deferreds = null;
      }

      function Handler(onFulfilled, onRejected, promise) {
        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
        this.promise = promise;
      }
      /**
       * Take a potentially misbehaving resolver function and make sure
       * onFulfilled and onRejected are only called once.
       *
       * Makes no guarantees about asynchrony.
       */


      function doResolve(fn, self) {
        var done = false;

        try {
          fn(function (value) {
            if (done) return;
            done = true;
            resolve(self, value);
          }, function (reason) {
            if (done) return;
            done = true;
            reject(self, reason);
          });
        } catch (ex) {
          if (done) return;
          done = true;
          reject(self, ex);
        }
      }

      Promise.prototype['catch'] = function (onRejected) {
        return this.then(null, onRejected);
      };

      Promise.prototype.then = function (onFulfilled, onRejected) {
        var prom = new this.constructor(noop);
        handle(this, new Handler(onFulfilled, onRejected, prom));
        return prom;
      };

      Promise.all = function (arr) {
        var args = Array.prototype.slice.call(arr);
        return new Promise(function (resolve, reject) {
          if (args.length === 0) return resolve([]);
          var remaining = args.length;

          function res(i, val) {
            try {
              if (val && (_typeof2(val) === 'object' || typeof val === 'function')) {
                var then = val.then;

                if (typeof then === 'function') {
                  then.call(val, function (val) {
                    res(i, val);
                  }, reject);
                  return;
                }
              }

              args[i] = val;

              if (--remaining === 0) {
                resolve(args);
              }
            } catch (ex) {
              reject(ex);
            }
          }

          for (var i = 0; i < args.length; i++) {
            res(i, args[i]);
          }
        });
      };

      Promise.resolve = function (value) {
        if (value && _typeof2(value) === 'object' && value.constructor === Promise) {
          return value;
        }

        return new Promise(function (resolve) {
          resolve(value);
        });
      };

      Promise.reject = function (value) {
        return new Promise(function (resolve, reject) {
          reject(value);
        });
      };

      Promise.race = function (values) {
        return new Promise(function (resolve, reject) {
          for (var i = 0, len = values.length; i < len; i++) {
            values[i].then(resolve, reject);
          }
        });
      }; // Use polyfill for setImmediate for performance gains


      Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
        setImmediate(fn);
      } || function (fn) {
        setTimeoutFunc(fn, 0);
      };

      Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
        if (typeof console !== 'undefined' && console) {
          console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
        }
      };
      /**
       * Set the immediate function to execute callbacks
       * @param fn {function} Function to execute
       * @deprecated
       */


      Promise._setImmediateFn = function _setImmediateFn(fn) {
        Promise._immediateFn = fn;
      };
      /**
       * Change the function to execute on unhandled rejection
       * @param {function} fn Function to execute on unhandled rejection
       * @deprecated
       */


      Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
        Promise._unhandledRejectionFn = fn;
      };

      if (typeof module !== 'undefined' && module.exports) {
        module.exports = Promise;
      } else if (!root.Promise) {
        root.Promise = Promise;
      }
    })(this);
  }, {}],
  5: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _en = _dereq_(15);

    var _general = _dereq_(27);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var i18n = {
      lang: 'en',
      en: _en.EN
    };

    i18n.language = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (args !== null && args !== undefined && args.length) {
        if (typeof args[0] !== 'string') {
          throw new TypeError('Language code must be a string value');
        }

        if (!/^[a-z]{2,3}((\-|_)[a-z]{2})?$/i.test(args[0])) {
          throw new TypeError('Language code must have format 2-3 letters and. optionally, hyphen, underscore followed by 2 more letters');
        }

        i18n.lang = args[0];

        if (i18n[args[0]] === undefined) {
          args[1] = args[1] !== null && args[1] !== undefined && _typeof(args[1]) === 'object' ? args[1] : {};
          i18n[args[0]] = !(0, _general.isObjectEmpty)(args[1]) ? args[1] : _en.EN;
        } else if (args[1] !== null && args[1] !== undefined && _typeof(args[1]) === 'object') {
          i18n[args[0]] = args[1];
        }
      }

      return i18n.lang;
    };

    i18n.t = function (message) {
      var pluralParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof message === 'string' && message.length) {
        var str = void 0,
            pluralForm = void 0;
        var language = i18n.language();

        var _plural = function _plural(input, number, form) {
          if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) !== 'object' || typeof number !== 'number' || typeof form !== 'number') {
            return input;
          }

          var _pluralForms = function () {
            return [function () {
              return arguments.length <= 1 ? undefined : arguments[1];
            }, function () {
              return (arguments.length <= 0 ? undefined : arguments[0]) === 1 ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 2 ? undefined : arguments[2];
            }, function () {
              return (arguments.length <= 0 ? undefined : arguments[0]) === 0 || (arguments.length <= 0 ? undefined : arguments[0]) === 1 ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 2 ? undefined : arguments[2];
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) % 10 === 1 && (arguments.length <= 0 ? undefined : arguments[0]) % 100 !== 11) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) !== 0) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else {
                return arguments.length <= 3 ? undefined : arguments[3];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 1 || (arguments.length <= 0 ? undefined : arguments[0]) === 11) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) === 2 || (arguments.length <= 0 ? undefined : arguments[0]) === 12) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) > 2 && (arguments.length <= 0 ? undefined : arguments[0]) < 20) {
                return arguments.length <= 3 ? undefined : arguments[3];
              } else {
                return arguments.length <= 4 ? undefined : arguments[4];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 1) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) === 0 || (arguments.length <= 0 ? undefined : arguments[0]) % 100 > 0 && (arguments.length <= 0 ? undefined : arguments[0]) % 100 < 20) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else {
                return arguments.length <= 3 ? undefined : arguments[3];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) % 10 === 1 && (arguments.length <= 0 ? undefined : arguments[0]) % 100 !== 11) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) % 10 >= 2 && ((arguments.length <= 0 ? undefined : arguments[0]) % 100 < 10 || (arguments.length <= 0 ? undefined : arguments[0]) % 100 >= 20)) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else {
                return [3];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) % 10 === 1 && (arguments.length <= 0 ? undefined : arguments[0]) % 100 !== 11) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) % 10 >= 2 && (arguments.length <= 0 ? undefined : arguments[0]) % 10 <= 4 && ((arguments.length <= 0 ? undefined : arguments[0]) % 100 < 10 || (arguments.length <= 0 ? undefined : arguments[0]) % 100 >= 20)) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else {
                return arguments.length <= 3 ? undefined : arguments[3];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 1) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) >= 2 && (arguments.length <= 0 ? undefined : arguments[0]) <= 4) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else {
                return arguments.length <= 3 ? undefined : arguments[3];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 1) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) % 10 >= 2 && (arguments.length <= 0 ? undefined : arguments[0]) % 10 <= 4 && ((arguments.length <= 0 ? undefined : arguments[0]) % 100 < 10 || (arguments.length <= 0 ? undefined : arguments[0]) % 100 >= 20)) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else {
                return arguments.length <= 3 ? undefined : arguments[3];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) % 100 === 1) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) % 100 === 2) {
                return arguments.length <= 3 ? undefined : arguments[3];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) % 100 === 3 || (arguments.length <= 0 ? undefined : arguments[0]) % 100 === 4) {
                return arguments.length <= 4 ? undefined : arguments[4];
              } else {
                return arguments.length <= 1 ? undefined : arguments[1];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 1) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) === 2) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) > 2 && (arguments.length <= 0 ? undefined : arguments[0]) < 7) {
                return arguments.length <= 3 ? undefined : arguments[3];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) > 6 && (arguments.length <= 0 ? undefined : arguments[0]) < 11) {
                return arguments.length <= 4 ? undefined : arguments[4];
              } else {
                return arguments.length <= 5 ? undefined : arguments[5];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 0) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) === 1) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) === 2) {
                return arguments.length <= 3 ? undefined : arguments[3];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) % 100 >= 3 && (arguments.length <= 0 ? undefined : arguments[0]) % 100 <= 10) {
                return arguments.length <= 4 ? undefined : arguments[4];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) % 100 >= 11) {
                return arguments.length <= 5 ? undefined : arguments[5];
              } else {
                return arguments.length <= 6 ? undefined : arguments[6];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 1) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) === 0 || (arguments.length <= 0 ? undefined : arguments[0]) % 100 > 1 && (arguments.length <= 0 ? undefined : arguments[0]) % 100 < 11) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) % 100 > 10 && (arguments.length <= 0 ? undefined : arguments[0]) % 100 < 20) {
                return arguments.length <= 3 ? undefined : arguments[3];
              } else {
                return arguments.length <= 4 ? undefined : arguments[4];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) % 10 === 1) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) % 10 === 2) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else {
                return arguments.length <= 3 ? undefined : arguments[3];
              }
            }, function () {
              return (arguments.length <= 0 ? undefined : arguments[0]) !== 11 && (arguments.length <= 0 ? undefined : arguments[0]) % 10 === 1 ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 2 ? undefined : arguments[2];
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 1) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) % 10 >= 2 && (arguments.length <= 0 ? undefined : arguments[0]) % 10 <= 4 && ((arguments.length <= 0 ? undefined : arguments[0]) % 100 < 10 || (arguments.length <= 0 ? undefined : arguments[0]) % 100 >= 20)) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else {
                return arguments.length <= 3 ? undefined : arguments[3];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 1) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) === 2) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) !== 8 && (arguments.length <= 0 ? undefined : arguments[0]) !== 11) {
                return arguments.length <= 3 ? undefined : arguments[3];
              } else {
                return arguments.length <= 4 ? undefined : arguments[4];
              }
            }, function () {
              return (arguments.length <= 0 ? undefined : arguments[0]) === 0 ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 2 ? undefined : arguments[2];
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 1) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) === 2) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) === 3) {
                return arguments.length <= 3 ? undefined : arguments[3];
              } else {
                return arguments.length <= 4 ? undefined : arguments[4];
              }
            }, function () {
              if ((arguments.length <= 0 ? undefined : arguments[0]) === 0) {
                return arguments.length <= 1 ? undefined : arguments[1];
              } else if ((arguments.length <= 0 ? undefined : arguments[0]) === 1) {
                return arguments.length <= 2 ? undefined : arguments[2];
              } else {
                return arguments.length <= 3 ? undefined : arguments[3];
              }
            }];
          }();

          return _pluralForms[form].apply(null, [number].concat(input));
        };

        if (i18n[language] !== undefined) {
          str = i18n[language][message];

          if (pluralParam !== null && typeof pluralParam === 'number') {
            pluralForm = i18n[language]['mejs.plural-form'];
            str = _plural.apply(null, [str, pluralParam, pluralForm]);
          }
        }

        if (!str && i18n.en) {
          str = i18n.en[message];

          if (pluralParam !== null && typeof pluralParam === 'number') {
            pluralForm = i18n.en['mejs.plural-form'];
            str = _plural.apply(null, [str, pluralParam, pluralForm]);
          }
        }

        str = str || message;

        if (pluralParam !== null && typeof pluralParam === 'number') {
          str = str.replace('%1', pluralParam);
        }

        return (0, _general.escapeHTML)(str);
      }

      return message;
    };

    _mejs2.default.i18n = i18n;

    if (typeof mejsL10n !== 'undefined') {
      _mejs2.default.i18n.language(mejsL10n.language, mejsL10n.strings);
    }

    exports.default = i18n;
  }, {
    "15": 15,
    "27": 27,
    "7": 7
  }],
  6: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _general = _dereq_(27);

    var _media2 = _dereq_(28);

    var _renderer = _dereq_(8);

    var _constants = _dereq_(25);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var MediaElement = function MediaElement(idOrNode, options, sources) {
      var _this = this;

      _classCallCheck(this, MediaElement);

      var t = this;
      sources = Array.isArray(sources) ? sources : null;
      t.defaults = {
        renderers: [],
        fakeNodeName: 'mediaelementwrapper',
        pluginPath: 'build/',
        shimScriptAccess: 'sameDomain'
      };
      options = Object.assign(t.defaults, options);
      t.mediaElement = _document2.default.createElement(options.fakeNodeName);
      var id = idOrNode,
          error = false;

      if (typeof idOrNode === 'string') {
        t.mediaElement.originalNode = _document2.default.getElementById(idOrNode);
      } else {
        t.mediaElement.originalNode = idOrNode;
        id = idOrNode.id;
      }

      if (t.mediaElement.originalNode === undefined || t.mediaElement.originalNode === null) {
        return null;
      }

      t.mediaElement.options = options;
      id = id || 'mejs_' + Math.random().toString().slice(2);
      t.mediaElement.originalNode.setAttribute('id', id + '_from_mejs');
      var tagName = t.mediaElement.originalNode.tagName.toLowerCase();

      if (['video', 'audio'].indexOf(tagName) > -1 && !t.mediaElement.originalNode.getAttribute('preload')) {
        t.mediaElement.originalNode.setAttribute('preload', 'none');
      }

      t.mediaElement.originalNode.parentNode.insertBefore(t.mediaElement, t.mediaElement.originalNode);
      t.mediaElement.appendChild(t.mediaElement.originalNode);

      var processURL = function processURL(url, type) {
        if (_window2.default.location.protocol === 'https:' && url.indexOf('http:') === 0 && _constants.IS_IOS && _mejs2.default.html5media.mediaTypes.indexOf(type) > -1) {
          var xhr = new XMLHttpRequest();

          xhr.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
              var _url = _window2.default.URL || _window2.default.webkitURL,
                  blobUrl = _url.createObjectURL(this.response);

              t.mediaElement.originalNode.setAttribute('src', blobUrl);
              return blobUrl;
            }

            return url;
          };

          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.send();
        }

        return url;
      };

      var mediaFiles = void 0;

      if (sources !== null) {
        mediaFiles = sources;
      } else if (t.mediaElement.originalNode !== null) {
        mediaFiles = [];

        switch (t.mediaElement.originalNode.nodeName.toLowerCase()) {
          case 'iframe':
            mediaFiles.push({
              type: '',
              src: t.mediaElement.originalNode.getAttribute('src')
            });
            break;

          case 'audio':
          case 'video':
            var _sources = t.mediaElement.originalNode.children.length,
                nodeSource = t.mediaElement.originalNode.getAttribute('src');

            if (nodeSource) {
              var node = t.mediaElement.originalNode,
                  type = (0, _media2.formatType)(nodeSource, node.getAttribute('type'));
              mediaFiles.push({
                type: type,
                src: processURL(nodeSource, type)
              });
            }

            for (var i = 0; i < _sources; i++) {
              var n = t.mediaElement.originalNode.children[i];

              if (n.tagName.toLowerCase() === 'source') {
                var src = n.getAttribute('src'),
                    _type = (0, _media2.formatType)(src, n.getAttribute('type'));

                mediaFiles.push({
                  type: _type,
                  src: processURL(src, _type)
                });
              }
            }

            break;
        }
      }

      t.mediaElement.id = id;
      t.mediaElement.renderers = {};
      t.mediaElement.events = {};
      t.mediaElement.promises = [];
      t.mediaElement.renderer = null;
      t.mediaElement.rendererName = null;

      t.mediaElement.changeRenderer = function (rendererName, mediaFiles) {
        var t = _this,
            media = Object.keys(mediaFiles[0]).length > 2 ? mediaFiles[0] : mediaFiles[0].src;

        if (t.mediaElement.renderer !== undefined && t.mediaElement.renderer !== null && t.mediaElement.renderer.name === rendererName) {
          t.mediaElement.renderer.pause();

          if (t.mediaElement.renderer.stop) {
            t.mediaElement.renderer.stop();
          }

          t.mediaElement.renderer.show();
          t.mediaElement.renderer.setSrc(media);
          return true;
        }

        if (t.mediaElement.renderer !== undefined && t.mediaElement.renderer !== null) {
          t.mediaElement.renderer.pause();

          if (t.mediaElement.renderer.stop) {
            t.mediaElement.renderer.stop();
          }

          t.mediaElement.renderer.hide();
        }

        var newRenderer = t.mediaElement.renderers[rendererName],
            newRendererType = null;

        if (newRenderer !== undefined && newRenderer !== null) {
          newRenderer.show();
          newRenderer.setSrc(media);
          t.mediaElement.renderer = newRenderer;
          t.mediaElement.rendererName = rendererName;
          return true;
        }

        var rendererArray = t.mediaElement.options.renderers.length ? t.mediaElement.options.renderers : _renderer.renderer.order;

        for (var _i = 0, total = rendererArray.length; _i < total; _i++) {
          var index = rendererArray[_i];

          if (index === rendererName) {
            var rendererList = _renderer.renderer.renderers;
            newRendererType = rendererList[index];
            var renderOptions = Object.assign(newRendererType.options, t.mediaElement.options);
            newRenderer = newRendererType.create(t.mediaElement, renderOptions, mediaFiles);
            newRenderer.name = rendererName;
            t.mediaElement.renderers[newRendererType.name] = newRenderer;
            t.mediaElement.renderer = newRenderer;
            t.mediaElement.rendererName = rendererName;
            newRenderer.show();
            return true;
          }
        }

        return false;
      };

      t.mediaElement.setSize = function (width, height) {
        if (t.mediaElement.renderer !== undefined && t.mediaElement.renderer !== null) {
          t.mediaElement.renderer.setSize(width, height);
        }
      };

      t.mediaElement.generateError = function (message, urlList) {
        message = message || '';
        urlList = Array.isArray(urlList) ? urlList : [];
        var event = (0, _general.createEvent)('error', t.mediaElement);
        event.message = message;
        event.urls = urlList;
        t.mediaElement.dispatchEvent(event);
        error = true;
      };

      var props = _mejs2.default.html5media.properties,
          methods = _mejs2.default.html5media.methods,
          addProperty = function addProperty(obj, name, onGet, onSet) {
        var oldValue = obj[name];

        var getFn = function getFn() {
          return onGet.apply(obj, [oldValue]);
        },
            setFn = function setFn(newValue) {
          oldValue = onSet.apply(obj, [newValue]);
          return oldValue;
        };

        Object.defineProperty(obj, name, {
          get: getFn,
          set: setFn
        });
      },
          assignGettersSetters = function assignGettersSetters(propName) {
        if (propName !== 'src') {
          var capName = '' + propName.substring(0, 1).toUpperCase() + propName.substring(1),
              getFn = function getFn() {
            return t.mediaElement.renderer !== undefined && t.mediaElement.renderer !== null && typeof t.mediaElement.renderer['get' + capName] === 'function' ? t.mediaElement.renderer['get' + capName]() : null;
          },
              setFn = function setFn(value) {
            if (t.mediaElement.renderer !== undefined && t.mediaElement.renderer !== null && typeof t.mediaElement.renderer['set' + capName] === 'function') {
              t.mediaElement.renderer['set' + capName](value);
            }
          };

          addProperty(t.mediaElement, propName, getFn, setFn);
          t.mediaElement['get' + capName] = getFn;
          t.mediaElement['set' + capName] = setFn;
        }
      },
          getSrc = function getSrc() {
        return t.mediaElement.renderer !== undefined && t.mediaElement.renderer !== null ? t.mediaElement.renderer.getSrc() : null;
      },
          setSrc = function setSrc(value) {
        var mediaFiles = [];

        if (typeof value === 'string') {
          mediaFiles.push({
            src: value,
            type: value ? (0, _media2.getTypeFromFile)(value) : ''
          });
        } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.src !== undefined) {
          var _src = (0, _media2.absolutizeUrl)(value.src),
              _type2 = value.type,
              media = Object.assign(value, {
            src: _src,
            type: (_type2 === '' || _type2 === null || _type2 === undefined) && _src ? (0, _media2.getTypeFromFile)(_src) : _type2
          });

          mediaFiles.push(media);
        } else if (Array.isArray(value)) {
          for (var _i2 = 0, total = value.length; _i2 < total; _i2++) {
            var _src2 = (0, _media2.absolutizeUrl)(value[_i2].src),
                _type3 = value[_i2].type,
                _media = Object.assign(value[_i2], {
              src: _src2,
              type: (_type3 === '' || _type3 === null || _type3 === undefined) && _src2 ? (0, _media2.getTypeFromFile)(_src2) : _type3
            });

            mediaFiles.push(_media);
          }
        }

        var renderInfo = _renderer.renderer.select(mediaFiles, t.mediaElement.options.renderers.length ? t.mediaElement.options.renderers : []),
            event = void 0;

        if (!t.mediaElement.paused) {
          t.mediaElement.pause();
          event = (0, _general.createEvent)('pause', t.mediaElement);
          t.mediaElement.dispatchEvent(event);
        }

        t.mediaElement.originalNode.src = mediaFiles[0].src || '';

        if (renderInfo === null && mediaFiles[0].src) {
          t.mediaElement.generateError('No renderer found', mediaFiles);
          return;
        }

        return mediaFiles[0].src ? t.mediaElement.changeRenderer(renderInfo.rendererName, mediaFiles) : null;
      },
          triggerAction = function triggerAction(methodName, args) {
        try {
          if (methodName === 'play' && t.mediaElement.rendererName === 'native_dash') {
            var response = t.mediaElement.renderer[methodName](args);

            if (response && typeof response.then === 'function') {
              response.catch(function () {
                if (t.mediaElement.paused) {
                  setTimeout(function () {
                    var tmpResponse = t.mediaElement.renderer.play();

                    if (tmpResponse !== undefined) {
                      tmpResponse.catch(function () {
                        if (!t.mediaElement.renderer.paused) {
                          t.mediaElement.renderer.pause();
                        }
                      });
                    }
                  }, 150);
                }
              });
            }
          } else {
            t.mediaElement.renderer[methodName](args);
          }
        } catch (e) {
          t.mediaElement.generateError(e, mediaFiles);
        }
      },
          assignMethods = function assignMethods(methodName) {
        t.mediaElement[methodName] = function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (t.mediaElement.renderer !== undefined && t.mediaElement.renderer !== null && typeof t.mediaElement.renderer[methodName] === 'function') {
            if (t.mediaElement.promises.length) {
              Promise.all(t.mediaElement.promises).then(function () {
                triggerAction(methodName, args);
              }).catch(function (e) {
                t.mediaElement.generateError(e, mediaFiles);
              });
            } else {
              triggerAction(methodName, args);
            }
          }

          return null;
        };
      };

      addProperty(t.mediaElement, 'src', getSrc, setSrc);
      t.mediaElement.getSrc = getSrc;
      t.mediaElement.setSrc = setSrc;

      for (var _i3 = 0, total = props.length; _i3 < total; _i3++) {
        assignGettersSetters(props[_i3]);
      }

      for (var _i4 = 0, _total = methods.length; _i4 < _total; _i4++) {
        assignMethods(methods[_i4]);
      }

      t.mediaElement.addEventListener = function (eventName, callback) {
        t.mediaElement.events[eventName] = t.mediaElement.events[eventName] || [];
        t.mediaElement.events[eventName].push(callback);
      };

      t.mediaElement.removeEventListener = function (eventName, callback) {
        if (!eventName) {
          t.mediaElement.events = {};
          return true;
        }

        var callbacks = t.mediaElement.events[eventName];

        if (!callbacks) {
          return true;
        }

        if (!callback) {
          t.mediaElement.events[eventName] = [];
          return true;
        }

        for (var _i5 = 0; _i5 < callbacks.length; _i5++) {
          if (callbacks[_i5] === callback) {
            t.mediaElement.events[eventName].splice(_i5, 1);
            return true;
          }
        }

        return false;
      };

      t.mediaElement.dispatchEvent = function (event) {
        var callbacks = t.mediaElement.events[event.type];

        if (callbacks) {
          for (var _i6 = 0; _i6 < callbacks.length; _i6++) {
            callbacks[_i6].apply(null, [event]);
          }
        }
      };

      t.mediaElement.destroy = function () {
        var mediaElement = t.mediaElement.originalNode.cloneNode(true);
        var wrapper = t.mediaElement.parentElement;
        mediaElement.removeAttribute('id');
        mediaElement.remove();
        t.mediaElement.remove();
        wrapper.append(mediaElement);
      };

      if (mediaFiles.length) {
        t.mediaElement.src = mediaFiles;
      }

      if (t.mediaElement.promises.length) {
        Promise.all(t.mediaElement.promises).then(function () {
          if (t.mediaElement.options.success) {
            t.mediaElement.options.success(t.mediaElement, t.mediaElement.originalNode);
          }
        }).catch(function () {
          if (error && t.mediaElement.options.error) {
            t.mediaElement.options.error(t.mediaElement, t.mediaElement.originalNode);
          }
        });
      } else {
        if (t.mediaElement.options.success) {
          t.mediaElement.options.success(t.mediaElement, t.mediaElement.originalNode);
        }

        if (error && t.mediaElement.options.error) {
          t.mediaElement.options.error(t.mediaElement, t.mediaElement.originalNode);
        }
      }

      return t.mediaElement;
    };

    _window2.default.MediaElement = MediaElement;
    _mejs2.default.MediaElement = MediaElement;
    exports.default = MediaElement;
  }, {
    "2": 2,
    "25": 25,
    "27": 27,
    "28": 28,
    "3": 3,
    "7": 7,
    "8": 8
  }],
  7: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var mejs = {};
    mejs.version = '4.2.9';
    mejs.html5media = {
      properties: ['volume', 'src', 'currentTime', 'muted', 'duration', 'paused', 'ended', 'buffered', 'error', 'networkState', 'readyState', 'seeking', 'seekable', 'currentSrc', 'preload', 'bufferedBytes', 'bufferedTime', 'initialTime', 'startOffsetTime', 'defaultPlaybackRate', 'playbackRate', 'played', 'autoplay', 'loop', 'controls'],
      readOnlyProperties: ['duration', 'paused', 'ended', 'buffered', 'error', 'networkState', 'readyState', 'seeking', 'seekable'],
      methods: ['load', 'play', 'pause', 'canPlayType'],
      events: ['loadstart', 'durationchange', 'loadedmetadata', 'loadeddata', 'progress', 'canplay', 'canplaythrough', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'play', 'playing', 'pause', 'waiting', 'seeking', 'seeked', 'timeupdate', 'ended', 'ratechange', 'volumechange'],
      mediaTypes: ['audio/mp3', 'audio/ogg', 'audio/oga', 'audio/wav', 'audio/x-wav', 'audio/wave', 'audio/x-pn-wav', 'audio/mpeg', 'audio/mp4', 'video/mp4', 'video/webm', 'video/ogg', 'video/ogv']
    };
    _window2.default.mejs = mejs;
    exports.default = mejs;
  }, {
    "3": 3
  }],
  8: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.renderer = undefined;

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var Renderer = function () {
      function Renderer() {
        _classCallCheck(this, Renderer);

        this.renderers = {};
        this.order = [];
      }

      _createClass(Renderer, [{
        key: 'add',
        value: function add(renderer) {
          if (renderer.name === undefined) {
            throw new TypeError('renderer must contain at least `name` property');
          }

          this.renderers[renderer.name] = renderer;
          this.order.push(renderer.name);
        }
      }, {
        key: 'select',
        value: function select(mediaFiles) {
          var renderers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          var renderersLength = renderers.length;
          renderers = renderers.length ? renderers : this.order;

          if (!renderersLength) {
            var rendererIndicator = [/^(html5|native)/i, /^flash/i, /iframe$/i],
                rendererRanking = function rendererRanking(renderer) {
              for (var i = 0, total = rendererIndicator.length; i < total; i++) {
                if (rendererIndicator[i].test(renderer)) {
                  return i;
                }
              }

              return rendererIndicator.length;
            };

            renderers.sort(function (a, b) {
              return rendererRanking(a) - rendererRanking(b);
            });
          }

          for (var i = 0, total = renderers.length; i < total; i++) {
            var key = renderers[i],
                _renderer = this.renderers[key];

            if (_renderer !== null && _renderer !== undefined) {
              for (var j = 0, jl = mediaFiles.length; j < jl; j++) {
                if (typeof _renderer.canPlayType === 'function' && typeof mediaFiles[j].type === 'string' && _renderer.canPlayType(mediaFiles[j].type)) {
                  return {
                    rendererName: _renderer.name,
                    src: mediaFiles[j].src
                  };
                }
              }
            }
          }

          return null;
        }
      }, {
        key: 'order',
        set: function set(order) {
          if (!Array.isArray(order)) {
            throw new TypeError('order must be an array of strings.');
          }

          this._order = order;
        },
        get: function get() {
          return this._order;
        }
      }, {
        key: 'renderers',
        set: function set(renderers) {
          if (renderers !== null && (typeof renderers === 'undefined' ? 'undefined' : _typeof(renderers)) !== 'object') {
            throw new TypeError('renderers must be an array of objects.');
          }

          this._renderers = renderers;
        },
        get: function get() {
          return this._renderers;
        }
      }]);

      return Renderer;
    }();

    var renderer = exports.renderer = new Renderer();
    _mejs2.default.Renderers = renderer;
  }, {
    "7": 7
  }],
  9: [function (_dereq_, module, exports) {
    'use strict';

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _i18n = _dereq_(5);

    var _i18n2 = _interopRequireDefault(_i18n);

    var _player = _dereq_(16);

    var _player2 = _interopRequireDefault(_player);

    var _constants = _dereq_(25);

    var Features = _interopRequireWildcard(_constants);

    var _general = _dereq_(27);

    var _dom = _dereq_(26);

    var _media = _dereq_(28);

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};

        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }

        newObj.default = obj;
        return newObj;
      }
    }

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    Object.assign(_player.config, {
      usePluginFullScreen: true,
      fullscreenText: null,
      useFakeFullscreen: false
    });
    Object.assign(_player2.default.prototype, {
      isFullScreen: false,
      isNativeFullScreen: false,
      isInIframe: false,
      isPluginClickThroughCreated: false,
      fullscreenMode: '',
      containerSizeTimeout: null,
      buildfullscreen: function buildfullscreen(player) {
        if (!player.isVideo) {
          return;
        }

        player.isInIframe = _window2.default.location !== _window2.default.parent.location;
        player.detectFullscreenMode();

        var t = this,
            fullscreenTitle = (0, _general.isString)(t.options.fullscreenText) ? t.options.fullscreenText : _i18n2.default.t('mejs.fullscreen'),
            fullscreenBtn = _document2.default.createElement('div');

        fullscreenBtn.className = t.options.classPrefix + 'button ' + t.options.classPrefix + 'fullscreen-button';
        fullscreenBtn.innerHTML = '<button type="button" aria-controls="' + t.id + '" title="' + fullscreenTitle + '" aria-label="' + fullscreenTitle + '" tabindex="0"></button>';
        t.addControlElement(fullscreenBtn, 'fullscreen');
        fullscreenBtn.addEventListener('click', function () {
          var isFullScreen = Features.HAS_TRUE_NATIVE_FULLSCREEN && Features.IS_FULLSCREEN || player.isFullScreen;

          if (isFullScreen) {
            player.exitFullScreen();
          } else {
            player.enterFullScreen();
          }
        });
        player.fullscreenBtn = fullscreenBtn;
        t.options.keyActions.push({
          keys: [70],
          action: function action(player, media, key, event) {
            if (!event.ctrlKey) {
              if (typeof player.enterFullScreen !== 'undefined') {
                if (player.isFullScreen) {
                  player.exitFullScreen();
                } else {
                  player.enterFullScreen();
                }
              }
            }
          }
        });

        t.exitFullscreenCallback = function (e) {
          var key = e.which || e.keyCode || 0;

          if (t.options.enableKeyboard && key === 27 && (Features.HAS_TRUE_NATIVE_FULLSCREEN && Features.IS_FULLSCREEN || t.isFullScreen)) {
            player.exitFullScreen();
          }
        };

        t.globalBind('keydown', t.exitFullscreenCallback);
        t.normalHeight = 0;
        t.normalWidth = 0;

        if (Features.HAS_TRUE_NATIVE_FULLSCREEN) {
          var fullscreenChanged = function fullscreenChanged() {
            if (player.isFullScreen) {
              if (Features.isFullScreen()) {
                player.isNativeFullScreen = true;
                player.setControlsSize();
              } else {
                player.isNativeFullScreen = false;
                player.exitFullScreen();
              }
            }
          };

          player.globalBind(Features.FULLSCREEN_EVENT_NAME, fullscreenChanged);
        }
      },
      cleanfullscreen: function cleanfullscreen(player) {
        player.exitFullScreen();
        player.globalUnbind('keydown', player.exitFullscreenCallback);
      },
      detectFullscreenMode: function detectFullscreenMode() {
        var t = this,
            isNative = t.media.rendererName !== null && /(native|html5)/i.test(t.media.rendererName);
        var mode = '';

        if (Features.HAS_TRUE_NATIVE_FULLSCREEN && isNative) {
          mode = 'native-native';
        } else if (Features.HAS_TRUE_NATIVE_FULLSCREEN && !isNative) {
          mode = 'plugin-native';
        } else if (t.usePluginFullScreen && Features.SUPPORT_POINTER_EVENTS) {
          mode = 'plugin-click';
        }

        t.fullscreenMode = mode;
        return mode;
      },
      enterFullScreen: function enterFullScreen() {
        var t = this,
            isNative = t.media.rendererName !== null && /(html5|native)/i.test(t.media.rendererName),
            containerStyles = getComputedStyle(t.getElement(t.container));

        if (!t.isVideo) {
          return;
        }

        if (t.options.useFakeFullscreen === false && Features.IS_IOS && Features.HAS_IOS_FULLSCREEN && typeof t.media.originalNode.webkitEnterFullscreen === 'function' && t.media.originalNode.canPlayType((0, _media.getTypeFromFile)(t.media.getSrc()))) {
          t.media.originalNode.webkitEnterFullscreen();
          return;
        }

        (0, _dom.addClass)(_document2.default.documentElement, t.options.classPrefix + 'fullscreen');
        (0, _dom.addClass)(t.getElement(t.container), t.options.classPrefix + 'container-fullscreen');
        t.normalHeight = parseFloat(containerStyles.height);
        t.normalWidth = parseFloat(containerStyles.width);

        if (t.fullscreenMode === 'native-native' || t.fullscreenMode === 'plugin-native') {
          Features.requestFullScreen(t.getElement(t.container));

          if (t.isInIframe) {
            setTimeout(function checkFullscreen() {
              if (t.isNativeFullScreen) {
                var percentErrorMargin = 0.002,
                    windowWidth = _window2.default.innerWidth || _document2.default.documentElement.clientWidth || _document2.default.body.clientWidth,
                    screenWidth = screen.width,
                    absDiff = Math.abs(screenWidth - windowWidth),
                    marginError = screenWidth * percentErrorMargin;

                if (absDiff > marginError) {
                  t.exitFullScreen();
                } else {
                  setTimeout(checkFullscreen, 500);
                }
              }
            }, 1000);
          }
        }

        t.getElement(t.container).style.width = '100%';
        t.getElement(t.container).style.height = '100%';
        t.containerSizeTimeout = setTimeout(function () {
          t.getElement(t.container).style.width = '100%';
          t.getElement(t.container).style.height = '100%';
          t.setControlsSize();
        }, 500);

        if (isNative) {
          t.node.style.width = '100%';
          t.node.style.height = '100%';
        } else {
          var elements = t.getElement(t.container).querySelectorAll('embed, object, video'),
              _total = elements.length;

          for (var i = 0; i < _total; i++) {
            elements[i].style.width = '100%';
            elements[i].style.height = '100%';
          }
        }

        if (t.options.setDimensions && typeof t.media.setSize === 'function') {
          t.media.setSize(screen.width, screen.height);
        }

        var layers = t.getElement(t.layers).children,
            total = layers.length;

        for (var _i = 0; _i < total; _i++) {
          layers[_i].style.width = '100%';
          layers[_i].style.height = '100%';
        }

        if (t.fullscreenBtn) {
          (0, _dom.removeClass)(t.fullscreenBtn, t.options.classPrefix + 'fullscreen');
          (0, _dom.addClass)(t.fullscreenBtn, t.options.classPrefix + 'unfullscreen');
        }

        t.setControlsSize();
        t.isFullScreen = true;
        var zoomFactor = Math.min(screen.width / t.width, screen.height / t.height),
            captionText = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'captions-text');

        if (captionText) {
          captionText.style.fontSize = zoomFactor * 100 + '%';
          captionText.style.lineHeight = 'normal';
          t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'captions-position').style.bottom = (screen.height - t.normalHeight) / 2 - t.getElement(t.controls).offsetHeight / 2 + zoomFactor + 15 + 'px';
        }

        var event = (0, _general.createEvent)('enteredfullscreen', t.getElement(t.container));
        t.getElement(t.container).dispatchEvent(event);
      },
      exitFullScreen: function exitFullScreen() {
        var t = this,
            isNative = t.media.rendererName !== null && /(native|html5)/i.test(t.media.rendererName);

        if (!t.isVideo) {
          return;
        }

        clearTimeout(t.containerSizeTimeout);

        if (Features.HAS_TRUE_NATIVE_FULLSCREEN && (Features.IS_FULLSCREEN || t.isFullScreen)) {
          Features.cancelFullScreen();
        }

        (0, _dom.removeClass)(_document2.default.documentElement, t.options.classPrefix + 'fullscreen');
        (0, _dom.removeClass)(t.getElement(t.container), t.options.classPrefix + 'container-fullscreen');

        if (t.options.setDimensions) {
          t.getElement(t.container).style.width = t.normalWidth + 'px';
          t.getElement(t.container).style.height = t.normalHeight + 'px';

          if (isNative) {
            t.node.style.width = t.normalWidth + 'px';
            t.node.style.height = t.normalHeight + 'px';
          } else {
            var elements = t.getElement(t.container).querySelectorAll('embed, object, video'),
                _total2 = elements.length;

            for (var i = 0; i < _total2; i++) {
              elements[i].style.width = t.normalWidth + 'px';
              elements[i].style.height = t.normalHeight + 'px';
            }
          }

          if (typeof t.media.setSize === 'function') {
            t.media.setSize(t.normalWidth, t.normalHeight);
          }

          var layers = t.getElement(t.layers).children,
              total = layers.length;

          for (var _i2 = 0; _i2 < total; _i2++) {
            layers[_i2].style.width = t.normalWidth + 'px';
            layers[_i2].style.height = t.normalHeight + 'px';
          }
        }

        if (t.fullscreenBtn) {
          (0, _dom.removeClass)(t.fullscreenBtn, t.options.classPrefix + 'unfullscreen');
          (0, _dom.addClass)(t.fullscreenBtn, t.options.classPrefix + 'fullscreen');
        }

        t.setControlsSize();
        t.isFullScreen = false;
        var captionText = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'captions-text');

        if (captionText) {
          captionText.style.fontSize = '';
          captionText.style.lineHeight = '';
          t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'captions-position').style.bottom = '';
        }

        var event = (0, _general.createEvent)('exitedfullscreen', t.getElement(t.container));
        t.getElement(t.container).dispatchEvent(event);
      }
    });
  }, {
    "16": 16,
    "2": 2,
    "25": 25,
    "26": 26,
    "27": 27,
    "28": 28,
    "3": 3,
    "5": 5
  }],
  10: [function (_dereq_, module, exports) {
    'use strict';

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _player = _dereq_(16);

    var _player2 = _interopRequireDefault(_player);

    var _i18n = _dereq_(5);

    var _i18n2 = _interopRequireDefault(_i18n);

    var _general = _dereq_(27);

    var _dom = _dereq_(26);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    Object.assign(_player.config, {
      playText: null,
      pauseText: null
    });
    Object.assign(_player2.default.prototype, {
      buildplaypause: function buildplaypause(player, controls, layers, media) {
        var t = this,
            op = t.options,
            playTitle = (0, _general.isString)(op.playText) ? op.playText : _i18n2.default.t('mejs.play'),
            pauseTitle = (0, _general.isString)(op.pauseText) ? op.pauseText : _i18n2.default.t('mejs.pause'),
            play = _document2.default.createElement('div');

        play.className = t.options.classPrefix + 'button ' + t.options.classPrefix + 'playpause-button ' + t.options.classPrefix + 'play';
        play.innerHTML = '<button type="button" aria-controls="' + t.id + '" title="' + playTitle + '" aria-label="' + pauseTitle + '" tabindex="0"></button>';
        play.addEventListener('click', function () {
          if (t.paused) {
            t.play();
          } else {
            t.pause();
          }
        });
        var playBtn = play.querySelector('button');
        t.addControlElement(play, 'playpause');

        function togglePlayPause(which) {
          if ('play' === which) {
            (0, _dom.removeClass)(play, t.options.classPrefix + 'play');
            (0, _dom.removeClass)(play, t.options.classPrefix + 'replay');
            (0, _dom.addClass)(play, t.options.classPrefix + 'pause');
            playBtn.setAttribute('title', pauseTitle);
            playBtn.setAttribute('aria-label', pauseTitle);
          } else {
            (0, _dom.removeClass)(play, t.options.classPrefix + 'pause');
            (0, _dom.removeClass)(play, t.options.classPrefix + 'replay');
            (0, _dom.addClass)(play, t.options.classPrefix + 'play');
            playBtn.setAttribute('title', playTitle);
            playBtn.setAttribute('aria-label', playTitle);
          }
        }

        togglePlayPause('pse');
        media.addEventListener('loadedmetadata', function () {
          if (media.rendererName.indexOf('flash') === -1) {
            togglePlayPause('pse');
          }
        });
        media.addEventListener('play', function () {
          togglePlayPause('play');
        });
        media.addEventListener('playing', function () {
          togglePlayPause('play');
        });
        media.addEventListener('pause', function () {
          togglePlayPause('pse');
        });
        media.addEventListener('ended', function () {
          if (!player.options.loop) {
            (0, _dom.removeClass)(play, t.options.classPrefix + 'pause');
            (0, _dom.removeClass)(play, t.options.classPrefix + 'play');
            (0, _dom.addClass)(play, t.options.classPrefix + 'replay');
            playBtn.setAttribute('title', playTitle);
            playBtn.setAttribute('aria-label', playTitle);
          }
        });
      }
    });
  }, {
    "16": 16,
    "2": 2,
    "26": 26,
    "27": 27,
    "5": 5
  }],
  11: [function (_dereq_, module, exports) {
    'use strict';

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _player = _dereq_(16);

    var _player2 = _interopRequireDefault(_player);

    var _i18n = _dereq_(5);

    var _i18n2 = _interopRequireDefault(_i18n);

    var _constants = _dereq_(25);

    var _time = _dereq_(30);

    var _dom = _dereq_(26);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    Object.assign(_player.config, {
      enableProgressTooltip: true,
      useSmoothHover: true,
      forceLive: false
    });
    Object.assign(_player2.default.prototype, {
      buildprogress: function buildprogress(player, controls, layers, media) {
        var lastKeyPressTime = 0,
            mouseIsDown = false,
            startedPaused = false;

        var t = this,
            autoRewindInitial = player.options.autoRewind,
            tooltip = player.options.enableProgressTooltip ? '<span class="' + t.options.classPrefix + 'time-float">' + ('<span class="' + t.options.classPrefix + 'time-float-current">00:00</span>') + ('<span class="' + t.options.classPrefix + 'time-float-corner"></span>') + '</span>' : '',
            rail = _document2.default.createElement('div');

        rail.className = t.options.classPrefix + 'time-rail';
        rail.innerHTML = '<span class="' + t.options.classPrefix + 'time-total ' + t.options.classPrefix + 'time-slider">' + ('<span class="' + t.options.classPrefix + 'time-buffering"></span>') + ('<span class="' + t.options.classPrefix + 'time-loaded"></span>') + ('<span class="' + t.options.classPrefix + 'time-current"></span>') + ('<span class="' + t.options.classPrefix + 'time-hovered no-hover"></span>') + ('<span class="' + t.options.classPrefix + 'time-handle"><span class="' + t.options.classPrefix + 'time-handle-content"></span></span>') + ('' + tooltip) + '</span>';
        t.addControlElement(rail, 'progress');
        t.options.keyActions.push({
          keys: [37, 227],
          action: function action(player) {
            if (!isNaN(player.duration) && player.duration > 0) {
              if (player.isVideo) {
                player.showControls();
                player.startControlsTimer();
              }

              player.getElement(player.container).querySelector('.' + _player.config.classPrefix + 'time-total').focus();
              var newTime = Math.max(player.currentTime - player.options.defaultSeekBackwardInterval(player), 0);
              player.setCurrentTime(newTime);
            }
          }
        }, {
          keys: [39, 228],
          action: function action(player) {
            if (!isNaN(player.duration) && player.duration > 0) {
              if (player.isVideo) {
                player.showControls();
                player.startControlsTimer();
              }

              player.getElement(player.container).querySelector('.' + _player.config.classPrefix + 'time-total').focus();
              var newTime = Math.min(player.currentTime + player.options.defaultSeekForwardInterval(player), player.duration);
              player.setCurrentTime(newTime);
            }
          }
        });
        t.rail = controls.querySelector('.' + t.options.classPrefix + 'time-rail');
        t.total = controls.querySelector('.' + t.options.classPrefix + 'time-total');
        t.loaded = controls.querySelector('.' + t.options.classPrefix + 'time-loaded');
        t.current = controls.querySelector('.' + t.options.classPrefix + 'time-current');
        t.handle = controls.querySelector('.' + t.options.classPrefix + 'time-handle');
        t.timefloat = controls.querySelector('.' + t.options.classPrefix + 'time-float');
        t.timefloatcurrent = controls.querySelector('.' + t.options.classPrefix + 'time-float-current');
        t.slider = controls.querySelector('.' + t.options.classPrefix + 'time-slider');
        t.hovered = controls.querySelector('.' + t.options.classPrefix + 'time-hovered');
        t.buffer = controls.querySelector('.' + t.options.classPrefix + 'time-buffering');
        t.newTime = 0;
        t.forcedHandlePause = false;

        t.setTransformStyle = function (element, value) {
          element.style.transform = value;
          element.style.webkitTransform = value;
          element.style.MozTransform = value;
          element.style.msTransform = value;
          element.style.OTransform = value;
        };

        t.buffer.style.display = 'none';

        var handleMouseMove = function handleMouseMove(e) {
          var totalStyles = getComputedStyle(t.total),
              offsetStyles = (0, _dom.offset)(t.total),
              width = t.total.offsetWidth,
              transform = function () {
            if (totalStyles.webkitTransform !== undefined) {
              return 'webkitTransform';
            } else if (totalStyles.mozTransform !== undefined) {
              return 'mozTransform ';
            } else if (totalStyles.oTransform !== undefined) {
              return 'oTransform';
            } else if (totalStyles.msTransform !== undefined) {
              return 'msTransform';
            } else {
              return 'transform';
            }
          }(),
              cssMatrix = function () {
            if ('WebKitCSSMatrix' in window) {
              return 'WebKitCSSMatrix';
            } else if ('MSCSSMatrix' in window) {
              return 'MSCSSMatrix';
            } else if ('CSSMatrix' in window) {
              return 'CSSMatrix';
            }
          }();

          var percentage = 0,
              leftPos = 0,
              pos = 0,
              x = void 0;

          if (e.originalEvent && e.originalEvent.changedTouches) {
            x = e.originalEvent.changedTouches[0].pageX;
          } else if (e.changedTouches) {
            x = e.changedTouches[0].pageX;
          } else {
            x = e.pageX;
          }

          if (t.getDuration()) {
            if (x < offsetStyles.left) {
              x = offsetStyles.left;
            } else if (x > width + offsetStyles.left) {
              x = width + offsetStyles.left;
            }

            pos = x - offsetStyles.left;
            percentage = pos / width;
            t.newTime = percentage <= 0.02 ? 0 : percentage * t.getDuration();

            if (mouseIsDown && t.getCurrentTime() !== null && t.newTime.toFixed(4) !== t.getCurrentTime().toFixed(4)) {
              t.setCurrentRailHandle(t.newTime);
              t.updateCurrent(t.newTime);
            }

            if (!_constants.IS_IOS && !_constants.IS_ANDROID) {
              if (pos < 0) {
                pos = 0;
              }

              if (t.options.useSmoothHover && cssMatrix !== null && typeof window[cssMatrix] !== 'undefined') {
                var matrix = new window[cssMatrix](getComputedStyle(t.handle)[transform]),
                    handleLocation = matrix.m41,
                    hoverScaleX = pos / parseFloat(getComputedStyle(t.total).width) - handleLocation / parseFloat(getComputedStyle(t.total).width);
                t.hovered.style.left = handleLocation + 'px';
                t.setTransformStyle(t.hovered, 'scaleX(' + hoverScaleX + ')');
                t.hovered.setAttribute('pos', pos);

                if (hoverScaleX >= 0) {
                  (0, _dom.removeClass)(t.hovered, 'negative');
                } else {
                  (0, _dom.addClass)(t.hovered, 'negative');
                }
              }

              if (t.timefloat) {
                var half = t.timefloat.offsetWidth / 2,
                    offsetContainer = mejs.Utils.offset(t.getElement(t.container)),
                    tooltipStyles = getComputedStyle(t.timefloat);

                if (x - offsetContainer.left < t.timefloat.offsetWidth) {
                  leftPos = half;
                } else if (x - offsetContainer.left >= t.getElement(t.container).offsetWidth - half) {
                  leftPos = t.total.offsetWidth - half;
                } else {
                  leftPos = pos;
                }

                if ((0, _dom.hasClass)(t.getElement(t.container), t.options.classPrefix + 'long-video')) {
                  leftPos += parseFloat(tooltipStyles.marginLeft) / 2 + t.timefloat.offsetWidth / 2;
                }

                t.timefloat.style.left = leftPos + 'px';
                t.timefloatcurrent.innerHTML = (0, _time.secondsToTimeCode)(t.newTime, player.options.alwaysShowHours, player.options.showTimecodeFrameCount, player.options.framesPerSecond, player.options.secondsDecimalLength, player.options.timeFormat);
                t.timefloat.style.display = 'block';
              }
            }
          } else if (!_constants.IS_IOS && !_constants.IS_ANDROID && t.timefloat) {
            leftPos = t.timefloat.offsetWidth + width >= t.getElement(t.container).offsetWidth ? t.timefloat.offsetWidth / 2 : 0;
            t.timefloat.style.left = leftPos + 'px';
            t.timefloat.style.left = leftPos + 'px';
            t.timefloat.style.display = 'block';
          }
        },
            updateSlider = function updateSlider() {
          var seconds = t.getCurrentTime(),
              timeSliderText = _i18n2.default.t('mejs.time-slider'),
              time = (0, _time.secondsToTimeCode)(seconds, player.options.alwaysShowHours, player.options.showTimecodeFrameCount, player.options.framesPerSecond, player.options.secondsDecimalLength, player.options.timeFormat),
              duration = t.getDuration();

          t.slider.setAttribute('role', 'slider');
          t.slider.tabIndex = 0;

          if (media.paused) {
            t.slider.setAttribute('aria-label', timeSliderText);
            t.slider.setAttribute('aria-valuemin', 0);
            t.slider.setAttribute('aria-valuemax', duration);
            t.slider.setAttribute('aria-valuenow', seconds);
            t.slider.setAttribute('aria-valuetext', time);
          } else {
            t.slider.removeAttribute('aria-label');
            t.slider.removeAttribute('aria-valuemin');
            t.slider.removeAttribute('aria-valuemax');
            t.slider.removeAttribute('aria-valuenow');
            t.slider.removeAttribute('aria-valuetext');
          }
        },
            restartPlayer = function restartPlayer() {
          if (new Date() - lastKeyPressTime >= 1000) {
            t.play();
          }
        },
            handleMouseup = function handleMouseup() {
          if (mouseIsDown && t.getCurrentTime() !== null && t.newTime.toFixed(4) !== t.getCurrentTime().toFixed(4)) {
            t.setCurrentTime(t.newTime);
            t.setCurrentRailHandle(t.newTime);
            t.updateCurrent(t.newTime);
          }

          if (t.forcedHandlePause) {
            t.slider.focus();
            t.play();
          }

          t.forcedHandlePause = false;
        };

        t.slider.addEventListener('focus', function () {
          player.options.autoRewind = false;
        });
        t.slider.addEventListener('blur', function () {
          player.options.autoRewind = autoRewindInitial;
        });
        t.slider.addEventListener('keydown', function (e) {
          if (new Date() - lastKeyPressTime >= 1000) {
            startedPaused = t.paused;
          }

          if (t.options.enableKeyboard && t.options.keyActions.length) {
            var keyCode = e.which || e.keyCode || 0,
                duration = t.getDuration(),
                seekForward = player.options.defaultSeekForwardInterval(media),
                seekBackward = player.options.defaultSeekBackwardInterval(media);
            var seekTime = t.getCurrentTime();
            var volume = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'volume-slider');

            if (keyCode === 38 || keyCode === 40) {
              if (volume) {
                volume.style.display = 'block';
              }

              if (t.isVideo) {
                t.showControls();
                t.startControlsTimer();
              }

              var newVolume = keyCode === 38 ? Math.min(t.volume + 0.1, 1) : Math.max(t.volume - 0.1, 0),
                  mutePlayer = newVolume <= 0;
              t.setVolume(newVolume);
              t.setMuted(mutePlayer);
              return;
            } else {
              if (volume) {
                volume.style.display = 'none';
              }
            }

            switch (keyCode) {
              case 37:
                if (t.getDuration() !== Infinity) {
                  seekTime -= seekBackward;
                }

                break;

              case 39:
                if (t.getDuration() !== Infinity) {
                  seekTime += seekForward;
                }

                break;

              case 36:
                seekTime = 0;
                break;

              case 35:
                seekTime = duration;
                break;

              case 13:
              case 32:
                if (_constants.IS_FIREFOX) {
                  if (t.paused) {
                    t.play();
                  } else {
                    t.pause();
                  }
                }

                return;

              default:
                return;
            }

            seekTime = seekTime < 0 ? 0 : seekTime >= duration ? duration : Math.floor(seekTime);
            lastKeyPressTime = new Date();

            if (!startedPaused) {
              player.pause();
            }

            if (seekTime < t.getDuration() && !startedPaused) {
              setTimeout(restartPlayer, 1100);
            }

            t.setCurrentTime(seekTime);
            player.showControls();
            e.preventDefault();
            e.stopPropagation();
          }
        });
        var events = ['mousedown', 'touchstart'];
        t.slider.addEventListener('dragstart', function () {
          return false;
        });

        for (var i = 0, total = events.length; i < total; i++) {
          t.slider.addEventListener(events[i], function (e) {
            t.forcedHandlePause = false;

            if (t.getDuration() !== Infinity) {
              if (e.which === 1 || e.which === 0) {
                if (!t.paused) {
                  t.pause();
                  t.forcedHandlePause = true;
                }

                mouseIsDown = true;
                handleMouseMove(e);
                var endEvents = ['mouseup', 'touchend'];

                for (var j = 0, totalEvents = endEvents.length; j < totalEvents; j++) {
                  t.getElement(t.container).addEventListener(endEvents[j], function (event) {
                    var target = event.target;

                    if (target === t.slider || target.closest('.' + t.options.classPrefix + 'time-slider')) {
                      handleMouseMove(event);
                    }
                  });
                }

                t.globalBind('mouseup.dur touchend.dur', function () {
                  handleMouseup();
                  mouseIsDown = false;

                  if (t.timefloat) {
                    t.timefloat.style.display = 'none';
                  }
                });
              }
            }
          }, _constants.SUPPORT_PASSIVE_EVENT && events[i] === 'touchstart' ? {
            passive: true
          } : false);
        }

        t.slider.addEventListener('mouseenter', function (e) {
          if (e.target === t.slider && t.getDuration() !== Infinity) {
            t.getElement(t.container).addEventListener('mousemove', function (event) {
              var target = event.target;

              if (target === t.slider || target.closest('.' + t.options.classPrefix + 'time-slider')) {
                handleMouseMove(event);
              }
            });

            if (t.timefloat && !_constants.IS_IOS && !_constants.IS_ANDROID) {
              t.timefloat.style.display = 'block';
            }

            if (t.hovered && !_constants.IS_IOS && !_constants.IS_ANDROID && t.options.useSmoothHover) {
              (0, _dom.removeClass)(t.hovered, 'no-hover');
            }
          }
        });
        t.slider.addEventListener('mouseleave', function () {
          if (t.getDuration() !== Infinity) {
            if (!mouseIsDown) {
              if (t.timefloat) {
                t.timefloat.style.display = 'none';
              }

              if (t.hovered && t.options.useSmoothHover) {
                (0, _dom.addClass)(t.hovered, 'no-hover');
              }
            }
          }
        });

        t.broadcastCallback = function (e) {
          var broadcast = controls.querySelector('.' + t.options.classPrefix + 'broadcast');

          if (!t.options.forceLive && t.getDuration() !== Infinity) {
            if (broadcast) {
              t.slider.style.display = '';
              broadcast.remove();
            }

            player.setProgressRail(e);

            if (!t.forcedHandlePause) {
              player.setCurrentRail(e);
            }

            updateSlider();
          } else if (!broadcast || t.options.forceLive) {
            var label = _document2.default.createElement('span');

            label.className = t.options.classPrefix + 'broadcast';
            label.innerText = _i18n2.default.t('mejs.live-broadcast');
            t.slider.style.display = 'none';
            t.rail.appendChild(label);
          }
        };

        media.addEventListener('progress', t.broadcastCallback);
        media.addEventListener('timeupdate', t.broadcastCallback);
        media.addEventListener('play', function () {
          t.buffer.style.display = 'none';
        });
        media.addEventListener('playing', function () {
          t.buffer.style.display = 'none';
        });
        media.addEventListener('seeking', function () {
          t.buffer.style.display = '';
        });
        media.addEventListener('seeked', function () {
          t.buffer.style.display = 'none';
        });
        media.addEventListener('pause', function () {
          t.buffer.style.display = 'none';
        });
        media.addEventListener('waiting', function () {
          t.buffer.style.display = '';
        });
        media.addEventListener('loadeddata', function () {
          t.buffer.style.display = '';
        });
        media.addEventListener('canplay', function () {
          t.buffer.style.display = 'none';
        });
        media.addEventListener('error', function () {
          t.buffer.style.display = 'none';
        });
        t.getElement(t.container).addEventListener('controlsresize', function (e) {
          if (t.getDuration() !== Infinity) {
            player.setProgressRail(e);

            if (!t.forcedHandlePause) {
              player.setCurrentRail(e);
            }
          }
        });
      },
      cleanprogress: function cleanprogress(player, controls, layers, media) {
        media.removeEventListener('progress', player.broadcastCallback);
        media.removeEventListener('timeupdate', player.broadcastCallback);

        if (player.rail) {
          player.rail.remove();
        }
      },
      setProgressRail: function setProgressRail(e) {
        var t = this,
            target = e !== undefined ? e.detail.target || e.target : t.media;
        var percent = null;

        if (target && target.buffered && target.buffered.length > 0 && target.buffered.end && t.getDuration()) {
          percent = target.buffered.end(target.buffered.length - 1) / t.getDuration();
        } else if (target && target.bytesTotal !== undefined && target.bytesTotal > 0 && target.bufferedBytes !== undefined) {
          percent = target.bufferedBytes / target.bytesTotal;
        } else if (e && e.lengthComputable && e.total !== 0) {
          percent = e.loaded / e.total;
        }

        if (percent !== null) {
          percent = Math.min(1, Math.max(0, percent));

          if (t.loaded) {
            t.setTransformStyle(t.loaded, 'scaleX(' + percent + ')');
          }
        }
      },
      setCurrentRailHandle: function setCurrentRailHandle(fakeTime) {
        var t = this;
        t.setCurrentRailMain(t, fakeTime);
      },
      setCurrentRail: function setCurrentRail() {
        var t = this;
        t.setCurrentRailMain(t);
      },
      setCurrentRailMain: function setCurrentRailMain(t, fakeTime) {
        if (t.getCurrentTime() !== undefined && t.getDuration()) {
          var nTime = typeof fakeTime === 'undefined' ? t.getCurrentTime() : fakeTime;

          if (t.total && t.handle) {
            var tW = parseFloat(getComputedStyle(t.total).width);
            var newWidth = Math.round(tW * nTime / t.getDuration()),
                handlePos = newWidth - Math.round(t.handle.offsetWidth / 2);
            handlePos = handlePos < 0 ? 0 : handlePos;
            t.setTransformStyle(t.current, 'scaleX(' + newWidth / tW + ')');
            t.setTransformStyle(t.handle, 'translateX(' + handlePos + 'px)');

            if (t.options.useSmoothHover && !(0, _dom.hasClass)(t.hovered, 'no-hover')) {
              var pos = parseInt(t.hovered.getAttribute('pos'), 10);
              pos = isNaN(pos) ? 0 : pos;
              var hoverScaleX = pos / tW - handlePos / tW;
              t.hovered.style.left = handlePos + 'px';
              t.setTransformStyle(t.hovered, 'scaleX(' + hoverScaleX + ')');

              if (hoverScaleX >= 0) {
                (0, _dom.removeClass)(t.hovered, 'negative');
              } else {
                (0, _dom.addClass)(t.hovered, 'negative');
              }
            }
          }
        }
      }
    });
  }, {
    "16": 16,
    "2": 2,
    "25": 25,
    "26": 26,
    "30": 30,
    "5": 5
  }],
  12: [function (_dereq_, module, exports) {
    'use strict';

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _player = _dereq_(16);

    var _player2 = _interopRequireDefault(_player);

    var _time = _dereq_(30);

    var _dom = _dereq_(26);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    Object.assign(_player.config, {
      duration: 0,
      timeAndDurationSeparator: '<span> | </span>'
    });
    Object.assign(_player2.default.prototype, {
      buildcurrent: function buildcurrent(player, controls, layers, media) {
        var t = this,
            time = _document2.default.createElement('div');

        time.className = t.options.classPrefix + 'time';
        time.setAttribute('role', 'timer');
        time.setAttribute('aria-live', 'off');
        time.innerHTML = '<span class="' + t.options.classPrefix + 'currenttime">' + (0, _time.secondsToTimeCode)(0, player.options.alwaysShowHours, player.options.showTimecodeFrameCount, player.options.framesPerSecond, player.options.secondsDecimalLength, player.options.timeFormat) + '</span>';
        t.addControlElement(time, 'current');
        player.updateCurrent();

        t.updateTimeCallback = function () {
          if (t.controlsAreVisible) {
            player.updateCurrent();
          }
        };

        media.addEventListener('timeupdate', t.updateTimeCallback);
      },
      cleancurrent: function cleancurrent(player, controls, layers, media) {
        media.removeEventListener('timeupdate', player.updateTimeCallback);
      },
      buildduration: function buildduration(player, controls, layers, media) {
        var t = this,
            currTime = controls.lastChild.querySelector('.' + t.options.classPrefix + 'currenttime');

        if (currTime) {
          controls.querySelector('.' + t.options.classPrefix + 'time').innerHTML += t.options.timeAndDurationSeparator + '<span class="' + t.options.classPrefix + 'duration">' + ((0, _time.secondsToTimeCode)(t.options.duration, t.options.alwaysShowHours, t.options.showTimecodeFrameCount, t.options.framesPerSecond, t.options.secondsDecimalLength, t.options.timeFormat) + '</span>');
        } else {
          if (controls.querySelector('.' + t.options.classPrefix + 'currenttime')) {
            (0, _dom.addClass)(controls.querySelector('.' + t.options.classPrefix + 'currenttime').parentNode, t.options.classPrefix + 'currenttime-container');
          }

          var duration = _document2.default.createElement('div');

          duration.className = t.options.classPrefix + 'time ' + t.options.classPrefix + 'duration-container';
          duration.innerHTML = '<span class="' + t.options.classPrefix + 'duration">' + ((0, _time.secondsToTimeCode)(t.options.duration, t.options.alwaysShowHours, t.options.showTimecodeFrameCount, t.options.framesPerSecond, t.options.secondsDecimalLength, t.options.timeFormat) + '</span>');
          t.addControlElement(duration, 'duration');
        }

        t.updateDurationCallback = function () {
          if (t.controlsAreVisible) {
            player.updateDuration();
          }
        };

        media.addEventListener('timeupdate', t.updateDurationCallback);
      },
      cleanduration: function cleanduration(player, controls, layers, media) {
        media.removeEventListener('timeupdate', player.updateDurationCallback);
      },
      updateCurrent: function updateCurrent() {
        var t = this;
        var currentTime = t.getCurrentTime();

        if (isNaN(currentTime)) {
          currentTime = 0;
        }

        var timecode = (0, _time.secondsToTimeCode)(currentTime, t.options.alwaysShowHours, t.options.showTimecodeFrameCount, t.options.framesPerSecond, t.options.secondsDecimalLength, t.options.timeFormat);

        if (timecode.length > 5) {
          (0, _dom.addClass)(t.getElement(t.container), t.options.classPrefix + 'long-video');
        } else {
          (0, _dom.removeClass)(t.getElement(t.container), t.options.classPrefix + 'long-video');
        }

        if (t.getElement(t.controls).querySelector('.' + t.options.classPrefix + 'currenttime')) {
          t.getElement(t.controls).querySelector('.' + t.options.classPrefix + 'currenttime').innerText = timecode;
        }
      },
      updateDuration: function updateDuration() {
        var t = this;
        var duration = t.getDuration();

        if (t.media !== undefined && (isNaN(duration) || duration === Infinity || duration < 0)) {
          t.media.duration = t.options.duration = duration = 0;
        }

        if (t.options.duration > 0) {
          duration = t.options.duration;
        }

        var timecode = (0, _time.secondsToTimeCode)(duration, t.options.alwaysShowHours, t.options.showTimecodeFrameCount, t.options.framesPerSecond, t.options.secondsDecimalLength, t.options.timeFormat);

        if (timecode.length > 5) {
          (0, _dom.addClass)(t.getElement(t.container), t.options.classPrefix + 'long-video');
        } else {
          (0, _dom.removeClass)(t.getElement(t.container), t.options.classPrefix + 'long-video');
        }

        if (t.getElement(t.controls).querySelector('.' + t.options.classPrefix + 'duration') && duration > 0) {
          t.getElement(t.controls).querySelector('.' + t.options.classPrefix + 'duration').innerHTML = timecode;
        }
      }
    });
  }, {
    "16": 16,
    "2": 2,
    "26": 26,
    "30": 30
  }],
  13: [function (_dereq_, module, exports) {
    'use strict';

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _i18n = _dereq_(5);

    var _i18n2 = _interopRequireDefault(_i18n);

    var _player = _dereq_(16);

    var _player2 = _interopRequireDefault(_player);

    var _time = _dereq_(30);

    var _general = _dereq_(27);

    var _dom = _dereq_(26);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    Object.assign(_player.config, {
      startLanguage: '',
      tracksText: null,
      chaptersText: null,
      tracksAriaLive: false,
      hideCaptionsButtonWhenEmpty: true,
      toggleCaptionsButtonWhenOnlyOne: false,
      slidesSelector: ''
    });
    Object.assign(_player2.default.prototype, {
      hasChapters: false,
      buildtracks: function buildtracks(player, controls, layers, media) {
        this.findTracks();

        if (!player.tracks.length && (!player.trackFiles || !player.trackFiles.length === 0)) {
          return;
        }

        var t = this,
            attr = t.options.tracksAriaLive ? ' role="log" aria-live="assertive" aria-atomic="false"' : '',
            tracksTitle = (0, _general.isString)(t.options.tracksText) ? t.options.tracksText : _i18n2.default.t('mejs.captions-subtitles'),
            chaptersTitle = (0, _general.isString)(t.options.chaptersText) ? t.options.chaptersText : _i18n2.default.t('mejs.captions-chapters'),
            total = player.trackFiles === null ? player.tracks.length : player.trackFiles.length;

        if (t.domNode.textTracks) {
          for (var i = t.domNode.textTracks.length - 1; i >= 0; i--) {
            t.domNode.textTracks[i].mode = 'hidden';
          }
        }

        t.cleartracks(player);
        player.captions = _document2.default.createElement('div');
        player.captions.className = t.options.classPrefix + 'captions-layer ' + t.options.classPrefix + 'layer';
        player.captions.innerHTML = '<div class="' + t.options.classPrefix + 'captions-position ' + t.options.classPrefix + 'captions-position-hover"' + attr + '>' + ('<span class="' + t.options.classPrefix + 'captions-text"></span>') + '</div>';
        player.captions.style.display = 'none';
        layers.insertBefore(player.captions, layers.firstChild);
        player.captionsText = player.captions.querySelector('.' + t.options.classPrefix + 'captions-text');
        player.captionsButton = _document2.default.createElement('div');
        player.captionsButton.className = t.options.classPrefix + 'button ' + t.options.classPrefix + 'captions-button';
        player.captionsButton.innerHTML = '<button type="button" aria-controls="' + t.id + '" title="' + tracksTitle + '" aria-label="' + tracksTitle + '" tabindex="0"></button>' + ('<div class="' + t.options.classPrefix + 'captions-selector ' + t.options.classPrefix + 'offscreen">') + ('<ul class="' + t.options.classPrefix + 'captions-selector-list">') + ('<li class="' + t.options.classPrefix + 'captions-selector-list-item">') + ('<input type="radio" class="' + t.options.classPrefix + 'captions-selector-input" ') + ('name="' + player.id + '_captions" id="' + player.id + '_captions_none" ') + 'value="none" checked disabled>' + ('<label class="' + t.options.classPrefix + 'captions-selector-label ') + (t.options.classPrefix + 'captions-selected" ') + ('for="' + player.id + '_captions_none">' + _i18n2.default.t('mejs.none') + '</label>') + '</li>' + '</ul>' + '</div>';
        t.addControlElement(player.captionsButton, 'tracks');
        player.captionsButton.querySelector('.' + t.options.classPrefix + 'captions-selector-input').disabled = false;
        player.chaptersButton = _document2.default.createElement('div');
        player.chaptersButton.className = t.options.classPrefix + 'button ' + t.options.classPrefix + 'chapters-button';
        player.chaptersButton.innerHTML = '<button type="button" aria-controls="' + t.id + '" title="' + chaptersTitle + '" aria-label="' + chaptersTitle + '" tabindex="0"></button>' + ('<div class="' + t.options.classPrefix + 'chapters-selector ' + t.options.classPrefix + 'offscreen">') + ('<ul class="' + t.options.classPrefix + 'chapters-selector-list"></ul>') + '</div>';
        var subtitleCount = 0;

        for (var _i = 0; _i < total; _i++) {
          var kind = player.tracks[_i].kind,
              src = player.tracks[_i].src;

          if (src.trim()) {
            if (kind === 'subtitles' || kind === 'captions') {
              subtitleCount++;
            } else if (kind === 'chapters' && !controls.querySelector('.' + t.options.classPrefix + 'chapter-selector')) {
              player.captionsButton.parentNode.insertBefore(player.chaptersButton, player.captionsButton);
            }
          }
        }

        player.trackToLoad = -1;
        player.selectedTrack = null;
        player.isLoadingTrack = false;

        for (var _i2 = 0; _i2 < total; _i2++) {
          var _kind = player.tracks[_i2].kind;

          if (player.tracks[_i2].src.trim() && (_kind === 'subtitles' || _kind === 'captions')) {
            player.addTrackButton(player.tracks[_i2].trackId, player.tracks[_i2].srclang, player.tracks[_i2].label);
          }
        }

        player.loadNextTrack();
        var inEvents = ['mouseenter', 'focusin'],
            outEvents = ['mouseleave', 'focusout'];

        if (t.options.toggleCaptionsButtonWhenOnlyOne && subtitleCount === 1) {
          player.captionsButton.addEventListener('click', function (e) {
            var trackId = 'none';

            if (player.selectedTrack === null) {
              trackId = player.tracks[0].trackId;
            }

            var keyboard = e.keyCode || e.which;
            player.setTrack(trackId, typeof keyboard !== 'undefined');
          });
        } else {
          var labels = player.captionsButton.querySelectorAll('.' + t.options.classPrefix + 'captions-selector-label'),
              captions = player.captionsButton.querySelectorAll('input[type=radio]');

          for (var _i3 = 0, _total = inEvents.length; _i3 < _total; _i3++) {
            player.captionsButton.addEventListener(inEvents[_i3], function () {
              (0, _dom.removeClass)(this.querySelector('.' + t.options.classPrefix + 'captions-selector'), t.options.classPrefix + 'offscreen');
            });
          }

          for (var _i4 = 0, _total2 = outEvents.length; _i4 < _total2; _i4++) {
            player.captionsButton.addEventListener(outEvents[_i4], function () {
              (0, _dom.addClass)(this.querySelector('.' + t.options.classPrefix + 'captions-selector'), t.options.classPrefix + 'offscreen');
            });
          }

          for (var _i5 = 0, _total3 = captions.length; _i5 < _total3; _i5++) {
            captions[_i5].addEventListener('click', function (e) {
              var keyboard = e.keyCode || e.which;
              player.setTrack(this.value, typeof keyboard !== 'undefined');
            });
          }

          for (var _i6 = 0, _total4 = labels.length; _i6 < _total4; _i6++) {
            labels[_i6].addEventListener('click', function (e) {
              var radio = (0, _dom.siblings)(this, function (el) {
                return el.tagName === 'INPUT';
              })[0],
                  event = (0, _general.createEvent)('click', radio);
              radio.dispatchEvent(event);
              e.preventDefault();
            });
          }

          player.captionsButton.addEventListener('keydown', function (e) {
            e.stopPropagation();
          });
        }

        for (var _i7 = 0, _total5 = inEvents.length; _i7 < _total5; _i7++) {
          player.chaptersButton.addEventListener(inEvents[_i7], function () {
            if (this.querySelector('.' + t.options.classPrefix + 'chapters-selector-list').children.length) {
              (0, _dom.removeClass)(this.querySelector('.' + t.options.classPrefix + 'chapters-selector'), t.options.classPrefix + 'offscreen');
            }
          });
        }

        for (var _i8 = 0, _total6 = outEvents.length; _i8 < _total6; _i8++) {
          player.chaptersButton.addEventListener(outEvents[_i8], function () {
            (0, _dom.addClass)(this.querySelector('.' + t.options.classPrefix + 'chapters-selector'), t.options.classPrefix + 'offscreen');
          });
        }

        player.chaptersButton.addEventListener('keydown', function (e) {
          e.stopPropagation();
        });

        if (!player.options.alwaysShowControls) {
          player.getElement(player.container).addEventListener('controlsshown', function () {
            (0, _dom.addClass)(player.getElement(player.container).querySelector('.' + t.options.classPrefix + 'captions-position'), t.options.classPrefix + 'captions-position-hover');
          });
          player.getElement(player.container).addEventListener('controlshidden', function () {
            if (!media.paused) {
              (0, _dom.removeClass)(player.getElement(player.container).querySelector('.' + t.options.classPrefix + 'captions-position'), t.options.classPrefix + 'captions-position-hover');
            }
          });
        } else {
          (0, _dom.addClass)(player.getElement(player.container).querySelector('.' + t.options.classPrefix + 'captions-position'), t.options.classPrefix + 'captions-position-hover');
        }

        media.addEventListener('timeupdate', function () {
          player.displayCaptions();
        });

        if (player.options.slidesSelector !== '') {
          player.slidesContainer = _document2.default.querySelectorAll(player.options.slidesSelector);
          media.addEventListener('timeupdate', function () {
            player.displaySlides();
          });
        }
      },
      cleartracks: function cleartracks(player) {
        if (player) {
          if (player.captions) {
            player.captions.remove();
          }

          if (player.chapters) {
            player.chapters.remove();
          }

          if (player.captionsText) {
            player.captionsText.remove();
          }

          if (player.captionsButton) {
            player.captionsButton.remove();
          }

          if (player.chaptersButton) {
            player.chaptersButton.remove();
          }
        }
      },
      rebuildtracks: function rebuildtracks() {
        var t = this;
        t.findTracks();
        t.buildtracks(t, t.getElement(t.controls), t.getElement(t.layers), t.media);
      },
      findTracks: function findTracks() {
        var t = this,
            tracktags = t.trackFiles === null ? t.node.querySelectorAll('track') : t.trackFiles,
            total = tracktags.length;
        t.tracks = [];

        for (var i = 0; i < total; i++) {
          var track = tracktags[i],
              srclang = track.getAttribute('srclang').toLowerCase() || '',
              trackId = t.id + '_track_' + i + '_' + track.getAttribute('kind') + '_' + srclang;
          t.tracks.push({
            trackId: trackId,
            srclang: srclang,
            src: track.getAttribute('src'),
            kind: track.getAttribute('kind'),
            label: track.getAttribute('label') || '',
            entries: [],
            isLoaded: false
          });
        }
      },
      setTrack: function setTrack(trackId, setByKeyboard) {
        var t = this,
            radios = t.captionsButton.querySelectorAll('input[type="radio"]'),
            captions = t.captionsButton.querySelectorAll('.' + t.options.classPrefix + 'captions-selected'),
            track = t.captionsButton.querySelector('input[value="' + trackId + '"]');

        for (var i = 0, total = radios.length; i < total; i++) {
          radios[i].checked = false;
        }

        for (var _i9 = 0, _total7 = captions.length; _i9 < _total7; _i9++) {
          (0, _dom.removeClass)(captions[_i9], t.options.classPrefix + 'captions-selected');
        }

        track.checked = true;
        var labels = (0, _dom.siblings)(track, function (el) {
          return (0, _dom.hasClass)(el, t.options.classPrefix + 'captions-selector-label');
        });

        for (var _i10 = 0, _total8 = labels.length; _i10 < _total8; _i10++) {
          (0, _dom.addClass)(labels[_i10], t.options.classPrefix + 'captions-selected');
        }

        if (trackId === 'none') {
          t.selectedTrack = null;
          (0, _dom.removeClass)(t.captionsButton, t.options.classPrefix + 'captions-enabled');
        } else {
          for (var _i11 = 0, _total9 = t.tracks.length; _i11 < _total9; _i11++) {
            var _track = t.tracks[_i11];

            if (_track.trackId === trackId) {
              if (t.selectedTrack === null) {
                (0, _dom.addClass)(t.captionsButton, t.options.classPrefix + 'captions-enabled');
              }

              t.selectedTrack = _track;
              t.captions.setAttribute('lang', t.selectedTrack.srclang);
              t.displayCaptions();
              break;
            }
          }
        }

        var event = (0, _general.createEvent)('captionschange', t.media);
        event.detail.caption = t.selectedTrack;
        t.media.dispatchEvent(event);

        if (!setByKeyboard) {
          setTimeout(function () {
            t.getElement(t.container).focus();
          }, 500);
        }
      },
      loadNextTrack: function loadNextTrack() {
        var t = this;
        t.trackToLoad++;

        if (t.trackToLoad < t.tracks.length) {
          t.isLoadingTrack = true;
          t.loadTrack(t.trackToLoad);
        } else {
          t.isLoadingTrack = false;
          t.checkForTracks();
        }
      },
      loadTrack: function loadTrack(index) {
        var t = this,
            track = t.tracks[index];

        if (track !== undefined && (track.src !== undefined || track.src !== "")) {
          (0, _dom.ajax)(track.src, 'text', function (d) {
            track.entries = typeof d === 'string' && /<tt\s+xml/ig.exec(d) ? _mejs2.default.TrackFormatParser.dfxp.parse(d) : _mejs2.default.TrackFormatParser.webvtt.parse(d);
            track.isLoaded = true;
            t.enableTrackButton(track);
            t.loadNextTrack();

            if (track.kind === 'slides') {
              t.setupSlides(track);
            } else if (track.kind === 'chapters' && !t.hasChapters) {
              t.drawChapters(track);
              t.hasChapters = true;
            }
          }, function () {
            t.removeTrackButton(track.trackId);
            t.loadNextTrack();
          });
        }
      },
      enableTrackButton: function enableTrackButton(track) {
        var t = this,
            lang = track.srclang,
            target = _document2.default.getElementById('' + track.trackId);

        if (!target) {
          return;
        }

        var label = track.label;

        if (label === '') {
          label = _i18n2.default.t(_mejs2.default.language.codes[lang]) || lang;
        }

        target.disabled = false;
        var targetSiblings = (0, _dom.siblings)(target, function (el) {
          return (0, _dom.hasClass)(el, t.options.classPrefix + 'captions-selector-label');
        });

        for (var i = 0, total = targetSiblings.length; i < total; i++) {
          targetSiblings[i].innerHTML = label;
        }

        if (t.options.startLanguage === lang) {
          target.checked = true;
          var event = (0, _general.createEvent)('click', target);
          target.dispatchEvent(event);
        }
      },
      removeTrackButton: function removeTrackButton(trackId) {
        var element = _document2.default.getElementById('' + trackId);

        if (element) {
          var button = element.closest('li');

          if (button) {
            button.remove();
          }
        }
      },
      addTrackButton: function addTrackButton(trackId, lang, label) {
        var t = this;

        if (label === '') {
          label = _i18n2.default.t(_mejs2.default.language.codes[lang]) || lang;
        }

        t.captionsButton.querySelector('ul').innerHTML += '<li class="' + t.options.classPrefix + 'captions-selector-list-item">' + ('<input type="radio" class="' + t.options.classPrefix + 'captions-selector-input" ') + ('name="' + t.id + '_captions" id="' + trackId + '" value="' + trackId + '" disabled>') + ('<label class="' + t.options.classPrefix + 'captions-selector-label"') + ('for="' + trackId + '">' + label + ' (loading)</label>') + '</li>';
      },
      checkForTracks: function checkForTracks() {
        var t = this;
        var hasSubtitles = false;

        if (t.options.hideCaptionsButtonWhenEmpty) {
          for (var i = 0, total = t.tracks.length; i < total; i++) {
            var kind = t.tracks[i].kind;

            if ((kind === 'subtitles' || kind === 'captions') && t.tracks[i].isLoaded) {
              hasSubtitles = true;
              break;
            }
          }

          t.captionsButton.style.display = hasSubtitles ? '' : 'none';
          t.setControlsSize();
        }
      },
      displayCaptions: function displayCaptions() {
        if (this.tracks === undefined) {
          return;
        }

        var t = this,
            track = t.selectedTrack,
            sanitize = function sanitize(html) {
          var div = _document2.default.createElement('div');

          div.innerHTML = html;
          var scripts = div.getElementsByTagName('script');
          var i = scripts.length;

          while (i--) {
            scripts[i].remove();
          }

          var allElements = div.getElementsByTagName('*');

          for (var _i12 = 0, n = allElements.length; _i12 < n; _i12++) {
            var attributesObj = allElements[_i12].attributes,
                attributes = Array.prototype.slice.call(attributesObj);

            for (var j = 0, total = attributes.length; j < total; j++) {
              if (attributes[j].name.startsWith('on') || attributes[j].value.startsWith('javascript')) {
                allElements[_i12].remove();
              } else if (attributes[j].name === 'style') {
                allElements[_i12].removeAttribute(attributes[j].name);
              }
            }
          }

          return div.innerHTML;
        };

        if (track !== null && track.isLoaded) {
          var i = t.searchTrackPosition(track.entries, t.media.currentTime);

          if (i > -1) {
            t.captionsText.innerHTML = sanitize(track.entries[i].text);
            t.captionsText.className = t.options.classPrefix + 'captions-text ' + (track.entries[i].identifier || '');
            t.captions.style.display = '';
            t.captions.style.height = '0px';
            return;
          }

          t.captions.style.display = 'none';
        } else {
          t.captions.style.display = 'none';
        }
      },
      setupSlides: function setupSlides(track) {
        var t = this;
        t.slides = track;
        t.slides.entries.imgs = [t.slides.entries.length];
        t.showSlide(0);
      },
      showSlide: function showSlide(index) {
        var _this = this;

        var t = this;

        if (t.tracks === undefined || t.slidesContainer === undefined) {
          return;
        }

        var url = t.slides.entries[index].text;
        var img = t.slides.entries[index].imgs;

        if (img === undefined || img.fadeIn === undefined) {
          var image = _document2.default.createElement('img');

          image.src = url;
          image.addEventListener('load', function () {
            var self = _this,
                visible = (0, _dom.siblings)(self, function (el) {
              return visible(el);
            });
            self.style.display = 'none';
            t.slidesContainer.innerHTML += self.innerHTML;
            (0, _dom.fadeIn)(t.slidesContainer.querySelector(image));

            for (var i = 0, total = visible.length; i < total; i++) {
              (0, _dom.fadeOut)(visible[i], 400);
            }
          });
          t.slides.entries[index].imgs = img = image;
        } else if (!(0, _dom.visible)(img)) {
          var _visible = (0, _dom.siblings)(self, function (el) {
            return _visible(el);
          });

          (0, _dom.fadeIn)(t.slidesContainer.querySelector(img));

          for (var i = 0, total = _visible.length; i < total; i++) {
            (0, _dom.fadeOut)(_visible[i]);
          }
        }
      },
      displaySlides: function displaySlides() {
        var t = this;

        if (this.slides === undefined) {
          return;
        }

        var slides = t.slides,
            i = t.searchTrackPosition(slides.entries, t.media.currentTime);

        if (i > -1) {
          t.showSlide(i);
        }
      },
      drawChapters: function drawChapters(chapters) {
        var t = this,
            total = chapters.entries.length;

        if (!total) {
          return;
        }

        t.chaptersButton.querySelector('ul').innerHTML = '';

        for (var i = 0; i < total; i++) {
          t.chaptersButton.querySelector('ul').innerHTML += '<li class="' + t.options.classPrefix + 'chapters-selector-list-item" ' + 'role="menuitemcheckbox" aria-live="polite" aria-disabled="false" aria-checked="false">' + ('<input type="radio" class="' + t.options.classPrefix + 'captions-selector-input" ') + ('name="' + t.id + '_chapters" id="' + t.id + '_chapters_' + i + '" value="' + chapters.entries[i].start + '" disabled>') + ('<label class="' + t.options.classPrefix + 'chapters-selector-label"') + ('for="' + t.id + '_chapters_' + i + '">' + chapters.entries[i].text + '</label>') + '</li>';
        }

        var radios = t.chaptersButton.querySelectorAll('input[type="radio"]'),
            labels = t.chaptersButton.querySelectorAll('.' + t.options.classPrefix + 'chapters-selector-label');

        for (var _i13 = 0, _total10 = radios.length; _i13 < _total10; _i13++) {
          radios[_i13].disabled = false;
          radios[_i13].checked = false;

          radios[_i13].addEventListener('click', function (e) {
            var self = this,
                listItems = t.chaptersButton.querySelectorAll('li'),
                label = (0, _dom.siblings)(self, function (el) {
              return (0, _dom.hasClass)(el, t.options.classPrefix + 'chapters-selector-label');
            })[0];
            self.checked = true;
            self.parentNode.setAttribute('aria-checked', true);
            (0, _dom.addClass)(label, t.options.classPrefix + 'chapters-selected');
            (0, _dom.removeClass)(t.chaptersButton.querySelector('.' + t.options.classPrefix + 'chapters-selected'), t.options.classPrefix + 'chapters-selected');

            for (var _i14 = 0, _total11 = listItems.length; _i14 < _total11; _i14++) {
              listItems[_i14].setAttribute('aria-checked', false);
            }

            var keyboard = e.keyCode || e.which;

            if (typeof keyboard === 'undefined') {
              setTimeout(function () {
                t.getElement(t.container).focus();
              }, 500);
            }

            t.media.setCurrentTime(parseFloat(self.value));

            if (t.media.paused) {
              t.media.play();
            }
          });
        }

        for (var _i15 = 0, _total12 = labels.length; _i15 < _total12; _i15++) {
          labels[_i15].addEventListener('click', function (e) {
            var radio = (0, _dom.siblings)(this, function (el) {
              return el.tagName === 'INPUT';
            })[0],
                event = (0, _general.createEvent)('click', radio);
            radio.dispatchEvent(event);
            e.preventDefault();
          });
        }
      },
      searchTrackPosition: function searchTrackPosition(tracks, currentTime) {
        var lo = 0,
            hi = tracks.length - 1,
            mid = void 0,
            start = void 0,
            stop = void 0;

        while (lo <= hi) {
          mid = lo + hi >> 1;
          start = tracks[mid].start;
          stop = tracks[mid].stop;

          if (currentTime >= start && currentTime < stop) {
            return mid;
          } else if (start < currentTime) {
            lo = mid + 1;
          } else if (start > currentTime) {
            hi = mid - 1;
          }
        }

        return -1;
      }
    });
    _mejs2.default.language = {
      codes: {
        af: 'mejs.afrikaans',
        sq: 'mejs.albanian',
        ar: 'mejs.arabic',
        be: 'mejs.belarusian',
        bg: 'mejs.bulgarian',
        ca: 'mejs.catalan',
        zh: 'mejs.chinese',
        'zh-cn': 'mejs.chinese-simplified',
        'zh-tw': 'mejs.chines-traditional',
        hr: 'mejs.croatian',
        cs: 'mejs.czech',
        da: 'mejs.danish',
        nl: 'mejs.dutch',
        en: 'mejs.english',
        et: 'mejs.estonian',
        fl: 'mejs.filipino',
        fi: 'mejs.finnish',
        fr: 'mejs.french',
        gl: 'mejs.galician',
        de: 'mejs.german',
        el: 'mejs.greek',
        ht: 'mejs.haitian-creole',
        iw: 'mejs.hebrew',
        hi: 'mejs.hindi',
        hu: 'mejs.hungarian',
        is: 'mejs.icelandic',
        id: 'mejs.indonesian',
        ga: 'mejs.irish',
        it: 'mejs.italian',
        ja: 'mejs.japanese',
        ko: 'mejs.korean',
        lv: 'mejs.latvian',
        lt: 'mejs.lithuanian',
        mk: 'mejs.macedonian',
        ms: 'mejs.malay',
        mt: 'mejs.maltese',
        no: 'mejs.norwegian',
        fa: 'mejs.persian',
        pl: 'mejs.polish',
        pt: 'mejs.portuguese',
        ro: 'mejs.romanian',
        ru: 'mejs.russian',
        sr: 'mejs.serbian',
        sk: 'mejs.slovak',
        sl: 'mejs.slovenian',
        es: 'mejs.spanish',
        sw: 'mejs.swahili',
        sv: 'mejs.swedish',
        tl: 'mejs.tagalog',
        th: 'mejs.thai',
        tr: 'mejs.turkish',
        uk: 'mejs.ukrainian',
        vi: 'mejs.vietnamese',
        cy: 'mejs.welsh',
        yi: 'mejs.yiddish'
      }
    };
    _mejs2.default.TrackFormatParser = {
      webvtt: {
        pattern: /^((?:[0-9]{1,2}:)?[0-9]{2}:[0-9]{2}([,.][0-9]{1,3})?) --\> ((?:[0-9]{1,2}:)?[0-9]{2}:[0-9]{2}([,.][0-9]{3})?)(.*)$/,
        parse: function parse(trackText) {
          var lines = trackText.split(/\r?\n/),
              entries = [];
          var timecode = void 0,
              text = void 0,
              identifier = void 0;

          for (var i = 0, total = lines.length; i < total; i++) {
            timecode = this.pattern.exec(lines[i]);

            if (timecode && i < lines.length) {
              if (i - 1 >= 0 && lines[i - 1] !== '') {
                identifier = lines[i - 1];
              }

              i++;
              text = lines[i];
              i++;

              while (lines[i] !== '' && i < lines.length) {
                text = text + '\n' + lines[i];
                i++;
              }

              text = text.trim().replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig, "<a href='$1' target='_blank'>$1</a>");
              entries.push({
                identifier: identifier,
                start: (0, _time.convertSMPTEtoSeconds)(timecode[1]) === 0 ? 0.200 : (0, _time.convertSMPTEtoSeconds)(timecode[1]),
                stop: (0, _time.convertSMPTEtoSeconds)(timecode[3]),
                text: text,
                settings: timecode[5]
              });
            }

            identifier = '';
          }

          return entries;
        }
      },
      dfxp: {
        parse: function parse(trackText) {
          trackText = $(trackText).filter('tt');
          var container = trackText.firstChild,
              lines = container.querySelectorAll('p'),
              styleNode = trackText.getElementById('' + container.attr('style')),
              entries = [];
          var styles = void 0;

          if (styleNode.length) {
            styleNode.removeAttribute('id');
            var attributes = styleNode.attributes;

            if (attributes.length) {
              styles = {};

              for (var i = 0, total = attributes.length; i < total; i++) {
                styles[attributes[i].name.split(":")[1]] = attributes[i].value;
              }
            }
          }

          for (var _i16 = 0, _total13 = lines.length; _i16 < _total13; _i16++) {
            var style = void 0,
                _temp = {
              start: null,
              stop: null,
              style: null,
              text: null
            };

            if (lines.eq(_i16).attr('begin')) {
              _temp.start = (0, _time.convertSMPTEtoSeconds)(lines.eq(_i16).attr('begin'));
            }

            if (!_temp.start && lines.eq(_i16 - 1).attr('end')) {
              _temp.start = (0, _time.convertSMPTEtoSeconds)(lines.eq(_i16 - 1).attr('end'));
            }

            if (lines.eq(_i16).attr('end')) {
              _temp.stop = (0, _time.convertSMPTEtoSeconds)(lines.eq(_i16).attr('end'));
            }

            if (!_temp.stop && lines.eq(_i16 + 1).attr('begin')) {
              _temp.stop = (0, _time.convertSMPTEtoSeconds)(lines.eq(_i16 + 1).attr('begin'));
            }

            if (styles) {
              style = '';

              for (var _style in styles) {
                style += _style + ':' + styles[_style] + ';';
              }
            }

            if (style) {
              _temp.style = style;
            }

            if (_temp.start === 0) {
              _temp.start = 0.200;
            }

            _temp.text = lines.eq(_i16).innerHTML.trim().replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig, "<a href='$1' target='_blank'>$1</a>");
            entries.push(_temp);
          }

          return entries;
        }
      }
    };
  }, {
    "16": 16,
    "2": 2,
    "26": 26,
    "27": 27,
    "30": 30,
    "5": 5,
    "7": 7
  }],
  14: [function (_dereq_, module, exports) {
    'use strict';

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _player = _dereq_(16);

    var _player2 = _interopRequireDefault(_player);

    var _i18n = _dereq_(5);

    var _i18n2 = _interopRequireDefault(_i18n);

    var _constants = _dereq_(25);

    var _general = _dereq_(27);

    var _dom = _dereq_(26);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    Object.assign(_player.config, {
      muteText: null,
      unmuteText: null,
      allyVolumeControlText: null,
      hideVolumeOnTouchDevices: true,
      audioVolume: 'horizontal',
      videoVolume: 'vertical',
      startVolume: 0.8
    });
    Object.assign(_player2.default.prototype, {
      buildvolume: function buildvolume(player, controls, layers, media) {
        if ((_constants.IS_ANDROID || _constants.IS_IOS) && this.options.hideVolumeOnTouchDevices) {
          return;
        }

        var t = this,
            mode = t.isVideo ? t.options.videoVolume : t.options.audioVolume,
            muteText = (0, _general.isString)(t.options.muteText) ? t.options.muteText : _i18n2.default.t('mejs.mute'),
            unmuteText = (0, _general.isString)(t.options.unmuteText) ? t.options.unmuteText : _i18n2.default.t('mejs.unmute'),
            volumeControlText = (0, _general.isString)(t.options.allyVolumeControlText) ? t.options.allyVolumeControlText : _i18n2.default.t('mejs.volume-help-text'),
            mute = _document2.default.createElement('div');

        mute.className = t.options.classPrefix + 'button ' + t.options.classPrefix + 'volume-button ' + t.options.classPrefix + 'mute';
        mute.innerHTML = mode === 'horizontal' ? '<button type="button" aria-controls="' + t.id + '" title="' + muteText + '" aria-label="' + muteText + '" tabindex="0"></button>' : '<button type="button" aria-controls="' + t.id + '" title="' + muteText + '" aria-label="' + muteText + '" tabindex="0"></button>' + ('<a href="javascript:void(0);" class="' + t.options.classPrefix + 'volume-slider" ') + ('aria-label="' + _i18n2.default.t('mejs.volume-slider') + '" aria-valuemin="0" aria-valuemax="100" role="slider" ') + 'aria-orientation="vertical">' + ('<span class="' + t.options.classPrefix + 'offscreen">' + volumeControlText + '</span>') + ('<div class="' + t.options.classPrefix + 'volume-total">') + ('<div class="' + t.options.classPrefix + 'volume-current"></div>') + ('<div class="' + t.options.classPrefix + 'volume-handle"></div>') + '</div>' + '</a>';
        t.addControlElement(mute, 'volume');
        t.options.keyActions.push({
          keys: [38],
          action: function action(player) {
            var volumeSlider = player.getElement(player.container).querySelector('.' + _player.config.classPrefix + 'volume-slider');

            if (volumeSlider || player.getElement(player.container).querySelector('.' + _player.config.classPrefix + 'volume-slider').matches(':focus')) {
              volumeSlider.style.display = 'block';
            }

            if (player.isVideo) {
              player.showControls();
              player.startControlsTimer();
            }

            var newVolume = Math.min(player.volume + 0.1, 1);
            player.setVolume(newVolume);

            if (newVolume > 0) {
              player.setMuted(false);
            }
          }
        }, {
          keys: [40],
          action: function action(player) {
            var volumeSlider = player.getElement(player.container).querySelector('.' + _player.config.classPrefix + 'volume-slider');

            if (volumeSlider) {
              volumeSlider.style.display = 'block';
            }

            if (player.isVideo) {
              player.showControls();
              player.startControlsTimer();
            }

            var newVolume = Math.max(player.volume - 0.1, 0);
            player.setVolume(newVolume);

            if (newVolume <= 0.1) {
              player.setMuted(true);
            }
          }
        }, {
          keys: [77],
          action: function action(player) {
            player.getElement(player.container).querySelector('.' + _player.config.classPrefix + 'volume-slider').style.display = 'block';

            if (player.isVideo) {
              player.showControls();
              player.startControlsTimer();
            }

            if (player.media.muted) {
              player.setMuted(false);
            } else {
              player.setMuted(true);
            }
          }
        });

        if (mode === 'horizontal') {
          var anchor = _document2.default.createElement('a');

          anchor.className = t.options.classPrefix + 'horizontal-volume-slider';
          anchor.href = 'javascript:void(0);';
          anchor.setAttribute('aria-label', _i18n2.default.t('mejs.volume-slider'));
          anchor.setAttribute('aria-valuemin', 0);
          anchor.setAttribute('aria-valuemax', 100);
          anchor.setAttribute('role', 'slider');
          anchor.innerHTML += '<span class="' + t.options.classPrefix + 'offscreen">' + volumeControlText + '</span>' + ('<div class="' + t.options.classPrefix + 'horizontal-volume-total">') + ('<div class="' + t.options.classPrefix + 'horizontal-volume-current"></div>') + ('<div class="' + t.options.classPrefix + 'horizontal-volume-handle"></div>') + '</div>';
          mute.parentNode.insertBefore(anchor, mute.nextSibling);
        }

        var mouseIsDown = false,
            mouseIsOver = false,
            modified = false,
            updateVolumeSlider = function updateVolumeSlider() {
          var volume = Math.floor(media.volume * 100);
          volumeSlider.setAttribute('aria-valuenow', volume);
          volumeSlider.setAttribute('aria-valuetext', volume + '%');
        };

        var volumeSlider = mode === 'vertical' ? t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'volume-slider') : t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'horizontal-volume-slider'),
            volumeTotal = mode === 'vertical' ? t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'volume-total') : t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'horizontal-volume-total'),
            volumeCurrent = mode === 'vertical' ? t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'volume-current') : t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'horizontal-volume-current'),
            volumeHandle = mode === 'vertical' ? t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'volume-handle') : t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'horizontal-volume-handle'),
            positionVolumeHandle = function positionVolumeHandle(volume) {
          if (volume === null || isNaN(volume) || volume === undefined) {
            return;
          }

          volume = Math.max(0, volume);
          volume = Math.min(volume, 1);

          if (volume === 0) {
            (0, _dom.removeClass)(mute, t.options.classPrefix + 'mute');
            (0, _dom.addClass)(mute, t.options.classPrefix + 'unmute');
            var button = mute.firstElementChild;
            button.setAttribute('title', unmuteText);
            button.setAttribute('aria-label', unmuteText);
          } else {
            (0, _dom.removeClass)(mute, t.options.classPrefix + 'unmute');
            (0, _dom.addClass)(mute, t.options.classPrefix + 'mute');
            var _button = mute.firstElementChild;

            _button.setAttribute('title', muteText);

            _button.setAttribute('aria-label', muteText);
          }

          var volumePercentage = volume * 100 + '%',
              volumeStyles = getComputedStyle(volumeHandle);

          if (mode === 'vertical') {
            volumeCurrent.style.bottom = 0;
            volumeCurrent.style.height = volumePercentage;
            volumeHandle.style.bottom = volumePercentage;
            volumeHandle.style.marginBottom = -parseFloat(volumeStyles.height) / 2 + 'px';
          } else {
            volumeCurrent.style.left = 0;
            volumeCurrent.style.width = volumePercentage;
            volumeHandle.style.left = volumePercentage;
            volumeHandle.style.marginLeft = -parseFloat(volumeStyles.width) / 2 + 'px';
          }
        },
            handleVolumeMove = function handleVolumeMove(e) {
          var totalOffset = (0, _dom.offset)(volumeTotal),
              volumeStyles = getComputedStyle(volumeTotal);
          modified = true;
          var volume = null;

          if (mode === 'vertical') {
            var railHeight = parseFloat(volumeStyles.height),
                newY = e.pageY - totalOffset.top;
            volume = (railHeight - newY) / railHeight;

            if (totalOffset.top === 0 || totalOffset.left === 0) {
              return;
            }
          } else {
            var railWidth = parseFloat(volumeStyles.width),
                newX = e.pageX - totalOffset.left;
            volume = newX / railWidth;
          }

          volume = Math.max(0, volume);
          volume = Math.min(volume, 1);
          positionVolumeHandle(volume);
          t.setMuted(volume === 0);
          t.setVolume(volume);
          e.preventDefault();
          e.stopPropagation();
        },
            toggleMute = function toggleMute() {
          if (t.muted) {
            positionVolumeHandle(0);
            (0, _dom.removeClass)(mute, t.options.classPrefix + 'mute');
            (0, _dom.addClass)(mute, t.options.classPrefix + 'unmute');
          } else {
            positionVolumeHandle(media.volume);
            (0, _dom.removeClass)(mute, t.options.classPrefix + 'unmute');
            (0, _dom.addClass)(mute, t.options.classPrefix + 'mute');
          }
        };

        player.getElement(player.container).addEventListener('keydown', function (e) {
          var hasFocus = !!e.target.closest('.' + t.options.classPrefix + 'container');

          if (!hasFocus && mode === 'vertical') {
            volumeSlider.style.display = 'none';
          }
        });
        mute.addEventListener('mouseenter', function (e) {
          if (e.target === mute) {
            volumeSlider.style.display = 'block';
            mouseIsOver = true;
            e.preventDefault();
            e.stopPropagation();
          }
        });
        mute.addEventListener('focusin', function () {
          volumeSlider.style.display = 'block';
          mouseIsOver = true;
        });
        mute.addEventListener('focusout', function (e) {
          if ((!e.relatedTarget || e.relatedTarget && !e.relatedTarget.matches('.' + t.options.classPrefix + 'volume-slider')) && mode === 'vertical') {
            volumeSlider.style.display = 'none';
          }
        });
        mute.addEventListener('mouseleave', function () {
          mouseIsOver = false;

          if (!mouseIsDown && mode === 'vertical') {
            volumeSlider.style.display = 'none';
          }
        });
        mute.addEventListener('focusout', function () {
          mouseIsOver = false;
        });
        mute.addEventListener('keydown', function (e) {
          if (t.options.enableKeyboard && t.options.keyActions.length) {
            var keyCode = e.which || e.keyCode || 0,
                volume = media.volume;

            switch (keyCode) {
              case 38:
                volume = Math.min(volume + 0.1, 1);
                break;

              case 40:
                volume = Math.max(0, volume - 0.1);
                break;

              default:
                return true;
            }

            mouseIsDown = false;
            positionVolumeHandle(volume);
            media.setVolume(volume);
            e.preventDefault();
            e.stopPropagation();
          }
        });
        mute.querySelector('button').addEventListener('click', function () {
          media.setMuted(!media.muted);
          var event = (0, _general.createEvent)('volumechange', media);
          media.dispatchEvent(event);
        });
        volumeSlider.addEventListener('dragstart', function () {
          return false;
        });
        volumeSlider.addEventListener('mouseover', function () {
          mouseIsOver = true;
        });
        volumeSlider.addEventListener('focusin', function () {
          volumeSlider.style.display = 'block';
          mouseIsOver = true;
        });
        volumeSlider.addEventListener('focusout', function () {
          mouseIsOver = false;

          if (!mouseIsDown && mode === 'vertical') {
            volumeSlider.style.display = 'none';
          }
        });
        volumeSlider.addEventListener('mousedown', function (e) {
          handleVolumeMove(e);
          t.globalBind('mousemove.vol', function (event) {
            var target = event.target;

            if (mouseIsDown && (target === volumeSlider || target.closest(mode === 'vertical' ? '.' + t.options.classPrefix + 'volume-slider' : '.' + t.options.classPrefix + 'horizontal-volume-slider'))) {
              handleVolumeMove(event);
            }
          });
          t.globalBind('mouseup.vol', function () {
            mouseIsDown = false;

            if (!mouseIsOver && mode === 'vertical') {
              volumeSlider.style.display = 'none';
            }
          });
          mouseIsDown = true;
          e.preventDefault();
          e.stopPropagation();
        });
        media.addEventListener('volumechange', function (e) {
          if (!mouseIsDown) {
            toggleMute();
          }

          updateVolumeSlider(e);
        });
        var rendered = false;
        media.addEventListener('rendererready', function () {
          if (!modified) {
            setTimeout(function () {
              rendered = true;

              if (player.options.startVolume === 0 || media.originalNode.muted) {
                media.setMuted(true);
                player.options.startVolume = 0;
              }

              media.setVolume(player.options.startVolume);
              t.setControlsSize();
            }, 250);
          }
        });
        media.addEventListener('loadedmetadata', function () {
          setTimeout(function () {
            if (!modified && !rendered) {
              if (player.options.startVolume === 0 || media.originalNode.muted) {
                media.setMuted(true);
              }

              media.setVolume(player.options.startVolume);
              t.setControlsSize();
            }

            rendered = false;
          }, 250);
        });

        if (player.options.startVolume === 0 || media.originalNode.muted) {
          media.setMuted(true);
          player.options.startVolume = 0;
          toggleMute();
        }

        t.getElement(t.container).addEventListener('controlsresize', function () {
          toggleMute();
        });
      }
    });
  }, {
    "16": 16,
    "2": 2,
    "25": 25,
    "26": 26,
    "27": 27,
    "5": 5
  }],
  15: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var EN = exports.EN = {
      'mejs.plural-form': 1,
      'mejs.download-file': 'Download File',
      'mejs.install-flash': 'You are using a browser that does not have Flash player enabled or installed. Please turn on your Flash player plugin or download the latest version from https://get.adobe.com/flashplayer/',
      'mejs.fullscreen': 'Fullscreen',
      'mejs.play': 'Play',
      'mejs.pause': 'Pause',
      'mejs.time-slider': 'Time Slider',
      'mejs.time-help-text': 'Use Left/Right Arrow keys to advance one second, Up/Down arrows to advance ten seconds.',
      'mejs.live-broadcast': 'Live Broadcast',
      'mejs.volume-help-text': 'Use Up/Down Arrow keys to increase or decrease volume.',
      'mejs.unmute': 'Unmute',
      'mejs.mute': 'Mute',
      'mejs.volume-slider': 'Volume Slider',
      'mejs.video-player': 'Video Player',
      'mejs.audio-player': 'Audio Player',
      'mejs.captions-subtitles': 'Captions/Subtitles',
      'mejs.captions-chapters': 'Chapters',
      'mejs.none': 'None',
      'mejs.afrikaans': 'Afrikaans',
      'mejs.albanian': 'Albanian',
      'mejs.arabic': 'Arabic',
      'mejs.belarusian': 'Belarusian',
      'mejs.bulgarian': 'Bulgarian',
      'mejs.catalan': 'Catalan',
      'mejs.chinese': 'Chinese',
      'mejs.chinese-simplified': 'Chinese (Simplified)',
      'mejs.chinese-traditional': 'Chinese (Traditional)',
      'mejs.croatian': 'Croatian',
      'mejs.czech': 'Czech',
      'mejs.danish': 'Danish',
      'mejs.dutch': 'Dutch',
      'mejs.english': 'English',
      'mejs.estonian': 'Estonian',
      'mejs.filipino': 'Filipino',
      'mejs.finnish': 'Finnish',
      'mejs.french': 'French',
      'mejs.galician': 'Galician',
      'mejs.german': 'German',
      'mejs.greek': 'Greek',
      'mejs.haitian-creole': 'Haitian Creole',
      'mejs.hebrew': 'Hebrew',
      'mejs.hindi': 'Hindi',
      'mejs.hungarian': 'Hungarian',
      'mejs.icelandic': 'Icelandic',
      'mejs.indonesian': 'Indonesian',
      'mejs.irish': 'Irish',
      'mejs.italian': 'Italian',
      'mejs.japanese': 'Japanese',
      'mejs.korean': 'Korean',
      'mejs.latvian': 'Latvian',
      'mejs.lithuanian': 'Lithuanian',
      'mejs.macedonian': 'Macedonian',
      'mejs.malay': 'Malay',
      'mejs.maltese': 'Maltese',
      'mejs.norwegian': 'Norwegian',
      'mejs.persian': 'Persian',
      'mejs.polish': 'Polish',
      'mejs.portuguese': 'Portuguese',
      'mejs.romanian': 'Romanian',
      'mejs.russian': 'Russian',
      'mejs.serbian': 'Serbian',
      'mejs.slovak': 'Slovak',
      'mejs.slovenian': 'Slovenian',
      'mejs.spanish': 'Spanish',
      'mejs.swahili': 'Swahili',
      'mejs.swedish': 'Swedish',
      'mejs.tagalog': 'Tagalog',
      'mejs.thai': 'Thai',
      'mejs.turkish': 'Turkish',
      'mejs.ukrainian': 'Ukrainian',
      'mejs.vietnamese': 'Vietnamese',
      'mejs.welsh': 'Welsh',
      'mejs.yiddish': 'Yiddish'
    };
  }, {}],
  16: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.config = undefined;

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _mediaelement = _dereq_(6);

    var _mediaelement2 = _interopRequireDefault(_mediaelement);

    var _default = _dereq_(17);

    var _default2 = _interopRequireDefault(_default);

    var _i18n = _dereq_(5);

    var _i18n2 = _interopRequireDefault(_i18n);

    var _constants = _dereq_(25);

    var _general = _dereq_(27);

    var _time = _dereq_(30);

    var _media = _dereq_(28);

    var _dom = _dereq_(26);

    var dom = _interopRequireWildcard(_dom);

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};

        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }

        newObj.default = obj;
        return newObj;
      }
    }

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    _mejs2.default.mepIndex = 0;
    _mejs2.default.players = {};
    var config = exports.config = {
      poster: '',
      showPosterWhenEnded: false,
      showPosterWhenPaused: false,
      defaultVideoWidth: 480,
      defaultVideoHeight: 270,
      videoWidth: -1,
      videoHeight: -1,
      defaultAudioWidth: 400,
      defaultAudioHeight: 40,
      defaultSeekBackwardInterval: function defaultSeekBackwardInterval(media) {
        return media.getDuration() * 0.05;
      },
      defaultSeekForwardInterval: function defaultSeekForwardInterval(media) {
        return media.getDuration() * 0.05;
      },
      setDimensions: true,
      audioWidth: -1,
      audioHeight: -1,
      loop: false,
      autoRewind: true,
      enableAutosize: true,
      timeFormat: '',
      alwaysShowHours: false,
      showTimecodeFrameCount: false,
      framesPerSecond: 25,
      alwaysShowControls: false,
      hideVideoControlsOnLoad: false,
      hideVideoControlsOnPause: false,
      clickToPlayPause: true,
      controlsTimeoutDefault: 1500,
      controlsTimeoutMouseEnter: 2500,
      controlsTimeoutMouseLeave: 1000,
      iPadUseNativeControls: false,
      iPhoneUseNativeControls: false,
      AndroidUseNativeControls: false,
      features: ['playpause', 'current', 'progress', 'duration', 'tracks', 'volume', 'fullscreen'],
      useDefaultControls: false,
      isVideo: true,
      stretching: 'auto',
      classPrefix: 'mejs__',
      enableKeyboard: true,
      pauseOtherPlayers: true,
      secondsDecimalLength: 0,
      customError: null,
      keyActions: [{
        keys: [32, 179],
        action: function action(player) {
          if (!_constants.IS_FIREFOX) {
            if (player.paused || player.ended) {
              player.play();
            } else {
              player.pause();
            }
          }
        }
      }]
    };
    _mejs2.default.MepDefaults = config;

    var MediaElementPlayer = function () {
      function MediaElementPlayer(node, o) {
        _classCallCheck(this, MediaElementPlayer);

        var t = this,
            element = typeof node === 'string' ? _document2.default.getElementById(node) : node;

        if (!(t instanceof MediaElementPlayer)) {
          return new MediaElementPlayer(element, o);
        }

        t.node = t.media = element;

        if (!t.node) {
          return;
        }

        if (t.media.player) {
          return t.media.player;
        }

        t.hasFocus = false;
        t.controlsAreVisible = true;
        t.controlsEnabled = true;
        t.controlsTimer = null;
        t.currentMediaTime = 0;
        t.proxy = null;

        if (o === undefined) {
          var options = t.node.getAttribute('data-mejsoptions');
          o = options ? JSON.parse(options) : {};
        }

        t.options = Object.assign({}, config, o);

        if (t.options.loop && !t.media.getAttribute('loop')) {
          t.media.loop = true;
          t.node.loop = true;
        } else if (t.media.loop) {
          t.options.loop = true;
        }

        if (!t.options.timeFormat) {
          t.options.timeFormat = 'mm:ss';

          if (t.options.alwaysShowHours) {
            t.options.timeFormat = 'hh:mm:ss';
          }

          if (t.options.showTimecodeFrameCount) {
            t.options.timeFormat += ':ff';
          }
        }

        (0, _time.calculateTimeFormat)(0, t.options, t.options.framesPerSecond || 25);
        t.id = 'mep_' + _mejs2.default.mepIndex++;
        _mejs2.default.players[t.id] = t;
        t.init();
        return t;
      }

      _createClass(MediaElementPlayer, [{
        key: 'getElement',
        value: function getElement(element) {
          return element;
        }
      }, {
        key: 'init',
        value: function init() {
          var t = this,
              playerOptions = Object.assign({}, t.options, {
            success: function success(media, domNode) {
              t._meReady(media, domNode);
            },
            error: function error(e) {
              t._handleError(e);
            }
          }),
              tagName = t.node.tagName.toLowerCase();
          t.isDynamic = tagName !== 'audio' && tagName !== 'video' && tagName !== 'iframe';
          t.isVideo = t.isDynamic ? t.options.isVideo : tagName !== 'audio' && t.options.isVideo;
          t.mediaFiles = null;
          t.trackFiles = null;

          if (_constants.IS_IPAD && t.options.iPadUseNativeControls || _constants.IS_IPHONE && t.options.iPhoneUseNativeControls) {
            t.node.setAttribute('controls', true);

            if (_constants.IS_IPAD && t.node.getAttribute('autoplay')) {
              t.play();
            }
          } else if ((t.isVideo || !t.isVideo && (t.options.features.length || t.options.useDefaultControls)) && !(_constants.IS_ANDROID && t.options.AndroidUseNativeControls)) {
            t.node.removeAttribute('controls');
            var videoPlayerTitle = t.isVideo ? _i18n2.default.t('mejs.video-player') : _i18n2.default.t('mejs.audio-player');

            var offscreen = _document2.default.createElement('span');

            offscreen.className = t.options.classPrefix + 'offscreen';
            offscreen.innerText = videoPlayerTitle;
            t.media.parentNode.insertBefore(offscreen, t.media);
            t.container = _document2.default.createElement('div');
            t.getElement(t.container).id = t.id;
            t.getElement(t.container).className = t.options.classPrefix + 'container ' + t.options.classPrefix + 'container-keyboard-inactive ' + t.media.className;
            t.getElement(t.container).tabIndex = 0;
            t.getElement(t.container).setAttribute('role', 'application');
            t.getElement(t.container).setAttribute('aria-label', videoPlayerTitle);
            t.getElement(t.container).innerHTML = '<div class="' + t.options.classPrefix + 'inner">' + ('<div class="' + t.options.classPrefix + 'mediaelement"></div>') + ('<div class="' + t.options.classPrefix + 'layers"></div>') + ('<div class="' + t.options.classPrefix + 'controls"></div>') + '</div>';
            t.getElement(t.container).addEventListener('focus', function (e) {
              if (!t.controlsAreVisible && !t.hasFocus && t.controlsEnabled) {
                t.showControls(true);
                var btnSelector = (0, _general.isNodeAfter)(e.relatedTarget, t.getElement(t.container)) ? '.' + t.options.classPrefix + 'controls .' + t.options.classPrefix + 'button:last-child > button' : '.' + t.options.classPrefix + 'playpause-button > button',
                    button = t.getElement(t.container).querySelector(btnSelector);
                button.focus();
              }
            });
            t.node.parentNode.insertBefore(t.getElement(t.container), t.node);

            if (!t.options.features.length && !t.options.useDefaultControls) {
              t.getElement(t.container).style.background = 'transparent';
              t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'controls').style.display = 'none';
            }

            if (t.isVideo && t.options.stretching === 'fill' && !dom.hasClass(t.getElement(t.container).parentNode, t.options.classPrefix + 'fill-container')) {
              t.outerContainer = t.media.parentNode;

              var wrapper = _document2.default.createElement('div');

              wrapper.className = t.options.classPrefix + 'fill-container';
              t.getElement(t.container).parentNode.insertBefore(wrapper, t.getElement(t.container));
              wrapper.appendChild(t.getElement(t.container));
            }

            if (_constants.IS_ANDROID) {
              dom.addClass(t.getElement(t.container), t.options.classPrefix + 'android');
            }

            if (_constants.IS_IOS) {
              dom.addClass(t.getElement(t.container), t.options.classPrefix + 'ios');
            }

            if (_constants.IS_IPAD) {
              dom.addClass(t.getElement(t.container), t.options.classPrefix + 'ipad');
            }

            if (_constants.IS_IPHONE) {
              dom.addClass(t.getElement(t.container), t.options.classPrefix + 'iphone');
            }

            dom.addClass(t.getElement(t.container), t.isVideo ? t.options.classPrefix + 'video' : t.options.classPrefix + 'audio');

            if (_constants.IS_SAFARI && !_constants.IS_IOS) {
              dom.addClass(t.getElement(t.container), t.options.classPrefix + 'hide-cues');
              var cloneNode = t.node.cloneNode(),
                  children = t.node.children,
                  mediaFiles = [],
                  tracks = [];

              for (var i = 0, total = children.length; i < total; i++) {
                var childNode = children[i];

                (function () {
                  switch (childNode.tagName.toLowerCase()) {
                    case 'source':
                      var elements = {};
                      Array.prototype.slice.call(childNode.attributes).forEach(function (item) {
                        elements[item.name] = item.value;
                      });
                      elements.type = (0, _media.formatType)(elements.src, elements.type);
                      mediaFiles.push(elements);
                      break;

                    case 'track':
                      childNode.mode = 'hidden';
                      tracks.push(childNode);
                      break;

                    default:
                      cloneNode.appendChild(childNode);
                      break;
                  }
                })();
              }

              t.node.remove();
              t.node = t.media = cloneNode;

              if (mediaFiles.length) {
                t.mediaFiles = mediaFiles;
              }

              if (tracks.length) {
                t.trackFiles = tracks;
              }
            }

            t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'mediaelement').appendChild(t.node);
            t.media.player = t;
            t.controls = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'controls');
            t.layers = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'layers');
            var tagType = t.isVideo ? 'video' : 'audio',
                capsTagName = tagType.substring(0, 1).toUpperCase() + tagType.substring(1);

            if (t.options[tagType + 'Width'] > 0 || t.options[tagType + 'Width'].toString().indexOf('%') > -1) {
              t.width = t.options[tagType + 'Width'];
            } else if (t.node.style.width !== '' && t.node.style.width !== null) {
              t.width = t.node.style.width;
            } else if (t.node.getAttribute('width')) {
              t.width = t.node.getAttribute('width');
            } else {
              t.width = t.options['default' + capsTagName + 'Width'];
            }

            if (t.options[tagType + 'Height'] > 0 || t.options[tagType + 'Height'].toString().indexOf('%') > -1) {
              t.height = t.options[tagType + 'Height'];
            } else if (t.node.style.height !== '' && t.node.style.height !== null) {
              t.height = t.node.style.height;
            } else if (t.node.getAttribute('height')) {
              t.height = t.node.getAttribute('height');
            } else {
              t.height = t.options['default' + capsTagName + 'Height'];
            }

            t.initialAspectRatio = t.height >= t.width ? t.width / t.height : t.height / t.width;
            t.setPlayerSize(t.width, t.height);
            playerOptions.pluginWidth = t.width;
            playerOptions.pluginHeight = t.height;
          } else if (!t.isVideo && !t.options.features.length && !t.options.useDefaultControls) {
            t.node.style.display = 'none';
          }

          _mejs2.default.MepDefaults = playerOptions;
          new _mediaelement2.default(t.media, playerOptions, t.mediaFiles);

          if (t.getElement(t.container) !== undefined && t.options.features.length && t.controlsAreVisible && !t.options.hideVideoControlsOnLoad) {
            var event = (0, _general.createEvent)('controlsshown', t.getElement(t.container));
            t.getElement(t.container).dispatchEvent(event);
          }
        }
      }, {
        key: 'showControls',
        value: function showControls(doAnimation) {
          var t = this;
          doAnimation = doAnimation === undefined || doAnimation;

          if (t.controlsAreVisible || !t.isVideo) {
            return;
          }

          if (doAnimation) {
            (function () {
              dom.fadeIn(t.getElement(t.controls), 200, function () {
                dom.removeClass(t.getElement(t.controls), t.options.classPrefix + 'offscreen');
                var event = (0, _general.createEvent)('controlsshown', t.getElement(t.container));
                t.getElement(t.container).dispatchEvent(event);
              });
              var controls = t.getElement(t.container).querySelectorAll('.' + t.options.classPrefix + 'control');

              var _loop = function _loop(i, total) {
                dom.fadeIn(controls[i], 200, function () {
                  dom.removeClass(controls[i], t.options.classPrefix + 'offscreen');
                });
              };

              for (var i = 0, total = controls.length; i < total; i++) {
                _loop(i, total);
              }
            })();
          } else {
            dom.removeClass(t.getElement(t.controls), t.options.classPrefix + 'offscreen');
            t.getElement(t.controls).style.display = '';
            t.getElement(t.controls).style.opacity = 1;
            var controls = t.getElement(t.container).querySelectorAll('.' + t.options.classPrefix + 'control');

            for (var i = 0, total = controls.length; i < total; i++) {
              dom.removeClass(controls[i], t.options.classPrefix + 'offscreen');
              controls[i].style.display = '';
            }

            var event = (0, _general.createEvent)('controlsshown', t.getElement(t.container));
            t.getElement(t.container).dispatchEvent(event);
          }

          t.controlsAreVisible = true;
          t.setControlsSize();
        }
      }, {
        key: 'hideControls',
        value: function hideControls(doAnimation, forceHide) {
          var t = this;
          doAnimation = doAnimation === undefined || doAnimation;

          if (forceHide !== true && (!t.controlsAreVisible || t.options.alwaysShowControls || t.paused && t.readyState === 4 && (!t.options.hideVideoControlsOnLoad && t.currentTime <= 0 || !t.options.hideVideoControlsOnPause && t.currentTime > 0) || t.isVideo && !t.options.hideVideoControlsOnLoad && !t.readyState || t.ended)) {
            return;
          }

          if (doAnimation) {
            (function () {
              dom.fadeOut(t.getElement(t.controls), 200, function () {
                dom.addClass(t.getElement(t.controls), t.options.classPrefix + 'offscreen');
                t.getElement(t.controls).style.display = '';
                var event = (0, _general.createEvent)('controlshidden', t.getElement(t.container));
                t.getElement(t.container).dispatchEvent(event);
              });
              var controls = t.getElement(t.container).querySelectorAll('.' + t.options.classPrefix + 'control');

              var _loop2 = function _loop2(i, total) {
                dom.fadeOut(controls[i], 200, function () {
                  dom.addClass(controls[i], t.options.classPrefix + 'offscreen');
                  controls[i].style.display = '';
                });
              };

              for (var i = 0, total = controls.length; i < total; i++) {
                _loop2(i, total);
              }
            })();
          } else {
            dom.addClass(t.getElement(t.controls), t.options.classPrefix + 'offscreen');
            t.getElement(t.controls).style.display = '';
            t.getElement(t.controls).style.opacity = 0;
            var controls = t.getElement(t.container).querySelectorAll('.' + t.options.classPrefix + 'control');

            for (var i = 0, total = controls.length; i < total; i++) {
              dom.addClass(controls[i], t.options.classPrefix + 'offscreen');
              controls[i].style.display = '';
            }

            var event = (0, _general.createEvent)('controlshidden', t.getElement(t.container));
            t.getElement(t.container).dispatchEvent(event);
          }

          t.controlsAreVisible = false;
        }
      }, {
        key: 'startControlsTimer',
        value: function startControlsTimer(timeout) {
          var t = this;
          timeout = typeof timeout !== 'undefined' ? timeout : t.options.controlsTimeoutDefault;
          t.killControlsTimer('start');
          t.controlsTimer = setTimeout(function () {
            t.hideControls();
            t.killControlsTimer('hide');
          }, timeout);
        }
      }, {
        key: 'killControlsTimer',
        value: function killControlsTimer() {
          var t = this;

          if (t.controlsTimer !== null) {
            clearTimeout(t.controlsTimer);
            delete t.controlsTimer;
            t.controlsTimer = null;
          }
        }
      }, {
        key: 'disableControls',
        value: function disableControls() {
          var t = this;
          t.killControlsTimer();
          t.controlsEnabled = false;
          t.hideControls(false, true);
        }
      }, {
        key: 'enableControls',
        value: function enableControls() {
          var t = this;
          t.controlsEnabled = true;
          t.showControls(false);
        }
      }, {
        key: '_setDefaultPlayer',
        value: function _setDefaultPlayer() {
          var t = this;

          if (t.proxy) {
            t.proxy.pause();
          }

          t.proxy = new _default2.default(t);
          t.media.addEventListener('loadedmetadata', function () {
            if (t.getCurrentTime() > 0 && t.currentMediaTime > 0) {
              t.setCurrentTime(t.currentMediaTime);

              if (!_constants.IS_IOS && !_constants.IS_ANDROID) {
                t.play();
              }
            }
          });
        }
      }, {
        key: '_meReady',
        value: function _meReady(media, domNode) {
          var t = this,
              autoplayAttr = domNode.getAttribute('autoplay'),
              autoplay = !(autoplayAttr === undefined || autoplayAttr === null || autoplayAttr === 'false'),
              isNative = media.rendererName !== null && /(native|html5)/i.test(t.media.rendererName);

          if (t.getElement(t.controls)) {
            t.enableControls();
          }

          if (t.getElement(t.container) && t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'overlay-play')) {
            t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'overlay-play').style.display = '';
          }

          if (t.created) {
            return;
          }

          t.created = true;
          t.media = media;
          t.domNode = domNode;

          if (!(_constants.IS_ANDROID && t.options.AndroidUseNativeControls) && !(_constants.IS_IPAD && t.options.iPadUseNativeControls) && !(_constants.IS_IPHONE && t.options.iPhoneUseNativeControls)) {
            if (!t.isVideo && !t.options.features.length && !t.options.useDefaultControls) {
              if (autoplay && isNative) {
                t.play();
              }

              if (t.options.success) {
                if (typeof t.options.success === 'string') {
                  _window2.default[t.options.success](t.media, t.domNode, t);
                } else {
                  t.options.success(t.media, t.domNode, t);
                }
              }

              return;
            }

            t.featurePosition = {};

            t._setDefaultPlayer();

            t.buildposter(t, t.getElement(t.controls), t.getElement(t.layers), t.media);
            t.buildkeyboard(t, t.getElement(t.controls), t.getElement(t.layers), t.media);
            t.buildoverlays(t, t.getElement(t.controls), t.getElement(t.layers), t.media);

            if (t.options.useDefaultControls) {
              var defaultControls = ['playpause', 'current', 'progress', 'duration', 'tracks', 'volume', 'fullscreen'];
              t.options.features = defaultControls.concat(t.options.features.filter(function (item) {
                return defaultControls.indexOf(item) === -1;
              }));
            }

            t.buildfeatures(t, t.getElement(t.controls), t.getElement(t.layers), t.media);
            var event = (0, _general.createEvent)('controlsready', t.getElement(t.container));
            t.getElement(t.container).dispatchEvent(event);
            t.setPlayerSize(t.width, t.height);
            t.setControlsSize();

            if (t.isVideo) {
              t.clickToPlayPauseCallback = function () {
                if (t.options.clickToPlayPause) {
                  var button = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'overlay-button'),
                      pressed = button.getAttribute('aria-pressed');

                  if (t.paused && pressed) {
                    t.pause();
                  } else if (t.paused) {
                    t.play();
                  } else {
                    t.pause();
                  }

                  button.setAttribute('aria-pressed', !pressed);
                  t.getElement(t.container).focus();
                }
              };

              t.createIframeLayer();
              t.media.addEventListener('click', t.clickToPlayPauseCallback);

              if ((_constants.IS_ANDROID || _constants.IS_IOS) && !t.options.alwaysShowControls) {
                t.node.addEventListener('touchstart', function () {
                  if (t.controlsAreVisible) {
                    t.hideControls(false);
                  } else {
                    if (t.controlsEnabled) {
                      t.showControls(false);
                    }
                  }
                }, _constants.SUPPORT_PASSIVE_EVENT ? {
                  passive: true
                } : false);
              } else {
                t.getElement(t.container).addEventListener('mouseenter', function () {
                  if (t.controlsEnabled) {
                    if (!t.options.alwaysShowControls) {
                      t.killControlsTimer('enter');
                      t.showControls();
                      t.startControlsTimer(t.options.controlsTimeoutMouseEnter);
                    }
                  }
                });
                t.getElement(t.container).addEventListener('mousemove', function () {
                  if (t.controlsEnabled) {
                    if (!t.controlsAreVisible) {
                      t.showControls();
                    }

                    if (!t.options.alwaysShowControls) {
                      t.startControlsTimer(t.options.controlsTimeoutMouseEnter);
                    }
                  }
                });
                t.getElement(t.container).addEventListener('mouseleave', function () {
                  if (t.controlsEnabled) {
                    if (!t.paused && !t.options.alwaysShowControls) {
                      t.startControlsTimer(t.options.controlsTimeoutMouseLeave);
                    }
                  }
                });
              }

              if (t.options.hideVideoControlsOnLoad) {
                t.hideControls(false);
              }

              if (t.options.enableAutosize) {
                t.media.addEventListener('loadedmetadata', function (e) {
                  var target = e !== undefined ? e.detail.target || e.target : t.media;

                  if (t.options.videoHeight <= 0 && !t.domNode.getAttribute('height') && !t.domNode.style.height && target !== null && !isNaN(target.videoHeight)) {
                    t.setPlayerSize(target.videoWidth, target.videoHeight);
                    t.setControlsSize();
                    t.media.setSize(target.videoWidth, target.videoHeight);
                  }
                });
              }
            }

            t.media.addEventListener('play', function () {
              t.hasFocus = true;

              for (var playerIndex in _mejs2.default.players) {
                if (_mejs2.default.players.hasOwnProperty(playerIndex)) {
                  var p = _mejs2.default.players[playerIndex];

                  if (p.id !== t.id && t.options.pauseOtherPlayers && !p.paused && !p.ended) {
                    p.pause();
                    p.hasFocus = false;
                  }
                }
              }

              if (!(_constants.IS_ANDROID || _constants.IS_IOS) && !t.options.alwaysShowControls && t.isVideo) {
                t.hideControls();
              }
            });
            t.media.addEventListener('ended', function () {
              if (t.options.autoRewind) {
                try {
                  t.setCurrentTime(0);
                  setTimeout(function () {
                    var loadingElement = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'overlay-loading');

                    if (loadingElement && loadingElement.parentNode) {
                      loadingElement.parentNode.style.display = 'none';
                    }
                  }, 20);
                } catch (exp) {}
              }

              if (typeof t.media.renderer.stop === 'function') {
                t.media.renderer.stop();
              } else {
                t.pause();
              }

              if (t.setProgressRail) {
                t.setProgressRail();
              }

              if (t.setCurrentRail) {
                t.setCurrentRail();
              }

              if (t.options.loop) {
                t.play();
              } else if (!t.options.alwaysShowControls && t.controlsEnabled) {
                t.showControls();
              }
            });
            t.media.addEventListener('loadedmetadata', function () {
              (0, _time.calculateTimeFormat)(t.getDuration(), t.options, t.options.framesPerSecond || 25);

              if (t.updateDuration) {
                t.updateDuration();
              }

              if (t.updateCurrent) {
                t.updateCurrent();
              }

              if (!t.isFullScreen) {
                t.setPlayerSize(t.width, t.height);
                t.setControlsSize();
              }
            });
            var duration = null;
            t.media.addEventListener('timeupdate', function () {
              if (!isNaN(t.getDuration()) && duration !== t.getDuration()) {
                duration = t.getDuration();
                (0, _time.calculateTimeFormat)(duration, t.options, t.options.framesPerSecond || 25);

                if (t.updateDuration) {
                  t.updateDuration();
                }

                if (t.updateCurrent) {
                  t.updateCurrent();
                }

                t.setControlsSize();
              }
            });
            t.getElement(t.container).addEventListener('click', function (e) {
              dom.addClass(e.currentTarget, t.options.classPrefix + 'container-keyboard-inactive');
            });
            t.getElement(t.container).addEventListener('focusin', function (e) {
              dom.removeClass(e.currentTarget, t.options.classPrefix + 'container-keyboard-inactive');

              if (t.isVideo && !_constants.IS_ANDROID && !_constants.IS_IOS && t.controlsEnabled && !t.options.alwaysShowControls) {
                t.killControlsTimer('enter');
                t.showControls();
                t.startControlsTimer(t.options.controlsTimeoutMouseEnter);
              }
            });
            t.getElement(t.container).addEventListener('focusout', function (e) {
              setTimeout(function () {
                if (e.relatedTarget) {
                  if (t.keyboardAction && !e.relatedTarget.closest('.' + t.options.classPrefix + 'container')) {
                    t.keyboardAction = false;

                    if (t.isVideo && !t.options.alwaysShowControls && !t.paused) {
                      t.startControlsTimer(t.options.controlsTimeoutMouseLeave);
                    }
                  }
                }
              }, 0);
            });
            setTimeout(function () {
              t.setPlayerSize(t.width, t.height);
              t.setControlsSize();
            }, 0);

            t.globalResizeCallback = function () {
              if (!(t.isFullScreen || _constants.HAS_TRUE_NATIVE_FULLSCREEN && _document2.default.webkitIsFullScreen)) {
                t.setPlayerSize(t.width, t.height);
              }

              t.setControlsSize();
            };

            t.globalBind('resize', t.globalResizeCallback);
          }

          if (autoplay && isNative) {
            t.play();
          }

          if (t.options.success) {
            if (typeof t.options.success === 'string') {
              _window2.default[t.options.success](t.media, t.domNode, t);
            } else {
              t.options.success(t.media, t.domNode, t);
            }
          }
        }
      }, {
        key: '_handleError',
        value: function _handleError(e, media, node) {
          var t = this,
              play = t.getElement(t.layers).querySelector('.' + t.options.classPrefix + 'overlay-play');

          if (play) {
            play.style.display = 'none';
          }

          if (t.options.error) {
            t.options.error(e, media, node);
          }

          if (t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'cannotplay')) {
            t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'cannotplay').remove();
          }

          var errorContainer = _document2.default.createElement('div');

          errorContainer.className = t.options.classPrefix + 'cannotplay';
          errorContainer.style.width = '100%';
          errorContainer.style.height = '100%';
          var errorContent = typeof t.options.customError === 'function' ? t.options.customError(t.media, t.media.originalNode) : t.options.customError,
              imgError = '';

          if (!errorContent) {
            var poster = t.media.originalNode.getAttribute('poster');

            if (poster) {
              imgError = '<img src="' + poster + '" alt="' + _mejs2.default.i18n.t('mejs.download-file') + '">';
            }

            if (e.message) {
              errorContent = '<p>' + e.message + '</p>';
            }

            if (e.urls) {
              for (var i = 0, total = e.urls.length; i < total; i++) {
                var url = e.urls[i];
                errorContent += '<a href="' + url.src + '" data-type="' + url.type + '"><span>' + _mejs2.default.i18n.t('mejs.download-file') + ': ' + url.src + '</span></a>';
              }
            }
          }

          if (errorContent && t.getElement(t.layers).querySelector('.' + t.options.classPrefix + 'overlay-error')) {
            errorContainer.innerHTML = errorContent;
            t.getElement(t.layers).querySelector('.' + t.options.classPrefix + 'overlay-error').innerHTML = '' + imgError + errorContainer.outerHTML;
            t.getElement(t.layers).querySelector('.' + t.options.classPrefix + 'overlay-error').parentNode.style.display = 'block';
          }

          if (t.controlsEnabled) {
            t.disableControls();
          }
        }
      }, {
        key: 'setPlayerSize',
        value: function setPlayerSize(width, height) {
          var t = this;

          if (!t.options.setDimensions) {
            return false;
          }

          if (typeof width !== 'undefined') {
            t.width = width;
          }

          if (typeof height !== 'undefined') {
            t.height = height;
          }

          switch (t.options.stretching) {
            case 'fill':
              if (t.isVideo) {
                t.setFillMode();
              } else {
                t.setDimensions(t.width, t.height);
              }

              break;

            case 'responsive':
              t.setResponsiveMode();
              break;

            case 'none':
              t.setDimensions(t.width, t.height);
              break;

            default:
              if (t.hasFluidMode() === true) {
                t.setResponsiveMode();
              } else {
                t.setDimensions(t.width, t.height);
              }

              break;
          }
        }
      }, {
        key: 'hasFluidMode',
        value: function hasFluidMode() {
          var t = this;
          return t.height.toString().indexOf('%') !== -1 || t.node && t.node.style.maxWidth && t.node.style.maxWidth !== 'none' && t.node.style.maxWidth !== t.width || t.node && t.node.currentStyle && t.node.currentStyle.maxWidth === '100%';
        }
      }, {
        key: 'setResponsiveMode',
        value: function setResponsiveMode() {
          var t = this,
              parent = function () {
            var parentEl = void 0,
                el = t.getElement(t.container);

            while (el) {
              try {
                if (_constants.IS_FIREFOX && el.tagName.toLowerCase() === 'html' && _window2.default.self !== _window2.default.top && _window2.default.frameElement !== null) {
                  return _window2.default.frameElement;
                } else {
                  parentEl = el.parentElement;
                }
              } catch (e) {
                parentEl = el.parentElement;
              }

              if (parentEl && dom.visible(parentEl)) {
                return parentEl;
              }

              el = parentEl;
            }

            return null;
          }(),
              parentStyles = parent ? getComputedStyle(parent, null) : getComputedStyle(_document2.default.body, null),
              nativeWidth = function () {
            if (t.isVideo) {
              if (t.node.videoWidth && t.node.videoWidth > 0) {
                return t.node.videoWidth;
              } else if (t.node.getAttribute('width')) {
                return t.node.getAttribute('width');
              } else {
                return t.options.defaultVideoWidth;
              }
            } else {
              return t.options.defaultAudioWidth;
            }
          }(),
              nativeHeight = function () {
            if (t.isVideo) {
              if (t.node.videoHeight && t.node.videoHeight > 0) {
                return t.node.videoHeight;
              } else if (t.node.getAttribute('height')) {
                return t.node.getAttribute('height');
              } else {
                return t.options.defaultVideoHeight;
              }
            } else {
              return t.options.defaultAudioHeight;
            }
          }(),
              aspectRatio = function () {
            var ratio = 1;

            if (!t.isVideo) {
              return ratio;
            }

            if (t.node.videoWidth && t.node.videoWidth > 0 && t.node.videoHeight && t.node.videoHeight > 0) {
              ratio = t.height >= t.width ? t.node.videoWidth / t.node.videoHeight : t.node.videoHeight / t.node.videoWidth;
            } else {
              ratio = t.initialAspectRatio;
            }

            if (isNaN(ratio) || ratio < 0.01 || ratio > 100) {
              ratio = 1;
            }

            return ratio;
          }(),
              parentHeight = parseFloat(parentStyles.height);

          var newHeight = void 0,
              parentWidth = parseFloat(parentStyles.width);

          if (t.isVideo) {
            if (t.height === '100%') {
              newHeight = parseFloat(parentWidth * nativeHeight / nativeWidth, 10);
            } else {
              newHeight = t.height >= t.width ? parseFloat(parentWidth / aspectRatio, 10) : parseFloat(parentWidth * aspectRatio, 10);
            }
          } else {
            newHeight = nativeHeight;
          }

          if (isNaN(newHeight)) {
            newHeight = parentHeight;
          }

          if (t.getElement(t.container).parentNode.length > 0 && t.getElement(t.container).parentNode.tagName.toLowerCase() === 'body') {
            parentWidth = _window2.default.innerWidth || _document2.default.documentElement.clientWidth || _document2.default.body.clientWidth;
            newHeight = _window2.default.innerHeight || _document2.default.documentElement.clientHeight || _document2.default.body.clientHeight;
          }

          if (newHeight && parentWidth) {
            t.getElement(t.container).style.width = parentWidth + 'px';
            t.getElement(t.container).style.height = newHeight + 'px';
            t.node.style.width = '100%';
            t.node.style.height = '100%';

            if (t.isVideo && t.media.setSize) {
              t.media.setSize(parentWidth, newHeight);
            }

            var layerChildren = t.getElement(t.layers).children;

            for (var i = 0, total = layerChildren.length; i < total; i++) {
              layerChildren[i].style.width = '100%';
              layerChildren[i].style.height = '100%';
            }
          }
        }
      }, {
        key: 'setFillMode',
        value: function setFillMode() {
          var t = this;
          var isIframe = _window2.default.self !== _window2.default.top && _window2.default.frameElement !== null;

          var parent = function () {
            var parentEl = void 0,
                el = t.getElement(t.container);

            while (el) {
              try {
                if (_constants.IS_FIREFOX && el.tagName.toLowerCase() === 'html' && _window2.default.self !== _window2.default.top && _window2.default.frameElement !== null) {
                  return _window2.default.frameElement;
                } else {
                  parentEl = el.parentElement;
                }
              } catch (e) {
                parentEl = el.parentElement;
              }

              if (parentEl && dom.visible(parentEl)) {
                return parentEl;
              }

              el = parentEl;
            }

            return null;
          }();

          var parentStyles = parent ? getComputedStyle(parent, null) : getComputedStyle(_document2.default.body, null);

          if (t.node.style.height !== 'none' && t.node.style.height !== t.height) {
            t.node.style.height = 'auto';
          }

          if (t.node.style.maxWidth !== 'none' && t.node.style.maxWidth !== t.width) {
            t.node.style.maxWidth = 'none';
          }

          if (t.node.style.maxHeight !== 'none' && t.node.style.maxHeight !== t.height) {
            t.node.style.maxHeight = 'none';
          }

          if (t.node.currentStyle) {
            if (t.node.currentStyle.height === '100%') {
              t.node.currentStyle.height = 'auto';
            }

            if (t.node.currentStyle.maxWidth === '100%') {
              t.node.currentStyle.maxWidth = 'none';
            }

            if (t.node.currentStyle.maxHeight === '100%') {
              t.node.currentStyle.maxHeight = 'none';
            }
          }

          if (!isIframe && !parseFloat(parentStyles.width)) {
            parent.style.width = t.media.offsetWidth + 'px';
          }

          if (!isIframe && !parseFloat(parentStyles.height)) {
            parent.style.height = t.media.offsetHeight + 'px';
          }

          parentStyles = getComputedStyle(parent);
          var parentWidth = parseFloat(parentStyles.width),
              parentHeight = parseFloat(parentStyles.height);
          t.setDimensions('100%', '100%');
          var poster = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'poster>img');

          if (poster) {
            poster.style.display = '';
          }

          var targetElement = t.getElement(t.container).querySelectorAll('object, embed, iframe, video'),
              initHeight = t.height,
              initWidth = t.width,
              scaleX1 = parentWidth,
              scaleY1 = initHeight * parentWidth / initWidth,
              scaleX2 = initWidth * parentHeight / initHeight,
              scaleY2 = parentHeight,
              bScaleOnWidth = scaleX2 > parentWidth === false,
              finalWidth = bScaleOnWidth ? Math.floor(scaleX1) : Math.floor(scaleX2),
              finalHeight = bScaleOnWidth ? Math.floor(scaleY1) : Math.floor(scaleY2),
              width = bScaleOnWidth ? parentWidth + 'px' : finalWidth + 'px',
              height = bScaleOnWidth ? finalHeight + 'px' : parentHeight + 'px';

          for (var i = 0, total = targetElement.length; i < total; i++) {
            targetElement[i].style.height = height;
            targetElement[i].style.width = width;

            if (t.media.setSize) {
              t.media.setSize(width, height);
            }

            targetElement[i].style.marginLeft = Math.floor((parentWidth - finalWidth) / 2) + 'px';
            targetElement[i].style.marginTop = 0;
          }
        }
      }, {
        key: 'setDimensions',
        value: function setDimensions(width, height) {
          var t = this;
          width = (0, _general.isString)(width) && width.indexOf('%') > -1 ? width : parseFloat(width) + 'px';
          height = (0, _general.isString)(height) && height.indexOf('%') > -1 ? height : parseFloat(height) + 'px';
          t.getElement(t.container).style.width = width;
          t.getElement(t.container).style.height = height;
          var layers = t.getElement(t.layers).children;

          for (var i = 0, total = layers.length; i < total; i++) {
            layers[i].style.width = width;
            layers[i].style.height = height;
          }
        }
      }, {
        key: 'setControlsSize',
        value: function setControlsSize() {
          var t = this;

          if (!dom.visible(t.getElement(t.container))) {
            return;
          }

          if (t.rail && dom.visible(t.rail)) {
            var totalStyles = t.total ? getComputedStyle(t.total, null) : null,
                totalMargin = totalStyles ? parseFloat(totalStyles.marginLeft) + parseFloat(totalStyles.marginRight) : 0,
                railStyles = getComputedStyle(t.rail),
                railMargin = parseFloat(railStyles.marginLeft) + parseFloat(railStyles.marginRight);
            var siblingsWidth = 0;
            var siblings = dom.siblings(t.rail, function (el) {
              return el !== t.rail;
            }),
                total = siblings.length;

            for (var i = 0; i < total; i++) {
              siblingsWidth += siblings[i].offsetWidth;
            }

            siblingsWidth += totalMargin + (totalMargin === 0 ? railMargin * 2 : railMargin) + 1;
            t.getElement(t.container).style.minWidth = siblingsWidth + 'px';
            var event = (0, _general.createEvent)('controlsresize', t.getElement(t.container));
            t.getElement(t.container).dispatchEvent(event);
          } else {
            var children = t.getElement(t.controls).children;
            var minWidth = 0;

            for (var _i = 0, _total = children.length; _i < _total; _i++) {
              minWidth += children[_i].offsetWidth;
            }

            t.getElement(t.container).style.minWidth = minWidth + 'px';
          }
        }
      }, {
        key: 'addControlElement',
        value: function addControlElement(element, key) {
          var t = this;

          if (t.featurePosition[key] !== undefined) {
            var child = t.getElement(t.controls).children[t.featurePosition[key] - 1];
            child.parentNode.insertBefore(element, child.nextSibling);
          } else {
            t.getElement(t.controls).appendChild(element);
            var children = t.getElement(t.controls).children;

            for (var i = 0, total = children.length; i < total; i++) {
              if (element === children[i]) {
                t.featurePosition[key] = i;
                break;
              }
            }
          }
        }
      }, {
        key: 'createIframeLayer',
        value: function createIframeLayer() {
          var t = this;

          if (t.isVideo && t.media.rendererName !== null && t.media.rendererName.indexOf('iframe') > -1 && !_document2.default.getElementById(t.media.id + '-iframe-overlay')) {
            var layer = _document2.default.createElement('div'),
                target = _document2.default.getElementById(t.media.id + '_' + t.media.rendererName);

            layer.id = t.media.id + '-iframe-overlay';
            layer.className = t.options.classPrefix + 'iframe-overlay';
            layer.addEventListener('click', function (e) {
              if (t.options.clickToPlayPause) {
                if (t.paused) {
                  t.play();
                } else {
                  t.pause();
                }

                e.preventDefault();
                e.stopPropagation();
              }
            });
            target.parentNode.insertBefore(layer, target);
          }
        }
      }, {
        key: 'resetSize',
        value: function resetSize() {
          var t = this;
          setTimeout(function () {
            t.setPlayerSize(t.width, t.height);
            t.setControlsSize();
          }, 50);
        }
      }, {
        key: 'setPoster',
        value: function setPoster(url) {
          var t = this;

          if (t.getElement(t.container)) {
            var posterDiv = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'poster');

            if (!posterDiv) {
              posterDiv = _document2.default.createElement('div');
              posterDiv.className = t.options.classPrefix + 'poster ' + t.options.classPrefix + 'layer';
              t.getElement(t.layers).appendChild(posterDiv);
            }

            var posterImg = posterDiv.querySelector('img');

            if (!posterImg && url) {
              posterImg = _document2.default.createElement('img');
              posterImg.className = t.options.classPrefix + 'poster-img';
              posterImg.width = '100%';
              posterImg.height = '100%';
              posterDiv.style.display = '';
              posterDiv.appendChild(posterImg);
            }

            if (url) {
              posterImg.setAttribute('src', url);
              posterDiv.style.backgroundImage = 'url("' + url + '")';
              posterDiv.style.display = '';
            } else if (posterImg) {
              posterDiv.style.backgroundImage = 'none';
              posterDiv.style.display = 'none';
              posterImg.remove();
            } else {
              posterDiv.style.display = 'none';
            }
          } else if (_constants.IS_IPAD && t.options.iPadUseNativeControls || _constants.IS_IPHONE && t.options.iPhoneUseNativeControls || _constants.IS_ANDROID && t.options.AndroidUseNativeControls) {
            t.media.originalNode.poster = url;
          }
        }
      }, {
        key: 'changeSkin',
        value: function changeSkin(className) {
          var t = this;
          t.getElement(t.container).className = t.options.classPrefix + 'container ' + className;
          t.setPlayerSize(t.width, t.height);
          t.setControlsSize();
        }
      }, {
        key: 'globalBind',
        value: function globalBind(events, callback) {
          var t = this,
              doc = t.node ? t.node.ownerDocument : _document2.default;
          events = (0, _general.splitEvents)(events, t.id);

          if (events.d) {
            var eventList = events.d.split(' ');

            for (var i = 0, total = eventList.length; i < total; i++) {
              eventList[i].split('.').reduce(function (part, e) {
                doc.addEventListener(e, callback, false);
                return e;
              }, '');
            }
          }

          if (events.w) {
            var _eventList = events.w.split(' ');

            for (var _i2 = 0, _total2 = _eventList.length; _i2 < _total2; _i2++) {
              _eventList[_i2].split('.').reduce(function (part, e) {
                _window2.default.addEventListener(e, callback, false);

                return e;
              }, '');
            }
          }
        }
      }, {
        key: 'globalUnbind',
        value: function globalUnbind(events, callback) {
          var t = this,
              doc = t.node ? t.node.ownerDocument : _document2.default;
          events = (0, _general.splitEvents)(events, t.id);

          if (events.d) {
            var eventList = events.d.split(' ');

            for (var i = 0, total = eventList.length; i < total; i++) {
              eventList[i].split('.').reduce(function (part, e) {
                doc.removeEventListener(e, callback, false);
                return e;
              }, '');
            }
          }

          if (events.w) {
            var _eventList2 = events.w.split(' ');

            for (var _i3 = 0, _total3 = _eventList2.length; _i3 < _total3; _i3++) {
              _eventList2[_i3].split('.').reduce(function (part, e) {
                _window2.default.removeEventListener(e, callback, false);

                return e;
              }, '');
            }
          }
        }
      }, {
        key: 'buildfeatures',
        value: function buildfeatures(player, controls, layers, media) {
          var t = this;

          for (var i = 0, total = t.options.features.length; i < total; i++) {
            var feature = t.options.features[i];

            if (t['build' + feature]) {
              try {
                t['build' + feature](player, controls, layers, media);
              } catch (e) {
                console.error('error building ' + feature, e);
              }
            }
          }
        }
      }, {
        key: 'buildposter',
        value: function buildposter(player, controls, layers, media) {
          var t = this,
              poster = _document2.default.createElement('div');

          poster.className = t.options.classPrefix + 'poster ' + t.options.classPrefix + 'layer';
          layers.appendChild(poster);
          var posterUrl = media.originalNode.getAttribute('poster');

          if (player.options.poster !== '') {
            if (posterUrl && _constants.IS_IOS) {
              media.originalNode.removeAttribute('poster');
            }

            posterUrl = player.options.poster;
          }

          if (posterUrl) {
            t.setPoster(posterUrl);
          } else if (t.media.renderer !== null && typeof t.media.renderer.getPosterUrl === 'function') {
            t.setPoster(t.media.renderer.getPosterUrl());
          } else {
            poster.style.display = 'none';
          }

          media.addEventListener('play', function () {
            poster.style.display = 'none';
          });
          media.addEventListener('playing', function () {
            poster.style.display = 'none';
          });

          if (player.options.showPosterWhenEnded && player.options.autoRewind) {
            media.addEventListener('ended', function () {
              poster.style.display = '';
            });
          }

          media.addEventListener('error', function () {
            poster.style.display = 'none';
          });

          if (player.options.showPosterWhenPaused) {
            media.addEventListener('pause', function () {
              if (!player.ended) {
                poster.style.display = '';
              }
            });
          }
        }
      }, {
        key: 'buildoverlays',
        value: function buildoverlays(player, controls, layers, media) {
          if (!player.isVideo) {
            return;
          }

          var t = this,
              loading = _document2.default.createElement('div'),
              error = _document2.default.createElement('div'),
              bigPlay = _document2.default.createElement('div');

          loading.style.display = 'none';
          loading.className = t.options.classPrefix + 'overlay ' + t.options.classPrefix + 'layer';
          loading.innerHTML = '<div class="' + t.options.classPrefix + 'overlay-loading">' + ('<span class="' + t.options.classPrefix + 'overlay-loading-bg-img"></span>') + '</div>';
          layers.appendChild(loading);
          error.style.display = 'none';
          error.className = t.options.classPrefix + 'overlay ' + t.options.classPrefix + 'layer';
          error.innerHTML = '<div class="' + t.options.classPrefix + 'overlay-error"></div>';
          layers.appendChild(error);
          bigPlay.className = t.options.classPrefix + 'overlay ' + t.options.classPrefix + 'layer ' + t.options.classPrefix + 'overlay-play';
          bigPlay.innerHTML = '<div class="' + t.options.classPrefix + 'overlay-button" role="button" tabindex="0" ' + ('aria-label="' + _i18n2.default.t('mejs.play') + '" aria-pressed="false"></div>');
          bigPlay.addEventListener('click', function () {
            if (t.options.clickToPlayPause) {
              var button = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'overlay-button'),
                  pressed = button.getAttribute('aria-pressed');

              if (t.paused) {
                t.play();
              } else {
                t.pause();
              }

              button.setAttribute('aria-pressed', !!pressed);
              t.getElement(t.container).focus();
            }
          });
          bigPlay.addEventListener('keydown', function (e) {
            var keyPressed = e.keyCode || e.which || 0;

            if (keyPressed === 13 || _constants.IS_FIREFOX && keyPressed === 32) {
              var event = (0, _general.createEvent)('click', bigPlay);
              bigPlay.dispatchEvent(event);
              return false;
            }
          });
          layers.appendChild(bigPlay);

          if (t.media.rendererName !== null && (/(youtube|facebook)/i.test(t.media.rendererName) && !(t.media.originalNode.getAttribute('poster') || player.options.poster || typeof t.media.renderer.getPosterUrl === 'function' && t.media.renderer.getPosterUrl()) || _constants.IS_STOCK_ANDROID || t.media.originalNode.getAttribute('autoplay'))) {
            bigPlay.style.display = 'none';
          }

          var hasError = false;
          media.addEventListener('play', function () {
            bigPlay.style.display = 'none';
            loading.style.display = 'none';
            error.style.display = 'none';
            hasError = false;
          });
          media.addEventListener('playing', function () {
            bigPlay.style.display = 'none';
            loading.style.display = 'none';
            error.style.display = 'none';
            hasError = false;
          });
          media.addEventListener('seeking', function () {
            bigPlay.style.display = 'none';
            loading.style.display = '';
            hasError = false;
          });
          media.addEventListener('seeked', function () {
            bigPlay.style.display = t.paused && !_constants.IS_STOCK_ANDROID ? '' : 'none';
            loading.style.display = 'none';
            hasError = false;
          });
          media.addEventListener('pause', function () {
            loading.style.display = 'none';

            if (!_constants.IS_STOCK_ANDROID && !hasError) {
              bigPlay.style.display = '';
            }

            hasError = false;
          });
          media.addEventListener('waiting', function () {
            loading.style.display = '';
            hasError = false;
          });
          media.addEventListener('loadeddata', function () {
            loading.style.display = '';

            if (_constants.IS_ANDROID) {
              media.canplayTimeout = setTimeout(function () {
                if (_document2.default.createEvent) {
                  var evt = _document2.default.createEvent('HTMLEvents');

                  evt.initEvent('canplay', true, true);
                  return media.dispatchEvent(evt);
                }
              }, 300);
            }

            hasError = false;
          });
          media.addEventListener('canplay', function () {
            loading.style.display = 'none';
            clearTimeout(media.canplayTimeout);
            hasError = false;
          });
          media.addEventListener('error', function (e) {
            t._handleError(e, t.media, t.node);

            loading.style.display = 'none';
            bigPlay.style.display = 'none';
            hasError = true;
          });
          media.addEventListener('loadedmetadata', function () {
            if (!t.controlsEnabled) {
              t.enableControls();
            }
          });
          media.addEventListener('keydown', function (e) {
            t.onkeydown(player, media, e);
            hasError = false;
          });
        }
      }, {
        key: 'buildkeyboard',
        value: function buildkeyboard(player, controls, layers, media) {
          var t = this;
          t.getElement(t.container).addEventListener('keydown', function () {
            t.keyboardAction = true;
          });

          t.globalKeydownCallback = function (event) {
            var container = _document2.default.activeElement.closest('.' + t.options.classPrefix + 'container'),
                target = t.media.closest('.' + t.options.classPrefix + 'container');

            t.hasFocus = !!(container && target && container.id === target.id);
            return t.onkeydown(player, media, event);
          };

          t.globalClickCallback = function (event) {
            t.hasFocus = !!event.target.closest('.' + t.options.classPrefix + 'container');
          };

          t.globalBind('keydown', t.globalKeydownCallback);
          t.globalBind('click', t.globalClickCallback);
        }
      }, {
        key: 'onkeydown',
        value: function onkeydown(player, media, e) {
          if (player.hasFocus && player.options.enableKeyboard) {
            for (var i = 0, total = player.options.keyActions.length; i < total; i++) {
              var keyAction = player.options.keyActions[i];

              for (var j = 0, jl = keyAction.keys.length; j < jl; j++) {
                if (e.keyCode === keyAction.keys[j]) {
                  keyAction.action(player, media, e.keyCode, e);
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
              }
            }
          }

          return true;
        }
      }, {
        key: 'play',
        value: function play() {
          this.proxy.play();
        }
      }, {
        key: 'pause',
        value: function pause() {
          this.proxy.pause();
        }
      }, {
        key: 'load',
        value: function load() {
          this.proxy.load();
        }
      }, {
        key: 'setCurrentTime',
        value: function setCurrentTime(time) {
          this.proxy.setCurrentTime(time);
        }
      }, {
        key: 'getCurrentTime',
        value: function getCurrentTime() {
          return this.proxy.currentTime;
        }
      }, {
        key: 'getDuration',
        value: function getDuration() {
          return this.proxy.duration;
        }
      }, {
        key: 'setVolume',
        value: function setVolume(volume) {
          this.proxy.volume = volume;
        }
      }, {
        key: 'getVolume',
        value: function getVolume() {
          return this.proxy.getVolume();
        }
      }, {
        key: 'setMuted',
        value: function setMuted(value) {
          this.proxy.setMuted(value);
        }
      }, {
        key: 'setSrc',
        value: function setSrc(src) {
          if (!this.controlsEnabled) {
            this.enableControls();
          }

          this.proxy.setSrc(src);
        }
      }, {
        key: 'getSrc',
        value: function getSrc() {
          return this.proxy.getSrc();
        }
      }, {
        key: 'canPlayType',
        value: function canPlayType(type) {
          return this.proxy.canPlayType(type);
        }
      }, {
        key: 'remove',
        value: function remove() {
          var t = this,
              rendererName = t.media.rendererName,
              src = t.media.originalNode.src;

          for (var featureIndex in t.options.features) {
            var feature = t.options.features[featureIndex];

            if (t['clean' + feature]) {
              try {
                t['clean' + feature](t, t.getElement(t.layers), t.getElement(t.controls), t.media);
              } catch (e) {
                console.error('error cleaning ' + feature, e);
              }
            }
          }

          var nativeWidth = t.node.getAttribute('width'),
              nativeHeight = t.node.getAttribute('height');

          if (nativeWidth) {
            if (nativeWidth.indexOf('%') === -1) {
              nativeWidth = nativeWidth + 'px';
            }
          } else {
            nativeWidth = 'auto';
          }

          if (nativeHeight) {
            if (nativeHeight.indexOf('%') === -1) {
              nativeHeight = nativeHeight + 'px';
            }
          } else {
            nativeHeight = 'auto';
          }

          t.node.style.width = nativeWidth;
          t.node.style.height = nativeHeight;
          t.setPlayerSize(0, 0);

          if (!t.isDynamic) {
            (function () {
              t.node.setAttribute('controls', true);
              t.node.setAttribute('id', t.node.getAttribute('id').replace('_' + rendererName, '').replace('_from_mejs', ''));
              var poster = t.getElement(t.container).querySelector('.' + t.options.classPrefix + 'poster>img');

              if (poster) {
                t.node.setAttribute('poster', poster.src);
              }

              delete t.node.autoplay;
              t.node.setAttribute('src', '');

              if (t.media.canPlayType((0, _media.getTypeFromFile)(src)) !== '') {
                t.node.setAttribute('src', src);
              }

              if (rendererName && rendererName.indexOf('iframe') > -1) {
                var layer = _document2.default.getElementById(t.media.id + '-iframe-overlay');

                layer.remove();
              }

              var node = t.node.cloneNode();
              node.style.display = '';
              t.getElement(t.container).parentNode.insertBefore(node, t.getElement(t.container));
              t.node.remove();

              if (t.mediaFiles) {
                for (var i = 0, total = t.mediaFiles.length; i < total; i++) {
                  var source = _document2.default.createElement('source');

                  source.setAttribute('src', t.mediaFiles[i].src);
                  source.setAttribute('type', t.mediaFiles[i].type);
                  node.appendChild(source);
                }
              }

              if (t.trackFiles) {
                var _loop3 = function _loop3(_i4, _total4) {
                  var track = t.trackFiles[_i4];

                  var newTrack = _document2.default.createElement('track');

                  newTrack.kind = track.kind;
                  newTrack.label = track.label;
                  newTrack.srclang = track.srclang;
                  newTrack.src = track.src;
                  node.appendChild(newTrack);
                  newTrack.addEventListener('load', function () {
                    this.mode = 'showing';
                    node.textTracks[_i4].mode = 'showing';
                  });
                };

                for (var _i4 = 0, _total4 = t.trackFiles.length; _i4 < _total4; _i4++) {
                  _loop3(_i4, _total4);
                }
              }

              delete t.node;
              delete t.mediaFiles;
              delete t.trackFiles;
            })();
          } else {
            t.getElement(t.container).parentNode.insertBefore(t.node, t.getElement(t.container));
          }

          if (t.media.renderer && typeof t.media.renderer.destroy === 'function') {
            t.media.renderer.destroy();
          }

          delete _mejs2.default.players[t.id];

          if (_typeof(t.getElement(t.container)) === 'object') {
            var offscreen = t.getElement(t.container).parentNode.querySelector('.' + t.options.classPrefix + 'offscreen');
            offscreen.remove();
            t.getElement(t.container).remove();
          }

          t.globalUnbind('resize', t.globalResizeCallback);
          t.globalUnbind('keydown', t.globalKeydownCallback);
          t.globalUnbind('click', t.globalClickCallback);
          delete t.media.player;
        }
      }, {
        key: 'paused',
        get: function get() {
          return this.proxy.paused;
        }
      }, {
        key: 'muted',
        get: function get() {
          return this.proxy.muted;
        },
        set: function set(muted) {
          this.setMuted(muted);
        }
      }, {
        key: 'ended',
        get: function get() {
          return this.proxy.ended;
        }
      }, {
        key: 'readyState',
        get: function get() {
          return this.proxy.readyState;
        }
      }, {
        key: 'currentTime',
        set: function set(time) {
          this.setCurrentTime(time);
        },
        get: function get() {
          return this.getCurrentTime();
        }
      }, {
        key: 'duration',
        get: function get() {
          return this.getDuration();
        }
      }, {
        key: 'volume',
        set: function set(volume) {
          this.setVolume(volume);
        },
        get: function get() {
          return this.getVolume();
        }
      }, {
        key: 'src',
        set: function set(src) {
          this.setSrc(src);
        },
        get: function get() {
          return this.getSrc();
        }
      }]);

      return MediaElementPlayer;
    }();

    _window2.default.MediaElementPlayer = MediaElementPlayer;
    _mejs2.default.MediaElementPlayer = MediaElementPlayer;
    exports.default = MediaElementPlayer;
  }, {
    "17": 17,
    "2": 2,
    "25": 25,
    "26": 26,
    "27": 27,
    "28": 28,
    "3": 3,
    "30": 30,
    "5": 5,
    "6": 6,
    "7": 7
  }],
  17: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var DefaultPlayer = function () {
      function DefaultPlayer(player) {
        _classCallCheck(this, DefaultPlayer);

        this.media = player.media;
        this.isVideo = player.isVideo;
        this.classPrefix = player.options.classPrefix;

        this.createIframeLayer = function () {
          return player.createIframeLayer();
        };

        this.setPoster = function (url) {
          return player.setPoster(url);
        };

        return this;
      }

      _createClass(DefaultPlayer, [{
        key: 'play',
        value: function play() {
          this.media.play();
        }
      }, {
        key: 'pause',
        value: function pause() {
          this.media.pause();
        }
      }, {
        key: 'load',
        value: function load() {
          var t = this;

          if (!t.isLoaded) {
            t.media.load();
          }

          t.isLoaded = true;
        }
      }, {
        key: 'setCurrentTime',
        value: function setCurrentTime(time) {
          this.media.setCurrentTime(time);
        }
      }, {
        key: 'getCurrentTime',
        value: function getCurrentTime() {
          return this.media.currentTime;
        }
      }, {
        key: 'getDuration',
        value: function getDuration() {
          return this.media.getDuration();
        }
      }, {
        key: 'setVolume',
        value: function setVolume(volume) {
          this.media.setVolume(volume);
        }
      }, {
        key: 'getVolume',
        value: function getVolume() {
          return this.media.getVolume();
        }
      }, {
        key: 'setMuted',
        value: function setMuted(value) {
          this.media.setMuted(value);
        }
      }, {
        key: 'setSrc',
        value: function setSrc(src) {
          var t = this,
              layer = document.getElementById(t.media.id + '-iframe-overlay');

          if (layer) {
            layer.remove();
          }

          t.media.setSrc(src);
          t.createIframeLayer();

          if (t.media.renderer !== null && typeof t.media.renderer.getPosterUrl === 'function') {
            t.setPoster(t.media.renderer.getPosterUrl());
          }
        }
      }, {
        key: 'getSrc',
        value: function getSrc() {
          return this.media.getSrc();
        }
      }, {
        key: 'canPlayType',
        value: function canPlayType(type) {
          return this.media.canPlayType(type);
        }
      }, {
        key: 'paused',
        get: function get() {
          return this.media.paused;
        }
      }, {
        key: 'muted',
        set: function set(muted) {
          this.setMuted(muted);
        },
        get: function get() {
          return this.media.muted;
        }
      }, {
        key: 'ended',
        get: function get() {
          return this.media.ended;
        }
      }, {
        key: 'readyState',
        get: function get() {
          return this.media.readyState;
        }
      }, {
        key: 'currentTime',
        set: function set(time) {
          this.setCurrentTime(time);
        },
        get: function get() {
          return this.getCurrentTime();
        }
      }, {
        key: 'duration',
        get: function get() {
          return this.getDuration();
        }
      }, {
        key: 'remainingTime',
        get: function get() {
          return this.getDuration() - this.currentTime();
        }
      }, {
        key: 'volume',
        set: function set(volume) {
          this.setVolume(volume);
        },
        get: function get() {
          return this.getVolume();
        }
      }, {
        key: 'src',
        set: function set(src) {
          this.setSrc(src);
        },
        get: function get() {
          return this.getSrc();
        }
      }]);

      return DefaultPlayer;
    }();

    exports.default = DefaultPlayer;
    _window2.default.DefaultPlayer = DefaultPlayer;
  }, {
    "3": 3
  }],
  18: [function (_dereq_, module, exports) {
    'use strict';

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _player = _dereq_(16);

    var _player2 = _interopRequireDefault(_player);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    if (typeof jQuery !== 'undefined') {
      _mejs2.default.$ = _window2.default.jQuery = _window2.default.$ = jQuery;
    } else if (typeof Zepto !== 'undefined') {
      _mejs2.default.$ = _window2.default.Zepto = _window2.default.$ = Zepto;
    } else if (typeof ender !== 'undefined') {
      _mejs2.default.$ = _window2.default.ender = _window2.default.$ = ender;
    }

    (function ($) {
      if (typeof $ !== 'undefined') {
        $.fn.mediaelementplayer = function (options) {
          if (options === false) {
            this.each(function () {
              var player = $(this).data('mediaelementplayer');

              if (player) {
                player.remove();
              }

              $(this).removeData('mediaelementplayer');
            });
          } else {
            this.each(function () {
              $(this).data('mediaelementplayer', new _player2.default(this, options));
            });
          }

          return this;
        };

        $(document).ready(function () {
          $('.' + _mejs2.default.MepDefaults.classPrefix + 'player').mediaelementplayer();
        });
      }
    })(_mejs2.default.$);
  }, {
    "16": 16,
    "3": 3,
    "7": 7
  }],
  19: [function (_dereq_, module, exports) {
    'use strict';

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _renderer = _dereq_(8);

    var _general = _dereq_(27);

    var _media = _dereq_(28);

    var _constants = _dereq_(25);

    var _dom = _dereq_(26);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var NativeDash = {
      promise: null,
      load: function load(settings) {
        if (typeof dashjs !== 'undefined') {
          NativeDash.promise = new Promise(function (resolve) {
            resolve();
          }).then(function () {
            NativeDash._createPlayer(settings);
          });
        } else {
          settings.options.path = typeof settings.options.path === 'string' ? settings.options.path : 'https://cdn.dashjs.org/latest/dash.all.min.js';
          NativeDash.promise = NativeDash.promise || (0, _dom.loadScript)(settings.options.path);
          NativeDash.promise.then(function () {
            NativeDash._createPlayer(settings);
          });
        }

        return NativeDash.promise;
      },
      _createPlayer: function _createPlayer(settings) {
        var player = dashjs.MediaPlayer().create();

        _window2.default['__ready__' + settings.id](player);

        return player;
      }
    };
    var DashNativeRenderer = {
      name: 'native_dash',
      options: {
        prefix: 'native_dash',
        dash: {
          path: 'https://cdn.dashjs.org/latest/dash.all.min.js',
          debug: false,
          drm: {},
          robustnessLevel: ''
        }
      },
      canPlayType: function canPlayType(type) {
        return _constants.HAS_MSE && ['application/dash+xml'].indexOf(type.toLowerCase()) > -1;
      },
      create: function create(mediaElement, options, mediaFiles) {
        var originalNode = mediaElement.originalNode,
            id = mediaElement.id + '_' + options.prefix,
            autoplay = originalNode.autoplay,
            children = originalNode.children;
        var node = null,
            dashPlayer = null;
        originalNode.removeAttribute('type');

        for (var i = 0, total = children.length; i < total; i++) {
          children[i].removeAttribute('type');
        }

        node = originalNode.cloneNode(true);
        options = Object.assign(options, mediaElement.options);

        var props = _mejs2.default.html5media.properties,
            events = _mejs2.default.html5media.events.concat(['click', 'mouseover', 'mouseout']).filter(function (e) {
          return e !== 'error';
        }),
            attachNativeEvents = function attachNativeEvents(e) {
          var event = (0, _general.createEvent)(e.type, mediaElement);
          mediaElement.dispatchEvent(event);
        },
            assignGettersSetters = function assignGettersSetters(propName) {
          var capName = '' + propName.substring(0, 1).toUpperCase() + propName.substring(1);

          node['get' + capName] = function () {
            return dashPlayer !== null ? node[propName] : null;
          };

          node['set' + capName] = function (value) {
            if (_mejs2.default.html5media.readOnlyProperties.indexOf(propName) === -1) {
              if (propName === 'src') {
                var source = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.src ? value.src : value;
                node[propName] = source;

                if (dashPlayer !== null) {
                  dashPlayer.reset();

                  for (var _i = 0, _total = events.length; _i < _total; _i++) {
                    node.removeEventListener(events[_i], attachNativeEvents);
                  }

                  dashPlayer = NativeDash._createPlayer({
                    options: options.dash,
                    id: id
                  });

                  if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(value.drm) === 'object') {
                    dashPlayer.setProtectionData(value.drm);

                    if ((0, _general.isString)(options.dash.robustnessLevel) && options.dash.robustnessLevel) {
                      dashPlayer.getProtectionController().setRobustnessLevel(options.dash.robustnessLevel);
                    }
                  }

                  dashPlayer.attachSource(source);

                  if (autoplay) {
                    dashPlayer.play();
                  }
                }
              } else {
                node[propName] = value;
              }
            }
          };
        };

        for (var _i2 = 0, _total2 = props.length; _i2 < _total2; _i2++) {
          assignGettersSetters(props[_i2]);
        }

        _window2.default['__ready__' + id] = function (_dashPlayer) {
          mediaElement.dashPlayer = dashPlayer = _dashPlayer;

          var dashEvents = dashjs.MediaPlayer.events,
              assignEvents = function assignEvents(eventName) {
            if (eventName === 'loadedmetadata') {
              dashPlayer.getDebug().setLogToBrowserConsole(options.dash.debug);
              dashPlayer.initialize();
              dashPlayer.setScheduleWhilePaused(false);
              dashPlayer.setFastSwitchEnabled(true);
              dashPlayer.attachView(node);
              dashPlayer.setAutoPlay(false);

              if (_typeof(options.dash.drm) === 'object' && !_mejs2.default.Utils.isObjectEmpty(options.dash.drm)) {
                dashPlayer.setProtectionData(options.dash.drm);

                if ((0, _general.isString)(options.dash.robustnessLevel) && options.dash.robustnessLevel) {
                  dashPlayer.getProtectionController().setRobustnessLevel(options.dash.robustnessLevel);
                }
              }

              dashPlayer.attachSource(node.getSrc());
            }

            node.addEventListener(eventName, attachNativeEvents);
          };

          for (var _i3 = 0, _total3 = events.length; _i3 < _total3; _i3++) {
            assignEvents(events[_i3]);
          }

          var assignMdashEvents = function assignMdashEvents(e) {
            if (e.type.toLowerCase() === 'error') {
              mediaElement.generateError(e.message, node.src);
              console.error(e);
            } else {
              var _event = (0, _general.createEvent)(e.type, mediaElement);

              _event.data = e;
              mediaElement.dispatchEvent(_event);
            }
          };

          for (var eventType in dashEvents) {
            if (dashEvents.hasOwnProperty(eventType)) {
              dashPlayer.on(dashEvents[eventType], function (e) {
                return assignMdashEvents(e);
              });
            }
          }
        };

        if (mediaFiles && mediaFiles.length > 0) {
          for (var _i4 = 0, _total4 = mediaFiles.length; _i4 < _total4; _i4++) {
            if (_renderer.renderer.renderers[options.prefix].canPlayType(mediaFiles[_i4].type)) {
              node.setAttribute('src', mediaFiles[_i4].src);

              if (typeof mediaFiles[_i4].drm !== 'undefined') {
                options.dash.drm = mediaFiles[_i4].drm;
              }

              break;
            }
          }
        }

        node.setAttribute('id', id);
        originalNode.parentNode.insertBefore(node, originalNode);
        originalNode.autoplay = false;
        originalNode.style.display = 'none';

        node.setSize = function (width, height) {
          node.style.width = width + 'px';
          node.style.height = height + 'px';
          return node;
        };

        node.hide = function () {
          node.pause();
          node.style.display = 'none';
          return node;
        };

        node.show = function () {
          node.style.display = '';
          return node;
        };

        node.destroy = function () {
          if (dashPlayer !== null) {
            dashPlayer.reset();
          }
        };

        var event = (0, _general.createEvent)('rendererready', node);
        mediaElement.dispatchEvent(event);
        mediaElement.promises.push(NativeDash.load({
          options: options.dash,
          id: id
        }));
        return node;
      }
    };

    _media.typeChecks.push(function (url) {
      return ~url.toLowerCase().indexOf('.mpd') ? 'application/dash+xml' : null;
    });

    _renderer.renderer.add(DashNativeRenderer);
  }, {
    "25": 25,
    "26": 26,
    "27": 27,
    "28": 28,
    "3": 3,
    "7": 7,
    "8": 8
  }],
  20: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.PluginDetector = undefined;

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _i18n = _dereq_(5);

    var _i18n2 = _interopRequireDefault(_i18n);

    var _renderer = _dereq_(8);

    var _general = _dereq_(27);

    var _constants = _dereq_(25);

    var _media = _dereq_(28);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var PluginDetector = exports.PluginDetector = {
      plugins: [],
      hasPluginVersion: function hasPluginVersion(plugin, v) {
        var pv = PluginDetector.plugins[plugin];
        v[1] = v[1] || 0;
        v[2] = v[2] || 0;
        return pv[0] > v[0] || pv[0] === v[0] && pv[1] > v[1] || pv[0] === v[0] && pv[1] === v[1] && pv[2] >= v[2];
      },
      addPlugin: function addPlugin(p, pluginName, mimeType, activeX, axDetect) {
        PluginDetector.plugins[p] = PluginDetector.detectPlugin(pluginName, mimeType, activeX, axDetect);
      },
      detectPlugin: function detectPlugin(pluginName, mimeType, activeX, axDetect) {
        var version = [0, 0, 0],
            description = void 0,
            ax = void 0;

        if (_constants.NAV.plugins !== null && _constants.NAV.plugins !== undefined && _typeof(_constants.NAV.plugins[pluginName]) === 'object') {
          description = _constants.NAV.plugins[pluginName].description;

          if (description && !(typeof _constants.NAV.mimeTypes !== 'undefined' && _constants.NAV.mimeTypes[mimeType] && !_constants.NAV.mimeTypes[mimeType].enabledPlugin)) {
            version = description.replace(pluginName, '').replace(/^\s+/, '').replace(/\sr/gi, '.').split('.');

            for (var i = 0, total = version.length; i < total; i++) {
              version[i] = parseInt(version[i].match(/\d+/), 10);
            }
          }
        } else if (_window2.default.ActiveXObject !== undefined) {
          try {
            ax = new ActiveXObject(activeX);

            if (ax) {
              version = axDetect(ax);
            }
          } catch (e) {}
        }

        return version;
      }
    };
    PluginDetector.addPlugin('flash', 'Shockwave Flash', 'application/x-shockwave-flash', 'ShockwaveFlash.ShockwaveFlash', function (ax) {
      var version = [],
          d = ax.GetVariable("$version");

      if (d) {
        d = d.split(" ")[1].split(",");
        version = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
      }

      return version;
    });
    var FlashMediaElementRenderer = {
      create: function create(mediaElement, options, mediaFiles) {
        var flash = {};
        var isActive = false;
        flash.options = options;
        flash.id = mediaElement.id + '_' + flash.options.prefix;
        flash.mediaElement = mediaElement;
        flash.flashState = {};
        flash.flashApi = null;
        flash.flashApiStack = [];

        var props = _mejs2.default.html5media.properties,
            assignGettersSetters = function assignGettersSetters(propName) {
          flash.flashState[propName] = null;
          var capName = '' + propName.substring(0, 1).toUpperCase() + propName.substring(1);

          flash['get' + capName] = function () {
            if (flash.flashApi !== null) {
              if (typeof flash.flashApi['get_' + propName] === 'function') {
                var value = flash.flashApi['get_' + propName]();

                if (propName === 'buffered') {
                  return {
                    start: function start() {
                      return 0;
                    },
                    end: function end() {
                      return value;
                    },
                    length: 1
                  };
                }

                return value;
              } else {
                return null;
              }
            } else {
              return null;
            }
          };

          flash['set' + capName] = function (value) {
            if (propName === 'src') {
              value = (0, _media.absolutizeUrl)(value);
            }

            if (flash.flashApi !== null && flash.flashApi['set_' + propName] !== undefined) {
              try {
                flash.flashApi['set_' + propName](value);
              } catch (e) {}
            } else {
              flash.flashApiStack.push({
                type: 'set',
                propName: propName,
                value: value
              });
            }
          };
        };

        for (var i = 0, total = props.length; i < total; i++) {
          assignGettersSetters(props[i]);
        }

        var methods = _mejs2.default.html5media.methods,
            assignMethods = function assignMethods(methodName) {
          flash[methodName] = function () {
            if (isActive) {
              if (flash.flashApi !== null) {
                if (flash.flashApi['fire_' + methodName]) {
                  try {
                    flash.flashApi['fire_' + methodName]();
                  } catch (e) {}
                } else {}
              } else {
                flash.flashApiStack.push({
                  type: 'call',
                  methodName: methodName
                });
              }
            }
          };
        };

        methods.push('stop');

        for (var _i = 0, _total = methods.length; _i < _total; _i++) {
          assignMethods(methods[_i]);
        }

        var initEvents = ['rendererready'];

        for (var _i2 = 0, _total2 = initEvents.length; _i2 < _total2; _i2++) {
          var event = (0, _general.createEvent)(initEvents[_i2], flash);
          mediaElement.dispatchEvent(event);
        }

        _window2.default['__ready__' + flash.id] = function () {
          flash.flashReady = true;
          flash.flashApi = _document2.default.getElementById('__' + flash.id);

          if (flash.flashApiStack.length) {
            for (var _i3 = 0, _total3 = flash.flashApiStack.length; _i3 < _total3; _i3++) {
              var stackItem = flash.flashApiStack[_i3];

              if (stackItem.type === 'set') {
                var propName = stackItem.propName,
                    capName = '' + propName.substring(0, 1).toUpperCase() + propName.substring(1);
                flash['set' + capName](stackItem.value);
              } else if (stackItem.type === 'call') {
                flash[stackItem.methodName]();
              }
            }
          }
        };

        _window2.default['__event__' + flash.id] = function (eventName, message) {
          var event = (0, _general.createEvent)(eventName, flash);

          if (message) {
            try {
              event.data = JSON.parse(message);
              event.details.data = JSON.parse(message);
            } catch (e) {
              event.message = message;
            }
          }

          flash.mediaElement.dispatchEvent(event);
        };

        flash.flashWrapper = _document2.default.createElement('div');

        if (['always', 'sameDomain'].indexOf(flash.options.shimScriptAccess) === -1) {
          flash.options.shimScriptAccess = 'sameDomain';
        }

        var autoplay = mediaElement.originalNode.autoplay,
            flashVars = ['uid=' + flash.id, 'autoplay=' + autoplay, 'allowScriptAccess=' + flash.options.shimScriptAccess, 'preload=' + (mediaElement.originalNode.getAttribute('preload') || '')],
            isVideo = mediaElement.originalNode !== null && mediaElement.originalNode.tagName.toLowerCase() === 'video',
            flashHeight = isVideo ? mediaElement.originalNode.height : 1,
            flashWidth = isVideo ? mediaElement.originalNode.width : 1;

        if (mediaElement.originalNode.getAttribute('src')) {
          flashVars.push('src=' + mediaElement.originalNode.getAttribute('src'));
        }

        if (flash.options.enablePseudoStreaming === true) {
          flashVars.push('pseudostreamstart=' + flash.options.pseudoStreamingStartQueryParam);
          flashVars.push('pseudostreamtype=' + flash.options.pseudoStreamingType);
        }

        if (flash.options.streamDelimiter) {
          flashVars.push('streamdelimiter=' + encodeURIComponent(flash.options.streamDelimiter));
        }

        if (flash.options.proxyType) {
          flashVars.push('proxytype=' + flash.options.proxyType);
        }

        mediaElement.appendChild(flash.flashWrapper);
        mediaElement.originalNode.style.display = 'none';
        var settings = [];

        if (_constants.IS_IE || _constants.IS_EDGE) {
          var specialIEContainer = _document2.default.createElement('div');

          flash.flashWrapper.appendChild(specialIEContainer);

          if (_constants.IS_EDGE) {
            settings = ['type="application/x-shockwave-flash"', 'data="' + flash.options.pluginPath + flash.options.filename + '"', 'id="__' + flash.id + '"', 'width="' + flashWidth + '"', 'height="' + flashHeight + '\'"'];
          } else {
            settings = ['classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"', 'codebase="//download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab"', 'id="__' + flash.id + '"', 'width="' + flashWidth + '"', 'height="' + flashHeight + '"'];
          }

          if (!isVideo) {
            settings.push('style="clip: rect(0 0 0 0); position: absolute;"');
          }

          specialIEContainer.outerHTML = '<object ' + settings.join(' ') + '>' + ('<param name="movie" value="' + flash.options.pluginPath + flash.options.filename + '?x=' + new Date() + '" />') + ('<param name="flashvars" value="' + flashVars.join('&amp;') + '" />') + '<param name="quality" value="high" />' + '<param name="bgcolor" value="#000000" />' + '<param name="wmode" value="transparent" />' + ('<param name="allowScriptAccess" value="' + flash.options.shimScriptAccess + '" />') + '<param name="allowFullScreen" value="true" />' + ('<div>' + _i18n2.default.t('mejs.install-flash') + '</div>') + '</object>';
        } else {
          settings = ['id="__' + flash.id + '"', 'name="__' + flash.id + '"', 'play="true"', 'loop="false"', 'quality="high"', 'bgcolor="#000000"', 'wmode="transparent"', 'allowScriptAccess="' + flash.options.shimScriptAccess + '"', 'allowFullScreen="true"', 'type="application/x-shockwave-flash"', 'pluginspage="//www.macromedia.com/go/getflashplayer"', 'src="' + flash.options.pluginPath + flash.options.filename + '"', 'flashvars="' + flashVars.join('&') + '"'];

          if (isVideo) {
            settings.push('width="' + flashWidth + '"');
            settings.push('height="' + flashHeight + '"');
          } else {
            settings.push('style="position: fixed; left: -9999em; top: -9999em;"');
          }

          flash.flashWrapper.innerHTML = '<embed ' + settings.join(' ') + '>';
        }

        flash.flashNode = flash.flashWrapper.lastChild;

        flash.hide = function () {
          isActive = false;

          if (isVideo) {
            flash.flashNode.style.display = 'none';
          }
        };

        flash.show = function () {
          isActive = true;

          if (isVideo) {
            flash.flashNode.style.display = '';
          }
        };

        flash.setSize = function (width, height) {
          flash.flashNode.style.width = width + 'px';
          flash.flashNode.style.height = height + 'px';

          if (flash.flashApi !== null && typeof flash.flashApi.fire_setSize === 'function') {
            flash.flashApi.fire_setSize(width, height);
          }
        };

        flash.destroy = function () {
          flash.flashNode.remove();
        };

        if (mediaFiles && mediaFiles.length > 0) {
          for (var _i4 = 0, _total4 = mediaFiles.length; _i4 < _total4; _i4++) {
            if (_renderer.renderer.renderers[options.prefix].canPlayType(mediaFiles[_i4].type)) {
              flash.setSrc(mediaFiles[_i4].src);
              break;
            }
          }
        }

        return flash;
      }
    };
    var hasFlash = PluginDetector.hasPluginVersion('flash', [10, 0, 0]);

    if (hasFlash) {
      _media.typeChecks.push(function (url) {
        url = url.toLowerCase();

        if (url.startsWith('rtmp')) {
          if (~url.indexOf('.mp3')) {
            return 'audio/rtmp';
          } else {
            return 'video/rtmp';
          }
        } else if (/\.og(a|g)/i.test(url)) {
          return 'audio/ogg';
        } else if (~url.indexOf('.m3u8')) {
          return 'application/x-mpegURL';
        } else if (~url.indexOf('.mpd')) {
          return 'application/dash+xml';
        } else if (~url.indexOf('.flv')) {
          return 'video/flv';
        } else {
          return null;
        }
      });

      var FlashMediaElementVideoRenderer = {
        name: 'flash_video',
        options: {
          prefix: 'flash_video',
          filename: 'mediaelement-flash-video.swf',
          enablePseudoStreaming: false,
          pseudoStreamingStartQueryParam: 'start',
          pseudoStreamingType: 'byte',
          proxyType: '',
          streamDelimiter: ''
        },
        canPlayType: function canPlayType(type) {
          return ~['video/mp4', 'video/rtmp', 'audio/rtmp', 'rtmp/mp4', 'audio/mp4', 'video/flv', 'video/x-flv'].indexOf(type.toLowerCase());
        },
        create: FlashMediaElementRenderer.create
      };

      _renderer.renderer.add(FlashMediaElementVideoRenderer);

      var FlashMediaElementHlsVideoRenderer = {
        name: 'flash_hls',
        options: {
          prefix: 'flash_hls',
          filename: 'mediaelement-flash-video-hls.swf'
        },
        canPlayType: function canPlayType(type) {
          return ~['application/x-mpegurl', 'application/vnd.apple.mpegurl', 'audio/mpegurl', 'audio/hls', 'video/hls'].indexOf(type.toLowerCase());
        },
        create: FlashMediaElementRenderer.create
      };

      _renderer.renderer.add(FlashMediaElementHlsVideoRenderer);

      var FlashMediaElementMdashVideoRenderer = {
        name: 'flash_dash',
        options: {
          prefix: 'flash_dash',
          filename: 'mediaelement-flash-video-mdash.swf'
        },
        canPlayType: function canPlayType(type) {
          return ~['application/dash+xml'].indexOf(type.toLowerCase());
        },
        create: FlashMediaElementRenderer.create
      };

      _renderer.renderer.add(FlashMediaElementMdashVideoRenderer);

      var FlashMediaElementAudioRenderer = {
        name: 'flash_audio',
        options: {
          prefix: 'flash_audio',
          filename: 'mediaelement-flash-audio.swf'
        },
        canPlayType: function canPlayType(type) {
          return ~['audio/mp3'].indexOf(type.toLowerCase());
        },
        create: FlashMediaElementRenderer.create
      };

      _renderer.renderer.add(FlashMediaElementAudioRenderer);

      var FlashMediaElementAudioOggRenderer = {
        name: 'flash_audio_ogg',
        options: {
          prefix: 'flash_audio_ogg',
          filename: 'mediaelement-flash-audio-ogg.swf'
        },
        canPlayType: function canPlayType(type) {
          return ~['audio/ogg', 'audio/oga', 'audio/ogv'].indexOf(type.toLowerCase());
        },
        create: FlashMediaElementRenderer.create
      };

      _renderer.renderer.add(FlashMediaElementAudioOggRenderer);
    }
  }, {
    "2": 2,
    "25": 25,
    "27": 27,
    "28": 28,
    "3": 3,
    "5": 5,
    "7": 7,
    "8": 8
  }],
  21: [function (_dereq_, module, exports) {
    'use strict';

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _renderer = _dereq_(8);

    var _general = _dereq_(27);

    var _constants = _dereq_(25);

    var _media = _dereq_(28);

    var _dom = _dereq_(26);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var NativeFlv = {
      promise: null,
      load: function load(settings) {
        if (typeof flvjs !== 'undefined') {
          NativeFlv.promise = new Promise(function (resolve) {
            resolve();
          }).then(function () {
            NativeFlv._createPlayer(settings);
          });
        } else {
          settings.options.path = typeof settings.options.path === 'string' ? settings.options.path : 'https://cdn.jsdelivr.net/npm/flv.js@latest';
          NativeFlv.promise = NativeFlv.promise || (0, _dom.loadScript)(settings.options.path);
          NativeFlv.promise.then(function () {
            NativeFlv._createPlayer(settings);
          });
        }

        return NativeFlv.promise;
      },
      _createPlayer: function _createPlayer(settings) {
        flvjs.LoggingControl.enableDebug = settings.options.debug;
        flvjs.LoggingControl.enableVerbose = settings.options.debug;
        var player = flvjs.createPlayer(settings.options, settings.configs);

        _window2.default['__ready__' + settings.id](player);

        return player;
      }
    };
    var FlvNativeRenderer = {
      name: 'native_flv',
      options: {
        prefix: 'native_flv',
        flv: {
          path: 'https://cdn.jsdelivr.net/npm/flv.js@latest',
          cors: true,
          debug: false
        }
      },
      canPlayType: function canPlayType(type) {
        return _constants.HAS_MSE && ['video/x-flv', 'video/flv'].indexOf(type.toLowerCase()) > -1;
      },
      create: function create(mediaElement, options, mediaFiles) {
        var originalNode = mediaElement.originalNode,
            id = mediaElement.id + '_' + options.prefix;
        var node = null,
            flvPlayer = null;
        node = originalNode.cloneNode(true);
        options = Object.assign(options, mediaElement.options);

        var props = _mejs2.default.html5media.properties,
            events = _mejs2.default.html5media.events.concat(['click', 'mouseover', 'mouseout']).filter(function (e) {
          return e !== 'error';
        }),
            attachNativeEvents = function attachNativeEvents(e) {
          var event = (0, _general.createEvent)(e.type, mediaElement);
          mediaElement.dispatchEvent(event);
        },
            assignGettersSetters = function assignGettersSetters(propName) {
          var capName = '' + propName.substring(0, 1).toUpperCase() + propName.substring(1);

          node['get' + capName] = function () {
            return flvPlayer !== null ? node[propName] : null;
          };

          node['set' + capName] = function (value) {
            if (_mejs2.default.html5media.readOnlyProperties.indexOf(propName) === -1) {
              if (propName === 'src') {
                node[propName] = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.src ? value.src : value;

                if (flvPlayer !== null) {
                  var _flvOptions = {};
                  _flvOptions.type = 'flv';
                  _flvOptions.url = value;
                  _flvOptions.cors = options.flv.cors;
                  _flvOptions.debug = options.flv.debug;
                  _flvOptions.path = options.flv.path;
                  var _flvConfigs = options.flv.configs;
                  flvPlayer.destroy();

                  for (var i = 0, total = events.length; i < total; i++) {
                    node.removeEventListener(events[i], attachNativeEvents);
                  }

                  flvPlayer = NativeFlv._createPlayer({
                    options: _flvOptions,
                    configs: _flvConfigs,
                    id: id
                  });
                  flvPlayer.attachMediaElement(node);
                  flvPlayer.load();
                }
              } else {
                node[propName] = value;
              }
            }
          };
        };

        for (var i = 0, total = props.length; i < total; i++) {
          assignGettersSetters(props[i]);
        }

        _window2.default['__ready__' + id] = function (_flvPlayer) {
          mediaElement.flvPlayer = flvPlayer = _flvPlayer;

          var flvEvents = flvjs.Events,
              assignEvents = function assignEvents(eventName) {
            if (eventName === 'loadedmetadata') {
              flvPlayer.unload();
              flvPlayer.detachMediaElement();
              flvPlayer.attachMediaElement(node);
              flvPlayer.load();
            }

            node.addEventListener(eventName, attachNativeEvents);
          };

          for (var _i = 0, _total = events.length; _i < _total; _i++) {
            assignEvents(events[_i]);
          }

          var assignFlvEvents = function assignFlvEvents(name, data) {
            if (name === 'error') {
              var message = data[0] + ': ' + data[1] + ' ' + data[2].msg;
              mediaElement.generateError(message, node.src);
            } else {
              var _event = (0, _general.createEvent)(name, mediaElement);

              _event.data = data;
              mediaElement.dispatchEvent(_event);
            }
          };

          var _loop = function _loop(eventType) {
            if (flvEvents.hasOwnProperty(eventType)) {
              flvPlayer.on(flvEvents[eventType], function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                return assignFlvEvents(flvEvents[eventType], args);
              });
            }
          };

          for (var eventType in flvEvents) {
            _loop(eventType);
          }
        };

        if (mediaFiles && mediaFiles.length > 0) {
          for (var _i2 = 0, _total2 = mediaFiles.length; _i2 < _total2; _i2++) {
            if (_renderer.renderer.renderers[options.prefix].canPlayType(mediaFiles[_i2].type)) {
              node.setAttribute('src', mediaFiles[_i2].src);
              break;
            }
          }
        }

        node.setAttribute('id', id);
        originalNode.parentNode.insertBefore(node, originalNode);
        originalNode.autoplay = false;
        originalNode.style.display = 'none';
        var flvOptions = {};
        flvOptions.type = 'flv';
        flvOptions.url = node.src;
        flvOptions.cors = options.flv.cors;
        flvOptions.debug = options.flv.debug;
        flvOptions.path = options.flv.path;
        var flvConfigs = options.flv.configs;

        node.setSize = function (width, height) {
          node.style.width = width + 'px';
          node.style.height = height + 'px';
          return node;
        };

        node.hide = function () {
          if (flvPlayer !== null) {
            flvPlayer.pause();
          }

          node.style.display = 'none';
          return node;
        };

        node.show = function () {
          node.style.display = '';
          return node;
        };

        node.destroy = function () {
          if (flvPlayer !== null) {
            flvPlayer.destroy();
          }
        };

        var event = (0, _general.createEvent)('rendererready', node);
        mediaElement.dispatchEvent(event);
        mediaElement.promises.push(NativeFlv.load({
          options: flvOptions,
          configs: flvConfigs,
          id: id
        }));
        return node;
      }
    };

    _media.typeChecks.push(function (url) {
      return ~url.toLowerCase().indexOf('.flv') ? 'video/flv' : null;
    });

    _renderer.renderer.add(FlvNativeRenderer);
  }, {
    "25": 25,
    "26": 26,
    "27": 27,
    "28": 28,
    "3": 3,
    "7": 7,
    "8": 8
  }],
  22: [function (_dereq_, module, exports) {
    'use strict';

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _renderer = _dereq_(8);

    var _general = _dereq_(27);

    var _constants = _dereq_(25);

    var _media = _dereq_(28);

    var _dom = _dereq_(26);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var NativeHls = {
      promise: null,
      load: function load(settings) {
        if (typeof Hls !== 'undefined') {
          NativeHls.promise = new Promise(function (resolve) {
            resolve();
          }).then(function () {
            NativeHls._createPlayer(settings);
          });
        } else {
          settings.options.path = typeof settings.options.path === 'string' ? settings.options.path : 'https://cdn.jsdelivr.net/npm/hls.js@latest';
          NativeHls.promise = NativeHls.promise || (0, _dom.loadScript)(settings.options.path);
          NativeHls.promise.then(function () {
            NativeHls._createPlayer(settings);
          });
        }

        return NativeHls.promise;
      },
      _createPlayer: function _createPlayer(settings) {
        var player = new Hls(settings.options);

        _window2.default['__ready__' + settings.id](player);

        return player;
      }
    };
    var HlsNativeRenderer = {
      name: 'native_hls',
      options: {
        prefix: 'native_hls',
        hls: {
          path: 'https://cdn.jsdelivr.net/npm/hls.js@latest',
          autoStartLoad: false,
          debug: false
        }
      },
      canPlayType: function canPlayType(type) {
        return _constants.HAS_MSE && ['application/x-mpegurl', 'application/vnd.apple.mpegurl', 'audio/mpegurl', 'audio/hls', 'video/hls'].indexOf(type.toLowerCase()) > -1;
      },
      create: function create(mediaElement, options, mediaFiles) {
        var originalNode = mediaElement.originalNode,
            id = mediaElement.id + '_' + options.prefix,
            preload = originalNode.getAttribute('preload'),
            autoplay = originalNode.autoplay;
        var hlsPlayer = null,
            node = null,
            index = 0,
            total = mediaFiles.length;
        node = originalNode.cloneNode(true);
        options = Object.assign(options, mediaElement.options);
        options.hls.autoStartLoad = preload && preload !== 'none' || autoplay;

        var props = _mejs2.default.html5media.properties,
            events = _mejs2.default.html5media.events.concat(['click', 'mouseover', 'mouseout']).filter(function (e) {
          return e !== 'error';
        }),
            attachNativeEvents = function attachNativeEvents(e) {
          var event = (0, _general.createEvent)(e.type, mediaElement);
          mediaElement.dispatchEvent(event);
        },
            assignGettersSetters = function assignGettersSetters(propName) {
          var capName = '' + propName.substring(0, 1).toUpperCase() + propName.substring(1);

          node['get' + capName] = function () {
            return hlsPlayer !== null ? node[propName] : null;
          };

          node['set' + capName] = function (value) {
            if (_mejs2.default.html5media.readOnlyProperties.indexOf(propName) === -1) {
              if (propName === 'src') {
                node[propName] = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.src ? value.src : value;

                if (hlsPlayer !== null) {
                  hlsPlayer.destroy();

                  for (var i = 0, _total = events.length; i < _total; i++) {
                    node.removeEventListener(events[i], attachNativeEvents);
                  }

                  hlsPlayer = NativeHls._createPlayer({
                    options: options.hls,
                    id: id
                  });
                  hlsPlayer.loadSource(value);
                  hlsPlayer.attachMedia(node);
                }
              } else {
                node[propName] = value;
              }
            }
          };
        };

        for (var i = 0, _total2 = props.length; i < _total2; i++) {
          assignGettersSetters(props[i]);
        }

        _window2.default['__ready__' + id] = function (_hlsPlayer) {
          mediaElement.hlsPlayer = hlsPlayer = _hlsPlayer;

          var hlsEvents = Hls.Events,
              assignEvents = function assignEvents(eventName) {
            if (eventName === 'loadedmetadata') {
              var url = mediaElement.originalNode.src;
              hlsPlayer.detachMedia();
              hlsPlayer.loadSource(url);
              hlsPlayer.attachMedia(node);
            }

            node.addEventListener(eventName, attachNativeEvents);
          };

          for (var _i = 0, _total3 = events.length; _i < _total3; _i++) {
            assignEvents(events[_i]);
          }

          var recoverDecodingErrorDate = void 0,
              recoverSwapAudioCodecDate = void 0;

          var assignHlsEvents = function assignHlsEvents(name, data) {
            if (name === 'hlsError') {
              console.warn(data);
              data = data[1];

              if (data.fatal) {
                switch (data.type) {
                  case 'mediaError':
                    var now = new Date().getTime();

                    if (!recoverDecodingErrorDate || now - recoverDecodingErrorDate > 3000) {
                      recoverDecodingErrorDate = new Date().getTime();
                      hlsPlayer.recoverMediaError();
                    } else if (!recoverSwapAudioCodecDate || now - recoverSwapAudioCodecDate > 3000) {
                      recoverSwapAudioCodecDate = new Date().getTime();
                      console.warn('Attempting to swap Audio Codec and recover from media error');
                      hlsPlayer.swapAudioCodec();
                      hlsPlayer.recoverMediaError();
                    } else {
                      var message = 'Cannot recover, last media error recovery failed';
                      mediaElement.generateError(message, node.src);
                      console.error(message);
                    }

                    break;

                  case 'networkError':
                    if (data.details === 'manifestLoadError') {
                      if (index < total && mediaFiles[index + 1] !== undefined) {
                        node.setSrc(mediaFiles[index++].src);
                        node.load();
                        node.play();
                      } else {
                        var _message = 'Network error';
                        mediaElement.generateError(_message, mediaFiles);
                        console.error(_message);
                      }
                    } else {
                      var _message2 = 'Network error';
                      mediaElement.generateError(_message2, mediaFiles);
                      console.error(_message2);
                    }

                    break;

                  default:
                    hlsPlayer.destroy();
                    break;
                }
              }
            } else {
              var _event = (0, _general.createEvent)(name, mediaElement);

              _event.data = data;
              mediaElement.dispatchEvent(_event);
            }
          };

          var _loop = function _loop(eventType) {
            if (hlsEvents.hasOwnProperty(eventType)) {
              hlsPlayer.on(hlsEvents[eventType], function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                return assignHlsEvents(hlsEvents[eventType], args);
              });
            }
          };

          for (var eventType in hlsEvents) {
            _loop(eventType);
          }
        };

        if (total > 0) {
          for (; index < total; index++) {
            if (_renderer.renderer.renderers[options.prefix].canPlayType(mediaFiles[index].type)) {
              node.setAttribute('src', mediaFiles[index].src);
              break;
            }
          }
        }

        if (preload !== 'auto' && !autoplay) {
          node.addEventListener('play', function () {
            if (hlsPlayer !== null) {
              hlsPlayer.startLoad();
            }
          });
          node.addEventListener('pause', function () {
            if (hlsPlayer !== null) {
              hlsPlayer.stopLoad();
            }
          });
        }

        node.setAttribute('id', id);
        originalNode.parentNode.insertBefore(node, originalNode);
        originalNode.autoplay = false;
        originalNode.style.display = 'none';

        node.setSize = function (width, height) {
          node.style.width = width + 'px';
          node.style.height = height + 'px';
          return node;
        };

        node.hide = function () {
          node.pause();
          node.style.display = 'none';
          return node;
        };

        node.show = function () {
          node.style.display = '';
          return node;
        };

        node.destroy = function () {
          if (hlsPlayer !== null) {
            hlsPlayer.stopLoad();
            hlsPlayer.destroy();
          }
        };

        var event = (0, _general.createEvent)('rendererready', node);
        mediaElement.dispatchEvent(event);
        mediaElement.promises.push(NativeHls.load({
          options: options.hls,
          id: id
        }));
        return node;
      }
    };

    _media.typeChecks.push(function (url) {
      return ~url.toLowerCase().indexOf('.m3u8') ? 'application/x-mpegURL' : null;
    });

    _renderer.renderer.add(HlsNativeRenderer);
  }, {
    "25": 25,
    "26": 26,
    "27": 27,
    "28": 28,
    "3": 3,
    "7": 7,
    "8": 8
  }],
  23: [function (_dereq_, module, exports) {
    'use strict';

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _renderer = _dereq_(8);

    var _general = _dereq_(27);

    var _constants = _dereq_(25);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var HtmlMediaElement = {
      name: 'html5',
      options: {
        prefix: 'html5'
      },
      canPlayType: function canPlayType(type) {
        var mediaElement = _document2.default.createElement('video');

        if (_constants.IS_ANDROID && /\/mp(3|4)$/i.test(type) || ~['application/x-mpegurl', 'vnd.apple.mpegurl', 'audio/mpegurl', 'audio/hls', 'video/hls'].indexOf(type.toLowerCase()) && _constants.SUPPORTS_NATIVE_HLS) {
          return 'yes';
        } else if (mediaElement.canPlayType) {
          return mediaElement.canPlayType(type.toLowerCase()).replace(/no/, '');
        } else {
          return '';
        }
      },
      create: function create(mediaElement, options, mediaFiles) {
        var id = mediaElement.id + '_' + options.prefix;
        var isActive = false;
        var node = null;

        if (mediaElement.originalNode === undefined || mediaElement.originalNode === null) {
          node = _document2.default.createElement('audio');
          mediaElement.appendChild(node);
        } else {
          node = mediaElement.originalNode;
        }

        node.setAttribute('id', id);

        var props = _mejs2.default.html5media.properties,
            assignGettersSetters = function assignGettersSetters(propName) {
          var capName = '' + propName.substring(0, 1).toUpperCase() + propName.substring(1);

          node['get' + capName] = function () {
            return node[propName];
          };

          node['set' + capName] = function (value) {
            if (_mejs2.default.html5media.readOnlyProperties.indexOf(propName) === -1) {
              node[propName] = value;
            }
          };
        };

        for (var i = 0, _total = props.length; i < _total; i++) {
          assignGettersSetters(props[i]);
        }

        var events = _mejs2.default.html5media.events.concat(['click', 'mouseover', 'mouseout']).filter(function (e) {
          return e !== 'error';
        }),
            assignEvents = function assignEvents(eventName) {
          node.addEventListener(eventName, function (e) {
            if (isActive) {
              var _event = (0, _general.createEvent)(e.type, e.target);

              mediaElement.dispatchEvent(_event);
            }
          });
        };

        for (var _i = 0, _total2 = events.length; _i < _total2; _i++) {
          assignEvents(events[_i]);
        }

        node.setSize = function (width, height) {
          node.style.width = width + 'px';
          node.style.height = height + 'px';
          return node;
        };

        node.hide = function () {
          isActive = false;
          node.style.display = 'none';
          return node;
        };

        node.show = function () {
          isActive = true;
          node.style.display = '';
          return node;
        };

        var index = 0,
            total = mediaFiles.length;

        if (total > 0) {
          for (; index < total; index++) {
            if (_renderer.renderer.renderers[options.prefix].canPlayType(mediaFiles[index].type)) {
              node.setAttribute('src', mediaFiles[index].src);
              break;
            }
          }
        }

        node.addEventListener('error', function (e) {
          if (e.target.error.code === 4 && isActive) {
            if (index < total && mediaFiles[index + 1] !== undefined) {
              node.src = mediaFiles[index++].src;
              node.load();
              node.play();
            } else {
              mediaElement.generateError('Media error: Format(s) not supported or source(s) not found', mediaFiles);
            }
          }
        });
        var event = (0, _general.createEvent)('rendererready', node);
        mediaElement.dispatchEvent(event);
        return node;
      }
    };
    _window2.default.HtmlMediaElement = _mejs2.default.HtmlMediaElement = HtmlMediaElement;

    _renderer.renderer.add(HtmlMediaElement);
  }, {
    "2": 2,
    "25": 25,
    "27": 27,
    "3": 3,
    "7": 7,
    "8": 8
  }],
  24: [function (_dereq_, module, exports) {
    'use strict';

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _renderer = _dereq_(8);

    var _general = _dereq_(27);

    var _media = _dereq_(28);

    var _dom = _dereq_(26);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var YouTubeApi = {
      isIframeStarted: false,
      isIframeLoaded: false,
      iframeQueue: [],
      enqueueIframe: function enqueueIframe(settings) {
        YouTubeApi.isLoaded = typeof YT !== 'undefined' && YT.loaded;

        if (YouTubeApi.isLoaded) {
          YouTubeApi.createIframe(settings);
        } else {
          YouTubeApi.loadIframeApi();
          YouTubeApi.iframeQueue.push(settings);
        }
      },
      loadIframeApi: function loadIframeApi() {
        if (!YouTubeApi.isIframeStarted) {
          (0, _dom.loadScript)('https://www.youtube.com/player_api');
          YouTubeApi.isIframeStarted = true;
        }
      },
      iFrameReady: function iFrameReady() {
        YouTubeApi.isLoaded = true;
        YouTubeApi.isIframeLoaded = true;

        while (YouTubeApi.iframeQueue.length > 0) {
          var settings = YouTubeApi.iframeQueue.pop();
          YouTubeApi.createIframe(settings);
        }
      },
      createIframe: function createIframe(settings) {
        return new YT.Player(settings.containerId, settings);
      },
      getYouTubeId: function getYouTubeId(url) {
        var youTubeId = '';

        if (url.indexOf('?') > 0) {
          youTubeId = YouTubeApi.getYouTubeIdFromParam(url);

          if (youTubeId === '') {
            youTubeId = YouTubeApi.getYouTubeIdFromUrl(url);
          }
        } else {
          youTubeId = YouTubeApi.getYouTubeIdFromUrl(url);
        }

        var id = youTubeId.substring(youTubeId.lastIndexOf('/') + 1);
        youTubeId = id.split('?');
        return youTubeId[0];
      },
      getYouTubeIdFromParam: function getYouTubeIdFromParam(url) {
        if (url === undefined || url === null || !url.trim().length) {
          return null;
        }

        var parts = url.split('?'),
            parameters = parts[1].split('&');
        var youTubeId = '';

        for (var i = 0, total = parameters.length; i < total; i++) {
          var paramParts = parameters[i].split('=');

          if (paramParts[0] === 'v') {
            youTubeId = paramParts[1];
            break;
          }
        }

        return youTubeId;
      },
      getYouTubeIdFromUrl: function getYouTubeIdFromUrl(url) {
        if (url === undefined || url === null || !url.trim().length) {
          return null;
        }

        var parts = url.split('?');
        url = parts[0];
        return url.substring(url.lastIndexOf('/') + 1);
      },
      getYouTubeNoCookieUrl: function getYouTubeNoCookieUrl(url) {
        if (url === undefined || url === null || !url.trim().length || url.indexOf('//www.youtube') === -1) {
          return url;
        }

        var parts = url.split('/');
        parts[2] = parts[2].replace('.com', '-nocookie.com');
        return parts.join('/');
      }
    };
    var YouTubeIframeRenderer = {
      name: 'youtube_iframe',
      options: {
        prefix: 'youtube_iframe',
        youtube: {
          autoplay: 0,
          controls: 0,
          disablekb: 1,
          end: 0,
          loop: 0,
          modestbranding: 0,
          playsinline: 0,
          rel: 0,
          showinfo: 0,
          start: 0,
          iv_load_policy: 3,
          nocookie: false,
          imageQuality: null
        }
      },
      canPlayType: function canPlayType(type) {
        return ~['video/youtube', 'video/x-youtube'].indexOf(type.toLowerCase());
      },
      create: function create(mediaElement, options, mediaFiles) {
        var youtube = {},
            apiStack = [],
            readyState = 4;
        var youTubeApi = null,
            paused = true,
            ended = false,
            youTubeIframe = null,
            volume = 1;
        youtube.options = options;
        youtube.id = mediaElement.id + '_' + options.prefix;
        youtube.mediaElement = mediaElement;

        var props = _mejs2.default.html5media.properties,
            assignGettersSetters = function assignGettersSetters(propName) {
          var capName = '' + propName.substring(0, 1).toUpperCase() + propName.substring(1);

          youtube['get' + capName] = function () {
            if (youTubeApi !== null) {
              var value = null;

              switch (propName) {
                case 'currentTime':
                  return youTubeApi.getCurrentTime();

                case 'duration':
                  return youTubeApi.getDuration();

                case 'volume':
                  volume = youTubeApi.getVolume() / 100;
                  return volume;

                case 'paused':
                  return paused;

                case 'ended':
                  return ended;

                case 'muted':
                  return youTubeApi.isMuted();

                case 'buffered':
                  var percentLoaded = youTubeApi.getVideoLoadedFraction(),
                      duration = youTubeApi.getDuration();
                  return {
                    start: function start() {
                      return 0;
                    },
                    end: function end() {
                      return percentLoaded * duration;
                    },
                    length: 1
                  };

                case 'src':
                  return youTubeApi.getVideoUrl();

                case 'readyState':
                  return readyState;
              }

              return value;
            } else {
              return null;
            }
          };

          youtube['set' + capName] = function (value) {
            if (youTubeApi !== null) {
              switch (propName) {
                case 'src':
                  var url = typeof value === 'string' ? value : value[0].src,
                      _videoId = YouTubeApi.getYouTubeId(url);

                  if (mediaElement.originalNode.autoplay) {
                    youTubeApi.loadVideoById(_videoId);
                  } else {
                    youTubeApi.cueVideoById(_videoId);
                  }

                  break;

                case 'currentTime':
                  youTubeApi.seekTo(value);
                  break;

                case 'muted':
                  if (value) {
                    youTubeApi.mute();
                  } else {
                    youTubeApi.unMute();
                  }

                  setTimeout(function () {
                    var event = (0, _general.createEvent)('volumechange', youtube);
                    mediaElement.dispatchEvent(event);
                  }, 50);
                  break;

                case 'volume':
                  volume = value;
                  youTubeApi.setVolume(value * 100);
                  setTimeout(function () {
                    var event = (0, _general.createEvent)('volumechange', youtube);
                    mediaElement.dispatchEvent(event);
                  }, 50);
                  break;

                case 'readyState':
                  var event = (0, _general.createEvent)('canplay', youtube);
                  mediaElement.dispatchEvent(event);
                  break;

                default:
                  break;
              }
            } else {
              apiStack.push({
                type: 'set',
                propName: propName,
                value: value
              });
            }
          };
        };

        for (var i = 0, total = props.length; i < total; i++) {
          assignGettersSetters(props[i]);
        }

        var methods = _mejs2.default.html5media.methods,
            assignMethods = function assignMethods(methodName) {
          youtube[methodName] = function () {
            if (youTubeApi !== null) {
              switch (methodName) {
                case 'play':
                  paused = false;
                  return youTubeApi.playVideo();

                case 'pause':
                  paused = true;
                  return youTubeApi.pauseVideo();

                case 'load':
                  return null;
              }
            } else {
              apiStack.push({
                type: 'call',
                methodName: methodName
              });
            }
          };
        };

        for (var _i = 0, _total = methods.length; _i < _total; _i++) {
          assignMethods(methods[_i]);
        }

        var errorHandler = function errorHandler(error) {
          var message = '';

          switch (error.data) {
            case 2:
              message = 'The request contains an invalid parameter value. Verify that video ID has 11 characters and that contains no invalid characters, such as exclamation points or asterisks.';
              break;

            case 5:
              message = 'The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.';
              break;

            case 100:
              message = 'The video requested was not found. Either video has been removed or has been marked as private.';
              break;

            case 101:
            case 105:
              message = 'The owner of the requested video does not allow it to be played in embedded players.';
              break;

            default:
              message = 'Unknown error.';
              break;
          }

          mediaElement.generateError('Code ' + error.data + ': ' + message, mediaFiles);
        };

        var youtubeContainer = _document2.default.createElement('div');

        youtubeContainer.id = youtube.id;

        if (youtube.options.youtube.nocookie) {
          mediaElement.originalNode.src = YouTubeApi.getYouTubeNoCookieUrl(mediaFiles[0].src);
        }

        mediaElement.originalNode.parentNode.insertBefore(youtubeContainer, mediaElement.originalNode);
        mediaElement.originalNode.style.display = 'none';
        var isAudio = mediaElement.originalNode.tagName.toLowerCase() === 'audio',
            height = isAudio ? '1' : mediaElement.originalNode.height,
            width = isAudio ? '1' : mediaElement.originalNode.width,
            videoId = YouTubeApi.getYouTubeId(mediaFiles[0].src),
            youtubeSettings = {
          id: youtube.id,
          containerId: youtubeContainer.id,
          videoId: videoId,
          height: height,
          width: width,
          playerVars: Object.assign({
            controls: 0,
            rel: 0,
            disablekb: 1,
            showinfo: 0,
            modestbranding: 0,
            html5: 1,
            iv_load_policy: 3
          }, youtube.options.youtube),
          origin: _window2.default.location.host,
          events: {
            onReady: function onReady(e) {
              mediaElement.youTubeApi = youTubeApi = e.target;
              mediaElement.youTubeState = {
                paused: true,
                ended: false
              };

              if (apiStack.length) {
                for (var _i2 = 0, _total2 = apiStack.length; _i2 < _total2; _i2++) {
                  var stackItem = apiStack[_i2];

                  if (stackItem.type === 'set') {
                    var propName = stackItem.propName,
                        capName = '' + propName.substring(0, 1).toUpperCase() + propName.substring(1);
                    youtube['set' + capName](stackItem.value);
                  } else if (stackItem.type === 'call') {
                    youtube[stackItem.methodName]();
                  }
                }
              }

              youTubeIframe = youTubeApi.getIframe();

              if (mediaElement.originalNode.muted) {
                youTubeApi.mute();
              }

              var events = ['mouseover', 'mouseout'],
                  assignEvents = function assignEvents(e) {
                var newEvent = (0, _general.createEvent)(e.type, youtube);
                mediaElement.dispatchEvent(newEvent);
              };

              for (var _i3 = 0, _total3 = events.length; _i3 < _total3; _i3++) {
                youTubeIframe.addEventListener(events[_i3], assignEvents, false);
              }

              var initEvents = ['rendererready', 'loadedmetadata', 'loadeddata', 'canplay'];

              for (var _i4 = 0, _total4 = initEvents.length; _i4 < _total4; _i4++) {
                var event = (0, _general.createEvent)(initEvents[_i4], youtube);
                mediaElement.dispatchEvent(event);
              }
            },
            onStateChange: function onStateChange(e) {
              var events = [];

              switch (e.data) {
                case -1:
                  events = ['loadedmetadata'];
                  paused = true;
                  ended = false;
                  break;

                case 0:
                  events = ['ended'];
                  paused = false;
                  ended = !youtube.options.youtube.loop;

                  if (!youtube.options.youtube.loop) {
                    youtube.stopInterval();
                  }

                  break;

                case 1:
                  events = ['play', 'playing'];
                  paused = false;
                  ended = false;
                  youtube.startInterval();
                  break;

                case 2:
                  events = ['pause'];
                  paused = true;
                  ended = false;
                  youtube.stopInterval();
                  break;

                case 3:
                  events = ['progress'];
                  ended = false;
                  break;

                case 5:
                  events = ['loadeddata', 'loadedmetadata', 'canplay'];
                  paused = true;
                  ended = false;
                  break;
              }

              for (var _i5 = 0, _total5 = events.length; _i5 < _total5; _i5++) {
                var event = (0, _general.createEvent)(events[_i5], youtube);
                mediaElement.dispatchEvent(event);
              }
            },
            onError: function onError(e) {
              return errorHandler(e);
            }
          }
        };

        if (isAudio || mediaElement.originalNode.hasAttribute('playsinline')) {
          youtubeSettings.playerVars.playsinline = 1;
        }

        if (mediaElement.originalNode.controls) {
          youtubeSettings.playerVars.controls = 1;
        }

        if (mediaElement.originalNode.autoplay) {
          youtubeSettings.playerVars.autoplay = 1;
        }

        if (mediaElement.originalNode.loop) {
          youtubeSettings.playerVars.loop = 1;
        }

        if ((youtubeSettings.playerVars.loop && parseInt(youtubeSettings.playerVars.loop, 10) === 1 || mediaElement.originalNode.src.indexOf('loop=') > -1) && !youtubeSettings.playerVars.playlist && mediaElement.originalNode.src.indexOf('playlist=') === -1) {
          youtubeSettings.playerVars.playlist = YouTubeApi.getYouTubeId(mediaElement.originalNode.src);
        }

        YouTubeApi.enqueueIframe(youtubeSettings);

        youtube.onEvent = function (eventName, player, _youTubeState) {
          if (_youTubeState !== null && _youTubeState !== undefined) {
            mediaElement.youTubeState = _youTubeState;
          }
        };

        youtube.setSize = function (width, height) {
          if (youTubeApi !== null) {
            youTubeApi.setSize(width, height);
          }
        };

        youtube.hide = function () {
          youtube.stopInterval();
          youtube.pause();

          if (youTubeIframe) {
            youTubeIframe.style.display = 'none';
          }
        };

        youtube.show = function () {
          if (youTubeIframe) {
            youTubeIframe.style.display = '';
          }
        };

        youtube.destroy = function () {
          youTubeApi.destroy();
        };

        youtube.interval = null;

        youtube.startInterval = function () {
          youtube.interval = setInterval(function () {
            var event = (0, _general.createEvent)('timeupdate', youtube);
            mediaElement.dispatchEvent(event);
          }, 250);
        };

        youtube.stopInterval = function () {
          if (youtube.interval) {
            clearInterval(youtube.interval);
          }
        };

        youtube.getPosterUrl = function () {
          var quality = options.youtube.imageQuality,
              resolutions = ['default', 'hqdefault', 'mqdefault', 'sddefault', 'maxresdefault'],
              id = YouTubeApi.getYouTubeId(mediaElement.originalNode.src);
          return quality && resolutions.indexOf(quality) > -1 && id ? 'https://img.youtube.com/vi/' + id + '/' + quality + '.jpg' : '';
        };

        return youtube;
      }
    };

    _window2.default.onYouTubePlayerAPIReady = function () {
      YouTubeApi.iFrameReady();
    };

    _media.typeChecks.push(function (url) {
      return /\/\/(www\.youtube|youtu\.?be)/i.test(url) ? 'video/x-youtube' : null;
    });

    _renderer.renderer.add(YouTubeIframeRenderer);
  }, {
    "2": 2,
    "26": 26,
    "27": 27,
    "28": 28,
    "3": 3,
    "7": 7,
    "8": 8
  }],
  25: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.cancelFullScreen = exports.requestFullScreen = exports.isFullScreen = exports.FULLSCREEN_EVENT_NAME = exports.HAS_NATIVE_FULLSCREEN_ENABLED = exports.HAS_TRUE_NATIVE_FULLSCREEN = exports.HAS_IOS_FULLSCREEN = exports.HAS_MS_NATIVE_FULLSCREEN = exports.HAS_MOZ_NATIVE_FULLSCREEN = exports.HAS_WEBKIT_NATIVE_FULLSCREEN = exports.HAS_NATIVE_FULLSCREEN = exports.SUPPORTS_NATIVE_HLS = exports.SUPPORT_PASSIVE_EVENT = exports.SUPPORT_POINTER_EVENTS = exports.HAS_MSE = exports.IS_STOCK_ANDROID = exports.IS_SAFARI = exports.IS_FIREFOX = exports.IS_CHROME = exports.IS_EDGE = exports.IS_IE = exports.IS_ANDROID = exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = exports.UA = exports.NAV = undefined;

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var NAV = exports.NAV = _window2.default.navigator;
    var UA = exports.UA = NAV.userAgent.toLowerCase();
    var IS_IPAD = exports.IS_IPAD = /ipad/i.test(UA) && !_window2.default.MSStream;
    var IS_IPHONE = exports.IS_IPHONE = /iphone/i.test(UA) && !_window2.default.MSStream;
    var IS_IPOD = exports.IS_IPOD = /ipod/i.test(UA) && !_window2.default.MSStream;
    var IS_IOS = exports.IS_IOS = /ipad|iphone|ipod/i.test(UA) && !_window2.default.MSStream;
    var IS_ANDROID = exports.IS_ANDROID = /android/i.test(UA);
    var IS_IE = exports.IS_IE = /(trident|microsoft)/i.test(NAV.appName);
    var IS_EDGE = exports.IS_EDGE = 'msLaunchUri' in NAV && !('documentMode' in _document2.default);
    var IS_CHROME = exports.IS_CHROME = /chrome/i.test(UA);
    var IS_FIREFOX = exports.IS_FIREFOX = /firefox/i.test(UA);
    var IS_SAFARI = exports.IS_SAFARI = /safari/i.test(UA) && !IS_CHROME;
    var IS_STOCK_ANDROID = exports.IS_STOCK_ANDROID = /^mozilla\/\d+\.\d+\s\(linux;\su;/i.test(UA);
    var HAS_MSE = exports.HAS_MSE = 'MediaSource' in _window2.default;

    var SUPPORT_POINTER_EVENTS = exports.SUPPORT_POINTER_EVENTS = function () {
      var element = _document2.default.createElement('x'),
          documentElement = _document2.default.documentElement,
          getComputedStyle = _window2.default.getComputedStyle;

      if (!('pointerEvents' in element.style)) {
        return false;
      }

      element.style.pointerEvents = 'auto';
      element.style.pointerEvents = 'x';
      documentElement.appendChild(element);
      var supports = getComputedStyle && (getComputedStyle(element, '') || {}).pointerEvents === 'auto';
      element.remove();
      return !!supports;
    }();

    var SUPPORT_PASSIVE_EVENT = exports.SUPPORT_PASSIVE_EVENT = function () {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          get: function get() {
            supportsPassive = true;
          }
        });

        _window2.default.addEventListener('test', null, opts);
      } catch (e) {}

      return supportsPassive;
    }();

    var html5Elements = ['source', 'track', 'audio', 'video'];
    var video = void 0;

    for (var i = 0, total = html5Elements.length; i < total; i++) {
      video = _document2.default.createElement(html5Elements[i]);
    }

    var SUPPORTS_NATIVE_HLS = exports.SUPPORTS_NATIVE_HLS = IS_SAFARI || IS_ANDROID && (IS_CHROME || IS_STOCK_ANDROID) || IS_IE && /edge/i.test(UA);
    var hasiOSFullScreen = video.webkitEnterFullscreen !== undefined;
    var hasNativeFullscreen = video.requestFullscreen !== undefined;

    if (hasiOSFullScreen && /mac os x 10_5/i.test(UA)) {
      hasNativeFullscreen = false;
      hasiOSFullScreen = false;
    }

    var hasWebkitNativeFullScreen = video.webkitRequestFullScreen !== undefined;
    var hasMozNativeFullScreen = video.mozRequestFullScreen !== undefined;
    var hasMsNativeFullScreen = video.msRequestFullscreen !== undefined;
    var hasTrueNativeFullScreen = hasWebkitNativeFullScreen || hasMozNativeFullScreen || hasMsNativeFullScreen;
    var nativeFullScreenEnabled = hasTrueNativeFullScreen;
    var fullScreenEventName = '';
    var isFullScreen = void 0,
        requestFullScreen = void 0,
        cancelFullScreen = void 0;

    if (hasMozNativeFullScreen) {
      nativeFullScreenEnabled = _document2.default.mozFullScreenEnabled;
    } else if (hasMsNativeFullScreen) {
      nativeFullScreenEnabled = _document2.default.msFullscreenEnabled;
    }

    if (IS_CHROME) {
      hasiOSFullScreen = false;
    }

    if (hasTrueNativeFullScreen) {
      if (hasWebkitNativeFullScreen) {
        fullScreenEventName = 'webkitfullscreenchange';
      } else if (hasMozNativeFullScreen) {
        fullScreenEventName = 'mozfullscreenchange';
      } else if (hasMsNativeFullScreen) {
        fullScreenEventName = 'MSFullscreenChange';
      }

      exports.isFullScreen = isFullScreen = function isFullScreen() {
        if (hasMozNativeFullScreen) {
          return _document2.default.mozFullScreen;
        } else if (hasWebkitNativeFullScreen) {
          return _document2.default.webkitIsFullScreen;
        } else if (hasMsNativeFullScreen) {
          return _document2.default.msFullscreenElement !== null;
        }
      };

      exports.requestFullScreen = requestFullScreen = function requestFullScreen(el) {
        if (hasWebkitNativeFullScreen) {
          el.webkitRequestFullScreen();
        } else if (hasMozNativeFullScreen) {
          el.mozRequestFullScreen();
        } else if (hasMsNativeFullScreen) {
          el.msRequestFullscreen();
        }
      };

      exports.cancelFullScreen = cancelFullScreen = function cancelFullScreen() {
        if (hasWebkitNativeFullScreen) {
          _document2.default.webkitCancelFullScreen();
        } else if (hasMozNativeFullScreen) {
          _document2.default.mozCancelFullScreen();
        } else if (hasMsNativeFullScreen) {
          _document2.default.msExitFullscreen();
        }
      };
    }

    var HAS_NATIVE_FULLSCREEN = exports.HAS_NATIVE_FULLSCREEN = hasNativeFullscreen;
    var HAS_WEBKIT_NATIVE_FULLSCREEN = exports.HAS_WEBKIT_NATIVE_FULLSCREEN = hasWebkitNativeFullScreen;
    var HAS_MOZ_NATIVE_FULLSCREEN = exports.HAS_MOZ_NATIVE_FULLSCREEN = hasMozNativeFullScreen;
    var HAS_MS_NATIVE_FULLSCREEN = exports.HAS_MS_NATIVE_FULLSCREEN = hasMsNativeFullScreen;
    var HAS_IOS_FULLSCREEN = exports.HAS_IOS_FULLSCREEN = hasiOSFullScreen;
    var HAS_TRUE_NATIVE_FULLSCREEN = exports.HAS_TRUE_NATIVE_FULLSCREEN = hasTrueNativeFullScreen;
    var HAS_NATIVE_FULLSCREEN_ENABLED = exports.HAS_NATIVE_FULLSCREEN_ENABLED = nativeFullScreenEnabled;
    var FULLSCREEN_EVENT_NAME = exports.FULLSCREEN_EVENT_NAME = fullScreenEventName;
    exports.isFullScreen = isFullScreen;
    exports.requestFullScreen = requestFullScreen;
    exports.cancelFullScreen = cancelFullScreen;
    _mejs2.default.Features = _mejs2.default.Features || {};
    _mejs2.default.Features.isiPad = IS_IPAD;
    _mejs2.default.Features.isiPod = IS_IPOD;
    _mejs2.default.Features.isiPhone = IS_IPHONE;
    _mejs2.default.Features.isiOS = _mejs2.default.Features.isiPhone || _mejs2.default.Features.isiPad;
    _mejs2.default.Features.isAndroid = IS_ANDROID;
    _mejs2.default.Features.isIE = IS_IE;
    _mejs2.default.Features.isEdge = IS_EDGE;
    _mejs2.default.Features.isChrome = IS_CHROME;
    _mejs2.default.Features.isFirefox = IS_FIREFOX;
    _mejs2.default.Features.isSafari = IS_SAFARI;
    _mejs2.default.Features.isStockAndroid = IS_STOCK_ANDROID;
    _mejs2.default.Features.hasMSE = HAS_MSE;
    _mejs2.default.Features.supportsNativeHLS = SUPPORTS_NATIVE_HLS;
    _mejs2.default.Features.supportsPointerEvents = SUPPORT_POINTER_EVENTS;
    _mejs2.default.Features.supportsPassiveEvent = SUPPORT_PASSIVE_EVENT;
    _mejs2.default.Features.hasiOSFullScreen = HAS_IOS_FULLSCREEN;
    _mejs2.default.Features.hasNativeFullscreen = HAS_NATIVE_FULLSCREEN;
    _mejs2.default.Features.hasWebkitNativeFullScreen = HAS_WEBKIT_NATIVE_FULLSCREEN;
    _mejs2.default.Features.hasMozNativeFullScreen = HAS_MOZ_NATIVE_FULLSCREEN;
    _mejs2.default.Features.hasMsNativeFullScreen = HAS_MS_NATIVE_FULLSCREEN;
    _mejs2.default.Features.hasTrueNativeFullScreen = HAS_TRUE_NATIVE_FULLSCREEN;
    _mejs2.default.Features.nativeFullScreenEnabled = HAS_NATIVE_FULLSCREEN_ENABLED;
    _mejs2.default.Features.fullScreenEventName = FULLSCREEN_EVENT_NAME;
    _mejs2.default.Features.isFullScreen = isFullScreen;
    _mejs2.default.Features.requestFullScreen = requestFullScreen;
    _mejs2.default.Features.cancelFullScreen = cancelFullScreen;
  }, {
    "2": 2,
    "3": 3,
    "7": 7
  }],
  26: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.removeClass = exports.addClass = exports.hasClass = undefined;
    exports.loadScript = loadScript;
    exports.offset = offset;
    exports.toggleClass = toggleClass;
    exports.fadeOut = fadeOut;
    exports.fadeIn = fadeIn;
    exports.siblings = siblings;
    exports.visible = visible;
    exports.ajax = ajax;

    var _window = _dereq_(3);

    var _window2 = _interopRequireDefault(_window);

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function loadScript(url) {
      return new Promise(function (resolve, reject) {
        var script = _document2.default.createElement('script');

        script.src = url;
        script.async = true;

        script.onload = function () {
          script.remove();
          resolve();
        };

        script.onerror = function () {
          script.remove();
          reject();
        };

        _document2.default.head.appendChild(script);
      });
    }

    function offset(el) {
      var rect = el.getBoundingClientRect(),
          scrollLeft = _window2.default.pageXOffset || _document2.default.documentElement.scrollLeft,
          scrollTop = _window2.default.pageYOffset || _document2.default.documentElement.scrollTop;
      return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
      };
    }

    var hasClassMethod = void 0,
        addClassMethod = void 0,
        removeClassMethod = void 0;

    if ('classList' in _document2.default.documentElement) {
      hasClassMethod = function hasClassMethod(el, className) {
        return el.classList !== undefined && el.classList.contains(className);
      };

      addClassMethod = function addClassMethod(el, className) {
        return el.classList.add(className);
      };

      removeClassMethod = function removeClassMethod(el, className) {
        return el.classList.remove(className);
      };
    } else {
      hasClassMethod = function hasClassMethod(el, className) {
        return new RegExp('\\b' + className + '\\b').test(el.className);
      };

      addClassMethod = function addClassMethod(el, className) {
        if (!hasClass(el, className)) {
          el.className += ' ' + className;
        }
      };

      removeClassMethod = function removeClassMethod(el, className) {
        el.className = el.className.replace(new RegExp('\\b' + className + '\\b', 'g'), '');
      };
    }

    var hasClass = exports.hasClass = hasClassMethod;
    var addClass = exports.addClass = addClassMethod;
    var removeClass = exports.removeClass = removeClassMethod;

    function toggleClass(el, className) {
      hasClass(el, className) ? removeClass(el, className) : addClass(el, className);
    }

    function fadeOut(el) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
      var callback = arguments[2];

      if (!el.style.opacity) {
        el.style.opacity = 1;
      }

      var start = null;

      _window2.default.requestAnimationFrame(function animate(timestamp) {
        start = start || timestamp;
        var progress = timestamp - start;
        var opacity = parseFloat(1 - progress / duration, 2);
        el.style.opacity = opacity < 0 ? 0 : opacity;

        if (progress > duration) {
          if (callback && typeof callback === 'function') {
            callback();
          }
        } else {
          _window2.default.requestAnimationFrame(animate);
        }
      });
    }

    function fadeIn(el) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
      var callback = arguments[2];

      if (!el.style.opacity) {
        el.style.opacity = 0;
      }

      var start = null;

      _window2.default.requestAnimationFrame(function animate(timestamp) {
        start = start || timestamp;
        var progress = timestamp - start;
        var opacity = parseFloat(progress / duration, 2);
        el.style.opacity = opacity > 1 ? 1 : opacity;

        if (progress > duration) {
          if (callback && typeof callback === 'function') {
            callback();
          }
        } else {
          _window2.default.requestAnimationFrame(animate);
        }
      });
    }

    function siblings(el, filter) {
      var siblings = [];
      el = el.parentNode.firstChild;

      do {
        if (!filter || filter(el)) {
          siblings.push(el);
        }
      } while (el = el.nextSibling);

      return siblings;
    }

    function visible(elem) {
      if (elem.getClientRects !== undefined && elem.getClientRects === 'function') {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
      }

      return !!(elem.offsetWidth || elem.offsetHeight);
    }

    function ajax(url, dataType, success, error) {
      var xhr = _window2.default.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
      var type = 'application/x-www-form-urlencoded; charset=UTF-8',
          completed = false,
          accept = '*/'.concat('*');

      switch (dataType) {
        case 'text':
          type = 'text/plain';
          break;

        case 'json':
          type = 'application/json, text/javascript';
          break;

        case 'html':
          type = 'text/html';
          break;

        case 'xml':
          type = 'application/xml, text/xml';
          break;
      }

      if (type !== 'application/x-www-form-urlencoded') {
        accept = type + ', */*; q=0.01';
      }

      if (xhr) {
        xhr.open('GET', url, true);
        xhr.setRequestHeader('Accept', accept);

        xhr.onreadystatechange = function () {
          if (completed) {
            return;
          }

          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              completed = true;
              var data = void 0;

              switch (dataType) {
                case 'json':
                  data = JSON.parse(xhr.responseText);
                  break;

                case 'xml':
                  data = xhr.responseXML;
                  break;

                default:
                  data = xhr.responseText;
                  break;
              }

              success(data);
            } else if (typeof error === 'function') {
              error(xhr.status);
            }
          }
        };

        xhr.send();
      }
    }

    _mejs2.default.Utils = _mejs2.default.Utils || {};
    _mejs2.default.Utils.offset = offset;
    _mejs2.default.Utils.hasClass = hasClass;
    _mejs2.default.Utils.addClass = addClass;
    _mejs2.default.Utils.removeClass = removeClass;
    _mejs2.default.Utils.toggleClass = toggleClass;
    _mejs2.default.Utils.fadeIn = fadeIn;
    _mejs2.default.Utils.fadeOut = fadeOut;
    _mejs2.default.Utils.siblings = siblings;
    _mejs2.default.Utils.visible = visible;
    _mejs2.default.Utils.ajax = ajax;
    _mejs2.default.Utils.loadScript = loadScript;
  }, {
    "2": 2,
    "3": 3,
    "7": 7
  }],
  27: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.escapeHTML = escapeHTML;
    exports.debounce = debounce;
    exports.isObjectEmpty = isObjectEmpty;
    exports.splitEvents = splitEvents;
    exports.createEvent = createEvent;
    exports.isNodeAfter = isNodeAfter;
    exports.isString = isString;

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function escapeHTML(input) {
      if (typeof input !== 'string') {
        throw new Error('Argument passed must be a string');
      }

      var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;'
      };
      return input.replace(/[&<>"]/g, function (c) {
        return map[c];
      });
    }

    function debounce(func, wait) {
      var _this = this,
          _arguments = arguments;

      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof func !== 'function') {
        throw new Error('First argument must be a function');
      }

      if (typeof wait !== 'number') {
        throw new Error('Second argument must be a numeric value');
      }

      var timeout = void 0;
      return function () {
        var context = _this,
            args = _arguments;

        var later = function later() {
          timeout = null;

          if (!immediate) {
            func.apply(context, args);
          }
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
          func.apply(context, args);
        }
      };
    }

    function isObjectEmpty(instance) {
      return Object.getOwnPropertyNames(instance).length <= 0;
    }

    function splitEvents(events, id) {
      var rwindow = /^((after|before)print|(before)?unload|hashchange|message|o(ff|n)line|page(hide|show)|popstate|resize|storage)\b/;
      var ret = {
        d: [],
        w: []
      };
      (events || '').split(' ').forEach(function (v) {
        var eventName = '' + v + (id ? '.' + id : '');

        if (eventName.startsWith('.')) {
          ret.d.push(eventName);
          ret.w.push(eventName);
        } else {
          ret[rwindow.test(v) ? 'w' : 'd'].push(eventName);
        }
      });
      ret.d = ret.d.join(' ');
      ret.w = ret.w.join(' ');
      return ret;
    }

    function createEvent(eventName, target) {
      if (typeof eventName !== 'string') {
        throw new Error('Event name must be a string');
      }

      var eventFrags = eventName.match(/([a-z]+\.([a-z]+))/i),
          detail = {
        target: target
      };

      if (eventFrags !== null) {
        eventName = eventFrags[1];
        detail.namespace = eventFrags[2];
      }

      return new window.CustomEvent(eventName, {
        detail: detail
      });
    }

    function isNodeAfter(sourceNode, targetNode) {
      return !!(sourceNode && targetNode && sourceNode.compareDocumentPosition(targetNode) & 2);
    }

    function isString(value) {
      return typeof value === 'string';
    }

    _mejs2.default.Utils = _mejs2.default.Utils || {};
    _mejs2.default.Utils.escapeHTML = escapeHTML;
    _mejs2.default.Utils.debounce = debounce;
    _mejs2.default.Utils.isObjectEmpty = isObjectEmpty;
    _mejs2.default.Utils.splitEvents = splitEvents;
    _mejs2.default.Utils.createEvent = createEvent;
    _mejs2.default.Utils.isNodeAfter = isNodeAfter;
    _mejs2.default.Utils.isString = isString;
  }, {
    "7": 7
  }],
  28: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.typeChecks = undefined;
    exports.absolutizeUrl = absolutizeUrl;
    exports.formatType = formatType;
    exports.getMimeFromType = getMimeFromType;
    exports.getTypeFromFile = getTypeFromFile;
    exports.getExtension = getExtension;
    exports.normalizeExtension = normalizeExtension;

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    var _general = _dereq_(27);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var typeChecks = exports.typeChecks = [];

    function absolutizeUrl(url) {
      if (typeof url !== 'string') {
        throw new Error('`url` argument must be a string');
      }

      var el = document.createElement('div');
      el.innerHTML = '<a href="' + (0, _general.escapeHTML)(url) + '">x</a>';
      return el.firstChild.href;
    }

    function formatType(url) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return url && !type ? getTypeFromFile(url) : type;
    }

    function getMimeFromType(type) {
      if (typeof type !== 'string') {
        throw new Error('`type` argument must be a string');
      }

      return type && type.indexOf(';') > -1 ? type.substr(0, type.indexOf(';')) : type;
    }

    function getTypeFromFile(url) {
      if (typeof url !== 'string') {
        throw new Error('`url` argument must be a string');
      }

      for (var i = 0, total = typeChecks.length; i < total; i++) {
        var type = typeChecks[i](url);

        if (type) {
          return type;
        }
      }

      var ext = getExtension(url),
          normalizedExt = normalizeExtension(ext);
      var mime = 'video/mp4';

      if (normalizedExt) {
        if (~['mp4', 'm4v', 'ogg', 'ogv', 'webm', 'flv', 'mpeg', 'mov'].indexOf(normalizedExt)) {
          mime = 'video/' + normalizedExt;
        } else if (~['mp3', 'oga', 'wav', 'mid', 'midi'].indexOf(normalizedExt)) {
          mime = 'audio/' + normalizedExt;
        }
      }

      return mime;
    }

    function getExtension(url) {
      if (typeof url !== 'string') {
        throw new Error('`url` argument must be a string');
      }

      var baseUrl = url.split('?')[0],
          baseName = baseUrl.split('\\').pop().split('/').pop();
      return ~baseName.indexOf('.') ? baseName.substring(baseName.lastIndexOf('.') + 1) : '';
    }

    function normalizeExtension(extension) {
      if (typeof extension !== 'string') {
        throw new Error('`extension` argument must be a string');
      }

      switch (extension) {
        case 'mp4':
        case 'm4v':
          return 'mp4';

        case 'webm':
        case 'webma':
        case 'webmv':
          return 'webm';

        case 'ogg':
        case 'oga':
        case 'ogv':
          return 'ogg';

        default:
          return extension;
      }
    }

    _mejs2.default.Utils = _mejs2.default.Utils || {};
    _mejs2.default.Utils.typeChecks = typeChecks;
    _mejs2.default.Utils.absolutizeUrl = absolutizeUrl;
    _mejs2.default.Utils.formatType = formatType;
    _mejs2.default.Utils.getMimeFromType = getMimeFromType;
    _mejs2.default.Utils.getTypeFromFile = getTypeFromFile;
    _mejs2.default.Utils.getExtension = getExtension;
    _mejs2.default.Utils.normalizeExtension = normalizeExtension;
  }, {
    "27": 27,
    "7": 7
  }],
  29: [function (_dereq_, module, exports) {
    'use strict';

    var _document = _dereq_(2);

    var _document2 = _interopRequireDefault(_document);

    var _promisePolyfill = _dereq_(4);

    var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    (function (arr) {
      arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
          return;
        }

        Object.defineProperty(item, 'remove', {
          configurable: true,
          enumerable: true,
          writable: true,
          value: function remove() {
            this.parentNode.removeChild(this);
          }
        });
      });
    })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

    (function () {
      if (typeof window.CustomEvent === 'function') {
        return false;
      }

      function CustomEvent(event, params) {
        params = params || {
          bubbles: false,
          cancelable: false,
          detail: undefined
        };

        var evt = _document2.default.createEvent('CustomEvent');

        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      }

      CustomEvent.prototype = window.Event.prototype;
      window.CustomEvent = CustomEvent;
    })();

    if (typeof Object.assign !== 'function') {
      Object.assign = function (target) {
        if (target === null || target === undefined) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1, total = arguments.length; index < total; index++) {
          var nextSource = arguments[index];

          if (nextSource !== null) {
            for (var nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }

        return to;
      };
    }

    if (!String.prototype.startsWith) {
      String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
      };
    }

    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i = matches.length - 1;

        while (--i >= 0 && matches.item(i) !== this) {}

        return i > -1;
      };
    }

    if (window.Element && !Element.prototype.closest) {
      Element.prototype.closest = function (s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i = void 0,
            el = this;

        do {
          i = matches.length;

          while (--i >= 0 && matches.item(i) !== el) {}
        } while (i < 0 && (el = el.parentElement));

        return el;
      };
    }

    (function () {
      var lastTime = 0;
      var vendors = ['ms', 'moz', 'webkit', 'o'];

      for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
      }

      if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function () {
          callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };
      if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
        clearTimeout(id);
      };
    })();

    if (/firefox/i.test(navigator.userAgent)) {
      var getComputedStyle = window.getComputedStyle;

      window.getComputedStyle = function (el, pseudoEl) {
        var t = getComputedStyle(el, pseudoEl);
        return t === null ? {
          getPropertyValue: function getPropertyValue() {}
        } : t;
      };
    }

    if (!window.Promise) {
      window.Promise = _promisePolyfill2.default;
    }

    (function (constructor) {
      if (constructor && constructor.prototype && constructor.prototype.children === null) {
        Object.defineProperty(constructor.prototype, 'children', {
          get: function get() {
            var i = 0,
                node = void 0,
                nodes = this.childNodes,
                children = [];

            while (node = nodes[i++]) {
              if (node.nodeType === 1) {
                children.push(node);
              }
            }

            return children;
          }
        });
      }
    })(window.Node || window.Element);
  }, {
    "2": 2,
    "4": 4
  }],
  30: [function (_dereq_, module, exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.isDropFrame = isDropFrame;
    exports.secondsToTimeCode = secondsToTimeCode;
    exports.timeCodeToSeconds = timeCodeToSeconds;
    exports.calculateTimeFormat = calculateTimeFormat;
    exports.convertSMPTEtoSeconds = convertSMPTEtoSeconds;

    var _mejs = _dereq_(7);

    var _mejs2 = _interopRequireDefault(_mejs);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function isDropFrame() {
      var fps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 25;
      return !(fps % 1 === 0);
    }

    function secondsToTimeCode(time) {
      var forceHours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var showFrameCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var fps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
      var secondsDecimalLength = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var timeFormat = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'hh:mm:ss';
      time = !time || typeof time !== 'number' || time < 0 ? 0 : time;
      var dropFrames = Math.round(fps * 0.066666),
          timeBase = Math.round(fps),
          framesPer24Hours = Math.round(fps * 3600) * 24,
          framesPer10Minutes = Math.round(fps * 600),
          frameSep = isDropFrame(fps) ? ';' : ':',
          hours = void 0,
          minutes = void 0,
          seconds = void 0,
          frames = void 0,
          f = Math.round(time * fps);

      if (isDropFrame(fps)) {
        if (f < 0) {
          f = framesPer24Hours + f;
        }

        f = f % framesPer24Hours;
        var d = Math.floor(f / framesPer10Minutes);
        var m = f % framesPer10Minutes;
        f = f + dropFrames * 9 * d;

        if (m > dropFrames) {
          f = f + dropFrames * Math.floor((m - dropFrames) / Math.round(timeBase * 60 - dropFrames));
        }

        var timeBaseDivision = Math.floor(f / timeBase);
        hours = Math.floor(Math.floor(timeBaseDivision / 60) / 60);
        minutes = Math.floor(timeBaseDivision / 60) % 60;

        if (showFrameCount) {
          seconds = timeBaseDivision % 60;
        } else {
          seconds = Math.floor(f / timeBase % 60).toFixed(secondsDecimalLength);
        }
      } else {
        hours = Math.floor(time / 3600) % 24;
        minutes = Math.floor(time / 60) % 60;

        if (showFrameCount) {
          seconds = Math.floor(time % 60);
        } else {
          seconds = Math.floor(time % 60).toFixed(secondsDecimalLength);
        }
      }

      hours = hours <= 0 ? 0 : hours;
      minutes = minutes <= 0 ? 0 : minutes;
      seconds = seconds <= 0 ? 0 : seconds;
      seconds = seconds === 60 ? 0 : seconds;
      minutes = minutes === 60 ? 0 : minutes;
      var timeFormatFrags = timeFormat.split(':');
      var timeFormatSettings = {};

      for (var i = 0, total = timeFormatFrags.length; i < total; ++i) {
        var unique = '';

        for (var j = 0, t = timeFormatFrags[i].length; j < t; j++) {
          if (unique.indexOf(timeFormatFrags[i][j]) < 0) {
            unique += timeFormatFrags[i][j];
          }
        }

        if (~['f', 's', 'm', 'h'].indexOf(unique)) {
          timeFormatSettings[unique] = timeFormatFrags[i].length;
        }
      }

      var result = forceHours || hours > 0 ? (hours < 10 && timeFormatSettings.h > 1 ? '0' + hours : hours) + ':' : '';
      result += (minutes < 10 && timeFormatSettings.m > 1 ? '0' + minutes : minutes) + ':';
      result += '' + (seconds < 10 && timeFormatSettings.s > 1 ? '0' + seconds : seconds);

      if (showFrameCount) {
        frames = (f % timeBase).toFixed(0);
        frames = frames <= 0 ? 0 : frames;
        result += frames < 10 && timeFormatSettings.f ? frameSep + '0' + frames : '' + frameSep + frames;
      }

      return result;
    }

    function timeCodeToSeconds(time) {
      var fps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;

      if (typeof time !== 'string') {
        throw new TypeError('Time must be a string');
      }

      if (time.indexOf(';') > 0) {
        time = time.replace(';', ':');
      }

      if (!/\d{2}(\:\d{2}){0,3}/i.test(time)) {
        throw new TypeError('Time code must have the format `00:00:00`');
      }

      var parts = time.split(':');
      var output = void 0,
          hours = 0,
          minutes = 0,
          seconds = 0,
          frames = 0,
          totalMinutes = 0,
          dropFrames = Math.round(fps * 0.066666),
          timeBase = Math.round(fps),
          hFrames = timeBase * 3600,
          mFrames = timeBase * 60;

      switch (parts.length) {
        default:
        case 1:
          seconds = parseInt(parts[0], 10);
          break;

        case 2:
          minutes = parseInt(parts[0], 10);
          seconds = parseInt(parts[1], 10);
          break;

        case 3:
          hours = parseInt(parts[0], 10);
          minutes = parseInt(parts[1], 10);
          seconds = parseInt(parts[2], 10);
          break;

        case 4:
          hours = parseInt(parts[0], 10);
          minutes = parseInt(parts[1], 10);
          seconds = parseInt(parts[2], 10);
          frames = parseInt(parts[3], 10);
          break;
      }

      if (isDropFrame(fps)) {
        totalMinutes = 60 * hours + minutes;
        output = hFrames * hours + mFrames * minutes + timeBase * seconds + frames - dropFrames * (totalMinutes - Math.floor(totalMinutes / 10));
      } else {
        output = (hFrames * hours + mFrames * minutes + fps * seconds + frames) / fps;
      }

      return parseFloat(output.toFixed(3));
    }

    function calculateTimeFormat(time, options) {
      var fps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
      time = !time || typeof time !== 'number' || time < 0 ? 0 : time;
      var hours = Math.floor(time / 3600) % 24,
          minutes = Math.floor(time / 60) % 60,
          seconds = Math.floor(time % 60),
          frames = Math.floor((time % 1 * fps).toFixed(3)),
          lis = [[frames, 'f'], [seconds, 's'], [minutes, 'm'], [hours, 'h']];
      var format = options.timeFormat,
          firstTwoPlaces = format[1] === format[0],
          separatorIndex = firstTwoPlaces ? 2 : 1,
          separator = format.length < separatorIndex ? format[separatorIndex] : ':',
          firstChar = format[0],
          required = false;

      for (var i = 0, len = lis.length; i < len; i++) {
        if (~format.indexOf(lis[i][1])) {
          required = true;
        } else if (required) {
          var hasNextValue = false;

          for (var j = i; j < len; j++) {
            if (lis[j][0] > 0) {
              hasNextValue = true;
              break;
            }
          }

          if (!hasNextValue) {
            break;
          }

          if (!firstTwoPlaces) {
            format = firstChar + format;
          }

          format = lis[i][1] + separator + format;

          if (firstTwoPlaces) {
            format = lis[i][1] + format;
          }

          firstChar = lis[i][1];
        }
      }

      options.timeFormat = format;
    }

    function convertSMPTEtoSeconds(SMPTE) {
      if (typeof SMPTE !== 'string') {
        throw new TypeError('Argument must be a string value');
      }

      SMPTE = SMPTE.replace(',', '.');
      var decimalLen = ~SMPTE.indexOf('.') ? SMPTE.split('.')[1].length : 0;
      var secs = 0,
          multiplier = 1;
      SMPTE = SMPTE.split(':').reverse();

      for (var i = 0, total = SMPTE.length; i < total; i++) {
        multiplier = 1;

        if (i > 0) {
          multiplier = Math.pow(60, i);
        }

        secs += Number(SMPTE[i]) * multiplier;
      }

      return Number(secs.toFixed(decimalLen));
    }

    _mejs2.default.Utils = _mejs2.default.Utils || {};
    _mejs2.default.Utils.secondsToTimeCode = secondsToTimeCode;
    _mejs2.default.Utils.timeCodeToSeconds = timeCodeToSeconds;
    _mejs2.default.Utils.calculateTimeFormat = calculateTimeFormat;
    _mejs2.default.Utils.convertSMPTEtoSeconds = convertSMPTEtoSeconds;
  }, {
    "7": 7
  }]
}, {}, [29, 6, 5, 15, 23, 20, 19, 21, 22, 24, 16, 18, 17, 9, 10, 11, 12, 13, 14]);

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.VanillaSharing = {}));
})(this, function (exports) {
  'use strict';

  var WIN_PARAMS = 'scrollbars=0, resizable=1, menubar=0, left=100, top=100, width=550, height=440, toolbar=0, status=0'; // eslint-disable-line import/prefer-default-export

  function encodeParams(obj) {
    return Object.keys(obj).filter(function (k) {
      return typeof obj[k] !== 'undefined' && obj[k] !== '';
    }).map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
    }).join('&');
  }

  function getFbFeedUrl() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fbAppId = options.fbAppId,
        url = options.url,
        redirectUri = options.redirectUri;

    if (!fbAppId) {
      throw new Error('fbAppId is not defined');
    }

    var params = encodeParams({
      app_id: fbAppId,
      display: 'popup',
      redirect_uri: redirectUri,
      link: url
    });
    return 'https://www.facebook.com/dialog/feed?' + params;
  }

  function fbFeed() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return window.open(getFbFeedUrl(options), '_blank', WIN_PARAMS);
  }

  function getFbShareUrl() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fbAppId = options.fbAppId,
        url = options.url,
        hashtag = options.hashtag,
        redirectUri = options.redirectUri;

    if (!fbAppId) {
      throw new Error('fbAppId is not defined');
    }

    var params = encodeParams({
      app_id: fbAppId,
      display: 'popup',
      redirect_uri: redirectUri,
      href: url,
      hashtag: hashtag
    });
    return 'https://www.facebook.com/dialog/share?' + params;
  }

  function fbShare() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return window.open(getFbShareUrl(options), '_blank', WIN_PARAMS);
  }

  function getFbButtonUrl() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = options.url;

    if (!url) {
      throw new Error('url is not defined');
    }

    var params = encodeParams({
      kid_directed_site: '0',
      sdk: 'joey',
      u: url,
      display: 'popup',
      ref: 'plugin',
      src: 'share_button'
    });
    return 'https://www.facebook.com/sharer/sharer.php?' + params;
  }

  function fbButton() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return window.open(getFbButtonUrl(options), '_blank', WIN_PARAMS);
  }

  function gp() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = options.url;
    var params = encodeParams({
      url: url
    });
    return window.open('https://plus.google.com/share?' + params, '_blank', WIN_PARAMS);
  }

  function mail() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = options.url,
        title = options.title,
        description = options.description,
        image = options.image;
    var params = encodeParams({
      share_url: url,
      title: title,
      description: description,
      imageurl: image
    });
    return window.open('http://connect.mail.ru/share?' + params, '_blank', WIN_PARAMS);
  }

  function email() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = options.url,
        title = options.title,
        description = options.description;
    var body = (title || '') + '\r\n' + (description || '') + '\r\n' + (url || '');
    var uri = 'mailto:?body=' + encodeURIComponent(body);
    return window.location.assign(uri);
  }

  function getOkUrl() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = options.url,
        title = options.title,
        image = options.image;
    var params = encodeParams({
      url: url,
      title: title,
      imageUrl: image
    });
    return 'https://connect.ok.ru/offer?' + params;
  }

  function ok() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return window.open(getOkUrl(options), '_blank', WIN_PARAMS);
  }

  function getTelegramUrl() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = options.url,
        title = options.title;
    var params = encodeParams({
      url: url,
      text: title
    });
    return 'https://t.me/share/url?' + params;
  }

  function telegram() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return window.open(getTelegramUrl(options), '_blank', WIN_PARAMS);
  }

  function getTwUrl() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var title = options.title,
        url = options.url,
        _options$hashtags = options.hashtags,
        hashtags = _options$hashtags === undefined ? [] : _options$hashtags;
    var params = encodeParams({
      text: title,
      url: url,
      hashtags: hashtags.join(',')
    });
    return 'https://twitter.com/intent/tweet?' + params;
  }

  function tw() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return window.open(getTwUrl(options), '_blank', WIN_PARAMS);
  }

  function reddit() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = options.url,
        title = options.title;
    var params = encodeParams({
      url: url,
      title: title
    });
    return window.open('https://www.reddit.com/submit?' + params, '_blank', WIN_PARAMS);
  }

  function pinterest() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var description = options.description,
        url = options.url,
        media = options.media;
    var params = encodeParams({
      url: url,
      description: description,
      media: media
    });
    return window.open('https://pinterest.com/pin/create/button/?' + params, '_blank', WIN_PARAMS);
  }

  function tumblr() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = options.url,
        title = options.title,
        caption = options.caption,
        _options$tags = options.tags,
        tags = _options$tags === undefined ? [] : _options$tags,
        _options$posttype = options.posttype,
        posttype = _options$posttype === undefined ? 'link' : _options$posttype;
    var params = encodeParams({
      canonicalUrl: url,
      title: title,
      caption: caption,
      tags: tags.join(','),
      posttype: posttype
    });
    return window.open('https://www.tumblr.com/widgets/share/tool?' + params, '_blank', WIN_PARAMS);
  }

  function isMobileSafari() {
    return !!window.navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
  }

  function mobileShare(link) {
    return isMobileSafari() ? window.open(link) : window.location.assign(link);
  }

  function getViberUrl() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = options.url,
        title = options.title;

    if (!url && !title) {
      throw new Error('url and title not specified');
    }

    var params = encodeParams({
      text: [title, url].filter(function (item) {
        return item;
      }).join(' ')
    });
    return 'viber://forward?' + params;
  }

  function viber() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return mobileShare(getViberUrl(options));
  }

  var VK_MAX_LENGTH = 80;

  function getVkUrl() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = options.url,
        image = options.image,
        isVkParse = options.isVkParse;
    var description = options.description,
        title = options.title;

    if (description && description.length > VK_MAX_LENGTH) {
      description = description.substr(0, VK_MAX_LENGTH) + '...';
    }

    if (title && title.length > VK_MAX_LENGTH) {
      title = title.substr(0, VK_MAX_LENGTH) + '...';
    }

    var params = void 0;

    if (isVkParse) {
      params = encodeParams({
        url: url
      });
    } else {
      params = encodeParams({
        url: url,
        title: title,
        description: description,
        image: image,
        noparse: true
      });
    }

    return 'https://vk.com/share.php?' + params;
  }

  function vk() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return window.open(getVkUrl(options), '_blank', WIN_PARAMS);
  }

  function getWhatsappUrl() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var phone = options.phone,
        title = options.title,
        url = options.url;
    var params = encodeParams({
      text: [title, url].filter(function (item) {
        return item;
      }).join(' '),
      phone: phone
    });
    return 'https://api.whatsapp.com/send?' + params;
  }

  function whatsapp() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return window.open(getWhatsappUrl(options), '_blank', WIN_PARAMS);
  }

  function linkedin() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var title = options.title,
        url = options.url,
        description = options.description;
    var params = encodeParams({
      title: title,
      summary: description,
      url: url
    });
    return window.open('https://www.linkedin.com/shareArticle?mini=true&' + params, '_blank', WIN_PARAMS);
  }

  function messenger() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fbAppId = options.fbAppId,
        url = options.url;

    if (!fbAppId) {
      throw new Error('fbAppId is not defined');
    }

    var params = encodeParams({
      app_id: fbAppId,
      link: url
    });
    return window.location.assign('fb-messenger://share?' + params);
  }

  function line() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var title = options.title,
        url = options.url;

    if (!url) {
      throw new Error('url is not defined');
    }

    var params = encodeURIComponent('' + url);

    if (title) {
      params = '' + encodeURIComponent(title + ' ') + params;
    }

    return window.open('https://line.me/R/msg/text/?' + params, '_blank', WIN_PARAMS);
  }

  exports.fbFeed = fbFeed;
  exports.getFbFeedUrl = getFbFeedUrl;
  exports.fbShare = fbShare;
  exports.getFbShareUrl = getFbShareUrl;
  exports.fbButton = fbButton;
  exports.getFbButtonUrl = getFbButtonUrl;
  exports.messenger = messenger;
  exports.tw = tw;
  exports.getTwUrl = getTwUrl;
  exports.reddit = reddit;
  exports.pinterest = pinterest;
  exports.tumblr = tumblr;
  exports.gp = gp;
  exports.vk = vk;
  exports.getVkUrl = getVkUrl;
  exports.ok = ok;
  exports.getOkUrl = getOkUrl;
  exports.mail = mail;
  exports.email = email;
  exports.linkedin = linkedin;
  exports.whatsapp = whatsapp;
  exports.getWhatsappUrl = getWhatsappUrl;
  exports.viber = viber;
  exports.getViberUrl = getViberUrl;
  exports.telegram = telegram;
  exports.getTelegramUrl = getTelegramUrl;
  exports.line = line;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});
/*! lazysizes - v5.2.0 */


!function (a, b) {
  var c = b(a, a.document, Date);
  a.lazySizes = c, "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports && (module.exports = c);
}("undefined" != typeof window ? window : {}, function (a, b, c) {
  "use strict";

  var d, e;
  if (function () {
    var b,
        c = {
      lazyClass: "lazyload",
      loadedClass: "lazyloaded",
      loadingClass: "lazyloading",
      preloadClass: "lazypreload",
      errorClass: "lazyerror",
      autosizesClass: "lazyautosizes",
      srcAttr: "data-src",
      srcsetAttr: "data-srcset",
      sizesAttr: "data-sizes",
      minSize: 40,
      customMedia: {},
      init: !0,
      expFactor: 1.5,
      hFac: .8,
      loadMode: 2,
      loadHidden: !0,
      ricTimeout: 0,
      throttleDelay: 125
    };
    e = a.lazySizesConfig || a.lazysizesConfig || {};

    for (b in c) {
      b in e || (e[b] = c[b]);
    }
  }(), !b || !b.getElementsByClassName) return {
    init: function init() {},
    cfg: e,
    noSupport: !0
  };

  var f = b.documentElement,
      g = a.HTMLPictureElement,
      h = "addEventListener",
      i = "getAttribute",
      j = a[h].bind(a),
      k = a.setTimeout,
      l = a.requestAnimationFrame || k,
      m = a.requestIdleCallback,
      n = /^picture$/i,
      o = ["load", "error", "lazyincluded", "_lazyloaded"],
      p = {},
      q = Array.prototype.forEach,
      r = function r(a, b) {
    return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b];
  },
      s = function s(a, b) {
    r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b);
  },
      t = function t(a, b) {
    var c;
    (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " "));
  },
      u = function u(a, b, c) {
    var d = c ? h : "removeEventListener";
    c && u(a, b), o.forEach(function (c) {
      a[d](c, b);
    });
  },
      v = function v(a, c, e, f, g) {
    var h = b.createEvent("Event");
    return e || (e = {}), e.instance = d, h.initEvent(c, !f, !g), h.detail = e, a.dispatchEvent(h), h;
  },
      w = function w(b, c) {
    var d;
    !g && (d = a.picturefill || e.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), d({
      reevaluate: !0,
      elements: [b]
    })) : c && c.src && (b.src = c.src);
  },
      x = function x(a, b) {
    return (getComputedStyle(a, null) || {})[b];
  },
      y = function y(a, b, c) {
    for (c = c || a.offsetWidth; c < e.minSize && b && !a._lazysizesWidth;) {
      c = b.offsetWidth, b = b.parentNode;
    }

    return c;
  },
      z = function () {
    var a,
        c,
        d = [],
        e = [],
        f = d,
        g = function g() {
      var b = f;

      for (f = d.length ? e : d, a = !0, c = !1; b.length;) {
        b.shift()();
      }

      a = !1;
    },
        h = function h(d, e) {
      a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g)));
    };

    return h._lsFlush = g, h;
  }(),
      A = function A(a, b) {
    return b ? function () {
      z(a);
    } : function () {
      var b = this,
          c = arguments;
      z(function () {
        a.apply(b, c);
      });
    };
  },
      B = function B(a) {
    var b,
        d = 0,
        f = e.throttleDelay,
        g = e.ricTimeout,
        h = function h() {
      b = !1, d = c.now(), a();
    },
        i = m && g > 49 ? function () {
      m(h, {
        timeout: g
      }), g !== e.ricTimeout && (g = e.ricTimeout);
    } : A(function () {
      k(h);
    }, !0);

    return function (a) {
      var e;
      (a = !0 === a) && (g = 33), b || (b = !0, e = f - (c.now() - d), e < 0 && (e = 0), a || e < 9 ? i() : k(i, e));
    };
  },
      C = function C(a) {
    var b,
        d,
        e = 99,
        f = function f() {
      b = null, a();
    },
        g = function g() {
      var a = c.now() - d;
      a < e ? k(g, e - a) : (m || f)(f);
    };

    return function () {
      d = c.now(), b || (b = k(g, e));
    };
  },
      D = function () {
    var g,
        m,
        o,
        p,
        y,
        D,
        F,
        G,
        H,
        I,
        J,
        K,
        L = /^img$/i,
        M = /^iframe$/i,
        N = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent),
        O = 0,
        P = 0,
        Q = 0,
        R = -1,
        S = function S(a) {
      Q--, (!a || Q < 0 || !a.target) && (Q = 0);
    },
        T = function T(a) {
      return null == K && (K = "hidden" == x(b.body, "visibility")), K || !("hidden" == x(a.parentNode, "visibility") && "hidden" == x(a, "visibility"));
    },
        U = function U(a, c) {
      var d,
          e = a,
          g = T(a);

      for (G -= c, J += c, H -= c, I += c; g && (e = e.offsetParent) && e != b.body && e != f;) {
        (g = (x(e, "opacity") || 1) > 0) && "visible" != x(e, "overflow") && (d = e.getBoundingClientRect(), g = I > d.left && H < d.right && J > d.top - 1 && G < d.bottom + 1);
      }

      return g;
    },
        V = function V() {
      var a,
          c,
          h,
          j,
          k,
          l,
          n,
          o,
          q,
          r,
          s,
          t,
          u = d.elements;

      if ((p = e.loadMode) && Q < 8 && (a = u.length)) {
        for (c = 0, R++; c < a; c++) {
          if (u[c] && !u[c]._lazyRace) if (!N || d.prematureUnveil && d.prematureUnveil(u[c])) ba(u[c]);else if ((o = u[c][i]("data-expand")) && (l = 1 * o) || (l = P), r || (r = !e.expand || e.expand < 1 ? f.clientHeight > 500 && f.clientWidth > 500 ? 500 : 370 : e.expand, d._defEx = r, s = r * e.expFactor, t = e.hFac, K = null, P < s && Q < 1 && R > 2 && p > 2 && !b.hidden ? (P = s, R = 0) : P = p > 1 && R > 1 && Q < 6 ? r : O), q !== l && (D = innerWidth + l * t, F = innerHeight + l, n = -1 * l, q = l), h = u[c].getBoundingClientRect(), (J = h.bottom) >= n && (G = h.top) <= F && (I = h.right) >= n * t && (H = h.left) <= D && (J || I || H || G) && (e.loadHidden || T(u[c])) && (m && Q < 3 && !o && (p < 3 || R < 4) || U(u[c], l))) {
            if (ba(u[c]), k = !0, Q > 9) break;
          } else !k && m && !j && Q < 4 && R < 4 && p > 2 && (g[0] || e.preloadAfterLoad) && (g[0] || !o && (J || I || H || G || "auto" != u[c][i](e.sizesAttr))) && (j = g[0] || u[c]);
        }

        j && !k && ba(j);
      }
    },
        W = B(V),
        X = function X(a) {
      var b = a.target;
      if (b._lazyCache) return void delete b._lazyCache;
      S(a), s(b, e.loadedClass), t(b, e.loadingClass), u(b, Z), v(b, "lazyloaded");
    },
        Y = A(X),
        Z = function Z(a) {
      Y({
        target: a.target
      });
    },
        $ = function $(a, b) {
      try {
        a.contentWindow.location.replace(b);
      } catch (c) {
        a.src = b;
      }
    },
        _ = function _(a) {
      var b,
          c = a[i](e.srcsetAttr);
      (b = e.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c);
    },
        aa = A(function (a, b, c, d, f) {
      var g, h, j, l, m, p;
      (m = v(a, "lazybeforeunveil", b)).defaultPrevented || (d && (c ? s(a, e.autosizesClass) : a.setAttribute("sizes", d)), h = a[i](e.srcsetAttr), g = a[i](e.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), m = {
        target: a
      }, s(a, e.loadingClass), p && (clearTimeout(o), o = k(S, 2500), u(a, Z, !0)), l && q.call(j.getElementsByTagName("source"), _), h ? a.setAttribute("srcset", h) : g && !l && (M.test(a.nodeName) ? $(a, g) : a.src = g), f && (h || l) && w(a, {
        src: g
      })), a._lazyRace && delete a._lazyRace, t(a, e.lazyClass), z(function () {
        var b = a.complete && a.naturalWidth > 1;
        p && !b || (b && s(a, "ls-is-cached"), X(m), a._lazyCache = !0, k(function () {
          "_lazyCache" in a && delete a._lazyCache;
        }, 9)), "lazy" == a.loading && Q--;
      }, !0);
    }),
        ba = function ba(a) {
      if (!a._lazyRace) {
        var b,
            c = L.test(a.nodeName),
            d = c && (a[i](e.sizesAttr) || a[i]("sizes")),
            f = "auto" == d;
        (!f && m || !c || !a[i]("src") && !a.srcset || a.complete || r(a, e.errorClass) || !r(a, e.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, Q++, aa(a, b, f, d, c));
      }
    },
        ca = C(function () {
      e.loadMode = 3, W();
    }),
        da = function da() {
      3 == e.loadMode && (e.loadMode = 2), ca();
    },
        ea = function ea() {
      if (!m) {
        if (c.now() - y < 999) return void k(ea, 999);
        m = !0, e.loadMode = 3, W(), j("scroll", da, !0);
      }
    };

    return {
      _: function _() {
        y = c.now(), d.elements = b.getElementsByClassName(e.lazyClass), g = b.getElementsByClassName(e.lazyClass + " " + e.preloadClass), j("scroll", W, !0), j("resize", W, !0), j("pageshow", function (a) {
          if (a.persisted) {
            var c = b.querySelectorAll("." + e.loadingClass);
            c.length && c.forEach && l(function () {
              c.forEach(function (a) {
                a.complete && ba(a);
              });
            });
          }
        }), a.MutationObserver ? new MutationObserver(W).observe(f, {
          childList: !0,
          subtree: !0,
          attributes: !0
        }) : (f[h]("DOMNodeInserted", W, !0), f[h]("DOMAttrModified", W, !0), setInterval(W, 999)), j("hashchange", W, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function (a) {
          b[h](a, W, !0);
        }), /d$|^c/.test(b.readyState) ? ea() : (j("load", ea), b[h]("DOMContentLoaded", W), k(ea, 2e4)), d.elements.length ? (V(), z._lsFlush()) : W();
      },
      checkElems: W,
      unveil: ba,
      _aLSL: da
    };
  }(),
      E = function () {
    var a,
        c = A(function (a, b, c, d) {
      var e, f, g;
      if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++) {
        e[f].setAttribute("sizes", d);
      }
      c.detail.dataAttr || w(a, c.detail);
    }),
        d = function d(a, b, _d2) {
      var e,
          f = a.parentNode;
      f && (_d2 = y(a, f, _d2), e = v(a, "lazybeforesizes", {
        width: _d2,
        dataAttr: !!b
      }), e.defaultPrevented || (_d2 = e.detail.width) && _d2 !== a._lazysizesWidth && c(a, f, e, _d2));
    },
        f = function f() {
      var b,
          c = a.length;
      if (c) for (b = 0; b < c; b++) {
        d(a[b]);
      }
    },
        g = C(f);

    return {
      _: function _() {
        a = b.getElementsByClassName(e.autosizesClass), j("resize", g);
      },
      checkElems: g,
      updateElem: d
    };
  }(),
      F = function F() {
    !F.i && b.getElementsByClassName && (F.i = !0, E._(), D._());
  };

  return k(function () {
    e.init && F();
  }), d = {
    cfg: e,
    autoSizer: E,
    loader: D,
    init: F,
    uP: w,
    aC: s,
    rC: t,
    hC: r,
    fire: v,
    gW: y,
    rAF: z
  };
});
!function (a) {
  if ("object" == (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) && "undefined" != typeof module) module.exports = a();else if ("function" == typeof define && define.amd) define([], a);else {
    var b;
    b = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, b.oauthioWeb = a();
  }
}(function () {
  var a;
  return function b(a, c, d) {
    function e(g, h) {
      if (!c[g]) {
        if (!a[g]) {
          var i = "function" == typeof require && require;
          if (!h && i) return i(g, !0);
          if (f) return f(g, !0);
          var j = new Error("Cannot find module '" + g + "'");
          throw j.code = "MODULE_NOT_FOUND", j;
        }

        var k = c[g] = {
          exports: {}
        };
        a[g][0].call(k.exports, function (b) {
          var c = a[g][1][b];
          return e(c ? c : b);
        }, k, k.exports, b, a, c, d);
      }

      return c[g].exports;
    }

    for (var f = "function" == typeof require && require, g = 0; g < d.length; g++) {
      e(d[g]);
    }

    return e;
  }({
    1: [function (a, b, c) {
      b.exports = {
        oauthd_url: "https://oauth.io",
        oauthd_api: "https://oauth.io/api",
        version: "web-0.6.1",
        options: {}
      };
    }, {}],
    2: [function (a, b, c) {
      "use strict";

      b.exports = function (a) {
        var b, c;
        return b = a.getJquery(), c = function (c) {
          return function (c, d, e) {
            var f, g, h;
            return g = b.Deferred(), f = a.getOAuthdURL(), h = {
              url: f + d,
              type: c
            }, "post" === c || "put" === c ? (h.dataType = "json", h.contentType = "application/json", h.data = JSON.stringify(e)) : h.data = e, b.ajax(h).then(function (a) {
              return g.resolve(a);
            }, function (a) {
              return g.reject(a && a.responseJSON);
            }), g.promise();
          };
        }(this), {
          get: function (a) {
            return function (a, b) {
              return c("get", a, b);
            };
          }(this),
          post: function (a) {
            return function (a, b) {
              return c("post", a, b);
            };
          }(this),
          put: function (a) {
            return function (a, b) {
              return c("put", a, b);
            };
          }(this),
          del: function (a) {
            return function (a, b) {
              return c("delete", a, b);
            };
          }(this)
        };
      };
    }, {}],
    3: [function (a, b, c) {
      "use strict";

      var d, e, f, g, h, i;
      g = a("../config"), e = a("../tools/url"), d = a("../tools/location_operations"), h = a("../tools/cookies"), i = a("../tools/lstorage"), f = a("../tools/cache"), b.exports = function (a, b, c, j) {
        var k, l, m;
        return e = e(b), l = d(b), m = i.active() && i || h, h.init(g, b), f.init(m, g), k = {
          initialize: function initialize(a, b) {
            var c;
            if (g.key = a, b) for (c in b) {
              g.options[c] = b[c];
            }
          },
          setOAuthdURL: function setOAuthdURL(a) {
            g.oauthd_url = a, g.oauthd_base = e.getAbsUrl(g.oauthd_url).match(/^.{2,5}:\/\/[^\/]+/)[0];
          },
          getOAuthdURL: function getOAuthdURL() {
            return g.oauthd_url;
          },
          getVersion: function getVersion() {
            return g.version;
          },
          extend: function extend(a, b) {
            return this[a] = b(this);
          },
          getConfig: function getConfig() {
            return g;
          },
          getWindow: function getWindow() {
            return a;
          },
          getDocument: function getDocument() {
            return b;
          },
          getNavigator: function getNavigator() {
            return j;
          },
          getJquery: function getJquery() {
            return c;
          },
          getUrl: function getUrl() {
            return e;
          },
          getCache: function getCache() {
            return f;
          },
          getStorage: function getStorage() {
            return m;
          },
          getLocationOperations: function getLocationOperations() {
            return l;
          }
        };
      };
    }, {
      "../config": 1,
      "../tools/cache": 9,
      "../tools/cookies": 10,
      "../tools/location_operations": 12,
      "../tools/lstorage": 13,
      "../tools/url": 15
    }],
    4: [function (a, b, c) {
      "use strict";

      var d, e, f;
      d = a("../tools/cookies"), e = a("./request"), f = a("../tools/sha1"), b.exports = function (b) {
        var c, g, h, i, j, k, l, m, n, o, p, q, r;
        return g = b.getUrl(), j = b.getConfig(), k = b.getDocument(), r = b.getWindow(), c = b.getJquery(), h = b.getCache(), q = a("./providers")(b), j.oauthd_base = g.getAbsUrl(j.oauthd_url).match(/^.{2,5}:\/\/[^\/]+/)[0], i = [], n = void 0, (p = function p() {
          var a, b;
          b = /[\\#&]oauthio=([^&]*)/.exec(k.location.hash), b && (k.location.hash = k.location.hash.replace(/&?oauthio=[^&]*/, ""), n = decodeURIComponent(b[1].replace(/\+/g, " ")), a = d.read("oauthio_state"), a && (i.push(a), d.erase("oauthio_state")));
        })(), l = b.getLocationOperations(), o = {
          request: e(b, i, q)
        }, m = {
          initialize: function initialize(a, c) {
            return b.initialize(a, c);
          },
          setOAuthdURL: function setOAuthdURL(a) {
            j.oauthd_url = a, j.oauthd_base = g.getAbsUrl(j.oauthd_url).match(/^.{2,5}:\/\/[^\/]+/)[0];
          },
          create: function create(a, b, c) {
            var d, e, f, g;
            if (!b) return h.tryCache(m, a, !0);
            "object" != _typeof2(c) && q.fetchDescription(a), e = function e(d) {
              return o.request.mkHttp(a, b, c, d);
            }, f = function f(d, e) {
              return o.request.mkHttpEndpoint(a, b, c, d, e);
            }, g = {};

            for (d in b) {
              g[d] = b[d];
            }

            return g.toJson = function () {
              var a;
              return a = {}, null != g.access_token && (a.access_token = g.access_token), null != g.oauth_token && (a.oauth_token = g.oauth_token), null != g.oauth_token_secret && (a.oauth_token_secret = g.oauth_token_secret), null != g.expires_in && (a.expires_in = g.expires_in), null != g.token_type && (a.token_type = g.token_type), null != g.id_token && (a.id_token = g.id_token), null != g.provider && (a.provider = g.provider), null != g.email && (a.email = g.email), a;
            }, g.get = e("GET"), g.post = e("POST"), g.put = e("PUT"), g.patch = e("PATCH"), g.del = e("DELETE"), g.me = o.request.mkHttpMe(a, b, c, "GET"), g;
          },
          popup: function popup(a, b, d) {
            var e, l, n, p, q, s, t, u, v, w, x;
            return p = !1, n = function n(a) {
              if (!p) {
                if (a.origin !== j.oauthd_base) return;

                try {
                  u.close();
                } catch (c) {}

                return b.data = a.data, o.request.sendCallback(b, e), p = !0;
              }
            }, u = void 0, l = void 0, v = void 0, e = c.Deferred(), b = b || {}, j.key ? (2 === arguments.length && "function" == typeof b && (d = b, b = {}), h.cacheEnabled(b.cache) && (s = h.tryCache(m, a, b.cache)) ? (null != e && e.resolve(s), d ? d(null, s) : e.promise()) : (b.state || (b.state = f.create_hash(), b.state_type = "client"), i.push(b.state), t = j.oauthd_url + "/auth/" + a + "?k=" + j.key, t += "&d=" + encodeURIComponent(g.getAbsUrl("/")), b && (t += "&opts=" + encodeURIComponent(JSON.stringify(b))), b.wnd_settings ? (x = b.wnd_settings, delete b.wnd_settings) : x = {
              width: Math.floor(.8 * r.outerWidth),
              height: Math.floor(.5 * r.outerHeight)
            }, x.width < 1e3 && (x.width = 1e3), x.height < 630 && (x.height = 630), x.left = Math.floor(r.screenX + (r.outerWidth - x.width) / 2), x.top = Math.floor(r.screenY + (r.outerHeight - x.height) / 8), w = "width=" + x.width + ",height=" + x.height, w += ",toolbar=0,scrollbars=1,status=1,resizable=1,location=1,menuBar=0", w += ",left=" + x.left + ",top=" + x.top, b = {
              provider: a,
              cache: b.cache
            }, b.callback = function (a, c) {
              return r.removeEventListener ? r.removeEventListener("message", n, !1) : r.detachEvent ? r.detachEvent("onmessage", n) : k.detachEvent && k.detachEvent("onmessage", n), b.callback = function () {}, v && (clearTimeout(v), v = void 0), d ? d(a, c) : void 0;
            }, r.attachEvent ? r.attachEvent("onmessage", n) : k.attachEvent ? k.attachEvent("onmessage", n) : r.addEventListener && r.addEventListener("message", n, !1), "undefined" != typeof chrome && chrome.runtime && chrome.runtime.onMessageExternal && chrome.runtime.onMessageExternal.addListener(function (a, b, c) {
              return a.origin = b.url.match(/^.{2,5}:\/\/[^\/]+/)[0], n(a);
            }), !l && (-1 !== navigator.userAgent.indexOf("MSIE") || navigator.appVersion.indexOf("Trident/") > 0) && (l = k.createElement("iframe"), l.src = j.oauthd_url + "/auth/iframe?d=" + encodeURIComponent(g.getAbsUrl("/")), l.width = 0, l.height = 0, l.frameBorder = 0, l.style.visibility = "hidden", k.body.appendChild(l)), v = setTimeout(function () {
              null != e && e.reject(new Error("Authorization timed out")), b.callback && "function" == typeof b.callback && b.callback(new Error("Authorization timed out"));

              try {
                u.close();
              } catch (a) {}
            }, 12e5), u = r.open(t, "Authorization", w), u ? (u.focus(), q = r.setInterval(function () {
              return null !== u && !u.closed || (r.clearInterval(q), p || (null != e && e.reject(new Error("The popup was closed")), !b.callback || "function" != typeof b.callback)) ? void 0 : b.callback(new Error("The popup was closed"));
            }, 500)) : (null != e && e.reject(new Error("Could not open a popup")), b.callback && "function" == typeof b.callback && b.callback(new Error("Could not open a popup"))), null != e ? e.promise() : void 0)) : (null != e && e.reject(new Error("OAuth object must be initialized")), null == d ? e.promise() : d(new Error("OAuth object must be initialized")));
          },
          redirect: function redirect(a, b, c) {
            var e, i;
            if (2 === arguments.length && (c = b, b = {}), "string" != typeof c) throw new Error("You must specify an url");
            return h.cacheEnabled(b.cache) && (i = h.tryCache(m, a, b.cache)) ? (c = g.getAbsUrl(c) + (-1 === c.indexOf("#") ? "#" : "&") + "oauthio=cache:" + a, l.changeHref(c), void l.reload()) : (b.state || (b.state = f.create_hash(), b.state_type = "client"), d.create("oauthio_state", b.state), e = encodeURIComponent(g.getAbsUrl(c)), c = j.oauthd_url + "/auth/" + a + "?k=" + j.key, c += "&redirect_uri=" + e, b && (c += "&opts=" + encodeURIComponent(JSON.stringify(b))), void l.changeHref(c));
          },
          isRedirect: function isRedirect(a) {
            var b, c, d;
            if (null == n) return !1;
            if ("cache:" === (null != n ? n.substr(0, 6) : void 0)) return b = null != n ? n.substr(6) : void 0, a ? b.toLowerCase() === a.toLowerCase() : b;

            try {
              c = JSON.parse(n);
            } catch (e) {
              return d = e, !1;
            }

            return a ? c.provider.toLowerCase() === a.toLowerCase() : c.provider;
          },
          callback: function callback(a, b, d) {
            var e, f, g;
            if (e = c.Deferred(), 1 === arguments.length && "function" == typeof a && (d = a, a = void 0, b = {}), 1 === arguments.length && "string" == typeof a && (b = {}), 2 === arguments.length && "function" == typeof b && (d = b, b = {}), h.cacheEnabled(null != b ? b.cache : void 0) || "cache:" === (null != n ? n.substr(0, 6) : void 0)) if (a || "cache:" !== (null != n ? n.substr(0, 6) : void 0) || (a = n.substr(6)), g = h.tryCache(m, a, !0)) {
              if (!d) return null != e && e.resolve(g), null != e ? e.promise() : void 0;
              if (g) return d(null, g);
            } else if ("cache:" === (null != n ? n.substr(0, 6) : void 0)) return f = new Error("Could not fetch data from cache"), d ? d(f) : (null != e && e.reject(f), null != e ? e.promise() : void 0);
            return n ? (o.request.sendCallback({
              data: n,
              provider: a,
              cache: null != b ? b.cache : void 0,
              expires: null != b ? b.expires : void 0,
              callback: d
            }, e), null != e ? e.promise() : void 0) : void 0;
          },
          clearCache: function clearCache(a) {
            return h.clearCache(a);
          },
          http_me: function http_me(a) {
            o.request.http_me && o.request.http_me(a);
          },
          http: function http(a) {
            o.request.http && o.request.http(a);
          },
          getVersion: function getVersion() {
            return b.getVersion.apply(this);
          }
        };
      };
    }, {
      "../tools/cookies": 10,
      "../tools/sha1": 14,
      "./providers": 5,
      "./request": 6
    }],
    5: [function (a, b, c) {
      "use strict";

      var d;
      d = a("../config"), b.exports = function (a) {
        var b, c, e, f;
        return b = a.getJquery(), f = {}, e = {}, c = {
          execProvidersCb: function execProvidersCb(a, b, c) {
            var d, f;

            if (e[a]) {
              d = e[a], delete e[a];

              for (f in d) {
                d[f](b, c);
              }
            }
          },
          fetchDescription: function fetchDescription(a) {
            f[a] || (f[a] = !0, b.ajax({
              url: d.oauthd_api + "/providers/" + a,
              data: {
                extend: !0
              },
              dataType: "json"
            }).done(function (b) {
              f[a] = b.data, c.execProvidersCb(a, null, b.data);
            }).always(function () {
              "object" != _typeof2(f[a]) && (delete f[a], c.execProvidersCb(a, new Error("Unable to fetch request description")));
            }));
          },
          getDescription: function getDescription(a, b, d) {
            return b = b || {}, "object" == _typeof2(f[a]) ? d(null, f[a]) : (f[a] || c.fetchDescription(a), b.wait ? (e[a] = e[a] || [], void e[a].push(d)) : d(null, {}));
          }
        };
      };
    }, {
      "../config": 1
    }],
    6: [function (a, b, c) {
      "use strict";

      var d,
          e = [].indexOf || function (a) {
        for (var b = 0, c = this.length; c > b; b++) {
          if (b in this && this[b] === a) return b;
        }

        return -1;
      };

      d = a("../tools/url")(), b.exports = function (a, b, c) {
        var f, g, h, i, j;
        return f = a.getJquery(), h = a.getConfig(), g = a.getCache(), i = [], j = !1, {
          retrieveMethods: function retrieveMethods() {
            var a;
            return a = f.Deferred(), j ? a.resolve(i) : f.ajax(h.oauthd_url + "/api/extended-endpoints").then(function (b) {
              return i = b.data, j = !0, a.resolve();
            }).fail(function (b) {
              return j = !0, a.reject(b);
            }), a.promise();
          },
          generateMethods: function generateMethods(a, b, c) {
            var d, e, f, g, h, j, k, l, m;

            if (null != i) {
              for (k = [], e = d = 0, g = i.length; g > d; e = ++d) {
                l = i[e], h = l.name.split("."), j = a, k.push(function () {
                  var a, d, e;

                  for (e = [], f = a = 0, d = h.length; d > a; f = ++a) {
                    m = h[f], f < h.length - 1 ? (null == j[m] && (j[m] = {}), e.push(j = j[m])) : e.push(j[m] = this.mkHttpAll(c, b, l, arguments));
                  }

                  return e;
                }.apply(this, arguments));
              }

              return k;
            }
          },
          http: function http(a) {
            var b, g, i, j, k;
            i = function i() {
              var a, b, c, g;

              if (g = k.oauthio.request || {}, !g.cors) {
                k.url = encodeURIComponent(k.url), "/" !== k.url[0] && (k.url = "/" + k.url), k.url = h.oauthd_url + "/request/" + k.oauthio.provider + k.url, k.headers = k.headers || {}, k.headers.oauthio = "k=" + h.key, k.oauthio.tokens.oauth_token && k.oauthio.tokens.oauth_token_secret && (k.headers.oauthio += "&oauthv=1");

                for (b in k.oauthio.tokens) {
                  k.headers.oauthio += "&" + encodeURIComponent(b) + "=" + encodeURIComponent(k.oauthio.tokens[b]);
                }

                return delete k.oauthio, f.ajax(k);
              }

              if (k.oauthio.tokens) {
                if (k.oauthio.tokens.access_token && (k.oauthio.tokens.token = k.oauthio.tokens.access_token), k.url.match(/^[a-z]{2,16}:\/\//) || ("/" !== k.url[0] && (k.url = "/" + k.url), k.url = g.url + k.url), k.url = d.replaceParam(k.url, k.oauthio.tokens, g.parameters), g.query) {
                  c = [];

                  for (a in g.query) {
                    c.push(encodeURIComponent(a) + "=" + encodeURIComponent(d.replaceParam(g.query[a], k.oauthio.tokens, g.parameters)));
                  }

                  e.call(k.url, "?") >= 0 ? k.url += "&" + c : k.url += "?" + c;
                }

                if (g.headers) {
                  k.headers = k.headers || {};

                  for (a in g.headers) {
                    k.headers[a] = d.replaceParam(g.headers[a], k.oauthio.tokens, g.parameters);
                  }
                }

                return delete k.oauthio, f.ajax(k);
              }
            }, k = {}, j = void 0;

            for (j in a) {
              k[j] = a[j];
            }

            return k.oauthio.request && k.oauthio.request !== !0 ? i() : (g = {
              wait: !!k.oauthio.request
            }, b = f.Deferred(), c.getDescription(k.oauthio.provider, g, function (a, c) {
              return a ? b.reject(a) : (k.oauthio.tokens.oauth_token && k.oauthio.tokens.oauth_token_secret ? k.oauthio.request = c.oauth1 && c.oauth1.request : k.oauthio.request = c.oauth2 && c.oauth2.request, void b.resolve());
            }), b.then(i));
          },
          http_me: function http_me(a) {
            var b, d, e, g, i;
            e = function e() {
              var a, b, c, d;
              a = f.Deferred(), d = i.oauthio.request || {}, i.url = h.oauthd_url + "/auth/" + i.oauthio.provider + "/me", i.headers = i.headers || {}, i.headers.oauthio = "k=" + h.key, i.oauthio.tokens.oauth_token && i.oauthio.tokens.oauth_token_secret && (i.headers.oauthio += "&oauthv=1");

              for (b in i.oauthio.tokens) {
                i.headers.oauthio += "&" + encodeURIComponent(b) + "=" + encodeURIComponent(i.oauthio.tokens[b]);
              }

              return delete i.oauthio, c = f.ajax(i), f.when(c).done(function (b) {
                a.resolve(b.data);
              }).fail(function (b) {
                b.responseJSON ? a.reject(b.responseJSON.data) : a.reject(new Error("An error occured while trying to access the resource"));
              }), a.promise();
            }, i = {};

            for (g in a) {
              i[g] = a[g];
            }

            return i.oauthio.request && i.oauthio.request !== !0 ? e() : (d = {
              wait: !!i.oauthio.request
            }, b = f.Deferred(), c.getDescription(i.oauthio.provider, d, function (a, c) {
              return a ? b.reject(a) : (i.oauthio.tokens.oauth_token && i.oauthio.tokens.oauth_token_secret ? i.oauthio.request = c.oauth1 && c.oauth1.request : i.oauthio.request = c.oauth2 && c.oauth2.request, void b.resolve());
            }), b.then(e));
          },
          http_all: function http_all(a, b, c) {
            var d;
            return (d = function d() {
              var b, c, d, e;
              b = f.Deferred(), e = a.oauthio.request || {}, a.headers = a.headers || {}, a.headers.oauthio = "k=" + h.key, a.oauthio.tokens.oauth_token && a.oauthio.tokens.oauth_token_secret && (a.headers.oauthio += "&oauthv=1");

              for (c in a.oauthio.tokens) {
                a.headers.oauthio += "&" + encodeURIComponent(c) + "=" + encodeURIComponent(a.oauthio.tokens[c]);
              }

              return delete a.oauthio, d = f.ajax(a), f.when(d).done(function (a) {
                var c;
                if ("string" == typeof a.data) try {
                  a.data = JSON.parse(a.data);
                } catch (d) {
                  c = d, a.data = a.data;
                } finally {
                  b.resolve(a.data);
                }
              }).fail(function (a) {
                a.responseJSON ? b.reject(a.responseJSON.data) : b.reject(new Error("An error occured while trying to access the resource"));
              }), b.promise();
            })();
          },
          mkHttp: function mkHttp(a, b, c, d) {
            var e;
            return e = this, function (f, g) {
              var h, i;

              if (i = {}, "string" == typeof f) {
                if ("object" == _typeof2(g)) for (h in g) {
                  i[h] = g[h];
                }
                i.url = f;
              } else if ("object" == _typeof2(f)) for (h in f) {
                i[h] = f[h];
              }

              return i.type = i.type || d, i.oauthio = {
                provider: a,
                tokens: b,
                request: c
              }, e.http(i);
            };
          },
          mkHttpMe: function mkHttpMe(a, b, c, d) {
            var e;
            return e = this, function (f) {
              var g;
              return g = {}, g.type = g.type || d, g.oauthio = {
                provider: a,
                tokens: b,
                request: c
              }, g.data = g.data || {}, f && (g.data.filter = f.join(",")), e.http_me(g);
            };
          },
          mkHttpAll: function mkHttpAll(a, b, c) {
            var d;
            return d = this, function () {
              var e, f, g, i;
              f = {}, f.type = c.method, f.url = h.oauthd_url + c.endpoint.replace(":provider", a), f.oauthio = {
                provider: a,
                tokens: b
              }, f.data = {};

              for (e in arguments) {
                i = arguments[e], g = c.params[e], null != g && (f.data[g.name] = i);
              }

              return f.data = f.data || {}, d.http_all(f, c, arguments);
            };
          },
          sendCallback: function sendCallback(a, c) {
            var d, e, f, h, i, j, k, l, m;
            d = this, e = void 0, h = void 0;

            try {
              e = JSON.parse(a.data);
            } catch (n) {
              return f = n, c.reject(new Error("Error while parsing result")), a.callback(new Error("Error while parsing result"));
            }

            if (e && e.provider) {
              if (a.provider && e.provider.toLowerCase() !== a.provider.toLowerCase()) return h = new Error("Returned provider name does not match asked provider"), c.reject(h), a.callback && "function" == typeof a.callback ? a.callback(h) : void 0;
              if ("error" === e.status || "fail" === e.status) return h = new Error(e.message), h.body = e.data, c.reject(h), a.callback && "function" == typeof a.callback ? a.callback(h) : void 0;
              if ("success" !== e.status || !e.data) return h = new Error(), h.body = e.data, c.reject(h), a.callback && "function" == typeof a.callback ? a.callback(h) : void 0;

              for (e.state = e.state.replace(/\s+/g, ""), i = 0; i < b.length;) {
                b[i] = b[i].replace(/\s+/g, ""), i++;
              }

              if (!e.state || -1 === b.indexOf(e.state)) return c.reject(new Error("State is not matching")), a.callback && "function" == typeof a.callback ? a.callback(new Error("State is not matching")) : void 0;
              if (a.provider || (e.data.provider = e.provider), l = e.data, l.provider = e.provider.toLowerCase(), g.cacheEnabled(a.cache) && l && (a.expires && !l.expires_in && (l.expires_in = a.expires), g.storeCache(e.provider, l)), k = l.request, delete l.request, m = void 0, l.access_token ? m = {
                access_token: l.access_token
              } : l.oauth_token && l.oauth_token_secret && (m = {
                oauth_token: l.oauth_token,
                oauth_token_secret: l.oauth_token_secret
              }), !k) return c.resolve(l), a.callback && "function" == typeof a.callback ? a.callback(null, l) : void 0;
              if (k.required) for (i in k.required) {
                m[k.required[i]] = l[k.required[i]];
              }
              return j = function j(a) {
                return d.mkHttp(e.provider, m, k, a);
              }, l.toJson = function () {
                var a;
                return a = {}, null != l.access_token && (a.access_token = l.access_token), null != l.oauth_token && (a.oauth_token = l.oauth_token), null != l.oauth_token_secret && (a.oauth_token_secret = l.oauth_token_secret), null != l.expires_in && (a.expires_in = l.expires_in), null != l.token_type && (a.token_type = l.token_type), null != l.id_token && (a.id_token = l.id_token), null != l.provider && (a.provider = l.provider), null != l.email && (a.email = l.email), a;
              }, l.get = j("GET"), l.post = j("POST"), l.put = j("PUT"), l.patch = j("PATCH"), l.del = j("DELETE"), l.me = d.mkHttpMe(e.provider, m, k, "GET"), this.retrieveMethods().then(function (b) {
                return function () {
                  return b.generateMethods(l, m, e.provider), c.resolve(l), a.callback && "function" == typeof a.callback ? a.callback(null, l) : void 0;
                };
              }(this)).fail(function (b) {
                return function (b) {
                  return console.log("Could not retrieve methods", b), c.resolve(l), a.callback && "function" == typeof a.callback ? a.callback(null, l) : void 0;
                };
              }(this));
            }
          }
        };
      };
    }, {
      "../tools/url": 15
    }],
    7: [function (a, b, c) {
      "use strict";

      b.exports = function (a) {
        var b, c, d, e, f;
        return b = a.getJquery(), d = a.getConfig(), f = a.getStorage(), e = null, c = function () {
          function c(a) {
            this.token = a.token, this.data = a.user, this.providers = a.providers, e = this.getEditableData();
          }

          return c.prototype.getEditableData = function () {
            var a, b;
            a = [];

            for (b in this.data) {
              -1 === ["id", "email"].indexOf(b) && a.push({
                key: b,
                value: this.data[b]
              });
            }

            return a;
          }, c.prototype.save = function () {
            var b, c, f, g, h, i, j, k;

            for (c = {}, f = 0, i = e.length; i > f; f++) {
              b = e[f], this.data[b.key] !== b.value && (c[b.key] = this.data[b.key]), null === this.data[b.key] && delete this.data[b.key];
            }

            for (h = function h(a) {
              var b, c, d;

              for (b = 0, c = e.length; c > b; b++) {
                if (d = e[b], d.key === a) return !0;
              }

              return !1;
            }, k = this.getEditableData(), g = 0, j = k.length; j > g; g++) {
              b = k[g], h(b.key) || (c[b.key] = this.data[b.key]);
            }

            return this.saveLocal(), a.API.put("/api/usermanagement/user?k=" + d.key + "&token=" + this.token, c);
          }, c.prototype.select = function (a) {
            var b;
            return b = null;
          }, c.prototype.saveLocal = function () {
            var a;
            return a = {
              token: this.token,
              user: this.data,
              providers: this.providers
            }, f.erase("oio_auth"), f.create("oio_auth", JSON.stringify(a), 21600);
          }, c.prototype.hasProvider = function (a) {
            return !!this.providers && -1 !== this.providers.indexOf(a);
          }, c.prototype.getProviders = function () {
            var c;
            return c = b.Deferred(), a.API.get("/api/usermanagement/user/providers?k=" + d.key + "&token=" + this.token).done(function (a) {
              return function (b) {
                return a.providers = b.data, a.saveLocal(), c.resolve(a.providers);
              };
            }(this)).fail(function (a) {
              return c.reject(a);
            }), c.promise();
          }, c.prototype.addProvider = function (c) {
            var e;
            return e = b.Deferred(), "function" == typeof c.toJson && (c = c.toJson()), c.email = this.data.email, this.providers || (this.providers = []), this.providers.push(c.provider), a.API.post("/api/usermanagement/user/providers?k=" + d.key + "&token=" + this.token, c).done(function (a) {
              return function (b) {
                return a.data = b.data, a.saveLocal(), e.resolve();
              };
            }(this)).fail(function (a) {
              return function (b) {
                return a.providers.splice(a.providers.indexOf(c.provider), 1), e.reject(b);
              };
            }(this)), e.promise();
          }, c.prototype.removeProvider = function (c) {
            var e;
            return e = b.Deferred(), this.providers.splice(this.providers.indexOf(c), 1), a.API.del("/api/usermanagement/user/providers/" + c + "?k=" + d.key + "&token=" + this.token).done(function (a) {
              return function (b) {
                return a.saveLocal(), e.resolve(b);
              };
            }(this)).fail(function (a) {
              return function (b) {
                return a.providers.push(c), e.reject(b);
              };
            }(this)), e.promise();
          }, c.prototype.changePassword = function (b, c) {
            return a.API.post("/api/usermanagement/user/password?k=" + d.key + "&token=" + this.token, {
              password: c
            });
          }, c.prototype.isLoggued = function () {
            return a.User.isLogged();
          }, c.prototype.isLogged = function () {
            return a.User.isLogged();
          }, c.prototype.logout = function () {
            var c;
            return c = b.Deferred(), f.erase("oio_auth"), a.API.post("/api/usermanagement/user/logout?k=" + d.key + "&token=" + this.token).done(function () {
              return c.resolve();
            }).fail(function (a) {
              return c.reject(a);
            }), c.promise();
          }, c;
        }(), {
          initialize: function initialize(b, c) {
            return a.initialize(b, c);
          },
          setOAuthdURL: function setOAuthdURL(b) {
            return a.setOAuthdURL(b);
          },
          signup: function signup(e) {
            var g;
            return g = b.Deferred(), "function" == typeof e.toJson && (e = e.toJson()), a.API.post("/api/usermanagement/signup?k=" + d.key, e).done(function (a) {
              return f.create("oio_auth", JSON.stringify(a.data), a.data.expires_in || 21600), g.resolve(new c(a.data));
            }).fail(function (a) {
              return g.reject(a);
            }), g.promise();
          },
          signin: function signin(e, g) {
            var h, i;
            return h = b.Deferred(), "string" == typeof e || g ? a.API.post("/api/usermanagement/signin?k=" + d.key, {
              email: e,
              password: g
            }).done(function (a) {
              return f.create("oio_auth", JSON.stringify(a.data), a.data.expires_in || 21600), h.resolve(new c(a.data));
            }).fail(function (a) {
              return h.reject(a);
            }) : (i = e, "function" == typeof i.toJson && (i = i.toJson()), a.API.post("/api/usermanagement/signin?k=" + d.key, i).done(function (a) {
              return f.create("oio_auth", JSON.stringify(a.data), a.data.expires_in || 21600), h.resolve(new c(a.data));
            }).fail(function (a) {
              return h.reject(a);
            })), h.promise();
          },
          confirmResetPassword: function confirmResetPassword(b, c) {
            return a.API.post("/api/usermanagement/user/password?k=" + d.key, {
              password: b,
              token: c
            });
          },
          resetPassword: function resetPassword(b, c) {
            return a.API.post("/api/usermanagement/user/password/reset?k=" + d.key, {
              email: b
            });
          },
          refreshIdentity: function refreshIdentity() {
            var e;
            return e = b.Deferred(), a.API.get("/api/usermanagement/user?k=" + d.key + "&token=" + JSON.parse(f.read("oio_auth")).token).done(function (a) {
              return e.resolve(new c(a.data));
            }).fail(function (a) {
              return e.reject(a);
            }), e.promise();
          },
          getIdentity: function getIdentity() {
            var a;
            return a = f.read("oio_auth"), a ? new c(JSON.parse(a)) : null;
          },
          isLogged: function isLogged() {
            var a;
            return a = f.read("oio_auth"), !!a;
          }
        };
      };
    }, {}],
    8: [function (b, c, d) {
      !function () {
        var e, f;
        return f = b("./tools/jquery-lite.js"), e = b("./lib/core")(window, document, f, navigator), e.extend("OAuth", b("./lib/oauth")), e.extend("API", b("./lib/api")), e.extend("User", b("./lib/user")), "undefined" != typeof angular && null !== angular && angular.module("oauthio", []).factory("OAuth", [function () {
          return e.OAuth;
        }]).factory("User", [function () {
          return e.User;
        }]), d.OAuthio = e, window.User = d.User = d.OAuthio.User, window.OAuth = d.OAuth = d.OAuthio.OAuth, "function" == typeof a && a.amd && a(function () {
          return d;
        }), ("undefined" != typeof c && null !== c ? c.exports : void 0) && (c.exports = d), d;
      }();
    }, {
      "./lib/api": 2,
      "./lib/core": 3,
      "./lib/oauth": 4,
      "./lib/user": 7,
      "./tools/jquery-lite.js": 11
    }],
    9: [function (a, b, c) {
      "use strict";

      b.exports = {
        init: function init(a, b) {
          return this.config = b, this.storage = a;
        },
        tryCache: function tryCache(a, b, c) {
          var d, e, f;

          if (this.cacheEnabled(c)) {
            if (c = this.storage.read("oauthio_provider_" + b), !c) return !1;
            c = decodeURIComponent(c);
          }

          if ("string" == typeof c) try {
            c = JSON.parse(c);
          } catch (g) {
            return d = g, !1;
          }

          if ("object" == _typeof2(c)) {
            f = {};

            for (e in c) {
              "request" !== e && "function" != typeof c[e] && (f[e] = c[e]);
            }

            return a.create(b, f, c.request);
          }

          return !1;
        },
        storeCache: function storeCache(a, b) {
          var c;
          c = 3600, b.expires_in ? c = b.expires_in : (this.config.options.expires || this.config.options.expires === !1) && (c = this.config.options.expires), this.storage.create("oauthio_provider_" + a, encodeURIComponent(JSON.stringify(b)), c);
        },
        cacheEnabled: function cacheEnabled(a) {
          return "undefined" == typeof a ? this.config.options.cache : a;
        },
        clearCache: function clearCache(a) {
          a ? this.storage.erase("oauthio_provider_" + a) : this.storage.eraseFrom("oauthio_provider_");
        }
      };
    }, {}],
    10: [function (a, b, c) {
      "use strict";

      b.exports = {
        init: function init(a, b) {
          return this.config = a, this.document = b;
        },
        create: function create(a, b, c) {
          var d;
          this.erase(a), d = new Date(), c ? d.setTime(d.getTime() + 1e3 * (c || 1200)) : d.setFullYear(d.getFullYear() + 3), c = "; expires=" + d.toGMTString(), this.document.cookie = a + "=" + b + c + "; path=/";
        },
        read: function read(a) {
          var b, c, d, e;

          for (e = a + "=", c = this.document.cookie.split(";"), d = 0; d < c.length;) {
            for (b = c[d]; " " === b.charAt(0);) {
              b = b.substring(1, b.length);
            }

            if (0 === b.indexOf(e)) return b.substring(e.length, b.length);
            d++;
          }

          return null;
        },
        erase: function erase(a) {
          var b;
          b = new Date(), b.setTime(b.getTime() - 864e5), this.document.cookie = a + "=; expires=" + b.toGMTString() + "; path=/";
        },
        eraseFrom: function eraseFrom(a) {
          var b, c, d, e, f;

          for (d = this.document.cookie.split(";"), e = 0, f = d.length; f > e; e++) {
            c = d[e], b = c.split("=")[0].trim(), b.substr(0, a.length) === a && this.erase(b);
          }
        }
      };
    }, {}],
    11: [function (a, b, c) {
      !function (a, c) {
        "object" == _typeof2(b) && "object" == _typeof2(b.exports) ? b.exports = a.document ? c(a, !0) : function (a) {
          if (!a.document) throw new Error("jQuery requires a window with a document");
          return c(a);
        } : c(a);
      }("undefined" != typeof window ? window : this, function (a, b) {
        function c(a) {
          var b = a.length,
              c = B.type(a);
          return "function" === c || B.isWindow(a) ? !1 : 1 === a.nodeType && b ? !0 : "array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a;
        }

        function d(a) {
          var b = L[a] = {};
          return B.each(a.match(K) || [], function (a, c) {
            b[c] = !0;
          }), b;
        }

        function e() {
          z.removeEventListener("DOMContentLoaded", e, !1), a.removeEventListener("load", e, !1), B.ready();
        }

        function f() {
          Object.defineProperty(this.cache = {}, 0, {
            get: function get() {
              return {};
            }
          }), this.expando = B.expando + Math.random();
        }

        function g(a, b, c) {
          var d;
          if (void 0 === c && 1 === a.nodeType) if (d = "data-" + b.replace(Q, "-$1").toLowerCase(), c = a.getAttribute(d), "string" == typeof c) {
            try {
              c = "true" === c ? !0 : "false" === c ? !1 : "null" === c ? null : +c + "" === c ? +c : P.test(c) ? B.parseJSON(c) : c;
            } catch (e) {}

            data_user.set(a, b, c);
          } else c = void 0;
          return c;
        }

        function h() {
          return !0;
        }

        function i() {
          return !1;
        }

        function j() {
          try {
            return z.activeElement;
          } catch (a) {}
        }

        function k(a) {
          return function (b, c) {
            "string" != typeof b && (c = b, b = "*");
            var d,
                e = 0,
                f = b.toLowerCase().match(K) || [];
            if (B.isFunction(c)) for (; d = f[e++];) {
              "+" === d[0] ? (d = d.slice(1) || "*", (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c);
            }
          };
        }

        function l(a, b, c, d) {
          function e(h) {
            var i;
            return f[h] = !0, B.each(a[h] || [], function (a, h) {
              var j = h(b, c, d);
              return "string" != typeof j || g || f[j] ? g ? !(i = j) : void 0 : (b.dataTypes.unshift(j), e(j), !1);
            }), i;
          }

          var f = {},
              g = a === ga;
          return e(b.dataTypes[0]) || !f["*"] && e("*");
        }

        function m(a, b) {
          var c,
              d,
              e = B.ajaxSettings.flatOptions || {};

          for (c in b) {
            void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c]);
          }

          return d && B.extend(!0, a, d), a;
        }

        function n(a, b, c) {
          for (var d, e, f, g, h = a.contents, i = a.dataTypes; "*" === i[0];) {
            i.shift(), void 0 === d && (d = a.mimeType || b.getResponseHeader("Content-Type"));
          }

          if (d) for (e in h) {
            if (h[e] && h[e].test(d)) {
              i.unshift(e);
              break;
            }
          }
          if (i[0] in c) f = i[0];else {
            for (e in c) {
              if (!i[0] || a.converters[e + " " + i[0]]) {
                f = e;
                break;
              }

              g || (g = e);
            }

            f = f || g;
          }
          return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0;
        }

        function o(a, b, c, d) {
          var e,
              f,
              g,
              h,
              i,
              j = {},
              k = a.dataTypes.slice();
          if (k[1]) for (g in a.converters) {
            j[g.toLowerCase()] = a.converters[g];
          }

          for (f = k.shift(); f;) {
            if (a.responseFields[f] && (c[a.responseFields[f]] = b), !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)), i = f, f = k.shift()) if ("*" === f) f = i;else if ("*" !== i && i !== f) {
              if (g = j[i + " " + f] || j["* " + f], !g) for (e in j) {
                if (h = e.split(" "), h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) {
                  g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0], k.unshift(h[1]));
                  break;
                }
              }
              if (g !== !0) if (g && a["throws"]) b = g(b);else try {
                b = g(b);
              } catch (l) {
                return {
                  state: "parsererror",
                  error: g ? l : "No conversion from " + i + " to " + f
                };
              }
            }
          }

          return {
            state: "success",
            data: b
          };
        }

        function p(a, b, c, d) {
          var e;
          if (B.isArray(b)) B.each(b, function (b, e) {
            c || ka.test(a) ? d(a, e) : p(a + "[" + ("object" == _typeof2(e) ? b : "") + "]", e, c, d);
          });else if (c || "object" !== B.type(b)) d(a, b);else for (e in b) {
            p(a + "[" + e + "]", b[e], c, d);
          }
        }

        var q = [],
            r = q.slice,
            s = q.concat,
            t = q.push,
            u = q.indexOf,
            v = {},
            w = v.toString,
            x = v.hasOwnProperty,
            y = {},
            z = a.document,
            A = "2.1.1 -attributes,-attributes/attr,-attributes/classes,-attributes/prop,-attributes/support,-attributes/val,-css/addGetHookIf,-css/curCSS,-css/defaultDisplay,-css/hiddenVisibleSelectors,-css/support,-css/swap,-css/var,-css/var/cssExpand,-css/var/getStyles,-css/var/isHidden,-css/var/rmargin,-css/var/rnumnonpx,-css,-effects,-effects/Tween,-effects/animatedSelector,-dimensions,-offset,-data/var/data_user,-deprecated,-event/alias,-event/support,-intro,-manipulation/_evalUrl,-manipulation/support,-manipulation/var,-manipulation/var/rcheckableType,-manipulation,-outro,-queue,-queue/delay,-selector-native,-selector-sizzle,-sizzle/dist,-sizzle/dist/sizzle,-sizzle/dist/min,-sizzle/test,-sizzle/test/jquery,-traversing,-traversing/findFilter,-traversing/var/rneedsContext,-traversing/var,-wrap,-exports,-exports/amd",
            B = function B(a, b) {
          return new B.fn.init(a, b);
        },
            C = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
            D = /^-ms-/,
            E = /-([\da-z])/gi,
            F = function F(a, b) {
          return b.toUpperCase();
        };

        B.fn = B.prototype = {
          jquery: A,
          constructor: B,
          selector: "",
          length: 0,
          toArray: function toArray() {
            return r.call(this);
          },
          get: function get(a) {
            return null != a ? 0 > a ? this[a + this.length] : this[a] : r.call(this);
          },
          pushStack: function pushStack(a) {
            var b = B.merge(this.constructor(), a);
            return b.prevObject = this, b.context = this.context, b;
          },
          each: function each(a, b) {
            return B.each(this, a, b);
          },
          map: function map(a) {
            return this.pushStack(B.map(this, function (b, c) {
              return a.call(b, c, b);
            }));
          },
          slice: function slice() {
            return this.pushStack(r.apply(this, arguments));
          },
          first: function first() {
            return this.eq(0);
          },
          last: function last() {
            return this.eq(-1);
          },
          eq: function eq(a) {
            var b = this.length,
                c = +a + (0 > a ? b : 0);
            return this.pushStack(c >= 0 && b > c ? [this[c]] : []);
          },
          end: function end() {
            return this.prevObject || this.constructor(null);
          },
          push: t,
          sort: q.sort,
          splice: q.splice
        }, B.extend = B.fn.extend = function () {
          var a,
              b,
              c,
              d,
              e,
              f,
              g = arguments[0] || {},
              h = 1,
              i = arguments.length,
              j = !1;

          for ("boolean" == typeof g && (j = g, g = arguments[h] || {}, h++), "object" == _typeof2(g) || B.isFunction(g) || (g = {}), h === i && (g = this, h--); i > h; h++) {
            if (null != (a = arguments[h])) for (b in a) {
              c = g[b], d = a[b], g !== d && (j && d && (B.isPlainObject(d) || (e = B.isArray(d))) ? (e ? (e = !1, f = c && B.isArray(c) ? c : []) : f = c && B.isPlainObject(c) ? c : {}, g[b] = B.extend(j, f, d)) : void 0 !== d && (g[b] = d));
            }
          }

          return g;
        }, B.extend({
          expando: "jQuery" + (A + Math.random()).replace(/\D/g, ""),
          isReady: !0,
          error: function error(a) {
            throw new Error(a);
          },
          noop: function noop() {},
          isFunction: function isFunction(a) {
            return "function" === B.type(a);
          },
          isArray: Array.isArray,
          isWindow: function isWindow(a) {
            return null != a && a === a.window;
          },
          isNumeric: function isNumeric(a) {
            return !B.isArray(a) && a - parseFloat(a) >= 0;
          },
          isPlainObject: function isPlainObject(a) {
            return "object" !== B.type(a) || a.nodeType || B.isWindow(a) ? !1 : !a.constructor || x.call(a.constructor.prototype, "isPrototypeOf");
          },
          isEmptyObject: function isEmptyObject(a) {
            var b;

            for (b in a) {
              return !1;
            }

            return !0;
          },
          type: function type(a) {
            return null == a ? a + "" : "object" == _typeof2(a) || "function" == typeof a ? v[w.call(a)] || "object" : _typeof2(a);
          },
          globalEval: function globalEval(a) {
            var b,
                c = eval;
            a = B.trim(a), a && (1 === a.indexOf("use strict") ? (b = z.createElement("script"), b.text = a, z.head.appendChild(b).parentNode.removeChild(b)) : c(a));
          },
          camelCase: function camelCase(a) {
            return a.replace(D, "ms-").replace(E, F);
          },
          nodeName: function nodeName(a, b) {
            return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase();
          },
          each: function each(a, b, d) {
            var e,
                f = 0,
                g = a.length,
                h = c(a);

            if (d) {
              if (h) for (; g > f && (e = b.apply(a[f], d), e !== !1); f++) {
                ;
              } else for (f in a) {
                if (e = b.apply(a[f], d), e === !1) break;
              }
            } else if (h) for (; g > f && (e = b.call(a[f], f, a[f]), e !== !1); f++) {
              ;
            } else for (f in a) {
              if (e = b.call(a[f], f, a[f]), e === !1) break;
            }

            return a;
          },
          trim: function trim(a) {
            return null == a ? "" : (a + "").replace(C, "");
          },
          makeArray: function makeArray(a, b) {
            var d = b || [];
            return null != a && (c(Object(a)) ? B.merge(d, "string" == typeof a ? [a] : a) : t.call(d, a)), d;
          },
          inArray: function inArray(a, b, c) {
            return null == b ? -1 : u.call(b, a, c);
          },
          merge: function merge(a, b) {
            for (var c = +b.length, d = 0, e = a.length; c > d; d++) {
              a[e++] = b[d];
            }

            return a.length = e, a;
          },
          grep: function grep(a, b, c) {
            for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++) {
              d = !b(a[f], f), d !== h && e.push(a[f]);
            }

            return e;
          },
          map: function map(a, b, d) {
            var e,
                f = 0,
                g = a.length,
                h = c(a),
                i = [];
            if (h) for (; g > f; f++) {
              e = b(a[f], f, d), null != e && i.push(e);
            } else for (f in a) {
              e = b(a[f], f, d), null != e && i.push(e);
            }
            return s.apply([], i);
          },
          guid: 1,
          proxy: function proxy(a, b) {
            var c, d, e;
            return "string" == typeof b && (c = a[b], b = a, a = c), B.isFunction(a) ? (d = r.call(arguments, 2), e = function e() {
              return a.apply(b || this, d.concat(r.call(arguments)));
            }, e.guid = a.guid = a.guid || B.guid++, e) : void 0;
          },
          now: Date.now,
          support: y
        }), B.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (a, b) {
          v["[object " + b + "]"] = b.toLowerCase();
        });

        var G,
            H = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
            I = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
            J = B.fn.init = function (a, b) {
          var c, d;
          if (!a) return this;

          if ("string" == typeof a) {
            if (c = "<" === a[0] && ">" === a[a.length - 1] && a.length >= 3 ? [null, a, null] : I.exec(a), !c || !c[1] && b) return !b || b.jquery ? (b || G).find(a) : this.constructor(b).find(a);

            if (c[1]) {
              if (b = b instanceof B ? b[0] : b, B.merge(this, B.parseHTML(c[1], b && b.nodeType ? b.ownerDocument || b : z, !0)), H.test(c[1]) && B.isPlainObject(b)) for (c in b) {
                B.isFunction(this[c]) ? this[c](b[c]) : this.attr(c, b[c]);
              }
              return this;
            }

            return d = z.getElementById(c[2]), d && d.parentNode && (this.length = 1, this[0] = d), this.context = z, this.selector = a, this;
          }

          return a.nodeType ? (this.context = this[0] = a, this.length = 1, this) : B.isFunction(a) ? "undefined" != typeof G.ready ? G.ready(a) : a(B) : (void 0 !== a.selector && (this.selector = a.selector, this.context = a.context), B.makeArray(a, this));
        };

        J.prototype = B.fn, G = B(z);
        var K = /\S+/g,
            L = {};
        B.Callbacks = function (a) {
          a = "string" == typeof a ? L[a] || d(a) : B.extend({}, a);

          var b,
              c,
              e,
              f,
              g,
              h,
              i = [],
              j = !a.once && [],
              k = function k(d) {
            for (b = a.memory && d, c = !0, h = f || 0, f = 0, g = i.length, e = !0; i && g > h; h++) {
              if (i[h].apply(d[0], d[1]) === !1 && a.stopOnFalse) {
                b = !1;
                break;
              }
            }

            e = !1, i && (j ? j.length && k(j.shift()) : b ? i = [] : l.disable());
          },
              l = {
            add: function add() {
              if (i) {
                var c = i.length;
                !function d(b) {
                  B.each(b, function (b, c) {
                    var e = B.type(c);
                    "function" === e ? a.unique && l.has(c) || i.push(c) : c && c.length && "string" !== e && d(c);
                  });
                }(arguments), e ? g = i.length : b && (f = c, k(b));
              }

              return this;
            },
            remove: function remove() {
              return i && B.each(arguments, function (a, b) {
                for (var c; (c = B.inArray(b, i, c)) > -1;) {
                  i.splice(c, 1), e && (g >= c && g--, h >= c && h--);
                }
              }), this;
            },
            has: function has(a) {
              return a ? B.inArray(a, i) > -1 : !(!i || !i.length);
            },
            empty: function empty() {
              return i = [], g = 0, this;
            },
            disable: function disable() {
              return i = j = b = void 0, this;
            },
            disabled: function disabled() {
              return !i;
            },
            lock: function lock() {
              return j = void 0, b || l.disable(), this;
            },
            locked: function locked() {
              return !j;
            },
            fireWith: function fireWith(a, b) {
              return !i || c && !j || (b = b || [], b = [a, b.slice ? b.slice() : b], e ? j.push(b) : k(b)), this;
            },
            fire: function fire() {
              return l.fireWith(this, arguments), this;
            },
            fired: function fired() {
              return !!c;
            }
          };

          return l;
        }, B.extend({
          Deferred: function Deferred(a) {
            var b = [["resolve", "done", B.Callbacks("once memory"), "resolved"], ["reject", "fail", B.Callbacks("once memory"), "rejected"], ["notify", "progress", B.Callbacks("memory")]],
                c = "pending",
                d = {
              state: function state() {
                return c;
              },
              always: function always() {
                return e.done(arguments).fail(arguments), this;
              },
              then: function then() {
                var a = arguments;
                return B.Deferred(function (c) {
                  B.each(b, function (b, f) {
                    var g = B.isFunction(a[b]) && a[b];
                    e[f[1]](function () {
                      var a = g && g.apply(this, arguments);
                      a && B.isFunction(a.promise) ? a.promise().done(c.resolve).fail(c.reject).progress(c.notify) : c[f[0] + "With"](this === d ? c.promise() : this, g ? [a] : arguments);
                    });
                  }), a = null;
                }).promise();
              },
              promise: function promise(a) {
                return null != a ? B.extend(a, d) : d;
              }
            },
                e = {};
            return d.pipe = d.then, B.each(b, function (a, f) {
              var g = f[2],
                  h = f[3];
              d[f[1]] = g.add, h && g.add(function () {
                c = h;
              }, b[1 ^ a][2].disable, b[2][2].lock), e[f[0]] = function () {
                return e[f[0] + "With"](this === e ? d : this, arguments), this;
              }, e[f[0] + "With"] = g.fireWith;
            }), d.promise(e), a && a.call(e, e), e;
          },
          when: function when(a) {
            var b,
                c,
                d,
                e = 0,
                f = r.call(arguments),
                g = f.length,
                h = 1 !== g || a && B.isFunction(a.promise) ? g : 0,
                i = 1 === h ? a : B.Deferred(),
                j = function j(a, c, d) {
              return function (e) {
                c[a] = this, d[a] = arguments.length > 1 ? r.call(arguments) : e, d === b ? i.notifyWith(c, d) : --h || i.resolveWith(c, d);
              };
            };

            if (g > 1) for (b = new Array(g), c = new Array(g), d = new Array(g); g > e; e++) {
              f[e] && B.isFunction(f[e].promise) ? f[e].promise().done(j(e, d, f)).fail(i.reject).progress(j(e, c, b)) : --h;
            }
            return h || i.resolveWith(d, f), i.promise();
          }
        });
        var M;
        B.fn.ready = function (a) {
          return B.ready.promise().done(a), this;
        }, B.extend({
          isReady: !1,
          readyWait: 1,
          holdReady: function holdReady(a) {
            a ? B.readyWait++ : B.ready(!0);
          },
          ready: function ready(a) {
            (a === !0 ? --B.readyWait : B.isReady) || (B.isReady = !0, a !== !0 && --B.readyWait > 0 || (M.resolveWith(z, [B]), B.fn.triggerHandler && (B(z).triggerHandler("ready"), B(z).off("ready"))));
          }
        }), B.ready.promise = function (b) {
          return M || (M = B.Deferred(), "complete" === z.readyState ? setTimeout(B.ready) : (z.addEventListener("DOMContentLoaded", e, !1), a.addEventListener("load", e, !1))), M.promise(b);
        }, B.ready.promise();

        var N = B.access = function (a, b, c, d, e, f, g) {
          var h = 0,
              i = a.length,
              j = null == c;

          if ("object" === B.type(c)) {
            e = !0;

            for (h in c) {
              B.access(a, b, h, c[h], !0, f, g);
            }
          } else if (void 0 !== d && (e = !0, B.isFunction(d) || (g = !0), j && (g ? (b.call(a, d), b = null) : (j = b, b = function b(a, _b, c) {
            return j.call(B(a), c);
          })), b)) for (; i > h; h++) {
            b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
          }

          return e ? a : j ? b.call(a) : i ? b(a[0], c) : f;
        };

        B.acceptData = function (a) {
          return 1 === a.nodeType || 9 === a.nodeType || !+a.nodeType;
        }, f.uid = 1, f.accepts = B.acceptData, f.prototype = {
          key: function key(a) {
            if (!f.accepts(a)) return 0;
            var b = {},
                c = a[this.expando];

            if (!c) {
              c = f.uid++;

              try {
                b[this.expando] = {
                  value: c
                }, Object.defineProperties(a, b);
              } catch (d) {
                b[this.expando] = c, B.extend(a, b);
              }
            }

            return this.cache[c] || (this.cache[c] = {}), c;
          },
          set: function set(a, b, c) {
            var d,
                e = this.key(a),
                f = this.cache[e];
            if ("string" == typeof b) f[b] = c;else if (B.isEmptyObject(f)) B.extend(this.cache[e], b);else for (d in b) {
              f[d] = b[d];
            }
            return f;
          },
          get: function get(a, b) {
            var c = this.cache[this.key(a)];
            return void 0 === b ? c : c[b];
          },
          access: function access(a, b, c) {
            var d;
            return void 0 === b || b && "string" == typeof b && void 0 === c ? (d = this.get(a, b), void 0 !== d ? d : this.get(a, B.camelCase(b))) : (this.set(a, b, c), void 0 !== c ? c : b);
          },
          remove: function remove(a, b) {
            var c,
                d,
                e,
                f = this.key(a),
                g = this.cache[f];
            if (void 0 === b) this.cache[f] = {};else {
              B.isArray(b) ? d = b.concat(b.map(B.camelCase)) : (e = B.camelCase(b), b in g ? d = [b, e] : (d = e, d = d in g ? [d] : d.match(K) || [])), c = d.length;

              for (; c--;) {
                delete g[d[c]];
              }
            }
          },
          hasData: function hasData(a) {
            return !B.isEmptyObject(this.cache[a[this.expando]] || {});
          },
          discard: function discard(a) {
            a[this.expando] && delete this.cache[a[this.expando]];
          }
        };
        var O = new f(),
            P = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            Q = /([A-Z])/g;
        B.extend({
          hasData: function hasData(a) {
            return data_user.hasData(a) || O.hasData(a);
          },
          data: function data(a, b, c) {
            return data_user.access(a, b, c);
          },
          removeData: function removeData(a, b) {
            data_user.remove(a, b);
          },
          _data: function _data(a, b, c) {
            return O.access(a, b, c);
          },
          _removeData: function _removeData(a, b) {
            O.remove(a, b);
          }
        }), B.fn.extend({
          data: function data(a, b) {
            var c,
                d,
                e,
                f = this[0],
                h = f && f.attributes;

            if (void 0 === a) {
              if (this.length && (e = data_user.get(f), 1 === f.nodeType && !O.get(f, "hasDataAttrs"))) {
                for (c = h.length; c--;) {
                  h[c] && (d = h[c].name, 0 === d.indexOf("data-") && (d = B.camelCase(d.slice(5)), g(f, d, e[d])));
                }

                O.set(f, "hasDataAttrs", !0);
              }

              return e;
            }

            return "object" == _typeof2(a) ? this.each(function () {
              data_user.set(this, a);
            }) : N(this, function (b) {
              var c,
                  d = B.camelCase(a);

              if (f && void 0 === b) {
                if (c = data_user.get(f, a), void 0 !== c) return c;
                if (c = data_user.get(f, d), void 0 !== c) return c;
                if (c = g(f, d, void 0), void 0 !== c) return c;
              } else this.each(function () {
                var c = data_user.get(this, d);
                data_user.set(this, d, b), -1 !== a.indexOf("-") && void 0 !== c && data_user.set(this, a, b);
              });
            }, null, b, arguments.length > 1, null, !0);
          },
          removeData: function removeData(a) {
            return this.each(function () {
              data_user.remove(this, a);
            });
          }
        });
        var R = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, "undefined"),
            S = /^key/,
            T = /^(?:mouse|pointer|contextmenu)|click/,
            U = /^(?:focusinfocus|focusoutblur)$/,
            V = /^([^.]*)(?:\.(.+)|)$/;
        B.event = {
          global: {},
          add: function add(a, b, c, d, e) {
            var f,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q = O.get(a);
            if (q) for (c.handler && (f = c, c = f.handler, e = f.selector), c.guid || (c.guid = B.guid++), (i = q.events) || (i = q.events = {}), (g = q.handle) || (g = q.handle = function (b) {
              return _typeof2(B) !== R && B.event.triggered !== b.type ? B.event.dispatch.apply(a, arguments) : void 0;
            }), b = (b || "").match(K) || [""], j = b.length; j--;) {
              h = V.exec(b[j]) || [], n = p = h[1], o = (h[2] || "").split(".").sort(), n && (l = B.event.special[n] || {}, n = (e ? l.delegateType : l.bindType) || n, l = B.event.special[n] || {}, k = B.extend({
                type: n,
                origType: p,
                data: d,
                handler: c,
                guid: c.guid,
                selector: e,
                needsContext: e && B.expr.match.needsContext.test(e),
                namespace: o.join(".")
              }, f), (m = i[n]) || (m = i[n] = [], m.delegateCount = 0, l.setup && l.setup.call(a, d, o, g) !== !1 || a.addEventListener && a.addEventListener(n, g, !1)), l.add && (l.add.call(a, k), k.handler.guid || (k.handler.guid = c.guid)), e ? m.splice(m.delegateCount++, 0, k) : m.push(k), B.event.global[n] = !0);
            }
          },
          remove: function remove(a, b, c, d, e) {
            var f,
                g,
                h,
                i,
                j,
                k,
                l,
                m,
                n,
                o,
                p,
                q = O.hasData(a) && O.get(a);

            if (q && (i = q.events)) {
              for (b = (b || "").match(K) || [""], j = b.length; j--;) {
                if (h = V.exec(b[j]) || [], n = p = h[1], o = (h[2] || "").split(".").sort(), n) {
                  for (l = B.event.special[n] || {}, n = (d ? l.delegateType : l.bindType) || n, m = i[n] || [], h = h[2] && new RegExp("(^|\\.)" + o.join("\\.(?:.*\\.|)") + "(\\.|$)"), g = f = m.length; f--;) {
                    k = m[f], !e && p !== k.origType || c && c.guid !== k.guid || h && !h.test(k.namespace) || d && d !== k.selector && ("**" !== d || !k.selector) || (m.splice(f, 1), k.selector && m.delegateCount--, l.remove && l.remove.call(a, k));
                  }

                  g && !m.length && (l.teardown && l.teardown.call(a, o, q.handle) !== !1 || B.removeEvent(a, n, q.handle), delete i[n]);
                } else for (n in i) {
                  B.event.remove(a, n + b[j], c, d, !0);
                }
              }

              B.isEmptyObject(i) && (delete q.handle, O.remove(a, "events"));
            }
          },
          trigger: function trigger(b, c, d, e) {
            var f,
                g,
                h,
                i,
                j,
                k,
                l,
                m = [d || z],
                n = x.call(b, "type") ? b.type : b,
                o = x.call(b, "namespace") ? b.namespace.split(".") : [];

            if (g = h = d = d || z, 3 !== d.nodeType && 8 !== d.nodeType && !U.test(n + B.event.triggered) && (n.indexOf(".") >= 0 && (o = n.split("."), n = o.shift(), o.sort()), j = n.indexOf(":") < 0 && "on" + n, b = b[B.expando] ? b : new B.Event(n, "object" == _typeof2(b) && b), b.isTrigger = e ? 2 : 3, b.namespace = o.join("."), b.namespace_re = b.namespace ? new RegExp("(^|\\.)" + o.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = d), c = null == c ? [b] : B.makeArray(c, [b]), l = B.event.special[n] || {}, e || !l.trigger || l.trigger.apply(d, c) !== !1)) {
              if (!e && !l.noBubble && !B.isWindow(d)) {
                for (i = l.delegateType || n, U.test(i + n) || (g = g.parentNode); g; g = g.parentNode) {
                  m.push(g), h = g;
                }

                h === (d.ownerDocument || z) && m.push(h.defaultView || h.parentWindow || a);
              }

              for (f = 0; (g = m[f++]) && !b.isPropagationStopped();) {
                b.type = f > 1 ? i : l.bindType || n, k = (O.get(g, "events") || {})[b.type] && O.get(g, "handle"), k && k.apply(g, c), k = j && g[j], k && k.apply && B.acceptData(g) && (b.result = k.apply(g, c), b.result === !1 && b.preventDefault());
              }

              return b.type = n, e || b.isDefaultPrevented() || l._default && l._default.apply(m.pop(), c) !== !1 || !B.acceptData(d) || j && B.isFunction(d[n]) && !B.isWindow(d) && (h = d[j], h && (d[j] = null), B.event.triggered = n, d[n](), B.event.triggered = void 0, h && (d[j] = h)), b.result;
            }
          },
          dispatch: function dispatch(a) {
            a = B.event.fix(a);
            var b,
                c,
                d,
                e,
                f,
                g = [],
                h = r.call(arguments),
                i = (O.get(this, "events") || {})[a.type] || [],
                j = B.event.special[a.type] || {};

            if (h[0] = a, a.delegateTarget = this, !j.preDispatch || j.preDispatch.call(this, a) !== !1) {
              for (g = B.event.handlers.call(this, a, i), b = 0; (e = g[b++]) && !a.isPropagationStopped();) {
                for (a.currentTarget = e.elem, c = 0; (f = e.handlers[c++]) && !a.isImmediatePropagationStopped();) {
                  a.namespace_re && !a.namespace_re.test(f.namespace) || (a.handleObj = f, a.data = f.data, d = ((B.event.special[f.origType] || {}).handle || f.handler).apply(e.elem, h), void 0 !== d && (a.result = d) === !1 && (a.preventDefault(), a.stopPropagation()));
                }
              }

              return j.postDispatch && j.postDispatch.call(this, a), a.result;
            }
          },
          handlers: function handlers(a, b) {
            var c,
                d,
                e,
                f,
                g = [],
                h = b.delegateCount,
                i = a.target;
            if (h && i.nodeType && (!a.button || "click" !== a.type)) for (; i !== this; i = i.parentNode || this) {
              if (i.disabled !== !0 || "click" !== a.type) {
                for (d = [], c = 0; h > c; c++) {
                  f = b[c], e = f.selector + " ", void 0 === d[e] && (d[e] = f.needsContext ? B(e, this).index(i) >= 0 : B.find(e, this, null, [i]).length), d[e] && d.push(f);
                }

                d.length && g.push({
                  elem: i,
                  handlers: d
                });
              }
            }
            return h < b.length && g.push({
              elem: this,
              handlers: b.slice(h)
            }), g;
          },
          props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
          fixHooks: {},
          keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function filter(a, b) {
              return null == a.which && (a.which = null != b.charCode ? b.charCode : b.keyCode), a;
            }
          },
          mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function filter(a, b) {
              var c,
                  d,
                  e,
                  f = b.button;
              return null == a.pageX && null != b.clientX && (c = a.target.ownerDocument || z, d = c.documentElement, e = c.body, a.pageX = b.clientX + (d && d.scrollLeft || e && e.scrollLeft || 0) - (d && d.clientLeft || e && e.clientLeft || 0), a.pageY = b.clientY + (d && d.scrollTop || e && e.scrollTop || 0) - (d && d.clientTop || e && e.clientTop || 0)), a.which || void 0 === f || (a.which = 1 & f ? 1 : 2 & f ? 3 : 4 & f ? 2 : 0), a;
            }
          },
          fix: function fix(a) {
            if (a[B.expando]) return a;
            var b,
                c,
                d,
                e = a.type,
                f = a,
                g = this.fixHooks[e];

            for (g || (this.fixHooks[e] = g = T.test(e) ? this.mouseHooks : S.test(e) ? this.keyHooks : {}), d = g.props ? this.props.concat(g.props) : this.props, a = new B.Event(f), b = d.length; b--;) {
              c = d[b], a[c] = f[c];
            }

            return a.target || (a.target = z), 3 === a.target.nodeType && (a.target = a.target.parentNode), g.filter ? g.filter(a, f) : a;
          },
          special: {
            load: {
              noBubble: !0
            },
            focus: {
              trigger: function trigger() {
                return this !== j() && this.focus ? (this.focus(), !1) : void 0;
              },
              delegateType: "focusin"
            },
            blur: {
              trigger: function trigger() {
                return this === j() && this.blur ? (this.blur(), !1) : void 0;
              },
              delegateType: "focusout"
            },
            click: {
              trigger: function trigger() {
                return "checkbox" === this.type && this.click && B.nodeName(this, "input") ? (this.click(), !1) : void 0;
              },
              _default: function _default(a) {
                return B.nodeName(a.target, "a");
              }
            },
            beforeunload: {
              postDispatch: function postDispatch(a) {
                void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result);
              }
            }
          },
          simulate: function simulate(a, b, c, d) {
            var e = B.extend(new B.Event(), c, {
              type: a,
              isSimulated: !0,
              originalEvent: {}
            });
            d ? B.event.trigger(e, null, b) : B.event.dispatch.call(b, e), e.isDefaultPrevented() && c.preventDefault();
          }
        }, B.removeEvent = function (a, b, c) {
          a.removeEventListener && a.removeEventListener(b, c, !1);
        }, B.Event = function (a, b) {
          return this instanceof B.Event ? (a && a.type ? (this.originalEvent = a, this.type = a.type, this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? h : i) : this.type = a, b && B.extend(this, b), this.timeStamp = a && a.timeStamp || B.now(), void (this[B.expando] = !0)) : new B.Event(a, b);
        }, B.Event.prototype = {
          isDefaultPrevented: i,
          isPropagationStopped: i,
          isImmediatePropagationStopped: i,
          preventDefault: function preventDefault() {
            var a = this.originalEvent;
            this.isDefaultPrevented = h, a && a.preventDefault && a.preventDefault();
          },
          stopPropagation: function stopPropagation() {
            var a = this.originalEvent;
            this.isPropagationStopped = h, a && a.stopPropagation && a.stopPropagation();
          },
          stopImmediatePropagation: function stopImmediatePropagation() {
            var a = this.originalEvent;
            this.isImmediatePropagationStopped = h, a && a.stopImmediatePropagation && a.stopImmediatePropagation(), this.stopPropagation();
          }
        }, B.each({
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout"
        }, function (a, b) {
          B.event.special[a] = {
            delegateType: b,
            bindType: b,
            handle: function handle(a) {
              var c,
                  d = this,
                  e = a.relatedTarget,
                  f = a.handleObj;
              return e && (e === d || B.contains(d, e)) || (a.type = f.origType, c = f.handler.apply(this, arguments), a.type = b), c;
            }
          };
        }), y.focusinBubbles || B.each({
          focus: "focusin",
          blur: "focusout"
        }, function (a, b) {
          var c = function c(a) {
            B.event.simulate(b, a.target, B.event.fix(a), !0);
          };

          B.event.special[b] = {
            setup: function setup() {
              var d = this.ownerDocument || this,
                  e = O.access(d, b);
              e || d.addEventListener(a, c, !0), O.access(d, b, (e || 0) + 1);
            },
            teardown: function teardown() {
              var d = this.ownerDocument || this,
                  e = O.access(d, b) - 1;
              e ? O.access(d, b, e) : (d.removeEventListener(a, c, !0), O.remove(d, b));
            }
          };
        }), B.fn.extend({
          on: function on(a, b, c, d, e) {
            var f, g;

            if ("object" == _typeof2(a)) {
              "string" != typeof b && (c = c || b, b = void 0);

              for (g in a) {
                this.on(g, b, c, a[g], e);
              }

              return this;
            }

            if (null == c && null == d ? (d = b, c = b = void 0) : null == d && ("string" == typeof b ? (d = c, c = void 0) : (d = c, c = b, b = void 0)), d === !1) d = i;else if (!d) return this;
            return 1 === e && (f = d, d = function d(a) {
              return B().off(a), f.apply(this, arguments);
            }, d.guid = f.guid || (f.guid = B.guid++)), this.each(function () {
              B.event.add(this, a, d, c, b);
            });
          },
          one: function one(a, b, c, d) {
            return this.on(a, b, c, d, 1);
          },
          off: function off(a, b, c) {
            var d, e;
            if (a && a.preventDefault && a.handleObj) return d = a.handleObj, B(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler), this;

            if ("object" == _typeof2(a)) {
              for (e in a) {
                this.off(e, b, a[e]);
              }

              return this;
            }

            return b !== !1 && "function" != typeof b || (c = b, b = void 0), c === !1 && (c = i), this.each(function () {
              B.event.remove(this, a, c, b);
            });
          },
          trigger: function trigger(a, b) {
            return this.each(function () {
              B.event.trigger(a, b, this);
            });
          },
          triggerHandler: function triggerHandler(a, b) {
            var c = this[0];
            return c ? B.event.trigger(a, b, c, !0) : void 0;
          }
        });
        var W = B.now(),
            X = /\?/;
        B.parseJSON = function (a) {
          return JSON.parse(a + "");
        }, B.parseXML = function (a) {
          var b, c;
          if (!a || "string" != typeof a) return null;

          try {
            c = new DOMParser(), b = c.parseFromString(a, "text/xml");
          } catch (d) {
            b = void 0;
          }

          return b && !b.getElementsByTagName("parsererror").length || B.error("Invalid XML: " + a), b;
        };
        var Y,
            Z,
            $ = /#.*$/,
            _ = /([?&])_=[^&]*/,
            aa = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            ba = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
            ca = /^(?:GET|HEAD)$/,
            da = /^\/\//,
            ea = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
            fa = {},
            ga = {},
            ha = "*/".concat("*");

        try {
          Z = location.href;
        } catch (ia) {
          Z = z.createElement("a"), Z.href = "", Z = Z.href;
        }

        Y = ea.exec(Z.toLowerCase()) || [], B.extend({
          active: 0,
          lastModified: {},
          etag: {},
          ajaxSettings: {
            url: Z,
            type: "GET",
            isLocal: ba.test(Y[1]),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
              "*": ha,
              text: "text/plain",
              html: "text/html",
              xml: "application/xml, text/xml",
              json: "application/json, text/javascript"
            },
            contents: {
              xml: /xml/,
              html: /html/,
              json: /json/
            },
            responseFields: {
              xml: "responseXML",
              text: "responseText",
              json: "responseJSON"
            },
            converters: {
              "* text": String,
              "text html": !0,
              "text json": B.parseJSON,
              "text xml": B.parseXML
            },
            flatOptions: {
              url: !0,
              context: !0
            }
          },
          ajaxSetup: function ajaxSetup(a, b) {
            return b ? m(m(a, B.ajaxSettings), b) : m(B.ajaxSettings, a);
          },
          ajaxPrefilter: k(fa),
          ajaxTransport: k(ga),
          ajax: function ajax(a, b) {
            function c(a, b, c, g) {
              var i,
                  k,
                  l,
                  u,
                  v,
                  x = b;
              2 !== w && (w = 2, h && clearTimeout(h), d = void 0, f = g || "", y.readyState = a > 0 ? 4 : 0, i = a >= 200 && 300 > a || 304 === a, c && (u = n(m, y, c)), u = o(m, u, y, i), i ? (m.ifModified && (v = y.getResponseHeader("Last-Modified"), v && (B.lastModified[e] = v), v = y.getResponseHeader("etag"), v && (B.etag[e] = v)), 204 === a || "HEAD" === m.type ? x = "nocontent" : 304 === a ? x = "notmodified" : (x = u.state, k = u.data, l = u.error, i = !l)) : (l = x, !a && x || (x = "error", 0 > a && (a = 0))), y.status = a, y.statusText = (b || x) + "", i ? r.resolveWith(p, [k, x, y]) : r.rejectWith(p, [y, x, l]), y.statusCode(t), t = void 0, j && q.trigger(i ? "ajaxSuccess" : "ajaxError", [y, m, i ? k : l]), s.fireWith(p, [y, x]), j && (q.trigger("ajaxComplete", [y, m]), --B.active || B.event.trigger("ajaxStop")));
            }

            "object" == _typeof2(a) && (b = a, a = void 0), b = b || {};
            var d,
                e,
                f,
                g,
                h,
                i,
                j,
                k,
                m = B.ajaxSetup({}, b),
                p = m.context || m,
                q = m.context && (p.nodeType || p.jquery) ? B(p) : B.event,
                r = B.Deferred(),
                s = B.Callbacks("once memory"),
                t = m.statusCode || {},
                u = {},
                v = {},
                w = 0,
                x = "canceled",
                y = {
              readyState: 0,
              getResponseHeader: function getResponseHeader(a) {
                var b;

                if (2 === w) {
                  if (!g) for (g = {}; b = aa.exec(f);) {
                    g[b[1].toLowerCase()] = b[2];
                  }
                  b = g[a.toLowerCase()];
                }

                return null == b ? null : b;
              },
              getAllResponseHeaders: function getAllResponseHeaders() {
                return 2 === w ? f : null;
              },
              setRequestHeader: function setRequestHeader(a, b) {
                var c = a.toLowerCase();
                return w || (a = v[c] = v[c] || a, u[a] = b), this;
              },
              overrideMimeType: function overrideMimeType(a) {
                return w || (m.mimeType = a), this;
              },
              statusCode: function statusCode(a) {
                var b;
                if (a) if (2 > w) for (b in a) {
                  t[b] = [t[b], a[b]];
                } else y.always(a[y.status]);
                return this;
              },
              abort: function abort(a) {
                var b = a || x;
                return d && d.abort(b), c(0, b), this;
              }
            };
            if (r.promise(y).complete = s.add, y.success = y.done, y.error = y.fail, m.url = ((a || m.url || Z) + "").replace($, "").replace(da, Y[1] + "//"), m.type = b.method || b.type || m.method || m.type, m.dataTypes = B.trim(m.dataType || "*").toLowerCase().match(K) || [""], null == m.crossDomain && (i = ea.exec(m.url.toLowerCase()), m.crossDomain = !(!i || i[1] === Y[1] && i[2] === Y[2] && (i[3] || ("http:" === i[1] ? "80" : "443")) === (Y[3] || ("http:" === Y[1] ? "80" : "443")))), m.data && m.processData && "string" != typeof m.data && (m.data = B.param(m.data, m.traditional)), l(fa, m, b, y), 2 === w) return y;
            j = m.global, j && 0 === B.active++ && B.event.trigger("ajaxStart"), m.type = m.type.toUpperCase(), m.hasContent = !ca.test(m.type), e = m.url, m.hasContent || (m.data && (e = m.url += (X.test(e) ? "&" : "?") + m.data, delete m.data), m.cache === !1 && (m.url = _.test(e) ? e.replace(_, "$1_=" + W++) : e + (X.test(e) ? "&" : "?") + "_=" + W++)), m.ifModified && (B.lastModified[e] && y.setRequestHeader("If-Modified-Since", B.lastModified[e]), B.etag[e] && y.setRequestHeader("If-None-Match", B.etag[e])), (m.data && m.hasContent && m.contentType !== !1 || b.contentType) && y.setRequestHeader("Content-Type", m.contentType), y.setRequestHeader("Accept", m.dataTypes[0] && m.accepts[m.dataTypes[0]] ? m.accepts[m.dataTypes[0]] + ("*" !== m.dataTypes[0] ? ", " + ha + "; q=0.01" : "") : m.accepts["*"]);

            for (k in m.headers) {
              y.setRequestHeader(k, m.headers[k]);
            }

            if (m.beforeSend && (m.beforeSend.call(p, y, m) === !1 || 2 === w)) return y.abort();
            x = "abort";

            for (k in {
              success: 1,
              error: 1,
              complete: 1
            }) {
              y[k](m[k]);
            }

            if (d = l(ga, m, b, y)) {
              y.readyState = 1, j && q.trigger("ajaxSend", [y, m]), m.async && m.timeout > 0 && (h = setTimeout(function () {
                y.abort("timeout");
              }, m.timeout));

              try {
                w = 1, d.send(u, c);
              } catch (z) {
                if (!(2 > w)) throw z;
                c(-1, z);
              }
            } else c(-1, "No Transport");

            return y;
          },
          getJSON: function getJSON(a, b, c) {
            return B.get(a, b, c, "json");
          },
          getScript: function getScript(a, b) {
            return B.get(a, void 0, b, "script");
          }
        }), B.each(["get", "post"], function (a, b) {
          B[b] = function (a, c, d, e) {
            return B.isFunction(c) && (e = e || d, d = c, c = void 0), B.ajax({
              url: a,
              type: b,
              dataType: e,
              data: c,
              success: d
            });
          };
        }), B.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (a, b) {
          B.fn[b] = function (a) {
            return this.on(b, a);
          };
        });
        var ja = /%20/g,
            ka = /\[\]$/,
            la = /\r?\n/g,
            ma = /^(?:submit|button|image|reset|file)$/i,
            na = /^(?:input|select|textarea|keygen)/i;
        B.param = function (a, b) {
          var c,
              d = [],
              e = function e(a, b) {
            b = B.isFunction(b) ? b() : null == b ? "" : b, d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b);
          };

          if (void 0 === b && (b = B.ajaxSettings && B.ajaxSettings.traditional), B.isArray(a) || a.jquery && !B.isPlainObject(a)) B.each(a, function () {
            e(this.name, this.value);
          });else for (c in a) {
            p(c, a[c], b, e);
          }
          return d.join("&").replace(ja, "+");
        }, B.fn.extend({
          serialize: function serialize() {
            return B.param(this.serializeArray());
          },
          serializeArray: function serializeArray() {
            return this.map(function () {
              var a = B.prop(this, "elements");
              return a ? B.makeArray(a) : this;
            }).filter(function () {
              var a = this.type;
              return this.name && !B(this).is(":disabled") && na.test(this.nodeName) && !ma.test(a) && (this.checked || !rcheckableType.test(a));
            }).map(function (a, b) {
              var c = B(this).val();
              return null == c ? null : B.isArray(c) ? B.map(c, function (a) {
                return {
                  name: b.name,
                  value: a.replace(la, "\r\n")
                };
              }) : {
                name: b.name,
                value: c.replace(la, "\r\n")
              };
            }).get();
          }
        }), B.ajaxSettings.xhr = function () {
          try {
            return new XMLHttpRequest();
          } catch (a) {}
        };
        var oa = 0,
            pa = {},
            qa = {
          0: 200,
          1223: 204
        },
            ra = B.ajaxSettings.xhr();
        a.ActiveXObject && B(a).on("unload", function () {
          for (var a in pa) {
            pa[a]();
          }
        }), y.cors = !!ra && "withCredentials" in ra, y.ajax = ra = !!ra, B.ajaxTransport(function (a) {
          var _b2;

          return y.cors || ra && !a.crossDomain ? {
            send: function send(c, d) {
              var e,
                  f = a.xhr(),
                  g = ++oa;
              if (f.open(a.type, a.url, a.async, a.username, a.password), a.xhrFields) for (e in a.xhrFields) {
                f[e] = a.xhrFields[e];
              }
              a.mimeType && f.overrideMimeType && f.overrideMimeType(a.mimeType), a.crossDomain || c["X-Requested-With"] || (c["X-Requested-With"] = "XMLHttpRequest");

              for (e in c) {
                f.setRequestHeader(e, c[e]);
              }

              _b2 = function b(a) {
                return function () {
                  _b2 && (delete pa[g], _b2 = f.onload = f.onerror = null, "abort" === a ? f.abort() : "error" === a ? d(f.status, f.statusText) : d(qa[f.status] || f.status, f.statusText, "string" == typeof f.responseText ? {
                    text: f.responseText
                  } : void 0, f.getAllResponseHeaders()));
                };
              }, f.onload = _b2(), f.onerror = _b2("error"), _b2 = pa[g] = _b2("abort");

              try {
                f.send(a.hasContent && a.data || null);
              } catch (h) {
                if (_b2) throw h;
              }
            },
            abort: function abort() {
              _b2 && _b2();
            }
          } : void 0;
        }), B.ajaxSetup({
          accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
          },
          contents: {
            script: /(?:java|ecma)script/
          },
          converters: {
            "text script": function textScript(a) {
              return B.globalEval(a), a;
            }
          }
        }), B.ajaxPrefilter("script", function (a) {
          void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = "GET");
        }), B.ajaxTransport("script", function (a) {
          if (a.crossDomain) {
            var b, _c;

            return {
              send: function send(d, e) {
                b = B("<script>").prop({
                  async: !0,
                  charset: a.scriptCharset,
                  src: a.url
                }).on("load error", _c = function c(a) {
                  b.remove(), _c = null, a && e("error" === a.type ? 404 : 200, a.type);
                }), z.head.appendChild(b[0]);
              },
              abort: function abort() {
                _c && _c();
              }
            };
          }
        });
        var sa = [],
            ta = /(=)\?(?=&|$)|\?\?/;
        B.ajaxSetup({
          jsonp: "callback",
          jsonpCallback: function jsonpCallback() {
            var a = sa.pop() || B.expando + "_" + W++;
            return this[a] = !0, a;
          }
        }), B.ajaxPrefilter("json jsonp", function (b, c, d) {
          var e,
              f,
              g,
              h = b.jsonp !== !1 && (ta.test(b.url) ? "url" : "string" == typeof b.data && !(b.contentType || "").indexOf("application/x-www-form-urlencoded") && ta.test(b.data) && "data");
          return h || "jsonp" === b.dataTypes[0] ? (e = b.jsonpCallback = B.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, h ? b[h] = b[h].replace(ta, "$1" + e) : b.jsonp !== !1 && (b.url += (X.test(b.url) ? "&" : "?") + b.jsonp + "=" + e), b.converters["script json"] = function () {
            return g || B.error(e + " was not called"), g[0];
          }, b.dataTypes[0] = "json", f = a[e], a[e] = function () {
            g = arguments;
          }, d.always(function () {
            a[e] = f, b[e] && (b.jsonpCallback = c.jsonpCallback, sa.push(e)), g && B.isFunction(f) && f(g[0]), g = f = void 0;
          }), "script") : void 0;
        }), B.parseHTML = function (a, b, c) {
          if (!a || "string" != typeof a) return null;
          "boolean" == typeof b && (c = b, b = !1), b = b || z;
          var d = H.exec(a),
              e = !c && [];
          return d ? [b.createElement(d[1])] : (d = B.buildFragment([a], b, e), e && e.length && B(e).remove(), B.merge([], d.childNodes));
        };
        var ua = B.fn.load;
        return B.fn.load = function (a, b, c) {
          if ("string" != typeof a && ua) return ua.apply(this, arguments);
          var d,
              e,
              f,
              g = this,
              h = a.indexOf(" ");
          return h >= 0 && (d = B.trim(a.slice(h)), a = a.slice(0, h)), B.isFunction(b) ? (c = b, b = void 0) : b && "object" == _typeof2(b) && (e = "POST"), g.length > 0 && B.ajax({
            url: a,
            type: e,
            dataType: "html",
            data: b
          }).done(function (a) {
            f = arguments, g.html(d ? B("<div>").append(B.parseHTML(a)).find(d) : a);
          }).complete(c && function (a, b) {
            g.each(c, f || [a.responseText, b, a]);
          }), this;
        }, B.noConflict = function () {}, B;
      });
    }, {}],
    12: [function (a, b, c) {
      "use strict";

      b.exports = function (a) {
        return {
          reload: function reload() {
            return a.location.reload();
          },
          getHash: function getHash() {
            return a.location.hash;
          },
          setHash: function setHash(b) {
            return a.location.hash = b;
          },
          changeHref: function changeHref(b) {
            return a.location.href = b;
          }
        };
      };
    }, {}],
    13: [function (a, b, c) {
      "use strict";

      var d;
      d = function d(a) {
        var b;
        return b = localStorage.getItem("oauthio_cache"), b = b ? JSON.parse(b) : {}, a(b, function () {
          return localStorage.setItem("oauthio_cache", JSON.stringify(b));
        });
      }, b.exports = {
        init: function init(a, b) {
          return this.config = a, this.document = b;
        },
        active: function active() {
          return "undefined" != typeof localStorage && null !== localStorage;
        },
        create: function create(a, b, c) {
          var e;
          this.erase(a), e = new Date(), localStorage.setItem(a, b), d(function (b, d) {
            return b[a] = c ? e.getTime() + 1e3 * (c || 1200) : !1, d();
          });
        },
        read: function read(a) {
          return d(function (b, c) {
            return null == b[a] ? null : b[a] === !1 ? localStorage.getItem(a) : new Date().getTime() > b[a] ? (localStorage.removeItem(a), delete b[a], c(), null) : localStorage.getItem(a);
          });
        },
        erase: function erase(a) {
          return d(function (b, c) {
            return localStorage.removeItem(a), delete b[a], c();
          });
        },
        eraseFrom: function eraseFrom(a) {
          d(function (b, c) {
            var d, e, f, g;

            for (d = Object.keys(b), e = 0, f = d.length; f > e; e++) {
              g = d[e], g.substr(0, a.length) === a && (localStorage.removeItem(g), delete b[g]);
            }

            return c();
          });
        }
      };
    }, {}],
    14: [function (a, b, c) {
      var d, e;
      e = 0, d = "", b.exports = {
        hex_sha1: function hex_sha1(a) {
          return this.rstr2hex(this.rstr_sha1(this.str2rstr_utf8(a)));
        },
        b64_sha1: function b64_sha1(a) {
          return this.rstr2b64(this.rstr_sha1(this.str2rstr_utf8(a)));
        },
        any_sha1: function any_sha1(a, b) {
          return this.rstr2any(this.rstr_sha1(this.str2rstr_utf8(a)), b);
        },
        hex_hmac_sha1: function hex_hmac_sha1(a, b) {
          return this.rstr2hex(this.rstr_hmac_sha1(this.str2rstr_utf8(a), this.str2rstr_utf8(b)));
        },
        b64_hmac_sha1: function b64_hmac_sha1(a, b) {
          return this.rstr2b64(this.rstr_hmac_sha1(this.str2rstr_utf8(a), this.str2rstr_utf8(b)));
        },
        any_hmac_sha1: function any_hmac_sha1(a, b, c) {
          return this.rstr2any(this.rstr_hmac_sha1(this.str2rstr_utf8(a), this.str2rstr_utf8(b)), c);
        },
        sha1_vm_test: function sha1_vm_test() {
          return "a9993e364706816aba3e25717850c26c9cd0d89d" === thishex_sha1("abc").toLowerCase();
        },
        rstr_sha1: function rstr_sha1(a) {
          return this.binb2rstr(this.binb_sha1(this.rstr2binb(a), 8 * a.length));
        },
        rstr_hmac_sha1: function rstr_hmac_sha1(a, b) {
          var c, d, e, f, g;

          for (c = this.rstr2binb(a), c.length > 16 && (c = this.binb_sha1(c, 8 * a.length)), f = Array(16), g = Array(16), e = 0; 16 > e;) {
            f[e] = 909522486 ^ c[e], g[e] = 1549556828 ^ c[e], e++;
          }

          return d = this.binb_sha1(f.concat(this.rstr2binb(b)), 512 + 8 * b.length), this.binb2rstr(this.binb_sha1(g.concat(d), 672));
        },
        rstr2hex: function rstr2hex(a) {
          var b, c, d, f, g;

          try {} catch (h) {
            b = h, e = 0;
          }

          for (c = e ? "0123456789ABCDEF" : "0123456789abcdef", f = "", g = void 0, d = 0; d < a.length;) {
            g = a.charCodeAt(d), f += c.charAt(g >>> 4 & 15) + c.charAt(15 & g), d++;
          }

          return f;
        },
        rstr2b64: function rstr2b64(a) {
          var b, c, e, f, g, h, i;

          try {} catch (j) {
            b = j, d = "";
          }

          for (h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", g = "", f = a.length, c = 0; f > c;) {
            for (i = a.charCodeAt(c) << 16 | (f > c + 1 ? a.charCodeAt(c + 1) << 8 : 0) | (f > c + 2 ? a.charCodeAt(c + 2) : 0), e = 0; 4 > e;) {
              g += 8 * c + 6 * e > 8 * a.length ? d : h.charAt(i >>> 6 * (3 - e) & 63), e++;
            }

            c += 3;
          }

          return g;
        },
        rstr2any: function rstr2any(a, b) {
          var c, d, e, f, g, h, i, j, k;

          for (d = b.length, j = Array(), f = void 0, h = void 0, k = void 0, i = void 0, c = Array(Math.ceil(a.length / 2)), f = 0; f < c.length;) {
            c[f] = a.charCodeAt(2 * f) << 8 | a.charCodeAt(2 * f + 1), f++;
          }

          for (; c.length > 0;) {
            for (i = Array(), k = 0, f = 0; f < c.length;) {
              k = (k << 16) + c[f], h = Math.floor(k / d), k -= h * d, (i.length > 0 || h > 0) && (i[i.length] = h), f++;
            }

            j[j.length] = k, c = i;
          }

          for (g = "", f = j.length - 1; f >= 0;) {
            g += b.charAt(j[f]), f--;
          }

          for (e = Math.ceil(8 * a.length / (Math.log(b.length) / Math.log(2))), f = g.length; e > f;) {
            g = b[0] + g, f++;
          }

          return g;
        },
        str2rstr_utf8: function str2rstr_utf8(a) {
          var b, c, d, e;

          for (c = "", b = -1, d = void 0, e = void 0; ++b < a.length;) {
            d = a.charCodeAt(b), e = b + 1 < a.length ? a.charCodeAt(b + 1) : 0, d >= 55296 && 56319 >= d && e >= 56320 && 57343 >= e && (d = 65536 + ((1023 & d) << 10) + (1023 & e), b++), 127 >= d ? c += String.fromCharCode(d) : 2047 >= d ? c += String.fromCharCode(192 | d >>> 6 & 31, 128 | 63 & d) : 65535 >= d ? c += String.fromCharCode(224 | d >>> 12 & 15, 128 | d >>> 6 & 63, 128 | 63 & d) : 2097151 >= d && (c += String.fromCharCode(240 | d >>> 18 & 7, 128 | d >>> 12 & 63, 128 | d >>> 6 & 63, 128 | 63 & d));
          }

          return c;
        },
        str2rstr_utf16le: function str2rstr_utf16le(a) {
          var b, c;

          for (c = "", b = 0; b < a.length;) {
            c += String.fromCharCode(255 & a.charCodeAt(b), a.charCodeAt(b) >>> 8 & 255), b++;
          }

          return c;
        },
        str2rstr_utf16be: function str2rstr_utf16be(a) {
          var b, c;

          for (c = "", b = 0; b < a.length;) {
            c += String.fromCharCode(a.charCodeAt(b) >>> 8 & 255, 255 & a.charCodeAt(b)), b++;
          }

          return c;
        },
        rstr2binb: function rstr2binb(a) {
          var b, c;

          for (c = Array(a.length >> 2), b = 0; b < c.length;) {
            c[b] = 0, b++;
          }

          for (b = 0; b < 8 * a.length;) {
            c[b >> 5] |= (255 & a.charCodeAt(b / 8)) << 24 - b % 32, b += 8;
          }

          return c;
        },
        binb2rstr: function binb2rstr(a) {
          var b, c;

          for (c = "", b = 0; b < 32 * a.length;) {
            c += String.fromCharCode(a[b >> 5] >>> 24 - b % 32 & 255), b += 8;
          }

          return c;
        },
        binb_sha1: function binb_sha1(a, b) {
          var c, d, e, f, g, h, i, j, k, l, m, n, o, p;

          for (a[b >> 5] |= 128 << 24 - b % 32, a[(b + 64 >> 9 << 4) + 15] = b, p = Array(80), c = 1732584193, d = -271733879, e = -1732584194, f = 271733878, g = -1009589776, h = 0; h < a.length;) {
            for (j = c, k = d, l = e, m = f, n = g, i = 0; 80 > i;) {
              16 > i ? p[i] = a[h + i] : p[i] = this.bit_rol(p[i - 3] ^ p[i - 8] ^ p[i - 14] ^ p[i - 16], 1), o = this.safe_add(this.safe_add(this.bit_rol(c, 5), this.sha1_ft(i, d, e, f)), this.safe_add(this.safe_add(g, p[i]), this.sha1_kt(i))), g = f, f = e, e = this.bit_rol(d, 30), d = c, c = o, i++;
            }

            c = this.safe_add(c, j), d = this.safe_add(d, k), e = this.safe_add(e, l), f = this.safe_add(f, m), g = this.safe_add(g, n), h += 16;
          }

          return Array(c, d, e, f, g);
        },
        sha1_ft: function sha1_ft(a, b, c, d) {
          return 20 > a ? b & c | ~b & d : 40 > a ? b ^ c ^ d : 60 > a ? b & c | b & d | c & d : b ^ c ^ d;
        },
        sha1_kt: function sha1_kt(a) {
          return 20 > a ? 1518500249 : 40 > a ? 1859775393 : 60 > a ? -1894007588 : -899497514;
        },
        safe_add: function safe_add(a, b) {
          var c, d;
          return c = (65535 & a) + (65535 & b), d = (a >> 16) + (b >> 16) + (c >> 16), d << 16 | 65535 & c;
        },
        bit_rol: function bit_rol(a, b) {
          return a << b | a >>> 32 - b;
        },
        create_hash: function create_hash() {
          var a;
          return a = this.b64_sha1(new Date().getTime() + ":" + Math.floor(9999999 * Math.random())), a.replace(/\+/g, "-").replace(/\//g, "_").replace(/\=+$/, "");
        }
      };
    }, {}],
    15: [function (a, b, c) {
      b.exports = function (a) {
        return {
          getAbsUrl: function getAbsUrl(b) {
            var c;
            return b.match(/^.{2,5}:\/\//) ? b : "/" === b[0] ? a.location.protocol + "//" + a.location.host + b : (c = a.location.protocol + "//" + a.location.host + a.location.pathname, "/" !== c[c.length - 1] && "#" !== b[0] ? c + "/" + b : c + b);
          },
          replaceParam: function replaceParam(a, b, c) {
            return a = a.replace(/\{\{(.*?)\}\}/g, function (a, c) {
              return b[c] || "";
            }), c && (a = a.replace(/\{(.*?)\}/g, function (a, b) {
              return c[b] || "";
            })), a;
          }
        };
      };
    }, {}]
  }, {}, [8])(8);
});
/*!
 * imagesLoaded PACKAGED v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

!function (e, t) {
  "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = t() : e.EvEmitter = t();
}("undefined" != typeof window ? window : this, function () {
  function e() {}

  var t = e.prototype;
  return t.on = function (e, t) {
    if (e && t) {
      var i = this._events = this._events || {},
          n = i[e] = i[e] || [];
      return n.indexOf(t) == -1 && n.push(t), this;
    }
  }, t.once = function (e, t) {
    if (e && t) {
      this.on(e, t);
      var i = this._onceEvents = this._onceEvents || {},
          n = i[e] = i[e] || {};
      return n[t] = !0, this;
    }
  }, t.off = function (e, t) {
    var i = this._events && this._events[e];

    if (i && i.length) {
      var n = i.indexOf(t);
      return n != -1 && i.splice(n, 1), this;
    }
  }, t.emitEvent = function (e, t) {
    var i = this._events && this._events[e];

    if (i && i.length) {
      i = i.slice(0), t = t || [];

      for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
        var r = i[o],
            s = n && n[r];
        s && (this.off(e, r), delete n[r]), r.apply(this, t);
      }

      return this;
    }
  }, t.allOff = function () {
    delete this._events, delete this._onceEvents;
  }, e;
}), function (e, t) {
  "use strict";

  "function" == typeof define && define.amd ? define(["ev-emitter/ev-emitter"], function (i) {
    return t(e, i);
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof2(module)) && module.exports ? module.exports = t(e, require("ev-emitter")) : e.imagesLoaded = t(e, e.EvEmitter);
}("undefined" != typeof window ? window : this, function (e, t) {
  function i(e, t) {
    for (var i in t) {
      e[i] = t[i];
    }

    return e;
  }

  function n(e) {
    if (Array.isArray(e)) return e;
    var t = "object" == _typeof2(e) && "number" == typeof e.length;
    return t ? d.call(e) : [e];
  }

  function o(e, t, r) {
    if (!(this instanceof o)) return new o(e, t, r);
    var s = e;
    return "string" == typeof e && (s = document.querySelectorAll(e)), s ? (this.elements = n(s), this.options = i({}, this.options), "function" == typeof t ? r = t : i(this.options, t), r && this.on("always", r), this.getImages(), h && (this.jqDeferred = new h.Deferred()), void setTimeout(this.check.bind(this))) : void a.error("Bad element for imagesLoaded " + (s || e));
  }

  function r(e) {
    this.img = e;
  }

  function s(e, t) {
    this.url = e, this.element = t, this.img = new Image();
  }

  var h = e.jQuery,
      a = e.console,
      d = Array.prototype.slice;
  o.prototype = Object.create(t.prototype), o.prototype.options = {}, o.prototype.getImages = function () {
    this.images = [], this.elements.forEach(this.addElementImages, this);
  }, o.prototype.addElementImages = function (e) {
    "IMG" == e.nodeName && this.addImage(e), this.options.background === !0 && this.addElementBackgroundImages(e);
    var t = e.nodeType;

    if (t && u[t]) {
      for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
        var o = i[n];
        this.addImage(o);
      }

      if ("string" == typeof this.options.background) {
        var r = e.querySelectorAll(this.options.background);

        for (n = 0; n < r.length; n++) {
          var s = r[n];
          this.addElementBackgroundImages(s);
        }
      }
    }
  };
  var u = {
    1: !0,
    9: !0,
    11: !0
  };
  return o.prototype.addElementBackgroundImages = function (e) {
    var t = getComputedStyle(e);
    if (t) for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n;) {
      var o = n && n[2];
      o && this.addBackground(o, e), n = i.exec(t.backgroundImage);
    }
  }, o.prototype.addImage = function (e) {
    var t = new r(e);
    this.images.push(t);
  }, o.prototype.addBackground = function (e, t) {
    var i = new s(e, t);
    this.images.push(i);
  }, o.prototype.check = function () {
    function e(e, i, n) {
      setTimeout(function () {
        t.progress(e, i, n);
      });
    }

    var t = this;
    return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function (t) {
      t.once("progress", e), t.check();
    }) : void this.complete();
  }, o.prototype.progress = function (e, t, i) {
    this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded, this.emitEvent("progress", [this, e, t]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e), this.progressedCount == this.images.length && this.complete(), this.options.debug && a && a.log("progress: " + i, e, t);
  }, o.prototype.complete = function () {
    var e = this.hasAnyBroken ? "fail" : "done";

    if (this.isComplete = !0, this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
      var t = this.hasAnyBroken ? "reject" : "resolve";
      this.jqDeferred[t](this);
    }
  }, r.prototype = Object.create(t.prototype), r.prototype.check = function () {
    var e = this.getIsImageComplete();
    return e ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image(), this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void (this.proxyImage.src = this.img.src));
  }, r.prototype.getIsImageComplete = function () {
    return this.img.complete && this.img.naturalWidth;
  }, r.prototype.confirm = function (e, t) {
    this.isLoaded = e, this.emitEvent("progress", [this, this.img, t]);
  }, r.prototype.handleEvent = function (e) {
    var t = "on" + e.type;
    this[t] && this[t](e);
  }, r.prototype.onload = function () {
    this.confirm(!0, "onload"), this.unbindEvents();
  }, r.prototype.onerror = function () {
    this.confirm(!1, "onerror"), this.unbindEvents();
  }, r.prototype.unbindEvents = function () {
    this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
  }, s.prototype = Object.create(r.prototype), s.prototype.check = function () {
    this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url;
    var e = this.getIsImageComplete();
    e && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
  }, s.prototype.unbindEvents = function () {
    this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
  }, s.prototype.confirm = function (e, t) {
    this.isLoaded = e, this.emitEvent("progress", [this, this.element, t]);
  }, o.makeJQueryPlugin = function (t) {
    t = t || e.jQuery, t && (h = t, h.fn.imagesLoaded = function (e, t) {
      var i = new o(this, e, t);
      return i.jqDeferred.promise(h(this));
    });
  }, o.makeJQueryPlugin(), o;
});
/*
    jQuery Masked Input Plugin
    Copyright (c) 2007 - 2015 Josh Bush (digitalbush.com)
    Licensed under the MIT license (http://digitalbush.com/projects/masked-input-plugin/#license)
    Version: 1.4.1
*/

!function (a) {
  "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) ? require("jquery") : jQuery);
}(function (a) {
  var b,
      c = navigator.userAgent,
      d = /iphone/i.test(c),
      e = /chrome/i.test(c),
      f = /android/i.test(c);
  a.mask = {
    definitions: {
      9: "[0-9]",
      a: "[A-Za-z]",
      "*": "[A-Za-z0-9]"
    },
    autoclear: !0,
    dataName: "rawMaskFn",
    placeholder: "_"
  }, a.fn.extend({
    caret: function caret(a, b) {
      var c;
      if (0 !== this.length && !this.is(":hidden")) return "number" == typeof a ? (b = "number" == typeof b ? b : a, this.each(function () {
        this.setSelectionRange ? this.setSelectionRange(a, b) : this.createTextRange && (c = this.createTextRange(), c.collapse(!0), c.moveEnd("character", b), c.moveStart("character", a), c.select());
      })) : (this[0].setSelectionRange ? (a = this[0].selectionStart, b = this[0].selectionEnd) : document.selection && document.selection.createRange && (c = document.selection.createRange(), a = 0 - c.duplicate().moveStart("character", -1e5), b = a + c.text.length), {
        begin: a,
        end: b
      });
    },
    unmask: function unmask() {
      return this.trigger("unmask");
    },
    mask: function mask(c, g) {
      var h, i, j, k, l, m, n, o;

      if (!c && this.length > 0) {
        h = a(this[0]);
        var p = h.data(a.mask.dataName);
        return p ? p() : void 0;
      }

      return g = a.extend({
        autoclear: a.mask.autoclear,
        placeholder: a.mask.placeholder,
        completed: null
      }, g), i = a.mask.definitions, j = [], k = n = c.length, l = null, a.each(c.split(""), function (a, b) {
        "?" == b ? (n--, k = a) : i[b] ? (j.push(new RegExp(i[b])), null === l && (l = j.length - 1), k > a && (m = j.length - 1)) : j.push(null);
      }), this.trigger("unmask").each(function () {
        function h() {
          if (g.completed) {
            for (var a = l; m >= a; a++) {
              if (j[a] && C[a] === p(a)) return;
            }

            g.completed.call(B);
          }
        }

        function p(a) {
          return g.placeholder.charAt(a < g.placeholder.length ? a : 0);
        }

        function q(a) {
          for (; ++a < n && !j[a];) {
            ;
          }

          return a;
        }

        function r(a) {
          for (; --a >= 0 && !j[a];) {
            ;
          }

          return a;
        }

        function s(a, b) {
          var c, d;

          if (!(0 > a)) {
            for (c = a, d = q(b); n > c; c++) {
              if (j[c]) {
                if (!(n > d && j[c].test(C[d]))) break;
                C[c] = C[d], C[d] = p(d), d = q(d);
              }
            }

            z(), B.caret(Math.max(l, a));
          }
        }

        function t(a) {
          var b, c, d, e;

          for (b = a, c = p(a); n > b; b++) {
            if (j[b]) {
              if (d = q(b), e = C[b], C[b] = c, !(n > d && j[d].test(e))) break;
              c = e;
            }
          }
        }

        function u() {
          var a = B.val(),
              b = B.caret();

          if (o && o.length && o.length > a.length) {
            for (A(!0); b.begin > 0 && !j[b.begin - 1];) {
              b.begin--;
            }

            if (0 === b.begin) for (; b.begin < l && !j[b.begin];) {
              b.begin++;
            }
            B.caret(b.begin, b.begin);
          } else {
            for (A(!0); b.begin < n && !j[b.begin];) {
              b.begin++;
            }

            B.caret(b.begin, b.begin);
          }

          h();
        }

        function v() {
          A(), B.val() != E && B.change();
        }

        function w(a) {
          if (!B.prop("readonly")) {
            var b,
                c,
                e,
                f = a.which || a.keyCode;
            o = B.val(), 8 === f || 46 === f || d && 127 === f ? (b = B.caret(), c = b.begin, e = b.end, e - c === 0 && (c = 46 !== f ? r(c) : e = q(c - 1), e = 46 === f ? q(e) : e), y(c, e), s(c, e - 1), a.preventDefault()) : 13 === f ? v.call(this, a) : 27 === f && (B.val(E), B.caret(0, A()), a.preventDefault());
          }
        }

        function x(b) {
          if (!B.prop("readonly")) {
            var c,
                d,
                e,
                g = b.which || b.keyCode,
                i = B.caret();

            if (!(b.ctrlKey || b.altKey || b.metaKey || 32 > g) && g && 13 !== g) {
              if (i.end - i.begin !== 0 && (y(i.begin, i.end), s(i.begin, i.end - 1)), c = q(i.begin - 1), n > c && (d = String.fromCharCode(g), j[c].test(d))) {
                if (t(c), C[c] = d, z(), e = q(c), f) {
                  var k = function k() {
                    a.proxy(a.fn.caret, B, e)();
                  };

                  setTimeout(k, 0);
                } else B.caret(e);

                i.begin <= m && h();
              }

              b.preventDefault();
            }
          }
        }

        function y(a, b) {
          var c;

          for (c = a; b > c && n > c; c++) {
            j[c] && (C[c] = p(c));
          }
        }

        function z() {
          B.val(C.join(""));
        }

        function A(a) {
          var b,
              c,
              d,
              e = B.val(),
              f = -1;

          for (b = 0, d = 0; n > b; b++) {
            if (j[b]) {
              for (C[b] = p(b); d++ < e.length;) {
                if (c = e.charAt(d - 1), j[b].test(c)) {
                  C[b] = c, f = b;
                  break;
                }
              }

              if (d > e.length) {
                y(b + 1, n);
                break;
              }
            } else C[b] === e.charAt(d) && d++, k > b && (f = b);
          }

          return a ? z() : k > f + 1 ? g.autoclear || C.join("") === D ? (B.val() && B.val(""), y(0, n)) : z() : (z(), B.val(B.val().substring(0, f + 1))), k ? b : l;
        }

        var B = a(this),
            C = a.map(c.split(""), function (a, b) {
          return "?" != a ? i[a] ? p(b) : a : void 0;
        }),
            D = C.join(""),
            E = B.val();
        B.data(a.mask.dataName, function () {
          return a.map(C, function (a, b) {
            return j[b] && a != p(b) ? a : null;
          }).join("");
        }), B.one("unmask", function () {
          B.off(".mask").removeData(a.mask.dataName);
        }).on("focus.mask", function () {
          if (!B.prop("readonly")) {
            clearTimeout(b);
            var a;
            E = B.val(), a = A(), b = setTimeout(function () {
              B.get(0) === document.activeElement && (z(), a == c.replace("?", "").length ? B.caret(0, a) : B.caret(a));
            }, 10);
          }
        }).on("blur.mask", v).on("keydown.mask", w).on("keypress.mask", x).on("input.mask paste.mask", function () {
          B.prop("readonly") || setTimeout(function () {
            var a = A(!0);
            B.caret(a), h();
          }, 0);
        }), e && f && B.off("input.mask").on("input.mask", u), A();
      });
    }
  });
});
/**
 * jQuery Editable Select
 * Indri Muska <indrimuska@gmail.com>
 *
 * Source on GitHub @ https://github.com/indrimuska/jquery-editable-select
 */

+function ($) {
  // jQuery Editable Select
  EditableSelect = function EditableSelect(select, options) {
    var that = this;
    this.options = options;
    this.$select = $(select);
    this.$input = $('<input type="text" autocomplete="off">');
    this.$list = $('<ul class="es-list">');
    this.utility = new EditableSelectUtility(this);
    if (['focus', 'manual'].indexOf(this.options.trigger) < 0) this.options.trigger = 'focus';
    if (['default', 'fade', 'slide'].indexOf(this.options.effects) < 0) this.options.effects = 'default';
    if (isNaN(this.options.duration) && ['fast', 'slow'].indexOf(this.options.duration) < 0) this.options.duration = 'fast'; // create text input

    this.$select.replaceWith(this.$input);
    this.$list.appendTo(this.options.appendTo || this.$input.parent()); // initalization

    this.utility.initialize();
    this.utility.initializeList();
    this.utility.initializeInput();
    this.utility.trigger('created');
  };

  EditableSelect.DEFAULTS = {
    filter: true,
    effects: 'default',
    duration: 'fast',
    trigger: 'focus'
  };

  EditableSelect.prototype.filter = function () {
    var hiddens = 0;
    var search = this.$input.val().toLowerCase().trim();
    this.$list.find('li').addClass('es-visible').show();

    if (this.options.filter) {
      hiddens = this.$list.find('li').filter(function (i, li) {
        return $(li).text().toLowerCase().indexOf(search) < 0;
      }).hide().removeClass('es-visible').length;
      if (this.$list.find('li').length == hiddens) this.hide();
    }
  };

  EditableSelect.prototype.show = function () {
    this.$list.css({
      top: this.$input.position().top + this.$input.outerHeight() - 1,
      left: this.$input.position().left,
      width: this.$input.outerWidth()
    });

    if (!this.$list.is(':visible') && this.$list.find('li.es-visible').length > 0) {
      var fns = {
        default: 'show',
        fade: 'fadeIn',
        slide: 'slideDown'
      };
      var fn = fns[this.options.effects];
      this.utility.trigger('show');
      this.$input.addClass('open');
      this.$list[fn](this.options.duration, $.proxy(this.utility.trigger, this.utility, 'shown'));
    }
  };

  EditableSelect.prototype.hide = function () {
    var fns = {
      default: 'hide',
      fade: 'fadeOut',
      slide: 'slideUp'
    };
    var fn = fns[this.options.effects];
    this.utility.trigger('hide');
    this.$input.removeClass('open');
    this.$list[fn](this.options.duration, $.proxy(this.utility.trigger, this.utility, 'hidden'));
  };

  EditableSelect.prototype.select = function ($li) {
    if (!this.$list.has($li) || !$li.is('li.es-visible:not([disabled])')) return;
    this.$input.val($li.text());
    if (this.options.filter) this.hide();
    this.filter();
    this.utility.trigger('select', $li);
  };

  EditableSelect.prototype.add = function (text, index, attrs, data) {
    var $li = $('<li>').html(text);
    var $option = $('<option>').text(text);
    var last = this.$list.find('li').length;
    if (isNaN(index)) index = last;else index = Math.min(Math.max(0, index), last);

    if (index == 0) {
      this.$list.prepend($li);
      this.$select.prepend($option);
    } else {
      this.$list.find('li').eq(index - 1).after($li);
      this.$select.find('option').eq(index - 1).after($option);
    }

    this.utility.setAttributes($li, attrs, data);
    this.utility.setAttributes($option, attrs, data);
    this.filter();
  };

  EditableSelect.prototype.remove = function (index) {
    var last = this.$list.find('li').length;
    if (isNaN(index)) index = last;else index = Math.min(Math.max(0, index), last - 1);
    this.$list.find('li').eq(index).remove();
    this.$select.find('option').eq(index).remove();
    this.filter();
  };

  EditableSelect.prototype.clear = function () {
    this.$list.find('li').remove();
    this.$select.find('option').remove();
    this.filter();
  };

  EditableSelect.prototype.destroy = function () {
    this.$list.off('mousemove mousedown mouseup');
    this.$input.off('focus blur input keydown');
    this.$input.replaceWith(this.$select);
    this.$list.remove();
    this.$select.removeData('editable-select');
  }; // Utility


  EditableSelectUtility = function EditableSelectUtility(es) {
    this.es = es;
  };

  EditableSelectUtility.prototype.initialize = function () {
    var that = this;
    that.setAttributes(that.es.$input, that.es.$select[0].attributes, that.es.$select.data());
    that.es.$input.addClass('es-input').data('editable-select', that.es);
    that.es.$select.find('option').each(function (i, option) {
      var $option = $(option).remove();
      that.es.add($option.text(), i, option.attributes, $option.data());

      if ($option.attr('selected')) {
        that.es.$input.val($option.text());
        that.es.$input.attr('data-selected', $option.val());
      }
    });
    that.es.filter();
  };

  EditableSelectUtility.prototype.initializeList = function () {
    var that = this;
    that.es.$list.on('mousemove', 'li:not([disabled])', function () {
      that.es.$list.find('.selected').removeClass('selected');
      $(this).addClass('selected');
    }).on('mousedown', 'li', function (e) {
      if ($(this).is('[disabled]')) e.preventDefault();else that.es.select($(this));
    }).on('mouseup', function () {
      that.es.$list.find('li.selected').removeClass('selected');
    });
  };

  EditableSelectUtility.prototype.initializeInput = function () {
    var that = this;

    switch (this.es.options.trigger) {
      default:
      case 'focus':
        that.es.$input.on('focus', $.proxy(that.es.show, that.es)).on('blur', $.proxy(that.es.hide, that.es));
        break;

      case 'manual':
        break;
    }

    that.es.$input.on('input keydown', function (e) {
      switch (e.keyCode) {
        case 38:
          // Up
          var visibles = that.es.$list.find('li.es-visible:not([disabled])');
          var selectedIndex = visibles.index(visibles.filter('li.selected'));
          that.highlight(selectedIndex - 1);
          e.preventDefault();
          break;

        case 40:
          // Down
          var visibles = that.es.$list.find('li.es-visible:not([disabled])');
          var selectedIndex = visibles.index(visibles.filter('li.selected'));
          that.highlight(selectedIndex + 1);
          e.preventDefault();
          break;

        case 13:
          // Enter
          if (that.es.$list.is(':visible')) {
            that.es.select(that.es.$list.find('li.selected'));
            e.preventDefault();
          }

          break;

        case 9: // Tab

        case 27:
          // Esc
          that.es.hide();
          break;

        default:
          that.es.filter();
          that.highlight(0);
          break;
      }
    });
  };

  EditableSelectUtility.prototype.highlight = function (index) {
    var that = this;
    that.es.show();
    setTimeout(function () {
      var visibles = that.es.$list.find('li.es-visible');
      var oldSelected = that.es.$list.find('li.selected').removeClass('selected');
      var oldSelectedIndex = visibles.index(oldSelected);

      if (visibles.length > 0) {
        var selectedIndex = (visibles.length + index) % visibles.length;
        var selected = visibles.eq(selectedIndex);
        var top = selected.position().top;
        selected.addClass('selected');
        if (selectedIndex < oldSelectedIndex && top < 0) that.es.$list.scrollTop(that.es.$list.scrollTop() + top);
        if (selectedIndex > oldSelectedIndex && top + selected.outerHeight() > that.es.$list.outerHeight()) that.es.$list.scrollTop(that.es.$list.scrollTop() + selected.outerHeight() + 2 * (top - that.es.$list.outerHeight()));
      }
    });
  };

  EditableSelectUtility.prototype.setAttributes = function ($element, attrs, data) {
    $.each(attrs || {}, function (i, attr) {
      $element.attr(attr.name, attr.value);
    });
    $element.data(data);
  };

  EditableSelectUtility.prototype.trigger = function (event) {
    var params = Array.prototype.slice.call(arguments, 1);
    var args = [event + '.editable-select'];
    args.push(params);
    this.es.$select.trigger.apply(this.es.$select, args);
    this.es.$input.trigger.apply(this.es.$input, args);
  }; // Plugin


  Plugin = function Plugin(option) {
    var args = Array.prototype.slice.call(arguments, 1);
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('editable-select');
      var options = $.extend({}, EditableSelect.DEFAULTS, $this.data(), _typeof2(option) == 'object' && option);
      if (!data) data = new EditableSelect(this, options);
      if (typeof option == 'string') data[option].apply(data, args);
    });
  };

  $.fn.editableSelect = Plugin;
  $.fn.editableSelect.Constructor = EditableSelect;
}(jQuery); // Sticky Plugin v1.0.4 for jQuery
// =============
// Author: Anthony Garand
// Improvements by German M. Bravo (Kronuz) and Ruud Kamphuis (ruudk)
// Improvements by Leonardo C. Daronco (daronco)
// Created: 02/14/2011
// Date: 07/20/2015
// Website: http://stickyjs.com/
// Description: Makes an element on the page stick on the screen as you scroll
//              It will only set the 'top' and 'position' of your element, you
//              might need to adjust the width in some cases.

(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof2(module)) === 'object' && module.exports) {
    // Node/CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
})(function ($) {
  var slice = Array.prototype.slice; // save ref to original slice()

  var splice = Array.prototype.splice; // save ref to original slice()

  var defaults = {
    topSpacing: 0,
    bottomSpacing: 0,
    className: 'is-sticky',
    wrapperClassName: 'sticky-wrapper',
    center: false,
    getWidthFrom: '',
    widthFromWrapper: true,
    // works only when .getWidthFrom is empty
    responsiveWidth: false,
    zIndex: 'inherit'
  },
      $window = $(window),
      $document = $(document),
      sticked = [],
      windowHeight = $window.height(),
      scroller = function scroller() {
    var scrollTop = $window.scrollTop(),
        documentHeight = $document.height(),
        dwh = documentHeight - windowHeight,
        extra = scrollTop > dwh ? dwh - scrollTop : 0;

    for (var i = 0, l = sticked.length; i < l; i++) {
      var s = sticked[i],
          elementTop = s.stickyWrapper.offset().top,
          etse = elementTop - s.topSpacing - extra; //update height in case of dynamic content

      s.stickyWrapper.css('height', s.stickyElement.outerHeight());

      if (scrollTop <= etse) {
        if (s.currentTop !== null) {
          s.stickyElement.css({
            'width': '',
            'position': '',
            'top': '',
            'z-index': ''
          });
          s.stickyElement.parent().removeClass(s.className);
          s.stickyElement.trigger('sticky-end', [s]);
          s.currentTop = null;
        }
      } else {
        var newTop = documentHeight - s.stickyElement.outerHeight() - s.topSpacing - s.bottomSpacing - scrollTop - extra;

        if (newTop < 0) {
          newTop = newTop + s.topSpacing;
        } else {
          newTop = s.topSpacing;
        }

        if (s.currentTop !== newTop) {
          var newWidth;

          if (s.getWidthFrom) {
            padding = s.stickyElement.innerWidth() - s.stickyElement.width();
            newWidth = $(s.getWidthFrom).width() - padding || null;
          } else if (s.widthFromWrapper) {
            newWidth = s.stickyWrapper.width();
          }

          if (newWidth == null) {
            newWidth = s.stickyElement.width();
          }

          s.stickyElement.css('width', newWidth).css('position', 'fixed').css('top', newTop).css('z-index', s.zIndex);
          s.stickyElement.parent().addClass(s.className);

          if (s.currentTop === null) {
            s.stickyElement.trigger('sticky-start', [s]);
          } else {
            // sticky is started but it have to be repositioned
            s.stickyElement.trigger('sticky-update', [s]);
          }

          if (s.currentTop === s.topSpacing && s.currentTop > newTop || s.currentTop === null && newTop < s.topSpacing) {
            // just reached bottom || just started to stick but bottom is already reached
            s.stickyElement.trigger('sticky-bottom-reached', [s]);
          } else if (s.currentTop !== null && newTop === s.topSpacing && s.currentTop < newTop) {
            // sticky is started && sticked at topSpacing && overflowing from top just finished
            s.stickyElement.trigger('sticky-bottom-unreached', [s]);
          }

          s.currentTop = newTop;
        } // Check if sticky has reached end of container and stop sticking


        var stickyWrapperContainer = s.stickyWrapper.parent();
        var unstick = s.stickyElement.offset().top + s.stickyElement.outerHeight() >= stickyWrapperContainer.offset().top + stickyWrapperContainer.outerHeight() && s.stickyElement.offset().top <= s.topSpacing;

        if (unstick) {
          s.stickyElement.css('position', 'absolute').css('top', '').css('bottom', 0).css('z-index', '');
        } else {
          s.stickyElement.css('position', 'fixed').css('top', newTop).css('bottom', '').css('z-index', s.zIndex);
        }
      }
    }
  },
      resizer = function resizer() {
    windowHeight = $window.height();

    for (var i = 0, l = sticked.length; i < l; i++) {
      var s = sticked[i];
      var newWidth = null;

      if (s.getWidthFrom) {
        if (s.responsiveWidth) {
          newWidth = $(s.getWidthFrom).width();
        }
      } else if (s.widthFromWrapper) {
        newWidth = s.stickyWrapper.width();
      }

      if (newWidth != null) {
        s.stickyElement.css('width', newWidth);
      }
    }
  },
      methods = {
    init: function init(options) {
      return this.each(function () {
        var o = $.extend({}, defaults, options);
        var stickyElement = $(this);
        var stickyId = stickyElement.attr('id');
        var wrapperId = stickyId ? stickyId + '-' + defaults.wrapperClassName : defaults.wrapperClassName;
        var wrapper = $('<div></div>').attr('id', wrapperId).addClass(o.wrapperClassName);
        stickyElement.wrapAll(function () {
          if ($(this).parent("#" + wrapperId).length == 0) {
            return wrapper;
          }
        });
        var stickyWrapper = stickyElement.parent();

        if (o.center) {
          stickyWrapper.css({
            width: stickyElement.outerWidth(),
            marginLeft: "auto",
            marginRight: "auto"
          });
        }

        if (stickyElement.css("float") === "right") {
          stickyElement.css({
            "float": "none"
          }).parent().css({
            "float": "right"
          });
        }

        o.stickyElement = stickyElement;
        o.stickyWrapper = stickyWrapper;
        o.currentTop = null;
        sticked.push(o);
        methods.setWrapperHeight(this);
        methods.setupChangeListeners(this);
      });
    },
    setWrapperHeight: function setWrapperHeight(stickyElement) {
      var element = $(stickyElement);
      var stickyWrapper = element.parent();

      if (stickyWrapper) {
        stickyWrapper.css('height', element.outerHeight());
      }
    },
    setupChangeListeners: function setupChangeListeners(stickyElement) {
      if (window.MutationObserver) {
        var mutationObserver = new window.MutationObserver(function (mutations) {
          if (mutations[0].addedNodes.length || mutations[0].removedNodes.length) {
            methods.setWrapperHeight(stickyElement);
          }
        });
        mutationObserver.observe(stickyElement, {
          subtree: true,
          childList: true
        });
      } else {
        if (window.addEventListener) {
          stickyElement.addEventListener('DOMNodeInserted', function () {
            methods.setWrapperHeight(stickyElement);
          }, false);
          stickyElement.addEventListener('DOMNodeRemoved', function () {
            methods.setWrapperHeight(stickyElement);
          }, false);
        } else if (window.attachEvent) {
          stickyElement.attachEvent('onDOMNodeInserted', function () {
            methods.setWrapperHeight(stickyElement);
          });
          stickyElement.attachEvent('onDOMNodeRemoved', function () {
            methods.setWrapperHeight(stickyElement);
          });
        }
      }
    },
    update: scroller,
    unstick: function unstick(options) {
      return this.each(function () {
        var that = this;
        var unstickyElement = $(that);
        var removeIdx = -1;
        var i = sticked.length;

        while (i-- > 0) {
          if (sticked[i].stickyElement.get(0) === that) {
            splice.call(sticked, i, 1);
            removeIdx = i;
          }
        }

        if (removeIdx !== -1) {
          unstickyElement.unwrap();
          unstickyElement.css({
            'width': '',
            'position': '',
            'top': '',
            'float': '',
            'z-index': ''
          });
        }
      });
    }
  }; // should be more efficient than using $window.scroll(scroller) and $window.resize(resizer):


  if (window.addEventListener) {
    window.addEventListener('scroll', scroller, false);
    window.addEventListener('resize', resizer, false);
  } else if (window.attachEvent) {
    window.attachEvent('onscroll', scroller);
    window.attachEvent('onresize', resizer);
  }

  $.fn.sticky = function (method) {
    if (methods[method]) {
      return methods[method].apply(this, slice.call(arguments, 1));
    } else if (_typeof2(method) === 'object' || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.sticky');
    }
  };

  $.fn.unstick = function (method) {
    if (methods[method]) {
      return methods[method].apply(this, slice.call(arguments, 1));
    } else if (_typeof2(method) === 'object' || !method) {
      return methods.unstick.apply(this, arguments);
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.sticky');
    }
  };

  $(function () {
    setTimeout(scroller, 0);
  });
});